// NOTE: Quick polyfill fix for Safari and Firefox removing this method.
(function() 
{ 
  if (!Error.captureStackTrace) {
    Error.captureStackTrace = function() {}; 
  }
})();
//****************************************************************************

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("q"));
	else if(typeof define === 'function' && define.amd)
		define("web-audio-player", ["q"], factory);
	else if(typeof exports === 'object')
		exports["web-audio-player"] = factory(require("q"));
	else
		root["web-audio-player"] = factory(root["q"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_q__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./javascript/src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./javascript/src/index.js":
/*!*********************************!*\
  !*** ./javascript/src/index.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    11/06/13
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Module to load the SWF and create an injectable service.
 *
 *      NOTE: This module does have an external dependency on the constant "audioPlayerPath". This should come from the
 *      client application using this Module. It defines the directory path to the actual audio player implementation
 *      so it can be loaded at runtime.
 *
 *      NOTE: The ID and dependencies parameters of the define() method must be explicitly spelled out with values
 *      and not set with variables (used by reference); this is due to a limitation with RequireJS's build process that
 *      requires the string literals for both parameters.
 */

/**
 * Register the module with RequireJS.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(require)
  {
    var AudioPlayer = __webpack_require__(/*! sxm/audioplayer/AudioPlayer */ "./javascript/src/sxm/audioplayer/AudioPlayer.js");
    
    // Return the AudioPlayer constructor back to the Client
    return AudioPlayer;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/AudioPlayer.js":
/*!*******************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/AudioPlayer.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    11/06/13
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * The JavaScript Facade layer to the underlying audio player implementation. This object's API provides the
 * audio player's main functionality that's exposed to the client object.
 *
 * NOTE: The ID and dependencies parameters of the define() method must be explicitly spelled out with values
 * and not set with variables (used by reference); this is due to a limitation with RequireJS's build process that
 * requires the string literals for both parameters.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var loggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var AudioPlayerFactory = __webpack_require__(/*! sxm/audioplayer/AudioPlayerFactory */ "./javascript/src/sxm/audioplayer/AudioPlayerFactory.js");
  var AudioPlayerTypeIdentifier = __webpack_require__(/*! sxm/audioplayer/AudioPlayerTypeIdentifier */ "./javascript/src/sxm/audioplayer/AudioPlayerTypeIdentifier.js");
  var AudioPlayerEvent = __webpack_require__(/*! sxm/audioplayer/event/AudioPlayerEvent */ "./javascript/src/sxm/audioplayer/event/AudioPlayerEvent.js");
  var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
  var URLUtils = __webpack_require__(/*! sxm/util/URLUtils */ "./javascript/src/sxm/util/URLUtils.js");
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
  var Q = __webpack_require__(/*! q */ "q");
  var WebAudioPlayerLogger = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");

  var logger = loggerFactory.getLogger("AudioPlayer");

  /**
   * Make the Audio player instance singleton, ever create only once
   */
  var instance;

  /**
   * Flag indicating if the player is in debug mode.
   * @type {Boolean}
   */
  var debug = (URLUtils.getURLParam("debug", "boolean") || window.debugMode);

  /**
   * Developer friendly flag that allows testing of track failures.
   * @type {Boolean}
   */
  var randomTrackFailure = false;

  /**
   * Flag indicating that the player should seek instead of resuming.
   *
   * NOTE: This is a new property that's only used for Chromecast and specifically for the following use case:
   * This use case is where the Chromecast audio player is current (so now we're switching back to the web client
   * audio player), but we're not currently playing (most likely paused). However, since we were playing we
   * don't simply want the web client to resume where it last played, we want it to seek to the last timestamp
   * for the Chromecast player. This is a new and unique use case.
   * @type {Number}
   */
  var seekTime = NaN;

  // Developer area -- only items that are used during development should be performed here as the check
  // is for a `debug === true` is only enabled in debug mode.
  if (debug) {
    // Set the max number of chunks to load -- this is a development only feature allowing for
    // devs to set a lower threshold so they don't need to wait for an entire track to complete.
    // Extremely useful when debugging MySXM trick play use cases as the tracks can be as quick
    // as 30 seconds, aka 3 chunks.
    var maxChunksToLoad = URLUtils.getURLParam("maxChunksToLoad", "number");
    var valid = ObjectUtil.isNumber(maxChunksToLoad) && (maxChunksToLoad >= HlsConfig.MIN_NUMBER_CHUNKS_TO_LOAD);
    HlsConfig.MAX_NUMBER_CHUNKS_TO_LOAD = valid ? maxChunksToLoad : HlsConfig.MAX_NUMBER_CHUNKS_TO_LOAD;

    randomTrackFailure = URLUtils.getURLParam("rtf", "number");
    randomTrackFailure = ObjectUtil.isNumber(randomTrackFailure) ? randomTrackFailure : false;
    logger.debug("Random track failure ( {0} )", [String(randomTrackFailure)]);
  }

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * Constructor.
   *
   * Creates an audio player instance.
   * @param config {null| object} Optional. ex: config PATH, so that audio player knows where to look for it's assets,
   * and defaults to root directory
   * @returns {instance|*}
   * @constructor
   */
  function AudioPlayer(config) {
    /**
     * The instance object is returned as the object for this constructor.  This means the function can either
     * be called directly or used with new and the result will be the same.  This also means that this object is a
     * singleton, even if new is used.
     *
     * All property names are quoted.  This is no different than non-quited from the perspective of the JS runtime.
     * Where this DOES make a difference is in the mangling process for production builds.  The TerserPlugin mangling
     * can be controlled to NOT mangle properties that are quoted, and that is important here as this is the public
     * interface for the wen-audio-player module, so we do NOT want the mangler touching this object.
     */
    if (!instance) {
      // If we get a client logger, then we will update the WebAudioPlayerLogger with the client instance
      // The reason for doing this before player instance initialization, is that we make sure that the logs for
      // player also follows the client settings.
      if (config) {
        WebAudioPlayerLogger.logger = config.logger;
        WebAudioPlayerLogger.isEnabled = config.enableLogging || debug;
      }

      instance = {
        //////////////////////////////////////////
        // Playback Methods
        //////////////////////////////////////////

        "play": play,
        "preload": preload,
        "pause": pause,
        "resume": resume,
        "stop": stop,
        "skip": skip,
        "rewind": rewind,
        "seek": seek,

        //////////////////////////////////////////
        // Volume Methods
        //////////////////////////////////////////

        "setVolume": setVolume,
        "getVolume": getVolume,
        "mute": mute,
        "unmute": unmute,
        "toggleMute": toggleMute,
        "fade": fade,

        //////////////////////////////////////////
        // Player Properties
        //////////////////////////////////////////

        "isLoaded": isLoaded,
        "isPlaying": isPlaying,
        "isPaused": isPaused,
        "isMuted": isMuted,
        "getDuration": getDuration,
        "getCurrentURL": getCurrentURL,
        "getPlayerId": getPlayerId,
        "getConfig": getConfig,
        "getPlaylist": getPlaylist,

        //////////////////////////////////////////
        // Misc Methods
        //////////////////////////////////////////

        "setNextTrack": setNextTrack,
        "getDefaultType": getDefaultType,
        "getType": getType,
        "setSeekTime": setSeekTime,
        "setWhatToPlay": setWhatToPlay,
        "updateConfiguration": updateConfiguration,
        "updatePlaybackSource": updatePlaybackSource,
        "enablePlayerLogging": enablePlayerLogging,
        "enableLogging": enablePlayerLogging,
        "enableCrossfade": enableCrossfade,
        "enableQualityOfService": enableQualityOfService,
        "getMetrics": getMetrics,
        "resetMetrics": resetMetrics,
        "warmUp": warmUp,

        //////////////////////////////////////////
        // Event Dispatcher Methods
        //////////////////////////////////////////

        "addEventListener": addEventListener,
        "removeEventListener": removeEventListener,

        //////////////////////////////////////////
        // Creation Methods
        //////////////////////////////////////////

        "init": init,
        "reset": reset,
        "destroy": destroy
      };

      logger.debug("run( Trying to create audio player... )");

      //Creates the AudioPLayer based on the audioPlayerType
      if (!originalAudioPlayerImpl) {
        createAudioPlayer(config);
      }
    }
    logger.debug("Returning playback instance");

    return instance;
  }

  //-----------------------------------------------------------------------
  // PLAYBACK FUNCTIONS
  //-----------------------------------------------------------------------

  function playbackResolveHandler(method, args) {
    return function (player) {
      var playerExists = !ObjectUtil.isUndefinedOrNull(player);
      var functionExists = player.hasOwnProperty(method) && ObjectUtil.isFunction(player[method]);
      if (playerExists && functionExists) {
        return Q.when(player[method].apply(player, args));
      }
      else {
        var msg = StringUtil.supplant("Player cannot be null and player.{0}() must be a function.", [method]);
        throw new Error(msg);
      }
    };
  }

  function playbackResolveHandlerQuiet(method, args) {
    return function (player) {
      var playerExists = !ObjectUtil.isUndefinedOrNull(player);
      var functionExists = player.hasOwnProperty(method) && ObjectUtil.isFunction(player[method]);
      if (playerExists && functionExists) {
        return Q.when(player[method].apply(player, args));
      }
      else if (playerExists) {
        return Q.reject('function does not exist on player');
      }
      else {
        var msg = StringUtil.supplant("Player cannot be null.", [method]);
        throw new Error(msg);
      }
    };
  }

  /**
   * Begins audio playback.
   *
   * @param url {String} - Manifest URL
   * @param config {Configuration} - Contains all parameters for player configuration.
   */
  function play(url, config) {
    checkURL(url);
    logger.debug("play( id = {0}, url = {1}, startTime = {2} )", [
      config.id, url, String(config.startTime)
    ]);

    whatToPlay.url = url;
    whatToPlay.config = config;
    whatToPlay.playing = true;

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("play", [url, config]))
      .fail(reportError);
  }

  /**
   * Preloads an audio player.
   *
   * @param url {String} - Manifest URL
   * @param config {Configuration} - Contains all parameters for player configuration.
   */
  function preload(url, config) {
    checkURL(url);
    logger.debug("preload( id = {0}, url = {1}, startTime = {2} )", [
      config.id, url, String(config.startTime)
    ]);

    if (window.debugMode === true && randomTrackFailure !== false) {
      var random = Math.random();
      var threshold = parseInt(randomTrackFailure, 10) / 100;

      if (threshold >= random && config.primaryAudioURL) {
        logger.debug("preloadTrack( simulating bad track for {0}", [url]);
        url = config.primaryAudioURL.replace("m3u8", "badtrack.m3u8");
        config.primaryAudioURL = url;

        for (var i = 0; i < config.audioURLs.length; i++) {
          config.audioURLs[i].small = config.audioURLs[i].small.replace("m3u8", "badtrack.m3u8");
        }
      }
    }

    whatToPreload.url = url;
    whatToPreload.config = config;
    whatToPreload.preloading = true;

    function preloadComplete(val) {
      whatToPreload.preloading = false;
      return val;
    }

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("preload", [url, config]))
      .then(preloadComplete)
      .fail(reportError);
  }

  /**
   * Pauses audio playback
   */
  function pause() {
    logger.debug("pause()");

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("pause"))
      .fail(reportError);
  }

  /**
   * Resumes audio playback when paused.
   *
   * There are specific cases check when switching players at runtime as in the case of Chromecast.
   */
  function resume() {
    logger.debug("resume()");

    return audioPlayerAvailable.promise
        .then(playbackResolveHandler("resume"))
        .fail(reportError);
  }

  /**
   * Stops audio playback and all player activity, including buffering, loading, fading, etc.
   * Used when ending playback rather than pausing which keeps buffer populated.
   *
   * Since the underlying core player engine has a cache of Playback instances, there are various
   * forms of stop; stop has the ability to stop a specific player by ID, the current player, or all players.
   *
   * 1) Stop Current = stop() || stop( null )
   * 2) Stop By ID = stop( valid string ID )
   * 3) Stop All = stop( -1 )
   *
   * In the event that a player ID or the current player resolves to a null player then we log it.
   *
   * @param {null|Number|String} [id=null] Optional. Null, string ID of a player to stop, or -1 to stop
   * all players.
   * @return {Promise}
   */
  function stop(id) {
    whatToPreload.preloading = false;
    whatToPlay.playing = false;

    logger.debug("stop({0})", [!id || (id === null) ? "" : " " + id + " "]);
    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("stop", [id]))
      .fail(reportError);
  }

  /**
   * Goes to and plays audio from provided seekTime. Assumes that player is already configured and playlist is
   * loaded.
   *
   * @param {Number} startTime - Can be the offset from the beginning of play in milliseconds or a date or string date object.
   * @param {String} [url] - Optional parameter that provides an HLS URL; if not used the player will try to seek within the
   */
  function seek(startTime, url) {
    logger.debug("seek( startTime = {0}, url = {1} )", [startTime, url]);

    whatToPlay.url = url;
    whatToPlay.playing = true;

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("seek", [startTime, url]))
      .fail(reportError);
  }

  /**
   * Skips to the next track in audio playback.
   *
   * @param url The URL to play.
   * @param config A player config object.
   */
  function skip(url, config) {
    logger.debug("skip( {0}, {1} )", [url, config.id]);

    whatToPlay.url = url;
    whatToPlay.config = config;
    whatToPlay.playing = true;

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("skip", [url, config]))
      .fail(reportError);
  }

  /**
   * Rewinds to the previous track in audio playback.
   *
   * @param url The URL to play.
   * @param config A player config object.
   */
  function rewind(url, config) {
    logger.debug("rewind( {0}, {1} )", [url, config.id]);

    whatToPlay.url = url;
    whatToPlay.config = config;
    whatToPlay.playing = true;

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("rewind", [url, config]))
      .fail(reportError);
  }

  //-----------------------------------------------------------------------
  // VOLUME FUNCTIONS
  //-----------------------------------------------------------------------

  /**
   * Sets the audio player's volume.
   *
   * @param {number} value the volume for the audio player.
   */
  function setVolume(value) {
    value = Math.round(value * 100) / 100;
    logger.debug("setVolume( {0} )", [value]);

    audioPlayerAvailable.promise
      .then(playbackResolveHandler("setVolume", [value]))
      .fail(reportError);

    return value;
  }

  /**
   * Returns the current volume of the player.
   *
   * @returns {Number} The current volume of the player.
   */
  function getVolume() {
    var value = (audioPlayerImpl !== null) ? audioPlayerImpl.getVolume() : 0;

    logger.debug("getVolume( {0} )", [value]);
    return value;
  }

  /**
   * Mutes the audio player's volume.
   */
  function mute() {
    logger.debug("mute()");

    audioPlayerAvailable.promise
      .then(function (player) {
        mutedVolume = player.getVolume();
        return Q.when(player.setVolume(0));
      })
      .fail(reportError);

    return 0;
  }

  /**
   * Un-Mutes the audio player's volume.
   */
  function unmute() {
    logger.debug("Unmute to {0}", [mutedVolume]);

    audioPlayerAvailable.promise
      .then(playbackResolveHandler("setVolume", [mutedVolume]))
      .fail(reportError);

    return mutedVolume;
  }

  /**
   * Toggles the audio player's volume as mute or unmute.
   */
  function toggleMute() {
    logger.debug("toggleMute()");
    var muteFn = isMuted() ? unmute : mute;
    return muteFn();
  }

  /**
   * Fades Player Volume based on provided params. Can be used to fade Up or Down.
   *
   * @param startVolume {Number} The start volume for the fade operation.
   * @param endVolume {Number} The end volume for the fade operation.
   * @param durationInMilliseconds {Number} The number of milliseconds for the fade operation.
   */
  function fade(startVolume, endVolume, durationInMilliseconds) {
    logger.debug("fade( {0}, {1}, {2} )", [startVolume, endVolume, durationInMilliseconds]);

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("fade", [startVolume, endVolume, durationInMilliseconds]))
      .fail(reportError);
  }

  //-----------------------------------------------------------------------
  // PROPERTIES
  //-----------------------------------------------------------------------

  function setNextTrack(trackID, nextTrackID) {
    logger.debug("setNextTrack( current = {0}, next = {1} )", [trackID, nextTrackID]);

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("setNextTrack", [trackID, nextTrackID]))
      .fail(reportError);
  }

  /**
   * Indicates if the player is loaded.
   */
  function isLoaded() {
    return audioPlayerImpl !== null ? true : false;
  }

  /**
   * Indicates if the player is playing.
   */
  function isPlaying() {
    return audioPlayerImpl ? audioPlayerImpl.isPlaying : false;
  }

  /**
   * Indicates if the player is playing.
   */
  function isPaused() {
    return audioPlayerImpl ? audioPlayerImpl.isPaused : true;
  }

  /**
   * Indicates if the player is muted.
   */
  function isMuted() {
    return audioPlayerImpl ? audioPlayerImpl.getVolume() === 0 : true;
  }

  /**
   * Returns the player's current track's duration.
   */
  function getDuration() {
    return audioPlayerImpl ? audioPlayerImpl.duration : 0;
  }

  /**
   * Returns the player's current URL.
   */
  function getCurrentURL() {
    return audioPlayerImpl ? audioPlayerImpl.currentURL : "";
  }

  /**
   * Returns the player's ID.
   */
  function getPlayerId() {
    return audioPlayerImpl && audioPlayerImpl.configuration ? audioPlayerImpl.configuration.id : "";
  }

  /**
   * Returns the player's configuration.
   */
  function getConfig() {
    return audioPlayerImpl ? audioPlayerImpl.configuration : null;
  }

  /**
   * Returns the player's type.
   */
  function getType() {
    return audioPlayerImplType || "N/A";
  }

  /**
   * Returns the player's default type, aka the first player impl created. This is most commonly used
   * when switching runtime players when using Chromecast and we're now switching back to the web
   * client's player.
   */
  function getDefaultType() {
    return originalAudioPlayerImplType || "N/A";
  }

  /**
   * Sets a seek time that can be used when trying to resume to a specific timestamp
   * when switching audio players.
   *
   * NOTE: This is currently only used switching from Chromecast to the web client audio player
   * in the paused state; in this case we don't simply want to resume, but rather seek to the
   * last known timestamp.
   */
  function setSeekTime(value) {
    seekTime = value || NaN;
    logger.debug("setSeekTime( {0}} )", [seekTime]);
  }

  /**
   * Sets details on the "what to play" object containing the URL and config object.
   *
   * NOTE: This is currently only used switching from Chromecast to the web client audio player after switching
   * channels and when in the paused state; in this case we don't simply want to resume, but rather start playback
   * of a new channel.
   *
   * @param url {String} - Manifest URL
   * @param config {Configuration} - Contains all parameters for player configuration.
   */
  function setWhatToPlay(url, config) {
    checkURL(url);
    logger.debug("setWhatToPlay( id = {0}, url = {1}, startTime = {2} )", [
      config.id, url, String(config.startTime)
    ]);

    whatToPlay.url = url;
    whatToPlay.config = config;
    whatToPlay.playing = false;
    whatToPlay.playLater = true;
  }

  //-----------------------------------------------------------------------
  // MISC
  //-----------------------------------------------------------------------

  /**
   * Updates the configuration for a given player.
   */
  function updateConfiguration(config) {
    if (config && (config.id !== "") && (config.id !== null)) {
      logger.debug("updateConfiguration( id = {0} )", [config.id]);

      return audioPlayerAvailable.promise
        .then(playbackResolveHandler("updateConfiguration", [config]))
        .fail(reportError);
    }
    else {
      logger.error("updateConfiguration( bad config {0} )", [config !== null ? config.id : "null"]);
      return Q.when(true);
    }
  }

  /**
   * Updates the playback Source for a given playback.
   */
  function updatePlaybackSource(url, playbackId) {
    if (url && playbackId) {
      logger.debug("updatePlaybackSource( id = {0} )", [playbackId]);

      return audioPlayerAvailable.promise
        .then(playbackResolveHandler("updatePlaybackSource", [url, playbackId]))
        .fail(reportError);
    }
    else {
      logger.error("updatePlaybackSource( bad arguments {0} {1})", [url, playbackId]);
      return Q.when(true);
    }
  }

  /**
   * Enables or disables the logging for the audio player implementaiton. Logging for this AudioPlayer
   * faćade is still enabled.
   *
   * @param {Boolean} bool Flag indicating if the logging for the player is enabled.
   */
  function enablePlayerLogging(bool) {

    logger.debug("enablePlayerLogging( {0} )", [String(bool)]);

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("enableLogging", [bool]))
      .fail(reportError);
  }

  /**
   * Enables or disables crossfade for the audio player implementaiton.
   *
   * @param {Boolean} bool Flag indicating if crossfade for the player is enabled.
   */
  function enableCrossfade(bool) {
    logger.debug("enableCrossfade( {0} )", [String(bool)]);

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("enableCrossfade", [bool]))
      .fail(reportError);
  }

  /**
   * Gets the playlist for the given HLS url.
   *
   * @param {String} url - Parameter that provides an HLS URL for the current playlist.
   */
  function getPlaylist(url) {
    var createPlaylist = function (playlist) {
      if (playlist && playlist.chunkUrls && playlist.timestamps) {
        var result;
        var list = [];

        // eslint-disable-next-line no-unused-vars
        var addItem = function (item, index) {
          list.push(
            {
              asset: playlist.chunkUrls[index],
              time: playlist.timestamps[index]
            });
        };

        playlist.chunkUrls.forEach(function(url,index) {
          addItem(url,index);
        });

        result = {
          chunksToBuffer: HlsConfig.NUMBER_BUFFER_CHUNKS,
          list: list
        };

        logger.debug("getPlaylist( Playlist has {0} chunks. )", [String(list.length)]);
        return Q.when(result);
      }
      else {
        return Q.when(null);
      }
    };

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("getPlaylist", [url]))
      .then(createPlaylist)
      .fail(reportError);
  }

  /**
   * Enables or disables quality of service for the audio player implementaiton.
   *
   * @param {Boolean} bool Flag indicating if quality of service for the player is enabled.
   */
  function enableQualityOfService(bool) {
    logger.debug("enableQualityOfService( {0} )", [String(bool)]);

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("enableQualityOfService", [bool]))
      .fail(reportError);
  }

  /**
   * Retrieves the metrics for all players.
   */
  function getMetrics() {
    logger.debug("getMetrics()");

    return (audioPlayerImpl !== null) ? audioPlayerImpl.getMetrics() : null;
  }

  /**
   * Resets the metrics for all players.
   */
  function resetMetrics() {
    logger.debug("resetMetrics()");

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("resetMetrics"))
      .fail(reportError);
  }

  /**
   * Aids in console error reporting since the internal audio player creation and usage are promise based.
   * @param error
   */
  function reportError (error) {
    var msg = "Unknown Error";

    if (error instanceof Error) {
      msg = error.stack;
      logger.error("reportError( {0} )", [msg]);
      throw error;
    }
  }

  //-----------------------------------------------------------------------
  // EVENT DISPATCHING
  //-----------------------------------------------------------------------

  /**
   * Add an event listener to the player.
   *
   * @param type
   * @param handler
   * @param useCapture
   * @param priority
   * @param weakReference
   */
  function addEventListener(type, handler, useCapture, priority, weakReference) {

    var newListener = {
      type: type,
      handler: handler,
      useCapture: useCapture,
      priority: priority,
      weakReference: weakReference
    };

    if (type !== AudioPlayerEvent.LOAD_FAILED && type !== AudioPlayerEvent.READY) {
      logger.debug("addEventListener( {0} )", [type]);

      if (eventListeners.findIndex(checkListener) < 0) {
        eventListeners.push(newListener);
      }
      return audioPlayerAvailable.promise
        .then(playbackResolveHandler("addEventListener", [type, handler, useCapture, priority, weakReference]))
        .fail(reportError);
    }
    else {
      logger.debug("addEventListener( queuing listener for for `{0}`)", [type]);

      if (type === AudioPlayerEvent.LOAD_FAILED) {
        if (loadFailedListeners.findIndex(checkListener) < 0) {
          loadFailedListeners.push(newListener);
        }
      }
      else if (type === AudioPlayerEvent.READY) {
        if ( readyListeners.findIndex(checkListener) < 0) {
          readyListeners.push(newListener);
        }
      }

      return Q.when(true);
    }

    function checkListener(listener)
    {
      return (listener.type === newListener.type
              && listener.handler === newListener.handler);
    }

  }

  /**
   * Remove an event listener from the player.
   *
   * @param type
   * @param handler
   * @param useCapture
   * @param priority
   * @param weakReference
   * @param destroy
   */
  function removeEventListener(type, handler) {
    // Force destroy to be a legit Boolean.
    destroy = !!destroy;
    logger.debug("removeEventListener( {0}, destroy = {1} )", [type, destroy]);

    // eslint-disable-next-line no-unused-vars
    var listeners = null;

    switch (type) {
      case AudioPlayerEvent.LOAD_FAILED:
        listeners = loadFailedListeners;
        break;
      case AudioPlayerEvent.READY:
        listeners = readyListeners;
        break;
      default:
        listeners = eventListeners;
        break;
    }

    return audioPlayerAvailable.promise
      .then(playbackResolveHandler("removeEventListener", [type, handler]))
      .fail(reportError);
  }

  //-----------------------------------------------------------------------
  // CREATION
  //-----------------------------------------------------------------------

  function createAudioPlayer(config) {

    // set the directory path for the audio player so it can be loaded and instantiated
    // this is defined by the client app using the this audio player module
    AudioPlayerFactory.PATH = config && config.PATH ? config.PATH : "";

    //Configure SWF_FILE, if provided else it's look for the defualt swf file `web-audio-player.swf`
    AudioPlayerFactory.SWF_FILE = config && config.SWF_FILE ? config.SWF_FILE : AudioPlayerFactory.SWF_FILE;

    // determine logging level based on url parameters
    var audioPlayerLoggingEnabled = (config && config.enableLogging) || window.debugMode || URLUtils.getURLParam("debug");

    // enable or disable the underlying audio player implementation
    // this is defined by the client app using the this audio player module
    enablePlayerLogging(audioPlayerLoggingEnabled);

    // Attempts to add a tail hook logging function for external clients.
    // WebAudioPlayerLogger.TAIL_HOOK = audioPlayerLoggingTailHook || ObjectUtil.noop;
    WebAudioPlayerLogger.TAIL_HOOK = ObjectUtil.noop;

    // The audio player type that's being created.
    // const audioPlayerType = AudioPlayerTypeIdentifier.getType(audioPlayerType);
    var audioPlayerType = AudioPlayerTypeIdentifier.getType();

    // Create the audio player implementation and initialize it as an AJS service.
    AudioPlayerFactory.getAudioPlayer(audioPlayerType)
      .then(onAudioPlayerCreationSuccess)
      .catch(onAudioPlayerCreationFault);

    /**
     * Callback for successful acquisition of the audio player service.
     * @param {Object} audioPlayerImpl - Reference to the underlying, core audio player
     * implementation created by the factory.
     */
    function onAudioPlayerCreationSuccess(audioPlayerImpl) {
      logger.debug("onAudioPlayerCreationSuccess()");

      // Now that we have a reference to the underlying audio player implementation,
      // let's add it to the application JavaScript Facade layer.
      init(audioPlayerImpl, audioPlayerType);
    }

    /**
     * Failed try for acquisition of the audio player service from the factory.
     * @param {Object} error - Error object with failure message.
     */
    function onAudioPlayerCreationFault(error) {
      logger.error("onAudioPlayerCreationFault( Returning null. Error: {0} )", [error]);
      return null;
    }
  }

  /**
   * Initializes the AudioPlayer by taking a reference to the underlying AudioPlayer implementation.
   *
   * @param {Object} audioPlayer - The underlying audio player implementation object.
   * @param {String} type - The string type of the audio player implementation: Flash or JS or ???.
   */
  function init(audioPlayer, type) {
    var i;
    type = type || "Unknown";

    // Save the reference to the actual audio player implementation and it's type.
    audioPlayerImpl = audioPlayer;
    audioPlayerImplType = type;

    // This is used when switching back and forth between players at runtime. This is currently
    // only used when switching between the web client's native player and Chromecast.
    //
    // NOTE: We only want to set this once, the first time we create an  audio player.
    if (!originalAudioPlayerImpl) {
      originalAudioPlayerImpl = audioPlayerImpl;
      originalAudioPlayerImplType = type;
    }

    if (audioPlayer !== null) {
      logger.debug("init()" +
        "\n" +
        "---------------------------------------------------" +
        "\n" +
        "AudioPlayer [{0}] Ready to Rock" +
        "\n" +
        "---------------------------------------------------", [type]);

      audioPlayerAvailable.resolve(audioPlayer);

      // If we are NOT working with the flash player, we can monkey patch the promise then function
      // to call the then callback synchronousely.  The Q promise library calls the then function
      // asynchronously, even if .then is called after the promise has been resolved.
      //
      // IMPORTANT!!!!!
      //
      // This solves certain classes of problems with modern browsers and HTML5, mostly involving
      // browsers attempting to block intrusive advertisements that attempt to autoplay ads without
      // direct user interaction.  By making the then operate synchronously, browser can now easily tell
      // that commands to the audio playback renderer are happening as a direct result of a user action
      if (type !== AudioPlayerTypeIdentifier.FLASH) {
        var fakePromise = {
          then: audioPlayerAvailable.promise.then.bind(audioPlayerAvailable.promise),
          fail: audioPlayerAvailable.promise.fail.bind(audioPlayerAvailable.promise)
        };

        audioPlayerAvailable.promise.then = function (callback) {
          var result;

          if (callback) {
            result = callback(audioPlayerImpl);
          }

          return fakePromise.then(function () {
            return result;
          }); // need to "undo" what we did to the promise chain here
        };
      }

      if (readyListeners) {
        logger.debug("callReadyListeners( queue length = {0} )", [readyListeners.length]);

        for (i = 0; i < readyListeners.length; i++) {
          readyListeners[i].handler(audioPlayer);
        }
      }
    }
    else {
      if (loadFailedListeners) {
        logger.debug("callLoadFailureListeners( queue length = {0} )", [loadFailedListeners.length]);

        for (i = 0; i < loadFailedListeners.length; i++) {
          loadFailedListeners[i].handler(null);
        }
      }

      audioPlayerAvailable.reject("Audio player is null");
    }

    return this;
  }

  /**
   * Completely destroys the player instance internally
   */
  function destroy() {
    logger.debug("destroy()");

    eventListeners.forEach(function (listener) {
      removeEventListener(listener.type, listener.handler, listener.useCapture, listener.priority, listener.weakReference);
    });

    loadFailedListeners.forEach(function (listener) {
      removeEventListener(listener.type, listener.handler, listener.useCapture, listener.priority, listener.weakReference);
    });

    readyListeners.forEach(function (listener) {
      removeEventListener(listener.type, listener.handler, listener.useCapture, listener.priority, listener.weakReference);
    });

    readyListeners = [];
    loadFailedListeners = [];
    eventListeners = [];
  }

  /**
   * Resets player settings/config to default condition
   */
  function reset(audioPlayer, type) {
    logger.debug("reset()");

    // Save the current player type and listeners
    var oldReadyListeners = readyListeners;
    var oldLoadFailedListeners = loadFailedListeners;
    var oldEventListeners = eventListeners;

    var setNewPlayer = function (type) {
      return function (audioPlayer) {
        return init(audioPlayer, type);
      };
    };

    var addEventListeners = function (audioPlayer) {
      oldEventListeners.forEach(function (listener) {
        addEventListener(listener.type, listener.handler, listener.useCapture, listener.priority, listener.weakReference);
      });

      oldLoadFailedListeners.forEach(function (listener) {
        addEventListener(listener.type, listener.handler, listener.useCapture, listener.priority, listener.weakReference);
      });

      oldReadyListeners.forEach(function (listener) {
        addEventListener(listener.type, listener.handler, listener.useCapture, listener.priority, listener.weakReference);
      });

      return audioPlayer;
    };

    // Destroy the old audio player now that we've saved configs from it.
    destroy();

    // Create a new promise for the availability of the new audio player.
    audioPlayerAvailable = Q.defer();

    // If an audio player isn't provided then create one based on the current type.
    audioPlayer = audioPlayer || AudioPlayerFactory.getAudioPlayer();
    audioPlayerAvailable.resolve(audioPlayer);

    // Once the new audio player is available, setup the event listeners and then initialize it.
    return audioPlayerAvailable.promise
      .then(addEventListeners)
      .then(setNewPlayer(type))
      .fail(reportError);
  }

  /**
   * Warms up the audio context.
   * This should be called as a direct result of a user action,
   * So the browser can un-mute asynchronously started audio.
   * */
  function warmUp() {
    return audioPlayerAvailable.promise
      .then(playbackResolveHandlerQuiet('warmUp'))
      .fail(function (error) {
        var msg = "warm up failed";

        if (error instanceof Error) {
          msg = error.stack;
          logger.error("reportError( {0} )", [msg]);
        }
      });
  }
  //-----------------------------------------------------------------------
  // INTERNALS
  //-----------------------------------------------------------------------

  /**
   * Reference to the internal audio player implementation.
   * @type {Flash|JavaScript|Chromecast}
   */
  var audioPlayerImpl = null;

  /**
   * Reference to the original internal audio player implementation. This is used when switching audio
   * player impls at runtime.
   * @type {Flash|JavaScript|Chromecast}
   * */
  var originalAudioPlayerImpl = null;

  /**
   * Reference to the internal audio player implementation's type. This is used when switching between
   * two player impls at runtime.
   * @type {String}
   */
  var audioPlayerImplType = null;

  /**
   * Reference to the original internal audio player implementation's type. This is used when switching between
   * two player impls at runtime.
   * @type {String}
   */
  var originalAudioPlayerImplType = null;

  /**
   * Promise that will be resolved when audioPlayerImpl is set
   * @type {Deferred}
   */
  var audioPlayerAvailable = Q.defer();

  /**
   * Object that contains what has been requested to preload, and whether it is still preloading
   * @type {Object}
   */
  var whatToPreload = {
    url: null,
    config: null,
    preloading: false
  };

  /**
   * Object that contains what has been requested to play, and whether it is playing yet
   * @type {Object}
   */
  var whatToPlay = {
    url: null,
    config: null,
    playing: false,
    playLater: false
  };

  /**
   * Stores the volume when muted so it can be restored.
   * @type {number}
   */
  var mutedVolume = 0;

  /**
   * List of event listeners (other than LOAD_FAILED and READY)
   * @type {Array}
   */
  var eventListeners = [];

  /**
   * List of event listeners for LOAD_FAILED events
   * @type {Array}
   */
  var loadFailedListeners = [];

  /**
   * List of event listeners for READY events
   * @type {Array}
   */
  var readyListeners = [];

  /**
   * Throws an error if the specified URL parameter is null or an empty string.
   *
   * @param {String} url URL being checked for validity.
   */
  var checkURL = function (url) {
    if ((url === null) || (url.replace(/\ /g, "") === "")) {
      throw new Error("The HLS URL for the audio player cannot be null or an empty string");
    }

    return url;
  };

  /**
   * tracking the last promise that was given to the client,
   * to make sure the client commands are followed in the order they were given
   * @type {Promise}
   */
  var _lastPromise = null; //Q.when(true);

  return AudioPlayer;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/AudioPlayerFactory.js":
/*!**************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/AudioPlayerFactory.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    11/07/13
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Factory that instantiates the audio player by type. Currently the factory supports both Flash and JavaScript
 * player creation requests, but only creates and returns a Flash audio player -- the JavaScript audio player
 * is simply a placeholder to be implemented if it ever becomes available.
 *
 * NOTE: The ID and dependencies parameters of the define() method must be explicitly spelled out with values
 * and not set with variables (used by reference); this is due to a limitation with RequireJS's build process that
 * requires the string literals for both parameters.
 */
(function () {
  "use strict";

  /**
   * Register the object module with RequireJS.
   */
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var loggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var AudioPlayerTypeIdentifier = __webpack_require__(/*! sxm/audioplayer/AudioPlayerTypeIdentifier */ "./javascript/src/sxm/audioplayer/AudioPlayerTypeIdentifier.js");
    var SWFLoader = __webpack_require__(/*! sxm/swfloader/SWFLoader */ "./javascript/src/sxm/swfloader/SWFLoader.js");
    var HTML5AudioPlayer = __webpack_require__(/*! sxm/audioplayer/html5/HTML5AudioPlayer */ "./javascript/src/sxm/audioplayer/html5/HTML5AudioPlayer.js");
    var Q = __webpack_require__(/*! q */ "q");

    var logger = loggerFactory.getLogger("AudioPlayerFactory");

    /**
     * @description
     * Factory object is returned making it feel like a static class when used by other objects.
     * @ngdoc method
     * @name sxm.app.channels.factory:AudioPlayerFactory#controller
     * @methodOf sxm.app.channels.factory:AudioPlayerFactory
     * @type {{getAudioPlayer: Function}}
     */
    var factory = {

      /**
       * Audio player ID.
       * @type {string}
       */
      AUDIO_PLAYER_ID: "web-audio-player",

      /**
       * Path to the library.
       * @type {string}
       */
      PATH: "",
  
      /**
       * SWF File name, client can give custom SWF file, defaults to look for  web-audio-player.swf
       * @type {string}
       */
      SWF_FILE: "web-audio-player",

      /**
       * Creates the audio player. Uses promises for player creation to handle any asynchronous delays
       * associated with instantiation.
       *
       * @param {String} type The type of being player being requested.
       * @path is the (optional) path to the player
       * @returns {promise}
       */
      getAudioPlayer: function (type) {
        logger.debug("getAudioPlayer( {0} )", [type]);

        var audioPlayer;

        switch (type.toLowerCase()) {
          case AudioPlayerTypeIdentifier.FLASH.toLowerCase():
          case AudioPlayerTypeIdentifier.SWF.toLowerCase():
          case AudioPlayerTypeIdentifier.AS3.toLowerCase():
          case AudioPlayerTypeIdentifier.ACTIONSCRIPT.toLowerCase():
            audioPlayer = factory.getFlashAudioPlayer();
            return Q.resolve(audioPlayer);

          case AudioPlayerTypeIdentifier.HTML5.toLowerCase():
          case AudioPlayerTypeIdentifier.JAVASCRIPT.toLowerCase():
          case AudioPlayerTypeIdentifier.JS.toLowerCase():
            audioPlayer = (window.location.href.indexOf('flash=true') > -1) ? factory.getFlashAudioPlayer() : factory.getJavaScriptAudioPlayer();
            return Q.resolve(audioPlayer);

          default:
            logger.warn("getAudioPlayer( Returning null since no type was specified )");
            return Q.resolve(null);
        }
      },

      /**
       * Creates a Flash audio player. Uses promises for player creation to handle any asynchronous delays
       * associated with instantiation.
       *
       * @param player is the audio player that we are loading the implementation for
       * @returns {Promise}
       */
      getFlashAudioPlayer: function () {
        logger.debug("getFlashAudioPlayer()");
        var dfd = Q.defer();

        // we're using the same audio player ID for both the SWF ID and DIV container ID, but
        // they can in fact be different
        SWFLoader
          .load(factory.SWF_FILE, factory.AUDIO_PLAYER_ID, factory.PATH)
          .then(
            /**
             * Callback for successful acquisition of the audio player service from the SWF.
             * Store a reference to the service and configure RequireJS.
             * @param {Object} audioPlayerImpl Reference to the audio player service returned from SWFService.
             */

            function onSWFLoaderSuccess(audioPlayerImpl) {
              //send the JS audioplayer implementation
              var jsAudioPlayerImpl = null;
  
              if(audioPlayerImpl !== null)
              {
                logger.debug("onSWFLoaderSuccess()");
                audioPlayerImpl.type = AudioPlayerTypeIdentifier.FLASH;
    
                //Enable the Logging
                if(window.location.href.indexOf('debug=true') > -1)
                {
                  audioPlayerImpl.enableLogging();
                }
                audioPlayerImpl.init();
                jsAudioPlayerImpl = new HTML5AudioPlayer();
                jsAudioPlayerImpl.flashRenderer = audioPlayerImpl;
                jsAudioPlayerImpl.type = AudioPlayerTypeIdentifier.JAVASCRIPT;
    
              }
              else
              {
                logger.error("onSWFLoaderFault( Returning null. Error: Load timeout failure)");
              }
  
              dfd.resolve(jsAudioPlayerImpl);
            },

            /**
             * Failed try for acquisition of the audio player service from the SWF.
             * @param {Object} error Error object with failure message.
             */

            function onSWFLoaderFault(error) {
              logger.error("onSWFLoaderFault( Returning null. Error: {0} )", [error]);
              dfd.resolve(null);
            }
          );

        return dfd.promise;
      },

      /**
       * Creates a JavaScript or HTML5 audio player. Does not uses promises for player creation as the player
       * is simply a Object Oriented instance created by calling `new` on the constructor function.
       *
       * @returns {HTML5AudioPlayer}
       */
      getJavaScriptAudioPlayer: function () {
        logger.debug("getJavaScriptAudioPlayer()");

        var audioPlayerImpl = new HTML5AudioPlayer();
        audioPlayerImpl.type = AudioPlayerTypeIdentifier.JAVASCRIPT;
        return audioPlayerImpl;
      }
    };

    return factory;

  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

}());


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/AudioPlayerTypeIdentifier.js":
/*!*********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/AudioPlayerTypeIdentifier.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    11/06/13
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Factory that determines the audio player type and returns a string representation of it. Currently this
 * supports the following player types.
 *
 *          - Flash
 *          - AS3
 *          - SWF
 *          - JavaScript
 *          - HTML5
 *
 * The player type can be set at runtime via a query string parameter `audioPlayerType` or is determined by
 * what's available in the browser or it defaults to Flash.
 *
 * NOTE: The ID and dependencies parameters of the define() method must be explicitly spelled out with values
 * and not set with variables (used by reference); this is due to a limitation with RequireJS's build process that
 * requires the string literals for both parameters.
 */


/**
 * Register the object module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var loggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var AudioContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js");
  var Cipher = __webpack_require__(/*! sxm/audioplayer/html5/crypto/Cipher */ "./javascript/src/sxm/audioplayer/html5/crypto/Cipher.js");
  var BrowserUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/BrowserUtil */ "./javascript/src/sxm/audioplayer/html5/util/BrowserUtil.js");
  var URLUtils = __webpack_require__(/*! sxm/util/URLUtils */ "./javascript/src/sxm/util/URLUtils.js");

  var logger = loggerFactory.getLogger("AudioPlayerTypeIdentifier");
  var MIN_SUPPORTED_EDGE = 15.14986;

  /**
   * Attempts to match the specified audio player type with a real audio player implementaiton type.
   * @param {String} type - The requested player type.
   * @returns {String} Player type or null.
   */
  var getRequestedType = function (type) {
    if ((typeof type !== "string") || (type === "") || (type === null) || (typeof type === "undefined")) {
      type = null;
    }
    else {
      switch (type.toLowerCase()) {
        case factory.FLASH.toLowerCase():
        case factory.SWF.toLowerCase():
        case factory.AS3.toLowerCase():
        case factory.ACTIONSCRIPT.toLowerCase():
        case factory.JS.toLowerCase():
        case factory.JAVASCRIPT.toLowerCase():
        case factory.HTML5.toLowerCase():
          logger.info("getRequestedType( Player type: `{0}` )", [
            type
          ]);
          break;

        default:
          type = null;
          break;
      }
    }
    return type;
  };

  /**
   * Attempts to grab the specified override parameter from external clients using the audio player. This is
   * used as a runtime override for developers and special case where we need to force a build to use
   * a specific audio player type.
   *
   * @param {String} type - An override for the audio player type as specificed by the AJS client
   * using this Audio Player.
   * @returns {String} Player type from external client.
   */
  var getTypeFromOverride = function (type) {
    type = getRequestedType(type);
    if (type) {
      logger.info("getTypeFromOverride( Using client override specified player type: `{0}`. )", [type]);
    }
    return type;
  };

  /**
   * Attempts to grab the player type from the query string. This is used as a runtime override for
   * developers.
   * @returns {String|null} Player type from query string or null if not valid.
   */
  var getTypeFromQueryString = function () {
    var type = URLUtils.getURLParam("audioPlayerType");
    type = getRequestedType(type);
    if (type) {
      logger.info("getTypeFromQueryString( Using query string specified player type: `{0}`. )", [type]);
    }
    return type;
  };

  /**
   * Determines if the HTML5 audio component and required dependencies are available in the current browser.
   * @returns {String} JavaScript player type or Flash player if not available in the browser.
   */
  var getTypeFromBrowser = function () {
    var useJavaScriptAudioPlayer = function () {
      logger.info("getTypeFromBrowser( JavaScript audio player supported in browser. )");
      return factory.JAVASCRIPT;
    };

    var useFlashAudioPlayer = function () {
      logger.info("getTypeFromBrowser( JavaScript audio player is NOT supported in this browser so defaulting to Flash. )");
      return factory.FLASH;
    };

    var isSupportedBrowser = function () {
      var isSupported = BrowserUtil.isEdge(MIN_SUPPORTED_EDGE) ||
        BrowserUtil.isChrome() ||
        BrowserUtil.isFirefox() ||
        BrowserUtil.isSafari();

      var hasRequiredApi = AudioContext.isSupported() && Cipher.isSupported();
      var bool = isSupported && hasRequiredApi;

      logger.info("isSupportedBrowser( {0} is {1} a supported HTML5 audio player browser. {2})", [
        BrowserUtil.getBrowser(), (bool ? "" : "NOT"), (hasRequiredApi ? "" : "Doesn't support the `AudioContext` or `subtleCrypto`. ")
      ]);
      return bool;
    };

    return isSupportedBrowser() ? useJavaScriptAudioPlayer() : useFlashAudioPlayer();
  };

  /**
   * Constants for underlying, core audio player implementation types.
   */
  var factory = {

    /**
     * Audio player type indicating Flash.
     * @type {String}
     */
    FLASH: "flash",

    /**
     * Audio player type indicating Flash.
     * @type {String}
     */
    SWF: "swf",

    /**
     * Audio player type indicating Flash.
     * @type {String}
     */
    AS3: "as3",

    /**
     * Audio player type indicating Flash.
     * @type {String}
     */
    ACTIONSCRIPT: "actionScript",

    /**
     * Audio player type indicating JavaScript.
     * @type {String}
     */
    JS: "js",

    /**
     * Audio player type indicating JavaScript.
     * @type {String}
     */
    JAVASCRIPT: "javaScript",

    /**
     * Audio player type indicating HTML5, aka JavaScript.
     * @type {String}
     */
    HTML5: "html5",

    /**
     * Determines the player type. The player type can be set at runtime via a query string parameter
     * `audioPlayerType` or it's determined by what's available in the browser or it defaults to Flash.
     *
     * @param {String} [type] - An override for the audio player type as specified by the AJS client
     * using this Audio Player.
     * @returns {String} Currently either 'flash' or 'javascript'.
     */
    getType: function (type) {
      // TODO: BMR: 03/08/2016: Currently we're hardcoding the player to default to Flash and the JS version can only be set via the query string parameter.
      // TODO: BMR: 03/08/2016: Uncomment the first and comment the second once browser is allowed to determine player type.
      //var type = getTypeFromQueryString() || getTypeFromBrowser() || factory.FLASH;
      type = getTypeFromQueryString() || getTypeFromOverride(type) || getTypeFromBrowser() || factory.FLASH;
      logger.debug("getType( {0} )", [type]);
      return type;
    }

  };

  return factory;

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/event/AudioPlayerEvent.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/event/AudioPlayerEvent.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @docType     function
 * @ngDoc       app
 * @name        sxm.audioplayer.event:AudioPlayerEvent
 * @author      Brian Riley
 * @date        January 27, 2014
 * @copyright   2013 Sirius XM Radio Inc.
 * @description
 *
 *      A event object listing the possible event types for the Audio Player.
 *
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {

  var types = {
    READY: "audioPlayerReady",
    PLAYBACK_READY: "playbackReady",
    PLAYHEAD_START: "playheadStart",
    PLAYHEAD: "playhead",
    BIT_RATE_CHANGE: "bitRateChange",
    BIT_RATE_AUTO_DOWN_SHIFT: "bitRateAutoDownShift",
    PRELOADING: "preloading",
    PRELOADING_COMPLETE: "preloadingComplete",
    // TODO: BMR: 03/09/2016: Are we even using "preloaded" since we have complete too?
    PRELOADED: "preloaded",
    BUFFER_EMPTY: "bufferEmpty",
    CROSSFADE: "crossfade",
    FAILOVER: "failover",
    RESTART: "restart",
    BAD_TRACK: "badTrack",
    NO_TRACKS: "noTracks",
    ERROR: "error",
    CONNECTIVITY_FAILED: "connectivityFailed",
    TOKEN_INVALID: "tokenInvalid",
    KEY_FAILED: "keyFailed",
    LOAD_FAILED: "audioPlayerLoadFailed",
    PLAYBACK_DENIED: "NotAllowedError",
    FINISHED: "finished",
    STATE_CHANGE: "playStateChanged",
    CUE_POINT: "cuePoint",
    CUE_POINTS_REFRESH: "cuePointRefresh"
  };

  return types;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/HTML5AudioPlayer.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/HTML5AudioPlayer.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Implements a high-level, facade API for audio playback, to be exposed as a remote service that can be
 *      called by JavaScript. Uses a player cache to manage multiple player instances. Re-dispatches core player
 *      events and in some cases throttles them.
 */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
    var PlaybackTypeUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaybackTypeUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js");
    var Playback = __webpack_require__(/*! sxm/audioplayer/html5/core/Playback */ "./javascript/src/sxm/audioplayer/html5/core/Playback.js");
    var AudioPlayerTypeIdentifier = __webpack_require__(/*! sxm/audioplayer/AudioPlayerTypeIdentifier */ "./javascript/src/sxm/audioplayer/AudioPlayerTypeIdentifier.js");
    var MediaElementPlayback = __webpack_require__(/*! sxm/audioplayer/html5/core/MediaElementPlayback */ "./javascript/src/sxm/audioplayer/html5/core/MediaElementPlayback.js");
    var AudioModel = __webpack_require__(/*! sxm/audioplayer/html5/model/AudioModel */ "./javascript/src/sxm/audioplayer/html5/model/AudioModel.js");
    var AudioContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js");
    var AudioFirst = __webpack_require__(/*! sxm/audioplayer/html5/model/AudioFirst */ "./javascript/src/sxm/audioplayer/html5/model/AudioFirst.js");
    var PlayerEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/PlayerEvent */ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js");
    var PlayerState = __webpack_require__(/*! sxm/audioplayer/html5/model/PlayerState */ "./javascript/src/sxm/audioplayer/html5/model/PlayerState.js");
    var PlaybackQueue = __webpack_require__(/*! sxm/audioplayer/html5/model/PlaybackQueue */ "./javascript/src/sxm/audioplayer/html5/model/PlaybackQueue.js");
    var EventManager = __webpack_require__(/*! sxm/audioplayer/html5/event/EventManager */ "./javascript/src/sxm/audioplayer/html5/event/EventManager.js");
    var QualityOfServiceMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/QualityOfServiceMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/QualityOfServiceMonitor.js");
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
    var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var Q = __webpack_require__(/*! q */ "q");

    /**
     * Internal reference to the logger.
     */
    var logger = LoggerFactory.getLogger("HTML5AudioPlayer");


  /**
   * Below class variables are for un-blocking the audio context of both MediaElement playback and Web Audio API
   * For some browsers( Ex: Safari) it was unable to recognize audio context for entire page is ubblocked  by unblocking a single type of audio context
   * ( say web audio API or from MediaElement playback).. so we create two dummy playbacks sampleContext & sampleAudioElement, which we will inject with
   * Dummy audio and try to unblock them by user click by listening to click event.
   *
   * This is an hack to not get our audio blocked more than once
   */
    var sampleContext, sampleAudioElement, audioContextPromise = Q.defer();

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the HTML5AudioPlayer function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @constructor
     */
    function HTML5AudioPlayer() {
      // This first guard ensures that the callee has invoked our Class' constructor function
      // with the `new` keyword - failure to do this will result in the `this` keyword referring
      // to the callee's scope (typically the window global) which will result in the following fields
      // (name and _age) leaking into the global namespace and not being set on this object.
      if (!(this instanceof HTML5AudioPlayer)) {
        throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["HTML5AudioPlayer"]);
      }

      // Bind the scope of "this" to all first class functions
      ClassUtil.bindFunctions(this);

      //-----------------------------------------------------------------------
      // PRIVATE METHODS
      //-----------------------------------------------------------------------

      /**
       * Creates a list of core Playback instance event interceptors that hit this object before being passed
       * onto outside clients.
       */
      var getEventInterceptors = function () {
        return [
          {
            type: PlayerEvent.FINISHED,
            handler: this.onFinished
          },
          {
            type: PlayerEvent.RESTART,
            handler: this.onRestart
          },
          {
            type: PlayerEvent.BEHIND_PLAYLIST,
            handler: this.onBehindPlaylist
          },
          {
            type: PlayerEvent.TRACK_FAILED,
            handler: this.onTrackFailed
          },
          {
            type: PlayerEvent.CROSSFADE_POINT_REACHED,
            handler: this.onCrossfadePointReached
          },
          {
            type: PlayerEvent.PLAYBACK_DENIED,
            handler: this.onPlaybackDenied
          }];
      }.bind(this);

      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------


      /**
       * This will preload the audio with Web Audio API ( Audio Context) and also dummy Media Element asset
       * So that we can unblock the Audio context when user clicks, this has to apply only HTML5 player, bypass this for flash
       */
      if(AudioPlayerTypeIdentifier.getType() === AudioPlayerTypeIdentifier.FLASH)
      {
        logger.info("Player is running in Flash, autoplay policy doesn't apply here.");
        audioContextPromise.resolve(true);
      }
      else
      {
        try{
          //Initialize mock AudioContext
          sampleContext = new AudioContext(false);

          //Initialize mock AudioElement
          sampleAudioElement = new Audio();
          sampleAudioElement.autoplay = false;
          var sourceElement = document.createElement('source');
          sampleAudioElement.appendChild(sourceElement);
          var blob = new Blob([new Uint8Array(8).buffer], {type: 'audio/mpeg'});
          sourceElement.src = window.URL.createObjectURL(blob);
          sourceElement.type = 'audio/mp3';
          sampleAudioElement.volume = 0;
          sampleAudioElement.load();
        }
        catch (error) {
          logger.error('Loading Sample Audio Context and Media Element', error);
          // For some reason we are unable to load AudioContext or MediaElement,
          // then we should resolve the contextPromise so that it will not block resume
          audioContextPromise.resolve(true);
        }

        this.unBlockAudioContextCallback = unBlockAudioContext.bind(this);

        //Listens for user click on the DOM and unblocks both playback contexts
        document.addEventListener('keydown', this.unBlockAudioContextCallback);
        document.addEventListener('click', this.unBlockAudioContextCallback);
      }

      function unBlockAudioContext() {
        logger.debug('unBlockAudioContext for both playback contexts');

        var self = this;
        sampleAudioElement.play().then(function () {
          sampleAudioElement.pause();
          sampleAudioElement.src = '';
          sampleAudioElement.load();
          sampleAudioElement = null;
        }).catch(function (err) {
          logger.error('Failed to unBlock AudioContext of sampleAudioElement', err);
        });


        sampleContext.resume().then(function () {
          if (self._playback && self._playback.audioSink) {
            return (self._playback.autoPlay !== true || self._playback.state === PlayerState.PAUSED) ?  sampleContext.pause() :  Q.when(true);
          } else {
            return sampleContext.reset();
          }
        }).catch(function (err) {
          logger.error('Failed to unBlock AudioContext of web-audio-api', err);
        }).finally(function () {
          //Just resolve the audioContextPromise irrespective of failure or success.
          audioContextPromise.resolve(true);
        });

        //Remove the event listener
        document.removeEventListener('keydown', this.unBlockAudioContextCallback);
        document.removeEventListener('click', this.unBlockAudioContextCallback);
      }
      /**
       * Reference to the Playback instance being monitored.
       * @type {Playback | MediaElementPlayback}
       * @private
       */
      this._playback = null;

      /**
       * Reference to the playbackQueue that contains all the preloaded Playback instances ready for play.
       * @type {PlaybackQueue}
       * @private
       */
      this._playbackQueue = new PlaybackQueue();

      /**
       * Reference to the event manager for the audio player.
       * @type {EventManager}
       * @private
       */
      this._eventManager = new EventManager(getEventInterceptors());

      /**
       * Reference to the quality of service monitor for the audio player; it ensures individual Playback
       * instances are stopped when a new one is played to prevent double audio.
       * @type {QualityOfServiceMonitor}
       * @private
       */
      this._qualityOfServiceMonitor = new QualityOfServiceMonitor();

      /**
       * Stores the volume when it's being set by a client before a Playback instance is created.
       * @type {Number}
       * @private
       */
      this._volume = NaN;

      /**
       * Stores the volume when muted so it can be restored.
       * @type {Number}
       * @private
       */
      this._mutedVolume = 0;

      /**
       * Stores the next track to play for each MySXM track by current track ID.
       * @type {String}
       * @private
       */
      this._nextTrackIdCache = [];

      /**
       * Reference to the last playback instance ID. This is currently only used for logging purposes.
       * @type {String}
       * @private
       */
      this._lastPlaybackId = "N/A";

      this._lastStoppedPlaybackConfig = null;

      /**
       * Playback denied means, our playback is blocked by brower autoPLay policy, Currently there is not way to recover
       * from that unless client send the resume action on the user click only or changes the website setting
       * and during this state we don't want to syncronize any client action
       * @type {Boolean}
       */
      this.playbackDenied = false;

      /**
       * IF we are already in playback denied state once we should ignore the any false denied states
       * @type {Boolean}
       */
      this.isPlaybackAlreadyDenied = false;

      /**
       * Read-only accessor for the current player.
       * @type {Playback}
       */
      Object.defineProperty(this, "currentPlayer",
        {
          get: function () {
            return this._playback || this._preloadedPlayback || null;
          }.bind(this)
        });

      /**
       * Read-only accessor for the preloaded player.
       * @type {Playback}
       */
      Object.defineProperty(this, "_preloadedPlayback",
        {
          get: function () {
            return this._playbackQueue.getNextPlayback() || null;
          }.bind(this)
        });

      /**
       * Accessor to the player's ID.
       * @type {String}
       */
      Object.defineProperty(this, "id",
        {
          get: function () {
            return this._playback ? this._playback.id : "";
          }.bind(this)
        });

      /**
       * Accessor to the player's configuration object.
       * @type {Configuration}
       */
      Object.defineProperty(this, "configuration",
        {
          get: function () {
            return this._playback ? this._playback.configuration : null;
          }.bind(this)
        });

      /**
       * Read-only accessor for the current player's current HLS URL.
       * @type {String}
       */
      Object.defineProperty(this, "currentURL",
        {
          get: function () {
            return this._playback ? this._playback.currentUrl : "";
          }.bind(this)
        });

      /**
       * Read-only accessor for the current player's current playback duration. For Live this is NaN, but for
       * AOD and MySXM this will be an actual number in milliseconds.
       * @type {Number}
       */
      Object.defineProperty(this, "duration",
        {
          get: function () {
            return this._playback ? this._playback.duration : 0;
          }.bind(this)
        });

      /**
       * Indicates if the player is loaded.
       * @type {Boolean}
       */
      Object.defineProperty(this, "isLoaded",
        {
          get: function () {
            return !ObjectUtil.isUndefinedOrNull(this._playback);
          }.bind(this)
        });

      /**
       * Indicates if the player is playing.
       * @type {Boolean}
       */
      Object.defineProperty(this, "isPlaying",
        {
          get: function () {
            return this._playback ? this._playback.isPlaying : false;
          }.bind(this)
        });

      /**
       * Indicates if the player is paused.
       * @type {Boolean}
       */
      Object.defineProperty(this, "isPaused",
        {
          get: function () {
            return this._playback ? this._playback.isPaused : true;
          }.bind(this)
        });

      /**
       * Indicates if the player is preloading.
       * @type {Boolean}
       */
      Object.defineProperty(this, "isPreloading",
        {
          get: function () {
            return this._playback ? this._playback.isPreloading : true;
          }.bind(this)
        });

      /**
       * Indicates if the player is muted.
       * @type {Boolean}
       */
      Object.defineProperty(this, "isMuted",
        {
          get: function () {
            return this._playback ? this._playback.getVolume() <= 0 : true;
          }.bind(this)
        });

      /**
       * Read-only accessor to the cache of Playback instances; made up of both the current Playback instance
       * and any preloaded ones.
       * @type {Playback}
       */
      Object.defineProperty(this, "_playbackCache",
        {
          get: function () {
            return (this._playbackQueue.queue);
          }.bind(this)
        });
    };

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our HTML5AudioPlayer class, we could write:
     *
     *  `BankManager.prototype = HTML5AudioPlayer.prototype`
     *  `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    HTML5AudioPlayer.prototype = {

      /**
       * Whenever you replace an Object's Prototype, you need to repoint
       * the base Constructor back at the original constructor Function,
       * otherwise `instanceof` calls will fail.
       */
      constructor: HTML5AudioPlayer,

      //-----------------------------------------------------------------------
      // PLAYBACK FUNCTIONS
      //-----------------------------------------------------------------------

      /**
       * Begins audio playback.
       *
       * @param {String} url - URL to start playback. Currently either a M3U8 manifest file or AAC audio file.
       * @param {Configuration} config - Contains all parameters for player configuration.
       * @return {Promise}
       */
      play: function (url, config) {
        var self = this;
        if (this.checkUrl(url)) {
          var isRequestedPlaybackCurrent = (this._playback && (this._playback.id === config.id));
          var preloadedPlayback = (!isRequestedPlaybackCurrent) ? this._playbackQueue.getPlaybackById(config.id) : undefined;

          // We only want to resume playback on a preloaded player for the requested playback ID.
          if (isRequestedPlaybackCurrent && this.shouldPlayerResume(this._playback)) {
            logger.debug("play( Resuming player = {0} since it was preloaded or paused. )", [
              this._playback.uid
            ]);
            return this.resume();
          }
          else if(!!preloadedPlayback && this.shouldPlayerResume(preloadedPlayback))
          {
            // this make sures that, if we are trying play a valid playback which cached before the current playback position
            // then move the preloaded(valid playback), after current playback so that it can used to play and not being stopped.
            // if it already in correct order, then below logic doesn't apply and just returns it.

            this._playbackQueue.movePlaybackAfter(this._playback, preloadedPlayback);
            // Stop older playback instances -- make sure to this stop() and not Playback.stop()
            // directly so that it's only called if stopping is necessary and to ensure proper
            // Playback instance cleanup.

            //If we are trying to play a preloaded track from the cache, just resume the that playback
            // and set the active playback to this preloaded
            return this.stop().finally(function () {
              // TODO :Currently resume doesn't support the startTime, so it will be ignored and it will play from whatever it was given in the preload
              // Respect the requested start time parameter in the config.
              var startTime = config.startTime || null;

              //  current playback instance
              self.setActivePlayback(preloadedPlayback);

              logger.debug("resume( Playback[{0}], url = {1}, startTime = {2} )", [preloadedPlayback.uid, url, String(startTime)]);
              return preloadedPlayback.resume();
            });
          }
          else {
            // Stop older playback instances -- make sure to this stop() and not Playback.stop()
            // directly so that it's only called if stopping is necessary and to ensure proper
            // Playback instance cleanup.
            return this.stop().finally(function () {
              // Respect the requested start time parameter in the config.
              var startTime = config.startTime || null;

              // create the new, current playback instance
              var newPlayback = self.createPlaybackInstance(config, self._volume);
              self.setActivePlayback(newPlayback);

              logger.debug("play( Playback[{0}], url = {1}, startTime = {2} )", [newPlayback.uid, url, String(startTime)]);
              self.setFlashRendererOnPlayback(newPlayback);
              return newPlayback.play(url, startTime);
            });
          }
        }
      },

      /**
       * Preloads an audio player.
       *
       * @param {String} url - URL to start playback. Currently either a M3U8 manifest file or AAC audio file.
       * @param {Configuration} config - Contains all parameters for player configuration.
       * @return {Promise}
       */
      preload: function (url, config) {
        var preloadedPlayback = this._playbackQueue.getPlaybackById(config.id);

        // The player is considered stopped if it's not only stopped but also if it's state is "initial"
        // as that means it was just created (and therefore not preloaded or anything).
        var isStopped = preloadedPlayback && (preloadedPlayback.isStopped || preloadedPlayback.isStopping || preloadedPlayback.isInitialized);

        /**
         * In the case of MySXM and auto-play OFF there is no call to play() and preload() is called 2x for
         * player instances 1 and 2. This means there is no _player and the _preloadedPlayer is the last
         * one
         * in. To fix this we'll make sure that if _playback is null, that it's set even in the preload()
         * method.
         * @param {Playback} target - The new playback instance to save.
         */
        var savePlayback = function (target) {
          if (ObjectUtil.isUndefinedOrNull(this._playback)) {
            this.setActivePlayback(target);
          }
          else {
            this.setDefaultVolume(target);
            this._eventManager.activateAllListeners(target);
          }
        }.bind(this);

        if (this.checkUrl(url) && (!preloadedPlayback || isStopped)) {
          var playbackUid = Playback.COUNTER + 1 + "-" + config.id;
          logger.debug("preload( Playback[{0}], startTime = {1}, url = {2} )", [
            playbackUid, config.startTime, url
          ]);

          // create the new, current playback instance
          var playback = this.createPlaybackInstance(config, this._volume);
          savePlayback(playback);
          this.setFlashRendererOnPlayback(playback);
          return playback.preload(url, config);
        }
        else {
          return Q.when(preloadedPlayback);
        }
      },

      /**
       * Pauses audio playback.
       * @return {Promise}
       */
      pause: function () {
        if (this._playback) {
          logger.debug("pause( Playback[{0}] )", [this._playback.uid]);
          return this._playback.pause();
        }
      },

      /**
       * Resumes audio playback when paused.
       * @return {Promise}
       */
      resume: function () {
        if (this._playback) {
          logger.debug("resume( Playback[{0}] )", [this._playback.uid]);

          //If we are in playback denied state and resume was triggered, reset the playbackDenied as resume will unblock the audioContext
          if(this.playbackDenied === true)
          {
            this.playbackDenied = false;
          }
          var self = this;
          return audioContextPromise.promise.finally(function () {
            // There might be scenario where playback instance was destroyed(as if we are entering into finished state,
            // we will stop all playback instances including current one) while we are in process
            // of looking at the audioContextPromise state, this is mainly observed in firefox.
            return self._playback ?  self._playback.resume() : Q.reject('There is no active playback instance.');
          });
        }
      },


      /**
       * Stops audio playback and all player activity, including buffering, loading, fading, etc.
       * Used when ending playback rather than pausing which keeps buffer populated.
       *
       * Stop has the ability to stop a specific player by ID, the current player, or all players.
       *
       * 1) Stop And Remove All = stop( -1 )
       * 2) Stop By ID = stop( valid string ID )
       * 3) Stop All up to and including current... don't touch queue. and don't stop() future playbacks.
       * */


      stop: function (id) {
        var self = this;
        var playbacks = [];

        if (id === -1) {
          // The q library does not resolve or reject
          // Q.all([]).
          //
          //  https://github.com/kriskowal/q/issues/364

          playbacks = this._playbackQueue.queue;

          if (playbacks.length === 0) {
            logger.error("There are no playbacks to stop");
            return Q.when(true);
          }

          logger.debug("Stopping all playbacks, there are {0} playbacks in the queue", [playbacks.length]);

          var idsToStop = [];

          var stoppedPlaybacks = playbacks.map(function (playback) {
            logger.debug("Playback {0} will be stopped", [playback.id]);
            idsToStop.push(playback.id);
            return stopPlayback(playback);
          });

          return Q.all(stoppedPlaybacks)
            .then(function (result) {

              logger.debug("Playbacks stopped, there are {0} playbacks in the queue", [playbacks.length]);

              idsToStop.forEach(function (id) {
                self._playbackQueue.removePlaybackById(id);
              });

              logger.debug("Stopped playbacks removed, there are {0} playbacks in the queue", [playbacks.length]);

              //Should only set the playback state to null incase if we don't have new playback
              // As we are stopping all playbacks, and the current playabck is not in the idsToStop, it means a new playback is already triggered
              if(idsToStop.indexOf(self._playback.id) > -1)
              {
                self._playback = null;
                self._lastStoppedPlaybackConfig = null;
              }

              return result;
            })
            .catch(function (reason) {
              self._playbackQueue.reset();
              self._playback = null;
              self._lastStoppedPlaybackConfig = null;
              logger.warn("stop( Failed stopping Playback[{0}]. )", [reason]);
            });
        }
        else if (id) {
          var playback = this._playbackQueue.getPlaybackById(id);

          if (!playback) {
            return Q.when(true);
          }

          return stopPlayback(playback)
            .then(function (stoppedPlayback) {
              self._lastStoppedPlaybackConfig = stoppedPlayback.configuration;
              self._lastStoppedPlaybackConfig.url = stoppedPlayback.currentUrl;

              return stoppedPlayback;
            })
            .catch(function (reason) {
              logger.warn("stop( Failed stopping Playback[{0}]. )", [reason]);
            });
        }
        else {
          var current = this._playback;
          var playbacksBeforeCurrent = this._playbackQueue.getPlaybacksBefore(current);

          if (current) {
            playbacks = playbacksBeforeCurrent.concat(current);
          }

          if (playbacks.length === 0) {
            return Q.when(true);
          }

          return Q.all(
            playbacks.map(function (playback) {
              return stopPlayback(playback);
            })
            )
            .then(function (result) {
              if (current) {
                self._lastStoppedPlaybackConfig = current.configuration;
                self._lastStoppedPlaybackConfig.url = current.currentUrl;
                self._playback = null;
              }

              return result;
            })
            .catch(function (reason) {
              logger.warn("stop( Failed stopping Playback[{0}]. )", [reason]);
            });
        }


        function stopPlayback(playback) {
          self._eventManager.activateAllListeners(playback, false);

          return playback.stop()
            .then(function (stoppedPlayback) {
              logger.info("stop( Cleaning up instance Playback[{0}] and making available for garbage collection. )", [
                stoppedPlayback.uid
              ]);
              return stoppedPlayback;
            })
            .catch(function (fault) {
              logger.warn("stop( Failed stopping Playback[{0}]. )", [fault]);
              throw fault;
            });
        }
      },

      /**
       * Goes to and plays audio from provided seekTime. Assumes that player is already configured and
       * playlist is loaded.
       *
       * @param {Number|Date|String} startTime Can be the offset from the beginning of play in milliseconds
       * or a date or string date object.
       * @param {String} [url] - Optional parameter that provides an HLS URL; if not used the player will try
       *     to seek within the current HLS URL.
       * @return {Promise}
       */
      seek: function (startTime, url) {
        var self = this;
        // We have an existing playback instance in hand so simply clone it and seek on the clone.
        if (this._playback) {
          logger.debug("seek( Cloning existing Playback[{0}] and seeking. )", [this._playback.uid]);

          // If the playback instance is MediaElementPlayback, then just do a seek on MediaElement playback instance
          // instead of creating a new instance and trying to load it and stopping the existing one

          if (this._playback instanceof MediaElementPlayback || this._playback.configuration.useMediaElement) {
            return this._playback.seek(startTime, url);
          }
          // Order is important here...
          // 1) Clone the existing playback instance OR create a new one from the last config.
          // 2) Stop the existing playback instance.
          // 3) Set the new playback instance to the active, current one.
          // 4) Perform seek on the new playback instance.

          var freshPlayback = this._playback.clone();

          return this.stop().finally(function () {
            logger.debug("seek( Adding new (cloned) playback to queue. )", [freshPlayback.uid]);
            self._playbackQueue.addPlayback(freshPlayback);
            self.setActivePlayback(freshPlayback);

            self.setFlashRendererOnPlayback(freshPlayback);
            return freshPlayback.seek(startTime, url);
          });
        }
        // In the case of an AOD episode finishing playback is stopped and removed from memory,
        // so in order to seek to the same episode again we need the config object from it to
        // to create a new playback instance and use the last known URL.
        else if (this._lastStoppedPlaybackConfig) {
          var config = this._lastStoppedPlaybackConfig;
          config.startTime = startTime;
          logger.debug("seek( Created new Playback[{0}] from last stopped config and play. )", [config.uid]);
          return this.play(config.url, config);
        }
        else {
          logger.info("seek( No playback to seek. )");
          return Q.when(this);
        }
      },

      /**
       * @param {playback} playback
       */
      setFlashRendererOnPlayback: function(playback) {
        var self = this;
        if(!playback.flashRenderer)
        {
          logger.debug("Add flashRenderer to Playback ", self.flashRenderer);
          if(self.flashRenderer)
          {
            playback.flashRenderer = self.flashRenderer;
          }
        }

      },

      /**
       * Performs the skip audio player action and plays the next track. This is currently only enabled for
       * MySXM audio playback.
       *
       * @param {String} url - The URL to play.
       * @param {Configuration} config - Contains all parameters for player configuration.
       * @return {Promise}
       */
      skip: function (url, config) {
        var self = this;
        var skipToPlayback = this._playbackQueue.getNextPlayback(config.id);
        var uid = (Playback.COUNTER + 1) + "-" + config.id;

        // For optimal playback audio speed we'll attempt to resume the playback instance
        // instead of starting the entire playback process over and downloading manifests
        // and chunks.
        if (skipToPlayback && this.shouldPlayerResume(skipToPlayback)) {
          logger.debug("skip( Resuming Playback[{0}], {1} )", [
            skipToPlayback.uid, skipToPlayback.currentUrl
          ]);

          // Make sure the track doesn't fade in when rewinding and always start playback immediately.
          skipToPlayback.configuration.fadeInAllowed = false;
          skipToPlayback.autoPlay = true;

          return this.stop().finally(function () {
            self.setActivePlayback(skipToPlayback);
            return skipToPlayback.resume();
          });
        }
        else {
          logger.debug("skip( Loading Playback[{0}], {1} )", [
            uid, url
          ]);
          // Make sure the track doesn't fade in when rewinding and always start playback immediately.
          config.fadeInAllowed = false;
          config.autoPlay = true;
          return this.play(url, config);
        }
      },

      /**
       * Performs the rewind audio player action. If the player's URL is the same as the current one, then
       * simply rewind to the beginning of the track, otherwise start playing the URL provided (which should
       * be the prior track).
       *
       * @param {String} url - The URL to play.
       * @param {Configuration} config - Contains all parameters for player configuration.
       * @return {Promise}
       */
      rewind: function (url, config) {
        var uid = (Playback.COUNTER + 1) + "-" + config.id;

        var isIntraRewind = function (id) {
          return (this._playback.id === id);
        }.bind(this);

        // Make sure the track doesn't fade in when rewinding and always start playback immediately.
        config.fadeInAllowed = false;
        config.autoPlay = true;

        // If the URL being requested is the same as the one being played then simply rewind to the
        // beginning of that track.
        if (isIntraRewind(config.id)) {
          logger.debug("rewind( Play from beginning of current track: Seeking Playback[{0}], {1} )", [
            uid, url
          ]);

          return this.seek(0, url);
        }
        // Otherwise start playing the new URL being requested.
        else {
          logger.debug("rewind( Play the prior track: Loading Playback[{0}], {1} )", [
            uid, url
          ]);

          // Attempt to play from a cached Playback instance as it's faster than restarting the entire process.
          var rewindToPlayback = this._playbackQueue.getPlaybackById(config.id);
          if (rewindToPlayback) {
            this.setActivePlayback(rewindToPlayback);
            return this.restartPlayback(rewindToPlayback, url);
          }
          else {
            return this.play(url, config);
          }
        }
      },

      // ----------------------------------------------------------------------
      // VOLUME FUNCTIONS
      //-----------------------------------------------------------------------

      /**
       * Sets the audio player's volume.
       *
       * @param {Number} value - The volume for the audio player.
       */
      setVolume: function (value) {
        logger.debug("setVolume( Saving volume = {0} for later. )", [value]);
        this._volume = value;

        if (this._playback) {
          logger.debug("setVolume( Setting volume = {0} on Playback. )", [value]);

          var setPlaybackVolume = function (playback) {
            playback.setVolume(value);
          };

          this._playbackCache.forEach(setPlaybackVolume);
        }
      },

      /**
       * Returns the current volume of the player.
       *
       * @returns {Number} The current volume of the player.
       */
      getVolume: function () {
        if (this._playback) {
          var value = this._playback.getVolume();
          logger.debug("getVolume( Using current Playback's volume = {0} )", [value]);
          return value;
        }
        else if (!isNaN(this._volume)) {
          logger.debug("getVolume( Using internal _volume = {0} )", [this._volume]);
          return this._volume;
        }

        return NaN;
      },

      /**
       * Mutes the audio player's volume.
       */
      mute: function () {
        if (this._playback) {
          logger.debug("mute()");
          this._mutedVolume = this._playback.getVolume();

          // TODO: BMR: Need to set volume on all players: current, preloaded, prior, etc
          return this._playback.setVolume(0);
        }
      },

      /**
       * Un-Mutes the audio player's volume.
       */
      unmute: function () {
        if (this._playback) {
          logger.debug("unmute()");

          // TODO: BMR: Need to set volume on all players: current, preloaded, prior, etc
          return this._playback.setVolume(this._mutedVolume);
        }
      },

      /**
       * Toggles the audio player's volume as mute or unmute.
       */
      toggleMute: function () {
        logger.debug("toggleMute()");
        var muteFn = this.isMuted() ? this.unmute : this.mute;
        return muteFn();
      },

      /**
       * Fades Player Volume based on provided params. Can be used to fade Up or Down.
       *
       * @param {Number} startVolume - The start volume for the fade operation.
       * @param {Number} endVolume - The end volume for the fade operation.
       * @param {Number} durationInMilliseconds - The number of milliseconds for the fade operation.
       */
      fade: function (startVolume, endVolume, durationInMilliseconds) {
        logger.warn("fade( " + PlayerError.METOHD_NOT_IMPLEMENTED + " {0}, {1}, {2} )", [startVolume, endVolume, durationInMilliseconds]);
      },

      //-----------------------------------------------------------------------
      // MISC PLAYER API
      //-----------------------------------------------------------------------

      /**
       * Updates the configuration for a given player; the ID of the incoming config must match the ID of
       * the current playback instance.
       *
       * @param {Configuration} config - The newly updated player config object.
       */
      updateConfiguration: function (config) {
        if (this._playback && config && !ObjectUtil.isUndefinedOrNullOrEmptyString(config.id)) {
          if (this._playback.configuration.id === config.id) {
            logger.debug("updateConfiguration( id = {0} )", [config.id]);
            this._playback.configuration = config;
          }
          else {
            logger.warn("updateConfiguration( DO NOT update config. Playback id = {0} is NOT equal to Config id = {2} )", [
              this._playback.configuration.id, config.id
            ]);
          }

        }
      },

      /**
       * Updates the source URL  for the give playback instance.
       *
       * @param {url} string - Source of the media
       * @param {playbackId} string - id for playback.
       */
      updatePlaybackSource: function (url, playbackId) {
        if(!url || !playbackId)
        {
          logger.error("DO NOT update PlaybackSource as either url: {0} or playbackid:{1} is missing", [url, playbackId]);
          return;
        }

        var playback = this._playbackQueue.getPlaybackById(playbackId);

        if (playback) {
          logger.debug("updating the source url for the playback id = {0} ", [playbackId]);
          playback.updateSource(url);
        } else {
          logger.error("No Playback found with the ( id = {0} )", [playbackId]);
        }
      },

      /**
       * Enables or disables the logging for the core JS audio player implementaiton.
       *
       * @param {Boolean} bool - Flag indicating if the logging for the player is enabled.
       */
      enableLogging: function (bool) {
        logger.debug("enableLogging( {0} )", [bool]);
        LoggerFactory.isEnabled = bool;
      },

      /**
       * Enables or disables crossfade for the audio player implementaiton.
       *
       * @param {Boolean} bool Flag indicating if crossfade for the player is enabled.
       */
      enableCrossfade: function (bool) {
        var playbacks = [];
        if (bool) {
          playbacks = this._playbackQueue.getPlaybacksAfter(this._playback);
          playbacks.unshift(this._playback); // turn on this and later.
        }
        else {
          playbacks = this._playbackQueue.queue;  // turn off all.
        }

        playbacks.forEach(function (playback) {
          playback.crossfade(bool);
        });
      },

      /**
       * Sets up MySXM continuous playback with current and next track IDs; the next track ID is stored in
       * a dash using the current track ID as the key. The next track is then retrieved when either the
       * current one has completed playback or the crossfade event is fired.
       *
       * @param {String} trackId - Current track ID.
       * @param {String} nextTrackId - Next track ID.
       */
      setNextTrack: function (trackId, nextTrackId) {
        logger.debug("setNextTrack( trackId = {0}, nextTrackId = {1} )", [trackId, nextTrackId]);
        this._nextTrackIdCache[trackId] = nextTrackId;

        // If we have playback that is before the current playback, move the position to later
        var nextTrackPlayback = this._playbackQueue.getPlaybackById(nextTrackId);
        var tragetTrackPlayback = this._playbackQueue.getPlaybackById(trackId);
        if(nextTrackPlayback && tragetTrackPlayback)
        {
          this._playbackQueue.movePlaybackAfter(tragetTrackPlayback, nextTrackPlayback);
        }
      },

      /**
       * Returns the playlist for a given URL.
       */
      getPlaylist: function () {
        if (this._playback && this._playback.playlist) {
          var playlist = this._playback.playlist;
          logger.debug("getPlaylist( Playlist has {0} chunks. )", [playlist.chunkUrls.length]);
          return {
            chunkUrls: playlist.chunkUrls,
            timestamps: playlist.timestamps
          };
        }
        else {
          logger.warn("getPlaylist( There is no playlist. )");
          return null;
        }
      },

      //-----------------------------------------------------------------------
      // EVENT DISPATCHING
      //-----------------------------------------------------------------------

      /**
       * Add an event listener to the player.
       *
       * @param {String} type - The string event type used to map to the event listener function.
       * @param {Function} handler - The event listener function.
       */
      addEventListener: function (type, handler) {
        logger.debug("addEventListener( `{0}` )", [type]);
        this._eventManager.addEventListener(type, handler, this.currentPlayer);
      },

      /**
       * Remove an event listener from the player.
       *
       * @param {String} type - The string event type used to map to the event listener function.
       * @param {Function} handler - The event listener function.
       */
      // eslint-disable-next-line no-unused-vars
      removeEventListener: function (type, handler) {
        logger.debug("removeEventListener( `{0}` )", [type]);

        // TODO: BMR: 03/09/2106: Commented out as it kills the "playbackReady" too early...come back to this
        this._eventManager.removeEventListener(type, handler, this.currentPlayer);
      },

      /**
       * Handles the finished event from the playback engine and stops the current playback and starts playing
       * the preloaded, next playback IFF both are MySXM playbacks.
       *
       * Due to the async nature of events and promises we need to make sure the stop() method is executed
       * before we start to resume() the preloaded player's playback. This allows the "finished" event from
       * the current playback to fire and be received by clients before the next, preloaded playback fires
       * its "playheadStart" event -- if the latter is received prior to the first the client will be out
       * of sync.
       */
      onFinished: function (event) {
        // Grab the first preloaded playback instance off the queue that's not the current player.
        var finishedPlaybackId = event.id;
        var finishedPlayback = this._playbackQueue.getPlaybackById(finishedPlaybackId);
        var nextTrackId = this._nextTrackIdCache[finishedPlaybackId];
        var nextPlayback = nextTrackId ? this._playbackQueue.getNextPlayback(nextTrackId) : null;

        // Set up some tests to make sure the preloaded playback instance and current are valid.
        var isMultiTrack = PlaybackTypeUtil.isPlayerMySXM(finishedPlayback) || PlaybackTypeUtil.isPlayerTrackBased(finishedPlayback);
        var playbacksExist = !ObjectUtil.isUndefinedOrNull(finishedPlayback) && !ObjectUtil.isUndefinedOrNull(nextPlayback);
        var validPlaybacks = playbacksExist && isMultiTrack;

        var playNext = function () {
          var restartPlaybackFailed = function (error) {
            logger.error("onFinished.restartPlaybackFailed( There are no tracks to play. Alerting client {0}. )",
              [error.toString()]);

            this._playback.dispatchPlayerEvent(PlayerEvent.NO_TRACKS);
          }.bind(this);

          logger.debug("onFinished( Finished track ID = {0}. Play next track ID = {1}. )", [
            finishedPlaybackId, nextPlayback.uid
          ]);

          // Save the last ID...basically used for logging.
          this._lastPlaybackId = finishedPlaybackId;

          // if next track has already crossfaded in
          if (nextPlayback.state === PlayerState.PLAYING) {
            return;
          }

          // Make the preloaded player the active one.
          this.setActivePlayback(nextPlayback);

          // Play the preloaded player, which is now the active one as well.
          // NOTE: We attempt to play the cached Playback instance from the beginning instead of
          // starting the entire playback process over again.
          this.restartPlayback(nextPlayback).fail(restartPlaybackFailed);
        }.bind(this);

        // If the current player is multitrack then try to stop the current player and play the next one.
        // NOTE: Do not attempt to stop the current player if it's not multitrack as we want to keep it
        // around for seeking performance. It'll get cleaned up as soon as the next player is ready
        // to rock.
        if (isMultiTrack) {
          if (!validPlaybacks) {
            // The expected preload Playback instance was removed from cache, so create a new one
            // using the config object for the requested player.
            var config = this._playbackQueue.getConfigById(nextTrackId);

            var logMsg = "onFinished( INVALID TRACKS >> Finished track ID = {0}. Next track ID = {1}. {2} )";

            if (config) {
              logger.warn(logMsg, [
                finishedPlaybackId, nextTrackId, "Creating new Playback with cached config since no preloaded playback exists."
              ]);

              // Create a new playback from the existing config.
              nextPlayback = this.createPlaybackInstance(config, this._volume);

              // Stop the current player and then play the preloaded playback.
              this.stop(finishedPlaybackId).then(playNext);
            }
            else {
              logger.warn(logMsg, [
                finishedPlaybackId, nextTrackId, "No preloaded Playback and no config to create one. Alerting client."
              ]);

              // Without a playback instance or config to create one we're dead in the water. Stop playback and
              // alert the client that we're out of tracks to play.
              this._playback.dispatchPlayerEvent(PlayerEvent.NO_TRACKS);
              this.stop();
            }
          }
          else {
            // Stop the current player and then play the next one.
            this.stop(finishedPlaybackId).then(playNext);
          }
        }
        // If the current player is not MySXM (and most likely AOD since Live is infinite and shouldn't ever
        // finish), then simply stop it.
        else {
          this.stop();
        }
      },

      /**
       * Handles the restart event from the playback engine and stops all playback instances -- it's
       * essentially a reset to the player since the player was told to restart, which occurs from
       * failover failing.
       */
      onRestart: function () {
        logger.info("onRestart( Playback[{0}] )", [(this._playback) ? this._playback.uid : "no playback"]);
        this.stop(-1);
      },

      /**
       * Handles the behind playlist event from the playback engine
       * This calls a seek to the beginning of the current playlist
       */
      onBehindPlaylist: function () {
        logger.info("onBehindPlaylist( Playback[{0}] )", [(this._playback) ? this._playback.uid : "no playback"]);
        this.seek(0);
      },

      /**
       * * Handles the track failed event from the playback engine and stops all playback instances -- it's
       * * essentially a reset to the player which occurs from failover failing.
       * */
      onTrackFailed: function () {
        logger.info("onTrackFailed( Playback[{0}] )", [(this._playback) ? this._playback.uid : "no playback"]);
        this.stop(-1);
      },


      onCrossfadePointReached: function () {
        var self = this;
        // Grab the first preloaded playback instance off the queue that's not the current player.
        var currentPlayerId = this._playback ? this._playback.id : "Null player";
        var nextTrackId = this._nextTrackIdCache[this._playback.id];
        var nextPlayback = nextTrackId ? this._playbackQueue.getNextPlayback(nextTrackId) : null;

        if (!nextPlayback || !nextPlayback.isCrossfadeOn()) {
          return;
        }

        // If the current player is MySXM then try to stop the current player and play the next one.
        // NOTE: Do not attempt to stop the current player if it's not MySXM as we want to keep it
        // around for seeking performance. It'll get cleaned up as soon as the next player is ready
        // to rock.
        if (PlaybackTypeUtil.isPlayerMySXM(this._playback)) {   // will need to add seeded
          if (!nextPlayback) {
            // The expected preload Playback instance was removed from cache, so create a new one
            // using the config object for the requested player.
            var config = this._playbackQueue.getConfigById(nextTrackId);

            var logMsg = "onFinished( INVALID TRACKS >> Finished track ID = {0}. Next track ID = {1}. {2} )";

            if (config) {
              logger.warn(logMsg, [
                currentPlayerId, nextTrackId, "Creating new Playback with cached config since no preloaded playback exists."
              ]);

              // Create a new playback from the existing config.
              nextPlayback = this.createPlaybackInstance(config, this._volume);

              // Just start playing the preloaded playback.
              playNext();
            }
            else {
              logger.warn(logMsg, [
                currentPlayerId, nextTrackId, "No preloaded Playback and no config to create one. Alerting client."
              ]);

              // Without a playback instance or config to create one we're dead in the water. Stop playback and
              // alert the client that we're out of tracks to play.
              this._playback.dispatchPlayerEvent(PlayerEvent.NO_TRACKS);
              this.stop();
            }
          }
          else {
            // Just start playing the next one.
            playNext();
          }
        }

        function playNext() {

          logger.debug("onFinished( Finished track ID = {0}. Play next track ID = {1}. )", [
            currentPlayerId, nextPlayback.uid
          ]);

          // Save the last ID...basically used for logging.
          self._lastPlaybackId = currentPlayerId;

          // Make the preloaded player the active one.
          self.setActivePlayback(nextPlayback);

          // Play the preloaded player, which is now the active one as well.
          // NOTE: We attempt to play the cached Playback instance from the beginning instead of
          // starting the entire playback process over again.
          self.restartPlayback(nextPlayback).fail(function () {
            logger.error("onFinished.restartPlaybackFailed( There are no tracks to play. Alerting client. )");
            self._playback.dispatchPlayerEvent(PlayerEvent.NO_TRACKS);
          });
        }
      },

    /**
     * Handler for playbackDenied incase of autoplay policy is preventing us from the playing
     */
      onPlaybackDenied: function () {
        this.playbackDenied = true;
        this.isPlaybackAlreadyDenied = true;
      },

      //-----------------------------------------------------------------------
      // INTERNAL FUNCTIONS
      //-----------------------------------------------------------------------

      /**
       * Creates a new Playback instance with a properly created player configuration object.
       *
       * @param {Configuration} config - The player config object as a raw JS object literal.
       * @param {Number} volume - The default volume for the new Playback object.
       * @returns {Playback} New Playback object.
       */
      createPlaybackInstance: function (config, volume) {
        config = this.buildConfig(config, volume);
        var pb;

        // IF we are running on IE11, and the playback type is MP3 we just default to MediaElementPlayback
        // or if Client want to use MediaElement, we will allow them to use MediaElementPlayback
        if((this.flashRenderer && config.playbackType === PlaybackTypeUtil.MP3) || config.useMediaElement)
        {
          pb = new MediaElementPlayback(config);
        }
        else {
          pb =  new Playback(config);
        }

        logger.debug("createPlaybackInstance( Playback[{0}] )", [pb.uid]);
        return this._playbackQueue.addPlayback(pb);
      },

      // TODO: BMR: 03/03/2016: Consider moving to a ConfigFactory or Configuration.build() -- see PlayerConfig.as for details.
      /**
       * Creates a proper player configuration object from the raw JavaScript object literal.
       * @param {Object} config - The player config object as a raw JS object literal.
       * @param {Number} volume - The default volume for the new Playback object.
       * @returns {Configuration}
       */
      buildConfig: function (config, volume) {
        var audioURLs = config.audioURLs || (config.audio ? config.audio.data : null);
        if (!ObjectUtil.isUndefinedOrNullOrEmptyString(audioURLs)) {
          config.audio = new AudioModel(audioURLs);
          delete config.audioURLs;
        }
        else {
          throw new PlayerError(PlayerError.REQUIRED_PARAM, ["config.audioURLs"]);
        }

        if (!ObjectUtil.isUndefinedOrNullOrEmptyString(config.audioFirstURLs)) {
          config.audioFirst = new AudioFirst(config.audioFirstURLs);
          delete config.audioFirstURLs;
        }

        if (!ObjectUtil.isUndefinedOrNullOrEmptyString(config.connectivityUrl)) {
          HlsConfig.CONNECTIVITY_URL = config.connectivityUrl;
        }

        if (ObjectUtil.isEmptyString(config.startTime)) {
          config.startTime = null;
        }

        HlsConfig.CONSUMPTION_INFO = config.hlsConsumptionInfo || '';

        if (!ObjectUtil.isUndefinedOrNullOrEmptyString(config.keyPath)) {
          HlsConfig.KEYPATH = config.keyPath;
        }

        HlsConfig.getTokenizedUrl = ObjectUtil.isFunction(config.getTokenizedUrl) ?
          config.getTokenizedUrl : function (url) {
            return url;
          };

        HlsConfig.getTokenStrategy = ObjectUtil.isFunction(config.getTokenStrategy) ?
          config.getTokenStrategy : function () {
            return null;
          };

        // Set the default volume. It's possible the volume that's passed in is still NaN as the default,
        // so we make sure to grab it from the config in this case.
        config.volume = volume || config.volume || HlsConfig.VOLUME_DEFAULT;

        // Set the flag stating if we already entered to PlaybackDenied state once
        config.isPlaybackAlreadyDenied = this.isPlaybackAlreadyDenied;

        logger.debug("buildConfig( ID = {0} )", [config.id]);
        return config;
      },

      /**
       * Sets the active or current playback instance and activates all the listeners for it.
       *
       * @param {Playback} newPlayback - New, current playback instance.
       */
      setActivePlayback: function (newPlayback) {
        if (ObjectUtil.isUndefinedOrNull(newPlayback)) {
          throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
        }

        // Set up some logging vars.
        var oldId = this._playback ? this._playback.uid : this._lastPlaybackId;
        var newId = newPlayback.uid;
        logger.debug("setActivePlayback( old = {0}, new = {1} )", [oldId, newId]);

        // Set the default volume.
        this.setDefaultVolume(newPlayback);

        // Pass the QOS Monitor the new and old Playback instances so it can stop the old if necessary.
        this._qualityOfServiceMonitor.activate(newPlayback, this._playback, this._playbackCache);

        // Save the new Playback instance and setup it's listeners.
        this._playback = newPlayback;
        this._eventManager.activateAllListeners(newPlayback);
      },

      /**
       * Attempts to set the default volume using an existing playback instance.
       *
       * @param {Playback} newPlayback - New playback instance that needs volume.
       */
      setDefaultVolume: function (newPlayback) {
        var volume = this.getVolume();
        volume = !isNaN(volume) ? volume : newPlayback.configuration.volume;
        logger.debug("setDefaultVolume( {0} )", [volume]);
        newPlayback.setVolume(volume);
      },

      /**
       * Throws an error if the specified URL parameter is null or an empty string.
       *
       * @param {String} url - URL being checked for validity.
       */
      checkUrl: function (url) {
        if (ObjectUtil.isUndefinedOrNullOrEmptyString(url)) {
          var logMsg = "The HLS URL for the audio player cannot be undefined, null, or an empty string";
          logger.error(logMsg);
          throw new Error(logMsg);
        }

        return url;
      },

      /**
       * Indicates if the player is in a resumeable state either because it's preloaded or paused.
       *
       * @param {Playback} playback - Playback instance being checked for validity.
       */
      shouldPlayerResume: function (playback) {
        var exists = !ObjectUtil.isUndefinedOrNull(playback);
        return exists && (playback.isPreloading || playback.isPaused);
      },

      /**
       * Starts the current Playback instance over by starting it up or by simply resuming if the
       * Playback has never actually played.
       *
       * If there's no URL, then we alert the client so it can determine how to handle. Currently this
       * restarts a channel in an attempt to restart audio.
       *
       * @param {Playback} playback - Playback instance being restarted.
       * @param {String} [url] - Optional playback URL.
       */
      restartPlayback: function (playback, url) {
        // The player is considered stopped if it's not only stopped but also if it's state is "initial"
        // as that means it was just created (and therefore not preloaded or anything).
        var isStopped = playback.isStopped || playback.isStopping || playback.isInitialized;

        if (ObjectUtil.isUndefinedOrNull(playback)) {
          throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
        }

        if (playback.hasPlayed || isStopped) {
          url = url || playback.currentUrl || playback.getDefaultUrl(null, null, true);

          if (url) {
            logger.debug("restartPlayback( Reinitializing Playback[{0}] as it's already played with URL = {1}. )", [
              playback.uid, url
            ]);

            // We might be able to optimize playback to be faster by reusing the Playback instance and seeking,
            // but the code becomes extremely complex and introduces many possible regression issues. Instead
            // we simply restart the process and call play().
            //
            // return playback.seek(0, url);
            //
            // Make sure the track doesn't fade in when restarting and always start playback immediately.
            playback.configuration.fadeInAllowed = false;
            playback.autoPlay = true;
            return this.play(url, playback.configuration);
          }
          else {
            logger.error("restartPlayback( We are dead in the water. No URL for Playback[{0}], URL = {1}. )", [
              playback.uid, url
            ]);
            this._playback.dispatchPlayerEvent(PlayerEvent.NO_TRACKS);
            Q.reject(PlayerEvent.NO_TRACKS);
          }
        }
        else {
          logger.debug("restartPlayback( Resuming as [{0}] has never played. )", [playback.uid]);
          return playback.resume();
        }
      },

      /**
       * Warms up the audio player by calling resume() then suspend();
       * */
      warmUp: function () {
        return Q.when(true);
      }
    };

    return HTML5AudioPlayer;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/AudioBufferContext.js":
/*!**************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/AudioBufferContext.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************************************************************
 * @MODULE:     AACBufferContext
 * @CREATED:    12/22/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Utility class that abstracts away the Web Audio API Audio Context audio buffer functionality
 **********************************************************************************************************************/
/* beautify preserve:start */



/*******************************************************************************************************************
 * Register the module with RequireJS.
 ******************************************************************************************************************/
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  //----------------------------------------------------------------------------------------------------------
  // CLASS members
  //----------------------------------------------------------------------------------------------------------

  var AudioContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js");
  var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");

  //----------------------------------------------------------------------------------------------------------
  // CONSTRUCTOR
  //----------------------------------------------------------------------------------------------------------

  /**
   * AudioBufferContext Constructor
   *
   * @param {Boolean} createContext if true, then a new audio context will be created and used.  This is
   * handled by parent constructor
   */
  function AudioBufferContext(createContext) {
    createContext = createContext || false;

    AudioBufferContext.parent.call(this, createContext); // Call parent constructor

    ClassUtils.bind(this, AudioBufferContext);
  };

  //----------------------------------------------------------------------------------------------------------
  // PROTOTYPE Inherit AudioDecodeContext's prototype and restore AacDecoder's constructor
  //----------------------------------------------------------------------------------------------------------

  ClassUtils.subClass(AudioBufferContext, AudioContext).prototype = {

    /*******************************************************************************************************
     * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/createBuffer
     *
     * @param numChannels number of channels of audio the buffer will contain
     * @param numSamples number of audio samples in each channel
     * @param sampleRate number of samples per second the buffer will be created fpr
     * @returns {AudioBuffer} filled with zeroed samples
     ******************************************************************************************************/
    createBuffer: function (numChannels, numSamples, sampleRate) {
      if (this.audioContext !== null) {
        return this.audioContext.createBuffer(numChannels, numSamples, sampleRate);
      }

      return null;
    },

    /*******************************************************************************************************
     * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/createBufferSource
     *
     * @returns {AudioBufferSourceNode}
     ******************************************************************************************************/
    createBufferSource: function () {
      if (this.audioContext !== null) {
        return this.audioContext.createBufferSource();
      }
      else {
        return null;
      }
    }
  };

  return AudioBufferContext;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js":
/*!********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/***
 * @MODULE:     AudioContext
 * @CREATED:    12/22/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Utility class that abstracts away the Web Audio API Audio Context object
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var AudioUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
    var Q = __webpack_require__(/*! q */ "q");

    //----------------------------------------------------------------------------------------------------------
    // MODULE variables
    //----------------------------------------------------------------------------------------------------------

    var logger = LoggerFactory.getLogger("AudioContext", "CORE");

    /**
     * AudioContext Constructor
     *
     * @param {Boolean} createContext if true, then a new audio context will be created and used, otherwise the
     *                  global audio context (created above) will be used
     */
    var AudioContext = function (createContext) {
      createContext = createContext || false;

      ClassUtils.bind(this, AudioContext);

      //------------------------------------------------------------------------------------------------------
      // CLASS MEMBERS
      //------------------------------------------------------------------------------------------------------

      var self = this; // for usage in properties

      /**
       * The AudioContext instance that will be used for all audio functions.  The actual reference to
       * the audio context will be captured in a closure, and will either reference the global context
       * (audioContext above), or be a context created specifically for this object (if createContext is true)
       *
       * Access to the context will be through a read only property on the object
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
       *
       * @type {AudioContext}
       */
      (function () {
        if (!AudioContext.audioContext) {
          AudioContext.audioContext = AudioContext.createContext();
        }

        var _localAudioContext;
        var _globalAudioContext = AudioContext.audioContext;

        _globalAudioContext.isGlobal = true;

        if (createContext === true) {
          _localAudioContext = AudioContext.createContext();
        }

        Object.defineProperty(self, "audioContext", {
          get: function () {
            return _localAudioContext || _globalAudioContext;
          },
          set: function (value) {
            _localAudioContext = value;
          }
        });

      })(); // call lambda, create closure, bind either global or local context;
    };

    //----------------------------------------------------------------------------------------------------------
    // PROTOTYPE
    //----------------------------------------------------------------------------------------------------------

    /**
     * Hash of enumerated values describing constants the AudioContext's state.
     * @type {Object}
     */
    AudioContext.AUDIO_CONTEXT_STATE = {
      RUNNING: "running", // Playing audio
      SUSPENDED: "suspended", // Not playing audio but not closed
      CLOSED: "closed" // Not playing audio and closed
    };

    /**
     * Constants that are useful for audio operations
     * @type {Object}
     */
    AudioContext.CONSTS = {
      FAILED: "failed",
      IN_PROGRESS: "inprogress",
      NO_CONTEXT: "nocontext",
      NO_BUFFERS: "nobuffers",
      CLOSED: "closed",
      OFFLINE: "offline",
      STEREO: AudioUtil.CONSTS.STEREO_NUMCHANNELS,
      MONO: AudioUtil.CONSTS.MONO_NUMCHANNELS,
      SAMPLE_RATE_48KHZ: AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_48KHZ,
      SAMPLE_RATE_44KHZ: AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_44KHZ,
      SAMPLE_RATE_22KHZ: AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_22Khz,
      SAMPLE_RATE_11KHZ: AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_11KHZ
    };

    Object.defineProperty(AudioContext, "sampleRate", {
      get: function () {
        return AudioContext.audioContext.sampleRate;
      }
    });

    /**
     * Check if the Web Audio APIs are available
     *
     * @returns true if WAA is available, false otherwise
     */
    AudioContext.isSupported = function () {
      return (window.AudioContext || window.webkitAudioContext) ? true : false;
    };

    /**
     * Create a new Web Audio API context
     *
     * @returns {AudioContext} a new WAA audio context
     */
    AudioContext.createContext = function () {
      var WebAudioAPIContext = window.AudioContext || window.webkitAudioContext;
      var context = new WebAudioAPIContext();

      if (!context.state) {
        var _state = AudioContext.AUDIO_CONTEXT_STATE.RUNNING;
        Object.defineProperty(context, "state", {
          get: function () {
            return _state;
          },
          set: function (value) {
            var e = new Event("statechange");

            if (this.onstatechange && typeof this.onstatechange === "function") {
              this.onstatechange(e);
            }

            _state = value;
            if (this.dispatchEvent) {
              this.dispatchEvent(e);
            }
          }
        });
      }

      if (!context.suspend && !context.resume) {

        context.suspendable = false;

        context.suspend = function () {
          if (this.state === AudioContext.AUDIO_CONTEXT_STATE.CLOSED) {
            return Q.reject("Cannot call suspend on a closed AudioContext object");
          }

          this.state = AudioContext.AUDIO_CONTEXT_STATE.SUSPENDED;

          return Q.resolve();
        };

        context.resume = function () {
          if (this.state === AudioContext.AUDIO_CONTEXT_STATE.CLOSED) {
            return Q.reject("Cannot call resume on a closed AudioContext object");
          }

          this.state = AudioContext.AUDIO_CONTEXT_STATE.RUNNING;

          return Q.resolve();
        };
      }
      else {
        context.suspendable = true;
      }

      if (!context.close) {
        context.close = function () {
          if (this.state !== AudioContext.AUDIO_CONTEXT_STATE.CLOSED) {
            this.suspend(null);
            this.state = AudioContext.AUDIO_CONTEXT_STATE.CLOSED;
            this.suspend = null;
            this.resume = null;
            this.close = null;

            return Q.resolve();
          }

          return Q.reject("Cannot close an audio context that has already been closed");
        };
      }

      // TODO: Bundle this logic up into factory that allows the player to chose the appropriate decoder function at runtime.
      // If this is a Win10 Universal App, and there is a global decodeAudioData function available, then
      // this means we will use that function instead of the audioContext function.  There was a bug
      // in the ms implementation of the decodeAudioFunction that caused the decoder to hang, and this
      // is the workaround.
      //
      // Once the bug is fixed, the web client should remove the global decodeAudioDecode function.  Then
      // we can use the audioContext version again.  We may need to keep this code around for a while,
      // because the client may need to detect the OS version it is running on to make the decision
      // about whether or not we need to bypass the audioContext.decodeAudioData function or not.
      if ((typeof Windows !== 'undefined') && typeof window.decodeAudioData === 'function') {
        context.decodeAudioData = window.decodeAudioData;
      }

      return context;
    };

    /**
     * Create a new offline Web Audio API context
     *
     * @returns {OfflineAudioContext} a new WAA offline audio context
     */
    AudioContext.createOfflineContext = function () {
      var WebAudioAPIOfflineContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;

      return new WebAudioAPIOfflineContext(AudioContext.CONSTS.STEREO, 2048, AudioContext.sampleRate);
    };

    ClassUtils.baseClass(AudioContext).prototype = {

      /**
       * Property that gets the clock time for the underlying audio context
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/currentTime
       *
       * @return {Number} seconds since the context was "started"
       */
      currentTime: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return (this.audioContext) ? this.audioContext.currentTime : 0;
          }
        }),

      /**
       * Property that gets or sets the state change handler for the underlying audio context
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/onstatechange
       */
      stateChangeHandler: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return (this.audioContext) ? this.audioContext.onstatechange : null;
          },
          set: function (handler) {
            if (this.audioContext) {
              this.audioContext.onstatechange = handler;
            }
          }
        }),

      /**
       * Property that gets the output for the underlying audio context
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/destination
       *
       * @return {Object} the AudioNode that the context will write to
       */
      destination: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return (this.audioContext) ? this.audioContext.destination : null;
          }
        }),

      /**
       * Property that gets the sample rate for the audio context being used for the object instance
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/sampleRate
       *
       * @return {Number} samples per second that audio manipulated through this object will use
       */
      sampleRate: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return (this.audioContext) ? this.audioContext.sampleRate : undefined;
          }
        }),

      /**
       * The state of the underlying audioContext
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
       *
       * @return {Number} value of this.audioContext.state
       */
      state: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return this.audioContext ? this.audioContext.state : "null";
          }
        }),

      /**
       * The output of the underlying audioContext.  This is different from the destination, which is the
       * final playback device for the underlying audio context being used for the object. For the base
       * AudioContext object, this is null.  A child class may chose to change this to something else that
       * represents audio output for the given object.
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
       *
       * @return {Number} null, this method should be overridden by a child class.
       */
      output: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return null;
          }
        }),

      /**
       * Close the AudioContext object. Releases all resources that are not referenced elsewhere to the system
       * so that other AudioContexts can be created.
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/close
       *
       * @return {Promise} that will be resolved or rejected when the Audio context is disposed of
       *
       */
      close: function () {
        if (this.audioContext) {
          if (this.audioContext !== AudioContext.audioContext) {

            var deferred = Q.defer();
            var self = this;

            this.audioContext.close()
              .then(function () {
                self.audioContext = null;
                deferred.resolve(true);
              })
              .catch(function (fault) {
                logger.debug("Exception caught on audio context close {0}", [fault]);
                deferred.reject(fault);
              });

            return deferred.promise;
          }
        }

        return Q.when(true);
      },

      /**
       * Reset the AudioContext object.  Releases all resources that are not referenced elsewhere to the system
       * and create a new audio context for use.
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/close
       *
       * @return {Promise} that will be resolved or rejected when the Audio context is closed and recreated
       *
       */
      reset: function () {

        var self = this;

        return this.close()
          .finally(function () {
            if (self.audioContext === AudioContext.audioContext) {
              self.audioContext = AudioContext.createContext();
            }
          })
          .fail(function (fault) {
            logger.error("Could not reset the AudioContext for {0}", [fault]);
            return Q.reject(fault);
          });
      },


      /**
       * Pause audio playback
       *
       * @returns a promise that will be resolved when playback is paused, or rejected if the render's audio
       * context is in a non-active state
       */
      pause: function () {
        var self = this;
        switch (this.state) {
          case AudioContext.AUDIO_CONTEXT_STATE.SUSPENDED:
            logger.debug("pause( Already paused. )");
            return Q.resolve(this.state);

          case AudioContext.AUDIO_CONTEXT_STATE.RUNNING:
            logger.debug("about to suspend audio context");

            return this.audioContext.suspend().then(function () {
              logger.debug("suspend completed. state = " + self.state);
              return self.state;
            });

          default:
            logger.error("pause( Unknown AudioContext state = {0} )", [this.audioContext.state]);
            return Q.reject(this.state);
        }
      },

      /**
       * Resume audio playback
       *
       * @returns a promise that will be resolved when playback is resumed, or rejected if the renderer's audio
       * context is in a non-active state
       */
      resume: function () {
        var self = this;
        switch (this.state) {
          case AudioContext.AUDIO_CONTEXT_STATE.SUSPENDED:
            logger.debug("about to resume audio context");

            return this.audioContext.resume().then(function () {
              logger.debug("resume completed. state = " + self.state);
              return self.state;
            });

          case AudioContext.AUDIO_CONTEXT_STATE.RUNNING:
            logger.debug("pause( Already playing (aka running). )");
            return Q.resolve(this.state);

          default:
            logger.error("pause( Unknown AudioContext state = {0} )", [this.audioContext.state]);
            return Q.reject(this.state);
        }
      }
    };
    return AudioContext;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/AudioGainContext.js":
/*!************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/AudioGainContext.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     AudioGainContext
 * @CREATED:    12/22/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Allows for decoding of AAC frames into PCM sample buffers.
 */
/* beautify preserve:start */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var AudioContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js");
    var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");

    //----------------------------------------------------------------------------------------------------------
    // CONSTRUCTOR
    //----------------------------------------------------------------------------------------------------------

    /**
     * AudioGainContext Constructor
     *
     * @param {Boolean} createContext if true, then a new audio context will be created and used, otherwise the
     *                  global audio context (created above) will be used
     */
    function AudioGainContext(createContext) {
      AudioGainContext.parent.call(this, createContext); /// Call parent constructor

      ClassUtils.bind(this, AudioGainContext);

      this.crossfadeGainNode = null;

      /**
       * Property that represents the audioNode output for the gain object.  This can be used with WAA
       * functions to connect the output of this object to something else.  This is different from
       * destination (inherited from AudioContext) in that output is the output of the AudioGainContext,
       * whereas destination represents the final destination for audio playback.
       *
       * Note this is using a lambda here to create a closure with _gainNode inside of it.  The getter will
       * then return the value captured in the closure.
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioNode
       *
       * @return {AudioNode} WAA AudioNode that represent the output of the AudioGainContext object
       */
      (function (self) {
        var createGain = self.audioContext.createGain || self.audioContext.createGainNode;
        var _gainNode = createGain.apply(self.audioContext);

        createGain = null;

        Object.defineProperty(self, "output", {
          get: function () {
            return _gainNode;
          },
          set : function (value) {
            _gainNode = value;
          }
        });
      })(this); // call the lambda, get _gainNode in a closure, create the getter
    };

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * This is a convienence member that is just set to be the same as AudioContext's AUDIO_CONTEXT_STATE.
     * This allows comparing of the state property (defined in the AudioContext prototype) with the possible
     * values from the renderers AudioContext parent class.
     *
     * @type {Object}
     */
    AudioGainContext.AUDIO_CONTEXT_STATE = AudioContext.AUDIO_CONTEXT_STATE;

    //----------------------------------------------------------------------------------------------------------
    // PROTOTYPE Inherit AudioContext's prototype and restore AACDecodeContext's constructor
    //----------------------------------------------------------------------------------------------------------

    ClassUtils.subClass(AudioGainContext, AudioContext).prototype = {

      //------------------------------------------------------------------------------------------------------
      // PROPERTIES
      //------------------------------------------------------------------------------------------------------

      /**
       * Get or set the volume for the object
       *
       * @return {Number} this.output.gain.value
       */
      volume: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return this.output.gain.value;
          },
          set: function (volume) {
            if (isNaN(volume) === false) {
              this.output.gain.value = volume;
            }
          }
        }),


      removeCrossfadeSchedule: function () {
        if (this.crossfadeGainNode) {
          this.crossfadeGainNode.gain.cancelScheduledValues(0);
          this.crossfadeGainNode.disconnect();
          this.output.disconnect();
          this.output.connect(this.destination);
        }
        this.crossfadeGainNode = null;
      },


      executeLinearRamp: function (value, endTime) {
        if (!this.crossfadeGainNode) {
          this.createGainNode(1);
        }
        this.crossfadeGainNode.gain.linearRampToValueAtTime(value, endTime);
      },


      createGainNode: function (startingValue) {
        if (!this.crossfadeGainNode) {
          var createGain = this.audioContext.createGain || this.audioContext.createGainNode;
          this.crossfadeGainNode = createGain.call(this.audioContext);

          this.crossfadeGainNode.gain.value = startingValue;

          this.output.disconnect(this.destination);

          this.output.connect(this.crossfadeGainNode);

          this.crossfadeGainNode.connect(this.destination);
        }
      },

      /**
       * Close the AudioContext object. Releases all resources that are not referenced elsewhere to the system
       * so that other AudioContexts can be created.
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/close
       *
       * @return {Promise} that will be resolved or rejected when the Audio context is disposed of
       *
       */
      close: function () {

        var self = this;

        return AudioGainContext.parent.prototype.close.call(this)
                               .then(function(result) {
                                 self.output.disconnect();
                                 self.output = null;
                                 return result;
                               });
      }
    };

    return AudioGainContext;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/decoder/AacDecoder.js":
/*!**************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/decoder/AacDecoder.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************************************************************
 * @MODULE:     AacDecoder
 * @CREATED:    12/22/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Allows for decoding of AAC frames into PCM sample buffers.
 **********************************************************************************************************************/
/* beautify preserve:start */



/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  //----------------------------------------------------------------------------------------------------------
  // CLASS members
  //----------------------------------------------------------------------------------------------------------

  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var AudioBufferContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioBufferContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioBufferContext.js");
  var AudioContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js");
  var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var AudioUtils = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
  var Q = __webpack_require__(/*! q */ "q");

  var logger = LoggerFactory.getLogger("AacDecoder", "CORE");

  //----------------------------------------------------------------------------------------------------------
  // CLASS functions
  //----------------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------------
  // CONSTRUCTOR
  //----------------------------------------------------------------------------------------------------------

  /**
   * AacDecoder Constructor
   *
   * @param {Boolean} createContext if true, then a new audio context will be created and used.  This is
   * handled by parent constructor
   */
  function AacDecoder(createContext) {

    createContext = createContext || false;

    AacDecoder.parent.call(this, createContext); /// Call parent constructor

    ClassUtils.bind(this, AacDecoder);

    logger.debug("Constructor( Creating AAC Decoder sample rate {0}. )", [this.sampleRate]);

    /**
     * Gets the last frame that was decoded
     *
     * @return {ArrayBuffer} last frame of encoded audio that was decoded
     */

    /**
     * Gets the last pcm that was decoded
     *
     * @return {ArrayBuffer} whether or not this decoder has ever decoded a frame of pcm
     */
    Object.defineProperty(this, "lastFramePCM", (function () {

      var _lastFramePCM = false;

      return {
        get: function () {
          return _lastFramePCM;
        },
        set: function (value) {
          _lastFramePCM = value;
        }
      };
    })());

    /**
     * Gets the last pcm that was decoded
     *
     * @return {ArrayBuffer} last frame of encoded audio that was decoded
     */
    Object.defineProperty(this, "lastFrameWasAACPlus", (function () {

      var _lastFrameWasAACPlus = true;

      return {
        get: function () {
          return _lastFrameWasAACPlus;
        },
        set: function (value) {
          _lastFrameWasAACPlus = value;
        }
      };
    })());

  };

  //----------------------------------------------------------------------------------------------------------
  // STATIC MEMBERS
  //----------------------------------------------------------------------------------------------------------

  AacDecoder.CONSTS = {

    /**
     * Constant that defines the minimum number of AAC frames that should be decoded at once.  The SiriusXM
     * chunk content is encoded such that any temporal dependencies between AAC frames will not cover more
     * that the number of frames represented by the constant below.  Thus, this number of frames starting at
     * the beginning of a chunk should be considered an indivisible access unit for decoding purposes in order
     * to prevent any glitches during playback from occurring.
     *
     * This does not apply to MP4 decoding, where the atomic access units are defined by the chunk offset box
     * contained within the MP4 header
     */
    AAC_ATOMIC_ACCESS_UNIT_FRAME_COUNT: 10,

    /**
     * Constant representing the amount of zero padding added to the end of an audio buffer specifically
     * for Chrome. While this 2.5 might seem arbitrary, and to some degree it is, there's a large explanation
     * below where it's used.
     */
    ZERO_PADDING: 2.5,

    /**
     * AAC-LC number of samples or bytes per frame.
     *
     * @type {Number}
     */
    AAC_LC_SAMPLES_PER_FRAME: 1024,

    /**
     * AAC-HE number of samples or bytes per frame.
     *
     * @type {Number}
     */
    AAC_HE_SAMPLES_PER_FRAME: 2048,

    /**
     * Lists the AAC types. Less than 128k bits is AAC-Plus (so chunks 32k, 64k, 96k). More than 128k bits is
     * AAC-LC (chunks 256).
     */
    TYPE: {
      AAC: "AAC-LC",
      AAC_PLUS: "AAC-HE/Plus"
    }
  };

  //----------------------------------------------------------------------------------------------------------
  // PROTOTYPE Add AudioDecodeContext prototype and restore AacDecoder constructor
  //----------------------------------------------------------------------------------------------------------

  ClassUtils.subClass(AacDecoder, AudioBufferContext).prototype = {

    /**
     * Decode a frame (or frames) of audio data.
     *
     * @param {ArrayBuffer} encodedAudio - The audio to decode.
     * @param {Number} sacrificialSamples - Number of extra samples added to the decoder to kickstart it. These
     *        should be decoded, but not played and therefore need to be removed from the channel audio data.
     * @param {Boolean} aacPlus indicates whether or not the encodedAudio is AAC-HE (true) or AAC-LC (false).
     * @param {Boolean} aacPlus indicates whether or not the encodedAudio is AAC-HE (true) or AAC-LC (false).
     * @param {Number} doubledAudioThreshold - number value above which indicates an erroneous doubling.
     * @param {Boolean} lastBuffer - true if this is the final buffer for this decoding session
     * @return Promise that gets resolved when the decoded audio data becomes available
     **/
    decode: function (encodedAudio, sacrificialSamples, aacPlus, doubledAudioThreshold, lastBuffer) {

      var self = this;
      var bytesToDecode = (encodedAudio) ? encodedAudio.byteLength : 0;

      // Default the number of samples to trim from the decoded audio data to zero.
      sacrificialSamples = sacrificialSamples || 0;

      var deferred = Q.defer();

      /**
       * Promise handler for when an audio frame is decoded
       *
       * @param {ArrayBuffer} decodedAudio is the pcm for the decoded frame
       * @return {ArrayBuffer} post processed pcm that contains just the pcm for the actual audio
       *         that was to be decoded
       **/
      function decodeSuccess(decodedAudio) {

        if (decodedAudio === null) {
          return Q.reject("Decoded audio was null");
        }

        logger.debug("decodeSuccess( Decoded {0} bytes. "
                     + "Audio Duration of {1} secs; "
                     + "Double Audio threshold {2} secs "
                     + "{3} samples, sample rate = {4} KHz; lastbuffer = {5})", [
                       bytesToDecode,
                       decodedAudio.duration,
                       doubledAudioThreshold,
                       decodedAudio.length,
                       decodedAudio.sampleRate,
                       lastBuffer
                     ]);

        // By default we expect the sample rate to be 44.1 KHZ (44100 samples), but it's possible that the user's
        // machine expects a different number, which is provided by the decoder, so we'll adjust the "samples
        // to trim" by that percentage. For most users this percentage will be 100% or 1 as their expected
        // output will default to 44.1 KHZ.
        if (decodedAudio.sampleRate !== AudioContext.CONSTS.SAMPLE_RATE_44KHZ) {
          sacrificialSamples = Math.floor((decodedAudio.sampleRate / AudioContext.CONSTS.SAMPLE_RATE_44KHZ) * sacrificialSamples);
          logger.info("decodeSuccess( Adjust samples to trim as the decoder's sample rate of {0} is different " +
            "than the default and expected sample rate of {1}. )", [
            decodedAudio.sampleRate, AudioContext.CONSTS.SAMPLE_RATE_44KHZ
          ]);
        }

        // For Firefox, on the Windows 10 Creator's update (Build 15063) we have an intermittent issue
        // where the audio duration that comes out of the decoder is double what it should be.  the following
        // constant is used to detect this situation.  If the issue occurs for the first chunk decoded in
        // a session, then the duration will be 9.752395833333333 * 2.  If it occurs on subsequent chunks the
        // duration will be 10.216791666666667 * 2 and occasionally, 9.729160997732427 * 2.
        // To match all these cases the constant should be 9.5 * 2 for non-seeded audio.

        var doubleAudioSamplesDetected = !!doubledAudioThreshold && (decodedAudio.duration >= doubledAudioThreshold);

        logger.debug("Doubled audio detected {0}", [doubleAudioSamplesDetected]);

        if (doubleAudioSamplesDetected === true && sacrificialSamples !== 0) {
          sacrificialSamples = (sacrificialSamples - AacDecoder.CONSTS.AAC_LC_SAMPLES_PER_FRAME) * 2;
        }

        // Trim any excess samples added to the decoded audio, prepare it as an audio buffer,
        // and finally copy that buffer to the output channels so it can be audible.
        var trimmedSamples = trimSamples(decodedAudio, sacrificialSamples, lastBuffer);
        var audioBuffer = createBuffer(decodedAudio, trimmedSamples.numSamplesTrimmed, doubleAudioSamplesDetected);
        var pcmAudio = copyAudioToChannel(audioBuffer, trimmedSamples.audio, doubleAudioSamplesDetected);

        logger.debug("{0} samples ready for playback {1} secs", [pcmAudio.length, pcmAudio.duration]);

        // Indicate we have decoded at least one frame of audio
        self.lastFramePCM = true;
        self.lastFrameWasAACPlus = aacPlus;

        deferred.resolve(pcmAudio);

        /**
         * Trims audio samples from either the beginning or the end or both. This is done
         * when the audio muxer creates audio data with extra samples used to kickstart
         * and ensure the correct decoding of the beginning and end of each audio data packet.
         *
         * During various browser testing it was discovered that the decoder didn't always
         * complete the audio decoding with audio that lined up with the beginning of the
         * next audio frame, so we pad the beginning of the next frame with samples from the
         * last frame to force the decoder to decode across frame boundaries. We then
         * only play or create audio output that includes one chunk, so we trim those extra
         * samples.
         *
         * In the case of Safari we needed to actually decode through the frame boundary but
         * play audio from a little before the boundary -- we found that Safari would have issues
         * and create blips between audio frame boundaries, so we actually force the trimmer
         * to remove only 1/2 of the extra frames from the beginning and the end of the frame.
         *
         * @param {ArrayBuffer} decodedAudio - The decoded audio data.
         * @param {Number} samplesToTrim - The number of samples trimmed.
         * @param {Boolean} lastBuffer = true if this is the last buffer being decoded
         * @returns {{audio: *, length: number}} An object containing the trimmed audio samples and
         * the number of samples trimmed.
         */
        function trimSamples(decodedAudio, samplesToTrim, lastBuffer) {

          var type;

          if (lastBuffer !== true) {
            type = (self.lastFramePCM === true) ? AudioUtils.CONSTS.TRIM_FROM_START_AND_END
              : AudioUtils.CONSTS.TRIM_FROM_END;
          }
          else {
            type = (self.lastFramePCM === true) ? AudioUtils.CONSTS.TRIM_FROM_START
              : AudioUtils.CONSTS.NO_TRIM;
          }

          var trimmedAudio = decodedAudio;
          var numSamplesTrimmed = 0;
          var halfSamplesToTrim = samplesToTrim / 2;
          var samplesToBeTrimmed = (type === AudioUtils.CONSTS.TRIM_FROM_END
            || type === AudioUtils.CONSTS.TRIM_FROM_START) ? halfSamplesToTrim
            : samplesToTrim;
          var logMsg = "";

          if (decodedAudio.length >= samplesToBeTrimmed) {
            // NOTE : There is still a slight glitch when switching to AAC-LC from AAC-HE.  This is due to
            // an inconsistency in the high frequency content when going from spectral band replication to
            // actual high frequency encoding.

            // NOTE: See documentation for this function above for an explantaion of the trim strategy chosen
            // here and why we are removing samples from the start and end of the audio buffer.
            //
            // THIS IS AN ISSUE WITH SAFARI DECODING! ... SAFARI clobbers the end of the audio for a decode




            // We're always passing 1/2 the samples to the trim function, but if we're doing a trim
            // on both the start and end of the audio, then we're actually trimming all of the samples
            // and not half. This is why the `numSamplesToTrim` can be different values.
            trimmedAudio = AudioUtils.trimAudioBuffer(decodedAudio, halfSamplesToTrim, type);
            numSamplesTrimmed = trimmedAudio.trimmedFromStart + trimmedAudio.trimmedFromEnd;

            logMsg = "Trimmed " + trimmedAudio.trimmedFromStart + " samples from the beginning and " +
                     trimmedAudio.trimmedFromEnd + " samples from the end ";
          }
          else {
            //in case we have decodedAudio samples less than samplesToBeTrimmed, we will not trim any samples from the audio
            type = AudioUtils.CONSTS.NO_TRIM;
            trimmedAudio = AudioUtils.trimAudioBuffer(decodedAudio, samplesToBeTrimmed, type);
          }

          logger.debug("trimSamples( {0} )", [logMsg]);

          return {
            audio: trimmedAudio.audio,
            numSamplesTrimmed: (type === AudioUtils.CONSTS.NO_TRIM) ? 0 : numSamplesTrimmed
          };
        }

        /**
         * Creates an audio buffer by making sure it matches the trimmed audio -- the key here
         * is the number of samples that are expected to play after trimming or not trimming.
         *
         * @param {ArrayBuffer} decodedAudio - The decoded audio data.
         * @param {Number} samplesTrimmed - The number of samples trimmed.
         * @param {Boolean} cutInHalf - if false, a full size buffer is returned, otherwise half size
         * @returns {*|AudioBuffer} - The audio buffer.
         */
        function createBuffer(decodedAudio, samplesTrimmed, cutInHalf) {

          var numberOfChannels = decodedAudio.numberOfChannels;
          var numberOfSamples = decodedAudio.length - samplesTrimmed;
          var sampleRate = decodedAudio.sampleRate;
          return self.createBuffer(numberOfChannels, (cutInHalf) ? numberOfSamples / 2 : numberOfSamples, sampleRate);
        }

        /**
         * Prepares the audio data as output for the channels.
         *
         * The key here is that some browser don't natively support AudioBuffer.copyToChannel(),
         * like Safari, so we need to check and possibly shim it. The native version is obviously
         * faster than the manual process.
         *
         * @param {AudioBuffer} audioBuffer - The audio buffer to output to the audio channels.
         * @param {ArrayBuffer} audioData - The audio data that's being copied to the channels for audible
         *   playback.
         * @param {Boolean} everyOtherSample tells the copy operation to copy every other sample from
         *   audioData
         * @returns {AudioBuffer}
         */
        function copyAudioToChannel(audioBuffer, audioData, everyOtherSample) {
          if (audioBuffer !== null) {
            var rightChannelIndex = audioData.length === 1 ? 0 : 1;
            var leftChannelData = audioBuffer.getChannelData(0);
            var rightChannelData = audioBuffer.getChannelData(rightChannelIndex);
            var audioBufferLen = audioBuffer.length;

            var increment = (everyOtherSample) ? 2 : 1;

            for (var i = 0; i < audioBufferLen * increment; i = i + increment) {
              leftChannelData[i / increment] = audioData[0][i];
              rightChannelData[i / increment] = audioData[rightChannelIndex][i];
            }
          }
          return audioBuffer;
        }
      }

      /**
       * Promise rejection handler for when an audio frame decode fails.  Log the error and the frame
       * data that could not be decoded
       *
       * @param {Object} fault is the reason why the decode failed.
       * @return {Promise} rejected promise with the fault code
       **/
      function onFailure(fault) {
        var msg = (fault instanceof Error) ? (fault.message + fault.stack) : "";
        logger.error("frameRejected( Could not decode frame due to: {0} )", [msg]);

        deferred.reject(fault);
      }

      /**
       * Function to actually decode audio.
       *
       * @param {ArrayBuffer} bufferToDecode - Contains the audio to decode.
       * @param {Boolean} aacPlus - Is true of bufferToDecode is AAC-HE and false if AAC-LC.
       *
       * @return {Promise} that will be resolved or rejected if the audio decodes or fails to decode
       **/
      function decodeAudio(bufferToDecode, aacPlus) {
        
        var bytesToDecode = (!bufferToDecode) ? 0 : bufferToDecode.byteLength;

        var accType = aacPlus ? AacDecoder.CONSTS.TYPE.AAC_PLUS : AacDecoder.CONSTS.TYPE.AAC;
        logger.debug("decodeAudio( Decoding AAC Type `{0}` with {1} bytes. )", [
          accType, bytesToDecode
        ]);

        self.audioContext.decodeAudioData(bufferToDecode, decodeSuccess, onFailure);
      }

      /* An explanation of what is going on here.
       *
       *   Issue #1
       *
       *   WAA audio decode (On chrome at least) appears to corrupt the first hundred samples of decoded
       * audio.  This shows up as very small floating point values at the start of the decoded pcm.  For
       * the first buffer that plays out, this is not audible, but for the subsequent buffers that come
       * out we have audible glitches that prevent seamless playback.
       *
       *   To address this, we keep the previous frame that was decoded around (lastFrame) and append the
       * current frame to be decoded to it.  Then (in decodeSuccess), we remove the pcm samples that would have
       * come from the previous frame and only keep the samples from the actual frame we wanted to decode.
       * One way of thinking about this is that lastFrame is a "sacrificial" frame that can get corrupted
       * so that encodedAudio does *not* get corrupted.
       *
       *   It is very possible that this is a function of the frequency domain processing that occurs in
       * the audio decoding algorithms for AAC-HE.  The issue does not seem to effect AAC-LC.
       *
       *   Issue #2
       *
       *   For ADTS, the FFMPEG decoder (used in chrome, perhaps in safari, edge, others) uses the size
       * of the audio frame, along with the bitrate reported in the ADTS header to determine how many
       * samples are expected to come out of encodedAudio.  It then pre-allocates space for the decoded
       * audio.  If this guess is wrong (and often is), then the decoded audio will be truncated.
       *
       *   To avoid this, padding is added to the end of the audio to be decoded to double the perceived
       * size of the audio. This forces FFMPEG to allocate more space than necessary to hold all the samples
       * from the encoded audio.  Once FFMPEG decodes the audio, it will reduce the size of the samples
       * to the actual number of samples decoded, removing the extra space.
       *
       *   The padding is all zeros, which an AAC decoder will ignore at the end of an ADTS frame.  This
       * means that if the truncation issue is fixed in future browsers, this technique will do no harm
       * other than that caused by the extra memory for the padding.
       *
       *   This particular issue was determined by debugging a Chrome process on Windows using
       * Visual Studio.  The Chromium codebase was cloned and used to step through the decode process
       * to observe the decoded audio getting truncated.  This truncation appears to occur on Chrome
       * under Windows and OSX with the usage of the FFMPEG library.
       */

      var encodedProcessedAudio = null;

      if (encodedAudio !== null) {

        if (this.lastFramePCM && (aacPlus !== this.lastFrameWasAACPlus)) {
          logger.info("decode( Decode type switch detected. Last frame AAC-Plus = {0}, current frame AAC-Plus =  {1}", [
            this.lastFrameWasAACPlus, aacPlus
          ]);
          this.lastFramePCM = false;
        }

        // NOTE: See above for an explanation on the ZERO_PADDING value.
        var paddingBytes = encodedAudio.byteLength * AacDecoder.CONSTS.ZERO_PADDING;
        encodedProcessedAudio = AudioUtils.concatArrayBuffers([encodedAudio], paddingBytes);

        logger.debug("Processed audio byte length {0} bytes", [encodedProcessedAudio.byteLength]);
      }

      logger.debug("Raw audio for decode = {0} bytes last frame was {1} bytes)",
        [bytesToDecode, (this.lastFrame) ? this.lastFrame.byteLength : 0]);

      decodeAudio(encodedProcessedAudio, aacPlus);
      
      return deferred.promise;

      /* jshint ignore:line */
    },

    /**
     * Clear out state than call parent close
     *
     * @returns {Promise} that will be resolved when close is completed
     */
    close: function () {

      this.lastFramePCM = false;

      return AudioBufferContext.prototype.close.apply(this);
    }
  };

  return AacDecoder;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/muxer/AdtsMuxer.js":
/*!***********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/muxer/AdtsMuxer.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/07/16
 * @COPYRIGHT:  2016 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Muxes an ADTS container by either letting the existing one pass through or optionally padding
 *      it with additional AAC data for the decoder.
 *
 *      NOTE: No transcoding is done and we're still using the same raw AAC audio data from the ADTS container
 *      in the MP4 container if we do end up muxing.
 *
 *        - Optional: Pads the beginning of the audio data with some audio data from the last chunk to
 *        kickstart the decoder; this data will be decoded but not played through the output channels.
 *
 *        -- High-Level Overview of how the padding of audio samples works
 *
 *        1) Muxing
 *        * Don't add or remove any samples from C0 and simply allow it to pass through the muxing phase as is.
 *        * Save {x} number of samples from the end of Cn in an array as we mux each chunk.
 *        * Prepend the saved samples from C(n-1) to the beginning of Cn. This means there's an overlap of audio
 *        samples at the end of C(n-1) and the beginning of Cn for every chunk after C0.
 *
 *        2) Decoding
 *        * Always decode all of the audio data in each chunk which may include overlap samples from the previous
 *        chunk. This is done to eliminate audible blips that tend to occur when decoding happens precisely on chunk
 *        boundaries. Here we decode through chunk boundaries due to the samples overlap.
 *
 *        3) Outputting to Channel
 *        * Given the audio samples overlap between chunks, trim the output audio from the beginning and end to create
 *        seamless audio where applicable.
 *        * For C0, trim the audio output of {x}/2 samples from the end.
 *        * After C0, trim the audio output of {x}/2 samples from the beginning and the end.
 *
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var AudioUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
  var AdtsFrame = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");
  var Mp4Builder = __webpack_require__(/*! sxm/audioplayer/html5/protocols/mp4/Mp4Builder */ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/Mp4Builder.js");
  var MuxerResult = __webpack_require__(/*! sxm/audioplayer/html5/audio/muxer/MuxerResult */ "./javascript/src/sxm/audioplayer/html5/audio/muxer/MuxerResult.js");

  /**
   * @constructor
   */
  var AdtsMuxer = function (kickStartFrames) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof AdtsMuxer)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["AdtsMuxer"]);
    }
    this._kickStartFrames = kickStartFrames;

    this._framesToPrepend = {
      numFrames: 0,
      // eslint-disable-next-line no-undef
      arrayBuffer: new ArrayBuffer()
    };
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * File name used when saving the MP4 to the client.
   * @type {String}
   */
  AdtsMuxer.SAVE_FILE_NAME = "sxm-adts-aac.aac";

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our ABRMonitor class, we could write:
   *
   *  `BankManager.prototype = ABRMonitor.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  AdtsMuxer.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: AdtsMuxer,

    /**
     * Converts ADTS files with AAC frames in it to and MP4 container with AAC audio.
     *
     * Using the MediaBuffer's raw byte array as the data source, loop through all the ADTS frames,
     * extract the AAC data, and concatenate it into one byte array. This essentially means we're stripping
     * out the ADTS headers from the data and just want the raw AAC audio.
     *
     * @param {MediaBuffer} mediaBuffer - Contains byte array with the ADTS frames.
     * @param {Boolean} isAACPlus - Flag indicating if AAC is Low Complexity (LC, greater than 128k) or High
     * Complexity (HC, lower than 128k).
     * @param {Number} offset - milliseconds in the mediaBuffer to skip after decoding
     * with to kickstart the decoder.
     */

    mux: function (mediaBuffer, isAACPlus) {

      /**
       * Number of kickstarter AAC bytes added to the beginning of the AAC audio data.
       * @type {Number}
       */


      /**
       * Number of frames in audio before prepending.
       */
      var numFrames = 0;

      var indexesOfSyncWords = [];

      var i = 0;
      var frame;

      while ((frame = AdtsFrame.findNextFrame(mediaBuffer, i)) !== -1) {
        numFrames += 1;
        i = frame.index + frame.length;
        indexesOfSyncWords.push(frame.index);
      }

      var aacFrames = mediaBuffer.arrayBuffer.slice(indexesOfSyncWords[0]);
      var sacrificialSamples = 0;

      if (this._framesToPrepend.numFrames === 0) {
        sacrificialSamples = numFrames * (isAACPlus ? Mp4Builder.AAC_HE_SAMPLES_PER_FRAME
          : Mp4Builder.AAC_LC_SAMPLES_PER_FRAME);
      }
      else {
        sacrificialSamples = this._framesToPrepend.numFrames * (isAACPlus ? Mp4Builder.AAC_HE_SAMPLES_PER_FRAME
          : Mp4Builder.AAC_LC_SAMPLES_PER_FRAME);
      }

      var arrayBufferAfterPrepend = AudioUtil.concatArrayBuffers([this._framesToPrepend.arrayBuffer, aacFrames]);

      var muxerResult = new MuxerResult(
        arrayBufferAfterPrepend,
        isAACPlus,
        numFrames + this._framesToPrepend.numFrames,
        0,
        arrayBufferAfterPrepend.byteLength,
        sacrificialSamples,
        AdtsMuxer.SAVE_FILE_NAME
      );

      
      if(this._kickStartFrames > 0)
      {
        this._framesToPrepend = {numFrames: numFrames, arrayBuffer: aacFrames};
      }
      
      return muxerResult;
    }
  };

  return AdtsMuxer;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/muxer/AudioMuxer.js":
/*!************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/muxer/AudioMuxer.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    10/12/16
 * @COPYRIGHT:  2016 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Prepares the audio data as ADTS AAC or MP4 AAC based on the browser. The expected incoming
 *      audio data container is ADTS, so if the current browser only supports MP4 then the container
 *      is muxed from ADTS to MP4.
 *
 *      Acts as a proxy and factory that creates and maintains a reference to the underlying Muxing
 *      implementation; once the muxer has been created it's saved as a static property and reused
 *      so the internal muxer instance can save properties (like previous audio data) from one
 *      mux to the next.
 *
 *      Currently the MP4 container is only created for Firefox.
 */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
    var BitUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/BitUtil */ "./javascript/src/sxm/audioplayer/html5/util/BitUtil.js");
    var BrowserUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/BrowserUtil */ "./javascript/src/sxm/audioplayer/html5/util/BrowserUtil.js");
    var Mp4Muxer = __webpack_require__(/*! sxm/audioplayer/html5/audio/muxer/Mp4Muxer */ "./javascript/src/sxm/audioplayer/html5/audio/muxer/Mp4Muxer.js");
    var AdtsMuxer = __webpack_require__(/*! sxm/audioplayer/html5/audio/muxer/AdtsMuxer */ "./javascript/src/sxm/audioplayer/html5/audio/muxer/AdtsMuxer.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");

    /**
     * Internal reference to the logger.
     * @type {WebAudioPlayerLogger|*}
     */
    var logger = LoggerFactory.getLogger("AudioMuxer", "CORE");

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the AudioMuxer function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @constructor
     */
    function AudioMuxer() {
      // This first guard ensures that the callee has invoked our Class' constructor function
      // with the `new` keyword - failure to do this will result in the `this` keyword referring
      // to the callee's scope (typically the window global) which will result in the following fields
      // (name and _age) leaking into the global namespace and not being set on this object.
      if (!(this instanceof AudioMuxer)) {
        throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["AudioMuxer"]);
      }

      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------

      /**
       * Reference to the Playback instance being monitored.
       * @type {Playback}
       * @private
       */
      this._muxer = null;

      /**
       * Flag indicating if AAC is Low Complexity (LC, greater than 128k) or High Complexity (HC, lower than 128k).
       * @type {Boolean}
       */
      this.isAacPlus = true;
    };

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Number of AAC frames to use as the kickstarter for the decoder.
     * @const
     * @type {Number}
     */
    AudioMuxer.KICK_START_NUM_FRAMES = 30;

    /**
     * Flag indicating if the generated audio file should be saved. This is mainly for
     * development purposes.
     * @type {Boolean}
     */
    AudioMuxer.SAVE_FILE = false;

    /**
     * Max number of files to download.
     * @type {Number}
     */
    AudioMuxer.SAVE_FILE_COUNT_MAX = 2;

    /**
     * Number of files downloaded, which must be less than the max.
     * @type {Number}
     */
    AudioMuxer.SAVE_FILE_COUNT = 0;

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our AudioMuxer class, we could write:
     *
     *  `BankManager.prototype = AudioMuxer.prototype`
     *  `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    AudioMuxer.prototype = {

      /**
       * Whenever you replace an Object's Prototype, you need to repoint
       * the base Constructor back at the original constructor Function,
       * otherwise `instanceof` calls will fail.
       */
      constructor: AudioMuxer,

      /**
       * Disables the addition of sacrificial frames to audio data.
       */
      disableSacrificialFrames: function () {
        AudioMuxer.KICK_START_NUM_FRAMES = 0;
      },

      /**
       * Makes the Muxer implementation a singleton that's only created once and then saved as a
       * static property. This returns a reference to that Muxer impl.
       *
       * @param {Boolean} reset - Flag indicating if the underlying muxer should be reset. This is
       * especially important when changing channels or seeking as some of the muxers hold onto
       * audio data from the last ADTS frame, so if we don't create a new muxer we'll play audio
       * from wrong source.
       * @kickStartFrames {Number} = number of frames that need to be dropped
       * @return {Muxer}
       */
      getMuxer: function (reset, kickStartFrames) {
        reset = !ObjectUtil.isBoolean(reset) ? false : reset;

        // Create the muxer if it doesn't exist or it needs to be reset.
        if (!this._muxer || reset) {
          this._muxer = (BrowserUtil.isFirefox() || BrowserUtil.isEdge()) ? new Mp4Muxer(kickStartFrames) : new AdtsMuxer(kickStartFrames);
        }
        return this._muxer;
      },

      /**
       * Prepares the audio data as ADTS AAC or MP4 AAC based on the browser by muxing the container.
       * Technically if the container is ADTS and is playable on the current browser, then it leaves
       * the ADTS as is; however, on Firefox ADTS is not natively supported so we mux the audio container
       * from ADTS to MP4 (which it can natively play).
       *
       * NOTE: No transcoding is done and we're still using the same raw AAC audio data from the ADTS container
       * in the MP4 container if we do end up muxing.
       *
       * @param {MediaBuffer} mediaBuffer - Contains byte array with the ADTS frames.
       * This is used to tell the decoder where to start.
       * @param {Boolean} isAacPlus - Flag indicating if AAC is Low Complexity (LC, greater than 128k) or High
       * Complexity (HC, lower than 128k).
       * @param {boolean} isMP4 - flag indicating if audio is seeded audio.
       * @param {Boolean} reset - Flag indicating if the underlying muxer should be reset. This is
       * especially important when changing channels or seeking as some of the muxers hold onto
       * audio data from the last ADTS frame, so if we don't create a new muxer we'll play audio
       * from wrong source.
       * @param {Number} offset is the offset in ms we want to start playing
       * @return {Object} Contains the byte array data in the media buffer in the required container. Currently
       * this is either ADTS or MP4. Also contains the start and end byte indexes for the container.
       */
      // eslint-disable-next-line no-unused-vars
      mux: function (mediaBuffer, isAacPlus, isMP4, reset, offset) {
        var msg = !this._muxer ? "null muxer." : "a channel change or seek.";

        // Need to create a new muxer if we're switching to/from AAC-HE and AAC-LC.
        if (this.isAacPlus !== isAacPlus) {
          msg = "a decoder switch to/from AAC-HE and AAC-LC.";
          this.isAacPlus = isAacPlus;
          reset = true;
        }

        if (reset) {
          logger.info("mux( Creating a new muxer due to {0} )", [msg]);
        }

        /**
         * The result of the muxed audio data.
         * @type {*}
         */
        var muxedAudioData = this.getMuxer(reset, AudioMuxer.KICK_START_NUM_FRAMES).mux(mediaBuffer, isAacPlus, offset);

        // NOTE: This is primarily here as a debugging resource. It generates a savable MP4 file to the dev's
        // machine based on the MP4 array buffer created above.
        if (AudioMuxer.SAVE_FILE && (AudioMuxer.SAVE_FILE_COUNT < AudioMuxer.SAVE_FILE_COUNT_MAX)) {
          AudioMuxer.SAVE_FILE_COUNT++;

          // NOTE: This only works in Chrome.
          BitUtil.saveByteArrayToFile([muxedAudioData.arrayBuffer], muxedAudioData.fileName);
        }

        return muxedAudioData;
      }

    };

    return AudioMuxer;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/muxer/Mp4Muxer.js":
/*!**********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/muxer/Mp4Muxer.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/07/16
 * @COPYRIGHT:  2016 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Muxes an ADTS container with AAC audio data to a MP4 container with AAC.
 *
 *      NOTE: No transcoding is done and we're still using the same raw AAC audio data from the ADTS container
 *      in the MP4 container if we do end up muxing.
 *
 *        - Loop over all ADTS frames grabbing the raw AAC data and concatenating it into one byte array.
 *        - Save the frame counter and AAC bytes per frame as input data to create the MP4 container.
 *        - Use the MP4 builder to create the container and return the updated byte array and new
 *        start and end bytes for the data.
 *        - Optional: Pads the beginning of the audio data with some audio data from the last chunk to
 *        kickstart the decoder; this data will be decoded but not played through the output channels.
 *
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var AudioUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
  var AdtsFrame = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");
  var Mp4Builder = __webpack_require__(/*! sxm/audioplayer/html5/protocols/mp4/Mp4Builder */ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/Mp4Builder.js");
  var MuxerResult = __webpack_require__(/*! sxm/audioplayer/html5/audio/muxer/MuxerResult */ "./javascript/src/sxm/audioplayer/html5/audio/muxer/MuxerResult.js");


  /**
   * @constructor
   */
  function Mp4Muxer() {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof Mp4Muxer)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["Mp4Muxer"]);
    }

    this._framesToPrepend = {
      numFrames: 0,
      frameLengths: [],
      frames: undefined
    };
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * File name used when saving the MP4 to the client.
   * @type {String}
   */
  Mp4Muxer.SAVE_FILE_NAME = "sxm-mp4-aac.mp4";

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our ABRMonitor class, we could write:
   *
   *  `BankManager.prototype = ABRMonitor.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  Mp4Muxer.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: Mp4Muxer,

    /**
     * Converts ADTS files with AAC frames in it to and MP4 container with AAC audio.
     *
     * Using the MediaBuffer's raw byte array as the data source, loop through all the ADTS frames,
     * extract the AAC data, and concatenate it into one byte array. This essentially means we're stripping
     * out the ADTS headers from the data and just want the raw AAC audio.
     *
     * @param {MediaBuffer} mediaBuffer - Contains byte array with the ADTS frames.
     * @param {Boolean} isAACPlus - Flag indicating if AAC is Low Complexity (LC, greater than 128k) or High
     * Complexity (HC, lower than 128k).
     * @param {Number} offset is the number of ms of audio we wish to skip before playing mediaBuffer
     * with to kickstart the decoder.
     */
    mux: function (mediaBuffer, isAACPlus) {

      /**
       * List of each AAC frame data's byte length. This is used when constructing an MP4, as the `stsz` box
       * needs to know the byte length of size of each frame (aka sample).
       * @type {Array}
       */
      var aacBytesLengthPerFrame = (this._framesToPrepend.numFrames > 0) ? this._framesToPrepend.frameLengths : [];
      var rawAACFrames = [];
      var numFrames = 0;
      var i = 0;
      var frame;

      while ((frame = AdtsFrame.findNextFrame(mediaBuffer, i)) !== -1) {
        numFrames += 1;
        i = frame.index + frame.length;
        aacBytesLengthPerFrame.push(frame.payloadLength);
        rawAACFrames.push(mediaBuffer.arrayBuffer.slice(frame.payloadIndex, i));
      }

      var sacrificialSamples = 0;
      var sacrificialFrames = 0;

      if (this._framesToPrepend.numFrames === 0) {
        sacrificialSamples = numFrames * (isAACPlus ? Mp4Builder.AAC_HE_SAMPLES_PER_FRAME
          : Mp4Builder.AAC_LC_SAMPLES_PER_FRAME);
      }
      else {
        sacrificialSamples = this._framesToPrepend.numFrames * (isAACPlus ? Mp4Builder.AAC_HE_SAMPLES_PER_FRAME
          : Mp4Builder.AAC_LC_SAMPLES_PER_FRAME);
        sacrificialFrames = this._framesToPrepend.numFrames;
      }

      var aacFrames = AudioUtil.concatArrayBuffers(rawAACFrames);
      var arrayBufferAfterPrepend = (this._framesToPrepend.numFrames > 0)
        ? AudioUtil.concatArrayBuffers([this._framesToPrepend.frames, aacFrames])
        : aacFrames;

      // Populate the MP4 box tree template with requested audio data and then create the MP4 container with it.
      var mp4BoxTree = Mp4Builder.createBoxTreeTemplate(arrayBufferAfterPrepend,
        numFrames + this._framesToPrepend.numFrames,
        aacBytesLengthPerFrame,
        isAACPlus);
      var mp4 = Mp4Builder.build(mp4BoxTree, isAACPlus).source;
      var muxerResult = new MuxerResult(mp4.buffer,
        isAACPlus,
        numFrames + this._framesToPrepend.numFrames,
        0,
        mp4.buffer.byteLength,
        sacrificialSamples,
        Mp4Muxer.SAVE_FILE_NAME);

      this._framesToPrepend = {
        numFrames: numFrames,
        frames: aacFrames,
        frameLengths: aacBytesLengthPerFrame.slice(sacrificialFrames)
      };

      return muxerResult;
    }

  };

  return Mp4Muxer;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/muxer/MuxerResult.js":
/*!*************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/muxer/MuxerResult.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Data model representing a chunk. Contains the URL, raw data, timestamp, and offset.
 */


/**
 * Register the module with RequireJS.
 * @module sxm/audioplayer/html5/model/MuxerResult
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var AudioUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
  var AacDecoder = __webpack_require__(/*! sxm/audioplayer/html5/audio/decoder/AacDecoder */ "./javascript/src/sxm/audioplayer/html5/audio/decoder/AacDecoder.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the MuxerResult function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {ArrayBuffer} arrayBuffer - The raw byte array of muxed data.
   * @param {boolean} isAACPlus - true if the audio is AAC-HE (AAC+)
   * @param {number} numFrames - number of audio frames in the arrayBuffer
   * @param {Array} startByteIndex - The index in the byte array to start decoding.
   * @param {Number} endByteIndex - The index in the byte array to start decoding.
   * @param {Number} sacrificialSamples - The number of samples used to pad the beginning
   * of the audio byte array.
   * @param {Number} trimStrategy - The trim direction strategy used to remove the padded samples on the
   * audio byte array.
   * @param {String} fileName - The file name of the byte array used when saving.
   */
  function MuxerResult(arrayBuffer,
                       isAACPlus,
                       numFrames,
                       startByteIndex,
                       endByteIndex,
                       sacrificialSamples,
                       fileName) {

    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof MuxerResult)) {
      throw new TypeError("MuxerResult constructor cannot be called as a function.");
    }

    // NOTE: Keep commented out as it'll log too much...use only for debugging.
    // logger.debug("Constructor()");

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * The raw byte array of muxed data.
     * @type {ArrayBuffer}
     */
    // eslint-disable-next-line no-undef
    this.arrayBuffer = arrayBuffer || new ArrayBuffer();

    /**
     * Indicates whether the audio data is AAC+ (true) or not (false)
     * @type {boolean}
     */
    this.isAACPlus = isAACPlus;

    /**
     * The index in the byte array to start decoding.
     * @type {Number}
     */
    this.startByteIndex = startByteIndex || 0;

    /**
     * The index in the byte array to start decoding.
     * @type {Number}
     */
    this.endByteIndex = endByteIndex || 0;

    /**
     * The number of samples used to pad the beginning of the audio byte array.
     * @type {Number}
     */
    this.sacrificialSamples = sacrificialSamples || 0;

    var decodedFrameSamples = (isAACPlus) ? AacDecoder.CONSTS.AAC_HE_SAMPLES_PER_FRAME
      : AacDecoder.CONSTS.AAC_LC_SAMPLES_PER_FRAME;
    var frameDuration = decodedFrameSamples / AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_44KHZ;
    var sacrificialFrames = this.sacrificialSamples / decodedFrameSamples;

    /**
     * The duration (in seconds) for the audio contained in arrayBuffer after sacrificial samples are removed
     * @type {Number}
     */
    this.playDuration = (numFrames > sacrificialFrames) ? (numFrames - sacrificialFrames) * frameDuration
      : numFrames * frameDuration;

    /**
     * The duration (in seconds) for the audio contained in arrayBuffer;.
     * @type {Number}
     */
    this.duration = numFrames * frameDuration;

    /**
     * The file name of the byte array used when saving.
     * @type {String}
     */
    this.fileName = fileName || "";
  }

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our MuxerResult class, we could write:
   *
   *  `BankManager.prototype = MuxerResult.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  MuxerResult.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: MuxerResult
  };

  return MuxerResult;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderBuffer.js":
/*!********************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderBuffer.js ***!
  \********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/03/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * AudiorenderBuffer object that can be used for audio playback.
 */
/* beautify preserve:start */

/**
 * Register the module with RequireJS.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var ClassUtils         = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var AudioBufferContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioBufferContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioBufferContext.js");
  var AudioUtils         = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
  var Q                  = __webpack_require__(/*! q */ "q");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the AudioRenderBuffer function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {AudioContext| outputContext is the object the buffer should output to
   * @param {AudioSamples} audioSamples contains the pcm samples to render
   * @param {Number} startCopy is the sample index in audioSamples to start the new render buffer with
   * @param {Number} endCopy is the sample index (non inclusive) to end the new render buffer with
   * @param {Number} startTime in seconds that audio should start playing
   * @param {Number} timestamp is the unix epoch timestamp for the render buffer
   * @return {AudioRenderBuffer} interface for rending audio
   */

  /* beautify preserve:start */
  function AudioRenderBuffer(outputContext,audioSamples,startCopy,endCopy,startTime,timestampAttr) {
    AudioRenderBuffer.parent.call(this); /// Call parent constructor

    var self = this;

    ClassUtils.bind(this,AudioRenderBuffer);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * AudioContext that the buffer will play on
     * @type {AudioContext}
     */
    this.outputContext = outputContext;

    /**
     * StartTime (seconds) when pcm data needs to be rendered
     * @type {Number}
     */
    this.startTime = startTime;

    this.timestampAttr = timestampAttr;

    /**
     * Audio duration (milliseconds) of the pcm samples in the render buffer
     * @type {Number}
     */
    this.duration = AudioUtils.calculateDurationInMs(endCopy - startCopy,audioSamples.sampleRate);

    /**
     * Timestamp (milliseconds) playback timestamp of the pcm
     * @type {Number}
     */
    this.timestamp = AudioUtils.adjustTimestampPrecision(this.timestampAttr,this.duration);

    /**
     * A property that represent a promise that will be resolved when the buffer finishes playing.
     * reading the property gets the promise, writing the property resolves the promise with the
     * value specified
     */
    ClassUtils.createPromiseProperty(this,"onPlayed",true);

    Object.defineProperty(this, "renderState", createRenderStateProperty(this));

    /**
     * An array of callbacks to be called when the AudioRenderBuffer finishes playing
     * @type {Array}
     */
    this.onBufferPlayedEventHandlers = [];

    /**
     * Reference to the HTML5 audio source object that will manage pcm data for playback.  Get populated from
     * a function that is immediately executed so we can perform the following steps.
     *
     *    1) A source AudioBufferSourceNode is created using audioContext.createBufferSource()
     *    2) pcmBuffer is attached to the source's buffer member
     *    2) A private function is attached to the source's onended member
     *       a) When the function is called, it will will set the object state to FINISHED
     *       b) If _self.onBufferPlayed has been populated with a callback, that callback will be called
     *       c) Callbacks will be deregistered so they are only called once.
     *
     * @param {Object} self is the this pointer for the AudioRenderBuffer object
     */
    this.source = this.createBufferSource();

    var pcmBuffer = this.createBuffer(audioSamples.channels,
      endCopy - startCopy,
      audioSamples.sampleRate
    );

    audioSamples.samples.forEach(function(pcm,channel) {
      pcmBuffer.getChannelData(channel).set(pcm.subarray(startCopy, endCopy), 0);
    });

    this.source.buffer = pcmBuffer;

    this.source.connect(outputContext.output);

    this.source.onended = function() {
      self.renderState = AudioRenderBuffer.STATE.FINISHED;
      self.source.onended = null;
    };
  }

  /**
   * Create the property descriptor for the render state, including backing store that is used to actually
   * stop the state (_renderState)
   *
   * @param self is the this reference for the AudioRenderBuffer for which this state property applies.
   */
  function createRenderStateProperty(self) {
    var _renderState = AudioRenderBuffer.STATE.STOPPED;

    return {
      get: function() {
        return _renderState;
      },

      set: function(state) {

        if (_renderState === state) {
          return;
          /* idempotent; */
        }

        _renderState = state;

        switch (_renderState) {
          case AudioRenderBuffer.STATE.STOPPED:
          case AudioRenderBuffer.STATE.FINISHED:

            while (self.onBufferPlayedEventHandlers.length > 0) {
              var handler = self.onBufferPlayedEventHandlers[0];

              handler(self);

              self.deregisterNotificationHandler(handler);
            }

            self.source.stop();
            self.source.disconnect();
            delete self.source.buffer; //Edge not supporting the re-assigning the buffer to null, so deleting that buffer from the source itself
            self.onPlayed       = self; // resolve the onPlayed promise property with self
            break;

          case AudioRenderBuffer.STATE.STARTED:
            self.source.start(self.startTime);
            break;

          case AudioRenderBuffer.STATE.STOPPING:
            self.source.stop();
            break;
        }
      }
    };
  }

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Hash of enumerated values describing the state of the renderer.
     * @type {string}
     */
    AudioRenderBuffer.STATE = {
      STOPPING: "stopping",
      STOPPED: "stopped",
      STARTED: "started",
      FINISHED: "finished"
    };

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a new class which extended our AudioRenderBuffer class, we could write:
     *
     *  `NewClass.prototype = AudioRenderBuffer.prototype`
     *  `NewClass.prototype.constructor = NewClass`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    ClassUtils.subClass(AudioRenderBuffer, AudioBufferContext).prototype = {

      //-----------------------------------------------------------------------
      // PUBLIC API
      //-----------------------------------------------------------------------

      /**
       * Register a function that will be called when the render buffer has played out
       *
       * @param {Function} handler to be called when the render buffer has finished playing
       */
      registerNotificationHandler: function (handler) {
        this.onBufferPlayedEventHandlers.push(handler);
      },

      /**
       * Deregister a function that was previously registered for callback when the render buffer has played
       * out.
       *
       * @param {Function} handler to be removed from the list of handlers that get notiified when the buffer
       * plays out.
       */
      deregisterNotificationHandler: function (handler) {
        var index = this.onBufferPlayedEventHandlers.indexOf(handler);
        if (index > -1) {
          this.onBufferPlayedEventHandlers.splice(index, 1);
        }
      },


      /**
       * Start the AudioRenderBuffer.  Audio will only start playing once the startime passes
       *
       * @returns {Boolean} promise that will be resolved when buffer plays completely
       */
      start: function () {
        try {
          switch (this.renderState) {
            case AudioRenderBuffer.STATE.STOPPED:
              this.renderState = AudioRenderBuffer.STATE.STARTED;
              break;

            case AudioRenderBuffer.STATE.STARTED:
              this.renderState = AudioRenderBuffer.STATE.STARTED;
              break;

            case AudioRenderBuffer.STATE.FINISHED:
              return Q.reject("Cannot restart a finished render buffer");

            default:
              return Q.reject("Invalid state " + this.renderState + "detected in start");
          }
        }
        catch (e) {
          return Q.reject("Start FAILED " + e.toString());
        }

        return this.onPlayed;
      },

      /**
       * Stop the AudioRenderBuffer.  If audio is actually being rendered, then it will stop, otherwise the
       * audio will not be started when its startTime comes due
       *
       * @returns {Promise} promise that will be solved when the render buffer has stopped, or rejected if the
       *          render buffer cannot be stopped
       */
      stop: function () {
        var dfd = Q.defer();

        try {
          switch (this.renderState) {
            case AudioRenderBuffer.STATE.STOPPED:
            case AudioRenderBuffer.STATE.FINISHED:
              dfd.resolve(this);
              break;

            case AudioRenderBuffer.STATE.STARTED:
              var self = this;

              this.source.onended = function () {
                self.renderState = AudioRenderBuffer.STATE.STOPPED;
                self.onPlayed = self;
                self.source.onended = null;
                dfd.resolve(self);
              };

              this.renderState = AudioRenderBuffer.STATE.STOPPING;

              break;

            default:
              dfd.reject("Invalid state " + this.renderState + "detected in stop");
          }
        }
        catch (e) {
          dfd.reject("Stop FAILED " + e.toString());
        }

        return dfd.promise;
      }
    };

    return AudioRenderBuffer;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderer.js":
/*!****************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderer.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Created by Charles Christine on 8/31/2015.
 *
 * RequireJS module that allows for rendering of PCM sample buffers to an audio output
 */
/* beautify preserve:start */

/**
 * Register the module with RequireJS.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var AudioGainContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioGainContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioGainContext.js");
    var AudioRenderBuffer = __webpack_require__(/*! sxm/audioplayer/html5/audio/render/AudioRenderBuffer */ "./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderBuffer.js");
    var AudioSamples = __webpack_require__(/*! sxm/audioplayer/html5/model/AudioSamples */ "./javascript/src/sxm/audioplayer/html5/model/AudioSamples.js");
    var CrossfadeProtocol = __webpack_require__(/*! sxm/audioplayer/html5/model/CrossfadeProtocol */ "./javascript/src/sxm/audioplayer/html5/model/CrossfadeProtocol.js");
    var AudioUtils = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
    var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var ObjectUtils = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
    var Q = __webpack_require__(/*! q */ "q");


   var audioRendererNum = 0;

  //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * @param {Number}  audioRendererId will be used in the logging for the audioRenderer to allow the logs from audioRenderes
     * @param {Number}  msPerBuffer is the number of (integer, rounded down) ms per audio pcm buffer
     * @param {Number} inFlightBuffers is the max # (rounded down, scheduled to play) buffers the renderer uses
     * @param {Number} preBufferBuffers is the number of audio buffers needed before audio render can begin
     * @param {Boolean} createContext indicates whether the global audio context is used ot a local one is
     *     created
     */

    /* beautify preserve:start */
    var AudioRenderer = function (audioRendererId, msPerBuffer, inFlightBuffers, preBufferBuffers, createContext) {
      createContext |= false;

      /**
       * The unique name for the AudioRenderer.
       * @type {String}
       */
      this.audioRendererName = "AudioRenderer:";

      if (!audioRendererId) {
        this.audioRendererName += audioRendererNum++;
        audioRendererNum = audioRendererId % 1000;
      }
      else {
        this.audioRendererName += audioRendererId;
      }
      
      this.logger = LoggerFactory.getLogger(this.audioRendererName, "CORE");
      
      AudioRenderer.parent.call(this, createContext); // Call parent constructor

      this.output.connect(this.destination);

      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------

      /**
       * Number of buffers per second the audio renderer will render
       * @type {Number}
       */
      this.msPerBuffer = (msPerBuffer) ? msPerBuffer : AudioRenderer.CONSTS.MS_PER_BUFFER;

      /**
       * Maximum number of active buffers (scheduled to play) that the audio render will use.  Number of
       * buffers in flight must be an integer, so the Math.ceil function is used to make this so.
       * @type {Number}
       */
      this.inFlightBuffers = (inFlightBuffers) ? Math.floor(inFlightBuffers) : AudioRenderer.CONSTS.INFLIGHT;

      /**
       * Number of pcm samples in each buffer that the renderer will use.  Note, this must be an integer
       * sp the Math.ceil function is used to make sure this is so.
       * @type {Number}
       */
      this.samplesPerBuffer = Math.ceil(((this.sampleRate) * this.msPerBuffer) / 1000);

      /**
       * Number of pcm samples to buffer up before audio playback starts
       * @type {Number}
       */
      this.preBufferSamples = (ObjectUtils.isNumber(preBufferBuffers) && preBufferBuffers >= 1) ?
        this.samplesPerBuffer * Math.floor(preBufferBuffers) : this.samplesPerBuffer * this.inFlightBuffers;

      /**
       * Array of buffers queued for playback.
       * @type {Array}
       */
      this.buffers = [];

      /**
       * Array of buffers queued for playback.
       * @type {Array}
       */
      this.pausedBufferQueue = [];

      /**
       * PCM samples from a previous render operation that should be added to the next render operation
       * @type {AudioSamples}
       */

      this.orphanedSamples = null;

      /**
       * Number of buffers that are currently playing/scheduled for playback
       * @type {Number}
       */
      this.buffersPlaying = 0;

      /**
       * Number of samples that are playing/scheduled for playback
       * @type {Numbert}
       * Now a property descriptor. See below.
       */

      /**
       * Time that the first AudioRenderBuffer was started
       * @type {Number}
       */
      this.renderStartTime = 0;

      /**
       * These are the promises that will be rendered when the buffers are rendered.
       * @type {Number}
       */
      this.renderPromises = [];


      this.crossfadeProtocol = null;

      /**
       * A list of callbacks that can be registered so that outside world can be notified when a buffer has
       * been played.  Callbacks should have the following signature
       *
       * @type {function}
       * @param {Number} buffersLeft of buffers that are left to be played on the renderer
       * @param {Number} start time in seconds that the buffer started playing
       * @param {Number} end time in seconds that the buffer finished playing
       */
      this.onBufferPlayedEventHandlers = [];

      /**
       * A list of callbacks that can be registered so that outside world can be notified when a buffer has
       * been played.  Callbacks should have the following signature
       *
       * @type {function}
       * @param {string} state (optional) that triggered the handler
       * @param {string} old state (optional) that triggered the handler
       */
      this.onStateNotificationHandlers = {};

      for (var prop in AudioRenderer.STATE) {
        if (AudioRenderer.STATE.hasOwnProperty(prop)) {
          this.onStateNotificationHandlers[AudioRenderer.STATE[prop]] = [];
        }
      }

      //-----------------------------------------------------------------------
      // CLASS Properties
      //-----------------------------------------------------------------------

      /**
       * A property that represent a promise that will be resolved when the buffer finishes playing.
       * reading the property gets the promise, writing the property resolves the promise with the
       * value specified and creates a new promise (autoReset is true) that will be resolved when the
       * next buffer plays
       */
      ClassUtils.createPromiseProperty(this, "onPlayed", true);

      /**
       * Property representing the state that the renderer is in
       *
       *
       * The setter function will look at the AudioRenderer.STATETABLE object to get a function to call
       * to set the renderer into the desired state based on the state it is currently in.  It then
       * updates _renderState if the promise that the function that is called is resolved.
       *
       * The getter function returns _renderState;
       *
       * @return {set} a the results from calling the function defined in the AudioRenderer.STATETABLE object
       * @return {get} the value of the _state variable in the private closure.
       */
      var _renderState = AudioRenderer.STATE.STOPPED; // private

      Object.defineProperty(this, "renderState",
        {
          set: function (state) {
            var self = this;
            var oldState = this.renderState;
            _renderState = state;

            self.logger.debug("BUFFERS = {0} going from {1} to {2} state", [this.numBuffers, oldState, state]);

            // note, stateToSet may not be the same as state, as some states are
            // transitional and get set above, and then set to a new state on promise
            // resolution (stopping and starting work like this)

            return AudioRenderer.STATETABLE.INSTATE[oldState].TO[state](this)
              .then(function (stateToSet) {
                self.onStateNotificationHandlers[state].forEach(function (handler) {
                  handler(state, oldState);
                });

                return _renderState = stateToSet;
              })
              .fail(function (badState) {
                _renderState = oldState;
                throw badState;
              });
          },
          get: function () {
            return _renderState;
          }
        });

      /**
       * Autostart property dictates whether or not the renderer starts rendering as soon as it gets enough
       * pcm to start playback.
       *
       * The setter function will look at the AudioRenderer.STATETABLE object to get the function to call to
       * set the state, and will then set _state when the state table function resolves the promise it
       * returns.
       *
       * The getter function returns _state;
       *
       * @return {set} a the results from calling the function defined in the AudioRenderer.STATETABLE object
       * @return {get} the value of the _state variable in the private closure.
       */
      var _autoStart = true; // private

      Object.defineProperty(this, "autoStart",
        {
          set: function (value) {
            _autoStart = value || false;

            if (value === true) {
              AudioRenderer.STATETABLE.INSTATE[this.renderState].API.feedRenderer(this);
            }
          },
          get: function () {
            return _autoStart;
          }
        });


      /**
       * Feed property returns the feed function for the state that the renderer is in
       * @return {get} the value of the _state variable in the private closure.
       */
      Object.defineProperty(this, "feed",
        {
          get: function () {
            return AudioRenderer.STATETABLE.INSTATE[this.renderState].API.feedRenderer;
          }
        });

      //-----------------------------------------------------------------------
      // CLASS Functions
      //-----------------------------------------------------------------------

      /**
       * Kick start the renderer
       *   1) Set the renderStartTime to the nearest second, but at least 500 ms in the future.
       *   2) Adjust all the start times of the ready to render buffers to play off renderStartTime.
       *   3) Submit buffers through continueRendering to get the render process started.
       *   4) When continueRendering's promise resolves, transition the renderer to the STARTED state.
       *   5) If continueRendering's promize fails, keep the renderer in its current state
       */
      this.kickStartRendering = function () {
        this.renderStartTime = this.currentTime;

        for (var i = 0; i < this.buffers.length; i++) {
          this.buffers[i].startTime += this.renderStartTime;
        }

        return this.continueScheduling();
      };

      this.kickStartRenderingFromPause = function () {
        if (!this.pausedBufferQueue.length) {
          return this.kickStartRendering();
        }
        var elapsedTime = this.currentTime - this.pausedBufferQueue[0].startTime;
        this.renderStartTime = this.currentTime;

        this.buffers = this.pausedBufferQueue.map(function (buffer) {
          buffer.startTime += elapsedTime;
          return buffer;
        });

        this.pausedBufferQueue = [];
        return this.continueScheduling();
      };

      /**
       * Stop the renderer
       *   1) stop all playback buffers running on renderer
       *   2) capture the promises from all the stops above
       *   3) when all the playback buffers have stopped, clear buffers playing and samplesBuffered
       *   4) return promise to caller that will be resolved when all playback buffers are stopped
       */
      this.stopRendering = function () {
        var results = [];

        while (this.numBuffers > 0) {
          var playbackBuffer = this.buffers.shift();
          results.push(playbackBuffer.stop(0));
        }

        var self = this;

        return Q.all(results).then(function (results) {
          self.buffersPlaying = 0;

          return results;
        });
      };

      /**
       * Make sure that AudioRenderer.CONSTS.INFLIGHT AudioRenderBuffers are playing or scheduled for
       * playback
       *
       * @returns promise that will be resolved when AudioRenderer.CONSTS.INFLIGHT AudioRenderBuffers are
       *     playing or scheduled for playback
       */
      this.continueScheduling = function () {
        if (this.buffers.length <= 1
          && this.orphanedSamples !== null
          && this.renderState !== AudioRenderer.STATE.STOPPING
          && this.renderState !== AudioRenderer.STATE.STOPPED) {

          this.logger.debug("Underflow imminent, Buffer time = {0} ms, playing orphaned audio", [this.bufferTime]);

          var samples = getAudioForRender(this.orphanedSamples, this.samplesPerBuffer);
          this.orphanedSamples = null;
          var renderResults = this.createRenderBuffers(samples);


          if (renderResults.samplesLeft !== 0) {
            this.logger.error("Could not play all ophaned samples ({0} samples left), something is wrong!",
              [renderResults.samplesLeft]);
          }
        }

        var results = scheduleBuffersForPlayback(this.buffers, this.buffersPlaying, this.inFlightBuffers);

        this.buffersPlaying += results.length;

        var self = this;

        return Q.all(results)
          .then(function () {
            if ((self.renderState === AudioRenderer.STATE.STOPPED) ||
              (self.renderState === AudioRenderer.STATE.STOPPING)) {
              self.logger.debug("BUFFERS = {0} renderer is stopped");
              return false;
            }
            else {
              return true;
            }
          });

        function getAudioForRender(samples, samplesPerBuffer) {
          if (samples.samplesAvailable > samplesPerBuffer) {
            self.logger.error("Orphaned samples too large ({0} samples), something is wrong ", [samples.samplesAvailable]);
          }
          else {
            samples.appendSilence(samplesPerBuffer - samples.samplesAvailable);
            return samples;
          }
        }

        function scheduleBuffersForPlayback(buffers, buffersPlaying, inFlightBuffers) {
          var results = [];

          for (var i = 0; i < buffers.length && buffersPlaying < inFlightBuffers; i++) {
            if (buffers[i].renderState === AudioRenderBuffer.STATE.STOPPED) {
              results.push(buffers[i].start());
              buffersPlaying++;
            }
          }

          return results;
        }
      };


      /**
       * PROMISE CALLBACKS
       * These are important promise callbacks that get attached to AudioRenderBuffers
       * before they are pushed onto the renderPromises queue.
       */


      /**
       * Function that is called after a buffer finishes playing.
       * Attempts to remove the buffer from the buffers queue.
       *
       * @param {Object} buffer that has finished rendering
       */
      this.removeFromBuffers = function (buffer) {
        this.buffersPlaying -= 1;
        this.onPlayed = buffer;

        var index = this.buffers.indexOf(buffer);
        if (index < 0) {
          throw("An unknown buffer (play start time " + buffer.startTime + ") was encountered");
        }

        this.buffers.splice(index, 1);

        if (this.numBuffers % (1000 / this.msPerBuffer) === 0) {
          this.logger.debug("onPlayed( contextTime = {0}, startTime = {1} timestamp = {2} BUFFERS = {3}:{4}",
            [this.currentTime, buffer.startTime, buffer.timestamp, this.numBuffers, this.buffersPlaying]);
        }

        return buffer;
      };


      this.checkToScheduleAgain = function (buffer) {
        if (this.state !== AudioRenderer.AUDIO_CONTEXT_STATE.SUSPENDED) {
          this.continueScheduling();
        }
        return buffer;
      };


      /**
       * Function that will be used to call all the event handlers to indicate a buffer has played.
       * @param {Object} buffer that has finished rendering
       */
      this.callEventHandlers = function (buffer) {
        var self = this;

        this.onBufferPlayedEventHandlers.forEach(function (handler) {
          handler(self.numBuffers, buffer.startTime, buffer.duration, buffer.timestamp, self.renderStartTime);
        });
        return buffer;
      };

      /**
       * Function that will be used to keep the audio renderer rendering
       *
       * @param {Object} buffer that has finished rendering
       */
      this.checkForUnderFlow = function (buffer) {
        if (
          (this.renderState === AudioRenderer.STATE.STARTING
            || this.renderState === AudioRenderer.STATE.STARTED)
          && this.buffersPlaying === 0) {
          this.logger.debug("BUFFERS = " + this.numBuffers + " Audio Renderer UNDERFLOWING");
          this.renderState = AudioRenderer.STATE.UNDERFLOWING;
        }
        return buffer;
      };


      /**
       * Create a new AudioRenderBuffers for all the pcm data in samples
       *
       * @param {AudioSamples} samples contains an Array of Float32Array's that contain samples for each
       *                       channel of pcm data to create a render buffer for
       *
       * @returns {Object} number of samples remaining after render buffers were created and array of promises
       *          that will be resolved once all buffers have been rendered
       */
      this.createRenderBuffers = function (samples) {
        var samplesLeft = samples.samplesAvailable;
        var samplesPerBuffer = this.samplesPerBuffer;

        if (samplesLeft < samplesPerBuffer) {
          return {
            samplesLeft: samplesLeft,
            renderPromises: [
              Q.resolve(0)
              .then(this.checkToScheduleAgain)
            ]
          };
        }

        var timestamp = samples.timestamp;

        this.renderPromises = [];

        while (samplesLeft >= samplesPerBuffer) {
          var startCopy = samples.samplesAvailable - samplesLeft;
          var endCopy = startCopy + samplesPerBuffer;
          var zuluTime = Math.round(timestamp);
          var startTime = this.nextScheduledStartTime;

          var buf = new AudioRenderBuffer(this, samples, startCopy, endCopy, startTime, zuluTime);

          this.buffers.push(buf);

          samplesLeft -= samplesPerBuffer;
          timestamp += AudioUtils.calculateDurationInMs(samplesPerBuffer, samples.sampleRate);

          this.logger.debug("BUFFERS = {0} queueing buffer to start @{1}s duration {2}ms ",
            [this.numBuffers, buf.startTime, buf.duration]);

          this.renderPromises.push(buf.onPlayed
            .then(this.checkToScheduleAgain)
            .then(this.removeFromBuffers)
            .then(this.checkForUnderFlow)
            .then(this.callEventHandlers));
        }

        return {samplesLeft: samplesLeft, renderPromises: this.renderPromises};
      };


      this.createPausedRenderBuffers = function () {
        var self = this;
        this.pausedBufferQueue = this.buffers.map(function (oldBuf) {
          var buf = new AudioRenderBuffer(
            oldBuf.outputContext,
            oldBuf.audioSamples,
            oldBuf.startCopy,
            oldBuf.endCopy,
            oldBuf.startTime,
            oldBuf.timestampAttr
          );
          oldBuf.stop(0);
          return buf;
        });

        this.renderPromises = this.pausedBufferQueue.map(function (buffer) {
          return buffer.onPlayed
            .then(self.checkToScheduleAgain)
            .then(self.removeFromBuffers)
            .then(self.checkForUnderFlow)
            .then(self.callEventHandlers);
        });
      };


      this.clearPausedBuffers = function () {
        this.pausedBufferQueue = [];
        this.renderPromises = [];
      };

      ClassUtils.bind(this, AudioRenderer);
    };

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * This is a convienence member that is just set to be the same as AudioContext's AUDIO_CONTEXT_STATE.
     * This allows comparing of the state property (defined in the AudioGainContext prototype) with the possible
     * values from the renderers AudioContext parent class.
     *
     * @type {Object}
     */
    AudioRenderer.AUDIO_CONTEXT_STATE = AudioGainContext.AUDIO_CONTEXT_STATE;

    /**
     * Hash of enumerated values describing the state of the renderer.
     * @type {Object}
     */
    AudioRenderer.STATE = {
      STOPPING: "STOPPING",
      STOPPED: "STOPPED",
      UNDERFLOWING: "UNDERFLOWING",
      STARTED: "STARTED",
      STARTING: "STARTING"
    };

    /**
     * Hash of enumerated values describing default constantsused by the renderer.
     * @type {Object}
     */
    AudioRenderer.CONSTS = {
      MS_PER_BUFFER: 1000, // default to 1 buffer per second
      INFLIGHT: 2 // default to ping/pong buffer style
    };

    /**
     * State table that defines all the state transition logic.
     *
     * @type {Object}
     *
     * Each state is represented by an object.  The object has the following members
     *   1) {String} Name of the state
     *   2) {Object} TO: an object that contains all the state names with functions for transitioning to those
     *     states
     *   3) {Object} API: an object with functions that have different implementations based on current state
     *      a) feedRenderer : a function for feeding a renderBuffer to the AudioRenderer for scheduling
     */
    AudioRenderer.STATETABLE = {
      INSTATE: {
        "STOPPING": {TO: {}, API: {}},
        "STOPPED": {TO: {}, API: {}},
        "STARTING": {TO: {}, API: {}},
        "STARTED": {TO: {}, API: {}},
        "UNDERFLOWING": {TO: {}, API: {}}
      }
    };

    /**
     * Simple feed function that just returns a promise that has been rejected
     *
     *
     * @param self is the renderer (this) that is being fed
     * @returns a promise that is rejected with a message that PCM cannot be fed in the given state
     */
    function rejectFeed(self) {
      return Q.reject("Cannot feed PCM in " + self.renderState + " state");
    }

    /**
     * Return a simple state transition function that will (itself) return a rejected promise indicating
     * that transitioning from the current state to the desired state is not allowed
     *
     *
     * @param {String} from is the state that we are attempting to transitioning from
     * @param {String} to is the state that we are attempting to transition to
     * @returns function that returns a rejected promise for the desired state transition
     */
    function rejectStateTransition(from, to) {
      return function () {
        return Q.reject("AudioRenderer : Transition from " + from + " to " + to + " not allowed");
      };
    }

    // All state transitions default to rejected unless specified otherwise
    for (var from in AudioRenderer.STATE) {
      if (AudioRenderer.STATE.hasOwnProperty(from)) {

        AudioRenderer.STATETABLE.INSTATE[from].API.feedRenderer = rejectFeed;

        for (var to in AudioRenderer.STATE) {
          if (AudioRenderer.STATE.hasOwnProperty(to)) {
            AudioRenderer.STATETABLE.INSTATE[from].TO[to] = rejectStateTransition(from, to);
          }
        }
      }
    }

    /**
     * Simple feed function that just returns a promise resolved to the renderer state
     *
     *
     * @param self is the renderer (this) that is being fed
     * @returns a promise that is resolved with the state of the renderer
     */
    function resolveFeed(self) {
      return Q.resolve(self.renderState);
    }

    /**
     * For the given state transition (from --> to), hook up a simple function that just returns a promise
     * resolved to the to state.
     *
     *
     * @param {String} from is the current state
     * @param {String} [to] is the state to go to (if undefined, then this is set to from)
     * @returns a promise that is resolved with the to state
     */
    function resolveState(from, to) {
      to = to || from; // to not specified, then generate callback for going from a state to itself

      AudioRenderer.STATETABLE.INSTATE[from].TO[to] = function () {
        return Q.resolve(to);
      };
    }

    // STOPPING STATE

    resolveState(AudioRenderer.STATE.STOPPING); // going from state to itself is simple
    resolveState(AudioRenderer.STATE.STOPPING, AudioRenderer.STATE.STOPPED); // simple case

    // UNDERFLOWING STATE

    resolveState(AudioRenderer.STATE.UNDERFLOWING); // going from state to itself is simple
    resolveState(AudioRenderer.STATE.UNDERFLOWING, AudioRenderer.STATE.STOPPING); // simple case
    resolveState(AudioRenderer.STATE.STARTED, AudioRenderer.STATE.UNDERFLOWING);
    resolveState(AudioRenderer.STATE.STARTING, AudioRenderer.STATE.UNDERFLOWING);


    /**
     * UNDERFLOWING state renderer feed function
     *
     * Check to see if autostart is true and we are still pre-buffering.  If we are, then transition the
     * renderer to the starting state. Otherwise, we just return a resolved promise with the current
     * renderer state
     *
     * @param self is the renderer (this) that is being fed
     * @returns {Object} promise that will be resolved when the renderer enters that started state
     */
    AudioRenderer.STATETABLE.INSTATE[AudioRenderer.STATE.UNDERFLOWING].API.feedRenderer = function (self) {
      if (self.samplesBuffered >= self.preBufferSamples) {
        self.logger.debug("BUFFERS = {0} pre-buffer complete, starting", [self.samplesBuffered]);
        return self.renderState = AudioRenderer.STATE.STARTING;
      }

      return Q.resolve(self.renderState);
    };


    // STOPPED STATE

    resolveState(AudioRenderer.STATE.STOPPED); // going from state to itself is simple

    /**
     * STOPPED --> STARTING
     *
     * Make the startRendering call and then return a promise that will be resolved when the renderer enters
     * the started state
     *
     * @param self is the renderer that is being fed
     * @returns a promise that will be resolved when the renderer enters that started state
     */
    AudioRenderer.STATETABLE.INSTATE[AudioRenderer.STATE.STOPPED]
      .TO[AudioRenderer.STATE.STARTING] = function (self) {
      return self.kickStartRendering()
        .then(function (result) {
          return (result === true) ? AudioRenderer.STATE.STARTED : this.renderState;
        });
    };

    /**
     * STOPPED state renderer feed function
     *
     * Check to see if autostart is true and we are still pre-buffering.  If we are, then transition the
     * renderer to the starting state. Otherwise, we just return a resolved promise with the current
     * renderer state
     *
     * @param self is the renderer (this) that is being fed
     * @returns {Object} promise that will be resolved when the renderer enters that started state
     */
    AudioRenderer.STATETABLE.INSTATE[AudioRenderer.STATE.STOPPED].API.feedRenderer = function (self) {
      if (self.autoStart === true && self.preBufferSamples <= self.samplesBuffered) {
        self.logger.debug("SAMPLES = {0} pre-buffer of {1} complete, starting",
          [self.samplesBuffered, self.preBufferSamples]);
        return self.renderState = AudioRenderer.STATE.STARTING;
      }

      return Q.resolve(self.renderState);
    };

    // STARTING STATE

    resolveState(AudioRenderer.STATE.STARTING); // going from state to itself is simple
    resolveState(AudioRenderer.STATE.STARTING, AudioRenderer.STATE.STARTED); // simple case

    /**
     * STARTING --> STOPPED
     *
     * Stop all rendering and return a promise that will be resolved when the renderer enters the stopped
     * state.
     *
     * @param self is the renderer that is being fed
     * @returns a promise that will be resolved when the renderer enters that stopped state
     */
    AudioRenderer.STATETABLE.INSTATE[AudioRenderer.STATE.STARTING]
      .TO[AudioRenderer.STATE.STOPPING] = function (self) {
      return self.stopRendering()
        .then(function () {
          return self.renderState = AudioRenderer.STATE.STOPPED;
        });
    };

    /**
     * STARTING state renderer feed function
     *
     * Already starting, so just resolve the promise as there is nothing additional to do
     */
    AudioRenderer.STATETABLE.INSTATE[AudioRenderer.STATE.STARTING].API.feedRenderer = resolveFeed;

    // STARTED STATE

    resolveState(AudioRenderer.STATE.STARTED); // going from state to itself is simple

    /**
     * STARTED --> STOPPING
     *
     * Stop all rendering and return a promise that will be resolved when the renderer enters the stopped
     * state
     *
     * @param self is the renderer that is being fed
     * @returns a promise that will be resolved when the renderer enters the stopped state
     */

    AudioRenderer.STATETABLE.INSTATE[AudioRenderer.STATE.STARTED]
      .TO[AudioRenderer.STATE.STOPPING] = function (self) {
      return self.stopRendering()
        .then(function () {
          return self.renderState = AudioRenderer.STATE.STOPPED;
        });
    };


    /**
     * STARTED state renderer feed function
     *
     * Return a promise that will be resolved when the next buffer plays out
     */
    AudioRenderer.STATETABLE.INSTATE[AudioRenderer.STATE.STARTED].API.feedRenderer = function (self) {
      return self.onPlayed;
    };


    /**
     * UNDERFLOWING --> STARTING
     *
     * Make the startRendering call and then return a promise that will be resolved when the renderer enters
     * the started state
     *
     * A lot can happen during the kickStarting process including
     * being back in the underflowing state LOL.
     *
     * First thing you do is check the current state.
     * It better be starting in order to transition into started.
     * Also kickStartRendering() can return a truthy of falsy val
     * just as before only go to started if it's truthy.
     *
     * @param self is the renderer that is being fed
     * @returns a promise that will be resolved when the renderer enters that started state
     */
    AudioRenderer.STATETABLE.INSTATE[AudioRenderer.STATE.UNDERFLOWING]
      .TO[AudioRenderer.STATE.STARTING] = function (self) {

      return self.kickStartRendering().then(function (val) {
        if (val && self.renderState === AudioRenderer.STATE.STARTING)
        {
          return AudioRenderer.STATE.STARTED;
        }
        else
        {
          return self.renderState;
        }
      });
    };

    //----------------------------------------------------------------------------------------------------------
    // PROTOTYPE Inherit AudioGainContext's prototype and restore AudioRenderer's constructor
    //----------------------------------------------------------------------------------------------------------

    ClassUtils.subClass(AudioRenderer, AudioGainContext).prototype = {

      //------------------------------------------------------------------------------------------------------
      // PROPERTIES
      //------------------------------------------------------------------------------------------------------

      /**
       * Get the number of AudioRenderBuffers queued for playback
       *
       * @return {Number} value of this.buffers.length
       */
      numBuffers: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return this.buffers.length;
          }
        }),

      /**
       * Get the start time that the last buffer on the AudioRenderer should start playback at
       *
       * @return {Number} seconds that last buffer submitted to AudioRenderer should be scheduled to start
       *     playing
       */
      lastBufferStartTime: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return (this.buffers.length === 0) ? 0 : this.buffers[this.buffers.length - 1].startTime;
          }
        }),

      /**
       * Get the duration of the last buffer on the AudioRenderer
       *
       * @return {Number} seconds that the last buffer on the AudioRenderer should play for
       */
      lastBufferDuration: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            return (this.buffers.length === 0) ? 0 : this.buffers[this.buffers.length - 1].duration;
          }
        }),

      /**
       * Get the next time that an AudioRenderBuffer should be schedule to start based on the buffers already
       * queued for playback
       *
       * @return {Number} seconds that the next buffer should be scheduled for playback
       */
      nextScheduledStartTime: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            var startTime = this.lastBufferStartTime;
            var duration = this.lastBufferDuration;

            return AudioUtils.calculateNewTimestamp(startTime * 1000, duration) / 1000;
          }
        }),

      /**
       * Gets the audio player's total time buffered in milliseconds.
       *
       * @return {Number} milliseconds of audio in buffers waiting to be rendered
       */
      bufferTime: ClassUtils.createPropertyDescriptor(
        {
          get: function () {
            var result = 0;

            for (var i = 0; i < this.numBuffers; i++) {
              result += (this.buffers[i].duration);
            }

            return result;
          }
        }),

      /**
       * Number of samples that are playing/scheduled for playback
       * @type {number}
       * Now a property descriptor. See below.
       */
      samplesBuffered: ClassUtils.createPropertyDescriptor(
        {
          get: function() {
            return this.buffers.length * this.samplesPerBuffer;
          }
        }
      ),

      //------------------------------------------------------------------------------------------------------
      // METHODS
      //------------------------------------------------------------------------------------------------------

      /**
       * Feed a PCM buffer to the AudioRenderer
       *
       * @param {AccessUnit} accessUnit contains the pcm samples to be rendered and the timestamp
       * information for the input data
       *
       * @return promise that is resolved when either immediately if we are prebuffering or when the pcm
       *     buffer is played completely if the AudioRenderer has been started
       */
      feedPCM: function (accessUnit) {
        var samplesLeft = accessUnit.pcmData.length;
        var samples;

        if (accessUnit.offset !== 0 || this.orphanedSamples === null) {
          samples = accessUnit.getSamples();
        }
        else {
          samples = accessUnit.prependSamples(this.orphanedSamples);
        }

        this.orphanedSamples = null;

        var renderResults = this.createRenderBuffers(samples);

        samplesLeft = renderResults.samplesLeft;

        if (samplesLeft > 0) {
          var orphaned = [];

          var startCopy = samples.samplesAvailable - samplesLeft;
          var endCopy = samples.samplesAvailable;

          samples.samples.forEach(function (pcmSamples) {
            // eslint-disable-next-line no-undef
            var channelData = new Float32Array(samplesLeft);
            channelData.set(pcmSamples.subarray(startCopy, endCopy), 0);
            orphaned.push(channelData);
          });

          this.orphanedSamples = new AudioSamples(orphaned, accessUnit.audioSamples.sampleRate);
        }

        var self = this;

        return Q.when(this.feed(this))
          .then(function () {
            return Q.all(renderResults.renderPromises);
          })
          .then(function (results) {
            return results[results.length - 1];
          })
          .fail(function (fault) {
            if (self.renderState !== AudioRenderer.STATE.STOPPED) {
              self.logger.error("Rendering error {0} in state {1}", [fault, self.renderState]);
              return Q.reject(fault);
            }
            else {
              return fault;
            }
          });
      },

      /**
       * Start the AudioRenderer.  This will cause AudioRenderer.CONSTS.PREBUFFER AudioRenderBuffers to be
       * started for playback (if that many are available).
       *
       * NOTE: Using FeedPCM will result in the AudioRenderer being started once
       * AudioRenderer.CONSTS.PREBUFFER AudioRenderBuffers have been fed to the renderer.  Calling this
       * method manually will start the Renderer immediately, but if there not enough AdioRendererBuffers
       * queued up, then the Renderer may underflow and automatically stop itself.
       *
       * @return promise that is resolved when the AudioRenderer enters the STARTED state
       */
      start: function () {
        if (this.renderState === AudioRenderer.STATE.STARTED) {
          return Q.when(true); // already started
        }

        return Q.when(this.renderState = AudioRenderer.STATE.STARTING);
      },

      /**
       * Stop the AudioRenderer.  Any AudioRenderBuffers that are queued up or playing will be stopped and
       * removed from the renderer
       *
       * @return promise that is resolved when the AudioRenderer enters the STOPPED state
       */
      stop: function () {
        this.autoStart = false;

        if (this.renderState === AudioRenderer.STATE.STOPPED) {
          return Q.when(true); // already stopped
        }

        this.logger.debug("Stopping renderer Buffer time = {0} ms left to play {1} samples orphaned",
          [this.bufferTime, this.orphanedSamples ? this.orphanedSamples.samplesAvailable : 0]);

        return Q.when(this.renderState = AudioRenderer.STATE.STOPPING);
      },

      /**
       * Close the renderer.  If the state is suspended, call a resume
       * since this is a shared AudioContext (AC)
       * and this state can affect other objects that will be created in the future.
       * Once we know the AC is no longer suspended, then call parent close
       * to release our reference to the AC.
       *
       * @return promise that is resolved when the AudioRenderer enters the STOPPED state
       */
      close: function () {
        if (this.state === AudioGainContext.AUDIO_CONTEXT_STATE.SUSPENDED) {
          this.clearPausedBuffers();
          this.resume();
        }

        do {
          var buffer = this.buffers.shift();

          if (buffer) {
            buffer.stop();
            buffer.source.onended = null;
            delete buffer.source.buffer;
          }

        } while (this.buffers.length > 0);

        return AudioRenderer.parent.prototype.close.call(this);
      },

      /**
       * Pause the AudioRenderer.  This function has 2 modes of operation
       *
       * Mode #1: If this.audioContext.suspendable is true (set in AudioContext.createContext), then this
       * function just fowards to this.sUper.pause, which will use the native audioContext functions to
       * pause and resume playback.
       *
       * Mode #3:
       *
       * @return promise that is resolved when the AudioRenderer enters the STOPPED state
       */
      pause: function () {
        var self = this;
        return AudioRenderer.parent.prototype.pause.call(this).then(function (result) {
          if (self.audioContext.suspendable === false) {
            self.createPausedRenderBuffers();
          }
          return result;
        });
      },

      /**
       * Resume the AudioRenderer.
       * First thing this function does is call the parent resume function.
       * Which should be the grandparent AudioContext resume function.
       * They have the same name.
       */
      resume: function () {
        var self = this;
        if (this.state === AudioRenderer.AUDIO_CONTEXT_STATE.SUSPENDED) {
          return AudioRenderer.parent.prototype.resume.call(this).then(function (result) {
            if (self.audioContext.suspendable === false) {
              self.kickStartRenderingFromPause();
              return result;
            }
          });
        }
        else {

          // TODO: BMR: 05/16/2016: Chris do want to set autoStart = true always on resume?
          if (this.renderState === AudioRenderer.STATE.STOPPED) {
            this.autoStart = true;
          }
          return AudioRenderer.STATETABLE.INSTATE[this.renderState].API.feedRenderer(this);
        }
      },

      registerStateNotificationHandler: function (state, handler) {
        if (this.onStateNotificationHandlers[state] instanceof Array) {
          this.onStateNotificationHandlers[state].push(handler);
        }
      },

      deregisterStateNotificationHandler: function (state, handler) {
        if (this.onStateNotificationHandlers[state] instanceof Array) {
          var index = this.onStateNotificationHandlers[state].indexOf(handler);
          if (index > -1) {
            this.onStateNotificationHandlers[state].splice(index, 1);
          }
        }
      },

      /**
       * Register a callback to be called when an AudioRenderBuffer finishes playing on the Renderer.  If
       * buffer is specified and non-null, then the callback will only fire once the specific buffer has
       * finished playing, otherwise, the callback will be called whenever any AudioRenderBuffer finishes
       *
       * NOTE : a callback can be registered multiple times
       *
       * @param {function} handler will be called whenever either buffer plays out or any buffer plays out if
       *     buffer is not specified
       * @buffer {AudioRenderBuffer) buffer is an optional parameter that will specify which buffer must play
       *     out for handler to be called.
       */
      registerNotificationHandler: function (handler, buffer) {
        if (buffer && buffer !== null) {
          var index = this.buffers.indexOf(buffer);

          if (index > -1) {
            this.buffers[index].registerNotificationHandler(handler);
          }
        }
        else {
          this.onBufferPlayedEventHandlers.push(handler);
        }
      },

      /**
       * Deregister a callback from being called an AudioRenderBuffer is played out.
       *
       * NOTE: If a callback is registered multiple times it must be dergistered multiple times.
       *
       * @param {function} handler will be deregistered from callback notification
       * @buffer {AudioRenderBuffer) buffer is an optional parameter that will specify which buffer to
       *     deregister handler for
       */
      deregisterNotificationHandler: function (handler, buffer) {
        if (buffer && buffer !== null) {
          var index = this.buffers.indexOf(buffer);

          if (index > -1) {
            this.buffers[index].deregisterNotificationHandler(handler);
          }
        }
        else {
          for (var i = 0; i < this.onBufferPlayedEventHandlers.length; i++) {
            if (this.onBufferPlayedEventHandlers[i] === handler) {
              this.onBufferPlayedEventHandlers.splice(i, 1);
              break;
            }
          }
        }
      },


      /**
       * *  Warm up the audio context by calling resume and pause.
       * */
      warmUp: function () {
        var self = this;
        return self.resume().then(function () {
          return self.pause();
        });
      },


      crossfade: function (config, isTurnedOn) {

        var self = this;

        this.crossfadeProtocol = new CrossfadeProtocol(
          this.msPerBuffer,
          config.crossfade,
          config.duration,
          isTurnedOn
        );

        this.removeCrossfadeSchedule();  // parent

        if (this.crossfadeProtocol.isTurnedOn()) {
          this.registerNotificationHandler(checkForFadeDownPos);
          this.registerNotificationHandler(checkForFadeUpPos);
        }
        else {
          this.deregisterNotificationHandler(checkForFadeDownPos);
          this.deregisterNotificationHandler(checkForFadeUpPos);
        }

        if (this.crossfadeProtocol.isTurnedOn() &&
          this.crossfadeProtocol.fadeUpDurationMSecs() > 0 &&
          this.renderStartTime === 0) {
          this.createGainNode(0);
        }

        // eslint-disable-next-line no-unused-vars
        function checkForFadeDownPos(numBuffers, startTimeSecs, bufferDuration, timestamp, renderStartTime) {

          if (!self.crossfadeProtocol.isTurnedOn()) {
            return;
          }

          var elapsedSecs = startTimeSecs + self.crossfadeProtocol.bufferDurationSecs() - renderStartTime;

          if (self.crossfadeProtocol.isFadeDownPointReached(elapsedSecs)) {
            self.executeLinearRamp( // parent
              0, // ending value
              startTimeSecs + self.crossfadeProtocol.bufferDurationSecs() + self.crossfadeProtocol.fadeDownDurationSecs()
            );
          }
        }

        // eslint-disable-next-line no-unused-vars
        function checkForFadeUpPos(numBuffers, startTimeSecs, bufferDuration, timestamp, renderStartTime) {

          if (!self.crossfadeProtocol.isTurnedOn()) {
            return;
          }

          var elapsedSecs = startTimeSecs + self.crossfadeProtocol.bufferDurationSecs() - renderStartTime;

          if (self.crossfadeProtocol.isFadeUpPointReached(elapsedSecs)) {
            self.executeLinearRamp( // parent
              1, // ending value
              startTimeSecs + self.crossfadeProtocol.bufferDurationSecs() + self.crossfadeProtocol.fadeUpDurationSecs()
            );
          }
        }
      },


      isCrossfadeOn: function () {
        if (!this.crossfadeProtocol) {
          return false;
        }

        return this.crossfadeProtocol.isTurnedOn();
      },

      isCrossfadeSupported: function () {
        return true; // HTML5 renderer supports crossfade
      }
    };

    return AudioRenderer;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/sink/AdtsAacAudioSink.js":
/*!*****************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/sink/AdtsAacAudioSink.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     AdtsAacAudioSink
 * @CREATED:    09/11/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * An object that represents a destination for compressed audio playback.
 */
/* beautify preserve:start */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require)
  {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var EventDispatcher = __webpack_require__(/*! sxm/audioplayer/html5/event/EventDispatcher */ "./javascript/src/sxm/audioplayer/html5/event/EventDispatcher.js");
    var MediaBuffer = __webpack_require__(/*! sxm/audioplayer/html5/model/MediaBuffer */ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js");
    var AccessUnit = __webpack_require__(/*! sxm/audioplayer/html5/model/AccessUnit */ "./javascript/src/sxm/audioplayer/html5/model/AccessUnit.js");
    var AdtsFrame = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");
    var Codec = __webpack_require__(/*! sxm/audioplayer/html5/model/Codec */ "./javascript/src/sxm/audioplayer/html5/model/Codec.js");
    var AacDecoder = __webpack_require__(/*! sxm/audioplayer/html5/audio/decoder/AacDecoder */ "./javascript/src/sxm/audioplayer/html5/audio/decoder/AacDecoder.js");
    var AudioMuxer = __webpack_require__(/*! sxm/audioplayer/html5/audio/muxer/AudioMuxer */ "./javascript/src/sxm/audioplayer/html5/audio/muxer/AudioMuxer.js");
    var AudioRenderer = __webpack_require__(/*! sxm/audioplayer/html5/audio/render/AudioRenderer */ "./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderer.js");
    var AudioContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js");
    var PlayerEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/PlayerEvent */ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js");
    var Q = __webpack_require__(/*! q */ "q");

    var sinkNum = 0;

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * Create an AdtsAacAudioSink
     *
     * @param {Object} sinkID will be used in the logging for the sink to allow the logs from different sinks
     *                 to be distinguished from each other.
     * @param {Object} feeder is a object with a method called feedMoreChunks that can be called when the sink needs
     *                 more data
     *
     * @returns {Object} results from calling continuePlaying again
     */
    function AdtsAacAudioSink(sinkID, feeder) {
      
      // Extend this object with event dispatching capabilities
      EventDispatcher.apply(this);

      this._decodeWhenPaused = true;

      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------

      /**
       * The unique name for the sink.
       * @type {String}
       */
      this.sinkName = "AudioSink:";

      if (!sinkID) {
        this.sinkName += sinkNum++;
        sinkNum = sinkNum % 1000;
      }
      else {
        this.sinkName += sinkID;
      }

      this.logger = LoggerFactory.getLogger(this.sinkName, "CORE");

      /**
       * AAC Decoder object for decoding AAC.
       * @type {AacDecoder}
       */
      this.decoder = new AacDecoder(true);

      /**
       * Audio Render object for rendering audio.
       * @type {AudioRenderer}
       *
       * WC-8190 : for small tracks on MyMix (interstitials), we can see chunks that are 1 second in length.
       * In order to be able to render these smaller chunks, we need to change the size of the render buffers
       * from the default, which is 1000 ms, to MS_PER_RENDER_BUFFER so that we can play these smaller chunks.
       *
       * In addition, since our render buffers are smaller, we up the number of in-flight (ready for render)
       * buffers that we use in the renderer from the default of 2 to IN_FLIGHT_RENDER_BUFFERS, so that we can
       * tolerate the javascript thread in the execution environment getting blocked for longer periods of time.
       *
       * Finally, we do not want to have to buffer all the preflight buffers before we can start playing, so
       * we tell the audio renderer it should have PREBUFFER_BUFFERS of audio available before it can start
       *
       * For explanation of the constant values themselves, see the documentation for AdtsAacAudioSink.CONSTS
       */
      this.renderer = new AudioRenderer(sinkID, AdtsAacAudioSink.CONSTS.MS_PER_RENDER_BUFFER,
                                        AdtsAacAudioSink.CONSTS.IN_FLIGHT_RENDER_BUFFERS,
                                        AdtsAacAudioSink.CONSTS.PREBUFFER_BUFFERS);

      /**
       * Audio Render object for rendering audio.
       * @type {AudioRenderer}
       */
      this.muxer = new AudioMuxer();

      /**
       * An array that contains parser "buffers" that can be used to get the frames for creating access units.
       * @type {AudioContext}
       */
      this.buffersToParse = [];

      /**
       * An array that contains acesss units that need to be decoded
       * @type {AudioContext}
       */
      this.accessUnitsToDecode = [];

      /**
       * An array that contains AdtsFrame objects that need to be renderer
       * @type {AudioContext}
       */
      this.accessUnitsToRender = [];
  
      /**
       * An array that contains AdtsFrame objects that need to be renderer
       * @type {Object} access unit descriptor for the access unit that is currently being rendered
       */
      this.currentAccessUnit = null;
  
      /**
       * A flag that is set to true once at least one chunk has been passed into the sink
       * @type {Boolean}
       */
      this.hasSeenAtLeastOneChunk = false;

      /**
       * Handler that gets called every time the renderer renders a buffer.  Checks to see if we need to feed
       * the renderer with more data
       *
       * @param {ArrayBuffer} buffer is the buffer that was played
       * @returns {Object} results from calling continuePlaying again
       */
      this.renderer.registerNotificationHandler(function () {

        if (this.decoder !== null && this.renderer.state === AudioRenderer.AUDIO_CONTEXT_STATE.RUNNING) {
          return this.continuePlaying();
        }

        return Q.reject(AacDecoder.CONSTS.CLOSED);
      }.bind(this));
  
      /**
       * Feeder that implements a method feedMoreBytes().
       *
       */
      this.feeder = feeder;

      this.feederPromise = Q.when(5);
      
      /**
       * Indicates if the decoder is still decoding the last audio chunk.
       * @type {Boolean}
       */
      Object.defineProperty(this, "isDecoding",
        {
          get: function () {
            return (!!this.currentAccessUnit && (this.currentAccessUnit.decodeStarted === true));
          }
        });

      Object.defineProperty(this,"decodeWhenPaused",
        {
          get : function () { return this._decodeWhenPaused; },
          set : function (value) { this._decodeWhenPaused = value; }
        });

      /**
       * IIFE ALERT!!!!
       *
       * continuePlaying will get populated with what the function below returns, which is a function to do the work
       * of keeping audio playback going.
       *
       * The function below gets passed this, and thus can provide the this reference (called) self as a closure.
       * This allow basic functions (that are more likely to be effectively JITed) to be used in the promise chain that
       * deals with the details of playing audio.
       *
       * This is done in the constructor rather than the object prototype below so much of this can be kept private to
       * the function below.  Don't want the outside world using these functions since they are only intended for
       * internal use by this ONE function
       */
      this.continuePlaying = (function (self) {

        /**
         * Check to see if the renderer is running low on data and there are access units to decode.
         *
         * If so, the function will queue up an access unit for decoding/rendering/finalization, and repeat the
         * cycle.
         *
         * If the renderer does not need data or there is no access unit available for processing, then the function
         * waits on the renderer's onPlayed promise and will call itself the next time a buffer has rendered.
         **
         * @param accessUnit is passed through this function so that it can be used in the promise chain below
         *        to ensure that the renderer is kept fed with data as access units are decoded
         */
        return function() {
          if (!self.decoder) {
            self.logger.warn("No decoder present ( decoder = {0}), buffer will be deferred",[self.decoder]);
            return;
          }

          self.logger.debug("Renderer has {0} buffers needs {1} buffers there are {2} buffers to be decoded left",
                            [self.renderer.numBuffers,self.renderer.inFlightBuffers * 2,self.buffersToParse.length]);

          if (self.buffersToParse.length > 0
              && (self.renderer.numBuffers < (self.renderer.inFlightBuffers * 2))
              && (self.isDecoding === false)
              && (self.state === AdtsAacAudioSink.AUDIO_CONTEXT_STATE.RUNNING || self._decodeWhenPaused === true)) {


            self.logger.debug("Getting an access unit to decode there are {0} buffers available",
                              [self.buffersToParse.length]);

            var auDescriptor = self.buffersToParse ? findAccessUnitToDecode(self.buffersToParse) : null;

            if (auDescriptor) {
              decodeAccessUnit(auDescriptor).then(accessUnitDecoded)
                                            .then(feedPCM)
                                            .then(accessUnitRendered)
                                            .fail(function(fault) { return failureHandler(fault,auDescriptor); });

              auDescriptor.decodeStarted = true;
              self.currentAccessUnit     = auDescriptor;
            }
          }
          else if (self.feeder) {
            if (self.feeder.isEnded === false && self.buffersToParse.length === 0) {
              self.logger.debug("No more buffers to parse getting another chunk");
              if (self.feederPromise.isFulfilled() || self.feederPromise.isRejected()) {
                self.feederPromise = self.feeder.feedMoreChunks();
              }
            } else if (self.feeder.isEnded === true) { self.feeder = null; }
          }
        };

        /**
         * Search through the buffers available for parsing to get the next access unit available for decoding.
         *
         * @param buffersToParse list of buffers that can be parsed for access units
         *
         * @returns access unit descriptor with an access unit ready for decoding.
         */
        function findAccessUnitToDecode(buffersToParse) {
          var auDescriptor;
          var buffer = buffersToParse.shift();
          
          if (buffer)
          {
            auDescriptor = getAccessUnit(buffer, self.muxer);
          }

          return auDescriptor;

          /**
           * Take the given buffer to parse, and parse an access unit from it.
           *
           * @param bufferToParse contains the parser that can be used to parse access units from an available buffer
           * @param muxer is the muxer to use to multiplex the access unit into a format that is ready for decode
           *
           * @returns an access unit descriptor with data ready to decode, or undefined if the current buffer to parse
           *          has no more data to create access units from
           */
          function getAccessUnit(bufferToParse, muxer) {

            // Prepare the audio data by creating the appropriate container based on the current browser;
            // currently this is either the ADTS audio data as is or a new MP4 container using the AAC
            // from the ADTS.
            var muxerResult = muxer.mux(
              bufferToParse.mediaBuffer,
              bufferToParse.mediaBuffer.isAACPlus,
              bufferToParse.mediaBuffer.isMP4,
              bufferToParse.reset
            );
  
            // Sanity checks to make sure the access unit data is sane.
            if ((muxerResult.startByteIndex >= muxerResult.arrayBuffer.byteLength || muxerResult.startByteIndex < 0)
              || (muxerResult.endByteIndex !== muxerResult.arrayBuffer.byteLength)) {
              self.logger.error("Corrupted chunk detected");
              return undefined;
            }

            self.logger.debug("Got a buffer to decode timestamp = {0} lastbuffer = {1}",
                              [bufferToParse.timestamp,bufferToParse.lastBuffer]);

            // Get the next audio descriptor and prepare it for decoding.
            var auDescriptor = getAccessUnitDescriptor(muxerResult,
                                                       bufferToParse.offset,
                                                       bufferToParse.timestamp,
                                                       bufferToParse.lastBuffer);
  
            return auDescriptor;

            /**
             * Get a new access unit descriptor for audio frame data
             *
             * @param audioFrames contains the audio data to create the descriptor from
             * @param offset in seconds to trim off the start of the pcm before playback
             * @param timestamp playback timestamp for the start of the samples
             * @param lastBuffer is true if this is the final buffer available for playback
             *
             * @returns {Object} a new access unit descriptor, or null if one could not be created because setBytes
             *   failed
             */
            function getAccessUnitDescriptor(audioFrames,offset,timestamp,lastBuffer) {
              var accessUnit = new AccessUnit(audioFrames.isAACPlus);

              if (accessUnit.setBytes(audioFrames.arrayBuffer,
                                      audioFrames.startByteIndex,
                                      audioFrames.endByteIndex,
                                      audioFrames.sacrificialSamples,
                                      timestamp,
                                      offset,
                                      audioFrames.duration,
                                      audioFrames.isAACPlus) < 0) {
                return null;
              }

              return {
                startIndex      : audioFrames.startByteIndex,
                decodeStarted   : false,
                renderStarted   : false,
                accessUnit      : accessUnit,
                duration        : audioFrames.duration,
                dfd             : null,
                resolveOnDecode : false,
                lastAccessUnit  : lastBuffer
              };
            }
          }
        }

        /**
         * Take an access unit descriptor and add it to the list of access units to decode and start the decode
         * processs
         *
         * @param auDescriptor is the access unit descriptor to start decoding
         *
         * @returns {*|Promise} that will be resolved/rejected once the decode has succeeded or failed
         */
        function decodeAccessUnit(auDescriptor) {

          self.accessUnitsToDecode.push(auDescriptor);

          self.logger.debug("Renderer has {0} buffers needs {1} buffers decode some audio",
                            [self.renderer.numBuffers,self.renderer.inFlightBuffers * 2]);

          var doubledAudioThreshold = (auDescriptor.accessUnit.duration)
                                      ? (auDescriptor.accessUnit.duration * .95) * 2
                                      : 9999999;

          return self.decoder
                     .decode(auDescriptor.accessUnit.frameData,
                             auDescriptor.accessUnit.samplesToTrim,
                             auDescriptor.accessUnit.aacPlus,
                             doubledAudioThreshold,
                             auDescriptor.lastAccessUnit);
        }


        /**
         * Promise resolution handler for when an access unit gets decoded.  Since we only pass the
         * compressed bitstream to the decoder, this function will put the decoded pcm into the access
         * unit object that the bitstream came from
         *
         * @param {ArrayBuffer} pcmData is the pcm for the last access unit to be decoded
         * @returns {Object} the accessUnit object for the pcm data
         */
        function accessUnitDecoded(pcmData) {

          if (!self.decoder) { return Q.reject(AudioContext.CONSTS.CLOSED); }

          self.logger.debug("accessUnitDecoded( Finished decoding an access unit {0} seconds of audio produced)",
                            [pcmData.duration]);

          var auDescriptor = self.accessUnitsToDecode.shift();

          if (auDescriptor.resolveOnDecode === true && auDescriptor.dfd !== null) {
            auDescriptor.dfd.resolve(auDescriptor.accessUnit.timestamp);
            auDescriptor.dfd = null;
          }

          auDescriptor.renderStarted = true;
          auDescriptor.decodeStarted = false;
          auDescriptor.frameData = null;

          auDescriptor.accessUnit.setPCM(pcmData);
          self.accessUnitsToRender.push(auDescriptor);
          self.currentAccessUnit = null;
          return auDescriptor.accessUnit;
        }

        /**
         * Feed PCM from a decoded access unit into the renderer.  After the render is fed this function will take
         * another pass at continuePlaying in case the renderer still needs more data to avoid underflow or to
         * actually start rendering
         *
         * @param accessUnit
         * @returns {*|promise}
         */
        function feedPCM(accessUnit)
        {
          self.logger.debug("feedPcm( feeded decoded access unit to renderer. )");

          var feedResult = self.renderer.feedPCM(accessUnit);

          self.logger.debug("feedPcm(Renderer now has {0} buffers needs {1} buffers)",
                            [self.renderer.numBuffers,self.renderer.inFlightBuffers * 2]);

          accessUnit.clearBytes();

          // Update the flag once we have actually fed pcm to renderer instead when we get 1st chunk, as in low network
          // conditions We are checking the feed before buffer actually rendered and we have the context state suspended
          self.hasSeenAtLeastOneChunk = true;

          self.continuePlaying();

          return feedResult;
        }

        /**
         * Promise resolution handler for when an access unit gets rendered. This method will take the
         * access unit of the list to be decoded and put it back on the list of access unit object available
         * for new requests
         *
         * @param {Object} buffer is the last buffer that was rendered by the renderer, or undefined if
         *                 nothing has been rendered yet.
         * @returns {Object} buffer that was passed to the function for usage further down the promise chain
         */
        function accessUnitRendered(buffer) {

          self.logger.debug("accessUnitRendered( Access unit has been rendered. )");

          var auDescriptor = self.accessUnitsToRender ? self.accessUnitsToRender.shift() : null;

          if (auDescriptor && auDescriptor.dfd !== null) {
            auDescriptor.decodeStarted = auDescriptor.renderStarted = false;
            auDescriptor.dfd.resolve(auDescriptor.accessUnit.timestamp);
            auDescriptor.dfd = null;
          }

          return buffer;
        }

        /**
         * Promise failure handler for when the decode/render promise chain throws an error
         *
         * @param {Object} fault is the fault that is being reported
         * @param {Object} auDescriptor is the descriptor for the access unit that failed;
         * @returns {Promise} a rejected promise that will pass the fault upstream
         */
        function failureHandler(fault, auDescriptor) {
          fault = fault.message || fault;

          var logFunc = (fault !== AudioContext.CONSTS.CLOSED)
                        ? self.logger.error.bind(self.logger)
                        : self.logger.debug.bind(self.logger);
          var logString = "continuePlaying general failure {0}";

          if (fault === PlayerEvent.DECODER_FAILURE) {
            // Event dispatcher was mixed in during object construction (EventDispatcher.applu), so we can do this
            self.dispatchEvent({type: PlayerEvent.DECODER_FAILURE});
          }

          auDescriptor.accessUnit.clearBytes();

          var accessUnitArray;

          if (auDescriptor.decodeStarted === true) {
            if (auDescriptor.renderStarted === false) {
              logString       = "continuePlaying decode failure {0}";
              accessUnitArray = self.accessUnitsToDecode;
            }
            else {
              logString = "continuePlaying render failure {0}";
              accessUnitArray = self.accessUnitsToRender;
            }
          }
          else {
            accessUnitArray = [];
          }

          logFunc(logString,[fault]);

          var indexToRemove = accessUnitArray.indexOf(auDescriptor);
          if (indexToRemove >= 0) { accessUnitArray.splice(indexToRemove, 1); }

          return Q.reject(fault);
        }
      })(this); // call lambda, create closure, return actual function for continuePlaying

      ClassUtils.bind(this, AdtsAacAudioSink);
    };

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * This is a convenience member that is just set to be the same as AudioContext's AUDIO_CONTEXT_STATE.
     * This allows comparing of the state property (defined below in the prototype) with the possible
     * values from the renderers AudioContext parent class.
     *
     * @type {Object}
     */
    AdtsAacAudioSink.AUDIO_CONTEXT_STATE = AudioRenderer.AUDIO_CONTEXT_STATE;

    /**
     * This is a convenience member that is just set to be the same as AudioRender.STATE.
     * This allows registering with the sink for audio render state changes
     *
     * @type {Object}
     */
    AdtsAacAudioSink.RENDERER_STATES = AudioRenderer.STATE;

    /**
     * Hash of sink states.
     * @type {Object}
     */
    AdtsAacAudioSink.STATES = {
      STOPPED: "stopped",
      STARTED: "started",
      PAUSED: "paused",
      KILLED: "dead"
    };

    /**
     * Hash of enumerated values describing constants for the AudioSink class.
     * @type {Object}
     */
    AdtsAacAudioSink.CONSTS = {
      ADTS_MS_PER_ACCESS_UNIT: 0,
      ADTS_FRAMES_PER_ACCESS_UNIT: 210, // # of ADTS frames that comprise an atomic access unit
      MS_PER_RENDER_BUFFER: 250, // 250 ms buffers means we can play chunks as small as 500 ms
      PREBUFFER_BUFFERS: 1,   // need to have 250ms in buffer to start rendering
      IN_FLIGHT_RENDER_BUFFERS: 32    // 8 in-flight buffers means that we have 2s of audio ready to play
    };

    AdtsAacAudioSink.CONSTS.ADTS_MS_PER_ACCESS_UNIT =
      AdtsFrame.CONSTS.ADTS_MS_PER_FRAME * AdtsAacAudioSink.CONSTS.ADTS_FRAMES_PER_ACCESS_UNIT;

    //----------------------------------------------------------------------------------------------------------
    // PROTOTYPE Add AdtsAacAudioSink prototype and restore constructor
    //----------------------------------------------------------------------------------------------------------

    ClassUtils.baseClass(AdtsAacAudioSink).prototype = {

      /**
       * Get or set the volume for the object
       *
       * @param (Number) volume (between 0 and 100) to set the renderer output to
       * @return {Number} volume value from the renderer
       */
      volume : ClassUtils.createPropertyDescriptor(
        {
          get : function() {
            if (!this.renderer) {
              return NaN;
            }
            return this.renderer.volume;
          },
          set : function(volume) {
            this.logger.debug("volume( {0} )",[volume]);
            this.renderer.volume = volume;
          }
        }),

      /**
       * The (AudioContext) state of the renderer
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
       *
       * @return {Number} value of this.buffers.length
       */
      state : ClassUtils.createPropertyDescriptor(
        {
          get : function() {
            return this.renderer.state;
          }
        }),

      /**
       * The (AudioContext) state change handler
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
       *
       * Set this property with a function and that function will be called whenever the state of the
       * renderer's underlying audio context changes.
       */
      stateChangeHandler : ClassUtils.createPropertyDescriptor(
        {
          set : function(handler) {

            var self = this;

            this.renderer.stateChangeHandler = function() {
              if (handler && typeof handler === "function") {
                handler(self.renderer.state);
              }
            };
          }
        }),

      /**
       * The (boolean) value that determines if the sink starts playing automatically
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
       *
       * @return {Number} value of this.buffers.length
       */
      autoStart : ClassUtils.createPropertyDescriptor(
        {
          get : function() {
            return this.renderer.autoStart;
          },
          set : function(value) {
            this.logger.debug("autoStart( {0} )",[String(value)]);
            this.renderer.autoStart = value;
          }
        }),

      /**
       * Stop the Sink from rendering.  Once the Sink has stopped, if it is in the paused
       * state (AudioContext.AUDIO_CONTEXT_STATE.SUSPENDED) it will be resumed.  This is in case the
       * renderer is using the global audio context, we do not leave the audio context in the paused
       * state.
       *
       * @returns {Promise} a promise that will be resolved when the render has stopped all playback
       */
      stop: function() {

        this.logger.debug("stop( Audio Sink being asked to stop. )");

        return this.reset()
                   .then(completeRendering.bind(this))
                   .then(cleanup.bind(this));

        function completeRendering() {
          return this.renderer.close();
        }

        function cleanup(promise) {
          this.logger.debug("cleanup( Audio Sink has stopped and all internals reset. )");

          // Remove any callbacks.
          this.renderer.stateChangeHandler = null;

          // Null out all internals so they're ready for GC.
          this.sinkName            = null;
          this.decoder             = null;
          this.renderer            = null;
          this.muxer               = null;
          this.accessUnitsToDecode = null;
          this.accessUnitsToRender = null;
          this.currentAccessUnit   = null;

          return promise;
        }
      },

      /**
       * Pause the renderer
       *
       * @returns a promise that will be resolved when playback is paused, or rejected if the render's audio
       * context is in a non-active state
       */
      pause: function () {
        this.logger.debug("pause()");
        return this.renderer.pause();
      },

      /**
       * Resume the renderer
       *
       * @returns a promise that will be resolved when playback is resumed, or rejected if the renderer's audio
       * context is in a non-active state
       */
      resume: function () {
        var self = this;
        this.logger.debug("resume()");

        return this.renderer.resume()
          .then(function(result) {
            self.continuePlaying();
            return result;
          });
      },

      /**
       * Gets the audio player's total time buffered in milliseconds.
       */
      getBufferTime: function () {
        var msecsToParse = this.buffersToParse.reduce(function(total,current) { return total + current.duration; },0);
        var msecsToDecode = this.accessUnitsToDecode.reduce(function(total,current) { return total + current.duration; },0);
        var msInRenderer = this.renderer.buffers.length * this.renderer.msPerBuffer;
        var msInOrphanedPcm = this.renderer.orphanedSamples ? this.renderer.orphanedSamples.duration : 0;

        //this.logger.error("Buffer time = {0} {1} + {2}",[msecsInSink + msInRenderer,msecsInSink,msInRenderer]);

        return msecsToParse + msecsToDecode + msInRenderer + msInOrphanedPcm;
      },
      
      
      
      isReady: function() {
        return this.hasSeenAtLeastOneChunk;
      },

      /**
       * Register a callback to be called when the renderer enters a certain state
       * NOTE : a callback can be registered multiple times, and must be deregistered for every time it is
       *        registered
       *
       * @param {String} state that the handler should be registered for
       * @param {function} handler will be called whenever the renderer enters (or transitions through) the
       * requested state
       */
      registerStateNotificationHandler: function (state, handler) {
        this.renderer.registerStateNotificationHandler(state, handler);
      },

      /**
       * Deregister a callback from being called when a render request finishes.
       *
       * NOTE: If a callback is registered multiple times it must be deregistered multiple times.
       *
       * @param {String} state that the handler should be de-registered for
       * @param {function} handler will be de-registered for the given state
       */
      deregisterStateNotificationHandler: function (state, handler) {
        this.renderer.deregisterStateNotificationHandler(state, handler);
      },

      /**
       * Register a callback to be called when an render request finishes playing on the Renderer.
       *
       * NOTE : a callback can be registered multiple times, and must be deregistered for every time it is
       *        registered
       *
       * @param {function} handler will be called whenever either buffer plays out or any buffer plays out if
       *   buffer is not specified
       */
      registerNotificationHandler: function (handler) {
        this.renderer.registerNotificationHandler(handler);
      },

      /**
       * Deregister a callback from being called when a render request finishes.
       *
       * NOTE: If a callback is registered multiple times it must be deregistered multiple times.
       *
       * @param {function} handler will be deregistered from callback notification
       */
      deregisterNotificationHandler: function (handler) {
        this.renderer.deregisterNotificationHandler(handler);
      },

      /**
       * Decode and render audio data.
       *
       * First, skip the ID3Tag (as it's not important to decoding) and copy the remaining data
       * into a new array buffer.
       *
       * Attempts to build the correct audio data container -- either use the incoming ADTS as is
       * or create an MP4 container. This conversion is performed in the AudioMuxer
       * object.
       *
       * Validates chunk data -- rejects the promise if invalid otherwise drops it
       * onto a queue for decoding at a later time.
       *
       * @param {Chunk} chunk - Chunk object that contains compressed AAC audio data.
       * @param {Boolean} reset - Flag indicating if the underlying audio player components
       * (like the decoder, muxer, etc) should be reset.
       * @return Promise that gets resolved as soon as the data is queued up for decode.
       */
      render: function (chunk, reset) {

        this.logger.debug("render( Chunk timestamp = {0} offset = {1} duration = {2} chunk = {3} )",
                          [chunk.timestamp, chunk.offset, chunk.duration, chunk.fileName]);

        if (!chunk.data) { return Q.reject("Corrupted chunk detected. No audio data detected."); }



        var mediaBuffer;

        if (chunk.isMP4) {
          // Set the initial AAC audio data to the incoming chunks complete data, which should be parseable as MP4 data

          mediaBuffer = new MediaBuffer(chunk.data, chunk.duration, Codec.isAacPlus(chunk), true);
        }
        else {
          // Set the initial AAC audio data to the incoming media buffer's audio data sans
          // the prefixing ID3 tag; this means the new version of the data starts with the first ADTS
          // frame and not the ID3 tag.

          mediaBuffer = skipID3Tag(chunk);
        }

        this.buffersToParse.push({ mediaBuffer: mediaBuffer,
                                   reset : reset,
                                   lastBuffer : chunk.lastChunk,
                                   offset : chunk.offset,
                                   timestamp : chunk.timestamp,
                                   duration : chunk.duration ? chunk.duration * 1000 : 10000
        });

        // this.hasSeenAtLeastOneChunk = true;

        this.continuePlaying();

        return Q.resolve(1);

        /**
         * Return the data after the ID3 tag (if it exists).  If there is no ID3 tag then no data is skipped
         *
         * @param mediaBuffer is the media buffer to search for the ID3 tag in
         * @returns array buffer with data after any ID3 tag that is detected at the start of the buffer
         */
        function skipID3Tag(chunk) {
          var mediaBuffer        = new MediaBuffer(chunk.data,
                                                   chunk.duration,
                                                   Codec.isAacPlus(chunk),
                                                   chunk.isMP4);
          var id3TagEndByteIndex = AdtsFrame.skipID3TAG(mediaBuffer.bytes,0);

          if (id3TagEndByteIndex !== 0) {
            mediaBuffer.arrayBuffer = mediaBuffer.arrayBuffer.slice(id3TagEndByteIndex,mediaBuffer.length);
          }

          return mediaBuffer;
        }
      },

      /**
       * Reset the sink, which means close the decoder and null it out. Sink will no longer be usable after
       * doing this.
       *
       * @returns {Promise} A promise that will be resolved when the render has stopped all playback.
       */
      reset: function () {

        this.feeder = null;

        if (this.decoder) {
          var decoder = this.decoder;
          this.decoder = null;

          return decoder.close()
                        .finally(stopRenderer.bind(this))
                        .fail(fault.bind(this));
        }

        return Q.when(true);

        function stopRenderer() {
          this.logger.debug("reset( Sink decoder has been closed. )");
          return this.renderer.stop();
        }

        function fault(fault) {
          this.logger.error("reset( Sink decoder failed to close or renderer failed to stop. Error: {0} )", [fault]);
          throw fault;
        }
      },

      crossfade: function(config, isTurnedOn) {
        if (!this.renderer) { return; }

        this.renderer.crossfade(config, isTurnedOn);
      },

      isCrossfadeOn: function() {
        if (!this.renderer) { return false; }

        return this.renderer.isCrossfadeOn();
      },

      isCrossfadeSupported: function() {
        if (!this.renderer) { return false; }

        return this.renderer.isCrossfadeSupported();
      }
    };

    return AdtsAacAudioSink;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/sink/AdtsFlashAudioSink.js":
/*!*******************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/sink/AdtsFlashAudioSink.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     AdtsFlashAudioSink
 * @CREATED:    09/11/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * An object that represents a destination for compressed audio playback.
 */
/* beautify preserve:start */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require)
  {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var EventDispatcher = __webpack_require__(/*! sxm/audioplayer/html5/event/EventDispatcher */ "./javascript/src/sxm/audioplayer/html5/event/EventDispatcher.js");
    var MediaBuffer = __webpack_require__(/*! sxm/audioplayer/html5/model/MediaBuffer */ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js");
    var AccessUnit = __webpack_require__(/*! sxm/audioplayer/html5/model/AccessUnit */ "./javascript/src/sxm/audioplayer/html5/model/AccessUnit.js");
    var AdtsFrame = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");
    var AdtsParser = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsParser */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsParser.js");
    var Codec = __webpack_require__(/*! sxm/audioplayer/html5/model/Codec */ "./javascript/src/sxm/audioplayer/html5/model/Codec.js");
    var AudioMuxer = __webpack_require__(/*! sxm/audioplayer/html5/audio/muxer/AudioMuxer */ "./javascript/src/sxm/audioplayer/html5/audio/muxer/AudioMuxer.js");
    var AudioRenderer = __webpack_require__(/*! sxm/audioplayer/html5/audio/render/AudioRenderer */ "./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderer.js");
    var Q = __webpack_require__(/*! q */ "q");
    
    var sinkNum = 0;
    
    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------
    
    /**
     * Create an AdtsFlashAudioSink
     *
     * @param {Object} sinkID will be used in the logging for the sink to allow the logs from different sinks
     * to be distinguished from each other.
     *
     * @returns {Object} results from calling continuePlaying again
     */
    function AdtsFlashAudioSink(sinkID, feeder, renderer) {
      
      // Extend this object with event dispatching capabilities
      EventDispatcher.apply(this);
      
      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------
      
      /**
       * The unique name for the sink.
       * @type {String}
       */
      this.sinkName = "AudioSink:";
      
      if (!sinkID) {
        this.sinkName += sinkNum++;
        sinkNum = sinkNum % 1000;
      }
      else {
        this.sinkName += sinkID;
      }
  
      /**
       * Feeder that implements a method feedMoreChunks().
       *
       */
      this.feeder = feeder;
  
      this.feederPromise = Q.when(5);
  
      /**
       * adtsParser object holds the mediaBuffer
       *
       */
      this.adtsParser = null;
      
      this.isAACPlus = null;
      
      /**
       * The renderer object.
       * @type {Function}
       */
      
      this.renderer = renderer;
      
      this.flashPlayback = this.renderer.createPlayback();
      
      
      this.logger = LoggerFactory.getLogger(this.sinkName, "CORE");
      this.logger.debug("Constructor()");
  
      /**
       * Audio Render object for rendering audio.
       * @type {AudioRenderer}
       */
      this.muxer = new AudioMuxer();
      this.muxer.disableSacrificialFrames();
      /**
       * An array that contains parser "buffers" that can be used to get the frames for creating access units.
       * @type {AudioContext}
       */
      this.buffersToParse = [];
      
      /**
       * An array that contains acesss units that need to be decoded
       * @type {AudioContext}
       */
      this.accessUnitsToDecode = [];
      
      /**
       * An array that contains AdtsFrame objects that need to be renderer
       * @type {AudioContext}
       */
      this.accessUnitsToRender = [];
      
      /**
       * An array that contains AdtsFrame objects that need to be renderer
       * @type {Object} access unit descriptor for the access unit that is currently being rendered
       */
      this.currentAccessUnit = null;
  
  
      /**
       * Handler that gets called every time the renderer is BUFFER_UNDERFLOW.  Checks to see if we need to feed
       * the renderer with more data
       */

      this.bufferUnderFlowEvent = 'BUFFER_UNDERFLOW_'+ this.flashPlayback.id;
      this.onBufferUnderFlow = function () {
        this.logger.debug("Event : {0} ",[this.bufferUnderFlowEvent]);
        this.continuePlaying();
      };
      this.onBufferUnderFlowHandler = this.onBufferUnderFlow.bind(this);
      this.renderer.addEventListener(this.bufferUnderFlowEvent, this.onBufferUnderFlowHandler);
      
      /**
       * Indicates if the decoder is still decoding the last audio chunk.
       * @type {Boolean}
       */
      Object.defineProperty(this, "isDecoding",
        {
          get: function () {
            return this.currentAccessUnit && (this.currentAccessUnit.decodeStarted === true);
          }
        });
      
      /**
       * IIFE ALERT!!!!
       *
       * continuePlaying will get populated with what the function below returns, which is a function to do the work
       * of keeping audio playback going.
       *
       * The function below gets passed this, and thus can provide the this reference (called) self as a closure.
       * This allow basic functions (that are more likely to be effectively JITed) to be used in the promise chain that
       * deals with the details of playing audio.
       *
       * This is done in the constructor rather than the object prototype below so much of this can be kept private to
       * the function below.  Don't want the outside world using these functions since they are only intended for
       * internal use by this ONE function
       */
      this.continuePlaying = (function (self) {
        
        /**
         * Check to see if the renderer is running low on data and there are access units to decode.
         *
         * If so, the function will queue up an access unit for decoding/rendering/finalization, and repeat the
         * cycle.
         *
         * If the renderer does not need data or there is no access unit available for processing, then the function
         * waits on the renderer's onPlayed promise and will call itself the next time a buffer has rendered.
         **
         * @param accessUnit is passed through this function so that it can be used in the promise chain below
         *        to ensure that the renderer is kept fed with data as access units are decoded
         */
        return function() {

          //If the renderer has bufferTime > 16000 then don't send any more buffer wait until it gets lower
          if (!self.renderer || self.renderer.bufferTime > 16000) {
            return;
          } else if(self.adtsParser){  //If we have buffer already in adtsParser, then use this data to first send to flashRenderer
            var mediaFrameBuffer = self.adtsParser.getAACFrames(210);
            
            if(mediaFrameBuffer)
            {
              var uint8Array = new Uint8Array(mediaFrameBuffer.arrayBuffer);
              self.renderer.appendBytes(this.flashPlayback.id,uint8Array, uint8Array.length);
              return;
            }
            
          }
          var isMP4 = self.buffersToParse && self.buffersToParse[0] ? self.buffersToParse[0].mediaBuffer.isMP4 : false;
          
          var auDescriptor = findAccessUnitToDecode(self.buffersToParse);

          if (!!auDescriptor) {
  
            //IF the bitrate is shifting from AAC HE(lower bitrate) to AAC LC( higher bitrate) or the viceversa
            // the flash renderer cannot handle both buffers in continous stream so has to reset the playback
            // TODO : Need to revist again to fix this as with this approach we noticed a glitch
            if (self.isAACPlus === null) {
              
              self.isAACPlus = auDescriptor.accessUnit.aacPlus;
            }
            if(self.isAACPlus !== auDescriptor.accessUnit.aacPlus)
            {
              self.logger.debug("Switched bitrate, should reset the playbackStream ");
              // Reset the flashPlayback ref with new playback and append The bytes to the new playback
              // as once the old one is empty, flashPlayer will switch with the new playback
              self.flashPlayback = self.renderer.resetPlaybackStream();
  
              //this is to make sure we are listening to new BUFFER_UNDERFLOW event and closing the current one
              self.close();
              self.bufferUnderFlowEvent = 'BUFFER_UNDERFLOW_'+ self.flashPlayback.id;
              self.renderer.addEventListener(self.bufferUnderFlowEvent,self.onBufferUnderFlowHandler);
            }
            
            self.logger.debug("AdtsParser- isMP4 {0} , isAACPlus - {1} ", [isMP4, auDescriptor.accessUnit.aacPlus]);
            var mediaBuffer = new MediaBuffer(auDescriptor.accessUnit.frameData, auDescriptor.duration, auDescriptor.accessUnit.aacPlus, isMP4);
            self.adtsParser = new AdtsParser(mediaBuffer);
  
            var mediaFrameBuffer = self.adtsParser.getAACFrames(210);
            var uint8Array = new Uint8Array(mediaFrameBuffer.arrayBuffer);
            self.renderer.appendBytes(self.flashPlayback.id, uint8Array, uint8Array.byteLength);
            
            // Below code is working solution for Live/AOD/AIC as these chunks are lesser size compared to MP4 chunk size
            // but we have to move away from this and use the adtsParser send 210 frames at a time to fix the MP$ chunks and
            // we are using this for all playback types to be consistent
            // Leave the code for now
            
            // var uint8Array = new Uint8Array(auDescriptor.accessUnit.frameData);
            // self.logger.debug("appendBytes {0} ",[uint8Array.length]);
            //
            // this.renderer.appendBytes(this.flashPlayback.id, uint8Array, uint8Array.length);
            // this.continuePlaying();
            //
            // auDescriptor.decodeStarted = true;
            // self.currentAccessUnit     = auDescriptor;
  
            self.isAACPlus = auDescriptor.accessUnit.aacPlus;
          }

          if (self.feeder.isEnded === false) {
            
            self.logger.debug("No more buffers to parse getting another chunk");
            
            if (self.feederPromise.isFulfilled() || self.feederPromise.isRejected()) {
              self.feederPromise = self.feeder.feedMoreChunks();
            }
            else {
              self.feederPromise = self.feederPromise.then(function() {
                return self.feeder.feedMoreChunks();
              });
            }
          }
          else {
            //Let the renderer know that the track has ended and there are no more chunks
            self.renderer.isEnded(true);
            self.logger.warn("Audio renderer is getting low and there are no more buffers to decode");
          }
        };
        
        /**
         * Search through the buffers available for parsing to get the next access unit available for decoding.
         *
         * @param buffersToParse list of buffers that can be parsed for access units
         *
         * @returns access unit descriptor with an access unit ready for decoding.
         */
        function findAccessUnitToDecode(buffersToParse) {
          var auDescriptor;
          var buffer = buffersToParse.shift();
          
          if (buffer)
          {
            auDescriptor = getAccessUnit(buffer, self.muxer);
          }
          
          return auDescriptor;
          
          /**
           * Take the given buffer to parse, and parse an access unit from it.
           *
           * @param bufferToParse contains the parser that can be used to parse access units from an available buffer
           * @param muxer is the muxer to use to multiplex the access unit into a format that is ready for decode
           *
           * @returns an access unit descriptor with data ready to decode, or undefined if the current buffer to parse
           *          has no more data to create access units from
           */
          function getAccessUnit(bufferToParse, muxer) {
            
            // Prepare the audio data by creating the appropriate container based on the current browser;
            // currently this is either the ADTS audio data as is or a new MP4 container using the AAC
            // from the ADTS.
            var muxerResult = muxer.mux(
              bufferToParse.mediaBuffer,
              bufferToParse.mediaBuffer.isAACPlus,
              bufferToParse.mediaBuffer.isMP4,
              bufferToParse.reset
            );
            
            // Sanity checks to make sure the access unit data is sane.
            if ((muxerResult.startByteIndex >= muxerResult.arrayBuffer.byteLength || muxerResult.startByteIndex < 0)
              || (muxerResult.endByteIndex !== muxerResult.arrayBuffer.byteLength)) {
              self.logger.error("Corrupted chunk detected");
              return undefined;
            }
            
            self.logger.debug("Got a buffer to decode timestamp = {0} lastbuffer = {1}",
              [bufferToParse.timestamp,bufferToParse.lastBuffer]);
            
            // Get the next audio descriptor and prepare it for decoding.
            var auDescriptor = getAccessUnitDescriptor(muxerResult,
              0,
              bufferToParse.timestamp,
              bufferToParse.lastBuffer);
            
            return auDescriptor;
            
            /**
             * Get a new access unit descriptor for audio frame data
             *
             * @param audioFrames contains the audio data to create the descriptor from
             * @param offset in seconds to trim off the start of the pcm before playback
             * @param timestamp playback timestamp for the start of the samples
             * @param lastBuffer is true if this is the final buffer available for playback
             *
             * @returns {Object} a new access unit descriptor, or null if one could not be created because setBytes failed
             */
            function getAccessUnitDescriptor(audioFrames,offset,timestamp,lastBuffer) {
              var accessUnit = new AccessUnit(audioFrames.isAACPlus);
              
              if (accessUnit.setBytes(audioFrames.arrayBuffer,
                audioFrames.startByteIndex,
                audioFrames.endByteIndex,
                audioFrames.sacrificialSamples,
                timestamp,
                offset,
                audioFrames.duration,
                audioFrames.isAACPlus) < 0) {
                return null;
              }
              
              return {
                startIndex      : audioFrames.startByteIndex,
                decodeStarted   : false,
                renderStarted   : false,
                accessUnit      : accessUnit,
                duration        : audioFrames.duration,
                dfd             : null,
                resolveOnDecode : false,
                lastAccessUnit  : lastBuffer
              };
            }
          }
        }
        
      })(this); // call lambda, create closure, return actual function for continuePlaying
      
      ClassUtils.bind(this, AdtsFlashAudioSink);
    };
    
    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------
    
    /**
     * This is a convenience member that is just set to be the same as AudioContext's AUDIO_CONTEXT_STATE.
     * This allows comparing of the state property (defined below in the prototype) with the possible
     * values from the renderers AudioContext parent class.
     *
     * @type {Object}
     */
    AdtsFlashAudioSink.AUDIO_CONTEXT_STATE = AudioRenderer.AUDIO_CONTEXT_STATE;
    
    /**
     * This is a convenience member that is just set to be the same as AudioRender.STATE.
     * This allows registering with the sink for audio render state changes
     *
     * @type {Object}
     */
    AdtsFlashAudioSink.RENDERER_STATES = AudioRenderer.STATE;
    
    /**
     * Hash of sink states.
     * @type {Object}
     */
    AdtsFlashAudioSink.STATES = {
      STOPPED: "stopped",
      STARTED: "started",
      PAUSED: "paused",
      KILLED: "dead"
    };
    
    /**
     * Hash of enumerated values describing constants for the AudioSink class.
     * @type {Object}
     */
    AdtsFlashAudioSink.CONSTS = {
      ADTS_MS_PER_ACCESS_UNIT: 0,
      ADTS_FRAMES_PER_ACCESS_UNIT: 210, // # of ADTS frames that comprise an atomic access unit
      MS_PER_RENDER_BUFFER: 250, // 250 ms buffers means we can play chunks as small as 500 ms
      PREBUFFER_BUFFERS: 1,   // need to have 250ms in buffer to start rendering
      IN_FLIGHT_RENDER_BUFFERS: 8    // 8 in-flight buffers means that we have 2s of audio ready to play
    };
  
    AdtsFlashAudioSink.CONSTS.ADTS_MS_PER_ACCESS_UNIT =
      AdtsFrame.CONSTS.ADTS_MS_PER_FRAME * AdtsFlashAudioSink.CONSTS.ADTS_FRAMES_PER_ACCESS_UNIT;
    
    //----------------------------------------------------------------------------------------------------------
    // PROTOTYPE Add AudioDecodeContext prototype and restore AacDecoder constructor
    //----------------------------------------------------------------------------------------------------------
    
    ClassUtils.baseClass(AdtsFlashAudioSink).prototype = {
      
      /**
       * Get or set the volume for the object
       *
       * @param (Number) volume (between 0 and 100) to set the renderer output to
       * @return {Number} volume value from the renderer
       */
      volume : ClassUtils.createPropertyDescriptor(
        {
          get : function() {
            if (!this.renderer) {
              return NaN;
            }
            return this.renderer.volume;
          },
          set : function(volume) {
            this.logger.debug("volume( {0} )",[volume]);
            this.renderer.volume = volume;
          }
        }),

      /**
       * Get or set the volume for the object
       *
       * @param (Number) volume (between 0 and 100) to set the renderer output to
       * @return {Number} volume value from the renderer
       */
      crossfadeOn : ClassUtils.createPropertyDescriptor((function() {
        var _crossFadeOn = false;
        return {
          get : function() {
            return _crossFadeOn;
          },
          set : function(flag) {
            _crossFadeOn = flag;
          }
        };
      })()),

      /**
       * The (AudioContext) state of the renderer
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
       *
       * @return {Number} value of this.buffers.length
       */
      state : ClassUtils.createPropertyDescriptor(
        {
          get : function() {
            return this.renderer.state;
          }
        }),
      
      /**
       * The (AudioContext) state change handler
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
       *
       * Set this property with a function and that function will be called whenever the state of the
       * renderer's underlying audio context changes.
       */
      stateChangeHandler : ClassUtils.createPropertyDescriptor(
        {
          set : function(handler) {
            
            var self = this;
            
            this.renderer.stateChangeHandler = function() {
              if (handler && typeof handler === "function") {
                handler(self.renderer.state);
              }
            };
          }
        }),
      
      /**
       * The (boolean) value that determines if the sink starts playing automatically
       *
       * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
       *
       * @return {Number} value of this.buffers.length
       */
      autoStart : ClassUtils.createPropertyDescriptor(
        {
          get : function() {
            return this.renderer.autoStart;
          },
          set : function(value) {
            this.logger.debug("autoStart( {0} )",[String(value)]);
            this.renderer.updateAutoStart(this.flashPlayback.id, value);
          }
        }),
      
      /**
       * Stop the Sink from rendering.  Once the Sink has stopped, if it is in the paused
       * state (AudioContext.AUDIO_CONTEXT_STATE.SUSPENDED) it will be resumed.  This is in case the
       * renderer is using the global audio context, we do not leave the audio context in the paused
       * state.
       *
       * @returns {Promise} a promise that will be resolved when the render has stopped all playback
       */
      stop : function() {
        
        this.logger.debug("stop( Audio Sink being asked to stop. )");
        
        return this.reset()
          .then(completeRendering.bind(this))
          .then(cleanup.bind(this));
        
        function completeRendering() {
          return this.renderer.close(this.flashPlayback.id);
        }
        
        function cleanup(promise) {
          this.logger.debug("cleanup( Audio Sink has stopped and all internals reset. )");
          
          // Remove any callbacks.
          this.renderer.stateChangeHandler = null;
          
          // Null out all internals so they're ready for GC.
          this.sinkName            = null;
          this.renderer            = null;
          this.muxer               = null;
          this.accessUnitsToDecode = null;
          this.accessUnitsToRender = null;
          
          return promise;
        }
      },
      
      /**
       * Pause the renderer
       *
       * @returns a promise that will be resolved when playback is paused, or rejected if the render's audio
       * context is in a non-active state
       */
      pause: function () {
        this.logger.debug("pause()");
        return this.renderer.pause(this.flashPlayback.id);
      },
      
      /**
       * Resume the renderer
       *
       * @returns a promise that will be resolved when playback is resumed, or rejected if the renderer's audio
       * context is in a non-active state
       */
      resume: function () {
        this.logger.debug("resume()");
        this.continuePlaying();
        return this.renderer.resume(this.flashPlayback.id);
      },
      
      /**
       * Gets the audio player's total time buffered in milliseconds.
       */
      getBufferTime: function () {
        var msecsToParse = this.buffersToParse.reduce(function(total,current) { return total + current.duration; },0);
        var msecsToDecode = this.accessUnitsToDecode.reduce(function(total,current) { return total + current.duration; },0);
        var msInRenderer = this.renderer.bufferTime;
        
        //this.logger.error("Buffer time = {0} {1} + {2}",[msecsInSink + msInRenderer,msecsInSink,msInRenderer]);
        
        return msecsToParse + msecsToDecode + msInRenderer;
      },
      
      
      
      isReady: function() {
        return this.hasSeenAtLeastOneChunk;
      },
      
      close: function(){
        //TODO : Need to revisit again- as SWFService is not removing the eventListeners properly
        this.renderer.removeEventListener(this.bufferUnderFlowEvent, this.onBufferUnderFlowHandler);
      },
      
      /**
       * Register a callback to be called when the renderer enters a certain state
       * NOTE : a callback can be registered multiple times, and must be deregistered for every time it is
       *        registered
       *
       * @param {String} state that the handler should be registered for
       * @param {function} handler will be called whenever the renderer enters (or transitions through) the
       * requested state
       */
      registerStateNotificationHandler: function (state, handler) {
        this.logger.debug("TODO registerStateNotificationHandler", state, handler);
        // this.renderer.registerStateNotificationHandler(state, handler);
      },
      
      /**
       * Deregister a callback from being called when a render request finishes.
       *
       * NOTE: If a callback is registered multiple times it must be deregistered multiple times.
       *
       * @param {String} state that the handler should be de-registered for
       * @param {function} handler will be de-registered for the given state
       */
      deregisterStateNotificationHandler: function (state, handler) {
        this.logger.debug("TODO deregisterStateNotificationHandler", state, handler);
        // this.renderer.deregisterStateNotificationHandler(state, handler);
      },
      
      /**
       * Register a callback to be called when an render request finishes playing on the Renderer.
       *
       * NOTE : a callback can be registered multiple times, and must be deregistered for every time it is
       *        registered
       *
       * @param {function} handler will be called whenever either buffer plays out or any buffer plays out if
       *   buffer is not specified
       */
      registerNotificationHandler: function (handler) {
        this.logger.debug("TODO registerNotificationHandler", handler);
        // this.renderer.registerNotificationHandler(handler);
      },
      
      /**
       * Deregister a callback from being called when a render request finishes.
       *
       * NOTE: If a callback is registered multiple times it must be deregistered multiple times.
       *
       * @param {function} handler will be deregistered from callback notification
       */
      deregisterNotificationHandler: function (handler) {
        this.logger.debug("TODO deregisterNotificationHandler", handler);
        // this.renderer.deregisterNotificationHandler(handler);
      },
      
      /**
       * Decode and render audio data.
       *
       * First, skip the ID3Tag (as it's not important to decoding) and copy the remaining data
       * into a new array buffer.
       *
       * Attempts to build the correct audio data container -- either use the incoming ADTS as is
       * or create an MP4 container. This conversion is performed in the AudioMuxer
       * object.
       *
       * Validates chunk data -- rejects the promise if invalid otherwise drops it
       * onto a queue for decoding at a later time.
       *
       * @param {Chunk} chunk - Chunk object that contains compressed AAC audio data.
       * @param {Boolean} reset - Flag indicating if the underlying audio player components
       * (like the decoder, muxer, etc) should be reset.
       * @return Promise that gets resolved as soon as the data is queued up for decode.
       */
      render: function (chunk, reset) {
        
        this.logger.debug("render( Chunk timestamp = {0} offset = {1} duration = {2} chunk = {3} )",
          [chunk.timestamp, chunk.offset, chunk.duration, chunk.fileName]);
        
        if (!chunk.data) { return Q.reject("Corrupted chunk detected. No audio data detected."); }
        
        
        
        var mediaBuffer;
        
        if (chunk.isMP4) {
          // Set the initial AAC audio data to the incoming chunks complete data, which should be parseable as MP4 data
          
          mediaBuffer = new MediaBuffer(chunk.data, chunk.duration, Codec.isAacPlus(chunk), true);
        }
        else {
          // Set the initial AAC audio data to the incoming media buffer's audio data sans
          // the prefixing ID3 tag; this means the new version of the data starts with the first ADTS
          // frame and not the ID3 tag.
          
          mediaBuffer = skipID3Tag(chunk);
        }
        
        this.buffersToParse.push({ mediaBuffer: mediaBuffer,
          reset : reset,
          lastBuffer : chunk.lastChunk,
          offset : chunk.offset,
          timestamp : chunk.timestamp,
          duration : chunk.duration ? chunk.duration * 1000 : 10000
        });
        
        this.hasSeenAtLeastOneChunk = true;
        
        this.continuePlaying();
        
        return Q.resolve(1);
        
        /**
         * Return the data after the ID3 tag (if it exists).  If there is no ID3 tag then no data is skipped
         *
         * @param mediaBuffer is the media buffer to search for the ID3 tag in
         * @returns array buffer with data after any ID3 tag that is detected at the start of the buffer
         */
        function skipID3Tag(chunk) {
          var mediaBuffer        = new MediaBuffer(chunk.data,
            chunk.duration,
            Codec.isAacPlus(chunk),
            chunk.isMP4);
          var id3TagEndByteIndex = AdtsFrame.skipID3TAG(mediaBuffer.bytes,0);
          
          if (id3TagEndByteIndex !== 0) {
            mediaBuffer.arrayBuffer = mediaBuffer.arrayBuffer.slice(id3TagEndByteIndex,mediaBuffer.length);
          }
          
          return mediaBuffer;
        }
      },
      
      /**
       * Reset the sink, which means close the decoder and null it out. Sink will no longer be usable after
       * doing this.
       *
       * @returns {Promise} A promise that will be resolved when the render has stopped all playback.
       */
      reset: function () {
        
        return Q.when(this)
          .finally(stopRenderer.bind(this))
          .fail(fault.bind(this));
  
        function stopRenderer() {
          this.logger.debug("reset( Sink decoder has been closed. )");
          return this.renderer.stop(this.flashPlayback.id);
        }
        
        function fault(fault) {
          this.logger.error("reset( Sink decoder failed to close or renderer failed to stop. Error: {0} )", [fault]);
          throw fault;
        }
      },
      
      crossfade: function(config, isTurnedOn) {
        if (!this.renderer) { return; }
        this.logger.debug(config, isTurnedOn);

        this.crossfadeOn = isTurnedOn === true;
      },
      
      isCrossfadeOn: function() {
        return this.crossfadeOn;
      },

      isCrossfadeSupported : function() {
        return false; // flash does not currently support crossfade
      }

    };
    
    return AdtsFlashAudioSink;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/sink/MpegAudioSink.js":
/*!**************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/sink/MpegAudioSink.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     AdtsAacAudioSink
 * @CREATED:    09/11/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * An object that represents a destination for compressed audio playback.
 */
/* beautify preserve:start */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require)
    {
        var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
        var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
        var EventDispatcher = __webpack_require__(/*! sxm/audioplayer/html5/event/EventDispatcher */ "./javascript/src/sxm/audioplayer/html5/event/EventDispatcher.js");
        var MediaBuffer = __webpack_require__(/*! sxm/audioplayer/html5/model/MediaBuffer */ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js");
        var AccessUnit = __webpack_require__(/*! sxm/audioplayer/html5/model/AccessUnit */ "./javascript/src/sxm/audioplayer/html5/model/AccessUnit.js");
        var AdtsFrame = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");
        var Codec = __webpack_require__(/*! sxm/audioplayer/html5/model/Codec */ "./javascript/src/sxm/audioplayer/html5/model/Codec.js");
        var AacDecoder = __webpack_require__(/*! sxm/audioplayer/html5/audio/decoder/AacDecoder */ "./javascript/src/sxm/audioplayer/html5/audio/decoder/AacDecoder.js");
        var AudioRenderer = __webpack_require__(/*! sxm/audioplayer/html5/audio/render/AudioRenderer */ "./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderer.js");
        var AudioContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js");
        var PlayerEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/PlayerEvent */ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js");
        var MP3File = __webpack_require__(/*! sxm/audioplayer/html5/protocols/mp4/MP3File */ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP3File.js");
        var AudioUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
        var Q = __webpack_require__(/*! q */ "q");

        var sinkNum = 0;

        //-----------------------------------------------------------------------
        // CONSTRUCTOR
        //-----------------------------------------------------------------------

        /**
         * Create an MpegAudioSink
         *
         * @param {Object} sinkID will be used in the logging for the sink to allow the logs from different sinks
         *                 to be distinguished from each other.
         * @param {Object} feeder is a object with a method called feedAnotherChunk that can be called when the sink needs
         *                 more data
         *
         * @returns {Object} results from calling continuePlaying again
         */
        function MpegAudioSink(sinkID, feeder) {

            // Extend this object with event dispatching capabilities
            EventDispatcher.apply(this);

            this._decodeWhenPaused = true;

            //-----------------------------------------------------------------------
            // CLASS MEMBERS
            //-----------------------------------------------------------------------

            /**
             * The unique name for the sink.
             * @type {String}
             */
            this.sinkName = "AudioSink:";

            if (!sinkID) {
                this.sinkName += sinkNum++;
                sinkNum = sinkNum % 1000;
            }
            else {
                this.sinkName += sinkID;
            }

            this.logger = LoggerFactory.getLogger(this.sinkName, "CORE");

            /**
             * AAC Decoder object for decoding AAC.
             * @type {AacDecoder}
             */
            this.decoder = new AacDecoder(true);

            this.isMp3 = false;

            /**
             * Audio Render object for rendering audio.
             * @type {AudioRenderer}
             *
             * WC-8190 : for small tracks on MyMix (interstitials), we can see chunks that are 1 second in length.
             * In order to be able to render these smaller chunks, we need to change the size of the render buffers
             * from the default, which is 1000 ms, to MS_PER_RENDER_BUFFER so that we can play these smaller chunks.
             *
             * In addition, since our render buffers are smaller, we up the number of in-flight (ready for render)
             * buffers that we use in the renderer from the default of 2 to IN_FLIGHT_RENDER_BUFFERS, so that we can
             * tolerate the javascript thread in the execution environment getting blocked for longer periods of time.
             *
             * Finally, we do not want to have to buffer all the preflight buffers before we can start playing, so
             * we tell the audio renderer it should have PREBUFFER_BUFFERS of audio available before it can start
             *
             * For explanation of the constant values themselves, see the documentation for MpegAudioSink.CONSTS
             */
            this.renderer = new AudioRenderer(sinkID, MpegAudioSink.CONSTS.MS_PER_RENDER_BUFFER,
                MpegAudioSink.CONSTS.IN_FLIGHT_RENDER_BUFFERS,
                MpegAudioSink.CONSTS.PREBUFFER_BUFFERS);

            /**
             * An array that contains parser "buffers" that can be used to get the frames for creating access units.
             * @type {AudioContext}
             */
            this.buffersToParse = [];

            /**
             * An array that contains acesss units that need to be decoded
             * @type {AudioContext}
             */
            this.accessUnitsToDecode = [];

            /**
             * An array that contains AdtsFrame objects that need to be renderer
             * @type {AudioContext}
             */
            this.accessUnitsToRender = [];

            /**
             * An array that contains AdtsFrame objects that need to be renderer
             * @type {Object} access unit descriptor for the access unit that is currently being rendered
             */
            this.currentAccessUnit = null;

            /**
             * A flag that is set to true once at least one chunk has been passed into the sink
             * @type {Boolean}
             */
            this.hasSeenAtLeastOneChunk = false;

            /**
             * Handler that gets called every time the renderer renders a buffer.  Checks to see if we need to feed
             * the renderer with more data
             *
             * @param {ArrayBuffer} buffer is the buffer that was played
             * @returns {Object} results from calling continuePlaying again
             */
            this.renderer.registerNotificationHandler(function () {

                if (this.decoder !== null && this.renderer.state === AudioRenderer.AUDIO_CONTEXT_STATE.RUNNING) {
                    return this.continuePlaying();
                }

                return Q.reject(AacDecoder.CONSTS.CLOSED);
            }.bind(this));

            /**
             * Feeder that implements a method feedMoreBytes().
             *
             */
            this.feeder = feeder;

            this.feederPromise = Q.when(5);

            this._framesToPrepend = {
                numFrames: 0,
                // eslint-disable-next-line no-undef
                arrayBuffer: new ArrayBuffer()
            };

            /**
             * Indicates if the decoder is still decoding the last audio chunk.
             * @type {Boolean}
             */
            Object.defineProperty(this, "isDecoding",
                {
                    get: function () {
                        return (!!this.currentAccessUnit && (this.currentAccessUnit.decodeStarted === true));
                    }
                });

            Object.defineProperty(this,"decodeWhenPaused",
                {
                    get : function () { return this._decodeWhenPaused; },
                    set : function (value) { this._decodeWhenPaused = value; }
                });

            /**
             * IIFE ALERT!!!!
             *
             * continuePlaying will get populated with what the function below returns, which is a function to do the work
             * of keeping audio playback going.
             *
             * The function below gets passed this, and thus can provide the this reference (called) self as a closure.
             * This allow basic functions (that are more likely to be effectively JITed) to be used in the promise chain that
             * deals with the details of playing audio.
             *
             * This is done in the constructor rather than the object prototype below so much of this can be kept private to
             * the function below.  Don't want the outside world using these functions since they are only intended for
             * internal use by this ONE function
             */
            this.continuePlaying = (function (self) {

                /**
                 * Check to see if the renderer is running low on data and there are access units to decode.
                 *
                 * If so, the function will queue up an access unit for decoding/rendering/finalization, and repeat the
                 * cycle.
                 *
                 * If the renderer does not need data or there is no access unit available for processing, then the function
                 * waits on the renderer's onPlayed promise and will call itself the next time a buffer has rendered.
                 **
                 * @param accessUnit is passed through this function so that it can be used in the promise chain below
                 *        to ensure that the renderer is kept fed with data as access units are decoded
                 */
                return function() {
                    if (!self.decoder) {
                        self.logger.warn("No decoder present ( decoder = {0}), buffer will be deferred",[self.decoder]);
                        return;
                    }

                    self.logger.debug("Renderer has {0} buffers needs {1} buffers there are {2} buffers to be decoded left",
                        [self.renderer.numBuffers,self.renderer.inFlightBuffers * 2,self.buffersToParse.length]);

                    if (self.buffersToParse.length > 0
                        && (self.renderer.numBuffers < (self.renderer.inFlightBuffers * 2))
                        && (self.isDecoding === false)
                        && (self.state === MpegAudioSink.AUDIO_CONTEXT_STATE.RUNNING || self._decodeWhenPaused === true)) {


                        self.logger.debug("Getting an access unit to decode there are {0} buffers available",
                            [self.buffersToParse.length]);

                        var auDescriptor = (self.buffersToParse) ? findAccessUnitToDecode(self.buffersToParse) : null;

                        if (auDescriptor) {
                            decodeAccessUnit(auDescriptor).then(accessUnitDecoded)
                                .then(feedPCM)
                                .then(accessUnitRendered)
                                .fail(function(fault) { return failureHandler(fault,auDescriptor); });


                            self.currentAccessUnit     = auDescriptor;
                            auDescriptor.decodeStarted = true;
                        }

                    }
                    else if (self.feeder) {
                        if (self.feeder.isEnded === false && self.buffersToParse.length === 0) {
                            self.logger.debug("No more buffers to parse getting another chunk");
                            if (self.feederPromise.isFulfilled() || self.feederPromise.isRejected()) {
                                self.feederPromise = self.feeder.feedMoreChunks();
                            }
                        } else if (self.feeder.isEnded === true) { self.feeder = null; }
                    }
                };

                /**
                 * Search through the buffers available for parsing to get the next access unit available for decoding.
                 *
                 * @param buffersToParse list of buffers that can be parsed for access units
                 *
                 * @returns access unit descriptor with an access unit ready for decoding.
                 */
                function findAccessUnitToDecode(buffersToParse) {
                    var auDescriptor;
                    var buffer = buffersToParse.shift();

                    if (buffer)
                    {
                        auDescriptor = getAccessUnit(buffer);
                    }

                    return auDescriptor;

                    /**
                     * Take the given buffer to parse, and parse an access unit from it.
                     *
                     * @param bufferToParse contains the parser that can be used to parse access units from an available buffer
                     *
                     * @returns an access unit descriptor with data ready to decode, or undefined if the current buffer to parse
                     *          has no more data to create access units from
                     */
                    function getAccessUnit(bufferToParse) {

                        self.logger.debug("Got a buffer to decode timestamp = {0} lastbuffer = {1}",
                            [bufferToParse.timestamp,bufferToParse.lastBuffer]);

                        var parsedMediaBufferData = parseMediaBuffer(bufferToParse.mediaBuffer);

                        var numFrames = parsedMediaBufferData.numFrames;
                        var samples = parsedMediaBufferData.samples;
                        var samplesPerFrame = parsedMediaBufferData.samplesPerFrame;
                        var samplerate = parsedMediaBufferData.samplerate;
                        
                        var sacrificialSamples = 0;

                        if (self._framesToPrepend.numFrames === 0) {
                            sacrificialSamples = samples;
                        } else {
                            sacrificialSamples = self._framesToPrepend.numFrames * samplesPerFrame;
                        }

                        var playDurationData = getPlayDuration(numFrames + self._framesToPrepend.numFrames, sacrificialSamples, samplerate, samplesPerFrame);
                        var playDuration = playDurationData.playDuration;
                        var duration = playDurationData.duration;
                        
                        var mpegFrames = bufferToParse.mediaBuffer.arrayBuffer.slice(0);
                        var arrayBufferAfterPrepend = AudioUtil.concatArrayBuffers([self._framesToPrepend.arrayBuffer, mpegFrames]);

                        var muxerResult = {
                            arrayBuffer: arrayBufferAfterPrepend,
                            duration: duration,
                            endByteIndex: arrayBufferAfterPrepend.byteLength,
                            fileName: "sxm-mpeg.mp3",
                            isAACPlus: false,
                            playDuration: playDuration,
                            sacrificialSamples: sacrificialSamples,
                            startByteIndex: 0
                        };

                        self._framesToPrepend = {
                            numFrames: numFrames,
                            arrayBuffer: mpegFrames
                        };

                        // Get the next audio descriptor and prepare it for decoding.
                        var auDescriptor = getAccessUnitDescriptor(muxerResult,
                            bufferToParse.offset,
                            bufferToParse.timestamp,
                            bufferToParse.lastBuffer);

                        return auDescriptor;


                        function parseMediaBuffer(mediaBuffer) {
                            var mp3File = new MP3File(mediaBuffer);
                            var mp3Boxes = mp3File.mp3Boxes;

                            if (mp3Boxes.length > 0) {
                                var numFrames = mp3Boxes.length;
                                var samplesPerFrame = mp3Boxes[0].num_samples;
                                var samplerate = mp3Boxes[0].samplerate;
                                var samples = numFrames * samplesPerFrame;
                                return {
                                    numFrames: numFrames,
                                    samples: samples,
                                    samplesPerFrame: samplesPerFrame,
                                    samplerate: samplerate
                                };
                            }
                            return null;
                        }

                        function getPlayDuration(numFrames, numSacrificialSamples, samplerate, samplesPerFrame) {
                            var frameDuration = samplesPerFrame / samplerate;
                            var sacrificialFrames = numSacrificialSamples / samplesPerFrame;
                            var playDuration = (numFrames > sacrificialFrames) ? (numFrames - sacrificialFrames) * frameDuration :
                                numFrames * frameDuration;
                            return {
                                playDuration: playDuration,
                                duration: numFrames * frameDuration
                            };
                        }

                        /**
                         * Get a new access unit descriptor for audio frame data
                         *
                         * @param audioFrames contains the audio data to create the descriptor from
                         * @param offset in seconds to trim off the start of the pcm before playback
                         * @param timestamp playback timestamp for the start of the samples
                         * @param lastBuffer is true if this is the final buffer available for playback
                         *
                         * @returns {Object} a new access unit descriptor, or null if one could not be created because setBytes
                         *   failed
                         */
                        function getAccessUnitDescriptor(audioFrames,offset,timestamp,lastBuffer) {
                            var accessUnit = new AccessUnit(audioFrames.isAACPlus);

                            if (accessUnit.setBytes(audioFrames.arrayBuffer,
                                audioFrames.startByteIndex,
                                audioFrames.endByteIndex,
                                audioFrames.sacrificialSamples,
                                timestamp,
                                offset,
                                audioFrames.duration,
                                audioFrames.isAACPlus) < 0) {
                                return null;
                            }

                            return {
                                startIndex      : audioFrames.startByteIndex,
                                decodeStarted   : false,
                                renderStarted   : false,
                                accessUnit      : accessUnit,
                                duration        : audioFrames.duration,
                                dfd             : null,
                                resolveOnDecode : false,
                                lastAccessUnit  : lastBuffer
                            };
                        }
                    }
                }

                /**
                 * Take an access unit descriptor and add it to the list of access units to decode and start the decode
                 * processs
                 *
                 * @param auDescriptor is the access unit descriptor to start decoding
                 *
                 * @returns {*|Promise} that will be resolved/rejected once the decode has succeeded or failed
                 */
                function decodeAccessUnit(auDescriptor) {

                    self.accessUnitsToDecode.push(auDescriptor);

                    self.logger.debug("Renderer has {0} buffers needs {1} buffers decode some audio",
                        [self.renderer.numBuffers,self.renderer.inFlightBuffers * 2]);

                    //TODO : Need to findout more about this
                    var doubledAudioThreshold = null;

                    return self.decoder
                        .decode(auDescriptor.accessUnit.frameData,
                            auDescriptor.accessUnit.samplesToTrim,
                            auDescriptor.accessUnit.aacPlus,
                            doubledAudioThreshold,
                            auDescriptor.lastAccessUnit);
                }

                /**
                 * Promise resolution handler for when an access unit gets decoded.  Since we only pass the
                 * compressed bitstream to the decoder, this function will put the decoded pcm into the access
                 * unit object that the bitstream came from
                 *
                 * @param {ArrayBuffer} pcmData is the pcm for the last access unit to be decoded
                 * @returns {Object} the accessUnit object for the pcm data
                 */
                function accessUnitDecoded(pcmData) {

                    if (!self.decoder) { return Q.reject(AudioContext.CONSTS.CLOSED); }

                    self.logger.debug("accessUnitDecoded( Finished decoding an access unit {0} seconds of audio produced)",
                        [pcmData.duration]);

                    var auDescriptor = self.accessUnitsToDecode.shift();

                    if (auDescriptor.resolveOnDecode === true && auDescriptor.dfd !== null) {
                        auDescriptor.dfd.resolve(auDescriptor.accessUnit.timestamp);
                        auDescriptor.dfd = null;
                    }

                    auDescriptor.renderStarted = true;
                    auDescriptor.decodeStarted = false;
                    auDescriptor.frameData = null;

                    auDescriptor.accessUnit.setPCM(pcmData);
                    self.accessUnitsToRender.push(auDescriptor);
                    self.currentAccessUnit = null;
                    return auDescriptor.accessUnit;
                }

                /**
                 * Feed PCM from a decoded access unit into the renderer.  After the render is fed this function will take
                 * another pass at continuePlaying in case the renderer still needs more data to avoid underflow or to
                 * actually start rendering
                 *
                 * @param accessUnit
                 * @returns {*|promise}
                 */
                function feedPCM(accessUnit)
                {
                    self.logger.debug("feedPcm( feeded decoded access unit to renderer. )");

                    var feedResult = self.renderer.feedPCM(accessUnit);

                    self.logger.debug("feedPcm(Renderer now has {0} buffers needs {1} buffers)",
                        [self.renderer.numBuffers,self.renderer.inFlightBuffers * 2]);

                    accessUnit.clearBytes();

                    // Update the flag once we have actually fed pcm to renderer instead when we get 1st chunk, as in low network
                    // conditions We are checking the feed before buffer actually rendered and we have the context state suspended
                    self.hasSeenAtLeastOneChunk = true;

                    self.continuePlaying();

                    return feedResult;
                }

                /**
                 * Promise resolution handler for when an access unit gets rendered. This method will take the
                 * access unit off the list of access units to be rendered
                 *
                 * @param {Object} buffer is the last buffer that was rendered by the renderer, or undefined if
                 *                 nothing has been rendered yet.
                 * @returns {Object} buffer that was passed to the function for usage further down the promise chain
                 */
                function accessUnitRendered(buffer) {

                    self.logger.debug("accessUnitRendered( Access unit has been rendered. )");

                    var auDescriptor = (self.accessUnitsToRender) ? self.accessUnitsToRender.shift() : null;

                    if (auDescriptor && auDescriptor.dfd !== null) {
                        auDescriptor.decodeStarted = auDescriptor.renderStarted = false;
                        auDescriptor.dfd.resolve(auDescriptor.accessUnit.timestamp);
                        auDescriptor.dfd = null;
                    }

                    return buffer;
                }

                /**
                 * Promise failure handler for when the decode/render promise chain throws an error
                 *
                 * @param {Object} fault is the fault that is being reported
                 * @param {Object} auDescriptor is the descriptor for the access unit that failed;
                 * @returns {Promise} a rejected promise that will pass the fault upstream
                 */
                function failureHandler(fault, auDescriptor) {
                    fault = fault.message || fault;

                    var logFunc = (fault !== AudioContext.CONSTS.CLOSED)
                        ? self.logger.error.bind(self.logger)
                        : self.logger.debug.bind(self.logger);
                    var logString = "continuePlaying general failure {0}";

                    if (fault === PlayerEvent.DECODER_FAILURE) {
                        // Event dispatcher was mixed in during object construction (EventDispatcher.applu), so we can do this
                        self.dispatchEvent({type: PlayerEvent.DECODER_FAILURE});
                    }

                    auDescriptor.accessUnit.clearBytes();

                    var accessUnitArray;

                    if (auDescriptor.decodeStarted === true) {
                        if (auDescriptor.renderStarted === false) {
                            logString       = "continuePlaying decode failure {0}";
                            accessUnitArray = self.accessUnitsToDecode;
                        }
                        else {
                            logString = "continuePlaying render failure {0}";
                            accessUnitArray = self.accessUnitsToRender;
                        }
                    }
                    else {
                        accessUnitArray = [];
                    }

                    logFunc(logString,[fault]);

                    var indexToRemove = accessUnitArray.indexOf(auDescriptor);
                    if (indexToRemove >= 0) { accessUnitArray.splice(indexToRemove, 1); }

                    return Q.reject(fault);
                }
            })(this); // call lambda, create closure, return actual function for continuePlaying

            ClassUtils.bind(this, MpegAudioSink);
        };

        //-----------------------------------------------------------------------
        // STATIC MEMBERS
        //-----------------------------------------------------------------------

        /**
         * This is a convenience member that is just set to be the same as AudioContext's AUDIO_CONTEXT_STATE.
         * This allows comparing of the state property (defined below in the prototype) with the possible
         * values from the renderers AudioContext parent class.
         *
         * @type {Object}
         */
        MpegAudioSink.AUDIO_CONTEXT_STATE = AudioRenderer.AUDIO_CONTEXT_STATE;

        /**
         * This is a convenience member that is just set to be the same as AudioRender.STATE.
         * This allows registering with the sink for audio render state changes
         *
         * @type {Object}
         */
        MpegAudioSink.RENDERER_STATES = AudioRenderer.STATE;

        /**
         * Hash of sink states.
         * @type {Object}
         */
        MpegAudioSink.STATES = {
            STOPPED: "stopped",
            STARTED: "started",
            PAUSED: "paused",
            KILLED: "dead"
        };

        /**
         * Hash of enumerated values describing constants for the AudioSink class.
         * @type {Object}
         */
        MpegAudioSink.CONSTS = {
            ADTS_MS_PER_ACCESS_UNIT: 0,
            ADTS_FRAMES_PER_ACCESS_UNIT: 210, // # of ADTS frames that comprise an atomic access unit
            MS_PER_RENDER_BUFFER: 250, // 250 ms buffers means we can play chunks as small as 500 ms
            PREBUFFER_BUFFERS: 1,   // need to have 250ms in buffer to start rendering
            IN_FLIGHT_RENDER_BUFFERS: 32    // 8 in-flight buffers means that we have 2s of audio ready to play
        };

        MpegAudioSink.CONSTS.ADTS_MS_PER_ACCESS_UNIT =
            AdtsFrame.CONSTS.ADTS_MS_PER_FRAME * MpegAudioSink.CONSTS.ADTS_FRAMES_PER_ACCESS_UNIT;

        //----------------------------------------------------------------------------------------------------------
        // PROTOTYPE Add MpegAudioSink prototype and restore constructor
        //----------------------------------------------------------------------------------------------------------

        ClassUtils.baseClass(MpegAudioSink).prototype = {

            /**
             * Get or set the volume for the object
             *
             * @param (Number) volume (between 0 and 100) to set the renderer output to
             * @return {Number} volume value from the renderer
             */
            volume : ClassUtils.createPropertyDescriptor(
                {
                    get : function() {
                        if (!this.renderer) {
                            return NaN;
                        }
                        return this.renderer.volume;
                    },
                    set : function(volume) {
                        this.logger.debug("volume( {0} )",[volume]);
                        this.renderer.volume = volume;
                    }
                }),

            /**
             * The (AudioContext) state of the renderer
             *
             * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
             *
             * @return {Number} value of this.buffers.length
             */
            state : ClassUtils.createPropertyDescriptor(
                {
                    get : function() {
                        return this.renderer.state;
                    }
                }),

            /**
             * The (AudioContext) state change handler
             *
             * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
             *
             * Set this property with a function and that function will be called whenever the state of the
             * renderer's underlying audio context changes.
             */
            stateChangeHandler : ClassUtils.createPropertyDescriptor(
                {
                    set : function(handler) {

                        var self = this;

                        this.renderer.stateChangeHandler = function() {
                            if (handler && typeof handler === "function") {
                                handler(self.renderer.state);
                            }
                        };
                    }
                }),

            /**
             * The (boolean) value that determines if the sink starts playing automatically
             *
             * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
             *
             * @return {Number} value of this.buffers.length
             */
            autoStart : ClassUtils.createPropertyDescriptor(
                {
                    get : function() {
                        return this.renderer.autoStart;
                    },
                    set : function(value) {
                        this.logger.debug("autoStart( {0} )",[String(value)]);
                        this.renderer.autoStart = value;
                    }
                }),

            /**
             * Stop the Sink from rendering.  Once the Sink has stopped, if it is in the paused
             * state (AudioContext.AUDIO_CONTEXT_STATE.SUSPENDED) it will be resumed.  This is in case the
             * renderer is using the global audio context, we do not leave the audio context in the paused
             * state.
             *
             * @returns {Promise} a promise that will be resolved when the render has stopped all playback
             */
            stop: function() {

                this.logger.debug("stop( Audio Sink being asked to stop. )");

                return this.reset()
                    .then(completeRendering.bind(this))
                    .then(cleanup.bind(this));

                function completeRendering() {
                    return this.renderer.close();
                }

                function cleanup(promise) {
                    this.logger.debug("cleanup( Audio Sink has stopped and all internals reset. )");

                    // Remove any callbacks.
                    this.renderer.stateChangeHandler = null;

                    // Null out all internals so they're ready for GC.
                    this.sinkName            = null;
                    this.decoder             = null;
                    this.renderer            = null;
                    this.accessUnitsToDecode = null;
                    this.accessUnitsToRender = null;
                    this.currentAccessUnit   = null;

                    return promise;
                }
            },

            /**
             * Pause the renderer
             *
             * @returns a promise that will be resolved when playback is paused, or rejected if the render's audio
             * context is in a non-active state
             */
            pause: function () {
                this.logger.debug("pause()");
                return this.renderer.pause();
            },

            /**
             * Resume the renderer
             *
             * @returns a promise that will be resolved when playback is resumed, or rejected if the renderer's audio
             * context is in a non-active state
             */
            resume: function () {
                var self = this;
                this.logger.debug("resume()");

                return this.renderer.resume()
                    .then(function(result) {
                        self.continuePlaying();
                        return result;
                    });
            },

            /**
             * Gets the audio player's total time buffered in milliseconds.
             */
            getBufferTime: function () {
                var msecsToParse = this.buffersToParse.reduce(function(total,current) { return total + current.duration; },0);
                var msecsToDecode = this.accessUnitsToDecode.reduce(function(total,current) { return total + current.duration; },0);
                var msInRenderer = this.renderer.buffers.length * this.renderer.msPerBuffer;
                var msInOrphanedPcm = this.renderer.orphanedPcm ? this.renderer.orphanedPcm.duration : 0;

                //this.logger.error("Buffer time = {0} {1} + {2}",[msecsInSink + msInRenderer,msecsInSink,msInRenderer]);

                return msecsToParse + msecsToDecode + msInRenderer + msInOrphanedPcm;
            },



            isReady: function() {
                return this.hasSeenAtLeastOneChunk;
            },

            /**
             * Register a callback to be called when the renderer enters a certain state
             * NOTE : a callback can be registered multiple times, and must be deregistered for every time it is
             *        registered
             *
             * @param {String} state that the handler should be registered for
             * @param {function} handler will be called whenever the renderer enters (or transitions through) the
             * requested state
             */
            registerStateNotificationHandler: function (state, handler) {
                this.renderer.registerStateNotificationHandler(state, handler);
            },

            /**
             * Deregister a callback from being called when a render request finishes.
             *
             * NOTE: If a callback is registered multiple times it must be deregistered multiple times.
             *
             * @param {String} state that the handler should be de-registered for
             * @param {function} handler will be de-registered for the given state
             */
            deregisterStateNotificationHandler: function (state, handler) {
                this.renderer.deregisterStateNotificationHandler(state, handler);
            },

            /**
             * Register a callback to be called when an render request finishes playing on the Renderer.
             *
             * NOTE : a callback can be registered multiple times, and must be deregistered for every time it is
             *        registered
             *
             * @param {function} handler will be called whenever either buffer plays out or any buffer plays out if
             *   buffer is not specified
             */
            registerNotificationHandler: function (handler) {
                this.renderer.registerNotificationHandler(handler);
            },

            /**
             * Deregister a callback from being called when a render request finishes.
             *
             * NOTE: If a callback is registered multiple times it must be deregistered multiple times.
             *
             * @param {function} handler will be deregistered from callback notification
             */
            deregisterNotificationHandler: function (handler) {
                this.renderer.deregisterNotificationHandler(handler);
            },

            /**
             * Decode and render audio data.
             *
             * First, skip the ID3Tag (as it's not important to decoding) and copy the remaining data
             * into a new array buffer.
             *
             * Attempts to build the correct audio data container -- either use the incoming ADTS as is
             * or create an MP4 container. This conversion is performed in the AudioMuxer
             * object.
             *
             * Validates chunk data -- rejects the promise if invalid otherwise drops it
             * onto a queue for decoding at a later time.
             *
             * @param {Chunk} chunk - Chunk object that contains compressed AAC audio data.
             * @param {Boolean} reset - Flag indicating if the underlying audio player components
             * (like the decoder, muxer, etc) should be reset.
             * @return Promise that gets resolved as soon as the data is queued up for decode.
             */
            render: function (chunk, reset) {

                this.logger.debug("render( Chunk timestamp = {0} offset = {1} duration = {2} chunk = {3} )",
                    [chunk.timestamp, chunk.offset, chunk.duration, chunk.fileName]);

                if (!chunk.data) { return Q.reject("Corrupted chunk detected. No audio data detected."); }



                var mediaBuffer;

                if(chunk.codec === 'mp3')
                {
                    this.isMp3 = true;
                }
                if (chunk.isMP4) {
                    // Set the initial AAC audio data to the incoming chunks complete data, which should be parseable as MP4 data

                    mediaBuffer = new MediaBuffer(chunk.data, chunk.duration, Codec.isAacPlus(chunk), true);
                }
                else {
                    // Set the initial AAC audio data to the incoming media buffer's audio data sans
                    // the prefixing ID3 tag; this means the new version of the data starts with the first ADTS
                    // frame and not the ID3 tag.

                    mediaBuffer = skipID3Tag(chunk);
                }

                this.buffersToParse.push({ mediaBuffer: mediaBuffer,
                    reset : reset,
                    lastBuffer : chunk.lastChunk,
                    offset : chunk.offset,
                    timestamp : chunk.timestamp,
                    duration : chunk.duration ? chunk.duration * 1000 : 10000
                });

                // this.hasSeenAtLeastOneChunk = true;

                this.continuePlaying();

                return Q.resolve(1);

                /**
                 * Return the data after the ID3 tag (if it exists).  If there is no ID3 tag then no data is skipped
                 *
                 * @param mediaBuffer is the media buffer to search for the ID3 tag in
                 * @returns array buffer with data after any ID3 tag that is detected at the start of the buffer
                 */
                function skipID3Tag(chunk) {
                    var mediaBuffer        = new MediaBuffer(chunk.data,
                        chunk.duration,
                        Codec.isAacPlus(chunk),
                        chunk.isMP4);
                    var id3TagEndByteIndex = AdtsFrame.skipID3TAG(mediaBuffer.bytes,0);

                    if (id3TagEndByteIndex !== 0) {
                        mediaBuffer.arrayBuffer = mediaBuffer.arrayBuffer.slice(id3TagEndByteIndex,mediaBuffer.length);
                    }

                    return mediaBuffer;
                }
            },

            /**
             * Reset the sink, which means close the decoder and null it out. Sink will no longer be usable after
             * doing this.
             *
             * @returns {Promise} A promise that will be resolved when the render has stopped all playback.
             */
            reset: function () {

                this.feeder = null;

                if (this.decoder) {
                    var decoder = this.decoder;
                    this.decoder = null;

                    return decoder.close()
                        .finally(stopRenderer.bind(this))
                        .fail(fault.bind(this));
                }

                return Q.when(true);

                function stopRenderer() {
                    this.logger.debug("reset( Sink decoder has been closed. )");
                    return this.renderer.stop();
                }

                function fault(fault) {
                    this.logger.error("reset( Sink decoder failed to close or renderer failed to stop. Error: {0} )", [fault]);
                    throw fault;
                }
            },

            crossfade: function(config, isTurnedOn) {
                if (!this.renderer) { return; }

                this.renderer.crossfade(config, isTurnedOn);
            },

            isCrossfadeOn: function() {
                if (!this.renderer) { return false; }

                return this.renderer.isCrossfadeOn();
            },

            isCrossfadeSupported: function() {
                if (!this.renderer) { return false; }

                return this.renderer.isCrossfadeSupported();
            }
        };

        return MpegAudioSink;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/audio/sink/MpegFlashAudioSink.js":
/*!*******************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/audio/sink/MpegFlashAudioSink.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     AdtsAacAudioSink
 * @CREATED:    09/11/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * An object that represents a destination for compressed audio playback.
 */
/* beautify preserve:start */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require)
    {
        var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
        var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
        var EventDispatcher = __webpack_require__(/*! sxm/audioplayer/html5/event/EventDispatcher */ "./javascript/src/sxm/audioplayer/html5/event/EventDispatcher.js");
        var AdtsFrame = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");
        var AudioRenderer = __webpack_require__(/*! sxm/audioplayer/html5/audio/render/AudioRenderer */ "./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderer.js");
        var Q = __webpack_require__(/*! q */ "q");

        var sinkNum = 0;

        //-----------------------------------------------------------------------
        // CONSTRUCTOR
        //-----------------------------------------------------------------------

        /**
         * Create an MpegFlashAudioSink
         *
         * @param {Object} sinkID will be used in the logging for the sink to allow the logs from different sinks
         *                 to be distinguished from each other.
         * @param {Object} feeder is a object with a method called feedAnotherChunk that can be called when the sink needs
         *                 more data
         *
         * @returns {Object} results from calling continuePlaying again
         */
        function MpegFlashAudioSink(sinkID, feeder, renderer) {

            // Extend this object with event dispatching capabilities
            EventDispatcher.apply(this);

            //-----------------------------------------------------------------------
            // CLASS MEMBERS
            //-----------------------------------------------------------------------

            /**
             * The unique name for the sink.
             * @type {String}
             */
            this.sinkName = "AudioSink:";

            if (!sinkID) {
                this.sinkName += sinkNum++;
                sinkNum = sinkNum % 1000;
            }
            else {
                this.sinkName += sinkID;
            }

            /**
             * Feeder that implements a method feedMoreBytes().
             *
             */
            this.feeder = feeder;

            /**
             * The renderer object.
             * @type {Function}
             */

            this.renderer = renderer;

            this.flashPlayback = this.renderer.createPlayback(feeder.configuration);

            //Handle the IO_ERROR for invalid tokens
            this.ioErrorEventType = 'IO_ERROR_'+ this.flashPlayback.id;
            this.ioError = function (event) {
                this.logger.debug("Event : {0} {2}",[this.ioErrorEventType, event]);
                this.feeder.tokenRefresh();
            };
            this.ioErrorEventHandler = this.ioError.bind(this);
            this.renderer.addEventListener(this.ioErrorEventType, this.ioErrorEventHandler);

            this.logger = LoggerFactory.getLogger(this.sinkName, "CORE");
            this.logger.debug("Constructor()");

            ClassUtils.bind(this, MpegFlashAudioSink);
        };

        //-----------------------------------------------------------------------
        // STATIC MEMBERS
        //-----------------------------------------------------------------------

        /**
         * This is a convenience member that is just set to be the same as AudioContext's AUDIO_CONTEXT_STATE.
         * This allows comparing of the state property (defined below in the prototype) with the possible
         * values from the renderers AudioContext parent class.
         *
         * @type {Object}
         */
        MpegFlashAudioSink.AUDIO_CONTEXT_STATE = AudioRenderer.AUDIO_CONTEXT_STATE;

        /**
         * This is a convenience member that is just set to be the same as AudioRender.STATE.
         * This allows registering with the sink for audio render state changes
         *
         * @type {Object}
         */
        MpegFlashAudioSink.RENDERER_STATES = AudioRenderer.STATE;

        /**
         * Hash of sink states.
         * @type {Object}
         */
        MpegFlashAudioSink.STATES = {
            STOPPED: "stopped",
            STARTED: "started",
            PAUSED: "paused",
            KILLED: "dead"
        };

        /**
         * Hash of enumerated values describing constants for the AudioSink class.
         * @type {Object}
         */
        MpegFlashAudioSink.CONSTS = {
            ADTS_MS_PER_ACCESS_UNIT: 0,
            ADTS_FRAMES_PER_ACCESS_UNIT: 210, // # of ADTS frames that comprise an atomic access unit
            MS_PER_RENDER_BUFFER: 250, // 250 ms buffers means we can play chunks as small as 500 ms
            PREBUFFER_BUFFERS: 1,   // need to have 250ms in buffer to start rendering
            IN_FLIGHT_RENDER_BUFFERS: 32    // 8 in-flight buffers means that we have 2s of audio ready to play
        };

        MpegFlashAudioSink.CONSTS.ADTS_MS_PER_ACCESS_UNIT =
            AdtsFrame.CONSTS.ADTS_MS_PER_FRAME * MpegFlashAudioSink.CONSTS.ADTS_FRAMES_PER_ACCESS_UNIT;

        //----------------------------------------------------------------------------------------------------------
        // PROTOTYPE Add MpegFlashAudioSink prototype and restore constructor
        //----------------------------------------------------------------------------------------------------------

        ClassUtils.baseClass(MpegFlashAudioSink).prototype = {

            /**
             * Get or set the volume for the object
             *
             * @param (Number) volume (between 0 and 100) to set the renderer output to
             * @return {Number} volume value from the renderer
             */
            volume : ClassUtils.createPropertyDescriptor(
                {
                    get : function() {
                        if (!this.renderer) {
                            return NaN;
                        }
                        return this.renderer.volume;
                    },
                    set : function(volume) {
                        this.logger.debug("volume( {0} )",[volume]);
                        this.renderer.volume = volume;
                    }
                }),
            /**
             * Get or set the volume for the object
             *
             * @param (Number) volume (between 0 and 100) to set the renderer output to
             * @return {Number} volume value from the renderer
             */
            crossfadeOn : ClassUtils.createPropertyDescriptor((function() {
                var _crossFadeOn = false;
                return {
                    get : function() {
                        return _crossFadeOn;
                    },
                    set : function(flag) {
                        _crossFadeOn = flag;
                    }
                };
            })()),

            /**
             * The (AudioContext) state of the renderer
             *
             * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
             *
             * @return {Number} value of this.buffers.length
             */
            state : ClassUtils.createPropertyDescriptor(
                {
                    get : function() {
                        return this.renderer.state.name;
                    }
                }),

            /**
             * The (AudioContext) state change handler
             *
             * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
             *
             * Set this property with a function and that function will be called whenever the state of the
             * renderer's underlying audio context changes.
             */
            stateChangeHandler : ClassUtils.createPropertyDescriptor(
                {
                    set : function(handler) {

                        var self = this;

                        this.renderer.stateChangeHandler = function() {
                            if (handler && typeof handler === "function") {
                                handler(self.renderer.state);
                            }
                        };
                    }
                }),

            /**
             * The (boolean) value that determines if the sink starts playing automatically
             *
             * https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/state
             *
             * @return {Number} value of this.buffers.length
             */
            autoStart : ClassUtils.createPropertyDescriptor(
                {
                    get : function() {
                        return this.renderer.autoStart;
                    },
                    set : function(value) {
                        this.logger.debug("autoStart( {0} )",[String(value)]);
                        this.renderer.updateAutoStart(this.flashPlayback.id, value);
                    }
                }),

            /**
             * Stop the Sink from rendering.  Once the Sink has stopped, if it is in the paused
             * state (AudioContext.AUDIO_CONTEXT_STATE.SUSPENDED) it will be resumed.  This is in case the
             * renderer is using the global audio context, we do not leave the audio context in the paused
             * state.
             *
             * @returns {Promise} a promise that will be resolved when the render has stopped all playback
             */
            stop: function() {

                this.logger.debug("stop( Audio Sink being asked to stop. )");

                return this.reset()
                    .then(completeRendering.bind(this))
                    .then(cleanup.bind(this));

                function completeRendering() {
                    return this.renderer.close(this.flashPlayback.id);
                }

                function cleanup(promise) {
                    this.logger.debug("cleanup( Audio Sink has stopped and all internals reset. )");

                    // Remove any callbacks.
                    this.renderer.stateChangeHandler = null;

                    // Null out all internals so they're ready for GC.
                    this.sinkName            = null;
                    this.renderer            = null;
                    this.accessUnitsToDecode = null;
                    return promise;
                }
            },

            /**
             * Pause the renderer
             *
             * @returns a promise that will be resolved when playback is paused, or rejected if the render's audio
             * context is in a non-active state
             */
            pause: function () {
                this.logger.debug("pause()");
                return this.renderer.pause(this.flashPlayback.id);
            },

            /**
             * Resume the renderer
             *
             * @returns a promise that will be resolved when playback is resumed, or rejected if the renderer's audio
             * context is in a non-active state
             */
            resume: function () {
                this.logger.debug("resume()");
                return this.renderer.resume(this.flashPlayback.id);
            },

            /**
             * Gets the audio player's total time buffered in milliseconds.
             */
            getBufferTime: function () {
                return this.renderer.bufferTime;
            },

            isReady: function() {
                return (this.renderer.bufferTime > 1000);
            },

            close: function(){
                //TODO : Need to revisit again- as SWFService is not removing the eventListeners properly
                this.renderer.removeEventListener(this.bufferUnderFlowEvent, this.onBufferUnderFlowHandler);
            },

            /**
             * Register a callback to be called when the renderer enters a certain state
             * NOTE : a callback can be registered multiple times, and must be deregistered for every time it is
             *        registered
             *
             * @param {String} state that the handler should be registered for
             * @param {function} handler will be called whenever the renderer enters (or transitions through) the
             * requested state
             */
            registerStateNotificationHandler: function (state, handler) {
                this.logger.debug("TODO registerStateNotificationHandler", state, handler);
                // this.renderer.registerStateNotificationHandler(state, handler);
            },

            /**
             * Deregister a callback from being called when a render request finishes.
             *
             * NOTE: If a callback is registered multiple times it must be deregistered multiple times.
             *
             * @param {String} state that the handler should be de-registered for
             * @param {function} handler will be de-registered for the given state
             */
            deregisterStateNotificationHandler: function (state, handler) {
                this.logger.debug("TODO deregisterStateNotificationHandler", state, handler);
                // this.renderer.deregisterStateNotificationHandler(state, handler);
            },

            /**
             * Register a callback to be called when an render request finishes playing on the Renderer.
             *
             * NOTE : a callback can be registered multiple times, and must be deregistered for every time it is
             *        registered
             *
             * @param {function} handler will be called whenever either buffer plays out or any buffer plays out if
             *   buffer is not specified
             */
            registerNotificationHandler: function (handler) {
                this.logger.debug("TODO registerNotificationHandler", handler);
                // this.renderer.registerNotificationHandler(handler);
            },

            /**
             * Deregister a callback from being called when a render request finishes.
             *
             * NOTE: If a callback is registered multiple times it must be deregistered multiple times.
             *
             * @param {function} handler will be deregistered from callback notification
             */
            deregisterNotificationHandler: function (handler) {
                this.logger.debug("TODO deregisterNotificationHandler", handler);
                // this.renderer.deregisterNotificationHandler(handler);
            },

            /**
             * Load the Mpeg flash playback with the URL and the startTime position
             */
            load: function(url, startTime){

                this.renderer.loadMpegPlayback(this.flashPlayback.id, url, startTime);
            },

            /**
             * Reset the sink, which means close the decoder and null it out. Sink will no longer be usable after
             * doing this.
             *
             * @returns {Promise} A promise that will be resolved when the render has stopped all playback.
             */
            reset: function () {

                return Q.when(this)
                    .finally(stopRenderer.bind(this))
                    .fail(fault.bind(this));

                function stopRenderer() {
                    this.logger.debug("reset( Sink decoder has been closed. )");
                    return this.renderer.stop(this.flashPlayback.id);
                }

                function fault(fault) {
                    this.logger.error("reset( Sink decoder failed to close or renderer failed to stop. Error: {0} )", [fault]);
                    throw fault;
                }
            },

            crossfade: function(config, isTurnedOn) {
                if (!this.renderer) { return; }
                this.logger.debug(config, isTurnedOn);

                this.crossfadeOn = isTurnedOn === true;
            },

            isCrossfadeOn: function() {
                return this.crossfadeOn;
            },

            isCrossfadeSupported: function() {
                return false; // flash does not currently support crossfade
            }
        };

        return MpegFlashAudioSink;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/core/ChunkConsumer.js":
/*!********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/core/ChunkConsumer.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * The chunk consumer is responsible for chaining the decryption and decoding of binary audio chunks,
 * which ultimately leads to audio playback (by dropping them on the audio buffer).
 */

/**
 * Register the module with RequireJS.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require)
  {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var Cipher = __webpack_require__(/*! sxm/audioplayer/html5/crypto/Cipher */ "./javascript/src/sxm/audioplayer/html5/crypto/Cipher.js");
    var AssetError = __webpack_require__(/*! sxm/audioplayer/html5/error/AssetError */ "./javascript/src/sxm/audioplayer/html5/error/AssetError.js");
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
    var PlaybackTypeUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaybackTypeUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js");
    var Q = __webpack_require__(/*! q */ "q");

    /**
     * Internal reference to the logger.
     */
    var logger = LoggerFactory.getLogger("ChunkConsumer");
    
    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------
    
    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the ChunkConsumer function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @constructor
     * @param {AdtsAacAudioSink} audioSink Reference to the AudioSink responsible for playing audio.
     */
    function ChunkConsumer(audioSink) {
      // This first guard ensures that the callee has invoked our Class' constructor function
      // with the `new` keyword - failure to do this will result in the `this` keyword referring
      // to the callee's scope (typically the window global) which will result in the following fields
      // (name and _age) leaking into the global namespace and not being set on this object.
      if (!(this instanceof ChunkConsumer)) {
        throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["ChunkProducer"]);
      }
      
      // TODO: BMR: Chris is this supposed to call stop is it exists???
      if (ObjectUtil.isUndefinedOrNull(audioSink)) {
        throw new Error("The AudioSink cannot be null!");
      }
      
      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------
      
      /**
       * Reference to the AAC Audio sink that is an endpoint for audio chunks
       * by decoding nd playing them.
       * @type {AdtsAacAudioSink}
       * @private
       */
      this._audioSink = audioSink;
      
      /**
       * Cipher object for decrypting and using the key.
       * @type {Cipher}
       * @private
       */
      this._cipher = ((PlaybackTypeUtil.isPlayerMP4(audioSink.feeder) || PlaybackTypeUtil.isPlayerMP3(audioSink.feeder)) === false)
                     ? new Cipher(Cipher.ALGORITHM.AES_CBC, 128, Cipher.TYPE.RAW, ["decrypt"])
                     : null;
      
      /**
       * Flag indicating if the underlying audio player components (like the decoder, muxer, etc)
       * should be reset; this is reset only when a new instance is created, which usually
       * means we're changing channels or seeking so we need to reset various functional components
       * of the core audio player.
       * @type {Boolean}
       * @private
       */
      this._reset = true;
    };
    
    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------
    
    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our ChunkConsumer class, we could write:
     *
     *  `BankManager.prototype = ChunkConsumer.prototype`
     *  `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    ChunkConsumer.prototype = {
      
      /**
       * Whenever you replace an Object's Prototype, you need to repoint
       * the base Constructor back at the original constructor Function,
       * otherwise `instanceof` calls will fail.
       */
      constructor: ChunkConsumer,
      
      /**
       * Prepares the binary audio chunk data for playback by decrypting and decoding it.
       *
       * @param {Chunk} chunk - The audio chunk object with raw audio data to play.
       * @returns {Promise}
       */
      consume: function (chunk) {
        var decrypt = function (cipherText) {
          logger.debug("decrypt()");
          var decryptSuccess = function (data) {
            logger.debug("decryptSuccess()");
            chunk.isDecrypted = true;
            return data;
          };

          //Set the Initialization vector from the chunk decryptor
          if(chunk.decryptor && chunk.decryptor.vector)
          {
            this._cipher.importIV(chunk.decryptor.vector);
          }


          // don't try to decrypt the chunk if it's already been decrypted or there is no cipher for decryption
          return (chunk.isDecrypted || !this._cipher) ? Q.when(chunk.data) : this._cipher.decrypt(cipherText).then(decryptSuccess);
        }.bind(this);
        
        var render = function (audioFrame) {
          logger.debug("render( Chunk URL = {0} )", [chunk.url]);
          chunk.data = audioFrame;

          if (!!this._audioSink)
          {
            return this._audioSink.render(chunk, this._reset);
          }

          return Q.resolve(0);

        }.bind(this);
        
        var consumeSuccess = function () {
          logger.debug("consumeSuccess()");
          this._reset = false;
          return chunk;
        }.bind(this);
        
        var consumeFault = function (error) {
          logger.warn("consumeFault( error = {0} )", [error]);
          var message = ObjectUtil.isUndefinedOrNullOrEmptyString(error) ? AssetError.CHUNK_CORRUPT : error;
          throw new AssetError(message, chunk.url, 0);
        }.bind(this);
        
        logger.info("consume( data = binary )");
        
        return decrypt(chunk.data)
          .then(render)
          .then(consumeSuccess)
          .catch(consumeFault);
        /* jshint ignore:line */
      },
      
      /**
       * Sets the decryption key on the consumer.
       *
       * @param {ArrayBuffer} value
       */
      setKey: function (value) {
        this._cipher.importKey(value);
      },

      /**
       * Resets the object.
       */
      reset: function () {
        logger.debug("reset()");
        
        this._audioSink = null;
        this._cipher = null;
        this._reset = true;
      }
    };
    
    return ChunkConsumer;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));




/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/core/ChunkProducer.js":
/*!********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/core/ChunkProducer.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      The chunk producer loads and caches raw audio chunks and stores them for later use. It's the job of the consumer
 *      to decrypt, decode, and feed them to the audio stream for playback.
 */
/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var AssetLoader = __webpack_require__(/*! sxm/audioplayer/html5/loader/AssetLoader */ "./javascript/src/sxm/audioplayer/html5/loader/AssetLoader.js");
    var RetryLoader = __webpack_require__(/*! sxm/audioplayer/html5/loader/RetryLoader */ "./javascript/src/sxm/audioplayer/html5/loader/RetryLoader.js");
    var Chunk = __webpack_require__(/*! sxm/audioplayer/html5/model/Chunk */ "./javascript/src/sxm/audioplayer/html5/model/Chunk.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
    var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var Q = __webpack_require__(/*! q */ "q");

    var logger = LoggerFactory.getLogger("ChunkProducer");

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the ChunkProducer function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @constructor
     * @param {Array} [chunkCache] - A dictionary of all the chunks loaded. Passed in only if we're seeking
     * within a given playback instance so that we can skip downloading chunks again.
     * @param {Function} [noConnectivity] - Optional callback handler for no connectivity.
     * @param {Function} [tokenRefresh] - Optional callback handler for invalid tokens.
     */
    function ChunkProducer(chunkCache, noConnectivity, tokenRefresh) {
      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------

      /**
       * A dictionary of all the chunks loaded. Keys are the chunk URLs and the value is the chunk
       * byte array data.
       * @type {Array}
       */
      this.chunkCache = ObjectUtil.isUndefinedOrNull(chunkCache) ? [] : chunkCache;

      /**
       * Counter for the number of chunks loaded.
       * @type {Number}
       */
      this.numChunksLoaded = 0;

      /**
       * URL to the last chunk loaded.
       * @type {String}
       */
      this.lastChunkUrlLoaded = "";

      /**
       * Allows external clients to handle no connectivity via a callback hook.
       * @type {Function}
       */
      this.noConnectivity = ObjectUtil.isUndefinedOrNull(noConnectivity) ? null : noConnectivity;

      /**
       * Allows external clients to handle invalid tokens via a callback hook.
       * @type {Function}
       */
      this.tokenRefresh = ObjectUtil.isUndefinedOrNull(tokenRefresh) ? null : tokenRefresh;

      /**
       * Chunk loader.
       * @private
       * @type {RetryLoader}
       */
      this._loader = null;


      this._load = null;
  
      //Indicates whether stream has ended or not mainly used for Mp4ChunkProducer
      this._isEnded = false;
      /**
       * Read-only accessor to indicate stream has not yet ended
       * @type {Boolean}
       */
      Object.defineProperty(this, "isEnded",
        {
          get: function () {
            return this._isEnded;
          },
          set: function (isEnded) {
            this._isEnded = isEnded;
          }
        });

      /**
       * Read-only accessor to the loading state.
       * @type {Boolean}
       */
      Object.defineProperty(this, "isLoading",
        {
          get: function () {
            return !ObjectUtil.isUndefinedOrNull(this._loader) && this._loader.isLoading;
          }.bind(this)
        });

      ClassUtils.bind(this, ChunkProducer);
    };

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Constant indicating the maximum number of items allowed in the chunk cache.
     * @const {Number}
     */
    ChunkProducer.CACHE_MAX_ITEMS = 4;
    ChunkProducer.END_OF_STREAM = 1;

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our ChunkProducer class, we could write:
     *
     *  `BankManager.prototype = ChunkProducer.prototype`
     *  `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    ClassUtils.baseClass(ChunkProducer).prototype = {

      /**
       * Either loads an audio file chunk via HTTP or pulls it from cache if already loaded.
       *
       * @param {String} url - The chunk audio file's URL.
       * @returns {Promise}
       */
      load: function (url) {
        var chunk = this.findBy(url);

        logger.debug("load( {0} {1} )", [(chunk ? "Cached" : "Loading"), url]);

        var loadSuccess = function (response) {
          logger.info("loadSuccess( url = {0} )", [url]);
          this.numChunksLoaded++;

          // create a new chunk domain model from the response
          var chunk = new Chunk(url, response.data, response.size, response.loadTime, response.fileName);

          // save the chunk for later use
          this.addChunkToCache(chunk);

          // save the URL of the last chunk loaded
          this.lastChunkUrlLoaded = url;

          return chunk;
        }.bind(this);

        var loadFault = function (fault) {
          logger.warn("loadFault( url = {0} )", [url]);
          throw fault;
        }.bind(this);

        // Don't bother loading the chunk if it's already loaded into cache and simply return it.
        if (chunk) {
          return Q.when(chunk);
        }
        else {
          this._loader = new RetryLoader(AssetLoader.TYPE_ARRAY_BUFFER, this.noConnectivity, this.tokenRefresh);
          return this._loader.load(url).then(loadSuccess, loadFault);
        }
      },

      /**
       * Adds a chunk to cache.
       *
       * @param {Chunk} chunk - The chunk to add to cache.
       * @return {Chunk} Chunk that was added.
       */
      addChunkToCache: function (chunk) {
        this.chunkCache.push(chunk);
        logger.debug("addChunkToCache( {0} )", [chunk.fileName]);
        this.prune();

        return chunk;
      },

      /**
       * Attempts to find and return a cached chunk using the URL as the key.
       *
       * @param {String} url - The chunk's URL used as a key to the chunk cache.
       * @return {Chunk} Cached chunky.
       */
      findBy: function (url) {
        var chunk = this.chunkCache.find(function(entry) { return entry.url === url; });
        logger.debug("findBy( {0}: {1} )", [(chunk ? "Found" : "Not Found"), url]);

        return chunk;
      },

      /**
       * The chunk cache should only hold a certain number of items at once to keep down memory, so we check
       * for too many and remove the extra ones. The removed items are also set to null for garbage collection.
       *
       * @return {Array} List of items removed from the cache.
       */
      prune: function () {
        var len = this.chunkCache.length;

        // Keep the cache to max number of items...any items beyond that will be removed so as not to
        // let the cache memory get out of control.
        if (len > ChunkProducer.CACHE_MAX_ITEMS) {
          logger.debug("prune()");
          return this.chunkCache.splice(0, len - ChunkProducer.CACHE_MAX_ITEMS);
        }
      },

      /**
       * Attempts to abort any current loads by the internal loader.
       */
      abort: function () {
        if (this._loader) {
          logger.debug("abort()");
          this._loader.abort();
        }
      },

      /**
       * Resets the object.
       */
      reset: function () {
        logger.debug("reset()");

        this.abort();
        this.noConnectivity = null;
        this.tokenRefresh = null;
        this.chunkCache = [];
        this.numChunksLoaded = 0;
        this.lastChunkUrlLoaded = "";
        this._loader = null;
      }
    };

    return ChunkProducer;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/core/MP3ChunkProducer.js":
/*!***********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/core/MP3ChunkProducer.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    12/31/2019
 * @COPYRIGHT:  2019 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      The chunk producer loads and caches raw MP3 audio chunks and caches them for later consumption
 */
/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
        var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
        var Chunk = __webpack_require__(/*! sxm/audioplayer/html5/model/Chunk */ "./javascript/src/sxm/audioplayer/html5/model/Chunk.js");
        var ProgressiveDownload = __webpack_require__(/*! sxm/audioplayer/html5/core/ProgressiveDownload */ "./javascript/src/sxm/audioplayer/html5/core/ProgressiveDownload.js");
        var ChunkProducer = __webpack_require__(/*! sxm/audioplayer/html5/core/ChunkProducer */ "./javascript/src/sxm/audioplayer/html5/core/ChunkProducer.js");
        var MP4Parser = __webpack_require__(/*! sxm/audioplayer/html5/protocols/mp4/MP4Parser */ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP4Parser.js");
        var MP3File = __webpack_require__(/*! sxm/audioplayer/html5/protocols/mp4/MP3File */ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP3File.js");
        var MediaBuffer = __webpack_require__(/*! sxm/audioplayer/html5/model/MediaBuffer */ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js");
        var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
        var Q = __webpack_require__(/*! q */ "q");

        var logger = LoggerFactory.getLogger("MP3ChunkProducer");

        var MP3_HEADER_SIZE = 125000;
        var MIN_CHUNK_SIZE = 32000 * 5;

        //-----------------------------------------------------------------------
        // CONSTRUCTOR
        //-----------------------------------------------------------------------

        /**
         * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
         * To differentiate constructor functions from regular functions, by convention we start the function
         * name with a capital letter. This informs users that they must invoke the ChunkProducer function using
         * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
         *
         * @constructor

         * @param {Function} [noConnectivity] - Optional callback handler for no connectivity.
         * @param {Function} [tokenRefresh] - Optional callback handler for invalid tokens.
         */
        function MP3ChunkProducer(noConnectivity, tokenRefresh, configuration) {

            MP3ChunkProducer.parent.call(this, [], noConnectivity, tokenRefresh);

            this._mp3File = new MP3File(new MediaBuffer(new ArrayBuffer(), 0, true, true));

            this.FAILOVER_RETRY_DELAY = configuration.FAILOVER_RETRY_DELAY || this.FAILOVER_RETRY_DELAY;

            this.FAILOVER_RETRY_LIMIT = +(configuration.FAILOVER_RETRY_LIMIT !== 0) && (configuration.FAILOVER_RETRY_LIMIT || this.FAILOVER_RETRY_LIMIT);

            //Defaults to true, incase of expired token(403's), it will be set to false if we don't ever retry and wait for client to update the source
            // only then we reset to true, uon updating the source form the client and as we do continous chunk pull's from the sink/renderer-> if the retry is ready
            // (which is after the source updated) it will do a retry with new source, if not it will throw an error.
            this.isRetryReady = true;

            MP3_HEADER_SIZE = configuration.mp4HeaderSize || MP3_HEADER_SIZE;
            MIN_CHUNK_SIZE = configuration.minChunkSize || MIN_CHUNK_SIZE;

            /**
             * This flag shows that if all chunks has been consumed by the renderer or not
             * @type {Boolean}
             */
            this.isEnded = false;

            this._lastChunkProducedSlice = [-1, 0];

            /**
             * Allows external clients to handle invalid tokens via a callback hook.
             * @type {Function}
             */
            this.tokenRefresh = tokenRefresh || function() { logger.error('tokenRefresh reference is not defined');};

            ClassUtils.bind(this, MP3ChunkProducer);
        };

        //-----------------------------------------------------------------------
        // EXPOSED API
        //-----------------------------------------------------------------------

        /**
         * Class prototype.  MP3 Chunk Producer is a base class
         */
        ClassUtils.subClass(MP3ChunkProducer,ChunkProducer).prototype = {

            /**
             * Constant indicating the number of milliseconds in between asset load error retries.
             * default it will wait for 1.5s before trying again
             * @type {Number}
             * @const
             */
            FAILOVER_RETRY_DELAY: 1500,

            /**
             * Constant indicating the number of times to retry before failing over.
             * @type {Number}
             * @const
             */
            FAILOVER_RETRY_LIMIT: 5,
            /**
             * This will get the MP3 load process started
             *
             * @param url is the url for the MP3 file we want to start loading
             */
            startLoading: function (url) {
                this._url = url;
                this._load = new ProgressiveDownload(url);
            },

            /**
             * Returns the number of chunks asked for.  If the chunks are available they are returned immediately,
             * otherwise a network call is made to get enough chunks to satisfy the request.
             *
             * @param numChunks is the number of chunks neeeded
             * @param startAt (optional, startTime where we need to start the playback from)
             */
            getChunks: function (numChunks, startAt) {
                var self = this;
                var retries = 0;

                try {
                    //Until the retry is ready, we don't make new request to pull more bytes
                    if (!this.isRetryReady) {
                        throw "Retry is not ready, it will fail with HTTP 403 Forbidden";
                    }

                    if(this.chunksAvailable > 0)
                    {
                        logger.debug("we have left over of {1} chunks in file not yet produced, so we will render these first, " +
                            "even though we got requested for {1}, to keep renderer happy fast", [this.chunksAvailable, numChunks]);
                        numChunks = this.chunksAvailable;
                    }
                    
                    
                    if ((startAt && this.chunksAvailable > 1) || this.chunksAvailable >= numChunks || this.allChunksPulled === true) {
                        return this.getAvailableChunks(numChunks,startAt, onSuccess, onFailure).catch(onFailure);
                    } else {
                        return this.pullChunks()
                            .then(onSuccess)
                            .catch(onFailure);
                    }
                }
                catch (e) {
                    Q.when(e);
                }

                function onFailure(error)
                {
                    self.inFlightRequest = null;
                    if (error === ProgressiveDownload.TIMED_OUT && retries++ < 5) {
                        logger.warn("Timed out getting chunk, retry #{0}", [retries]);
                        return self.getChunks(numChunks, startAt);
                    }

                    if (error.httpStatus && error.httpStatus === 403 && self.FAILOVER_RETRY_LIMIT === 0) {
                        logger.warn("Timed out getting chunk, retry #{0}", [retries]);
                        //Set this to false, so that we don't do retries
                        self.isRetryReady = false;
                        self.tokenRefresh();
                        throw error;
                    }

                    if (error.httpStatus && error.httpStatus === 403 && retries++ < self.FAILOVER_RETRY_LIMIT) {
                        logger.warn("Timed out getting chunk, retry #{0}", [retries]);
                        self.tokenRefresh();

                        return new Promise(function(resolve) {
                            setTimeout(resolve, self._load.totalFlightTime + self.FAILOVER_RETRY_DELAY);
                        }).then(function () { return self.getChunks(numChunks, startAt); });
                    }

                    if (error === ChunkProducer.END_OF_STREAM) {
                        self.isEnded = true;
                        logger.debug("No more chunks available");
                    }
                    else {
                        logger.error("Error getting chunk {0}", [error]);
                    }
                    throw error;
                }

                function onSuccess(requestSummary) {
                    logger.debug("Appending {0} bytes to MP3 file", [requestSummary.bytes.byteLength]);
                    self.inFlightRequest = null;
                    self._mp3File.appendData(requestSummary.bytes, requestSummary.contentRange);
                    return self.getChunks(numChunks, startAt);    // recurse
                }
            },

            /**
             * Get the number of chunks that have been produced (delivered downstream for processing) by the
             * MP3 chunk producer
             */
            chunksProduced : ClassUtils.createPropertyDescriptor({
                get : function() { return this._lastChunkProducedSlice[1]; }
            }),

            /**
             * Get the number of chunks that have been pulled (available for delivery but not delivered yet) by the
             * MP3 chunk producer
             */
            chunksPulled : ClassUtils.createPropertyDescriptor({
                get : function() {
                    var endByteIndexOfPulled = this._mp3File.mediaBuffer.length;

                    if (this.numberOfBytesInFile() > 0
                        && endByteIndexOfPulled >= this.numberOfBytesInFile()) {
                        return this.numberOfChunksInFile();
                    }

                    var chunkIndex = this.chunkIndexAtByteIndex(endByteIndexOfPulled);

                    return (chunkIndex >= 0) ? chunkIndex : 0;
                }
            }),

            /**
             * Get the number of chunks that have been produced (delivered downstream for processing) by the
             * MP3 chunk producer
             */
            chunksAvailable : ClassUtils.createPropertyDescriptor({
                get : function() { return this.chunksPulled - this.chunksProduced; }
            }),

            /**
             * Returns true of all chunks have been pulled from the MP3 file.  False otherwise
             */
            allChunksPulled : ClassUtils.createPropertyDescriptor((function () {

                return {
                    get: function () { return this._load._isEnded; }
                };
            })()),

            getAvailableChunks: function (numChunks, startAt, onSuccess, onFailure)
            {
                try {
                    var parser = new MP4Parser(this._mp3File);
                    var reqChunkDetails = (startAt !== null && startAt >= 0)
                        ? parser.getChunkIndexAndOffsetByTime(startAt)
                        : null;

                    var reqChunkIndex = (!!reqChunkDetails) ? reqChunkDetails.index : null;

                    var begIndex = (!isNaN(reqChunkIndex) && reqChunkIndex !== null)
                        ? reqChunkIndex
                        : this._lastChunkProducedSlice[1];

                    var endIndex = begIndex + numChunks;

                    endIndex = Math.min(endIndex, (parser.chunkDescriptors.length - 1));

                    if (begIndex > endIndex) {
                        throw ChunkProducer.END_OF_STREAM;
                    }
                    if(!this._load._isEnded &&
                        (this._mp3File.chunkDescriptors[begIndex].framesInChunk.length ===0
                            || this._mp3File.chunkDescriptors[endIndex].framesInChunk.length ===0))
                    {
                        logger.debug("Couldn't find the frames In Chunk index:{0}, so we need to pull them", [endIndex]);
                        return this.pullChunks(this._mp3File.chunkDescriptors[endIndex].endIndex)
                            .then(onSuccess)
                            .catch(onFailure);
                    }
                    logger.debug("Getting chunks {0} to {1}", [begIndex, endIndex]);

                    var chunkMediaBuffer = parser.getChunksByIndex(begIndex, (endIndex + 1), false);

                    this._lastChunkProducedSlice[0] = begIndex;
                    this._lastChunkProducedSlice[1] = endIndex + 1;

                    if (!chunkMediaBuffer) {
                        logger.error("Couldn't find the chunkMediaBuffer numChunks:{0}", [numChunks]);
                        throw 'Not able to find the chunkMediaBuffer numChunks';
                    }

                    var lastChunk = (this.chunksProduced === this.chunksPulled
                        && this.allChunksPulled === true);

                    // If we are serving last chunk, then it means the stream has ended
                    this.isEnded = lastChunk;

                    logger.debug("Got chunk {0} bytes", [chunkMediaBuffer.arrayBuffer.byteLength]);

                    var chunk = new Chunk(
                        this._load._url,
                        chunkMediaBuffer.arrayBuffer,
                        chunkMediaBuffer.arrayBuffer.byteLength,
                        0,
                        '',
                        lastChunk,
                        chunkMediaBuffer.duration
                    );

                    chunk.offset = reqChunkDetails ? reqChunkDetails.offset : 0;
                    chunk.codec = 'mp3';

                    return Q.when(chunk);
                } catch (error) {
                    return Q.when(error);
                }
            },

            pullChunks: function (reqByteIndex)
            {
                if (!this.inFlightRequest
                    || this.inFlightRequest.isFulfilled()
                    || this.inFlightRequest.isRejected()) {
                    var byteIndex = reqByteIndex || this._mp3File.mediaBuffer.length;
                    this.inFlightRequest = this.pullMoreData(byteIndex);
                    return this.inFlightRequest;
                }
                else {
                    var self = this;
                    this.inFlightRequest = this.inFlightRequest.then(function () {
                        var byteIndex = reqByteIndex || self._mp3File.mediaBuffer.length;
                        return self.pullMoreData(byteIndex);
                    });

                    return this.inFlightRequest;
                }
            },

            pullMoreData: function (byteIndex)
            {
                try {
                    var startByteIndex = this._mp3File.mediaBuffer.length;

                    if (startByteIndex === 0) {
                        logger.debug("Pulling 125000 bytes to get MP4 header");

                        return this._load.getRequestSummary(startByteIndex, MP3_HEADER_SIZE);
                    }  // start by pulling 125k bytes to read header.

                    var startChunkIndex = this.chunkIndexAtByteIndex(startByteIndex);

                    var endChunkIndex = startChunkIndex + 1;

                    var endByteIndex = this.startByteIndexAtChunkIndex(endChunkIndex);

                    while (endChunkIndex < this._mp3File.chunkDescriptors.length
                    && !byteIndex
                    && endByteIndex - startByteIndex < MIN_CHUNK_SIZE)
                    {
                        endChunkIndex += 1;
                        endByteIndex = this.startByteIndexAtChunkIndex(endChunkIndex);
                    }
                    //If we have numNewChunks > 1, that means we are trying to tune to a position in mediaBuffer where we don't have data,
                    // so we will pull all the bytes till that REQ_CHUNK byteindex plus additional ~5 chunks as these
                    // chunkDescriptor indexes are projected/fake values and some time we can be off by few bytes
                    if (byteIndex) {
                        // var chunkSize = this._mp3File.chunkDescriptors[0].chunkSize;
                        endByteIndex = byteIndex + MIN_CHUNK_SIZE;
                    }
                    // we shouldn't be pulling more bytes than actually exist and we shouldn't be making req with endbyte be less than startByte
                    if ((endByteIndex > this._mp3File.chunkDescriptors[this._mp3File.chunkDescriptors.length - 1].endIndex)
                        || endByteIndex <= this._mp3File.mediaBuffer.byteLength) {
                        endByteIndex = -1;
                    }

                    if (endByteIndex === -1) {
                        endByteIndex = null;
                    } else {
                        logger.debug("Pulling {0} bytes to get chunk {1} to {2}",
                            [endByteIndex - startByteIndex, startChunkIndex, endChunkIndex]);
                    }
                    return this._load.getRequestSummary(startByteIndex, endByteIndex);
                } catch (error) {
                    return Q.when(error);
                }
            },

            startByteIndexAtChunkIndex: function (chunkIndex) {
                var descriptor = this._mp3File.chunkDescriptors[chunkIndex];

                if (!descriptor) {
                    return -1;
                }

                return descriptor.startIndex;
            },

            chunkIndexAtByteIndex: function (byteIndex) {
                if (this._mp3File.chunkDescriptors.length === 0) {
                    return -1;
                }

                var lastDescriptor = this._mp3File.chunkDescriptors[this._mp3File.chunkDescriptors.length - 1];

                if (byteIndex >= lastDescriptor.startIndex + lastDescriptor.chunkSize) {
                    return -1;
                }

                var i = 0;
                while (i < this._mp3File.chunkDescriptors.length
                && !withinChunk(this._mp3File.chunkDescriptors[i], byteIndex)) {
                    i += 1;
                }

                return i;

                function withinChunk(descriptor, byteIndex) {
                    return descriptor.startIndex <= byteIndex && byteIndex < (descriptor.startIndex + descriptor.chunkSize);
                }
            },

            numberOfChunksPulled: function () {
                var endByteIndexOfPulled = this._mp3File.mediaBuffer.length;

                if (this.numberOfBytesInFile() > 0
                    && endByteIndexOfPulled >= this.numberOfBytesInFile()) {
                    return this.numberOfChunksInFile();
                }

                var chunkIndex = this.chunkIndexAtByteIndex(endByteIndexOfPulled);

                return (chunkIndex >= 0) ? chunkIndex : 0;
            },

            numberOfChunksInFile: function () {
                return this._mp3File.chunkDescriptors.length;
            },

            numberOfBytesInFile: function () {
                if (this._mp3File.chunkDescriptors.length === 0) {
                    return 0;
                }

                var lastDescriptor = this._mp3File.chunkDescriptors[this._mp3File.chunkDescriptors.length - 1];

                return lastDescriptor.startIndex + lastDescriptor.chunkSize;
            },

            /**
             * Update the url of the current playback incase the url got expired
             * @param url - string
             * @returns {*}
             */
            updateSource: function (url) {
                this._url = url;
                this._load._url = url;
                //set the retry state to true, so that we can do retries once the source has been updated
                this.isRetryReady = true;
            },

            //Only available after the first chunk has been parsed, used to get the total track duration
            getTrackDuration: function(){
                return this._mp3File ? this._mp3File.duration : 0;
            }
        };

        return MP3ChunkProducer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/core/MP4ChunkProducer.js":
/*!***********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/core/MP4ChunkProducer.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    06/03/19
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      The chunk producer loads and caches raw audio chunks and stores them for later use. It's the job of the consumer
 *      to decrypt, decode, and feed them to the audio stream for playback.
 */
/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var ChunkProducer = __webpack_require__(/*! sxm/audioplayer/html5/core/ChunkProducer */ "./javascript/src/sxm/audioplayer/html5/core/ChunkProducer.js");
    var Chunk = __webpack_require__(/*! sxm/audioplayer/html5/model/Chunk */ "./javascript/src/sxm/audioplayer/html5/model/Chunk.js");
    var ProgressiveDownload = __webpack_require__(/*! sxm/audioplayer/html5/core/ProgressiveDownload */ "./javascript/src/sxm/audioplayer/html5/core/ProgressiveDownload.js");
    var MP4Parser = __webpack_require__(/*! sxm/audioplayer/html5/protocols/mp4/MP4Parser */ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP4Parser.js");
    var MP4File = __webpack_require__(/*! sxm/audioplayer/html5/protocols/mp4/MP4File */ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP4File.js");
    var MediaBuffer = __webpack_require__(/*! sxm/audioplayer/html5/model/MediaBuffer */ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js");
    var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var XORCipher = __webpack_require__(/*! sxm/audioplayer/html5/crypto/XORCipher */ "./javascript/src/sxm/audioplayer/html5/crypto/XORCipher.js");
    var Cipher = __webpack_require__(/*! sxm/audioplayer/html5/crypto/Cipher */ "./javascript/src/sxm/audioplayer/html5/crypto/Cipher.js");
    var Codec = __webpack_require__(/*! sxm/audioplayer/html5/model/Codec */ "./javascript/src/sxm/audioplayer/html5/model/Codec.js");
    var Q = __webpack_require__(/*! q */ "q");

    var logger = LoggerFactory.getLogger("MP4ChunkProducer");

    var MP4_HEADER_SIZE;
    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the ChunkProducer function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @constructor
     * @param {Array} [chunkCache] - A dictionary of all the chunks loaded. Passed in only if we're seeking
     * within a given playback instance so that we can skip downloading chunks again.
     * @param {Function} [noConnectivity] - Optional callback handler for no connectivity.
     * @param {Function} [tokenRefresh] - Optional callback handler for invalid tokens.
     * @param {Configuration} configuration -
     */
    function MP4ChunkProducer(chunkCache, noConnectivity, tokenRefresh, configuration) {

      MP4ChunkProducer.parent.call(this, chunkCache, noConnectivity, tokenRefresh);

      this._mp4File = new MP4File(
        new MediaBuffer(
          // eslint-disable-next-line no-undef
          new ArrayBuffer(),
          0,
          true,
          true
        )
      );

      this.FAILOVER_RETRY_DELAY = configuration.FAILOVER_RETRY_DELAY || this.FAILOVER_RETRY_DELAY;

      this.FAILOVER_RETRY_LIMIT = +(configuration.FAILOVER_RETRY_LIMIT !== 0) && (configuration.FAILOVER_RETRY_LIMIT || this.FAILOVER_RETRY_LIMIT);

      //Defaults to true, incase of expired token(403's), it will be set to false if we don't ever retry and wait for client to update the source
      // only then we reset to true, uon updating the source form the client and as we do continous chunk pull's from the sink/renderer-> if the retry is ready
      // (which is after the source updated) it will do a retry with new source, if not it will throw an error.
      this.isRetryReady = true;

      MP4_HEADER_SIZE = configuration.mp4HeaderSize || 275000;

      // end exclusive
      // so if you've produced 4 chunks
      // it will be [0, 4]
      this._lastChunkProducedSlice = [-1, 0];
  
      /**
       * Allows external clients to handle invalid tokens via a callback hook.
       * @type {Function}
       */
      this.tokenRefresh = tokenRefresh || function() { logger.error('tokenRefresh reference is not defined');};
      
      ClassUtils.bind(this, MP4ChunkProducer);
    }

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our ChunkProducer class, we could write:
     *
     *  `BankManager.prototype = ChunkProducer.prototype`
     *  `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    ClassUtils.subClass(MP4ChunkProducer, ChunkProducer).prototype = {

      /**
       * Constant indicating the number of milliseconds in between asset load error retries.
       * default it will wait for 1.5s before trying again
       * @type {Number}
       * @const
       */
      FAILOVER_RETRY_DELAY: 1500,

      /**
       * Constant indicating the number of times to retry before failing over.
       * @type {Number}
       * @const
       */
      FAILOVER_RETRY_LIMIT: 5,

      /**
       * Returns a chunk of at least numFrames in length.
       * Might be longer if numframes is 42 and there are 81 frames remaining.
       * In that case, it will return 81 frames.
       * @param numChunks
       * @param startAt (optional, startTime where we need to start the playback)
       */
      getChunks: function (numChunks, startAt) {
        var self = this;
        var retries = 0;

        //Until the retry is ready, we don't make new request to pull more bytes
        if(!this.isRetryReady)
        {
          throw "Retry is not ready, it will fail with HTTP 403 Forbidden";
        }

        var leftOverChunks = this.numberOfChunksPulled() - this.numberOfChunksProduced();
        if(leftOverChunks > 0)
        {
          logger.debug("we have left over of {1} chunks in file not yet produced, so we will render these first, " +
              "even though we got requested for {1}, to keep renderer happy fast", [leftOverChunks, numChunks]);
          numChunks = leftOverChunks;
        }
        
        //TODO: Need to rewrite the below logic in more sophisticated way
        return this.mp4FileWithEnoughToProduce(numChunks, startAt)
          .then(function (value) {

            return getChunk(value.mp4File, value.numNewChunks, startAt, self);
          })
          .catch(onFailure);

        function onFailure(error) {
          if (error === ProgressiveDownload.TIMED_OUT && retries++ < 5) {
            logger.warn("Timed out getting chunk, retry #{0}", [retries]);
            return self.mp4FileWithEnoughToProduce(numChunks, startAt).then(function (value) {
              return getChunk(value.mp4File, value.numNewChunks, startAt, self);
            }).catch(onFailure);
          }

          if (error.httpStatus && error.httpStatus === 403 && self.FAILOVER_RETRY_LIMIT === 0) {
            logger.warn("Timed out getting chunk, retry #{0}", [retries]);
            //Set this to false, so that we don't do retries
            self.isRetryReady = false;
            self.tokenRefresh();
            throw error;
          }

          if (error.httpStatus && error.httpStatus === 403 && retries++ < self.FAILOVER_RETRY_LIMIT) {
            logger.warn("Timed out getting chunk, retry #{0}", [retries]);
            self.tokenRefresh();

            return delay(self._load.totalFlightTime + self.FAILOVER_RETRY_DELAY).then(function () {
              return self.mp4FileWithEnoughToProduce(numChunks, startAt).then(function (value) {
                return getChunk(value.mp4File, value.numNewChunks, startAt, self);
              }).catch(onFailure);
            });
          }
    
          if (error === ChunkProducer.END_OF_STREAM) {
  
            self.isEnded = true;
      
            logger.debug("No more chunks available");
          }
          else {
            logger.error("Error getting chunk {0}", [error]);
          }
          throw error;
        }
  
  
        /**
         * Delay a promise by t secs using setTimeout
         */
        function delay(timeout) {
          return new Promise(function(resolve) {
            setTimeout(resolve, timeout);
          });
        }
        
        function getChunk(mp4File, numChunks, startAt, self) {
          var parser = new MP4Parser(mp4File);
  
          retries = 0;
          
          var reqChunkDetails = null;
          
          if(startAt !== null && startAt >= 0)
          {
            reqChunkDetails = parser.getChunkIndexAndOffsetByTime(startAt);
          }
  
          var chunkMediaBuffer = getChunkMediaBuffer(numChunks, parser, reqChunkDetails ? reqChunkDetails.index : null,  self);
  
          if(!chunkMediaBuffer){
            logger.error("Couldn't find the chunkMediaBuffer numChunks:{0}", [numChunks]);
            throw 'Not able to find the chunkMediaBuffer numChunks';
          }
          var lastChunk = self.numberOfChunksProduced() >= self.numberOfChunksInFile();

          // If we are serving last chunk, then it means the stream has ended
          self.isEnded = lastChunk;
          
          logger.debug("Got chunk {0} bytes", [chunkMediaBuffer.arrayBuffer.byteLength]);
  
          var chunk = new Chunk(
            self._load._url,
            chunkMediaBuffer.arrayBuffer,
            chunkMediaBuffer.arrayBuffer.byteLength,
            0,
            '',
            lastChunk,
            chunkMediaBuffer.duration
          );
          
          chunk.offset = reqChunkDetails ? reqChunkDetails.offset : 0;
          chunk.codec = parser.isAACPlus ? Codec.AAC_HE : Codec.AAC_LC;
          
          return chunk;
        }
        /**
         * Determine the startIndex and endIndex for the chunk to be produced, and then get a media buffer
         * with the contents of those chunks
         *
         *
         * @param numChunks is the number of chunks to try to obtain from the mp4 file
         * @param parser is an MP4 parser that can be used to get chunk data
         * @param self is a reference to an MP4ChunkProducer to record new beginning and end chunk indexes
         *
         * @returns a mediaBuffer that contains
         */
        function getChunkMediaBuffer(numChunks, parser, reqChunkIndex, self) {
          var begIndex = (!isNaN(reqChunkIndex) && reqChunkIndex !== null) ? reqChunkIndex : self._lastChunkProducedSlice[1];
          
          var endIndex = begIndex + numChunks -1;
          
          endIndex = Math.min(endIndex, parser.chunkDescriptors.length - 1);

          if (begIndex > endIndex) {
            throw ChunkProducer.END_OF_STREAM;
          }
          if(!self._load._isEnded &&
              (self._mp4File.chunkDescriptors[begIndex].framesInChunk.length === 0
                  || self._mp4File.chunkDescriptors[endIndex].framesInChunk.length === 0))
          {
            logger.error("Couldn't find the frames In Chunk index:{0}", [begIndex]);
            return null;
          }
          logger.debug("Producing chunks {0} to {1} inclusive", [begIndex, endIndex]);

          var mediaBuffer = parser.getChunksByIndex(begIndex, endIndex + 1, true);

          self._lastChunkProducedSlice[0] = begIndex;
          self._lastChunkProducedSlice[1] = endIndex + 1;
          
          return mediaBuffer;
        }
      },


      numberOfChunksProduced: function () {
        return this._lastChunkProducedSlice[1];
      },


      mp4FileWithEnoughToProduce: function (numChunksRequested, seekTime) {
        var self = this;

        var opts = {
          numberOfChunksPulled: 0,
          chunksPulledButNotProduced: 0,
          chunksNeeded: numChunksRequested,
          pullHeader: true,
          seekingChunkIndex: null
        };

        // don't run the main logic if file is totally empty lol.
        // there is nothing in it to reason about.
        if (this.numberOfChunksInFile() !== 0) {

          opts = {
            numberOfChunksPulled: this.numberOfChunksPulled(),
            chunksPulledButNotProduced: this.numberOfChunksPulled() - this.numberOfChunksProduced(),
            chunksNeeded: numChunksRequested,
            pullHeader: false,
            seekingChunkIndex: null
          };

          logger.debug("Checking mp4 file: {0} chunks in file, {1} chunks pulled, {2} chunks produced {3}.",
              [this.numberOfChunksInFile(), this.numberOfChunksPulled(), this.numberOfChunksProduced(), this._url]);

          if (this.numberOfChunksInFile() > 0
              && (this.numberOfChunksPulled() === this.numberOfChunksInFile() || this._load._isEnded)) {
            logger.debug("All chunks have been pulled for MP4 file {0}", [self._load._url]);
            return Q.when({ mp4File: this._mp4File, numNewChunks: numChunksRequested });
          }

          if (this.numberOfChunksInFile() <= 0) {
            logger.debug("Need to get the MP4 box headers in order to get {0} chunks", [numChunksRequested]);
          }

          // seeking logic
          if (seekTime && seekTime >= 0 && this.numberOfChunksInFile() > 0) {
            var parser = new MP4Parser(this._mp4File);
            var chunkDetails = parser.getChunkIndexAndOffsetByTime(seekTime);
            var seekingChunkIndex = chunkDetails.index;

            if (seekingChunkIndex < this.numberOfChunksProduced())
            {
              // IMPORTANT SIDE EFFECT
              // we are seeking backwards.
              // so change some state.
              //
              // reset last chunk produced to where you are going to.
              // We will pretend like the last chunk produced was the one
              // right before where we seeked.  (end-exclusive)
              this._lastChunkProducedSlice = [seekingChunkIndex - 1, seekingChunkIndex];
            }

            opts.seekingChunkIndex = seekingChunkIndex;
          }


          var chunksLeft = this.numberOfChunksInFile() - this.numberOfChunksProduced();
          var chunksNeeded = numChunksRequested;
          if (chunksLeft > 0) {
            chunksNeeded = numChunksRequested <= chunksLeft ? numChunksRequested : chunksLeft;
          }


          // chunksPulledButNotProduced is non-zero:
          // 1. when you have surplus chunks from header pull.
          // 2. or in various seeking scenarios.
          // You will have pulled chunks that haven't been produced.
          // Don't re-pull them, lol
          // recalculate the value here because of the side-effect in the seeking logic
          var chunksPulledButNotProduced = this.numberOfChunksPulled() - this.numberOfChunksProduced();


          opts.chunksPulledButNotProduced = chunksPulledButNotProduced;
          opts.chunksNeeded = chunksNeeded;

          logger.debug("Checking mp4 file {0} chunks pulled but not produced, {1} chunks in file not yet produced, url is {2}",
              [chunksPulledButNotProduced, chunksLeft, this._url]);
        }


        // entering here will make an asset request.
        if (opts.pullHeader === true
            || opts.chunksNeeded > chunksPulledButNotProduced
            || (typeof opts.seekingChunkIndex) === "number" && opts.seekingChunkIndex + opts.chunksNeeded > opts.numberOfChunksPulled)
        {
          if (!this.inFlightRequest
              || this.inFlightRequest.isFulfilled()
              || this.inFlightRequest.isRejected())
          {
            this.inFlightRequest = this.pullMoreData(opts);

            return this.inFlightRequest
                .then(onSuccess)
                .catch(onFailure);
          }
          else
          {
            this.inFlightRequest = this.inFlightRequest.then(function() {
              return self.pullMoreData(opts);
            });

            return this.inFlightRequest
                .then(onSuccess)
                .catch(onFailure);
          }
        }
        else {
          logger.debug("New chunks available for {0}", [self._load._url]);
          return Q.when({ mp4File: this._mp4File, numNewChunks: numChunksRequested });
        }
  
        function onFailure(error) {
          throw error;
        }
        
        function onSuccess(requestSummary) {
    
          logger.debug("Appending {0} bytes to MP4 file", [requestSummary.bytes.byteLength]);

          if (self.key) {
      
            //Make sure we are not appending duplicate bytes to the MP4 file as it might break
            //So we will re-request the data to pull and it will properly fetch the chunks based on last requested bytes
            if(self._mp4File.mediaBuffer.length !== requestSummary.beg)
            {
              logger.error("We might have pulled invalid chunks with duplicate bytes {0}, " +
                "So validate the MP4 file and request again", [requestSummary.beg]);

              return self.mp4FileWithEnoughToProduce(
                requestSummary.numNewChunks,
                opts.pullHeader ? seekTime : null
              );    // recurse
            }
            return self._cipher.decrypt(requestSummary.bytes, self._mp4File.mediaBuffer.length).then(function(data) {
              self._mp4File.appendData(data);

              return self.mp4FileWithEnoughToProduce(
                requestSummary.numNewChunks,
                opts.pullHeader ? seekTime : null
              );    // recurse
            });
      
          } else {
            self._mp4File.appendData(requestSummary.bytes, requestSummary.contentRange);

            return self.mp4FileWithEnoughToProduce(
              requestSummary.numNewChunks,
              opts.pullHeader ? seekTime : null
            );    // recurse
          }
        }
      },

      pullMoreData: function (opts) {

        var chunksNeeded = opts.chunksNeeded;

        if (opts.pullHeader === true) {
          logger.debug("Pulling {0} bytes to get MP4 header", [MP4_HEADER_SIZE]);

          return this._load.getRequestSummary(this._mp4File.mediaBuffer.length, MP4_HEADER_SIZE)
              .then(function(requestSummary) {
                requestSummary.numNewChunks = chunksNeeded;
                return requestSummary;
              });
        }  // start by pulling 125k bytes to read header.

        var chunksPulledButNotProduced = opts.chunksPulledButNotProduced;

        var seekingChunkIndex = opts.seekingChunkIndex;

        var numberOfChunksPulled = opts.numberOfChunksPulled;  // always


        var isSeeking = typeof seekingChunkIndex === 'number';

        var startChunkIndex = isSeeking ? seekingChunkIndex : numberOfChunksPulled;

        var endChunkIndex = isSeeking
          ? startChunkIndex + chunksNeeded
          : startChunkIndex + chunksNeeded - chunksPulledButNotProduced;

        var startByteIndex = this.startByteIndexAtChunkIndex(startChunkIndex);
        var endByteIndex = this.startByteIndexAtChunkIndex(endChunkIndex);


        logger.debug("Pulling {0} bytes to get chunk {1} to {2}",
            [endByteIndex !== -1 ? endByteIndex - startByteIndex : "all", startChunkIndex, endChunkIndex - 1]);


        return this._load.getRequestSummary(
            this._mp4File.mediaBuffer.length,
            endByteIndex >= 0 ? endByteIndex : null
        ).then(function(requestSummary) {
          requestSummary.numNewChunks = chunksNeeded;
          return requestSummary;
        });
      },
      

      startByteIndexAtChunkIndex: function (chunkIndex) {
        var descriptor = this._mp4File.chunkDescriptors[chunkIndex];

        if (!descriptor) {
          return -1;
        }

        return descriptor.startIndex;
      },

      chunkIndexAtByteIndex: function (byteIndex) {
        if (this._mp4File.chunkDescriptors.length === 0) {
          return -1;
        }

        var lastDescriptor = this._mp4File.chunkDescriptors[this._mp4File.chunkDescriptors.length - 1];

        if (byteIndex >= lastDescriptor.startIndex + lastDescriptor.chunkSize) {
          return -1;
        }

        var i = 0;
        while (i < this._mp4File.chunkDescriptors.length
               && !withinChunk(this._mp4File.chunkDescriptors[i], byteIndex)) {
          i += 1;
        }

        return i;

        function withinChunk(descriptor, byteIndex) {
          return descriptor.startIndex <= byteIndex && byteIndex < (descriptor.startIndex + descriptor.chunkSize);
        }
      },

      numberOfChunksPulled: function () {
        var endByteIndexOfPulled = this._mp4File.mediaBuffer.length;
        
        if (this.numberOfBytesInFile() > 0
            && endByteIndexOfPulled >= this.numberOfBytesInFile()) {
          return this.numberOfChunksInFile();
        }
        
        var chunkIndex = this.chunkIndexAtByteIndex(endByteIndexOfPulled);

        return (chunkIndex >= 0) ? chunkIndex : 0;
      },


      numberOfChunksInFile: function () {
        return this._mp4File.chunkDescriptors.length;
      },

      numberOfBytesInFile: function () {
        if (this._mp4File.chunkDescriptors.length === 0) {
          return 0;
        }

        var lastDescriptor = this._mp4File.chunkDescriptors[this._mp4File.chunkDescriptors.length - 1];

        return lastDescriptor.startIndex + lastDescriptor.chunkSize;
      },

      startLoading: function (url, key) {
        this._url = url;
        this._load = new ProgressiveDownload(url);
        
        //TODO : IF we have key initiate the XORCipher to decrypt the buffer data usign the key
        if(key)
        {
          this.key = key;
          this._cipher = new XORCipher(Cipher.ALGORITHM.XOR_MASK, ["decrypt"]);
          this._cipher.importKey(key);
        }
      },
      /**
       * Update the url of the current playback incase the url got expired
       * @param url - string
       * @returns {*}
       */
      updateSource: function (url) {
        this._url = url;
        this._load._url = url;
        //set the retry state to true, so that we can do retries once the source has been updated
        this.isRetryReady = true;
      },
      
      //Only available after the first chunk has been parsed, used to get the total track duration
      getTrackDuration: function(){
        return this._mp4File ? this._mp4File.duration : 0;
      }
    };

    return MP4ChunkProducer;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/core/MediaElementPlayback.js":
/*!***************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/core/MediaElementPlayback.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    04/10/20
 * @COPYRIGHT:  2020 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:

 *
 *      Topics to add here:
 *
 *          * Basic Playback Flow with Audio Element, such as load the track, play/pause/seek/stop and other playback controls
 */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require)
    {
        var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
        var EventDispatcher = __webpack_require__(/*! sxm/audioplayer/html5/event/EventDispatcher */ "./javascript/src/sxm/audioplayer/html5/event/EventDispatcher.js");
        var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
        var PlaybackEventMonitor = __webpack_require__(/*! sxm/audioplayer/html5/event/PlaybackEventMonitor */ "./javascript/src/sxm/audioplayer/html5/event/PlaybackEventMonitor.js");
        var PlayerState = __webpack_require__(/*! sxm/audioplayer/html5/model/PlayerState */ "./javascript/src/sxm/audioplayer/html5/model/PlayerState.js");
        var PlayerEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/PlayerEvent */ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js");
        var AudioPlayerEvent = __webpack_require__(/*! sxm/audioplayer/event/AudioPlayerEvent */ "./javascript/src/sxm/audioplayer/event/AudioPlayerEvent.js");
        var StateChangeEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/StateChangeEvent */ "./javascript/src/sxm/audioplayer/html5/event/StateChangeEvent.js");
        var PlaybackTypeUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaybackTypeUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js");
        var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
        var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
        var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
        var Q = __webpack_require__(/*! q */ "q");

        //-----------------------------------------------------------------------
        // CONSTRUCTOR
        //-----------------------------------------------------------------------

        /**
         * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
         * To differentiate constructor functions from regular functions, by convention we start the function
         * name with a capital letter. This informs users that they must invoke the Playback function using
         * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
         *
         * @param {Configuration} config The configuration object for the audio player.
         * @constructor
         */
        function MediaElementPlayback(config) {
            // This first guard ensures that the callee has invoked our Class' constructor function
            // with the `new` keyword - failure to do this will result in the `this` keyword referring
            // to the callee's scope (typically the window global) which will result in the following fields
            // (name and _age) leaking into the global namespace and not being set on this object.
            if (!(this instanceof MediaElementPlayback)) {
                throw new TypeError("MediaElementPlayback constructor cannot be called as a function.");
            }

            // Player IDs are based off the content ID (Live = Channel ID, AOD = Episode ID, MySXM = Track ID),
            // but we also want to capture the Playback instance so we create a UID based off of both:
            // {PlaybackInstanceCounter}-{ContentId}
            var uid = ++MediaElementPlayback.COUNTER + "-" + config.id;

            // NOTE: Unlike loggers in other classes, this one is an class instance member so we can keep
            // track of Playback instances with a counter.
            this.logger = LoggerFactory.getLogger(StringUtil.supplant("MediaElementPlayback[{0}]", [uid]));

            if (ObjectUtil.isUndefinedOrNull(config)) {
                throw new TypeError("Playback constructor must have config object.");
            }

            // Bind the scope of "this" to all first class functions
            ClassUtil.bindFunctions(this);

            // Extend this object with event dispatching capabilities
            EventDispatcher.apply(this);

            //-----------------------------------------------------------------------
            // CLASS MEMBERS
            //-----------------------------------------------------------------------

            this.audioElement = null;
            /**
             * The player's ID based on the content ID.
             * @type {String}
             */
            this.id = config.id;

            /**
             * The player's true unique ID based on the instance counter and the content ID.
             * @type {String}
             */
            this.uid = uid;

            /**
             * The player's configuration object contains, well, configs for the player.
             * @type {Configuration}
             */
            this.configuration = config;

            /**
             * Update the HlsConfig's WITH_CREDENTIALS if client want's to override the deafult false
             * @type {boolean}
             */
            HlsConfig.WITH_CREDENTIALS = config.withCredentials === false ? false : true;

            /**
             * The current URL being played. This is most often the initial Variant URL.
             * @type {String}
             */
            this.currentUrl = "";

            /**
             * The initial start time for playback.
             * @type {String|Number|Date}
             */
            this.startTime = null;

            /**
             * Controls the event broadcasting from the Playback engine.
             * @type {PlaybackEventMonitor}
             */
            this.playbackEventMonitor = null;

            /**
             * The state of the player.
             * @type {String}
             */
            this._state = PlayerState.INITIAL;

            /**
             * Flag to tell whether the metadata has loaded or not.
             * We use this whether we have to dispatch the events when we don't have enough data on the track
             * @type {Boolean}
             */
            this._isMetaDataLoaded = false;

            /**
             * Flag indicating if the connection is open, ie we're up and running.
             * @type {Boolean}
             * @private
             */
            this._isConnectionOpen = false;

            /**
             * The volume can be grabbed from the Audio element but since it's not always available we store it in
             * this property.
             * @type {Number}
             * @private
             */
            this._volume = null;

            /**
             * If the audio renderer under flows, this will trigger a buffer empty event upstream
             */
            this.onUnderflow = function onOverflow() {
                this.dispatchPlayerEvent(AudioPlayerEvent.BUFFER_EMPTY);
            }.bind(this);


            /**
             * Indicates the player's current state.
             * @type {String}
             */
            Object.defineProperty(this, "state",
                {
                    get: function () {
                        return this._state;
                    },
                    set: function (value) {
                        var previousState = this._state;

                        if (previousState !== value) {
                            this._state = value;
                            this.logger.debug("state( old = {0}, new = {1} )", [String(previousState), value]);
                            this.dispatchEvent(new StateChangeEvent(this.id, value, previousState));
                        }
                    }
                });


            /**
             * Sets the autoPlay setting.
             * @type {Boolean}
             */
            Object.defineProperty(this, "autoPlay",
                {
                    get: function () {
                        return this.configuration ? this.configuration.autoPlay : false;
                    },
                    set: function (value) {
                        if (this.configuration) {
                            this.configuration.autoPlay = value;
                        }
                    }
                });

            /**
             * Read-only accessor for the player's buffer time in milliseconds.
             * @type {Number}
             */
            Object.defineProperty(this, "bufferTime",
                {
                    get: function () {
                        return this.audioElement && this.audioElement.buffered.length > 0 ? (this.audioElement.buffered.end(0) * 1000) : 0;
                    }
                });

            /**
             * Read-only accessor for the player's duraiton time in milliseconds.
             * @type {Number}
             */
            Object.defineProperty(this, "duration",
                {
                    get: function () {

                        return this.audioElement ? (this.audioElement.duration * 1000) : 0;
                    }
                });

            /**
             * Read-only accessor for the player's buffer percent compared to the expected, minimum buffer.
             * @type {Number}
             */
            Object.defineProperty(this, "bufferPercent",
                {
                    get: function () {
                        return (this.bufferTime / HlsConfig.BUFFER_TIME) * 100;
                    }
                });

            /**
             * Read-only accessor indicating if the underlying audio stream has ended.
             *
             * @type {Boolean}
             */
            Object.defineProperty(this, "isLive",
                {
                    get: function () {
                        return PlaybackTypeUtil.isPlayerLive(this);
                    }
                });

            /**
             * Read-only accessor indicating if the audio player is playing.
             *
             * There are cases where the internal, core AudioElement's state for playing is actually set before
             * the Playback instance's playing state is set, so we check for either case.
             *
             * @type {Boolean}
             */
            Object.defineProperty(this, "isPlaying",
                {
                    get: function () {
                        return (this.state === PlayerState.PLAYING);
                    }
                });

            /**
             * Read-only accessor indicating if the audio player is paused.
             *
             * @type {Boolean}
             */
            Object.defineProperty(this, "isPaused",
                {
                    get: function () {
                        return (this.state === PlayerState.PAUSED);
                    }
                });

            /**
             * Read-only accessor indicating if the audio player is stopped.
             *
             * @type {Boolean}
             */
            Object.defineProperty(this, "isStopped",
                {
                    get: function () {
                        return (this.state === PlayerState.STOPPED);
                    }
                });


            /**
             * Read-only accessor indicating if the underlying audio stream has ended.
             *
             * @type {Boolean}
             */
            Object.defineProperty(this, "isEnded",
                {
                    get: function () {
                        return this.audioElement.ended;
                    }
                });

            /**
             * Read-only accessor indicating if the audio player is in the process of stopping but not actually stopped.
             *
             * @type {Boolean}
             */
            Object.defineProperty(this, "isStopping",
                {
                    get: function () {
                        return (this.state === PlayerState.STOPPING);
                    }
                });

            /**
             * Read-only accessor indicating if the audio player is preloading.
             *
             * @type {Boolean}
             */
            Object.defineProperty(this, "isPreloading",
                {
                    get: function () {
                        return (this.state === PlayerState.PRELOADING);
                    }
                });

            /**
             * Read-only accessor indicating if the audio player is initialized.
             *
             * @type {Boolean}
             */
            Object.defineProperty(this, "isInitialized",
                {
                    get: function () {
                        return (this.state === PlayerState.INITIAL);
                    }
                });

            /**
             * Read-only accessor indicating if playback has ever played audio.
             *
             * @type {Boolean}
             */
            Object.defineProperty(this, "hasPlayed",
                {
                    get: function () {
                        return (this.playhead > 0);
                    }
                });

            /**
             * Read-only accessor for the current zero-based playhead value.
             *
             * @type {Number}
             */
            Object.defineProperty(this, "playhead",
                {
                    get: function () {
                        return this.audioElement ? parseFloat(this.audioElement.currentTime.toFixed(3))  * 1000 : 0;
                    }
                });
        };

        //-----------------------------------------------------------------------
        // STATIC MEMBERS
        //-----------------------------------------------------------------------

        /**
         * Indicates the actual instance counter for this object.
         */
        MediaElementPlayback.COUNTER = 0;

        /**
         * List of playback events we want to listen from the Media Element
         */
        MediaElementPlayback.CONSTS = {
            EVENTS: {
                WAITING : 'waiting',
                CAN_PLAY_THROUGH : 'canplaythrough',
                PLAYING : 'play',
                PAUSED : 'pause',
                ENDED : 'ended',
                TIME_UPDATE : 'timeupdate',
                ERROR : 'error',
                SEEKING : 'seeking',
                SEEKED : 'seeked',
                LOADED_META_DATA : 'loadedmetadata',
                NOT_ALLOWED_ERROR : 'NotAllowedError'
            }
        };
        //-----------------------------------------------------------------------
        // EXPOSED API
        //-----------------------------------------------------------------------

        /**
         * The prototype is a special type of Object which is used as a the blueprint for all instances
         * of a given Class; by defining functions and properties on the prototype we reduce memory
         * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
         * example, if we introduced a BankManager class which extended our Playback class, we could write:
         *
         *  `BankManager.prototype = Playback.prototype`
         *  `BankManager.prototype.constructor = BankManager`
         *
         * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
         * over inheritance will make your code easier to read and re-use.
         */
        MediaElementPlayback.prototype = {

            /**
             * Whenever you replace an Object's Prototype, you need to repoint
             * the base Constructor back at the original constructor Function,
             * otherwise `instanceof` calls will fail.
             */
            constructor: MediaElementPlayback,

            //-----------------------------------------------------------------------
            // PUBLIC PLAYER API
            //-----------------------------------------------------------------------

            /**
             * Begins audio playback.
             *
             * @param {String} url - URL to start playback. Currently either a M3U8 manifest file or AAC audio file.
             * @param {String|Number} startTime - The start time for the player can be a string timestamp or time
             * from epoch in milliseconds.
             * @return {Promise}
             */
            play: function (url, startTime) {
                this.logger.debug("play( url = {0}, startTime = {1} )", [url, String(startTime)]);

                // save the URL
                // NOTE: In order for failover to work this is expected to be the variant URL.
                this.currentUrl = url;

                // save the start time
                this.startTime = startTime || this.configuration.startTime || 0;

                // kickoff the playback process
                this.openConnection();

                if (!this.PlayOrPreloadDeferred) {

                    this.PlayOrPreloadDeferred = Q.defer();
                }

                return this.PlayOrPreloadDeferred.promise;
            },

            /**
             * Preloads audio playback by loading manifests and audio files without actually playing audible
             * sounds -- they are "preloaded" and ready for playback for later use.
             *
             * @param {String} url - URL to start playback. Currently either a M3U8 manifest file or AAC audio file.
             * @param {Object} config - The config for the playback.
             * from epoch in milliseconds.
             * @return {Promise}
             */
            preload: function (url, config) {

                // make sure the playback doesn't automatically start playing audio...technically this should
                // already be the case when clients call Player.preload() they are supposed to set autoPlay equal
                // to false, but we'll make sure here just to be safe
                this.autoPlay = false;

                // set the state before calling play to kickoff the preloading process
                this.state = PlayerState.PRELOADING;

                // play takes care of normal manifest and chunk loading process
                return this.play(url, config.startTime);
            },

            /**
             * Stops audio playback.
             *
             * @return {Promise}
             */
            stop: function () {
                var canStop = function () {
                    return !this.isStopped && !this.isStopping;
                }.bind(this);

                if (this.audioElement && canStop()) {
                    this.logger.debug("stop()");

                    // set the state to a stopping process
                    this.state = PlayerState.STOPPING;

                    // stop the playback process
                    this.closeConnection();

                    // set the state to a STOPPED process
                    this.state     = PlayerState.STOPPED;

                    return Q.when(this.state);
                }
                else {
                    this.logger.debug("stop( Already stopped; state = {0} )", [this.state]);
                    return Q.when(this);
                }

            },

            /**
             * Pauses audio playback.
             *
             * @return {Promise}
             */
            pause: function () {
                if (this.audioElement) {
                    this.logger.debug("pause()");
                    this.state = PlayerState.PAUSED;
                    this.audioElement.pause();
                    return Q.when(this.state);
                }
            },

            /**
             * Resumes audio playback.
             *
             * @return {Promise}
             */
            resume: function () {
                if (this.audioElement) {
                    this.logger.debug("resume()");
                    // Always make sure the playback starts audio immediately on a resume.
                    this.autoPlay = true;
                    this.state = PlayerState.PLAYING;

                    var playPromise = this.audioElement.play();
                    return playPromise ? playPromise : Q.when(this.state);
                }
            },

            /**
             * Seeks audio playback to a requested point in time.
             *
             * Seeking will either try to use the current playback instance in order to play as fast as possible (this
             * depends on the requested chunk being in the current playlist) or it'll reset the playback instance and
             * start the playback from the beginning.
             *
             * @param {Number|Date|String} startTime - Can be the offset from the beginning of play in milliseconds
             * or a date or string date object.
             * @param {String} [url] - Optional parameter that provides an HLS URL; if not used the player will try
             * to seek within the current HLS URL.
             * @return {Promise}
             */
            seek: function (startTime) {
                // if the player is already stopped that means we need to just play the track instead of seeking
                if(this.state === PlayerState.STOPPED)
                {
                    this.configuration.startTime = startTime;
                    return this.play(this.currentUrl, startTime);
                }
                var previousState = this.state;

                // If the play is in playing state we will autoplay, if not we will pause the player
                // We need this order, we need to set the autoPlay before we open a connection.
                this.autoPlay = previousState === PlayerState.PLAYING;

                this.startTime = startTime;

                var deferred = Q.defer();
                var self = this;
                var onSeeked = function(event){
                    self.logger.debug('Seek Completed  {0}', [event.type]);
                    self.state = self.autoPlay ? PlayerState.PLAYING : PlayerState.PAUSED;
                    self.audioElement.removeEventListener(MediaElementPlayback.CONSTS.EVENTS.SEEKED,onSeeked);
                    deferred.resolve(self.state);
                };

                this.audioElement.addEventListener(MediaElementPlayback.CONSTS.EVENTS.SEEKED,onSeeked);

                this.audioElement.currentTime = this.getFixedTime(startTime/1000);

                return deferred.promise;
            },

            /**
             * If we want to update the source url, incase  the url got expired especially for pandora MP4
             * Only supports the MP4
             * @param {String} url - The volume for the player.
             */
            updateSource: function (url) {

                this.logger.debug("update source URL to ( {0} )", [url]);
                this.audioElement.src = url;
                this.audioElement.load();
            },

            /**
             * Sets the volume of the audio player.
             * @param {Number} value - The volume for the player.
             */
            setVolume: function (value) {
                this.logger.debug("setVolume( {0} )", [value]);
                this._volume = value;
                this.configuration.volume = value;
                if (this.audioElement) {
                    this.audioElement.volume = value;
                }
            },

            /**
             * Gets the volume of the audio player.
             * @return {Number} vThe volume for the player.
             */
            getVolume: function () {
                if (this.audioElement) {
                    var value = this.audioElement.volume;
                    this.logger.debug("getVolume( {0} )", [value]);
                    return value;
                }
                else if (this._volume) {
                    return this._volume;
                }
                else {
                    return this.configuration.volume;
                }
            },

            //-----------------------------------------------------------------------
            // INTERNAL PLAYER API
            //-----------------------------------------------------------------------

            /**
             * Destroy the Audio PLayer, as there is no close/destry on the Audio, we pause it and make this available for the garbage collection
             */
            destroyAudio: function(){
                if(this.audioElement)
                {
                    this.audioElement.pause();
                    this.audioElement = null;
                }
            },
            /**
             * Create new Audio for playback
             */
            createAudio: function(url){
                var audioElement = new Audio();
                // We will use the player events to play or pause after the playback is ready
                audioElement.autoplay = false;
                audioElement.src = url;
                //We can't set the currentTime in creation of Audio, as Safari doesn't accomadate this
                // audioElement.currentTime = this.getFixedTime(startTime/1000);
                audioElement.load();
                return audioElement;
            },
            /**
             * Kicks off the audio player for most playback functions by creating and setting the AudioContext
             * for the player as well as any controllers and monitors for the player.
             *
             * TODO: BMR: Consider putting into ConnectionManager
             */
            openConnection: function () {
                if (!this._isConnectionOpen) {
                    this.logger.debug("openConnection()");

                    //Reset the metaDataLoaded, it will turned on once we have the event from the Audio Element
                    //If this already checked true, that we already have the metadata available( which will be in seek scenario)
                    this._isMetaDataLoaded = this._isMetaDataLoaded ? this._isMetaDataLoaded : false;

                    this._isConnectionOpen = true;

                    if(!this.audioElement)
                    {
                        this.audioElement = this.createAudio(this.currentUrl);
                    }

                    for (var eventKey in MediaElementPlayback.CONSTS.EVENTS) {
                        this.audioElement.addEventListener( MediaElementPlayback.CONSTS.EVENTS[eventKey], this.handleEvents);
                    }

                    // Must be done after the creation of the AudioSink as that's what uses the volume.
                    this.setVolume(this._volume);

                    this.playbackEventMonitor = new PlaybackEventMonitor(this);
                }
            },

            /**
             * Shuts down the audio player by resetting and clearing out all controllers and monitors.
             *
             * TODO: BMR: Consider putting into ConnectionManager
             */
            closeConnection: function () {
                // only close the connection if it's open and at least least one core component is available
                if (this._isConnectionOpen) {
                    this.logger.debug("closeConnection()");

                    this._isConnectionOpen = false;

                    if(this.audioElement) {
                        for (var eventKey in MediaElementPlayback.CONSTS.EVENTS) {
                            this.audioElement.removeEventListener( MediaElementPlayback.CONSTS.EVENTS[eventKey], this.handleEvents);
                        }
                    }
                    this.destroyAudio();

                    this.playbackEventMonitor.reset();
                    this.playbackEventMonitor = null;
                }
            },

            handleEvents: function(event){

                switch (event.type) {
                    case MediaElementPlayback.CONSTS.EVENTS.WAITING:
                        this.onUnderflow();
                        break;

                    case MediaElementPlayback.CONSTS.EVENTS.LOADED_META_DATA:
                        this.logger.info("Track Meta Data Loaded");
                        this._isMetaDataLoaded = true;
                        break;

                    case MediaElementPlayback.CONSTS.EVENTS.CAN_PLAY_THROUGH:
                        this.logger.info("ready( Player has at least 1 audio chunk ready to play. )");

                        if(this.getFixedTime(this.audioElement.currentTime) < this.getFixedTime(this.startTime/1000)){
                            this.audioElement.currentTime = this.getFixedTime(this.startTime/1000);
                            return;
                        }
                        this.dispatchPlayerEvent(PlayerEvent.PLAYBACK_READY);
                        //  IF we are PRELOADING, update state to PRELOADING_COMPLETE, once we are able to play through
                        //  this is intermediate state, based on autoplay, the state will be set to PLaying or Paused.
                        if(this.state === PlayerEvent.PRELOADING)
                        {
                            this.state = PlayerEvent.PRELOADING_COMPLETE;
                        }
                        if (this.autoPlay) {
                            this.renderPlay();
                        }
                        else if(!this.autoPlay && this.PlayOrPreloadDeferred){
                            // When we are not playing ( autoplay=false) and just preloading, then resolve the
                            // PlayOrPreloadDeferred promise and set it to null
                            this.PlayOrPreloadDeferred.resolve(this.state);
                            this.PlayOrPreloadDeferred = null;
                        }
                        break;

                    case MediaElementPlayback.CONSTS.EVENTS.PAUSED:
                        // this.state = PlayerState.PAUSED;
                        break;

                    case MediaElementPlayback.CONSTS.EVENTS.SEEKING:
                        // Set the state to seeking.
                        this.state = PlayerState.SEEKING;
                        break;

                    case MediaElementPlayback.CONSTS.EVENTS.SEEKED:
                        if(this.autoPlay)
                        {
                            this.renderPlay();
                        }
                        break;

                    case MediaElementPlayback.CONSTS.EVENTS.TIME_UPDATE:

                        // Only dispatch the playhead's when you know the metadata has been loaded by the AudioElement
                        // Otherwise we can have false information ( like duration - NAN)
                        if(this._isMetaDataLoaded)
                        {
                            this.dispatchPlayerEvent(PlayerEvent.PLAYHEAD);
                        }
                        break;

                    case MediaElementPlayback.CONSTS.EVENTS.ENDED:
                        this.logger.info("finished( FINISHED!!! )");
                        this.state = PlayerState.FINISHED;
                        this.dispatchPlayerEvent(PlayerEvent.FINISHED);
                        break;

                    case MediaElementPlayback.CONSTS.EVENTS.ERROR:
                        this.logger.error("Error", event);
                        this.handleError(event);
                        break;

                    default:
                        //These events are not attended, we just log them for development purpose.
                        this.logger.info("Unattended Event", event);
                        break;
                }

            },

            /**
             * Handler to deal with errors which occurred while handling media in an HTML media element
             *
             * @param {Object} event - Event type.
             */
            handleError: function (event){

                switch (event.target.error.code) {

                    case event.target.error.MEDIA_ERR_ABORTED:
                        this.logger.error('You aborted the media playback.');
                        break;

                    case event.target.error.MEDIA_ERR_NETWORK:
                        this.logger.error('A network error caused the media download to fail.');
                        break;

                    case event.target.error.MEDIA_ERR_DECODE:
                        this.logger.error('The media playback was aborted due to a corruption problem or because the media used features your browser did not support.');
                        break;

                    case event.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                        this.logger.error('The media could not be loaded, either because the server or network failed or because the format is not supported.');
                        this.tokenRefresh();
                        break;
                }

                //If we ever failed and we are playing or preloading, then reject the PlayOrPreloadDeferred
                if(this.PlayOrPreloadDeferred){

                    this.PlayOrPreloadDeferred.reject(event.target.error);
                    this.PlayOrPreloadDeferred = null;
                }
            },

            /**
             * Used to trigger play on the audio element and use the promise from the play to see if the playback is blocked or not
             */
            renderPlay: function(){
                var self = this;
                var playPromise = this.audioElement.play();
                // In browsers that don’t yet support this functionality, // playPromise won’t be defined.
                if (playPromise !== undefined) {
                    playPromise.then(function () {
                        self.state = PlayerState.PLAYING;
                        if(self.PlayOrPreloadDeferred)
                        {
                            self.PlayOrPreloadDeferred.resolve(self.state);
                            self.PlayOrPreloadDeferred = null;
                        }
                    }).catch(function (error) {
                        self.logger.error("Error( name = {0}, value = {1} )", [error.name, String(error)]);
                        if (error.name === MediaElementPlayback.CONSTS.EVENTS.NOT_ALLOWED_ERROR) {
                            self.state = PlayerState.PAUSED;
                            self.dispatchPlayerEvent(PlayerEvent.PLAYBACK_DENIED);
                        }
                        if(self.PlayOrPreloadDeferred)
                        {
                            self.PlayOrPreloadDeferred.reject(error);
                            self.PlayOrPreloadDeferred = null;
                        }
                    });
                } else {
                    self.state = PlayerState.PLAYING;
                }
            },
            /**
             * Dispatches a PlayerEvent for client objects using the Playback object. Simplifies what client objects need
             * to know about currently playback and centralizes it here. Allows for optional error parameter as well.
             *
             * @param {String} type - Event type.
             */
            dispatchPlayerEvent: function (type) {
                var playerEvent = new PlayerEvent(
                    type,
                    this.id,
                    this.configuration.playbackType,
                    this.playhead,
                    this.duration,
                    this.startTime,
                    this.bufferTime,
                    (this.audioElement ? (this.audioElement.currentTime + this.bufferTime) : NaN),
                    false,
                    0,
                    null,
                    null
                );
                this.dispatchEvent(playerEvent);
            },


            isReady: function () {
                return this.audioElement ? (this.audioElement.readyState >= 2) : false;
            },

            /**
             * Should acquire the live time.
             *
             * @returns {Number}
             */
            getLiveTime: function () {
                return this.playlist ? this.playlist.getLiveTime() : NaN;
            },

            /**
             * Should return Fixed milliseconds
             * @param {Number} type - number type.
             * @returns {Number}
             */
            getFixedTime: function(milliseconds){
                return  parseFloat(milliseconds.toFixed(3));
            },
            /**
             * Handles no connectivity for the player and announces it to clients using the player with an event.
             */
            noConnectivity: function () {
                this.logger.warn("noConnectivity()");
                this.dispatchPlayerEvent(PlayerEvent.CONNECTIVITY_FAILED);
            },

            /**
             * Handles invalid token for the player and announces it to clients using the player with an event.
             */
            tokenRefresh: function () {
                this.logger.warn("tokenRefresh()");
                this.dispatchPlayerEvent(PlayerEvent.TOKEN_INVALID);
            },


            crossfade: function () {
                // add a check if live or aod, just return;
                this.logger.warn("Not supported()");
            },

            isCrossfadeOn: function () {
                return false;
            },

            isCrossfadeSupported : function () {
                return false;
            }
        };

        return MediaElementPlayback;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/core/Playback.js":
/*!***************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/core/Playback.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/24/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      The Playback object is the workhorse of the player. While the HTML5AudioPlayer object is the front door that allows
 *      clients to control audio, it's merely a facade and API that proxies the work to the Playback object. It
 *      should be noted that the Player uses multiple Playback object instances to improve playback performance; there's
 *      a cost to setting up and tearing down the underlying Audio objects that's ultimately used to play audio
 *      so the approach is to create a clone or copy of a current Playback instance and then tearing down the old one
 *      rather than using one and tearing down and setting up synchronously.
 *
 *      Topics to add here:
 *
 *          * Basic Playback Flow
 *          * Refresh Playlist / Buffer Monitor
 *          * Playhead
 *          * Audio First
 *          * ABR
 *          * Audio Quality
 *          * Failover
 */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require)
  {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var EventDispatcher = __webpack_require__(/*! sxm/audioplayer/html5/event/EventDispatcher */ "./javascript/src/sxm/audioplayer/html5/event/EventDispatcher.js");
    var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
    var ManifestLoader = __webpack_require__(/*! sxm/audioplayer/html5/loader/ManifestLoader */ "./javascript/src/sxm/audioplayer/html5/loader/ManifestLoader.js");
    var KeyLoader = __webpack_require__( /*! sxm/audioplayer/html5/loader/KeyLoader */ "./javascript/src/sxm/audioplayer/html5/loader/KeyLoader.js");
    var ChunkProducer = __webpack_require__(/*! sxm/audioplayer/html5/core/ChunkProducer */ "./javascript/src/sxm/audioplayer/html5/core/ChunkProducer.js");
    var MP4ChunkProducer = __webpack_require__(/*! sxm/audioplayer/html5/core/MP4ChunkProducer */ "./javascript/src/sxm/audioplayer/html5/core/MP4ChunkProducer.js");
    var MP3ChunkProducer = __webpack_require__(/*! sxm/audioplayer/html5/core/MP3ChunkProducer */ "./javascript/src/sxm/audioplayer/html5/core/MP3ChunkProducer.js");
    var ChunkConsumer = __webpack_require__(/*! sxm/audioplayer/html5/core/ChunkConsumer */ "./javascript/src/sxm/audioplayer/html5/core/ChunkConsumer.js");
    var AdtsAacAudioSink = __webpack_require__(/*! sxm/audioplayer/html5/audio/sink/AdtsAacAudioSink */ "./javascript/src/sxm/audioplayer/html5/audio/sink/AdtsAacAudioSink.js");
    var MpegAudioSink = __webpack_require__(/*! sxm/audioplayer/html5/audio/sink/MpegAudioSink */ "./javascript/src/sxm/audioplayer/html5/audio/sink/MpegAudioSink.js");
    var AdtsFlashAudioSink = __webpack_require__(/*! sxm/audioplayer/html5/audio/sink/AdtsFlashAudioSink */ "./javascript/src/sxm/audioplayer/html5/audio/sink/AdtsFlashAudioSink.js");
    var MpegFlashAudioSink = __webpack_require__(/*! sxm/audioplayer/html5/audio/sink/MpegFlashAudioSink */ "./javascript/src/sxm/audioplayer/html5/audio/sink/MpegFlashAudioSink.js");
    var FeedMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/FeedMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/FeedMonitor.js");
    var PlaybackEventMonitor = __webpack_require__(/*! sxm/audioplayer/html5/event/PlaybackEventMonitor */ "./javascript/src/sxm/audioplayer/html5/event/PlaybackEventMonitor.js");
    var PlaylistMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/PlaylistMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/PlaylistMonitor.js");
    var AudioRenderer = __webpack_require__(/*! sxm/audioplayer/html5/audio/render/AudioRenderer */ "./javascript/src/sxm/audioplayer/html5/audio/render/AudioRenderer.js");
    var PlayheadMonitorFactory = __webpack_require__(/*! sxm/audioplayer/html5/monitor/playhead/PlayheadMonitorFactory */ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/PlayheadMonitorFactory.js");
    var ABRMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/ABRMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/ABRMonitor.js");
    var AudioQualityMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/AudioQualityMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/AudioQualityMonitor.js");
    var FailoverMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/FailoverMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/FailoverMonitor.js");
    var PreloadMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/PreloadMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/PreloadMonitor.js");
    var CrossfadeProtocol = __webpack_require__(/*! sxm/audioplayer/html5/model/CrossfadeProtocol */ "./javascript/src/sxm/audioplayer/html5/model/CrossfadeProtocol.js");
    var Manifest = __webpack_require__(/*! sxm/audioplayer/html5/model/Manifest */ "./javascript/src/sxm/audioplayer/html5/model/Manifest.js");
    var Variant = __webpack_require__(/*! sxm/audioplayer/html5/model/Variant */ "./javascript/src/sxm/audioplayer/html5/model/Variant.js");
    var Playlist = __webpack_require__(/*! sxm/audioplayer/html5/model/Playlist */ "./javascript/src/sxm/audioplayer/html5/model/Playlist.js");
    var AssetError = __webpack_require__(/*! sxm/audioplayer/html5/error/AssetError */ "./javascript/src/sxm/audioplayer/html5/error/AssetError.js");
    var AssetType = __webpack_require__(/*! sxm/audioplayer/html5/model/AssetType */ "./javascript/src/sxm/audioplayer/html5/model/AssetType.js");
    var PlayerState = __webpack_require__(/*! sxm/audioplayer/html5/model/PlayerState */ "./javascript/src/sxm/audioplayer/html5/model/PlayerState.js");
    var PlayerEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/PlayerEvent */ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js");
    var AudioPlayerEvent = __webpack_require__(/*! sxm/audioplayer/event/AudioPlayerEvent */ "./javascript/src/sxm/audioplayer/event/AudioPlayerEvent.js");
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
    var PromiseError = __webpack_require__(/*! sxm/audioplayer/html5/error/PromiseError */ "./javascript/src/sxm/audioplayer/html5/error/PromiseError.js");
    var StateChangeEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/StateChangeEvent */ "./javascript/src/sxm/audioplayer/html5/event/StateChangeEvent.js");
    var PlaybackTypeUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaybackTypeUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js");
    var Codec = __webpack_require__(/*! sxm/audioplayer/html5/model/Codec */ "./javascript/src/sxm/audioplayer/html5/model/Codec.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
    var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
    var PromiseUtil = __webpack_require__(/*! sxm/util/PromiseUtil */ "./javascript/src/sxm/util/PromiseUtil.js");
    var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var Timer = __webpack_require__(/*! sxm/audioplayer/html5/util/Timer */ "./javascript/src/sxm/audioplayer/html5/util/Timer.js");
    var Q = __webpack_require__(/*! q */ "q");

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the Playback function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @param {Configuration} config The configuration object for the audio player.
     * @constructor
     */
    function Playback(config) {
      // This first guard ensures that the callee has invoked our Class' constructor function
      // with the `new` keyword - failure to do this will result in the `this` keyword referring
      // to the callee's scope (typically the window global) which will result in the following fields
      // (name and _age) leaking into the global namespace and not being set on this object.
      if (!(this instanceof Playback)) {
        throw new TypeError("Playback constructor cannot be called as a function.");
      }

      // Player IDs are based off the content ID (Live = Channel ID, AOD = Episode ID, MySXM = Track ID),
      // but we also want to capture the Playback instance so we create a UID based off of both:
      // {PlaybackInstanceCounter}-{ContentId}
      var uid = ++Playback.COUNTER + "-" + config.id;

      // NOTE: Unlike loggers in other classes, this one is an class instance member so we can keep
      // track of Playback instances with a counter.
      this.logger = LoggerFactory.getLogger(StringUtil.supplant("Playback[{0}]", [uid]));

      if (ObjectUtil.isUndefinedOrNull(config)) {
        throw new TypeError("Playback constructor must have config object.");
      }

      // Bind the scope of "this" to all first class functions
      ClassUtil.bindFunctions(this);

      // Extend this object with event dispatching capabilities
      EventDispatcher.apply(this);

      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------

      /**
       * The player's ID based on the content ID.
       * @type {String}
       */
      this.id = config.id;

      /**
       * The player's true unique ID based on the instance counter and the content ID.
       * @type {String}
       */
      this.uid = uid;

      /**
       * The player's configuration object contains, well, configs for the player.
       * @type {Configuration}
       */
      this.configuration = config;
  
      /**
       * Update the HlsConfig's WITH_CREDENTIALS if client want's to override the deafult false
       * @type {boolean}
       */
      HlsConfig.WITH_CREDENTIALS = config.withCredentials === false ? false : true;
      
      /**
       * Update the HlsConfig's FAILOVER_RETRY_LIMIT if client want's to override the deafult value 5
       * @type {boolean}
       */
      HlsConfig.FAILOVER_RETRY_LIMIT = +(config.FAILOVER_RETRY_LIMIT !== 0) && (config.FAILOVER_RETRY_LIMIT || HlsConfig.FAILOVER_RETRY_LIMIT_DEFAULT);

      /**
       * The current URL being played. This is most often the initial Variant URL.
       * @type {String}
       */
      this.currentUrl = "";

      /**
       * The initial start time for playback.
       * @type {String|Number|Date}
       */
      this.startTime = null;

      /**
       * Reference to the current manifest variant file. Variants contain a list of possible audio streams
       * according to bit rate. Each bit rate is accompanied by a URL to a playlist.
       * @type {Variant}
       */
      this.variant = null;

      /**
       * Reference to the current manifest playlist file. Playlists contain a list URLs for audio chunk files.
       * Each playlist is for a given bit rate although the playlist doesn't have any knowledge of this.
       * @type {Playlist}
       */
      this.playlist = null;

      /**
       * The HTML5 Web object responsible for audio playback.
       * @type {AdtsAacAudioSink/AdtsFlashAudioSink/MpegAudioSink/MpegFlashAudioSink}
       */
      this.audioSink = null;

      /**
       * Loads variant and playlist manifests.
       * @type {ManifestLoader}
       */
      this.manifestLoader = null;

      /**
       * Loads HLS decryption keys.
       * @type {ManifestLoader}
       */
      this.keyLoader = null;

      /**
       * Controls the loading of chunks via a simple timer.
       * @type {FeedMonitor}
       */
      this.feedMonitor = null;

      /**
       * Controls the event broadcasting from the Playback engine.
       * @type {PlaybackEventMonitor}
       */
      this.playbackEventMonitor = null;

      /**
       * Watches the playlist and determines if it's good to go (and not invalid or stale).
       * @type {PlaylistMonitor}
       */
      this.playlistMonitor = null;

      /**
       * Loads the chunk for playback, effectively "producing" it.
       * @type {ChunkProducer}
       */
      this.chunkProducer = null;

      /**
       * Decrypts and decodes the chunk for playback, effectively "consuming" it.
       * @type {ChunkConsumer}
       */
      this.chunkConsumer = null;

      /**
       * Monitors the playhead or current time for the audio player.
       * @type {PlayheadMonitor}
       */
      this.playheadMonitor = null;

      /**
       * Monitors the loading of chunks and determines if the bit rate should go up, down, or stay the same
       * based on download speeds and thresholds.
       * @type {ABRMonitor}
       */
      this.abrMonitor = null;

      /**
       * Monitors the loading of streams and determines if the one being requested is allowable based
       * on the current audio quality.
       * @type {AudioQualityMonitor}
       */
      this.audioQualityMonitor = null;

      /**
       * Monitors the load of manifests for failures.
       * @type {FailoverMonitor}
       */
      this.manifestFailoverMonitor = null;

      /**
       * Monitors the load and consumption of chunks for failures.
       * @type {FailoverMonitor}
       */
      this.chunkFailoverMonitor = null;

      /**
       * Monitors the load of chunks during preload.
       * @type {PreloadMonitor}
       */
      this.preloadMonitor = null;

      /**
       * stores the crossfade Protocol if there is one.
       * @type {CrossfadeProtocol}
       */
      this.crossfadeProtocol = null;

      /**
       * stores the promise of invalidToken state, so that we wait for any resume commands until the invalidToken is resolved
       * * @type {Promise}
       */
      this.tokenInvalidDefered = null;
      /**
       * The state of the player.
       * @type {String}
       */
      this._state = PlayerState.INITIAL;

      /**
       * Used to keep track of the first chunk consumed when first starting playback or after seeking, as
       * it contains the chunk's timestamp and offset and can therefore be used to set the start time
       * (based on that timestamp and offset). This is currently set in the consumeChunkSuccess() handler.
       * @type {Chunk}
       * @private
       */
      this._firstChunk = null;

      /**
       * Flag indicating if the connection is open, ie we're up and running.
       * @type {Boolean}
       * @private
       */
      this._isConnectionOpen = false;

      /**
       * The volume can be grabbed from the AudioSink but since it's not always available we store it in
       * this property.
       * @type {Number}
       * @private
       */
      this._volume = null;


      /**
       * If the audio renderer underflows, stop the playhead monitor
       * and dispatch an event
       */
      this.onUnderflowing = function onOverflow() {
        this.playheadMonitor.stop();
        this.dispatchPlayerEvent(AudioPlayerEvent.BUFFER_EMPTY);
      }.bind(this);


      /**
       * If the audio renderer is starting, check if it is recovering
       * from an underflow and start the monitor again.
       */
      // eslint-disable-next-line no-unused-vars
      this.onStarting = function (state, oldState) {
        if (oldState === AudioRenderer.STATE.UNDERFLOWING)
        {
          this.playheadMonitor.start();
        }
      }.bind(this);



      this.onDecoderError = function () {
        this.dispatchPlayerEvent(PlayerEvent.DECODER_FAILURE);
      }.bind(this);

      // eslint-disable-next-line no-unused-vars
      this.checkForCrossfadePoint = function (numBuffers, startTimeSecs, bufferDuration, timestamp, renderStartTime) {

        if (!this.configuration) {
          return;
        }

        if (!this.isCrossfadeOn()) {
          return;
        }

        this.crossfadeProtocol =
          this.crossfadeProtocol || new CrossfadeProtocol(
          bufferDuration,
          this.configuration.crossfade,
          this.configuration.duration,
          true
          );

        var elapsedSecs = startTimeSecs + this.crossfadeProtocol.bufferDurationSecs() - renderStartTime;

        if (this.crossfadeProtocol.isCrossfadePointReached(elapsedSecs)) {
          this.dispatchPlayerEvent(PlayerEvent.CROSSFADE_POINT_REACHED);
        }
      }.bind(this);

      /**
       * Indicates the player's current state.
       * @type {String}
       */
      Object.defineProperty(this, "state",
        {
          get: function () {
            return this._state;
          },
          set: function (value) {
            var previousState = this._state;

            if (previousState !== value) {
              this._state = value;
              this.logger.debug("state( old = {0}, new = {1} )", [String(previousState), value]);
              this.dispatchEvent(new StateChangeEvent(this.id, value, previousState));
            }
          }
        });

      /**
       * Read-only accessor indicating if the player is in failover mode.
       * @type {Boolean}
       */
      Object.defineProperty(this, "inFailoverMode",
        {
          get: function () {
            var manifestInFailover = this.manifestFailoverMonitor && this.manifestFailoverMonitor.inFailoverMode;
            var chunkInFailover = this.chunkFailoverMonitor && this.chunkFailoverMonitor.inFailoverMode;
            var abrInFailover = this.abrMonitor && this.abrMonitor.inFailoverMode;
            return manifestInFailover || chunkInFailover || abrInFailover;
          },
          set: function (value) {
            if (this.manifestFailoverMonitor) {
              this.manifestFailoverMonitor.inFailoverMode = value;
            }
            if (this.chunkFailoverMonitor) {
              this.chunkFailoverMonitor.inFailoverMode = value;
            }
            if (this.abrMonitor) {
              this.abrMonitor.inFailoverMode = value;
            }
          }
        });

      /**
       * Sets the autoPlay setting.
       * @type {Boolean}
       */
      Object.defineProperty(this, "autoPlay",
        {
          get: function () {
            return this.configuration ? this.configuration.autoPlay : false;
          },
          set: function (value) {
            if (this.configuration) {
              this.configuration.autoPlay = value;
            }
            if (this.audioSink) {
              this.audioSink.autoStart = value;
            }
          }
        });

      /**
       * Read-only accessor for the player's buffer time in milliseconds.
       * @type {Number}
       */
      Object.defineProperty(this, "bufferTime",
        {
          get: function () {
            return this.audioSink ? this.audioSink.getBufferTime() : 0;
          }
        });
      
      /**
       * Read-only accessor for the player's duraiton time in milliseconds.
       * @type {Number}
       */
      Object.defineProperty(this, "duration",
        {
          get: function () {

            if(this.flashRenderer && PlaybackTypeUtil.isPlayerMP3(this))
            {
              return this.audioSink.renderer.duration;
            }
            else if (PlaybackTypeUtil.isPlayerTrackBased(this)) {
              return this.chunkProducer.getTrackDuration();
            }
            else {
              return this.playlist ? this.playlist.duration : 0;
            }
          }
        });

      /**
       * Read-only accessor for the player's buffer percent compared to the expected, minimum buffer.
       * @type {Number}
       */
      Object.defineProperty(this, "bufferPercent",
        {
          get: function () {
            return (this.bufferTime / HlsConfig.BUFFER_TIME) * 100;
          }
        });

      /**
       * Read-only accessor indicating if the underlying audio stream has ended.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isLive",
        {
          get: function () {
            return PlaybackTypeUtil.isPlayerLive(this);
          }
        });

      /**
       * Read-only accessor indicating if the audio player is playing.
       *
       * There are cases where the internal, core AudioSink's state for playing is actually set before
       * the Playback instance's playing state is set, so we check for either case.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isPlaying",
        {
          get: function () {
            var corePlaying = this.audioSink && (this.audioSink.state !== AdtsAacAudioSink.AUDIO_CONTEXT_STATE.SUSPENDED);
            var playbackPlaying = (this.state === PlayerState.PLAYING);
            // NOTE: BMR: 03/09/2017: The addition of the check on isPaused was added fro Chromecast...could break normal
            // client playback so keep an eye on this.
            var actuallyPlaying = !this.isInitialized && !this.isPreloading && !this.isPaused && !this.isStopped && !this.isStopping && !this.isFinished;
            return actuallyPlaying && (corePlaying || playbackPlaying);
          }
        });

      /**
       * Read-only accessor indicating if the audio player is paused.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isPaused",
        {
          get: function () {
            return (this.state === PlayerState.PAUSED);
          }
        });
      
      /**
       * Read-only accessor indicating if the audio player is Finished.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isFinished",
        {
          get: function () {
            return (this.state === PlayerState.FINISHED);
          }
        });

      /**
       * Read-only accessor indicating if the audio player is stopped.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isStopped",
        {
          get: function () {
            return (this.state === PlayerState.STOPPED);
          }
        });


      /**
       * Read-only accessor indicating if the underlying audio stream has ended.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isEnded",
        {
          get: function () {
            return this.chunkProducer.isEnded;
          }
        });

      /**
       * Read-only accessor indicating if the audio player is in the process of stopping but not actually stopped.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isStopping",
        {
          get: function () {
            return (this.state === PlayerState.STOPPING);
          }
        });

      /**
       * Read-only accessor indicating if the audio player is preloading.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isPreloading",
        {
          get: function () {
            return (this.state === PlayerState.PRELOADING);
          }
        });

      /**
       * Read-only accessor indicating if the audio player is initialized.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isInitialized",
        {
          get: function () {
            return (this.state === PlayerState.INITIAL);
          }
        });

      /**
       * Read-only accessor indicating if playback has ever played audio.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "hasPlayed",
        {
          get: function () {
            return (this.playhead > 0);
          }
        });

      /**
       * Read-only accessor for the current zero-based playhead value.
       *
       * @type {Number}
       */
      Object.defineProperty(this, "playhead",
        {
          get: function () {
            return this.playheadMonitor ? this.playheadMonitor.getPlayhead() : 0;
          }
        });
    }

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Indicates the actual instance counter for this object.
     */
    Playback.COUNTER = 0;

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our Playback class, we could write:
     *
     *  `BankManager.prototype = Playback.prototype`
     *  `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    Playback.prototype = {

      /**
       * Whenever you replace an Object's Prototype, you need to repoint
       * the base Constructor back at the original constructor Function,
       * otherwise `instanceof` calls will fail.
       */
      constructor: Playback,

      //-----------------------------------------------------------------------
      // PUBLIC PLAYER API
      //-----------------------------------------------------------------------

      /**
       * Begins audio playback.
       *
       * @param {String} url - URL to start playback. Currently either a M3U8 manifest file or AAC audio file.
       * @param {String|Number} startTime - The start time for the player can be a string timestamp or time
       * from epoch in milliseconds.
       * @return {Promise}
       */
      play: function (url, startTime) {
        this.logger.debug("play( url = {0}, startTime = {1} )", [url, String(startTime)]);

        var isChunk = function (url) {
          return url.indexOf(".aac") !== -1
            || url.indexOf(".mp4") !== -1
            || url.indexOf(".pandora.com") !== -1
            || url.indexOf("seeded-audio") !== -1;
        };

        // save the URL
        // NOTE: In order for failover to work this is expected to be the variant URL.
        this.currentUrl = this.getDefaultUrl(url, startTime);

        // save the start time
        this.startTime = startTime || this.configuration.startTime || null;

        // kickoff the playback process
        this.openConnection(this.flashRenderer);

        if (!this.inFailoverMode &&
          !this.configuration.lockInMaximumBitrate &&
          this.configuration.audioFirst &&
          this.configuration.audioFirst.canPlay(this.startTime)) {
          return this.startAudioFirstPlayback(this.currentUrl, this.configuration.audioFirst);
        }
        else if (PlaybackTypeUtil.isPlayerTrackBased(this)) {
          return this.loadSingleTrackAt(url, this.startTime);
        }
        // play a chunk
        else if (isChunk(url)) {
          return this.loadChunk(url)
            .then(this.consumeChunk);
        }
        // play anything else -- this is really expecting a HLS manifest file, either as a
        // variant or a playlist
        else {
          return this.startPlayback(this.currentUrl);
        }
      },

      /**
       * Preloads audio playback by loading manifests and audio files without actually playing audible
       * sounds -- they are "preloaded" and ready for playback for later use.
       *
       * @param {String} url - URL to start playback. Currently either a M3U8 manifest file or AAC audio file.
       * @param {Object} config - The config for the playback.
       * from epoch in milliseconds.
       * @return {Promise}
       */
      preload: function (url, config) {
        var releasePreloadPromise = function (isFullyPreloaded) {
          var completelyPreloaded = (isFullyPreloaded && (this.state === PlayerState.PRELOADING));
          this.state = completelyPreloaded ? PlayerState.PAUSED : this.state;
          if (this.preloadDeferred) {
            this.preloadDeferred.resolve(this);
            this.preloadDeferred = null;
          }
        }.bind(this);

        var rejectPreloadPromise = function (error) {
          if (this.preloadDeferred) {
            this.preloadDeferred.reject(error);
            this.preloadDeferred = null;
          }
        }.bind(this);

        var preloadComplete = function (isFullyPreloaded) {
          // Make sure this is only ever true if it's been passed as true.
          isFullyPreloaded = (isFullyPreloaded === true);
          var logMsg = isFullyPreloaded ? "Completely" : "Partially (minimum)";

          var url;

          if (this.playlist && this.playlist.isAudioFirst && this.configuration.audioFirst) {
            url = this.configuration.audioFirst.getChunk();
          }
          else {
            url = this.currentUrl;
          }

          this.logger.info("preloadComplete( {0} preloaded url = {1} )", [logMsg, url]);
          releasePreloadPromise(isFullyPreloaded);
        }.bind(this);

        var preloadFailed = function (error) {
          this.logger.error("preloadFailed( {0} url = {1} )", [error, url]);
          rejectPreloadPromise(error);
        }.bind(this);

        // make sure the playback doesn't automatically start playing audio...technically this should
        // already be the case when clients call Player.preload() they are supposed to set autoPlay equal
        // to false, but we'll make sure here just to be safe
        this.autoPlay = false;

        // if all of the chunks have been loaded then don't bother preloading
        var areAllChunksLoaded = ObjectUtil.isUndefinedOrNull(this.playlist) ? false : this.playlist.areAllChunksLoaded;
        if (!areAllChunksLoaded) {
          this.logger.debug("preload( url = {0}, startTime = {1} )", [url, (!!config) ? String(config.startTime) : "none"]);

          // Create our own promise so it's not part of the play() method's promise chain. This allows
          // us to control the flow separately and only truly resolve the preload's promise when
          // it's done (and not when play()'s promise is fulfilled).
          //
          // In addition, we'll save the deferred object as class member and only resolve it when the preload
          // was truly successful. This is helpful when the app is first loading and failover is applied to
          // the first preload() call...in this case we want to save the original promise that the client
          // is expecting so the client's promise chain is in tact and flows as expected.
          if (!this.preloadDeferred) {
            this.preloadDeferred = Q.defer();
          }

          // set the state before calling play to kickoff the preloading process
          this.state = PlayerState.PRELOADING;

          // play takes care of normal manifest and chunk loading process
          this.play(url, config.startTime)
            // eslint-disable-next-line dot-notation
            .then(preloadComplete)["catch"](preloadFailed);

          // set the preload min and complete handler after play so the monitor is available
          this.preloadMonitor.onMinimumPreloadedCallback = preloadComplete;
          this.preloadMonitor.onCompleteCallback = preloadComplete;
          this.preloadMonitor.onFailedCallback = preloadFailed;

          return this.preloadDeferred.promise;
        }
        else {
          this.logger.debug("preload( Don't bother as all chunks already loaded. )", [url, config.startTime]);
          return Q.when(this);
        }
      },

      /**
       * Stops audio playback.
       *
       * @return {Promise}
       */
      stop: function () {
        var canStop = function () {
          return !this.isStopped && !this.isStopping;
        }.bind(this);

        if (this.audioSink && canStop()) {
          this.logger.debug("stop()");

          // set the state to a stopping process
          this.state = PlayerState.STOPPING;

          // stop the playback process
          this.closeConnection();

          // stop audio and make sure this promise returns a reference to the stopped Playback instance
          return this.audioSink.stop()
                     .then(stopSuccess.bind(this));
        }
        else {
          this.logger.debug("stop( Already stopped; state = {0} )", [this.state]);
          return Q.when(this);
        }

        function stopSuccess() {
          this.state     = PlayerState.STOPPED;
          this.audioSink = null;

          this.logger.info("stop( Playback officially shutdown! )");

          return Q.when(this);
        }
      },

      /**
       * Pauses audio playback.
       *
       * @return {Promise}
       */
      pause: function () {
        if (this.audioSink) {
          this.logger.debug("pause()");
          this.state = PlayerState.PAUSED;
          return this.audioSink.pause();
        }
      },

      /**
       * Resumes audio playback.
       *
       * @return {Promise}
       */
      resume: function () {
        if (this.audioSink) {
          this.logger.debug("resume()");

          // Always make sure the playback starts audio immediately on a resume.
          this.autoPlay = true;

          // Handles the case where the player is in the middle of preloading and is asked to play
          // audio or resume audio playback. This forces the "preloadingComplete" event to fire
          // and the preload promise to resolve.
          if (this.preloadMonitor && this.isPreloading) {
            this.preloadMonitor.preloadComplete();
          }
          
          //If we in tokenInvalid state, we are waiting for track to be recovered:
          if (this.tokenInvalidDefered) {
            var self = this;
            return this.tokenInvalidDefered.promise.then(function () {
              self.state = PlayerState.PLAYING;
              return self.audioSink.resume();
            }).catch(function (){
              self.state = PlayerState.PAUSED;
              return Q.reject('Resume failed due to failure of asset Load');
            });
          } else {
            this.state = PlayerState.PLAYING;
            return this.audioSink.resume();
          }
        }
      },

      /**
       * Seeks audio playback to a requested point in time.
       *
       * Seeking will either try to use the current playback instance in order to play as fast as possible (this
       * depends on the requested chunk being in the current playlist) or it'll reset the playback instance and
       * start the playback from the beginning.
       *
       * @param {Number|Date|String} startTime - Can be the offset from the beginning of play in milliseconds
       * or a date or string date object.
       * @param {String} [url] - Optional parameter that provides an HLS URL; if not used the player will try
       * to seek within the current HLS URL.
       * @return {Promise}
       */
      seek: function (startTime) {
        var previousState = this.state;
        /**
         * Seeks audio playback to a requested point in time within the current playlist, so a new playlist
         * is NOT required and the player can simply load the chunk from the current playlist.
         */
        var playAtChunk = function () {
          this.logger.debug("seek.playAtChunk( startTime = {0} )", [startTime]);

          // Find the chunk to load and play -- this grabs the exact chunk to load, but since we're
          // always grabbing the next index as part of the normal playback flow we'll decrement this by
          // passing in "true" as the second parameter. The 3rd param is also specified as true to
          // make sure the initial chunk offset or sub-seek is set.
          this.playlist.startAt(startTime, true, true);

          // Load, consume, and play the requested chunk
          return this.loadAndConsumeChunk().fail(this.reportError);
        }.bind(this);

        /**
         * Seeks audio playback to a requested point in time NOT within the current playlist, so a new
         * variant and playlist are requested before loading chunks.
         */
        var resetAndPlay = function () {
          this.logger.debug("seek.resetAndPlay( startTime = {0} )", [startTime]);

          // Save the start time for seeking since we're starting playback as if we were starting
          // for the first time, except that we're starting from a particular timestamp.
          this.startTime = startTime;
          if(PlaybackTypeUtil.isPlayerTrackBased(this))
          {
            //Don't send the url as we already playing the track, it will use the same url for the seek
            return this.loadSingleTrackAt(null, this.startTime);
          }
          
          return this.startPlayback(this.currentUrl).fail(this.reportError);
        }.bind(this);

        var seekAndLoad = function () {
          // Stop the current audio playback.
          this.stop();

          // Set the state to seeking.
          this.state = PlayerState.SEEKING;

          // If the `startTime` prop is <= 0 then we'll grab the first chunk's timestamp in the playlist's.
          // This is specific to MySXM, so we might need to add a check to only do this for My...something
          // to consider in the future.
          startTime = startTime <= 0 && this.playlist ? this.playlist.firstChunkTime : startTime;

          // Open the connection to start playback -- theoretically not necessary but can't hurt either
          // since the method determines that internally
          this.openConnection(this.flashRenderer);

          //If the play is in playing state we will autoplay, if not we will pause the player
          this.autoPlay = previousState === PlayerState.PLAYING;

          // Reset the first chunk being consumed so we can grab the correct timestamp and offset for
          // the first seek chunk when the ready() method is called and sets the starting time.
          // This is currently set in the consumeChunkSuccess() handler.
          this._firstChunk = null;

          // Reset the playback ready flag so the ready() is called again once we have the first chunk
          // consumed from seeking.
          this.feedMonitor.isPlaybackReady = false;

          // If the requested seek time is in the playlist then go ahead and simply start playback
          // from the chunk matching the time, otherwise start normal playback by requesting the
          // variant, then manifest, then requested chunks by start time.
          if (this.variant && this.playlist && this.playlist.isInRange(startTime)) {
            return playAtChunk();
          }
          else {
            return resetAndPlay();
          }
        }.bind(this);

        var updateState = function () {
          this.state = this.autoPlay ? PlayerState.PLAYING : PlayerState.PAUSED;
        }.bind(this);

        return seekAndLoad()
          .then(updateState)
          .fail(this.reportError)
          .finally(this.playbackRequestComplete);
        /* jshint ignore:line */
      },
  
      /**
       * If we want to update the source url, incase  the url got expired especially for pandora MP4
       * Only supports the MP4
       * @param {String} url - The volume for the player.
       */
      updateSource: function (url) {
        
        this.logger.debug("update source URL to ( {0} )", [url]);
        if (this.flashRenderer && PlaybackTypeUtil.isPlayerMP3(this))
        {
          this.currentUrl = url;
          this.audioSink.load(url);
        }
        else if (PlaybackTypeUtil.isPlayerTrackBased(this))
        {
          this.currentUrl = url;
          this.chunkProducer.updateSource(url);
          var self = this;
          this.fetchAndConsumeSingleTrackChunks(null, this.startTime)
              .then(function () {
                if (self.tokenInvalidDefered) {
                  self.tokenInvalidDefered.resolve();
                  self.tokenInvalidDefered = null;
                }
              })
              .catch(function () {
                if (self.tokenInvalidDefered) {
                  self.tokenInvalidDefered.reject();
                  self.tokenInvalidDefered = null;
                }
              });
        }
        else {
          this.logger.error("Not handled the updating source for non seeded playback types ( {0} )", [url]);
        }
      },
      
      /**
       * Sets the volume of the audio player.
       * @param {Number} value - The volume for the player.
       */
      setVolume: function (value) {
        this.logger.debug("setVolume( {0} )", [value]);
        this._volume = value;
        this.configuration.volume = value;
        if (this.audioSink) {
          this.audioSink.volume = value;
        }
      },

      /**
       * Gets the volume of the audio player.
       * @return {Number} vThe volume for the player.
       */
      getVolume: function () {
        if (this.audioSink) {
          var value = this.audioSink.volume;
          this.logger.debug("getVolume( {0} )", [value]);
          return value;
        }
        else if (this._volume) {
          return this._volume;
        }
        else {
          return this.configuration.volume;
        }
      },

      /**
       * Clones this instance of Playback. Commonly used when seeking for faster playback.
       */
      clone: function () {
        var instance = new Playback(this.configuration);
        instance.variant = this.variant;
        instance.playlist = this.playlist;
        instance._volume = this._volume;
        instance.currentUrl = this.currentUrl;
        instance.state = this.state;

        // Save the cached chunks so they don't have to be downloaded again.
        if (this.chunkProducer) {

          var decodeWhenPaused;

          if (PlaybackTypeUtil.isPlayerTrackBased(this)) {

            // TODO: As we don't have the cache system for the Mp4/MP3ChunkProducer,so clone the instance variables
            // over to playback clone

            if (PlaybackTypeUtil.isPlayerMP4(this)) {
              instance.chunkProducer = new MP4ChunkProducer(this.chunkProducer.chunkCache, instance.noConnectivity, instance.tokenRefresh, instance.configuration);
              instance.chunkProducer._mp4File.appendData(this.chunkProducer._mp4File.mediaBuffer.arrayBuffer, this.chunkProducer._mp4File.contentRange);

            }
            else {
              instance.chunkProducer = new MP3ChunkProducer(instance.noConnectivity, instance.tokenRefresh, instance.configuration);
              instance.chunkProducer._mp3File.appendData(this.chunkProducer._mp3File.mediaBuffer.arrayBuffer, this.chunkProducer._mp3File.contentRange);
            }

            // instance.chunkProducer._lastChunkProducedSlice = this.chunkProducer._lastChunkProducedSlice;
            // instance.chunkProducer._url = this.chunkProducer._url;
            // instance.chunkProducer.key = this.configuration.key;
            // instance.chunkProducer._cipher = this.chunkProducer._cipher;
            
            instance.chunkProducer.startLoading(this.chunkProducer._url, this.configuration.key);
            // TODO: Will need to modify this logic once we have common chunkProducer for both Mp4 and Mp3 and also remove the dead code here
            instance.chunkProducer._load._isEnded = this.chunkProducer._load._isEnded;
            // instance.chunkProducer.tokenRefresh = instance.tokenRefresh;
            decodeWhenPaused = false;
          }
          else {
            instance.chunkProducer = new ChunkProducer(this.chunkProducer.chunkCache, instance.noConnectivity, instance.tokenRefresh);
            decodeWhenPaused = true;
          }

          if (instance.audioSink) { instance.audioSink.decodeWhenPaused = decodeWhenPaused; }
        }

        // DO NOT set the state to the last as it breaks the playhead not being dispatched after seeking
        //instance.state = this.state;

        return instance;
      },

      //-----------------------------------------------------------------------
      // INTERNAL PLAYER API
      //-----------------------------------------------------------------------

      /**
       * Kicks off the audio player for most playback functions by creating and setting the AudioContext
       * for the player as well as any controllers and monitors for the player.
       *
       * TODO: BMR: Consider putting into ConnectionManager
       */
      openConnection: function (flashRenderer) {
        if (!this._isConnectionOpen) {
          this.logger.debug("openConnection()");

          this._isConnectionOpen = true;

          // NOTE: This must always be first as other objects in the chain rely on it -- it's the
          // core wrapper to the Web Audio API's AudioContext object

          var feeder = PlaybackTypeUtil.isPlayerTrackBased(this) ? this : null;

          if(flashRenderer)
          {
            var FlashAudioSinkConstructor = PlaybackTypeUtil.isPlayerMP3(this) ? MpegFlashAudioSink : AdtsFlashAudioSink;
            this.audioSink = new FlashAudioSinkConstructor(Playback.COUNTER, this, flashRenderer);
          }
          else{
            var AudioSinkConstructor = PlaybackTypeUtil.isPlayerMP3(this) ? MpegAudioSink : AdtsAacAudioSink;
            this.audioSink = new AudioSinkConstructor(Playback.COUNTER, feeder);
          }
          
          this.audioSink.autoStart = this.autoPlay;

          this.audioSink.registerStateNotificationHandler(AudioRenderer.STATE.UNDERFLOWING, this.onUnderflowing);
          this.audioSink.registerStateNotificationHandler(AudioRenderer.STATE.STARTING, this.onStarting);

          this.audioSink.addEventListener(PlayerEvent.DECODER_FAILURE, this.onDecoderError);
          this.audioSink.registerNotificationHandler(this.checkForCrossfadePoint);

          // Must be done after the creation of the AudioSink as that's what uses the volume.
          this.setVolume(this._volume);

          // Fulfill the producer / consumer pattern.
          // Try to reuse chunks already downloaded from a seeking playback instance.
          if (!this.chunkProducer) {
            if (PlaybackTypeUtil.isPlayerMP4(this)) {
              this.chunkProducer = new MP4ChunkProducer([], this.noConnectivity, this.tokenRefresh, this.configuration);
            }
            else if (PlaybackTypeUtil.isPlayerMP3(this)) {
              this.chunkProducer = new MP3ChunkProducer(this.noConnectivity, this.tokenRefresh, this.configuration);
            }
            else {
              this.chunkProducer = new ChunkProducer([], this.noConnectivity, this.tokenRefresh);
            }
          }

          this.chunkConsumer = new ChunkConsumer(this.audioSink);

          // create loaders and monitors
          this.manifestLoader = new ManifestLoader(this.noConnectivity, this.tokenRefresh);
          this.keyLoader = new KeyLoader();
          this.playheadMonitor = PlayheadMonitorFactory.create(this);
          this.feedMonitor = new FeedMonitor(this);
          this.playbackEventMonitor = new PlaybackEventMonitor(this);
          this.playlistMonitor = new PlaylistMonitor(this);
          this.abrMonitor = new ABRMonitor(this);
          this.audioQualityMonitor = new AudioQualityMonitor(this);
          this.chunkFailoverMonitor = new FailoverMonitor(this, AssetType.CHUNK, Timer);
          this.manifestFailoverMonitor = new FailoverMonitor(this, AssetType.MANIFEST, Timer);
          this.preloadMonitor = new PreloadMonitor(this);
        }
      },

      /**
       * Shuts down the audio player by resetting and clearing out all controllers and monitors.
       *
       * TODO: BMR: Consider putting into ConnectionManager
       */
      closeConnection: function () {
        // only close the connection if it's open and at least least one core component is available
        if (this._isConnectionOpen && this.chunkConsumer) {
          this.logger.debug("closeConnection()");

          this.audioSink.deregisterStateNotificationHandler(AudioRenderer.STATE.UNDERFLOWING, this.onUnderflowing);
          this.audioSink.deregisterStateNotificationHandler(AudioRenderer.STATE.STARTING, this.onStarting);

          this.audioSink.removeEventListener(PlayerEvent.DECODER_FAILURE, this.onDecoderError);
          this.audioSink.deregisterNotificationHandler(this.checkForCrossfadePoint);

          if(this.flashRenderer)
          {
            this.audioSink.close();
          }
          this._isConnectionOpen = false;

          // immediately stop requesting HLS assets -- do this first
          this.feedMonitor.stopFeed();

          // kill the chunk producer and consumer
          this.chunkProducer.reset();
          this.chunkProducer = null;
          this.chunkConsumer.reset();
          this.chunkConsumer = null;

          // reset and kill all loaders and monitors
          this.manifestLoader.reset();
          this.manifestLoader = null;

          this.keyLoader.reset();
          this.keyLoader = null;

          this.feedMonitor.reset();
          this.feedMonitor = null;

          this.playbackEventMonitor.reset();
          this.playbackEventMonitor = null;

          this.playlistMonitor.reset();
          this.playlistMonitor = null;

          this.playheadMonitor.reset();
          this.playheadMonitor = null;

          this.abrMonitor.reset();
          this.abrMonitor = null;

          this.audioQualityMonitor.reset();
          this.audioQualityMonitor = null;

          this.chunkFailoverMonitor.reset();
          this.chunkFailoverMonitor = null;

          this.manifestFailoverMonitor.reset();
          this.manifestFailoverMonitor = null;

          this.preloadMonitor.reset();
          this.preloadMonitor = null;
        }
      },

      /**
       * Promised based HLS manifest loader that internally handles the success and failures. Applies
       * manifest monitoring so we can failover to the next server if necessary.
       *
       * NOTE: Advanced promise handling here. Typically the loadManifest(url) method is called directly
       * after the startLoad() method BUT the loadManifest(url) requires a URL parameter. To ensure proper
       * promise chaining we expose a resolver method to the startLoad() or chain initiator calling
       * loadManifest(url) so we can pass in the URL parameter and still work within a promise chain.
       *
       * @param {String} url - The URL for the manifest.
       * @returns {Promise}
       */
      loadManifest: function (url) {
        var loadManifestSuccess = function (data) {
          this.logger.info("loadManifestSuccess( url = {0} )", [url]);
          return data;
        }.bind(this);

        var loadManifestFault = function (fault) {
          this.logger.warn("loadManifestFault( url = {0}, fault = {1} )", [fault.url, fault.httpStatus]);
          throw fault;
        }.bind(this);

        if (this.manifestLoader) {
          // Load the manifest, but watch it for failures with the failover monitor.
          // Watching effectively intercepts the promise and hands it back ONLY after it's done, which
          // allows the failover process to take over if necessary.
          this.logger.debug("loadManifest( url = {0} )", [url]);
          var promise = this.manifestLoader.load(url);
          promise = this.manifestFailoverMonitor.watch(promise);
          return promise.then(loadManifestSuccess, loadManifestFault);
        }

        var deferred = Q.defer();

        deferred.reject("no loader");

        return deferred.promise;
      },

      /**
       * Attempts to refresh an infinite playlist. The playlist monitor is used to watch and monitor
       * the load of the playlist and specifically checks for invalid or stale playlists and retries
       * the refresh if necessary.
       *
       * @param {String} [url=this.playlist.url] - The URL for the playlist to refresh.
       */
      refreshPlaylist: function (url) {
        url = ObjectUtil.isUndefinedOrNullOrEmptyString(url) ? this.playlist.url : url;
        this.logger.info("refreshPlaylist( url = {0} )", [url]);

        this.feedMonitor.startLoad(url)
          .then(this.loadManifest)
          .then(this.playlistMonitor.watch)
          .then(this.acquireStream)
          .fail(this.reportError)
          .finally(this.feedMonitor.finishLoad);
        /* jshint ignore:line */
      },

      /**
       * Promised manifest handling -- if the manifest is a Variant, then load the playlist for the
       * current bit rate. If the manifest is a Playlist, then update the internal reference to the playlist
       * and it's current index based on the last chunk date played.
       *
       * Handles setting the Playlist index for both audio first and normal playback.
       *
       * @param {Variant|Playlist} manifest - Either a Variant or Playlist manifest.
       * @returns {Promise}
       */
      acquireStream: function (manifest) {
        /**
         * Updates the internal reference to the new Playlist object and sets the chunk index to load.
         * @param {Playlist} playlist - The new, updated playlist to save.
         * @return {Playlist} Reference to the new playlist.
         */
        var updatePlaylist = function (playlist) {
          // tell the new playlist to skip into the playlist based on audio first chunks
          var audioFirst = this.configuration.audioFirst;
          if ((audioFirst && audioFirst.success) && (this.playlist && this.playlist.isAudioFirst)) {
            this.logger.debug("acquireStream.updatePlaylist( Skipping for Audio First. )");
            playlist.skipForAudioFirst(this.configuration.audioFirst);
          }
          // if this is an updated playlist (loaded after changing streams or due to not enough data
          // in the buffer), then we need to update the playlist's index to that of the current chunk
          else {
            // TODO: BMR: We might want to consider doing the decrement in FailoverMonitor for failed chunk loads, but then it knows a lot about the playback process
            // Use either the start time passed into the play() method or the current chunk date
            // for normal ABR stream changing (aka we're switching to a new playlist with a
            // different bit rate than current stream).
            var date = this.startTime || (this.playlist ? this.playlist.currentChunkDate : null);

            // This must must be set here since `startTime` is set to null right after this.
            var useStartTime = !ObjectUtil.isUndefinedOrNullOrEmptyString(this.startTime);

            // We only want to use the saved `startTime` property once, which is usually in the case
            // of failover or starting playback from a specific timestamp without using audio first
            // and a start time is passed into the play() method.
            this.startTime = null;

            // Determine if we're recovering from a failed chunk and need to make sure we load
            // the failed chunk -- due to normal loading we always grab the next chunk, so
            // auto decrementing makes us grab the failed one.
            var autoDecrement = useStartTime || this.inFailoverMode;

            // We only want to use the saved `inFailoverMode` property once, which is usually in the case
            // of failover. If we don't reset this it'll always decrement when loading a new
            // playlist and grab one chunk back when not in failover, which grabs the same chunk
            // again

            // Find the chunk to load and play -- this grabs the exact chunk to load, but since we're
            // always grabbing the next index as part of the normal playback flow we'll decrement this by
            // passing in `true` as the second parameter if we're in failover mode. The 3rd param is
            // specified as `false` to make sure the initial chunk offset or sub-seek is NOT set.

            // Jordan D. Nelson - if we are using a start time we should sub seek into the chunk.
            // TODO: 072718 - investigate removing this no subseeking code entirely.
            var shouldSubSeek = useStartTime ? true : false;

            playlist.startAt(date, autoDecrement, shouldSubSeek);

            this.logger.debug("acquireStream.updatePlaylist( Set chunk index = {0}. )", [playlist.index]);
          }

          return playlist;
        }.bind(this);

        if (manifest) {
          // if the manifest has streams, then it's a variant...otherwise it's a playlist
          if ((manifest instanceof Variant) && !ObjectUtil.isUndefinedOrNull(manifest.streams)) {
            this.logger.debug("acquireStream( Using Variant )");
            this.variant = manifest;

            return this.loadStreamAt(
              this.configuration.lockInMaximumBitrate ? Variant.MAX_BIT_RATE_INDEX : Variant.MIN_BIT_RATE_INDEX,
              this.startTime
            );
          }
          else if (manifest instanceof Playlist) {
            this.logger.debug("acquireStream( Using Playlist )");

            // update the Playback instance's playlist and set the starting index
            this.playlist = updatePlaylist(manifest);

            // index might be -1 if playhead is way behind lastest playlist
            if (this.playlist.index === -1 && this.inFailoverMode) {
              this.inFailoverMode = false;
              this.dispatchPlayerEvent(PlayerEvent.BEHIND_PLAYLIST);
              this.stop();
            }
            this.inFailoverMode = false;

            // Add the codec to the playlist by grabbing it from the variant.
            this.playlist.codec = (this.variant) ? this.variant.getCurrentStreamCodec() : null;

            return Q.when(this.playlist);
          }
          else {
            // Both rejecting the promise and throwing an error manually work and will
            // stop the original promise chain...using error as it provides a bit more info
            // in the console's stack trace
            var err = "The manifest must either be a Variant or Playlist object.";
            this.logger.warn("acquireStream( Error = {0} )", [err]);
            throw new TypeError(err);
          }
        }
      },

      /**
       * Promised based playlist loading for the specified (or default) Stream, then load the first chunk for that stream.
       *
       * @param {Number} streamIndex - The index of the stream to start playing. The index is relative to the list
       * of streams provided by the variant manifest (which provides multiple streams according to bit rate)
       * and ultimately loads the playlist for that bit rate.
       * @param {Date|Number|String} startTime - A time value for the playback to start at. This is currently
       * only used when the method is called by FailoverMonitor.
       * @returns {Promise}
       */
      loadStreamAt: function (streamIndex, startTime) {
        // default to null if not passed as an argument
        // TODO: BMR: Does this break ABR Failover?
        //var useStartTime = this.inFailoverMode && !ObjectUtil.isUndefinedOrNullOrEmptyString(startTime);
        var useStartTime = !ObjectUtil.isUndefinedOrNullOrEmptyString(startTime);
        this.startTime = useStartTime ? startTime : null;

        var stream = this.variant.getStreamByIndex(streamIndex);
        var canPlayStream = (this.audioQualityMonitor) ? this.audioQualityMonitor.isStreamPlayable(stream) : false;

        // Only load a chunk if the player is not already trying to load one. We can simply avoid loading
        // a chunk when calling loadStreamAt() as the FeedMonitor will alwchays check if we have enough
        // chunks for the buffer. However, we still allow the load of a new stream, aka a new Playlist,
        // just not a chunk b/c it could interrupt the current chunk feed and asynchronously load the
        // wrong chunk order.
        var loadAndConsumeChunk = function () {
          var loadChunk = !this.feedMonitor || (this.chunkProducer && !this.chunkProducer.isLoading);
          if (!loadChunk) {
            this.logger.info("loadStreamAt( Don't load chunk as we're currently loading one. )");
          }
          return loadChunk ? this.loadAndConsumeChunk() : Q.when();
        }.bind(this);

        if (canPlayStream) {
          // set the current stream index on the variant
          var previousStreamIndex = this.variant.currentStreamIndex;
          this.variant.setCurrentStreamIndex(streamIndex);

          // Technically the new bit rate stream hasn't been loaded yet, but the change starts here
          // so we'll dispatch the event indicating the change. Also note that we don't dispatch
          // the event if the previous stream is the same as the new one -- this happens only when
          // playback initial starts up as the default index is 0 and the "new" one is also 0.
          if (previousStreamIndex !== this.variant.currentStreamIndex) {
            this.dispatchPlayerEvent(PlayerEvent.BIT_RATE_CHANGE);
          }

          this.logger.debug("loadStreamAt( {0} )", [stream.bitRateName]);

          // load the playlist for the current stream then start loading chunks
          // TODO: BMR: This is the same set of chained promises as startPlayback(). consider reusing or creating a different method
          return this.feedMonitor.startLoad(stream.url)
            .then(this.loadManifest)
            .then(this.acquireStream)
            .then(loadAndConsumeChunk)
            .fail(this.reportError)
            .finally(this.feedMonitor.finishLoad);
          /* jshint ignore:line */
        }
        else {
          this.logger.debug("loadStreamAt( Ignored >> Stream `{0}` is {1}. )", [
            stream.bitRateName, (canPlayStream ? "playable" : "NOT playable")
          ]);
          return Q.when("Don't load the next stream.");
        }
      },
      /**
       * Promised based mp4 loading for the specified track, then load the first chunk for that track.
       *
       * @param {url} track url
       * @param {number in ms} startTime - A time value for the playback to start at.
       * @returns {Promise}
       */
      loadSingleTrackAt: function (url, startTime) {
        this.feedMonitor.startFeed();

        //In case of Mp3 track and a flash --> directly load the track to the sink as flash will take care of downloading
        if(PlaybackTypeUtil.isPlayerMP3(this) && this.flashRenderer)
        {
          url = url || this.currentUrl;
          this.audioSink.load(url, startTime);
          return Q.when(true);
        }

        // If url is not been provided, that means we already have the chunkProducer instance and
        // we are using to load the chunks for a seek
        // and If we do destroy the chunkProducer before clone/seek the new instance doesn't have loader, so start loading
        if(url || !this.chunkProducer._load)
        {
          this.chunkProducer.startLoading(url || this.currentUrl, this.configuration.key);
        }
    
        //Set the initialTimeStamp and Offset for MP4/seededRadio
        this.playheadMonitor.setInitialTimestampAndOffset(
          startTime,
          0,
          'Using the startTime either from seek/starting the player from at an offset'
        );
        return this.fetchAndConsumeSingleTrackChunks((startTime ? null : 1), startTime);
      },

      /**
       * fetches and Consumes Single Track Chunks
       *
       * @param {number in ms} startTime - A time value for the playback to start at.
       * @returns {Promise}
       */
      fetchAndConsumeSingleTrackChunks: function(chunksPerPull, startTime) {
        var self = this;
        var chunksToPull = chunksPerPull || this.configuration.chunksPerPull || 1;
        return this.chunkProducer.getChunks(chunksToPull, startTime)
          .then(function (chunk) {
            //chunk.codec = Codec.AAC_HE;
            chunk.isMP4 = true;

            if(self.chunkConsumer)
            {
              return self.chunkConsumer.consume(chunk);
            }
            else {
              // This might happen while we are switching to new track/seeking, and we are still processing old request 
              // Mainly noticed in slow bandwidth networks
              self.logger.warn("No Chunk Consumer found, might be because we are trying to process outdated request");
              return Q.when(null);
            }
          })
          .catch(function (error) {
            if (error === ChunkProducer.END_OF_STREAM) {
              self.logger.debug("No more chunks available");
            }
            else {
              self.logger.error(error);
              throw error;
            }
            return ChunkProducer.END_OF_STREAM; // no more chunks
          });
      },

      /**
       * Feeds mores chunks to the audio sink
       *
       * @param {size} size - number of chunks to pull from the renderer for continous playing.
       * @returns {Promise}
       */
      feedMoreChunks: function (size) {
        if (!PlaybackTypeUtil.isPlayerTrackBased(this)) {
          return Q.when(true);
        }
        return this.fetchAndConsumeSingleTrackChunks(size);
      },
      /**
       * Promised based HLS decryption key loader that internally handles the success and failures.
       *
       * The key is only loaded if it hasn't already been loaded and cached on the playlist and decryptor.
       *
       * @returns {Promise}
       */
      loadDecryptKey: function () {
        var url;
        var decryptor = this.playlist ? this.playlist.decryptor : null;
        var chunkDecryptor = this.playlist.getChunkDecryptorByIndex(this.playlist.index);

        var loadDecryptKeySuccess = function (data) {
          this.logger.info("loadDecryptKeySuccess( url = {0} )", [url]);

          // save the key to the playlist's decryptor
          decryptor.key = data;
          if(chunkDecryptor)
          {
            chunkDecryptor.key = data;
          }

          // Save to chunk consumer for decryption processes
          this.chunkConsumer.setKey(data);
          return data;
        }.bind(this);

        var loadDecryptKeyFault = function (fault) {
          this.logger.warn("loadDecryptKeyFault( url = {0}, fault = {1} )", [url, fault]);
          throw fault;
        }.bind(this);

        // it's possible that the player is in shutdown mode and this async process
        if (ObjectUtil.isUndefinedOrNull(this.chunkConsumer)) {
          throw new PromiseError(PromiseError.CANCEL_PROMISE, ["Stopping promise chain b/c the player is being shutdown."]);
        }

        // determine if we need to load a key or simply use the cached one we already have
        // technically a key is good on a per playlist basis so each playlist's chunks can
        // be encrypted differently.
        if (decryptor && (!chunkDecryptor || chunkDecryptor.type !== 'NONE')) {
          var needKey = (decryptor.key === null);
          if (needKey) {
            url = decryptor.url;
            this.logger.debug("loadDecryptKey( url = {0} )", [url]);
            return this.keyLoader.load(url).then(loadDecryptKeySuccess, loadDecryptKeyFault);
          }
          else {
            this.logger.debug("loadDecryptKey( Using cached key. )");
            if(chunkDecryptor)
            {
              chunkDecryptor.key = decryptor.key;
            }
            this.chunkConsumer.setKey(decryptor.key);
            return Q.when(decryptor.key);
          }
        }
        else {
          this.logger.debug("loadDecryptKey( No decryptor so no key...hopefully chunks unencrypted. )");
          this.chunkConsumer.setKey(null);
          return Q.when(null);
        }

      },

      /**
       * Promised based HLS audio chunk loader that internally handles the success and failures. Ensures the
       * encryption key is loaded before loading a chunk.
       *
       * @param {String} url - The URL for the chunk audio asset.
       * @param {boolean} lastChunk - indicates this is the last chunk for a (non live) playlist
       * @returns {Promise}
       */
      loadChunk: function (url) {

        // Adds a configurable limit to the number of chunks that can be loaded by the player. This is
        // really a dev tool only and is especially useful when performing multiple trick plays on MySXM.
        // Make sure to also stop the feed that continually requests more chunks.
        if (this.chunkProducer && this.chunkProducer.numChunksLoaded >= HlsConfig.MAX_NUMBER_CHUNKS_TO_LOAD) {
          this.feedMonitor.canLoadMore = false;
          throw new PromiseError(PromiseError.CANCEL_PROMISE, ["Stopping promise chain b/c we're at max chunks to load."]);
        }

        this.logger.debug("loadChunk( url = {0} )", [url]);

        /**
         * Handles successful chunk loads.
         * @param {Chunk} chunk - Chunk object from successful load.
         */
        var loadChunkSuccess = function (chunk) {
          this.logger.info("loadChunkSuccess( url = {0} )", [chunk.url]);

          // we need to add the chunk's timestamp and offset from the playlist as the
          // ChunkProducer that created the Chunk does not have these values...we check
          // for a playlist in case we just loaded a chunk without a variant or playlist
          if (this.playlist) {
            chunk.timestamp = this.playlist.getChunkTimeByIndex(this.playlist.index);
            chunk.decryptor = this.playlist.getChunkDecryptorByIndex(this.playlist.index) || this.playlist.decryptor;
            chunk.duration = this.playlist.getChunkDurationByIndex(this.playlist.index);
            chunk.offset = this.playlist.offset;
            chunk.codec = this.playlist.codec;
            // eslint-disable-next-line eqeqeq
            chunk.lastChunk = (!this.playlist.isAudioFirst && url == this.playlist.lastChunk && this.isLive === false);

            // Save the very first chunk's details as it contains the exact timestamp and offset to be
            // consumed -- this allows the player to easily know the exact start time without calculating
            // it on various business rules as it can just grab this first chunk.
            // NOTE: Tried putting this in `consumeSuccess()` but due to async nature the `chunk` was
            // the second one and not the first
            if (!this._firstChunk) {
              this._firstChunk = Object.assign(chunk);

              this.playheadMonitor.setInitialTimestampAndOffset(
                chunk.timestamp,
                chunk.offset,
                'Using first chunk consumed.'
              );
            }

            // TODO: BMR: This may not be necessary with new PlayheadMonitor
            this.playlist.offset = 0; // CWC only applies to first chunk?
          }
          else if (PlaybackTypeUtil.isPlayerTrackBased(this)) {
            chunk.codec = Codec.AAC_HE;
            chunk.isMP4 = true;
          }

          return chunk;
        }.bind(this);

        /**
         * Handles failed chunk loads.
         * @param {AssetError} error - Error object for failed chunk load.
         */
        var loadChunkFault = function (error) {
          this.logger.warn("loadChunkFault( url = {0}, error = {1} )", [error.url, error.httpStatus]);
          throw error;
        }.bind(this);

        // Used to encapsulate the chunk loading process since the returned data from the key
        // loader is not a chunk URL but the binary key itself
        var decryptKeyResolver = function () {
          this.logger.debug("decryptKeyResolver()");

          // Load the chunk and apply Failover and ABR monitoring by watching the promise's successful
          // or failed fulfillment.
          var promise = (this.chunkProducer) ? this.chunkProducer.load(url) : Q.defer().reject("No producer");

          // NOTE: Do not apply chunk failover for audio first chunks as we have special requirements
          // just for audio first failures.
          // It's possible to not have a playlist if playing an unencrypted chunk only.
          if (this.playlist && !this.playlist.isAudioFirst) {
            this.chunkFailoverMonitor.watch(promise);
          }
          this.abrMonitor.watch(promise);
          return promise.then(loadChunkSuccess, loadChunkFault);
        }.bind(this);

        return this.loadDecryptKey().then(decryptKeyResolver, loadChunkFault);
      },

      /**
       * Promised based chunk consumer that decrypts, decodes, and adds audio chunk data to the audio buffer.
       *
       * @param {Chunk} chunk - The audio chunk object with raw audio data to play.
       * @returns {Promise}
       */
      consumeChunk: function (chunk) {
        this.logger.debug("consumeChunk()");

        var consumeChunkSuccess = function () {
          // DO NOT apply the feed monitor to the audio first chunks as they have their own loading sequence.
          // We want to allow the feed monitor to start requesting more chunks based on buffer requirements
          // only after the audio first chunks have been loaded and we're onto chunks from the real playlist.
          if (this.playlist && !this.playlist.isAudioFirst && this.feedMonitor) {
            this.feedMonitor.checkFeed();
          }

          this.logger.info("consumeChunkSuccess()");
          return Q.when(null);
        }.bind(this);

        var consumeChunkFault = function (fault) {
          this.logger.warn("consumeChunkFault( fault = {0} )", [fault.message]);
          throw fault;
        }.bind(this);

        // it's possible that the player is in shutdown mode and this async process
        if (ObjectUtil.isUndefinedOrNull(this.chunkConsumer)) {
          throw new PromiseError(PromiseError.CANCEL_PROMISE, ["Stopping promise chain b/c the player is being shutdown."]);
        }

        // Consume the chunk and apply Failover by watching the promise's successful or failed fulfillment.
        // In this case we are looking for a corrupt chunk or some failure that resulted from consumption.
        var promise = this.chunkConsumer.consume(chunk);

        // NOTE: Do not apply chunk failover for audio first chunks as we have special requirements
        // just for audio first failures.
        // It's possible to not have a playlist if playing an unencrypted chunk only.
        if (this.playlist && !this.playlist.isAudioFirst) {
          this.chunkFailoverMonitor.watch(promise);
        }

        // Also apply preload monitoring -- if we did it on the chunk load we wouldn't know the buffer
        // as consumption is what aggregates the player's buffer, so we apply it to consumption and not load.
        // NOTE: Technically this could only be called when we're actually preloading and not all the time.
        // It doesn't hurt anything, so we'll leave it in for now.
        this.preloadMonitor.watch(promise);

        return promise.then(consumeChunkSuccess, consumeChunkFault);
      },

      /**
       * Promised based next chunk loader -- uses the next available chunk URL in the playlist.
       *
       * @returns {Promise}
       */
      loadNextChunk: function () {
        if (this.playlist && this.playlist.hasNext) {
          var url = this.playlist.next();

          this.logger.debug("loadNextChunk( url = {0}, index = {1} )", [url, this.playlist.index]);
          return this.loadChunk(url);
        }
        else {
          this.logger.warn("loadNextChunk( Cannot load next chunk b/c the playlist does not have another. )");
          throw new PromiseError(PromiseError.CANCEL_PROMISE, ["Cannot load next chunk b/c the playlist does not have another."]);
        }
      },

      /**
       * Promised based next chunk loader and consumer wrapper method.
       *
       * @returns {Promise}
       */
      loadAndConsumeChunk: function () {
        this.logger.debug("loadAndConsumeChunk()");

        if (this.feedMonitor) {
          // only started if not already started...performed internally in the feed monitor.
          this.feedMonitor.startFeed();

          // go ahead and load some more chunks for consumption
          return this.feedMonitor.startLoad()
            .then(this.loadNextChunk)
            .then(this.consumeChunk)
            .fail(this.reportError)
            .finally(this.feedMonitor.finishLoad);
          /* jshint ignore:line */
        }
        else {
          return Q.when(null);
        }
      },

      /**
       * Starter method for all promise chains that kickoff the playback process. This method exists to
       * ensure that we have a starter promise for the chain; if a player is started and immediately stopped
       * then technically we could have a null `feedMonitor`, so instead of starting the promise chains with
       * that we start with an empty promise. This ensures that all promise failures hit the `reportError`
       * fault handler.
       *
       * @param {String} url - The URL of the manifest to load.
       * @returns {Promise}
       */
      startLoad: function (url) {
        var start = function () {
          if (this.feedMonitor) {
            return this.feedMonitor.startLoad(url);
          }
          else {
            throw "No feed monitor";
          }
        }.bind(this);
        return Q.when().then(start);
      },

      /**
       * Initiates audio playback.
       *
       * @param {String} url - The URL of the manifest to load.
       * @returns {Promise}
       */
      startPlayback: function (url) {
        this.logger.info("startPlayback( url = {0} )", [url]);

        // DO NOT call Promise.done() at the end of these chains or the client using the player cannot
        // access the promise
        return this.startLoad(url)
          .then(this.loadManifest)
          .then(this.acquireStream)
          .then(this.loadAndConsumeChunk)
          .fail(this.reportError)
          .finally(this.playbackRequestComplete);
        /* jshint ignore:line */
      },

      /**
       * Initiates audio first playback by loading and consuming chunks first and then resuming the normal
       * playback process by loading either a variant and/or playlist and then the rest of the chunks.
       *
       * Load chunks in order and start playing immediately:
       *
       *      1) Load, decrypt, decode, and play chunk 0 (that’s sequential per AF chunk)
       *      2) Repeat step 1 for as many AF chunks as available in the data.
       *      3) When all AF chunks have been loaded, decrypted, decoded, and are either playing
       *      or buffered, load the real playlist.
       *
       * TODO: BMR: If this method gets to big or there's specifics for audio first that start to become
       * TODO: BMR: too then consider a refactor to a AudioFirstPlayback or similar
       *
       * @param {String} url - The manifest URL to load after audio first.
       * @param {AudioFirst} audioFirst - The audio first data.
       * @returns {Promise}
       */
      startAudioFirstPlayback: function (url, audioFirst) {
        // get all of the audio first chunk URLs
        var chunkUrls = audioFirst.getURLs();

        var loadAndConsumeAudioFirst = function (url) {
          this.logger.info("loadAndConsumeAudioFirst()");

          // Theoretically after the first audio first chunk is loaded and consumed playback is ready,
          // so we add a check directly in this method to ensure that the ready event is fired as
          // soon as it possibly can when playing audio first.
          this.feedMonitor.checkPlaybackReady(this);

          // Go ahead and load and consume an audio first chunk.
          return this.loadChunk(url).then(this.consumeChunk);
        }.bind(this);

        // TODO: BMR: Consider just calling startPlayback() which uses the same promise sequence
        var resumeNormalPlayback = function () {
          // DO NOT call Promise.done() at the end of these chains or the client using the player cannot
          // access the promise
          this.logger.info("resumeNormalPlayback()");
          return this.startLoad(url)
            .then(this.loadManifest)
            .then(this.acquireStream)
            .then(this.loadAndConsumeChunk)
            .fail(this.reportError)
            .finally(this.playbackRequestComplete);
          /* jshint ignore:line */
        }.bind(this);

        var audioFirstSuccess = function () {
          this.logger.info("audioFirstSuccess()");

          // Set a flag to indicate AF has succeeded and has played...we only want to use audio
          // first on the very first channel tune
          audioFirst.success = true;
          audioFirst.hasPlayed = true;
          return Q.when(true);
        }.bind(this);

        var audioFirstFailed = function (error) {
          // Set a flag to indicate AF has failed and has played...we only want to use audio
          // first on the very first channel tune
          audioFirst.success = false;
          audioFirst.hasPlayed = true;

          // if audio first fails, then we want to start playback at the live point, which should be the
          // fist audio first chunk's time
          var audioFirstChunk0Timestamp = audioFirst.getChunk0Timestamp();
          var audioFirstChunk0Offset = audioFirst.getChunk0Offset();
          this.startTime = audioFirstChunk0Timestamp + audioFirstChunk0Offset;

          this.logger.warn("audioFirstFailed( Failover to default manifest using live time `{0}`. Error = {1} )", [
            this.startTime, error.message
          ]);

          // then resume normal playback by loading the default manifest
          return Q.when(true);

          // TODO: BMR: 02/24/2016: Consider adding the method Playback.getLiveTime() as shown below
          /*
           // if audio first fails, then we want to start playback at the live point, which should be the
           // fist audio first chunk's time
           startAt = getLiveTime(false, true);
           if (isNaN(startAt))
           {
           startAt = null;
           }

           _logger.warn("audioFirstFailed( Failover to default manifest using live time `" + startAt + "`. " +
           "ERROR >> [" + msg + ".] )", params);

           hasPlayedAudioFirst(true);
           _audioFirstSuccessful = false;
           return loadManifestAndStream();
           */

          //this.reportError(error);
        }.bind(this);

        /**
         * Creates a dynamic audio first playlist using the chunk URLs and timestamps. The decryptor is also
         * passed into the Playlist instantiation but it's not required or used for audio first playback
         * (in the playlist) as the chunk decryption is done outside of the scope of the audio first playlist.
         *
         * @return {Playlist} An audio first synthesized playlist.
         */
        var createAudioFirstPlayList = function (audioFirst) {
          // in the future this could be real playlist data
          var data = Playlist.AUDIO_FIRST_PLAYLIST_DATA;
          var manifestURL = Playlist.AUDIO_FIRST_PLAYLIST_URL;

          // grab the chunk URLs
          var urls = chunkUrls;

          // need to convert each string timestamp to a Date object
          var times = audioFirst.getDateTimestamps();

          // the decryptor param doesn't really matter as the playlist being created for audio first isn't
          // used for decryptor
          var chunk0 = audioFirst.getChunk();
          var decryptor = (chunk0.decryptor !== null) ? chunk0.decryptor : null;

          // grab the default offset for chunk 0
          var offset = audioFirst.getOffset();

          // create a stubbed audio first playlist and manually override the default index of -1 to 0
          // the index in the audio first playlist is not updated the same way as normal playback so we
          // manually intervene to ensure playback times for the playhead are set correctly.
          var playlist = new Playlist(data, urls, times, null, [decryptor], manifestURL, this.isLive, null, offset);
          playlist.index = 0;

          return playlist;
        }.bind(this);

        // create a dynamic playlist to support various player functions like playhead monitoring
        // this playlist is never used for playback, but is required by other functional components during playback
        this.playlist = createAudioFirstPlayList(audioFirst);

        this.logger.info("startAudioFirstPlayback( startTime = {0}, timestampChunk0 = {1}, offsetChunk0 = {2} )", [
          this.playlist.firstChunkTime + this.playlist.offset, this.playlist.firstChunkTime, this.playlist.offset
        ]);

        // kickoff the promise-based loop that loads and consumes each chunk sequentially
        return PromiseUtil.promiseLoopSequence(chunkUrls, loadAndConsumeAudioFirst)
          .then(audioFirstSuccess, audioFirstFailed)
          .then(resumeNormalPlayback)
          .fail(this.reportError);
      },

      /**
       * Dispatches a PlayerEvent for client objects using the Playback object. Simplifies what client objects need
       * to know about currently playback and centralizes it here. Allows for optional error parameter as well.
       *
       * @param {String} type - Event type.
       * @param {Object} [error] - Optional error object.
       */
      dispatchPlayerEvent: function (type, error) {
        this.playbackEventMonitor.dispatchEvent(type, error);
      },

      /**
       * Handler for failed promises. Rethrows the error to ensure promise chaining fails, unless it's
       * handling the cancel promise error which is designed to swallow the error -- it's the equivalent
       * to aborting a promise chain without actually throwing an error (because it's not really an error).
       *
       * We also don't bother rethrowing errors if we're in the middle of player shutdown.
       *
       * @throws {Error} Rethrows the error.
       */
      reportError: function (error) {
        var msg = PlayerError.UNKOWN_ERROR;

        // NOTE: Order is important here. Make sure specific errors are checked before the default Error case.
        if (error instanceof PromiseError) {
          // Just swallow error because chain was intentionally aborted, so do not throw another error.
          msg = error.message;
          this.logger.warn("reportError( {0} )", [msg]);

          return this;
        }
        else if (error instanceof AssetError) {
          // This asset failure can be an HTTP load or even usage, like chunk decryption and decoding failures.
          msg = StringUtil.supplant("Asset failed: HTTP status = {0}, message = {1}, url = {2}, state = {3}", [
            error.httpStatus, error.message, error.url, this.state
          ]);

          this.logger.error("reportError( {0} )", [msg]);
          throw new Error(msg);
        }
        else if (error instanceof Error) {
          msg = error.stack;
          this.logger.error("reportError( {0}, state = {1} )", [msg, this.state]);
          throw error;
        }
      },

      /**
       * Handler for playback request complete whether successful or failed.
       *
       * @returns {Promise}
       */
      playbackRequestComplete: function () {
        var msg = "Nothing to complete as player is being shutdown; state = " + this.state;
        if (this.feedMonitor) {
          msg = "";
          this.feedMonitor.finishLoad();
        }
        this.logger.info("playbackRequestComplete( {0} )", [msg]);
      },

      /**
       * Method called when the player has finished playback for a finite playlist (aka MySXM track or
       * AOD episode, not Live).
       *
       * NOTE: closeConnection() is used over stop as we want to keep this Playback instance around in case
       * the user attempts to seek back in time even after audio has finished.
       *
       * TODO: BMR: We have "ready" and "finished" methods done here and in FeedMonitor itself. Should we put them both in the same class?
       */
      finished: function () {
        this.logger.info("finished( FINISHED!!! )");
        this.state = PlayerState.FINISHED;
        this.dispatchPlayerEvent(PlayerEvent.FINISHED);
      },

      /**
       * Method called when the player is ready.
       *
       * TODO: BMR: We have "ready" and "finished" methods done here and in FeedMonitor itself. Should we put them both in the same class?
       */
      ready: function () {
        this.logger.info("ready( Player has at least 1 audio chunk ready to play. )");

        //As Browsers do not want anything to play unless user interacts with the app.
        // we will dispatch an Error to the client, so that client will detect this and handle the playback
        // And if we are in the PLAYBACK_DENIED state, don't want set the playback in ready state
        if(this.autoPlay
            && !this.configuration.isPlaybackAlreadyDenied
            && this.state === PlayerState.PRELOADING
            && this.audioSink.renderer.state === AdtsAacAudioSink.AUDIO_CONTEXT_STATE.SUSPENDED)
        {
          this.logger.error("Error( name = {0} )", [PlayerEvent.PLAYBACK_DENIED]);
          this.dispatchPlayerEvent(PlayerEvent.PLAYBACK_DENIED);
        }

        // make sure the player ready event is fired off before we set the state to playing which
        // will ultimately start the playhead monitor and flow of playhead events if the player
        // is in fact playing
        this.dispatchPlayerEvent(PlayerEvent.PLAYBACK_READY);

        // only set the state to playing if we're actually trying to play, which only happens at
        // playback startup when the auto play is true...otherwise the player is preloading, which is its own state
        // Note: for Flash, as renderer state is different from the AudioContext states, we should set the state based on autoPlay
        // as this will be used in the flash player to play or pause
        if(this.flashRenderer)
        {
          this.state = this.autoPlay ? PlayerState.PLAYING : PlayerState.PAUSED;
        }
        else {
          this.state = (this.autoPlay && this.audioSink.renderer.state === AdtsAacAudioSink.AUDIO_CONTEXT_STATE.RUNNING) ? PlayerState.PLAYING : PlayerState.PAUSED;
        }
      },

      isReady: function () {
        return this.audioSink ? this.audioSink.isReady() : false;
      },

      /**
       * Should acquire the live time.
       *
       * @returns {Number}
       */
      getLiveTime: function () {
        return this.playlist ? this.playlist.getLiveTime() : NaN;
      },

      /**
       * Gets the default URL based on the following rules:
       *
       * 1) If playing audio first it's often the case that the AF chunks are not in the small playlist, so
       * we use the medium or large playlist to ensure seamless playback from AF chunks into the playlist.
       *
       * 2) If an offset is provided it's possible we're outside the small playlist, so simply default
       * to the large playlist. An offset can be provided for several reasons, but will definitely be used
       * when the player performs a restart after failover is exhausted.
       *
       * 3) If the url is already a large URL do not request a new one from the list of audio URLs. This is
       * specifically important for failover cases where we need to use the passed in failover URL (usually
       * something like secondary), which is the large manifest. To counter that we simply check to see if the
       * requested URL is already a large manifest URL.
       *
       * 4) If the playback engine is already in failover mode then a new origin server URL will be provided
       * from the failover monitor so we should use that.
       *
       * 5) If the `overrideLargeManifest` is true then we simply return the large manifest. This can happen when
       * we construct a new Playback instance from a config object but we don't have a URL to play.
       *
       * @param {String} url - URL to start playback. Currently either a M3U8 manifest file or AAC audio file.
       * @param {String|Number} startAt - The start time for the player can be a string timestamp or time
       * from epoch in milliseconds.
       * @param {Boolean} [overrideLargeManifest] - Optional. Flag that indicates to use the large manifest from the audio
       * URLs no matter what. This can happen when we construct a new Playback instance from a config object
       * but we don't have a URL to play.
       * @returns {String} The default URL.
       */
      getDefaultUrl: function (url, startAt, overrideLargeManifest) {
        // Default to false -- we only want to use this value if provided by the method call.
        overrideLargeManifest = !ObjectUtil.isBoolean(overrideLargeManifest) ? false : overrideLargeManifest;

        var audioFirst = this.configuration.audioFirst;
        var audio = this.configuration.audio;
        var largeManifestUrl = audio.getAudioURL(Manifest.LARGE);
        var playAudioFirst = audioFirst && audioFirst.canPlay(startAt);
        var useLargeManifest = playAudioFirst || startAt || HlsConfig.MAXIMUM_QUALITY_AUDIO || overrideLargeManifest;
        var isAudioUrlLarge = audio.isAudioUrlLarge(url);
        return (useLargeManifest && !isAudioUrlLarge && !this.inFailoverMode) ? largeManifestUrl : url;
      },

      /**
       * Handles no connectivity for the player and announces it to clients using the player with an event.
       */
      noConnectivity: function () {
        this.logger.warn("noConnectivity()");
        this.dispatchPlayerEvent(PlayerEvent.CONNECTIVITY_FAILED);
      },

      /**
       * Handles invalid token for the player and announces it to clients using the player with an event.
       */
      tokenRefresh: function () {
        this.logger.warn("tokenRefresh()");
        this.dispatchPlayerEvent(PlayerEvent.TOKEN_INVALID);
        if (!this.tokenInvalidDefered) {
          this.tokenInvalidDefered = Q.defer();
        }
      },


      crossfade: function (turnItOn) {
        // add a check if live or aod, just return;

        if (!this.audioSink || !this.configuration) {
          return;
        }

        if (turnItOn === this.isCrossfadeOn()) {
          return;
        } // nothing to do.
        
        var config = this.isCrossfadeSupported() ? {
          crossfade: {
            crossFade: this.configuration.crossfade.crossFade,
            fade: this.configuration.crossfade.fade,
            fadeDownDuration: this.configuration.crossfade.fadeDownDuration,
            fadeDownPos: this.configuration.crossfade.fadeDownPos,
            fadeUpDuration: this.configuration.crossfade.fadeUpDuration,
            fadeUpPos: this.configuration.crossfade.fadeUpPos
          },
          duration: this.configuration.duration
        } : {};

        this.audioSink.crossfade(config, turnItOn);
      },

      isCrossfadeOn: function () {
        if (!this.audioSink) {
          return false;
        }

        return this.audioSink.isCrossfadeOn();
      },

      isCrossfadeSupported : function () {
        if (!this.audioSink) {
          return false;
        }

        return this.audioSink.isCrossfadeSupported();
      },

      streamEnded: function () {
        return this.streamEnded();
      }
    };

    return Playback;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/core/ProgressiveDownload.js":
/*!**************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/core/ProgressiveDownload.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    050819
 * @COPYRIGHT:  2019 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      The progressive download object represents a progressively downloaded object.
 *      Under the hood it uses range requests to download bytes as needed.
 */
/**
 * Register the module with RequireJS.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var Q = __webpack_require__(/*! q */ "q");
    var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
    var AssetError = __webpack_require__(/*! sxm/audioplayer/html5/error/AssetError */ "./javascript/src/sxm/audioplayer/html5/error/AssetError.js");
    var logger = LoggerFactory.getLogger("ProgressiveDownload");

    function ProgressiveDownload(url) {

      /**
       *  This stores the url for the download.
       */
      this._url = url;

      this._bytesPulled = 0;

      // eslint-disable-next-line no-undef
      this.bytes = new ArrayBuffer();
      
      /**
       * Total flight time for a successfull request to complete
       * @returns {*}
       */
      this.totalFlightTime = 0;
      
      this._isEnded = false;
    }

    ProgressiveDownload.TIMED_OUT = "timed out";

    ProgressiveDownload.prototype = {

      /**
       * @param endByteIndex - total number of total bytes that should be pulled thus far.
       * @returns {*}
       */
      getRequestSummary: function (startByteIndex, endByteIndex) {
        var self = this;

        // Generate the URL with HLS consumption data query string parameters.
        this._url = this.createUrl(this._url);

        var request = new XMLHttpRequest();

        var deferred = Q.defer();
        
        var startFlightTime = new Date().getTime();
        
        request.withCredentials = HlsConfig.WITH_CREDENTIALS;

        request.open("GET", this._url, true);

        //IE11 doesn't support setting the responseType before request is open
        request.responseType = 'arraybuffer';
        
        //TODO: If we are trying to pull single large chunk, it might take more than 9s to pull the large chunk
        //so for now commenting this
        
        // request.timeout = 9000;
        request.ontimeout = function () {
          deferred.reject(ProgressiveDownload.TIMED_OUT);
        };

        var requestSummary = {
          beg: startByteIndex,
          end: endByteIndex || null,
          bytes: []
        };

        // Note: Don't remove the Range header, as we use the content-range header to find the total bytes of the file in the success call
        // we use the content range for parsing a file(mp3/mp4)
        request.setRequestHeader('Range',
          'bytes='
          + requestSummary.beg.toString()
          + '-'
          + (requestSummary.end ? (requestSummary.end - 1).toString() : '')
        );
  
        // HTTP Range API is end inclusive
        // so that is why we subtract 1.

        request.onload = loadSuccess;
        request.onerror = loadFault;

        request.send();

        return deferred.promise;
  
  
        /**
         * Handles the successful HTTP request.
         * @param {XMLHttpRequestProgressEvent} response - The response from the successful asset load.
         * @return {Promise}
         */
        function loadSuccess() {
          if (request.readyState === 4) {
    
            if (request.status === 200 || request.status === 206 || request.status === 304) {
              self._bytesPulled += request.response.byteLength;

              requestSummary.bytes = request.response;

              var contentRange = request.getResponseHeader('content-range');
              requestSummary.contentRange = contentRange ? parseInt(contentRange.split('/')[1]) : parseInt(request.getResponseHeader('content-length'));

              //If we don't have end byte that means we are pulling all the chunks till end buffer
              // or if we got less bytes than what we requested which also means no more bytes at the server
              if(!requestSummary.end
                  || (request.response.byteLength < (requestSummary.end - requestSummary.beg))
                  || requestSummary.contentRange === request.response.byteLength)
              {
                self._isEnded = true;
              }

              deferred.resolve(requestSummary);
            } else {
              loadFault();
            }
          }
          self.totalFlightTime = new Date().getTime() - startFlightTime;
        }
        
        /**
         * Handles a failed HTTP request.
         * @param {AssetError} fault - The fault object for the failed asset load.
         * @return {Promise}
         */
        function loadFault() {
          var message = "HTTP {0} " + request.statusText;
          var assetError = new AssetError(message, request.responseURL, request.status);
    
          logger.warn("loadFault( HTTP Status Code = {0}, message = {1}, url = {3} )", [
            assetError.httpStatus, assetError.message, request.responseURL
          ]);
          
          deferred.reject(assetError);
        }
      },

      endByteIndexOfPulled: function () {
        return this._bytesPulled;
      },

      createUrl: function (url) {

        var addTokenParams = function (url) {
          var tokenStrategy = HlsConfig.getTokenStrategy(url);

          if (tokenStrategy === null) {
            return url;
          }

          var keyPattern = tokenStrategy.keyPattern;
          var assetStart = url.indexOf(tokenStrategy.assetStartPattern);
          var isKeyPull = ((url.indexOf(keyPattern) >= 0) && (assetStart >= 0));

          if (isKeyPull === true) {
            url = HlsConfig.KEYPATH + url.substring(assetStart);
          }
          else {
            url = HlsConfig.getTokenizedUrl(url);
          }

          return url;
        };

        url = addConsumptionInfoParams(url);
        url = addTokenParams(url);

        return url;

        function addConsumptionInfoParams(url) {
          // The consumption info always comes from the client as a valid query string; e.g., ?foo=bar.
          logger.info("addTokenParams( consumptionInfo = {0} )", [HlsConfig.CONSUMPTION_INFO]);
          return url + HlsConfig.CONSUMPTION_INFO;
        }
      }
    };

    return ProgressiveDownload;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/crypto/Cipher.js":
/*!***************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/crypto/Cipher.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/31/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Cipher object that can be used for encryption/decryption.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var XORCipher = __webpack_require__(/*! sxm/audioplayer/html5/crypto/XORCipher */ "./javascript/src/sxm/audioplayer/html5/crypto/XORCipher.js");
  var BitUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/BitUtil */ "./javascript/src/sxm/audioplayer/html5/util/BitUtil.js");
  var Q = __webpack_require__(/*! q */ "q");

  //-----------------------------------------------------------------------
  // MODULE variables
  //-----------------------------------------------------------------------

  var logger = LoggerFactory.getLogger("Cipher");
  var subtleCrypto = null;

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the Playback function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   *
   * @param {String} algorithm can be AES-CBC, AES-CTR, AES-GCM, RSA-OAEP, AES-KW, HMAC, RSASSA-PKCS1-v1_5, ECDSA, ECDH or DH
   * @param {Number} keyLength of key in bits
   * @param {String} type can be "raw", "pkcs8", "spki", or "jwk" (default is "raw")
   * @param {Array} usages array containing "encrypt","decrypt" or both (default is both)
   * @return {Cipher} interface for using the crypto object
   */
  function Cipher(algorithm, keyLength, type, usages) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope which will leak fields into the global namespace
    if (!(this instanceof Cipher)) {
      throw new TypeError("Cipher constructor cannot be called as a function.");
    }

    if (algorithm === XORCipher.ALGORITHM.XOR_MASK) {
      return new XORCipher(algorithm,usages);
    }

    if (!Cipher.isSupported()) {
      throw new Error("Crypto.subtle not supported");
    }

    logger.debug("Constructor( type = {0}, algorithm = {1}, bits = {2} )", [type, algorithm, keyLength]);

    algorithm = algorithm || Cipher.ALGORITHM.AES_CBC;
    keyLength = keyLength || 128;
    type = type || Cipher.TYPE.RAW;
    usages = usages || ["decrypt", "encrypt"];

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Key description as needed by cypto.subtle.importKey
     //* @type   {Object}
     //* @name   {String} name of the algorithm for de/encryption
     //* @length {Number} number of bits in key
     */
    this.keyConfig = {
      name: algorithm,
      length: keyLength
    };

    /**
     * Cipher description as needed by subtleCrypto.encrypt/decrypt
     //* @type {object}
     //* @name {String} name of the algorithm for de/encryption
     //* @iv   {ArrayBuffer} initialization vector for the cipher
     */
    this.cipherConfig = {
      name: algorithm,
      // eslint-disable-next-line no-undef
      iv: new ArrayBuffer(keyLength >>> 3)
    };

    this.rawKey = null;
    this.type = type;
    this.usages = usages;
    this.keyImport = new Q(null);
    this.hasDecrypt = usages.indexOf("decrypt") > -1;
    this.hasEncrypt = usages.indexOf("encrypt") > -1;

    this.doCrypto = (function (self) {
      /**
       * Perform crypto operation func on a buffer
       *
       * @param {function} func crypto function to perform
       * @param {ArrayBuffer} buffer (cipherText) to be decrypted
       * @return promise that will be resolved when buffer is decrypted
       */
      return function (func, buffer) {
        /**
         * Start the crypto process
         *
         * @param {ArrayBuffer} theKey crypto key
         * @return {Promise} promise that will be resolved when buffer is processed
         */
        var startCrypto = function (theKey) {
          if (theKey !== null) {
  
            if (window.msCrypto) {
              theKey.usages = ['decrypt'];
              
              var dfd = Q.defer();
              
              var op = subtleCrypto.decrypt(self.cipherConfig, theKey, buffer);
              op.onerror = function (evt) {
                dfd.reject(evt.toString());
              };
              
              op.oncomplete = function (evt) {
                dfd.resolve(evt.target.result);
              };
              
              return dfd.promise;
              
            } else {
              return Q.when(func.call(subtleCrypto, self.cipherConfig, theKey, buffer));
    
            }
          }
          else {
            logger.debug("startCrypto( NOT Encrypted. Simply returning chunk as is. )", [buffer.byteLength]);
            return Q.when(buffer);
          }
        };

        /**
         * Reject the promise, crypto operation failed
         *
         * @param {Object} failure contains the reason why the operation failed
         */
        var cryptoFailed = function (failure) {
          if (!failure || failure === null) {
            failure = "Unknown error";
          }

          logger.warn("cryptoFailed( {0} )", [failure.toString()]);
          return Q.reject(failure);
        };

        return self.keyImport
          .then(startCrypto)
          .catch(cryptoFailed);
        /* jshint ignore:line */
      };
    })(this); // capture this as self in a closure for usage in promise handlers

    // make sure all functions for this object are bound to this so that we can call them from different
    // contexts without issue
    //
    // http://stackoverflow.com/questions/20279484/how-to-access-the-correct-this-context-inside-a-callback
    for (var property in this) {
      if (typeof this[property] === "function") {
        this[property] = this[property].bind(this);
      }
    }
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Get the actual subtleCrypto API
   *
   * Crypto object with the subtle crypto API functions
   *
   * Sometimes you need the actual API (like with unit testing).  Here you cget it without worrying about
   * which browser you are on.
   */
  Cipher.getSubtleCryptoAPI = function () {
    if (Cipher.isSupported()) {
      return subtleCrypto;
    }

    return null;
  };

  /**
   * Determine if SubtleCrypto API is supported
   *
   * @return {Boolean} true if the api is supported, false otherwise
   */
  Cipher.isSupported = function () {
    subtleCrypto = window.msCrypto ? window.msCrypto.subtle : (window.crypto.subtle || window.crypto.webkitSubtle || window.subtleCrypto);

    if (!subtleCrypto || !subtleCrypto.importKey || !subtleCrypto.decrypt || !subtleCrypto.encrypt) {
      subtleCrypto = null;
    }

    return (subtleCrypto && subtleCrypto !== null) ? true : false;
  };
  
  /**
   * Hash of enumerated values describing the data format of the key to import.
   * @type {string}
   */
  Cipher.TYPE = {
    RAW: "raw",
    PKCS8: "pkcs8",
    SPKI: "spki",
    JWK: "jwk"
  };

  /**
   * Hash of enumerated values describing defining the signature function to use for en/decryption.
   * @type {string}
   */
  Cipher.ALGORITHM = {
    AES_CBC: "AES-CBC",
    AES_CTR: "AES-CTR",
    AES_GCM: "AES-GCM",
    RSA_OAEP: "RSA-OAEP",
    AES_KW: "AES-KW",
    HMAC: "HMAC",
    RSASSA_PKCS1_v1_5: "RSASSA-PKCS1-v1_5",
    ECDSA: "ECDSA",
    ECDH: "ECDH",
    DH: "DH"
  };

  Cipher.DIRECTION = {
    BOTH: ["decrypt", "encrypt"],
    DECRYPT: ["decrypt"],
    ENCRYPT: ["encrypt"]
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Playback class, we could write:
   *
   *  `BankManager.prototype = Playback.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  Cipher.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: Cipher,

    /**
     * Import a key into the Cipher object
     *
     * @rawKey {ArrayBuffer/JSONWebKey} if type is "raw/pkcs8 or spki" ArrayBuffer, otherwise JSONWebKey
     */
    importKey: function (rawKey) {
      if (this.rawKey === rawKey && rawKey !== null) {
        logger.debug("importKey( Key already imported, reuse existing keyImport promise. )");
      }

      else if (rawKey !== null) {
        this.rawKey = rawKey;
        logger.debug("importKey()");
  
        if(window.msCrypto){
          var dfd = Q.defer();
          
          var op = subtleCrypto.importKey(this.type, rawKey, this.keyConfig, false, this.usages);
          op.onerror = function (evt) {
            dfd.reject(evt.toString());
          };
          
          op.oncomplete = function (evt) {
            dfd.resolve(evt.target.result);
          };
          
          this.keyImport = dfd.promise;
        }else{
          this.keyImport =
            Q.when(subtleCrypto.importKey(this.type, rawKey, this.keyConfig, false, this.usages));
        }
      }
      else {
        logger.debug("importKey( No raw key so don't import )");
        this.rawKey = null;
        this.keyImport = new Q(this.rawKey);
      }

      return this.keyImport;
    },

    importIV: function (iv) {

      var hexString = '';

      if(iv[0] === '0' && iv[1] === 'x')
      {
        hexString = iv.slice(2);
      }

      if(!hexString)
      {
        throw new Error("Initialization vector is not a Hex stream");
      }

      //Pad hex-string with zeros at the start if it is less than 32 char's
      if(hexString.length < 32)
      {
        var zeroPadding = '00000000000000000000000000000000';
        zeroPadding = zeroPadding.substring(0, 32 - hexString.length);
        hexString = zeroPadding + hexString;
      }

      var ivByteArray = BitUtil.hexStringToByte(hexString);

      this.cipherConfig.iv = ivByteArray;
    },

    /**
     * Decrypt a buffer using the cipher
     *
     * @param {ArrayBuffer} buffer (cipherText) to be decrypted
     * @return {promise} Promise that will be resolved when buffer is decrypted
     */
    decrypt: function (buffer) {
      if (this.hasDecrypt === true) {
        logger.debug("decrypt()");

        return this.doCrypto(subtleCrypto.decrypt, buffer);
      }
      else {
        throw new Error("Cipher instance cannot be used for decryption.");
      }
    },

    /**
     * Encrypt a buffer using the cipher
     *
     * @param {ArrayBuffer} buffer (clearText} to be encrypted
     * @return {promise} Promise that will be resolved when buffer is encrypted
     */
    encrypt: function (buffer) {
      if (this.hasEncrypt === true) {
        logger.debug("encrypt()");
        return this.doCrypto(subtleCrypto.encrypt, buffer);
      }
      else {
        throw new Error("Cipher instance cannot be used for encryption");
      }
    }
  };

  return Cipher;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/crypto/XORCipher.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/crypto/XORCipher.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/16/19
 * @COPYRIGHT:  2019 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Cipher object that can be used for encryption/decryption.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var Q = __webpack_require__(/*! q */ "q");

  //-----------------------------------------------------------------------
  // MODULE variables
  //-----------------------------------------------------------------------

  var logger = LoggerFactory.getLogger("XORCipher");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the Playback function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   *
   * @param {String} algorithm can be XOR
   * @param {Array} usages array containing "encrypt","decrypt" or both (default is both)
   * @return {Cipher} interface for using the crypto object
   */
  function XORCipher(algorithm,usages) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope which will leak fields into the global namespace
    if (!(this instanceof XORCipher)) {
      throw new TypeError("Cipher constructor cannot be called as a function.");
    }

    if (!!algorithm && algorithm !== XORCipher.ALGORITHM.XOR_MASK) {
      throw new TypeError("XORCipher only supports XOR_MASK algorithm");
    }

    logger.debug("Constructor(algorithm = {0} )", [algorithm]);

    algorithm = algorithm || XORCipher.ALGORITHM.XOR_MASK;
    usages = usages || ["decrypt"];

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Key description as needed by cypto.subtle.importKey
     //* @type   {Object}
     //* @name   {String} name of the algorithm for de/encryption
     //* @length {Number} number of bits in key
     */
    this.keyConfig = {
      name: algorithm,
      length: undefined
    };

    /**
     * Cipher description as needed by subtleCrypto.encrypt/decrypt
     //* @type {object}
     //* @name {String} name of the algorithm for de/encryption
     //* @iv   {ArrayBuffer} initialization vector for the cipher
     */
    this.cipherConfig = {
      name: algorithm,
      // eslint-disable-next-line no-undef
      iv: undefined
    };

    this.rawKey = null;
    this.type = '';
    this.usages = usages;
    this.keyImport = new Q(null);
    this.hasDecrypt = usages.indexOf("decrypt") > -1;
    this.hasEncrypt = usages.indexOf("encrypt") > -1;
    
    this.doCrypto = (function (self) {
      /**
       * Perform crypto operation func on a buffer
       *
       * @param {function} func crypto function to perform
       * @param {ArrayBuffer} buffer (cipherText) to be decrypted
       * @param {offset} buffer offset where the decryption need to applied
       * @return promise that will be resolved when buffer is decrypted
       */
      return function (buffer, offset) {
        /**
         * Start the crypto process
         *
         * @param {ArrayBuffer} theKey crypto key
         * @return {Promise} promise that will be resolved when buffer is processed
         */

        var bufferView8 = new Uint8Array(buffer);
        offset = offset && offset > 0 ? offset : 0;
        function startCrypto (theKey) {
  
          if (theKey) {
            // console.time("startCrypto");
            
            logger.debug("startCrypto)", [buffer.byteLength]);
            
            var keyLength = theKey.byteLength;
            var fullKey = new ArrayBuffer(keyLength);
            var fullKeyView8 = new Uint8Array(fullKey);
            fullKeyView8.set(theKey);

            var result = new ArrayBuffer(buffer.byteLength);
            var resultView8 = new Uint8Array(result);

            var currentBufferLength = buffer.byteLength;
  
            for (var i = 0; i < currentBufferLength; i++) {
              resultView8[i] = fullKeyView8[(i+ offset) % fullKeyView8.length] ^ bufferView8[i];
            }
            // console.timeEnd("startCrypto");
  
            return Q.when(resultView8);
          } else {
            logger.debug("startCrypto( NOT Encrypted. Simply returning chunk as is. )", [buffer.byteLength]);
            return Q.when(buffer);
          }
        };

        
        
        /**
         * Reject the promise, crypto operation failed
         *
         * @param {Object} failure contains the reason why the operation failed
         */
        function cryptoFailed(failure) {
          if (!failure || failure === null) {
            failure = "Unknown error";
          }

          logger.warn("cryptoFailed( {0} )", [failure.toString()]);
          return Q.reject(failure);
        };

        return self.keyImport
          .then(startCrypto)
          .catch(cryptoFailed);
        /* jshint ignore:line */
      };
    })(this); // capture this as self in a closure for usage in promise handlers

    // make sure all functions for this object are bound to this so that we can call them from different
    // contexts without issue
    //
    // http://stackoverflow.com/questions/20279484/how-to-access-the-correct-this-context-inside-a-callback
    for (var property in this) {
      if (typeof this[property] === "function") {
        this[property] = this[property].bind(this);
      }
    }
  }

  /**
   * Hash of enumerated values describing defining the signature function to use for en/decryption.
   * @type {string}
   */
  XORCipher.ALGORITHM = {
    XOR_MASK: "XOR_MASK"
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Playback class, we could write:
   *
   *  `BankManager.prototype = Playback.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  XORCipher.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: XORCipher,

    /**
     * Import a key into the Cipher object
     *
     * @rawKey {ArrayBuffer/JSONWebKey} if type is "raw/pkcs8 or spki" ArrayBuffer, otherwise JSONWebKey
     */
    importKey: function (rawKey) {
  
      rawKey = atob(rawKey);
      function str2Uint8Array(str) {
        var buf = new ArrayBuffer(str.length);
        var uint8Array = new Uint8Array(buf);
        for (var i = 0;i < str.length; i++) {
          uint8Array[i] = str.charCodeAt(i);
        }
        return uint8Array;
      }
  
      if (typeof rawKey === 'string') {
        this.keyImport = Q.when(str2Uint8Array(rawKey));
      } else {
        this.keyImport = Q.when(rawKey);
      }
    },

    /**
     * Decrypt a buffer using the cipher
     *
     * @param {ArrayBuffer} buffer (cipherText) to be decrypted
     * @param {offset} offset point where we need to apply the decryption
     * @return {promise} Promise that will be resolved when buffer is decrypted
     */
    decrypt: function (buffer, offset) {
      if (this.hasDecrypt === true) {
        logger.debug("decrypt()");
    
        return this.doCrypto(buffer, offset);
      }
      else {
        throw new Error("Cipher instance cannot be used for decryption.");
      }
    },


    /**
     * Encrypt a buffer using the cipher
     *
     * @param {ArrayBuffer} buffer (clearText} to be encrypted
     * @return {promise} Promise that will be resolved when buffer is encrypted
     */
    encrypt: function () {
      logger.debug("encrypt()- Not implemented");
    }
  };

  return XORCipher;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/error/AssetError.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/error/AssetError.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Error for bad audio data most frequently used when accessing audio URLs from AudioModel.js.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the AssetError function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   */
  function AssetError(message, url, httpStatus, tokens) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof AssetError)) {
      throw new TypeError("AssetError constructor cannot be called as a function.");
    }

    // Grab the stack trace from the real-deal Error class
    Error.captureStackTrace(this, AssetError);

    /**
     * Create the error's message from the arguments passed; this allows token substitution; e.g.,
     * new AssetError("`{0}` parameter cannot be null.", ["playback"]) will output:
     *
     * "`playback` parameter cannot be null."
     */
    tokens = (tokens || []).concat([httpStatus]);
    message = ObjectUtil.isUndefinedOrNullOrEmptyString(message) ? AssetError.UNKOWN_ERROR : message;
    message = StringUtil.supplant(message, tokens);

    url = url || "Unknown";

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * The error message.
     * @type {String}
     */
    this.message = message || AssetError.UNKOWN_ERROR;

    /**
     * The error's name.
     * @type {String}
     */
    this.name = "AssetError";

    /**
     * URL for the asset.
     * @type {String}
     */
    this.url = url;

    /**
     * The HTTP status code for the failed asset.
     * @type {Number}
     */
    this.httpStatus = httpStatus ? httpStatus : null;
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * The default error message.
   * @type {String}
   * @const
   */
  AssetError.UNKOWN_ERROR = "Unknown error.";

  /**
   * Indicates the chunk data is invalid.
   * @const {String}
   */
  AssetError.CHUNK_CORRUPT = "The chunk data is corrupt and cannot be decoded for playback.";

  /**
   * Indicates an end-to-end audio time-out.
   * @const {String}
   */
  AssetError.COMPLETE_LOAD_TIMEOUT = "asset load time timed out";

  /**
   * Indicates the asset load did not make connection in time.
   * @const {String}
   */
  AssetError.MAKE_CONNECTION_TIMEOUT = "asset load did not make connection in time";

  /**
   * Indicates the asset load did not receive some playload in time.
   * @const {String}
   */
  AssetError.RECEIVE_BYTES_TIMEOUT = "asset load did not receive some payload in time";

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our AssetError class, we could write:
   *
   *  `BankManager.prototype = AssetError.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */

  // Inherit from the base Error class, which means we do not want to create a new `prototype` instance
  // for AssetError, but DO still need to point our prototype's `constructor` to our subclass `AssetError`.
  AssetError.prototype = Object.create(Error.prototype);
  AssetError.prototype.constructor = AssetError;

  return AssetError;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/error/AudioDataError.js":
/*!**********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/error/AudioDataError.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Error for bad audio data most frequently used when accessing audio URLs from AudioModel.js.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the AudioDataError function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   */
  function AudioDataError(message, tokens) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof AudioDataError)) {
      throw new TypeError("AudioDataError constructor cannot be called as a function.");
    }

    // Grab the stack trace from the real-deal Error class
    Error.captureStackTrace(this, AudioDataError);

    /**
     * Create the error's message from the arguments passed; this allows token substitution; e.g.,
     * new AudioDataError("`{0}` parameter cannot be null.", ["playback"]) will output:
     *
     * "`playback` parameter cannot be null."
     */
    message = ObjectUtil.isUndefinedOrNullOrEmptyString(message) ? AudioDataError.UNKOWN_ERROR : message;
    message = StringUtil.supplant(message, tokens);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * The error message.
     * @type {String}
     */
    this.message = message || AudioDataError.UNKOWN_ERROR;

    /**
     * The error's name.
     * @type {String}
     */
    this.name = "AudioDataError";
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * The default error message.
   * @type {String}
   * @const
   */
  AudioDataError.UNKOWN_ERROR = "Unknown error.";

  /**
   * Error message for an audio manifest size that has no URLs.
   * @type {String}
   * @const
   */
  AudioDataError.AUDIO_NO_URLS_FOR_SIZE = "There are no available HLS URLs for requested size `{0}`.";

  /**
   * Error message for bad audio data; i.e., there are no audio URLs in the data.
   * @type {String}
   * @const
   */
  AudioDataError.AUDIO_URLS_REQUIRED = "There are no HLS URLs in the audio data.";

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our AudioDataError class, we could write:
   *
   *  `BankManager.prototype = AudioDataError.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */

  // Inherit from the base Error class, which means we do not want to create a new `prototype` instance
  // for AudioDataError, but DO still need to point our prototype's `constructor` to our subclass `AudioDataError`.
  AudioDataError.prototype = Object.create(Error.prototype);
  AudioDataError.prototype.constructor = AudioDataError;

  return AudioDataError;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js":
/*!*******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/error/PlayerError.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Error for common player errors.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the PlayerError function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   */
  function PlayerError(message, tokens) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof PlayerError)) {
      throw new TypeError("PlayerError constructor cannot be called as a function.");
    }

    // Grab the stack trace from the real-deal Error class
    Error.captureStackTrace(this, PlayerError);

    /**
     * Create the error's message from the arguments passed; this allows token substitution; e.g.,
     * new PlayerError("`{0}` parameter cannot be null.", ["playback"]) will output:
     *
     * "`playback` parameter cannot be null."
     */
    message = ObjectUtil.isUndefinedOrNullOrEmptyString(message) ? PlayerError.UNKOWN_ERROR : message;
    message = StringUtil.supplant(message, tokens);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * The error message.
     * @type {String}
     */
    this.message = message || PlayerError.UNKOWN_ERROR;

    /**
     * The error's name.
     * @type {String}
     */
    this.name = "PlayerError";
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * The default error message.
   * @type {String}
   * @const
   */
  PlayerError.UNKOWN_ERROR = "Unknown error.";

  /**
   * Error message for calling constructor functions without the `new` keyword.
   * @type {String}
   * @const
   */
  PlayerError.CONSTRUCTOR_FUNCTION = "`{0}` constructor cannot be called as a function.";

  /**
   * Error message for calling a non-constructor functions with the `new` keyword.
   * @type {String}
   * @const
   */
  PlayerError.NOT_CONSTRUCTOR_FUNCTION = "'[object Object]' is not a constructor (evaluating 'new {0}()')";

  /**
   * Error message for required parameters that are missing from a function call.
   * @type {String}
   * @const
   */
  PlayerError.REQUIRED_PARAM = "`{0}` parameter cannot be null.";

  /**
   * Error message for the incorrect object type.
   * @type {String}
   * @const
   */
  PlayerError.INCORRECT_TYPE = "Incorrect type supplied. The expected type for `{0}` is `{1}`.";

  /**
   * Error message for a method that is required but not yet implemented.
   * @type {String}
   * @const
   */
  PlayerError.METOHD_NOT_IMPLEMENTED = "<< NOT AN ERROR >>. Method not implemented yet and just logging.";

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our PlayerError class, we could write:
   *
   *  `BankManager.prototype = PlayerError.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */

  // Inherit from the base Error class, which means we do not want to create a new `prototype` instance
  // for PlayerError, but DO still need to point our prototype's `constructor` to our subclass `PlayerError`.
  PlayerError.prototype = Object.create(Error.prototype);
  PlayerError.prototype.constructor = PlayerError;

  return PlayerError;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/error/PromiseError.js":
/*!********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/error/PromiseError.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Error for bad audio data most frequently used when accessing audio URLs from AudioModel.js.
 */



/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the PromiseError function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   */
  function PromiseError(message, tokens) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof PromiseError)) {
      throw new TypeError("PromiseError constructor cannot be called as a function.");
    }

    // Grab the stack trace from the real-deal Error class
    Error.captureStackTrace(this, PromiseError);

    /**
     * Create the error's message from the arguments passed; this allows token substitution; e.g.,
     * new PromiseError("`{0}` parameter cannot be null.", ["playback"]) will output:
     *
     * "`playback` parameter cannot be null."
     */
    message = ObjectUtil.isUndefinedOrNullOrEmptyString(message) ? PromiseError.UNKOWN_ERROR : message;
    message = StringUtil.supplant(message, tokens);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * The error message.
     * @type {String}
     */
    this.message = message || PromiseError.UNKOWN_ERROR;

    /**
     * The error's name.
     * @type {String}
     */
    this.name = "PromiseError";
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Error message for a promise that was intentionally cancelled.
   * @type {String}
   * @const
   */
  PromiseError.CANCEL_PROMISE = "Cancelling promise due to: {0}";

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our PromiseError class, we could write:
   *
   *  `BankManager.prototype = PromiseError.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */

  // Inherit from the base Error class, which means we do not want to create a new `prototype` instance
  // for PromiseError, but DO still need to point our prototype's `constructor` to our subclass `PromiseError`.
  PromiseError.prototype = Object.create(Error.prototype);
  PromiseError.prototype.constructor = PromiseError;

  return PromiseError;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/event/EventDispatcher.js":
/*!***********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/event/EventDispatcher.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    12/16/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * This EventDispatcher is a global event bus that handles publishing and subscribing of events.
 *
 * TODO: BMR: 03/10/2016: Consider giving events priority such that higher priority for a given type fires first
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   * @type {WebAudioPlayerLogger|*}
   */
  var logger = LoggerFactory.getLogger("EventDispatcher");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the EventDispatcher function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   */
  function EventDispatcher() {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof EventDispatcher)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["EventDispatcher"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Hash of listener, callback method with the event type string as the key.
     * @type {object}
     */
    this._listeners = {};
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Applies event dispatching capabilities to the supplied object param.
   */
  EventDispatcher.apply = function (object) {
    object.addEventListener = EventDispatcher.prototype.addEventListener;
    object.hasEventListener = EventDispatcher.prototype.hasEventListener;
    object.removeEventListener = EventDispatcher.prototype.removeEventListener;
    object.dispatchEvent = EventDispatcher.prototype.dispatchEvent;
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our EventDispatcher class, we could write:
   *
   *  `BankManager.prototype = EventDispatcher.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  EventDispatcher.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: EventDispatcher,

    /**
     * Adds an event listener or callback method to the event bus. Maintains a hash of listeners based on
     * event type.
     *
     * @param {String} type - The string event type linked to an event listener or callback method.
     * @param {Function} listener - The event listener method or callback for a given event type.
     */
    addEventListener: function (type, listener) {
      if (ObjectUtil.isUndefinedOrNull(type)) {
        throw new PlayerError(PlayerError.REQUIRED_PARAM, ["type"]);
      }

      if (!ObjectUtil.isString(type)) {
        throw new PlayerError(PlayerError.INCORRECT_TYPE, ["type", "string"]);
      }

      if (ObjectUtil.isUndefinedOrNull(listener)) {
        throw new PlayerError(PlayerError.REQUIRED_PARAM, ["listener"]);
      }

      if (!ObjectUtil.isFunction(listener)) {
        throw new PlayerError(PlayerError.INCORRECT_TYPE, ["listener", "function"]);
      }

      if (!this._listeners) {
        this._listeners = {};
      }

      if (!this._listeners[type]) {
        this._listeners[type] = [];
      }

      if (this._listeners[type].indexOf(listener) === -1) {
        this._listeners[type].push(listener);
      }
    },

    /**
     * Determines if the given object has event listeners.
     *
     * @param {String} type - The string event type linked to an event listener or callback method.
     * @param {Function} listener - The event listener method or callback for a given event type.
     * @returns {Boolean}
     */
    hasEventListener: function (type, listener) {

      if (!this._listeners) {
        return false;
      }

      var listeners = this._listeners[type];
      return (listeners !== undefined && listeners.indexOf(listener) !== -1);
    },

    /**
     * Removes an event listener or callback method to the event bus.
     *
     * @param {String} type - The string event type linked to an  event listener or callback method.
     * @param {Function} listener - The event listener method or callback for a given event type.
     */
    removeEventListener: function (type, listener) {
      if (!this._listeners) {
        return false;
      }

      var listeners = this._listeners;
      var listenerArray = listeners[type];

      if (listenerArray !== undefined) {
        var index = listenerArray.indexOf(listener);

        if (index !== -1) {
          listenerArray.splice(index, 1);
          return true;
        }
      }

      return false;
    },

    /**
     * Dispatches the event object, which essentially invokes any event listener or callback methods associated
     * with the type.
     *
     * The event object must contain a `type` property
     *
     * @param {Object} event - The event object contains a type property at a minimum and any data associated with it.
     */
    dispatchEvent: function (event) {
      if (ObjectUtil.isUndefinedOrNullOrEmptyString(event.type)) {
        throw new Error("All events must have a non-empty string `type` property.");
      }

      if (!this._listeners) {
        return false;
      }

      var listenerArray = this._listeners[event.type];

      if (listenerArray) {
        var array = [];
        var length = listenerArray.length;

        for (var i = 0; i < length; i++) {
          array[i] = listenerArray[i];
        }

        for (var j = 0; j < length; j++) {
          try {
            array[j](event);
          }
          catch (error) {
            logger.error(error);
          }
        }
        return true;
      }
      return false;
    }
  };

  return EventDispatcher;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/event/EventManager.js":
/*!********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/event/EventManager.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Handles all of the event management (adding and removing) for the audio player at the highest level. Will
 * cache all of the event listeners from clients and add/remove to/from the target object upon request.
 *
 * Currently this is all setup in the HTML5AudioPlayer object, as it's responsible for creating and destroying
 * individual Playback instances, which ultimately are the source of the player's events.
 *
 * Can perform single event handler adding/removing or all at once for all of the cached listeners.
 *
 * Also has the ability to add/remove event listeners to an interceptor, something other than the original client.
 * This is currently used in the case of the "finished" event from the player; both the client and our
 * HTML5AudioPlayer object need to know about this event, but the latter is more important as it handles
 * seamless playback for track based audio like MySXM -- simply put, it'll listen to the "finished" event from
 * Track1 and then play the queued (preloaded) Track2. This is the simplest example of an event that's published
 * to both the client using the audio player and intercepted by the object setting up the event system (in this
 * case the HTML5AudioPlayer). The event interceptors are passed in as an array with the following structure:
 *
 * [
 *   {
 *     type: "finished",
 *     handler: fn
 *   }
 * }
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("EventManager");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the EventManager function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Array} eventInterceptors - List of events to intercept from the client class using
   * this manager.
   */
  function EventManager(eventInterceptors) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof EventManager)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["EventManager"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * List of event interceptors..
     * @type {Array}
     * @private
     */
    this._eventInterceptors = eventInterceptors;

    /**
     * List of events and handlers that are cached and added to individual Playback instances as required.
     * @type {Array}
     * @private
     */
    this._listenerCache = [];
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Adds or removes event handlers to a target. Keeps repetitive code down when adding or remove event listeners.
   *
   * @param {Object} target - The object to add or remove event handlers.
   * @param {String} type - The event type.
   * @param {Function} callback - The event handler method.
   * @param {Boolean} [activate=true] - Flag indicating to add or remove event handlers.
   * @param {Array} [interceptors=[]] - List of events to intercept.
   */
  EventManager.activateListener = function (target, type, callback, activate, interceptors) {
    activate = ObjectUtil.isUndefinedOrNullOrEmptyString(activate) ? true : activate;
    interceptors = ObjectUtil.isUndefinedOrNullOrEmptyString(interceptors) ? [] : interceptors;

    if (ObjectUtil.isUndefinedOrNull(target)) {
      throw new Error("Target must be a defined and non-null.");
    }
    if (ObjectUtil.isUndefinedOrNullOrEmptyString(type)) {
      throw new Error("Event type must be a non-null, non-empty string.");
    }
    if (ObjectUtil.isUndefinedOrNullOrEmptyString(callback)) {
      throw new Error("Event handler method cannot be null.");
    }

    var fn = (activate) ? target.addEventListener : target.removeEventListener;
    // TODO: BMR: 03/02/2016: Might be able to delete this as it's a vestige from AS3 player
    //var args = (activate) ? [false, 0, true] : [];
    var args = [];

    var active = activate ? "activateListener" : "deactivateListener";
    var activeInterceptor = activate ? "activateInterceptorListener" : "deactivateInterceptorListener";
    var add = activate ? "Adding" : "Removing";
    logger.debug("{0}( {1} `{2}` from player ID = {3} )", [active, add, type, target.id]);
    fn.apply(target, [type, callback].concat(args));

    for (var prop in interceptors) {
      if (Object.prototype.hasOwnProperty.call(interceptors, prop)) {
        if (type === interceptors[prop].type) {
          logger.debug("{0}( {1} interceptor `{2}` )", [activeInterceptor, add, type]);
          fn.apply(target, [type, interceptors[prop].handler].concat(args));
        }
      }
    }
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our EventManager class, we could write:
   *
   *  `BankManager.prototype = EventManager.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  EventManager.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: EventManager,

    /**
     * Caches the event listener for latest use and/or adds them to the target immediately if provided.
     *
     * @param {String} type - The event type.
     * @param {Function} handler - The event handler method.
     * @param {Object} [target] - The object to add or remove event handlers. If not undefined or null then
     * add the listener immediately.
     */
    addEventListener: function (type, handler, target) {
      if (this._listenerCache.findIndex(function(listener) { return (listener.type === type); }) < 0) {
        var listener = {
          type: type,
          handler: handler
        };

        //logger.debug("addEventListener( Caching listener for for event type `{0}`. Will attach to object handler at a later time... )", [type]);
        this._listenerCache.push(listener);
      }

      if (!ObjectUtil.isUndefinedOrNull(target)) {
        EventManager.activateListener(target, type, handler, true);
      }
    },

    /**
     * Removes the event listener from the target.
     *
     * @param {String} type - The event type.
     * @param {Function} handler - The event handler method.
     * @param {Object} target - The object to add or remove event handlers.
     */
    removeEventListener: function (type, handler, target) {
      var item = this._listenerCache.find(function(listener) { return listener.type === type; });
      if (!ObjectUtil.isUndefinedOrNull(item) && !ObjectUtil.isUndefinedOrNull(target)) {
        EventManager.activateListener(target, type, handler, false);
      }
      this._listenerCache = this._listenerCache.filter(function(listener){
        return listener.type !== type;
      });
    },

    /**
     * Adds or removes all cached listeners to the target object.
     *
     * @param {Object} target - The object to add or remove event handlers.
     * @param {Boolean} activate - Indicates if adding or removing event listeners.
     */
    activateAllListeners: function (target, activate) {
      if (this._listenerCache && this._listenerCache.length > 0) {
        activate = ObjectUtil.isUndefinedOrNullOrEmptyString(activate) ? true : activate;
        var add = activate ? "Adding" : "Removing";
        var to = activate ? "to" : "from";

        logger.debug("activateAllListeners( {0} {1} listeners {2} Player ID = {3} )", [
          add, this._listenerCache.length, to, target.id
        ]);

        for (var i = 0; i < this._listenerCache.length; i++) {
          var item = this._listenerCache[i];
          EventManager.activateListener(target, item.type, item.handler, activate, this._eventInterceptors);
        }
      }
    }
  };

  return EventManager;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/event/PlaybackEventMonitor.js":
/*!****************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/event/PlaybackEventMonitor.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Handles all of the event management...
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var PlaybackTypeUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaybackTypeUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js");
  var PlayerEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/PlayerEvent */ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js");
  var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("PlaybackEventMonitor");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the PlaybackEventMonitor function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Playback} playback - Reference to the playback instance this is monitoring.
   */
  function PlaybackEventMonitor(playback) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof PlaybackEventMonitor)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["PlaybackEventMonitor"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Reference to the playback instance that will dispatch the events.
     * @type {Playback}
     * @private
     */
    this._playback = playback;

    /**
     * Used to keep track of the last playhead dispatched.
     * @type {Number}
     * @private
     */
    this._lastPlayhead = 0;
  }

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our PlaybackEventMonitor class, we could write:
   *
   *  `BankManager.prototype = PlaybackEventMonitor.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  PlaybackEventMonitor.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: PlaybackEventMonitor,

    /**
     * Dispatches a PlayerEvent for client objects using the Playback object. Simplifies what client objects need
     * to know about currently playback and centralizes it here. Allows for optional error parameter as well.
     *
     * @param {String} type - Event type.
     * @param {Object} [error] - Optional error object.
     */
    dispatchEvent: function (type, error) {
      if (this._playback) {
        // Flag indicating how much event dispatch logging is allowed.
        // Only use for development purposes -- useful for debugging all player event details.
        var verboseLogging = false;

        // Shortcut vars.
        var lastPlayhead = this._lastPlayhead;
        var playhead = this._playback.playhead;


        // ACCOUNT FOR EDGE CASES

        // we might have stopped the monitor.
        // by the time the message gets here.
        // so don't dispatch a playhead event
        // because if you were to you query the monitor in the following
        // lines after, the playhead data would be wrong.
        if (type === PlayerEvent.PLAYHEAD && this._playback.playheadMonitor._isStopped) {
          return;
        }

        // Create a player event.
        var playerEvent = this.createPlayerEvent(type, error);

        // Only dispatch the event if it's not throttled.
        if (!this.isThrottled(type)) {
          if (verboseLogging) {
            logger.info("dispatchEvent( {0} )", [type]);
          }
          else {
            var isMetricLoggable = PlayerEvent.isReady(type) || PlayerEvent.isStart(type) || PlayerEvent.isFinished(type);
            var isPlayheadLoggable = PlayerEvent.isPlayhead(type) && ((playhead > lastPlayhead) && ((playhead -
              lastPlayhead) >= HlsConfig.PLAYHEAD_INTERVAL));

            if (isMetricLoggable) {
              // NOTE: Only uncomment this for development purposes -- useful for debugging all player event details.
              //logger.metric("dispatch( {0} )", [playerEvent.toString()]);
              logger.info("dispatchEvent( {0} )", [playerEvent.toString()]);
            }
            else if (isPlayheadLoggable) {
              this._lastPlayhead = playhead;
              logger.info("dispatchEvent( {0} )", [playerEvent.toString()]);
            }
          }

          this._playback.dispatchEvent(playerEvent);
        }
      }
    },

    /**
     * Creates the PlayerEvent.
     *
     * @param {String} type - Event type.
     * @param {Object} [error] - Optional error object.
     * @return {PlayerEvent}
     */
    createPlayerEvent: function (type, error) {
      // NOTE: Only uncomment this for development purposes -- useful for debugging all player event details.
      // logger.debug("createPlayerEvent( `{0}` )", [type]);

      // Shortcut vars to objects in Playback.
      var playlist = this._playback.playlist;
      var variant = this._playback.variant;
      var playheadMonitor = this._playback.playheadMonitor;

      // it's possible a variant was not used and the player was given a playlist directly or we're playing audio first.
      var bitRate = variant ? variant.getCurrentStreamBitRateName() : "32k";

      // determines if all chunks have been loaded for finite playlists like AOD and MySXM -- not for Live
      // since it uses infinite playlists
      var isLive = PlaybackTypeUtil.isPlayerLive(this._playback);
      var bufferComplete = (!isLive && playlist && playlist.areAllChunksLoaded);

      var bufferTime = this._playback.bufferTime;
      var playhead = this._playback.playhead;
      var duration = this._playback.duration;
      var loaded = playhead + bufferTime;
      var zuluStart = playheadMonitor ? playheadMonitor.startTime : NaN;
      var offSet = playheadMonitor ? playheadMonitor.getInitialChunkOffset() : NaN;
      var playbackType = this._playback.configuration.playbackType;

      var playerEvent = new PlayerEvent(type, this._playback.id, playbackType, playhead, duration, offSet, bufferTime,
        loaded, isLive, zuluStart, bitRate, bufferComplete);
      playerEvent.error = error;

      // TODO: BMR: Consider removing this if not used by Chromecast.
      playerEvent.timeIntoPlaylist = playlist ? playlist.getTimeIntoPlaylist(playerEvent.playheadZulu) : null;

      return playerEvent;
    },

    /**
     * Determines if throttling should be applied to the event so it's not broadcast at too
     * high of a frequency.
     *
     * Currently this only throttles "playhead" events but this could be extended to throttle others.
     *
     * @param {String} type - Event type.
     * @returns {Boolean}
     */
    isThrottled: function (type) {
      var playhead = this._playback.playhead;
      var delta = playhead - this._lastPlayhead;

      if (type === PlayerEvent.PLAYHEAD) {
        // We want to provide immediate feedback to the user so we'll let the very first playhead event that's
        // fired slip through...after that it's every 750ms.
        if ((this._lastPlayhead === 0) && (playhead >= 0)) {
          return false;
        }
        else {
          return (type === PlayerEvent.PLAYHEAD) ? (delta < HlsConfig.EVENT_DISPATCHING_INTERVAL) : false;
        }
      }

      return false;
    },

    /**
     * Resets the monitor.
     */
    reset: function () {
      logger.debug("reset()");

      this._lastPlayhead = 0;
      this._playback = null;
    }

  };

  return PlaybackEventMonitor;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js":
/*!*******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Captures current player details and status in an event published to clients. Most commonly used to report
 *      playhead details.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require)
  {
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
    var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------
    
    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the PlayerEvent function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @constructor
     * @param {String} type - The event type.
     * @param {String} id - The unique ID for each player.
     * @param {String} playbackType - The playback type for this player: Live, AOR, or MySXM.
     * @param {Number} playhead - Position in milliseconds start of playback.
     * @param {Number} duration - Total playback duration in milliseconds ( Live === NaN ).
     * @param {Number} offset - Initial playback in milliseconds offset or last seek position.
     * @param {Number} buffered - Time amount in milliseconds of playback data currently in the pending input buffer.
     * @param {Boolean} isLive - Boolean indicating if the playback type is Live.
     * @param {Number} zuluStart - Time in milliseconds indicating the start time for playback.
     * @param {String} bitRate - The current bit rate for playback.
     * @param {Boolean} bufferComplete - Flag indicating if the buffer is completely full. This is only applicable to finite
     * playlists like AOD and MySXM and not Live.
     */
    function PlayerEvent(type,
                         id,
                         playbackType,
                         playhead,
                         duration,
                         offset,
                         buffered,
                         loaded,
                         isLive,
                         zuluStart,
                         bitRate,
                         bufferComplete) {
      // This first guard ensures that the callee has invoked our Class' constructor function
      // with the `new` keyword - failure to do this will result in the `this` keyword referring
      // to the callee's scope (typically the window global) which will result in the following fields
      // (name and _age) leaking into the global namespace and not being set on this object.
      if (!(this instanceof PlayerEvent)) {
        throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["PlayerEvent"]);
      }
      
      // Make sure the event type is defined
      // TODO: BMR: Consider creating a base event class with this check in it
      if (ObjectUtil.isUndefinedOrNull(type)) {
        throw new PlayerError(PlayerError.REQUIRED_PARAM, ["type"]);
      }
      
      if (!ObjectUtil.isString(type)) {
        throw new PlayerError(PlayerError.INCORRECT_TYPE, ["type", "string"]);
      }
      
      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------
      
      /**
       * The event type.
       * @type {String}
       */
      this.type = type;
      
      /**
       * The unique ID for each player.
       * @type {String}
       */
      this.id = id || "";
      
      /**
       * The playback type for this player: Live, AOD, or MySXM.
       * @type {String}
       */
      this.playbackType = playbackType || "";
      
      /**
       * Zero-based playhead position in milliseconds since the start of playback.
       * @type {Number}
       */
      this.playhead = playhead || 0;
      
      /**
       * Total playback duration in milliseconds ( Live === NaN ).
       * @type {Number}
       */
      this.duration = duration || NaN;
      
      /**
       * Initial playback in milliseconds offset or last seek position.
       * @type {Number}
       */
      this.started = offset || NaN;
      
      /**
       * Time amount in milliseconds of playback data currently in the pending input buffer.
       * @type {Number}
       */
      this.buffered = buffered || 0;
      
      
      /**
       * Time amount in milliseconds of playback includes buffered + playhead values.
       * @type {Number}
       */
      this.loaded = loaded || 0;
      
      /**
       * Absolute epoch/zulu start time (in milliseconds) for the player; should not be used for MySXM.
       * @type {Number}
       */
      this.startedZulu = zuluStart;
      
      /**
       * Absolute epoch/zulu playhead time (in milliseconds) for the player; should not be used for MySXM.
       * @type {Number}
       */
      this.playheadZulu = playhead + zuluStart;
      
      /**
       * Boolean indicating if the playback type is Live.
       * @type {boolean}
       */
      this.isLive = isLive || false;
      
      /**
       * Bit rate (32K/64K/96K/256K) of the now playing player stream.
       * @type {String}
       */
      this.bitRate = bitRate || "";
      
      /**
       * First chunk start time.
       * @type {Number}
       */
      this.zuluBaseline = isNaN(zuluStart) ? 0 : zuluStart;
      
      /**
       * Boolean indicating if the buffering is complete - all chunks for the playlist loaded.
       * @type {boolean}
       */
      this.bufferComplete = bufferComplete || false;
      
      /**
       * A generic object container for player errors. Contains details for the error.
       * @type {object}
       */
      this.error = {};
    };
    
    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------
    
    /**
     * Constant for the player event representing the player's state as ready.
     * @const {String}
     */
    PlayerEvent.PLAYBACK_READY = "playbackReady";
    
    /**
     * Constant for the player event representing the player's state as playback started.
     * @const {String}
     */
    PlayerEvent.PLAYHEAD_START = "playheadStart";
    
    /**
     * Constant for the player event representing the player's constant heartbeat via the playhead.
     * @const {String}
     */
    PlayerEvent.PLAYHEAD = "playhead";
    
    /**
     * Constant representing the preloading player event.
     * @const {String}
     */
    PlayerEvent.PRELOADING = "preloading";
    
    /**
     * Constant representing the preloading complete player event.
     * @const {String}
     */
    PlayerEvent.PRELOADING_COMPLETE = "preloadingComplete";
    
    /**
     * Constant representing the bit rate changee player event.
     * @const {String}
     */
    PlayerEvent.BIT_RATE_CHANGE = "bitRateChange";
    
    /**
     * Constant for the player event dispatched when it's failing over.
     * @const {String}
     */
    PlayerEvent.FAILOVER = "failover";
    
    /**
     * Constant for the player event dispatched when the token is invalid.
     * @const {String}
     */
    PlayerEvent.TOKEN_INVALID = "tokenInvalid";

    /**
     * Constant for the player event dispatched when the player goes to suspended state due to
     * autoPlay is disabled by the browser (safari/chrome/firefox) mainly safari(autoPlay issues)
     * @const {String}
     */
    PlayerEvent.PLAYBACK_DENIED = "NotAllowedError";
    
    /**
     * Constant for the player event dispatched when a key failed to load.
     * @const {String}
     */
    PlayerEvent.KEY_FAILED = "keyFailed";
    
    /**
     * Constant for the player event dispatched when there are no tracks to play for My.
     * @const {String}
     */
    PlayerEvent.NO_TRACKS = "noTracks";
  
    /**
     * Constant for the player event dispatched when there are no tracks to play for My.
     * @const {String}
     */
    PlayerEvent.TRACK_FAILED = "trackFailed";
    
    /**
     * Constant for the player event dispatched when there's no connectivity.
     * @const {String}
     */
    PlayerEvent.CONNECTIVITY_FAILED = "connectivityFailed";
    
    /**
     * Constant for the player event dispatched when it's restarted.
     * @const {String}
     */
    PlayerEvent.RESTART = "restart";
    
    /**
     * Constant for the player event dispatched when it's finished.
     * @const {String}
     */
    PlayerEvent.FINISHED = "finished";
    
    /**
     * Constant for the player event dispatched when it's behind the playlist.
     * This could happen on live if the player has been paused for > 5 hours.
     * @const {String}
     */
    PlayerEvent.BEHIND_PLAYLIST = "behindPlaylist";
    
    /**
     * Constant for the player event dispatched when the decoder fails
     * to decode a chunk properly.
     * @const {String}
     */
    PlayerEvent.DECODER_FAILURE = "decoderFailure";
  
    /**
     * Constant for the player event dispatched when a track reaches the
     * crossfade point in the track for when to start the next track.
     * @const {String}
     */
    PlayerEvent.CROSSFADE_POINT_REACHED = "crossfadePointReached";
    
    /**
     * Determines if the event type is the "ready" event.
     * @param {String} type - The event type under inspection.
     * @returns {Boolean} Flag indicating if the event is the "ready" event.
     */
    PlayerEvent.isReady = function (type) {
      return (type === PlayerEvent.PLAYBACK_READY);
    };
    
    /**
     * Determines if the event type is the "start" event.
     * @param {String} type - The event type under inspection.
     * @returns {Boolean} Flag indicating if the event is the "start" event.
     */
    PlayerEvent.isStart = function (type) {
      return (type === PlayerEvent.PLAYHEAD_START);
    };
    
    /**
     * Determines if the event type is the "playhead" event.
     * @param {String} type - The event type under inspection.
     * @returns {Boolean} Flag indicating if the event is the "playhead" event.
     */
    PlayerEvent.isPlayhead = function (type) {
      return (type === PlayerEvent.PLAYHEAD);
    };
    
    /**
     * Determines if the event type is the "finished" event.
     * @param {String} type - The event type under inspection.
     * @returns {Boolean} Flag indicating if the event is the "finished" event.
     */
    PlayerEvent.isFinished = function (type) {
      return (type === PlayerEvent.FINISHED);
    };
    
    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------
    
    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our PlayerEvent class, we could write:
     *
     *    `BankManager.prototype = PlayerEvent.prototype`
     *    `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    PlayerEvent.prototype = {
      
      /**
       * Whenever you replace an Object's Prototype, you need to repoint
       * the base Constructor back at the original constructor Function,
       * otherwise `instanceof` calls will fail.
       */
      constructor: PlayerEvent,
      
      /**
       * Simple toString() method capturing the objects details.
       * @returns {String}
       */
      toString: function () {
        return StringUtil.supplant(
          "type = {0}, playhead = {1}, duration = {2}, offset = {3}, buffered = {4}, isLive = {5}, " +
          "bitRate = {6}, bufferComplete = {7}, loaded = {8}, startedZulu = {9}, playheadZulu = {10}, startedZuluUTC = {11}, playheadZuluUTC = {12}", [
            this.type, this.playhead, this.duration, this.started, this.buffered, String(this.isLive), this.bitRate,
            String(this.bufferComplete), String(this.loaded), this.startedZulu, this.playheadZulu,
            new Date(this.startedZulu).toUTCString(), new Date(this.playheadZulu).toUTCString()
          ]);
      }
      
    };
    return PlayerEvent;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));




/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/event/StateChangeEvent.js":
/*!************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/event/StateChangeEvent.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Captures player state changes in an event published to clients with both the last state and the new state.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("StateChangeEvent");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the StateChangeEvent function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {String} id - The unique ID for each player.
   * @param {String} newState - The new current state that was just set.
   * @param {String} oldState - The old or last state.
   */
  var StateChangeEvent = function (id, newState, oldState) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof StateChangeEvent)) {
      throw new TypeError("StateChangeEvent constructor cannot be called as a function.");
    }

    logger.debug("Constructor( old = {0}, new = {1} )", [String(oldState), String(newState)]);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * The event type.
     * @type {String}
     * @required
     */
    this.type = StateChangeEvent.STATE_CHANGE;

    /**
     * The unique ID for each player.
     * @type {String}
     */
    this.id = id || "";

    /**
     * The new current state that was just set.
     * @type {String}
     */
    this.current = newState || "";

    /**
     * The old or last state.
     * @type {String}
     */
    this.previous = oldState || "";
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Constant representing the state change event.
   * @type {String}
   */
  StateChangeEvent.STATE_CHANGE = "playStateChanged";

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our StateChangeEvent class, we could write:
   *
   *    `BankManager.prototype = StateChangeEvent.prototype`
   *    `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  StateChangeEvent.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: StateChangeEvent,

    /**
     * Simple toString() method capturing the objects details.
     * @returns {String}
     */
    toString: function () {
      return StringUtil.supplant(
        "type = {0}, current = {1}, previous = {2}", [this.type, this.current, this.previous]);
    }

  };

  return StateChangeEvent;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/loader/AssetLoader.js":
/*!********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/loader/AssetLoader.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      This class loads data via HTTP by wrapping the XMLHttpRequest and exposing a promise based API.
 */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var Asset = __webpack_require__(/*! sxm/audioplayer/html5/model/Asset */ "./javascript/src/sxm/audioplayer/html5/model/Asset.js");
  var AssetError = __webpack_require__(/*! sxm/audioplayer/html5/error/AssetError */ "./javascript/src/sxm/audioplayer/html5/error/AssetError.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
  var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var Timer = __webpack_require__(/*! sxm/audioplayer/html5/util/Timer */ "./javascript/src/sxm/audioplayer/html5/util/Timer.js");
  var Q = __webpack_require__(/*! q */ "q");

  var logger = LoggerFactory.getLogger("AssetLoader");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the AssetLoader function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   */
  function AssetLoader() {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof AssetLoader)) {
      throw new TypeError("AssetLoader constructor cannot be called as a function.");
    }

    // Bind the scope of "this" to all first class functions
    ClassUtil.bindFunctions(this);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * The url used to load the asset.
     * @type {String}
     * @private
     */
    this._url = "";

    /**
     * Reference to the internal mm request object.
     * @type {null}
     * @private
     */
    this._request = null;
  }

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * The HTTP response type for text. This is used for manifests most of the time.
   * @const {String}
   */
  AssetLoader.TYPE_TEXT = "text";

  /**
   * The HTTP response type for binary data. This is used for chunks and keys most of the time.
   * @const {String}
   */
  AssetLoader.TYPE_ARRAY_BUFFER = "arraybuffer";

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our AssetLoader class, we could write:
   *
   *  `BankManager.prototype = AssetLoader.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  AssetLoader.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: AssetLoader,

    /**
     * Loads data via HTTP using the XMLHttpRequest object and wraps it in a promise.
     *
     * @param {String} url - The URL of the asset to load.
     * @param {String} type - The data type of the asset to load.
     * @returns {Promise}
     */
    load: function (url, type) {
      var self = this;
      // Generate the URL with HLS consumption data query string parameters.
      url = this.createUrl(url);
      this._url = url;

      if (ObjectUtil.isUndefinedOrNullOrEmptyString(url)) {
        throw new PlayerError(PlayerError.REQUIRED_PARAM, ["url"]);
      }
      logger.info("load( url = {0}, type = {1} )", [String(url), type]);

      this.dfd = Q.defer();
      var startTime = 0;
      var loadTime = 0;
      var size = 0;

      this._request = new XMLHttpRequest();

      // The following is designed to disable the dynatrace snooping of XmlHttpRequests.
      // That snooping slows down audio pulls.
      if (this._request && this._request.originalXhr) {
        this._request = this._request.originalXhr;
      }

      this._request.withCredentials = HlsConfig.WITH_CREDENTIALS;

      this._request.onload = loadSuccess;
      this._request.onerror = loadFault;
      this._request.ontimeout = loadTimeout;

      this._request.addEventListener('loadstart', onLoadStart);
      this._request.addEventListener('progress', onProgress);

      this._request.open("GET", url, true);
  
      if (!ObjectUtil.isUndefinedOrNull(type) && ObjectUtil.isString(type) && !ObjectUtil.isEmptyString(type)) {
        this._request.responseType = type;
      }
      this._request.timeout = HlsConfig.LOAD_COMPLETE_LIMIT;
      // we want to capture how long it took the asset to load
      startTime = new Date().getTime();
      this.startTimers();
      // fire off the load request
      this._request.send();
      return this.dfd.promise;

      /**
       * Handles the successful HTTP request.
       * @param {XMLHttpRequestProgressEvent} response - The response from the successful asset load.
       * @return {Promise}
       */
      function loadSuccess() {
        // Determine if the asset load was truly successful -- keep in mind that any actual server
        // response is considered a success, so we need to check the HTTP status code to know for sure.
        // If it's not a 200, then fail the request and reject the promise
        if (self._request.status === 200) {
          var endTime = new Date().getTime();
          loadTime = endTime - startTime;
          size = parseInt(self._request.getResponseHeader("Content-Length"), 10);

          logger.info("loadSuccess( url = {0}, type = {1}, loadTime = {2}, size = {3}, startTime = {4} )", [
            url, type, loadTime, size, startTime
          ]);

          var asset = new Asset(self._request.response, url, size, loadTime, StringUtil.getFileName(url), type);
          self.dfd.resolve(asset);
          self.cleanup();
        }
        else {
          loadFault();
        }
      }

      /**
       * Handles a failed HTTP request.
       * @param {AssetError} fault - The fault object for the failed asset load.
       * @return {Promise}
       */
      function loadFault() {
        var message = "HTTP {0} " + self._request.statusText;
        var assetError = new AssetError(message, url, self._request.status);

        logger.warn("loadFault( HTTP Status Code = {0}, message = {1}, type = {2}, url = {3} )", [
          assetError.httpStatus, assetError.message, type, url
        ]);

        self.dfd.reject(assetError);
        self.cleanup();
      }

      /**
       * Handles a complete load timeout.
       * @return undefined
       */
      function loadTimeout() {
        var assetError = new AssetError(AssetError.COMPLETE_LOAD_TIMEOUT, url);
        self.timerExpired(assetError);
      }

      /**
       * Handles a loadstart event received from xhr object.
       * Cancels the loadStartTimer.
       */
      function onLoadStart() {
        self.loadStartTimer.stop();
        self._request.removeEventListener('loadstart', onLoadStart);
      }

      /**
       * Handles a progress event received from xhr object.
       * Cancels the progress timer.
       */
      function onProgress() {
        self.progressTimer.stop();
        self._request.removeEventListener('progress', onProgress);
      }
    },

    /**
     * Code that runs after a timeout has occured.
     * rejects the promise with a given promise and aborts the current xhr request.
     */
    timerExpired: function (timeoutFault) {
      var aMessage = timeoutFault.message ? timeoutFault.message : "";
      logger.error(aMessage + ' ' + this._url);
      this.dfd.reject(timeoutFault);
      this.abort();
    },

    /**
     * Sets two timers which could timeout and run their callbacks
     * These timers might be canceled by progress events sent by xhr object.
     */
    startTimers: function () {
      var self = this;
      this.loadStartTimer = new Timer(HlsConfig.LOAD_EVENT_LIMIT, onLoadStartTimeout);
      this.progressTimer = new Timer(HlsConfig.LOAD_EVENT_LIMIT * this.progressTimeoutMultiplier(), onProgressTimeout);
      this.loadStartTimer.runOnce();
      this.progressTimer.runOnce();

      function onLoadStartTimeout() {
        var assetError = new AssetError(AssetError.MAKE_CONNECTION_TIMEOUT, self._url);
        self.timerExpired(assetError);
      }

      function onProgressTimeout() {
        var assetError = new AssetError(AssetError.RECEIVE_BYTES_TIMEOUT, self._url);
        self.timerExpired(assetError);
      }
    },

    /**
     * Determines what factor to multiple the timeout limit by for progress events.
     * Key pulls take longer so the multiple should be longer.
     */
    progressTimeoutMultiplier: function () {
      return this.isKeyPull() ? 10 : 10;
    },

    /**
     * If this asset load is a key pull returns true
     * Otherwise returns false.
     */
    isKeyPull: function () {
      var tokenStrategy = HlsConfig.getTokenStrategy(this._url);
      var keyPattern = tokenStrategy ? tokenStrategy.keyPattern : "/key/";
      return this._url.indexOf(keyPattern) >= 0;
    },

    /**
     * Attempts to abort any current loads by the internal loader.
     */
    abort: function () {
      if (this._request) {
        logger.debug("abort()");
        this._request.abort();
        this.cleanup();
      }
    },

    /**
     * Cleans up the request object by removing listeners and callbacks.
     */
    resetRequest: function () {
      if (this._request) {
        logger.debug("resetRequest( Removing listeners and callbacks. )");
        this._request.onload = null;
        this._request.onerror = null;
      }
    },

    /**
     * Generates the URL by using the passed in asset URL and appending the HLS consumption info
     * as the query string.
     * @param {String} url - The asset's URL.
     * @returns {String} The asset URL with HLS consumption info appended as a query string.
     */
    createUrl: function (url) {

      var addTokenParams = function (url) {
        var tokenStrategy = HlsConfig.getTokenStrategy(url);

        if (tokenStrategy === null) {
          return url;
        }

        var keyPattern = tokenStrategy.keyPattern;
        var assetStart = url.indexOf(tokenStrategy.assetStartPattern);
        var isKeyPull = ((url.indexOf(keyPattern) >= 0) && (assetStart >= 0));

        if (isKeyPull === true) {
          url = HlsConfig.KEYPATH + url.substring(assetStart);
        }
        else {
          url = HlsConfig.getTokenizedUrl(url);
        }

        return url;
      };

      url = addConsumptionInfoParams(url);
      url = addTokenParams(url);

      return url;


      function addConsumptionInfoParams(url) {
        // The consumption info always comes from the client as a valid query string; e.g., ?foo=bar.
        logger.info("addTokenParams( consumptionInfo = {0} )", [HlsConfig.CONSUMPTION_INFO]);
        return url + HlsConfig.CONSUMPTION_INFO;
      }
    },

    /**
     * Prepares the object for garbage collection by removing old references and listeners.
     */
    cleanup: function () {
      logger.debug("cleanup()");
      this.resetRequest();
      if (this.loadStartTimer) {
        this.loadStartTimer.stop();
      }
      if (this.progressTimer) {
        this.progressTimer.stop();
      }
      this.loadStartTimer = null;
      this.progressTimer = null;
    }
  };

  return AssetLoader;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/loader/KeyLoader.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/loader/KeyLoader.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      This class loads HLS decryption keys via a promise based API.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var AssetLoader = __webpack_require__(/*! sxm/audioplayer/html5/loader/AssetLoader */ "./javascript/src/sxm/audioplayer/html5/loader/AssetLoader.js");
  var RetryLoader = __webpack_require__(/*! sxm/audioplayer/html5/loader/RetryLoader */ "./javascript/src/sxm/audioplayer/html5/loader/RetryLoader.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("KeyLoader");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the KeyLoader function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   */
  function KeyLoader() {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof KeyLoader)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["KeyLoader"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Chunk loader.
     * @private
     * @type {RetryLoader}
     */
    this._loader = null;

    /**
     * Read-only accessor to the loading state.
     * @type {Boolean}
     */
    Object.defineProperty(this, "isLoading",
      {
        get: function () {
          return !ObjectUtil.isUndefinedOrNull(this._loader) && this._loader.isLoading;
        }.bind(this)
      });
  }

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our KeyLoader class, we could write:
   *
   *  `BankManager.prototype = KeyLoader.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  KeyLoader.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: KeyLoader,

    /**
     * Loads a decryption key file via HTTP.
     *
     * @param {String} url - The key file's URL.
     * @returns {Promise}
     */
    load: function (url) {
      logger.info("load( url = {0} )", [url]);

      this._loader = new RetryLoader(AssetLoader.TYPE_ARRAY_BUFFER);

      var loadSuccess = function (response) {
        logger.info("loadSuccess( url = {0} )", [url]);
        return response.data;
      };

      var loadFault = function (fault) {
        logger.warn("loadFault( url = {0} )", [url]);
        throw fault;
      };

      return this._loader.load(url).then(loadSuccess, loadFault);
    },

    /**
     * Attempts to abort any current loads by the internal loader.
     */
    abort: function () {
      if (this._loader) {
        logger.debug("abort()");
        this._loader.abort();
      }
    },

    /**
     * Resets the object.
     */
    reset: function () {
      logger.debug("reset()");

      this.abort();
      this._loader = null;
    }
  };

  return KeyLoader;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/loader/ManifestLoader.js":
/*!***********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/loader/ManifestLoader.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      This class loads and parses HLS manifest files and attempts to return the data as either a Variant
 *      or Playlist domain model via a promise based API.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var AssetLoader = __webpack_require__(/*! sxm/audioplayer/html5/loader/AssetLoader */ "./javascript/src/sxm/audioplayer/html5/loader/AssetLoader.js");
  var RetryLoader = __webpack_require__(/*! sxm/audioplayer/html5/loader/RetryLoader */ "./javascript/src/sxm/audioplayer/html5/loader/RetryLoader.js");
  var ManifestParser = __webpack_require__(/*! sxm/audioplayer/html5/protocols/hls/ManifestParser */ "./javascript/src/sxm/audioplayer/html5/protocols/hls/ManifestParser.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("ManifestLoader");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the ManifestLoader function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Function} [noConnectivity] - Optional callback handler for no connectivity.
   * @param {Function} [tokenRefresh] - Optional callback handler for invalid tokens.
   */
  function ManifestLoader(noConnectivity, tokenRefresh) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof ManifestLoader)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["ManifestLoader"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Allows external clients to handle no connectivity via a callback hook.
     * @type {Function}
     */
    this.noConnectivity = ObjectUtil.isUndefinedOrNull(noConnectivity) ? null : noConnectivity;

    /**
     * Allows external clients to handle invalid tokens via a callback hook.
     * @type {Function}
     */
    this.tokenRefresh = ObjectUtil.isUndefinedOrNull(tokenRefresh) ? null : tokenRefresh;

    /**
     * Chunk loader.
     * @private
     * @type {RetryLoader}
     */
    this._loader = null;

    /**
     * Read-only accessor to the loading state.
     * @type {Boolean}
     */
    Object.defineProperty(this, "isLoading",
      {
        get: function () {
          return !ObjectUtil.isUndefinedOrNull(this._loader) && this._loader.isLoading;
        }.bind(this)
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our ManifestLoader class, we could write:
   *
   *  `BankManager.prototype = ManifestLoader.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  ManifestLoader.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: ManifestLoader,

    /**
     * Either loads an audio file chunk via HTTP or pulls it from cache if already loaded.
     *
     * @param {String} url - The chunk audio file's URL.
     * @returns {Promise}
     */
    load: function (url) {
      logger.info("load( url = {0} )", [url]);

      this._loader = new RetryLoader(AssetLoader.TYPE_TEXT, this.noConnectivity, this.tokenRefresh);

      var loadSuccess = function (response) {
        logger.info("loadSuccess( url = {0} )", [url]);
        try {
          var manifest = ManifestParser.parse(response.data, url);
          return manifest;
        }
        catch (err) {
          loadFault(err);
        }
      };

      var loadFault = function (fault) {
        var msg = (fault.message) ? fault.message : "Unknown error";
        logger.warn("loadFault( message = {0}, url = {1} )", [msg, url]);
        throw fault;
      };

      return this._loader.load(url).then(loadSuccess, loadFault);
    },

    /**
     * Attempts to abort any current loads by the internal loader.
     */
    abort: function () {
      if (this._loader) {
        logger.debug("abort()");
        this._loader.abort();
      }
    },

    /**
     * Resets the object.
     */
    reset: function () {
      logger.debug("reset()");

      this.abort();
      this.noConnectivity = null;
      this.tokenRefresh = null;
      this._loader = null;
    }
  };

  return ManifestLoader;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/loader/RetryLoader.js":
/*!********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/loader/RetryLoader.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Responsible for handling the retry logic when loading assets. If the asset fails to load, attempts to load
 *      the asset again after a configurable delay in milliseconds for n retries, also configurable. If the asset retries
 *      have been exhausted, the load fails and rejects the load()'s promise.
 *
 *      Failures are captured and handled by the FailoverMonitor.
 *      @see sirius.hls.monitor.FailoverMonitor.js
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var EventDispatcher = __webpack_require__(/*! sxm/audioplayer/html5/event/EventDispatcher */ "./javascript/src/sxm/audioplayer/html5/event/EventDispatcher.js");
  var AssetLoader = __webpack_require__(/*! sxm/audioplayer/html5/loader/AssetLoader */ "./javascript/src/sxm/audioplayer/html5/loader/AssetLoader.js");
  var AssetError = __webpack_require__(/*! sxm/audioplayer/html5/error/AssetError */ "./javascript/src/sxm/audioplayer/html5/error/AssetError.js");
  var AssetType = __webpack_require__(/*! sxm/audioplayer/html5/model/AssetType */ "./javascript/src/sxm/audioplayer/html5/model/AssetType.js");
  var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
  var Timer = __webpack_require__(/*! sxm/audioplayer/html5/util/Timer */ "./javascript/src/sxm/audioplayer/html5/util/Timer.js");
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
  var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var Q = __webpack_require__(/*! q */ "q");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the RetryLoader function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {String} type The asset loader type: "text" or "binary" using AssetLoader.TYPE_TEXT and
   * AssetLoader.TYPE_ARRAY_BUFFER.
   * @param {Function} [noConnectivity] - Optional callback handler for no connectivity.
   * @param {Function} [tokenRefresh] - Optional callback handler for invalid tokens.
   */
  function RetryLoader(type, noConnectivity, tokenRefresh) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof RetryLoader)) {
      throw new TypeError("RetryLoader constructor cannot be called as a function.");
    }

    if (ObjectUtil.isUndefinedOrNull(type)) {
      throw new Error("`type` parameter cannot be null.");
    }

    // NOTE: Unlike loggers in other classes, this one is an class instance member so we can keep
    // track of instances with a type.
    var assetType = (type === AssetLoader.TYPE_TEXT) ? AssetType.MANIFEST : AssetType.CHUNK;
    this.logger = LoggerFactory.getLogger(StringUtil.supplant("RetryLoader[{0}]", [assetType]));

    // Bind the scope of "this" to all first class functions
    ClassUtil.bindFunctions(this);

    // Extend this object with event dispatching capabilities
    EventDispatcher.apply(this);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Flag that enables or disables the retries.
     * @type {Boolean}
     */
    this.enabled = true;

    /**
     * Allows external clients to handle no connectivity via a callback hook.
     * @type {Function}
     */
    this.noConnectivity = ObjectUtil.isUndefinedOrNull(noConnectivity) ? null : noConnectivity;

    /**
     * Allows external clients to handle invalid tokens via a callback hook.
     * @type {Function}
     */
    this.tokenRefresh = ObjectUtil.isUndefinedOrNull(tokenRefresh) ? null : tokenRefresh;

    /**
     * The type of asset for this loader, typically text or binary file.
     * @type {String}
     * @private
     */
    this._type = type;

    /**
     * The url used to load the asset.
     * @type {String}
     * @private
     */
    this._url = "";

    /**
     * The counter for number of asset load retries.
     * @type {Number}
     * @private
     */
    this._retries = 0;

    /**
     * A local cache of promises for each asset load attempt. The key is the asset's URL. This is only added or set
     * when the asset is first being loaded by client objects calling the load() method. This is released and
     * deleted once the asset has either successfully loaded or failed to load; at this point the promise is
     * retrieved from the cache and either resolved or rejected.
     * @type {Object}
     * @private
     */
    this._promiseCache = {};

    /**
     * Internal reference to the asset loader.
     * @type {AssetLoader}
     * @private
     */
    this._loader = null;

    /**
     * Flag indicating if the current recovery for a failed load should be cancelled.
     * @type {Boolean}
     * @private
     */
    this._cancelRecovery = false;

    /**
     * Flag indicating if the loader is in the middle of a load.
     * @type {Boolean}
     * @private
     */
    this._isLoading = false;

    /**
     * Read-only accessor to the loading state.
     *
     * @type {Boolean}
     */
    Object.defineProperty(this, "isLoading",
      {
        get: function () {
          return this._isLoading;
        }.bind(this)
      });
  }

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * List of events.
   */
  RetryLoader.EVENT = {

    /**
     * Constant representing the connectivity failed event.
     * @constant {String}
     */
    CONNECTIVITY_FAILED: "connectivityFailed",

    /**
     * Constant representing the invalid token event.
     * @constant {String}
     */
    TOKEN_INVALID: "tokenInvalid"

  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our RetryLoader class, we could write:
   *
   *  `BankManager.prototype = RetryLoader.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  RetryLoader.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: RetryLoader,

    /**
     * Loads the asset.
     *
     * @param {String} url The URL of the asset to load.
     * @return {Promise}
     */
    load: function (url) {
      if (this.findPromise(url)) {
        this.logger.debug("load( Already loading {0} )", [url]);
        return this.findPromise(url).promise;
      }

      this.logger.debug("load( {0} )", [url]);
      //var dfd = this.findPromise(url) || this.addPromise(url);
      var dfd = this.addPromise(url);

      this._isLoading = true;
      this._url = url;
      this._loadAsset(url);

      return dfd.promise;
    },

    /**
     * Success handler for loaded assets. Releases the cached promise with the asset's data.
     *
     * @param {String|[]} data - The raw response data.
     * @param {String} url - The URL used for the request.
     */
    loadSuccess: function (data, url) {
      this.logger.debug("loadSuccess()");

      // reset the retries
      this._retries = 0;
      this._isLoading = false;

      // resolve the promise for asset being loaded and remove it from the cache
      url = url || this._url;
      this.releasePromise(url, data);
    },

    /**
     * Fault handler for loaded assets. Releases the cached promise with the asset's data.
     *
     * @param {AssetError} error - The error for the load.
     */
    loadFault: function (error) {
      this.logger.warn("loadFault( HTTP Status Code = {0}, message = {1}, type = {2}, url = {3} )", [
        error.httpStatus, error.message, error.type, error.url
      ]);

      this.recoverFromLoadError(error);
    },

    //-----------------------------------------------------------------------
    // Promise Caching Methods
    //-----------------------------------------------------------------------

    /**
     * Finds a promise for an asset's load call execution using the URL as the key.
     *
     * @param {String} url The asset's URL used as a key to the asset's promise.
     * @return {Promise}
     */
    findPromise: function (url) {
      var dfd = this._promiseCache[url];
      return dfd;
    },

    /**
     * Adds a promise for an asset's load call execution using the URL as the key.
     *
     * @param {String} url The asset's URL used as a key to the asset's promise.
     * @return {Promise}
     */
    addPromise: function (url) {
      var dfd = this.findPromise(url);

      if (ObjectUtil.isUndefinedOrNull(dfd)) {
        dfd = Q.defer();
        this._promiseCache[url] = dfd;
      }

      this.logger.debug("addPromise( {0} )", [url]);
      return dfd;
    },

    /**
     * Removes a promise for an asset's load call execution using the URL as the key.
     *
     * @param {String} url The asset's URL used as a key to the asset's promise.
     * @return {Promise}
     */
    removePromise: function (url) {
      var dfd = this.findPromise(url);

      if (dfd !== null) {
        delete this._promiseCache[url];
      }

      this.logger.debug("removePromise( {0} )", [url]);
      return dfd;
    },

    /**
     * Releases a promise for an asset's load call execution using the URL as the key. By releasing, the promise
     * is either resolved or rejected.
     *
     * @param {String} url The asset's URL used as a key to the asset's promise.
     * @param {Object} data The asset's URL used as a key to the asset's promise.
     * @return Promise
     */
    releasePromise: function (url, data) {
      data = data || null;

      var dfd = this.findPromise(url);

      if (dfd !== null) {
        var isError = (data instanceof AssetError);
        var promiseResolver = !isError ? dfd.resolve : dfd.reject;
        var logMsg = !isError ? "Resolve" : "Reject";

        this.removePromise(url);

        //data = data || new AssetError(supplant(AssetError.ERROR_LOAD_FAILED, [url]), AssetError.ID_LOAD_FAILED, url, httpStatusCode);

        this.logger.debug("releasePromise( {0}: {1} ) ", [logMsg, url]);

        // it's possible that another object intercepted the promise resolution and already grabbed
        // the data, but in case that didn't happen we look for a LoaderResponse and grab it's data if available
        // so anything using this class has access to the underlying data directly
        //data = (data is LoaderResponse) ? data.data :
        //hasTokenExpired() ? (new PlayerError(PlayerError.ERROR_TOKEN_INVALID, PlayerError.ID_TOKEN_INVALID)) :
        //data;
        promiseResolver.apply(dfd, [data]);
      }
    },

    //-----------------------------------------------------------------------
    // INTERNAL METHODS
    //-----------------------------------------------------------------------

    /**
     * Handles failed asset load requests by either retrying the load or officially declaring it as a failure.
     * If not enabled then simple consider the load to be failed (ie no asset load retires). If enabled then
     * determine if there's internet connectivity:
     *
     *      -- Yes, then attempt asset load retries up to the max number of retries (typically 5).
     *          -- If token expired, attempt retries infinitely. The FailoverMonitor handles the dispatching
     *          of the token invalid event for the web client
     *          -- If we're under the allowed number of retires then try loading the asset again.
     *          -- Else fail the load and exit. This usually results in failover attempts but is handled by the
     *          FailoverMonitor.
     *
     *      -- No, then attempt retries infinitely. This will allow the buffer to play out and the client app
     *      will determine what to do at that point.
     *
     * @param {AssetError} error - Contains the asset load error.
     */
    recoverFromLoadError: function (error) {
      if (this._cancelRecovery) {
        this.logger.info("recoverFromLoadError( Recovery cancelled. )");
        return;
      }
      if (this.enabled) {
        if (error.httpStatus === 404 || !error.httpStatus) {
          this.loadFailed(error);
        }
        else {
          this.testConnectivityAndRetry(error);
        }
      }
      else {
        this.logger.debug("recoverFromLoadError( Retries not enabled or exhausted so failing load. )");
        this.loadFailed(error);
      }
    },

    /**
     * Attempts to load the asset again after a configurable delay.
     */
    attemptRetry: function (error, noConnectivity) {
      var self = this;

      // WC-8452 give the CDN or API a little time before we submit a retry.  This is mostly helpful for
      // HTTP 500 returns from key pulls, but it also helps with 403's and 400's so that we do not slam the CDN with
      // requests that are just going to return 403/400 error codes while we wait for the API to get us an
      // updated token.
      //
      // When we slam the API on key pulls, it just bogs the API down
      // When we slam the CDN on token expire errors, it pollutes the CDN access statistics and makes it look
      // like we are encountering lots of token access errors as we wait for the API to get us a new access token.
      // for 404/503 errors, we retry immediately, which keeps us from getting tar-pitted by bad audio first chunks
      var delay = (error.httpStatus === 504 || error.httpStatus === 503) ? HlsConfig.FAILOVER_FAST_RETRY_DELAY : HlsConfig.FAILOVER_RETRY_DELAY;
      if (noConnectivity) {
        delay = HlsConfig.FAILOVER_RETRY_DELAY;
      }

      var timer = new Timer(delay, retry);
      timer.runOnce();


      function retry() {
        self._retries += 1;

        self.logger.info("attemptRetry( {0} of {1} with delay of {2} secs with URL {3} )", [
          self._retries, HlsConfig.FAILOVER_RETRY_LIMIT, HlsConfig.FAILOVER_RETRY_DELAY / 1000, self._url
        ]);

        self._loadAsset(self._url);
      }
    },

    /**
     * tests the connection and runs retry logic path.
     */
    testConnectivityAndRetry: function (error) {
      var self = this;
      this._loader = new AssetLoader();
      this._loader.load(HlsConfig.CONNECTIVITY_URL, AssetLoader.TYPE_TEXT).then(yesConnectivity, noConnectivity);

      function noConnectivity() {
        self.logger.debug("recoverFromLoadError( No connectivity so attempting infinite retries. )");
        self.disconnectedHandler();
        self.attemptRetry(error, true);
      }

      function yesConnectivity() {
        if (areRetriesExhausted()) {
          self.logger.debug("recoverFromLoadError( Retries exhausted so failing load. )");
          self.loadFailed(error);
        }
        else if (self.hasTokenExpired(error)) {
          self.logger.debug("recoverFromLoadError( Token has expired. will noop and retry. )");
          self.tokenExpired();
          self.attemptRetry(error);
        }
        else if (error.message &&
          (error.message === AssetError.COMPLETE_LOAD_TIMEOUT ||
            error.message === AssetError.MAKE_CONNECTION_TIMEOUT ||
            error.message === AssetError.RECEIVE_BYTES_TIMEOUT)
        ) {
          self.logger.debug("recoverFromLoadError( There was a timeout so retrying. )");
          self.attemptRetry(error);
        }
        else if (error.httpStatus && error.httpStatus === 404) {
          /* Only perform a retry if we have not exhausted all retries.  Do not attempt retries
          *  for http 404's, or if http.status is not defined */
          self.logger.debug("recoverFromLoadError( Got a 404 so failing load. )");
          self.loadFailed(error);
        }
        else if (!error.httpStatus) {
          /* If httpStatus is undefined, then we are dealing
           * with a CORS issue and retries will not help. */
          self.logger.debug("recoverFromLoadError( Did not receive an http status so failing load. )");
          self.loadFailed(error);
        }
        else {
          self.logger.debug("recoverFromLoadError( Received error in default case. Retrying.");
          self.attemptRetry(error);
        }
      }

      function areRetriesExhausted() {
        return self._retries >= HlsConfig.FAILOVER_RETRY_LIMIT;
      }
    },

    /**
     * Handles no connectivity for the player which means it can't load anything as it's offline.
     *
     * Uses either the external callback or defaults and fires a generic event if one is not provided.
     */
    disconnectedHandler: function () {
      this.logger.debug("disconnectedHandler()");

      var defaultNoConnectivity = function () {
        this.logger.warn("defaultNoConnectivity( No connectivity handler defined externally so using default. )");
        this.dispatchEvent(new Event(RetryLoader.EVENT.CONNECTIVITY_FAILED));
      }.bind(this);

      this.noConnectivity = ObjectUtil.isFunction(this.noConnectivity) ? this.noConnectivity : defaultNoConnectivity;
      this.noConnectivity();
    },

    /**
     * Handles invalid tokens for the player which means the client needs to try to refresh tokens
     * on the player's behalf.
     *
     * Uses either the external callback or defaults and fires a generic event if one is not provided.
     */
    tokenExpired: function () {
      this.logger.debug("tokenExpired()");

      var defaultTokenRefresh = function () {
        this.logger.warn("defaultTokenRefresh( No token refresh error defined externally so using default. )");
        this.dispatchEvent(new Event(RetryLoader.EVENT.TOKEN_INVALID));
      }.bind(this);

      this.tokenRefresh = ObjectUtil.isFunction(this.tokenRefresh) ? this.tokenRefresh : defaultTokenRefresh;
      this.tokenRefresh();
    },

    /**
     * Handles failed asset load requests by either retrying the load or failing over to the next available server
     * origin.
     *
     * @param {AssetError} error - The error for the failed asset load.
     */
    loadFailed: function (error) {
      this.logger.error("loadFailed(): " + this._url);
      this._isLoading = false;
      this._retries = 0;
      this.releasePromise(this._url, error);
    },

    /**
     * Determines if the HTTP status code was a 403 which means the token has most likely expired.
     *
     * @param {AssetError} error - The error for the failed asset load.
     * @return {Boolean} Indicates if the token has expired.
     */
    hasTokenExpired: function (error) {
      var tokenStrategy;

      if (error && error.url) {
        tokenStrategy = HlsConfig.getTokenStrategy(error.url);
      }

      var invalidTokenStatusCode = (tokenStrategy && tokenStrategy.invalidTokenHTTPCode) ?
        tokenStrategy.invalidTokenHTTPCode : 403;

      return (error.httpStatus === invalidTokenStatusCode);
    },

    /**
     * Wrapper method to load the asset using the internal asset loader.
     *
     * @private
     * @param {String} url - URL for the asset to load.
     * @return {Promise}
     */
    _loadAsset: function (url) {
      this._loader = new AssetLoader();
      return this._loader.load(url, this._type)
        .then(this.loadSuccess)
        .fail(this.loadFault);
    },

    /**
     * Attempts to abort any current loads by the internal loader.
     */
    abort: function () {
      if (this._loader) {
        this.logger.debug("abort()");
        this.noConnectivity = null;
        this.tokenRefresh = null;
        this._cancelRecovery = true;
        this._loader.abort();
        this._promiseCache = {};
        this.enabled = false;
      }
    }
  };

  return RetryLoader;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/AccessUnit.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/AccessUnit.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/31/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Allows for collecting ADTS frames into an access unit, which is a collection of frames that can be decoded
 * independently of any other frames.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var AudioSamples = __webpack_require__(/*! sxm/audioplayer/html5/model/AudioSamples */ "./javascript/src/sxm/audioplayer/html5/model/AudioSamples.js");
  var AudioUtils = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
  var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");

  var logger = LoggerFactory.getLogger("AccessUnit");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * Construct an ADTS access unit object
   *
   * @constructor
   */
  function AccessUnit(isAACPlus) {
    ClassUtils.bind(this, AccessUnit);

    this.aacPlus = isAACPlus;
    this.length = 0;
    this.samplesToTrim = 0;
    this.frameData = null;
    this.pcmData = null;
    this.audioSamples = new AudioSamples();
    this.timestamp = null;
    this.offset = null;
    this.duration = null;
  };

  ClassUtils.baseClass(AccessUnit).prototype = {

    /**
     * Prepend samples to the access unit and return an AudioSamples object
     *
     * @param {AudioSamples} samplesToPrepend contains the audio samples to prepend to the AccessUnit pcn
     *                       data
     *
     * @returns {AudioSamples}
     */
    prependSamples: function (samplesToPrepend) {
      var sampleRate = this.pcmData.sampleRate;
      var channels = this.pcmData.numberOfChannels;
      var samples = [];
      var samplesAvailable = this.pcmData.length;
      var timestamp = this.timestamp || 0;
      var seekOffset = 0;

      samplesAvailable += samplesToPrepend.samplesAvailable;
      timestamp -= AudioUtils.calculateDurationInMs(samplesToPrepend.samplesAvailable, sampleRate);

      for (var channel = 0; channel < channels; channel++) {
        var pcmData;

        if (samplesToPrepend) {
          // eslint-disable-next-line no-undef
          pcmData = new Float32Array(samplesAvailable);
          pcmData.set(samplesToPrepend.samples[channel], 0);
          pcmData.set(this.pcmData.getChannelData(channel), samplesToPrepend.samplesAvailable);
        }
        else {
          pcmData = this.pcmData.getChannelData(channel).subarray(seekOffset);
        }

        samples.push(pcmData);
      }

      this.audioSamples.samples = samples;
      this.audioSamples.timestamp = timestamp;
      this.audioSamples.sampleRate = sampleRate;

      return this.audioSamples;
    },

    /**
     * get the pcm samples for the access unit.  This method will take into account the offset set on the
     * access unit and omit samples that come before the offset
     *
     * @param {Object} samplesToPrepend contains data to prepend to the access unit.
     *                 samplesToPrepend.length is the number of samples
     *                 samplesToPrepend.samples is an array of Float32Array's with pcm data for each channel
     * @returns {AudioSamples} Object that contains samples for each channel, total samples available
     *                         and the timestamp for the first sample
     */
    getSamples: function () {
      if (this.pcmData) {

        var sampleRate = this.pcmData.sampleRate;
        var channels = this.pcmData.numberOfChannels;
        var timestamp = this.timestamp || 0;
        var seekOffset = AudioUtils.calculateSampleOffset(this.offset, sampleRate);

        var samples = [];

        for (var channel = 0; channel < channels; channel++) {
          samples.push(this.pcmData.getChannelData(channel).subarray(seekOffset));
        }

        this.audioSamples.samples = samples;
        this.audioSamples.timestamp = timestamp;
        this.audioSamples.sampleRate = this.pcmData.sampleRate;

        return this.audioSamples;
      }

      return null;
    },

    /**
     * Add pcm data to the object
     * @param {AudioBuffer} data for the access unit
     */
    setPCM: function (data) {
      this.pcmData = data;
    },

    /**
     * Add bytes to the object
     * @param {ArrayBuffer} data for the access unit
     * @param {Number} startByteIndex is the index into frameData where the access unit should start
     * @param {Number} endByteIndex is the index into frameData where the access unit should stop
     * @param {Number} samplesToTrim - The number of samples prepended to the audio data to kickstart the
     *   decoder.
     * @param {Number} timestamp (Unix epoch) for the access unit
     * @param {Number} offset to seek in ms into the access unit to start playing
     * @param {Number} duration in ms of the access unit
     * @param {Boolean} aacPlus is true if the bytes are AAC-HE and false if they are AAC-LC
     *
     * @returns {Number} index of the next byte after the access unit ends
     */
    setBytes: function (data, startByteIndex, endByteIndex, samplesToTrim, timestamp, offset, duration,
                        aacPlus) {
      var framesAdded = 0;

      if (endByteIndex > startByteIndex) {
        this.frameData = data.slice(startByteIndex, endByteIndex);
        this.length = endByteIndex - startByteIndex;
        this.samplesToTrim = samplesToTrim;
        this.timestamp = timestamp;
        this.offset = offset;
        this.duration = duration;
        this.aacPlus = aacPlus;
      }
      else {
        logger.error("Error parsing ADTS frame #{0} from start byte index {1}", [framesAdded, startByteIndex]);
      }

      return endByteIndex;
    },

    /**
     * Clear the raw audio (input and output data from the access unit.  This is useful when we are done decoding
     * and rendering the access unit so that any javascript code still holding ion the to the access unit object
     * itself does not retain the raw audio data (which can be large)
     */
    clearBytes: function () {
      this.frameData = null;
      this.pcmData = null;
      this.audioSamples = null;
      this.length = 0;
      this.offset = 0;
      this.duration = 0;
    }
  };

  return AccessUnit;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/Asset.js":
/*!*************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/Asset.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Data model representing an asset loaded over HTTP via the AssetLoader.
 */


/**
 * Register the module with RequireJS.
 * @module sxm/audioplayer/html5/model/Asset
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   * @type {WebAudioPlayerLogger|*}
   */
  var logger = LoggerFactory.getLogger("Asset");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the Asset function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @alias sxm/audioplayer/html5/model/Asset
   * @param {String|Array|Object} data The raw binary data for the asset.
   * @param {String} url The HLS URL for the stream.
   * @param {Number} size The data size for the audio asset in bytes.
   * @param {Number} loadTime The load time for the audio asset in milliseconds.
   * @param {Number} fileName The file name of the asset.
   * @param {String} type The type of asset, usualy string or array buffer.
   */
  function Asset(data, url, size, loadTime, fileName, type) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof Asset)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["Asset"]);
    }

    if (ObjectUtil.isUndefinedOrNull(data)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["data"]);
    }

    if (ObjectUtil.isUndefinedOrNull(url)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["url"]);
    }

    logger.debug("Constructor( url = {0} )", [url]);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Raw data for the asset, usually text or binary data.
     * @type {*}
     */
    this.data = data;

    /**
     * URL for the asset.
     * @type {String}
     */
    this.url = url;

    /**
     * Size in bytes for the asset.
     * @type {Number}
     */
    this.size = size || 0;

    /**
     * The time it took to download the Asset in milliseconds.
     * @type {Number}
     */
    this.loadTime = loadTime || 0;

    /**
     * File name for the asset.
     * @type {String}
     */
    this.fileName = fileName || "";

    /**
     * Type for the asset.
     * @type {String|Array}
     */
    this.type = type || "";

    /**
     * The download bit rate in milliseconds; aka bits per milliseconds.
     * @type {Number}
     */
    Object.defineProperty(this, "bytesPerMilliseconds",
      {
        get: function () {
          return Math.round(this.size / this.loadTime);
        }
      });

    /**
     * The download bit rate in seconds; aka bits per second.
     * @type {Number}
     */
    Object.defineProperty(this, "bytesPerSecond",
      {
        get: function () {
          return Math.round(this.bytesPerMilliseconds * 1000);
        }
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Asset class, we could write:
   *
   *  `BankManager.prototype = Asset.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  Asset.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: Asset
  };

  return Asset;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/AssetType.js":
/*!*****************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/AssetType.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/15/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Contains static properties that apply to both variant and playlist manifests.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  /**
   * @typedef {Object} AssetType
   * @const {String} CHUNK - Small manifest size.
   * @const {String} PLAYLIST - Medium manifest size.
   * @const {String} VARIANT - Large manifest size.
   * @const {String} MANIFEST - Large manifest size.
   * @const {String} DECRYPTION_KEY - Large manifest size.
   */

  /**
   * AssetType constants.
   * @returns {AssetType} The constants for asset types.
   */
  return {

    /**
     * Small manifest size.
     * @type {String}
     * @const
     */
    CHUNK: "chunk",

    /**
     * Medium manifest size.
     * @type {String}
     * @const
     */
    PLAYLIST: "playlist",

    /**
     * Large manifest size.
     * @type {String}
     * @const
     */
    VARIANT: "variant",

    /**
     * Large manifest size.
     * @type {String}
     * @const
     */
    MANIFEST: "manifest",

    /**
     * Large manifest size.
     * @type {String}
     * @const
     */
    DECRYPTION_KEY: "decryptionKey"
  };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/AudioFirst.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/AudioFirst.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * The data model class for audio first playback. Includes the list of audio first chunk URLs, as well as helper
 * methods that provide access to audio first chunk data elements (like URL, decryption keys, and timestamps).
 */



/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var PlaylistUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaylistUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaylistUtil.js");
  var DecryptKey = __webpack_require__(/*! sxm/audioplayer/html5/model/DecryptKey */ "./javascript/src/sxm/audioplayer/html5/model/DecryptKey.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("AudioFirst");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * The list of audio first chunk URLs defined in a list by origin. One of the main performance criteria is
   * ensuring that the client play audio first. In order to ensure that the client starts providing audio, the API
   * is expected to provide the first 2 chunks. The responses which provide tracks are supposed to have the 2
   * audio chunks going forward. The format of the object looks like:
   *
   * <code>
   * audioFirstURLs: [
   *
   *      // primary origin audio first chunks
   *      {
			 *          chunks: [
			 *              {
			 *                  url: "http://hlsp.k2.engineering.mountain.siriusxm.com/HLS_60svibrations_32k_v3/60svibrations_32k_large_v3.aac",
			 *                  timestamp: "1970-01-01T00:00:00.000+0000", // {Optional}
			 *                  offset: 0, // {Optional}
			 *                  key: "AA==", // {Optional}
			 *                  keyUrl: " " // {Optional}
			 *              },
			 *              {
			 *                  url: "http://hlsp.k2.engineering.mountain.siriusxm.com/HLS_60svibrations_32k_v3/60svibrations_32k_large_v3.aac",
			 *                  timestamp: "1970-01-01T00:00:00.000+0000", // {Optional}
			 *                  offset: 0, // {Optional}
			 *                  key: "AA==", // {Optional}
			 *                  keyUrl: " " // {Optional}
			 *              }
			 *          ]
			 *      },
   *
   *      // secondary origin audio first chunks
   *      {
			 *          chunks: [
			 *              {
			 *                  url: "http://hlsp.k2.engineering.mountain.siriusxm.com/HLS_60svibrations_32k_v3/60svibrations_32k_large_v3.aac",
			 *                  timestamp: "1970-01-01T00:00:00.000+0000", // {Optional}
			 *                  offset: 0, // {Optional}
			 *                  key: "AA==", // {Optional}
			 *                  keyUrl: " " // {Optional}
			 *              },
			 *              {
			 *                  url: "http://hlsp.k2.engineering.mountain.siriusxm.com/HLS_60svibrations_32k_v3/60svibrations_32k_large_v3.aac",
			 *                  timestamp: "1970-01-01T00:00:00.000+0000", // {Optional}
			 *                  offset: 0, // {Optional}
			 *                  key: "AA==", // {Optional}
			 *                  keyUrl: " " // {Optional}
			 *              }
			 *          ]
			 *      }
   *  ]
   * </code>
   *
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the AudioFirst function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Array} source - The raw list of audio first origin objects each containing a list of chunks.
   */
  function AudioFirst(source) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof AudioFirst)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["AudioFirst"]);
    }

    if (ObjectUtil.isUndefinedOrNull(source)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["source"]);
    }

    if (!ObjectUtil.isArray(source)) {
      throw new PlayerError(PlayerError.INCORRECT_TYPE, ["source", "array"]);
    }

    //-----------------------------------------------------------------------
    // PRIVATE MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Builds the audio first object using a raw array of audio first data (defined above).
     *
     * @param {Array} source - The raw audio first data transformed into a usable AudioFirst object.
     */
    var build = function (source) {
      this.data = (source || []);

      /**
       * Intended to be used as an iterator on the chunks that servers to inject DecryptKey instances to each item if
       * necessary.
       *
       * LIVE & AOD = If the keyURL has "/null" at the end it's unencrypted so don't give it a decryptor.
       * MySXM = Need to allow no keyURL and only use the key; also need to Base4 decode the key.
       */
      var buildChunks = function (item) {
        if (ObjectUtil.isUndefined(item.decryptor)) {
          if (!ObjectUtil.isUndefinedOrNull(item.key)) {
            item.keyUrl = ObjectUtil.isUndefinedOrNull(item.keyUrl) ? "" : String(item.keyUrl);
            item.decryptor = DecryptKey.instanceFor(String(item.key), String(item.keyUrl));
            logger.info("buildDecryptor( key = {0}, keyUrl = {1} )", [item.key, item.keyUrl]);
          }
          else if (!ObjectUtil.isUndefinedOrNull(item.keyUrl)) {
            var type = null;
            var vector = null;
            item.decryptor = new DecryptKey(String(item.keyUrl), type, vector);
            logger.info("buildDecryptor( key = {0}, keyUrl = {1} )", [item.key, item.keyUrl]);
          }
          // TODO: BMR: Need to handle MyMix keys that are embedded in the audio first data. This is used in Flash audio player but not here???
          // MySXM does not have a `keyUrl`property, so just create the decryptor with the key
          //else {
          //	var key = item.key as String;
          //	item.decryptor = DecryptKey.instanceFor(key);
          //
          //	// NOTE: This is a workaround since MySXM AF chunk keys are encoded differently than the rest of the
          //	// keys for chunk decryption. The method name specifically has `MySXM` in it to indicate this is
          //	// a one-off case. The API should fix this in the future.
          //	key = (item.decryptor as DecryptKey).decodeAudioFirstMySXMKey(key);
          //	item.decryptor = DecryptKey.instanceFor(key);
          //	//logger.info("buildDecryptor( key = {0}, No keyUrl )", [key]);
          //}
          else {
            logger.info("buildDecryptor( No decryption keys or key URLs provided. )");
          }
        }
        else {
          logger.info("buildDecryptor( Decryptor already created for this audio first chunk. )");
        }

        // Make sure the timestamp property is removed from audio first chunks if it's null. This forces the player
        // to completely ignore it when trying to locate the next chunk after the audio first chunks, which then
        // defaults to chunk index -- this is used in MySXM playback.
        if (ObjectUtil.isDefined(item.timestamp) && (ObjectUtil.isNull(item.timestamp))) {
          // eslint-disable-next-line dot-notation
          delete item["timestamp"];
        }

        return item;
      };

      // TODO: BMR: Need to consider creating the audio first chunks for each origin to facilitate audio first failover
      // for now we'll simply default to the primary origin for chunks
      if (this.data[0]) {
        this.data[0].chunks = (this.data[0].chunks || []);
        logger.debug("build( Building {0} chunks )", [this.data[0].chunks.length]);
        this.data[0].chunks.map(buildChunks);
      }
      else {
        logger.warn("build( No chunks. )");
      }

      return this.data;
    }.bind(this);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Raw data source for audio first.
     * @type {Array}
     */
    this.data = build(source);

    /**
     * Flag indicating if audio first has been played for a player.
     * @type {Boolean}
     */
    this.hasPlayed = false;

    /**
     * Flag indicating if audio first played successfully.
     * @type {Boolean}
     */
    this.success = true;
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Utility method indicating if a raw chunk object is encrypted.
   *
   * @param {Object} chunk - Raw chunk object with property `keyUrl`.
   * @return {Boolean} Flag indicating if the chunk is encrypted.
   */
  AudioFirst.isRawChunkEncrypted = function (chunk) {
    if (ObjectUtil.isUndefinedOrNull(chunk)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["chunk"]);
    }

    // if "/null" is at the end of the key URL, then the chunk is not encrypted
    var hasKeyUrl = chunk.hasOwnProperty("keyUrl");
    var isKeyUrlEncrypted = (String(chunk.keyUrl)).indexOf("/null") === -1;
    return hasKeyUrl && isKeyUrlEncrypted;
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our AudioFirst class, we could write:
   *
   *    `BankManager.prototype = AudioFirst.prototype`
   *    `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  AudioFirst.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: AudioFirst,

    /**
     * Flag indicating if the audio first object can be used for playback. Ensures there are HLS URLs to play
     * and audio first has not already played (as it can only be used once per player). Audio first should
     * also not be played if a start time is provided.
     *
     * @param {String|Date|Number} startTime - Possible start time for playback.
     */
    canPlay: function (startTime) {
      var hasChunks = this.getURLs().length > 0;
      var urlEmpty = ObjectUtil.isUndefinedOrNullOrEmptyString(this.getURLs()[0]);
      var noStartTime = ObjectUtil.isUndefinedOrNullOrEmptyString(startTime);

      return (!this.hasPlayed && hasChunks && !urlEmpty && noStartTime);
    },

    /**
     * Returns a list of chunk URLs (usually AAC) for a given index value (aka origin as primary, secondary, tertiary, ...).
     * If the index is not provide, the default is 0, aka the primary origin.
     *
     * @param {Number} [index=0] - The index of the origin for the URLs, suggesting primary, secondary, tertiary, etc.
     * @return {Array} A list of chunk URLs.
     */
    getURLs: function (index) {
      index = index || 0;
      return this.getChunkProperties("url", index);
    },

    /**
     * Returns a list of chunk timestamps (usually AAC) for a given index value (aka origin as primary, secondary, tertiary, ...).
     * If the index is not provide, the default is 0, aka the primary origin. The timestamps are strings in the
     * form of "1970-01-01T00:00:00.000+0000" and need to be converted to Date objects when used.
     *
     * If the data is corrupt and the timestamps are not included, then we grab the date String from the default
     * for the chunks listed as "chunk.defaultTimestamp"; also in the format of "1970-01-01T00:00:00.000+0000".
     *
     * @param {Number} [index=0] - The index of the origin for the timestamps, suggesting primary, secondary, tertiary, etc.
     * @return {Array} A list of chunk timestamps.
     */
    getStringTimestamps: function (index) {
      index = index || 0;
      var timestamps = this.getChunkProperties("timestamp", index);

      var isInvalid = function (ts) {
        return !ts || (ts.length <= 0) || ObjectUtil.isUndefinedOrNull(ts[0]);
      };

      // if the audio first data is corrupt and missing timestamps we'll need to use the default
      // starting time
      if (isInvalid(timestamps)) {
        timestamps = this.getDefaultStartTime();
      }
      if (isInvalid(timestamps)) {
        timestamps = [0, 0];
      }

      return timestamps;
    },

    /**
     * Returns a list of chunk offsets for a given index value (aka origin as primary, secondary, tertiary, ...).
     * If the index is not provide, the default is 0, aka the primary origin.
     *
     * @param {Number} [index=0] - The index of the origin for the offset, suggesting primary, secondary, tertiary, etc.
     * @return {Array} A list of chunk offsets.
     */
    getOffsets: function (index) {
      index = index || 0;
      return this.getChunkProperties("offset", index);
    },

    /**
     * Returns the default chunk offset from the first origin from the first chunk.
     *
     * @return {Number} A chunk offset. If no offsets it defaults to 0.
     */
    getOffset: function () {
      var offsets = this.getOffsets(0);
      if ((offsets.length > 0) && (offsets[0])) {
        return offsets[0];
      }
      return 0;
    },

    /**
     * Returns list of chunks for a given index value (aka origin as primary, secondary, tertiary, ...).
     * If the index is not provide, the default is 0, aka the primary origin.
     *
     * @param {Number} [index=0] - The index of the origin for the URL, suggesting primary, secondary, tertiary, etc.
     * @return {Array} A list of chunk objects.
     */
    getChunks: function (index) {
      index = index || 0;
      if (this.data && this.data[index] && this.data[index].chunks) {
        return this.data[index].chunks;
      }
      return [];
    },

    /**
     * Returns a specific chunk for a given origin index and chunk index value. If the index is not provide, the
     * default is 0.
     *
     * @param {Number} [originIndex=0] - The index of the origin for the URL, suggesting primary, secondary, tertiary, etc.
     * @param {Number} [chunkIndex=0] - The index of chunk.
     * @return A chunk object.
     */
    getChunk: function (originIndex, chunkIndex) {
      originIndex = originIndex || 0;
      chunkIndex = chunkIndex || 0;
      var chunks = this.getChunks(originIndex);
      if ((chunks.length > 0) && (chunks[chunkIndex])) {
        return chunks[chunkIndex];
      }
      return {};
    },

    ///**
    // * Indicates that audio first data is valid and contains chunks.
    // *
    // * @return Flag indicating that audio first data is valid and contains chunks.
    // */
    //public function getDefaultStartTime():Array
    //{
    //	return getChunkProperties("defaultTimestamp");
    //}

    /**
     * TODO: BMR
     */
    getDefaultStartTime: function () {
      return this.getChunkProperties("defaultTimestamp");
    },

    /**
     * Returns the default HLS chunk timestamp, which is located in the first chunk object.
     *
     * @return {Number} The default (chunk0's) timestamp.
     */
    getChunk0Timestamp: function () {
      var date = PlaylistUtil.convertToDates(this.getStringTimestamps()[0]);
      var timestamp = date ? date.getTime() : NaN;
      return isNaN(timestamp) ? 0 : timestamp;
    },

    /**
     * Returns the default HLS chunk offset (aka sub-seek), which is located in the first chunk object.
     *
     * @return {Number} The default offset value.
     */
    getChunk0Offset: function () {
      var offset = this.getOffsets()[0];
      return isNaN(offset) ? 0 : offset;
    },

    /**
     * Creates a list of audio first times by grabbing the raw string dates from the audio first data and converting
     * them to data objects.
     *
     * NOTE: includeOffset is needed by FailoverMonitor so that we can create a time that will be used to find
     *       the closest chunk/offset on the failover system to where we *would* have played had we not been
     *       forced to failover
     *
     * @param {Boolean} includeOffset - If true, then the audio first offsets will be added to the timestamps returned, otherwise
     *        AF offsets will not be included.  Defaults to false.
     *
     * @return {Array} An array of audio first dates.
     *
     */
    getDateTimestamps: function (includeOffset) {
      includeOffset = includeOffset || false;
      var offsets = this.getOffsets();

      /**
       * The timestamps in the list of audio first chunks need to be converted to Date objects.
       *
       * @param item  The timestamp for an audio first chunk.
       * @param index into Array that we are working on (used if includeOffset is true to find offset that
       *        corresponds to item.
       * @return {date}
       */
      var buildTimes = function (item, index) {
        index = index || -1;
        var date = PlaylistUtil.convertToDates(item);

        if (includeOffset === true) {
          var msOffset = Number(offsets[index]);
          date = new Date(msOffset + date.getTime());
        }

        return date;

      };

      var timeStamps = this.getStringTimestamps().map(buildTimes);

      return timeStamps;
    },

    /**
     * Utility method that returns an array of the properties requested from the original array.
     *
     * @param {String} key - The property string name to get the value for.
     * @return {*} Value for the given key.
     */
    extractorFor: function (key) {
      return function extract(entry) {
        var value = entry[key];
        return ObjectUtil.isUndefinedOrNull(value) ? null : value;
      };
    },

    /**
     * Returns a list of properties from the chunk array for a given index value (aka origin as primary, secondary, tertiary, ...).
     * If the index is not provide, the default is 0, aka the primary origin.
     *
     * @param {String} property - The property to pull from the selected chunk data via index.
     * @param {Number} [index=0] - The index of the origin for the URLs, suggesting primary, secondary, tertiary, etc.
     * @return {Array} A list of chunk properties.
     */
    getChunkProperties: function (property, index) {
      index = index || 0;
      return this.getChunks(index).map(this.extractorFor(property));
    }
  };

  return AudioFirst;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/AudioModel.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/AudioModel.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    01/08/16
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * The data model class for audio playback. Includes the list of audio URLs, as well as helper
 * methods that provide access to audio HLS URLs by origin and manifest size.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var AudioDataError = __webpack_require__(/*! sxm/audioplayer/html5/error/AudioDataError */ "./javascript/src/sxm/audioplayer/html5/error/AudioDataError.js");
  var Manifest = __webpack_require__(/*! sxm/audioplayer/html5/model/Manifest */ "./javascript/src/sxm/audioplayer/html5/model/Manifest.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * Constructor.
   *
   * The list of HLS audio URLS for the player. They're provided in a list to allow for multiple origins, with
   * small, medium, and large playlist sizes for each item. The list is ordered implicitly of failover based on the item's
   * index in the list. Each item has 3 specific sizes: small, medium, and large. The format of the object
   * looks like:
   *
   * <code>
   * audioUrls: [
   *     {
			 *          small : xxx,
			 *          medium : xxx,
			 *          large : xxx
			 *      },
   *      {
			 *          small : xxx,
			 *          medium : xxx,
			 *          large : xxx
			 *      }
   *  ]
   * </code>
   *
   * @param {Array} data - The list of audio origin objects each containing HLS URL manifests by size.
   */
  function AudioModel(data) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof AudioModel)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["AudioModel"]);
    }

    if (ObjectUtil.isUndefinedOrNull(data)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["data"]);
    }

    if (!ObjectUtil.isArray(data)) {
      throw new PlayerError(PlayerError.INCORRECT_TYPE, ["data", "array"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Raw, binary data for the chunk.
     * @type {Array}
     */
    this.data = data;

    /**
     * Accessor to the number of origin servers for HLS audioModel.
     * @type {Number}
     */
    Object.defineProperty(this, "numServers",
      {
        get: function () {
          return (!ObjectUtil.isUndefinedOrNull(this.data)) ? this.data.length : 0;
        }
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Audio class, we could write:
   *
   *  `BankManager.prototype = Audio.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  AudioModel.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: AudioModel,

    /**
     * Returns an HLS URL for a given size and index value (aka origin as primary, secondary, tertiary, ...).
     * If a size and/or index is not provide, the default is small size and an index of 0.
     *
     * @param {String} [size=""] - The playlist size, typically set as small, medium, and large.
     * @param {Number} [index=0] - The index of the origin for the URL, suggesting primary, secondary, tertiary, etc.
     * @return {String} The audio URL.
     */
    getAudioURL: function (size, index) {
      if (!this.data || (this.data.length <= 0)) {
        throw new AudioDataError(AudioDataError.AUDIO_URLS_REQUIRED);
      }

      index = index || 0;
      size = this.getRequestedSize(size);

      // default the requested index to zero if outside the scope of available indexes
      index = ((index < 0) || (index > this.data.length - 1)) ? 0 : index;

      // try to grab the requested size from the requested server index
      var item = this.data[index];
      var url = item[size];

      // if the requested size isn't found, let's try one of the other available sizes using
      if (ObjectUtil.isUndefinedOrNull(url)) {
        // the original requested size most likely wasn't available so try another specific to this server index
        size = this.getRequestedSize(size, index);

        for (var prop in item) {
          if (item.hasOwnProperty(prop)) {
            if (prop.toLowerCase() === size.toLowerCase()) {
              return String(item[prop]);
            }
          }
        }
      }
      else {
        return url;
      }

      return null;
    },

    /**
     * Returns requested size. If the requested size is not available, then try the following
     * order before throwing an error: small, large, medium.
     *
     * @param {String} [size=""] - The playlist size, typically set as small, medium, and large.
     * @param {Number} [index=0] - The index of the origin for the URL, suggesting primary, secondary, tertiary, etc.
     * @return {String} Requested size.
     */
    getRequestedSize: function (size, index) {
      var possibleSizes = this.getAvailableSizes(index);
      size = (ObjectUtil.isUndefinedOrNullOrEmptyString(size)
              || (possibleSizes.findIndex(function(possibleSize) { return size === possibleSize; }) < 0))
             ? getDefaultSize() : size;

      return size;

      function getDefaultSize() {
        if (possibleSizes.findIndex(function(size) { return size === Manifest.SMALL; }) >= 0) {
          return Manifest.SMALL;
        }
        else if (possibleSizes.findIndex(function(size) { return size === Manifest.LARGE; }) >= 0) {
          return Manifest.LARGE;
        }
        else if (possibleSizes.findIndex(function(size) { return size === Manifest.MEDIUM; }) >= 0) {
          return Manifest.MEDIUM;
        }
        else {
          throw new AudioDataError(AudioDataError.AUDIO_NO_URLS_FOR_SIZE, [size]);
        }
      }
    },

    /**
     * Retrieves the list of possible manifest sizes for this audio player. The available sizes can be from a
     * particular server or all servers for the audio player. Specify an index of -1 for all servers.
     *
     * @param {Number} [index=-1] - The index of the origin for the URL, suggesting primary, secondary, tertiary, etc.
     * @return {Array} List of manifest sizes.
     */
    getAvailableSizes: function (index) {
      index = index || -1;
      if (index >= this.data.length) {
        index = -1;
      }

      // javascript does not have associative arrays, so you need to use an object hash
      // for this reason we need to use 2 objects here, one is an object the other the result array
      var possibleSizes = {};
      var possibleSizesResult = [];

      var getServerSizes = function (server) {
        for (var size in server) {
          if (server.hasOwnProperty(size)) {
            if (ObjectUtil.isUndefinedOrNull(possibleSizes[size])) {
              possibleSizes[size] = size;
              possibleSizesResult.push(size);
            }
          }
        }

        return possibleSizesResult;
      };

      if (index > -1) {
        getServerSizes(this.data[index]);
      }
      else {
        this.data.forEach(getServerSizes);
      }

      return possibleSizesResult;
    },

    /**
     * Searches audio URL collection for the current URL and returns the next URL
     * NOTE: Currently defaults to the small variant for the next server URL.
     *
     * @param {String} currentUrl - The URL of the currently playing manifest.
     * @param {String} [size=null] - The size of the manifest to request.
     * @return {String} The next audio URL.
     */
    getNextAudioUrl: function (currentUrl, size) {
      if (ObjectUtil.isUndefinedOrNullOrEmptyString(currentUrl)) {
        throw new PlayerError(PlayerError.REQUIRED_PARAM, ["currentUrl"]);
      }

      size = size || Manifest.LARGE;
      var nextUrl = null;

      for (var i = 0; i < this.data.length; i++) {
        var currentServer = this.data[i];

        switch (currentUrl) {
          case currentServer[Manifest.SMALL]:
          case currentServer[Manifest.MEDIUM]:
          case currentServer[Manifest.LARGE]:
            var nextServerIndex = i + 1;
            nextUrl = (nextServerIndex < this.data.length) ? this.getAudioURL(size, nextServerIndex) : null;
            break;
        }

        if (!ObjectUtil.isUndefinedOrNull(nextUrl) && (nextUrl !== currentUrl)) {
          return nextUrl;
        }
        else {
          nextUrl = null;
        }
      }

      return nextUrl;
    },

    /**
     * Returns true if the requested URL is a large manifest.
     *
     * @param {String} url - The URL to check if large manifest.
     * @return {Boolean} Indicating if the requested URL is a large manifest.
     */
    isAudioUrlLarge: function (url) {
      var found = false;

      for (var i = 0; i < this.data.length; i++) {
        var item = this.data[i];
        if (item.hasOwnProperty(Manifest.LARGE) && item[Manifest.LARGE] === url) {
          found = true;
          break;
        }
      }
      return found;

    }
  };

  return AudioModel;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/AudioSamples.js":
/*!********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/AudioSamples.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     AudioSamples
 * @CREATED:    12/30/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Container class for audio pcm samples
 */
/* beautify preserve:start */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  //----------------------------------------------------------------------------------------------------------
  // MODULE variables
  //----------------------------------------------------------------------------------------------------------

  var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var AudioUtils = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * Construct an AudioSamples from existing samples
   *
   * @param {Array} channelSamples (optional, default is null) is an array of Float32Array's with samples for
   *                multiple channels
   * @param {Number} sampleRate (optional, default is 0) is the sample rate of the pcm data
   * @param {Number} timestamp (optional, default is 0) is the unix epoch of the first sample
   */
  function AudioSamples(channelSamples, sampleRate, timestamp) {
    ClassUtils.bind(this, AudioSamples);

    this.samples = channelSamples || null;
    this.timestamp = timestamp || 0;
    this.sampleRate = sampleRate || 0;
  }

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Construct an empty AudioSamples object
   *
   * @param {Number} numChannels number of channels of audio to create new object with
   * @param {Number} numSamples number of samples in each channel
   * @param {Number} sampleRate is the number of samples per second for the new object
   * @param {Number} timestamp (optional, default is 0) is the unix epoch of the first sample
   */
  AudioSamples.createEmptyBuffer = function (numChannels, numSamples, sampleRate, timestamp) {
    var samples = [];

    for (var channel = 0; channel < numChannels; channel++) {
      // eslint-disable-next-line no-undef
      samples.push = new Float32Array(numSamples);
    }

    return new AudioSamples(samples, sampleRate, timestamp);
  };

  //-----------------------------------------------------------------------
  // Prototype
  //-----------------------------------------------------------------------

  ClassUtils.baseClass(AudioSamples).prototype = {

    appendSilence: function (numberOfSilentSamples) {

      if (numberOfSilentSamples < 1 || this.samples === null) {
        return; //nothing to do.
      }

      for (var i = 0; i < this.channels; i++) {
        // eslint-disable-next-line no-undef
        var newSamples = new Float32Array(this.samples[i].length + numberOfSilentSamples);

        newSamples.fill(0.0);
        newSamples.set(this.samples[i]);

        this.samples[i] = newSamples;
      }
    },

    /**
     * Property that returns the number of channels of PCM data available
     *
     * @return {Number} milliseconds of data available in the object based on the sample rate
     */
    channels: ClassUtils.createPropertyDescriptor({
      get: function () {
        return (this.samples !== null) ? this.samples.length : 0;
      }
    }),

    /**
     * Property that returns the number of audio samples available
     *
     * @return {Number} number of audio samples available
     */
    samplesAvailable: ClassUtils.createPropertyDescriptor({
      get: function () {
        return this.samples[0].length; // a channels
                                       // should have
                                       // the same
                                       // length, and
                                       // there should
        // always be at least one channel
      }
    }),

    /**
     * Property that returns the duration in milliseconds for the audio
     *
     * @return {Number} milliseconds of data available in the object based on the sample rate
     */
    duration: ClassUtils.createPropertyDescriptor({
      get: function () {
        return AudioUtils.calculateDurationInMs(this.samplesAvailable, this.sampleRate);
      }
    })
  };

  return AudioSamples;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/Chunk.js":
/*!*************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/Chunk.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Data model representing a chunk. Contains the URL, raw data, timestamp, and offset.
 */


/**
 * Register the module with RequireJS.
 * @module sxm/audioplayer/html5/model/Chunk
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   * @type {WebAudioPlayerLogger|*}
   */
  var logger = LoggerFactory.getLogger("Chunk");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the Chunk function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @alias sxm/audioplayer/html5/model/Chunk
   * @param {String} url The HLS URL for the stream.
   * @param {Array} data The raw binary data for the chunk.
   * @param {Number} size The data size for the audio chunk in bytes.
   * @param {Number} loadTime The load time for the audio chunk in milliseconds.
   * @param {Number} fileName The file name of the chunk.
   * @param {boolean} lastChunk is true if this is the last chunk for the content, false (default) otherwise
   * @param {Number} duration is the number of milliseconds of audio in the chunk, defaults is zero
   */
  function Chunk(url, data, size, loadTime, fileName, lastChunk, duration) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof Chunk)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["Chunk"]);
    }

    if (ObjectUtil.isUndefinedOrNull(url)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["url"]);
    }

    if (ObjectUtil.isUndefinedOrNull(data)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["data"]);
    }

    logger.debug("Constructor( url = {0} )", [url]);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * URL for the chunk.
     * @type {String}
     */
    this.url = url;

    /**
     * Raw, binary data for the chunk.
     * @type {Array}
     */
    this.data = data;

    /**
     * Size in bytes for the chunk.
     * @type {Number}
     */
    this.size = size || 0;

    /**
     * The time it took to download the Chunk in milliseconds.
     * @type {Number}
     */
    this.loadTime = loadTime || 0;

    /**
     * File name for the chunk.
     * @type {String}
     */
    this.fileName = fileName || "";

    /**
     * Indicates whether or not this chunk is the last in a sequence.
     * @type {boolean}
     */
    this.lastChunk = (lastChunk === undefined) ? false : lastChunk;

    /**
     * Timestamp for the chunk.
     * @type {Date}
     */
    this.timestamp = null;

    /**
     * Offset or sub-seek time into the chunk.
     * @type {String}
     */
    this.offset = 0;

    /**
     * Indicates the codec.
     * @type {String}
     */
    this.codec = null;

    /**
     * Duration for the chunk.
     * @type {Number}
     */
    this.duration = (duration || 0) / 1000;

    /**
     * Flag indicating if the chunk has been decrypted.
     * @type {Boolean}
     */
    this.isDecrypted = false;

    /**
     * decryptor if it has any
     * @type {Boolean}
     */
    this.decryptor = null;

    /**
     * Flag indicating if the chunk is seededAudio.
     * @type {Boolean}
     */
    this.isMP4 = false;

    /**
     * The download bit rate in milliseconds; aka bits per milliseconds.
     * @type {Number}
     */
    Object.defineProperty(this, "bytesPerMilliseconds",
      {
        get: function () {
          return Math.round(this.size / this.loadTime);
        }
      });

    /**
     * The download bit rate in seconds; aka bits per second.
     * @type {Number}
     */
    Object.defineProperty(this, "bytesPerSecond",
      {
        get: function () {
          return Math.round(this.bytesPerMilliseconds * 1000);
        }
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Chunk class, we could write:
   *
   *  `BankManager.prototype = Chunk.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  Chunk.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: Chunk
  };

  return Chunk;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/Codec.js":
/*!*************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/Codec.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/15/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Contains static properties define the possible audio codecs.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");

    /**
     * @typedef {Object} Codec
     * @const {String} AAC_HE - Commonly referred to as AAC-PLUS, this refers to bit rates under 128k. In the
     * SXM world this currently applies to bit rates 32k, 64k, and 96k.
     * @const {String} AAC_LC - Refers to bit rates over 128k. In the SXM world this currently applies to the
     * bit rates 256k.
     */

    /**
     * Codec constants.
     * @returns {Codec} The constants for asset types.
     */
    return {

      /**
       * Lower quality AAC codec.
       * @type {String}
       * @const
       */
      AAC_HE: "mp4a.40.5",

      /**
       * Higher quality AAC codec.
       * @type {String}
       * @const
       */
      AAC_LC: "mp4a.40.2",

      /**
       * Higher quality AAC codec file name contains this string.
       * @type {String}
       * @const
       */
      AAC_LC_FILE_NAME: "_256k_",

      /**
       * MP4 files end with .mp4
       */
      MP4_FILE_EXTENSION: ".mp4",

      /**
       * List of errors for the object.
       * @const
       */
      ERROR:
        {
          NO_CODEC_OR_URL: "Could not determine if AAC-PLUS as there's no chunk codec or URL."
        },

      /**
       * Determines if the chunk is AAC-PLUS by examining its codec or URL. If neither
       * are available it throws an error.
       *
       * @param {Chunk} chunk - The chunk being inspected.
       * @returns {Boolean}
       * @throws {Error} Throws an error for a falsy `chunk` param or no chunk codec or URL.
       */
      isAacPlus: function (chunk) {
        if (!chunk) {
          throw new PlayerError(PlayerError.REQUIRED_PARAM, ["chunk"]);
        }

        if (chunk.codec) {
          return chunk.codec === this.AAC_HE;
        }
        if (chunk.fileName) {
          var is256KFileName = chunk.fileName.indexOf(this.AAC_LC_FILE_NAME) !== -1;
          var isMP4 = chunk.fileName.indexOf(this.MP4_FILE_EXTENSION) !== -1;

          return isMP4 || !is256KFileName;
        }
        else {
          throw new Error(this.ERROR.NO_CODEC_OR_URL);
        }
      }
    };
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/CrossfadeProtocol.js":
/*!*************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/CrossfadeProtocol.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    function CrossfadeProtocol(msPerBuffer, crossfadeConfig, duration, turnedOn) {
      this.msPerBuffer = msPerBuffer || 250;

      this.crossfadeConfig = {
        crossFade: crossfadeConfig.crossFade,
        fadeUpPos: crossfadeConfig.fadeUpPos === -1 ? 0 : crossfadeConfig.fadeUpPos,
        fadeDownDuration: crossfadeConfig.fadeDownDuration,
        fadeDownPos: crossfadeConfig.fadeDownPos === -1 ? 9999999 : crossfadeConfig.fadeDownPos,
        fadeUpDuration: crossfadeConfig.fadeUpDuration
      };

      this.duration = duration || 0;
      this.turnedOn = !!turnedOn;

      return this;
    }

    CrossfadeProtocol.prototype = {

      constructor: CrossfadeProtocol,


      isTurnedOn: function () {
        return this.turnedOn;
      },


      bufferDurationSecs: function () {
        return this.msPerBuffer / 1000 || 0.250;
      },

      isCrossfadePointReached: function (elapsedSecs) {
        if (this.mSecsFromEndToStartNextSong() <= 250) {
          return false;
        } // no overlap if within 1 buffer
          // so as not to fire overlap and finished event
          // at the same time
          // and potentially race.
        var secsLeft = this.duration - elapsedSecs;
        var millisecondsLeft = Math.floor(secsLeft * 1000);
        var delta = millisecondsLeft - this.mSecsFromEndToStartNextSong();

        return delta < this.msPerBuffer && delta >= 0;
      },

      isFadeDownPointReached: function (elapsedSecs) {
        if (this.fadeDownDurationMSecs() === 0) {
          return false;
        }

        var elapsedMSecs = Math.floor(elapsedSecs * 1000);
        var delta = elapsedMSecs - this.fadeDownPosMSecs();
        return delta < this.msPerBuffer && delta >= 0;
      },


      isFadeUpPointReached: function (elapsedSecs) {
        if (this.fadeUpDurationMSecs() === 0) {
          return false;
        }

        var elapsedMSecs = Math.floor(elapsedSecs * 1000);
        var delta = elapsedMSecs - this.fadeUpPosMSecs();
        return delta < this.msPerBuffer && delta >= 0;
      },


      fadeDownDurationMSecs: function () {
        var mSec = this.crossfadeConfig.fadeDownDuration;
        if (mSec === -1) {
          return 0;
        }
        return mSec;
      },


      fadeDownDurationSecs: function () {
        return this.fadeDownDurationMSecs() / 1000;
      },


      fadeUpDurationMSecs: function () {
        var mSec = this.crossfadeConfig.fadeUpDuration;
        if (mSec === -1) {
          return 0;
        }
        return mSec;
      },


      fadeUpDurationSecs: function () {
        return this.fadeUpDurationMSecs() / 1000;
      },


      fadeDownPosMSecs: function () {
        return this.crossfadeConfig.fadeDownPos;
      },


      fadeUpPosMSecs: function () {
        var mSec = this.crossfadeConfig.fadeUpPos;
        if (mSec === -1) {
          return 0;
        }
        return mSec;
      },


      mSecsFromEndToStartNextSong: function () {
        var mSec = this.crossfadeConfig.crossFade;
        if (mSec === -1) {
          return 0;
        }
        return mSec;

        // https://confluence.sxm.telematics.net/confluence/pages/viewpage.action?pageId=23902063#Crossfade-PersonalizationEngSpecifications(K2)-1.Crossfade%E2%80%93Introduction
      }
    };

    return CrossfadeProtocol;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/DecryptKey.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/DecryptKey.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Data model representing a stream. Contains the URL to the stream, the bit rate or bandwidth and required codecs.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var loggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");

  /**
   * Internal reference to the logger.
   * @type {WebAudioPlayerLogger|*}
   */
      // eslint-disable-next-line no-unused-vars
  var logger = loggerFactory.getLogger("DecryptKey");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the DecryptKey function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {string} url The HLS URL for the stream.
   * @param {string} type Indicates the decryption type.
   * @param {string} vector Used in chunk decryption.
   */
  function DecryptKey(url, type, vector) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof DecryptKey)) {
      throw new TypeError("DecryptKey constructor cannot be called as a function.");
    }

    // logger.debug("Constructor( url = {0}, type = {1}, vector = {2} )", [url, type, vector]);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Original key as a string from the HLS manifest.
     * @type {string}
     */
    this.encodedKey = "";

    /**
     * Base 64 decoded byte array key for decryption.
     * @type {bytearray}
     */
    this.key = null;

    /**
     * URL for the key.
     * @type {string}
     */
    this.url = url || "";

    /**
     * Indicates the decryption type.
     * @type {string}
     */
    this.type = type || "";

    /**
     * Used in chunk decryption.
     * @type {string}
     */
    this.vector = vector || "";
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Create an instance of the Decryptor.
   *
   * TODO: BMR: This is probably not the best name for this method as it's actually creating a binary key from a Base64 encoded string
   */
  DecryptKey.instanceFor = function (key, url, type, iVector) {
    var decryptor = new DecryptKey(url, type, iVector);
    decryptor.encodedKey = key;
    decryptor.decodeKey(key, true);

    return decryptor;
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our DecryptKey class, we could write:
   *
   *    `BankManager.prototype = DecryptKey.prototype`
   *    `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  DecryptKey.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: DecryptKey,

    /**
     * Decodes the string key from base 64 to a byte array.
     *
     * @key {String} containins a base64 encoded key
     * @add {Boolean} true if this.key is to be set to the decoded key value
     * @return An ArrayBuffer containing the decoded bytes for the key, or null if key is empty
     */
    decodeKey: function (key, add) {
      var decodedKey = null;

      key = key || "";
      key = key.trim();

      if (key !== "") {
        decodedKey = atob(key);

        var length = decodedKey.length;

        // eslint-disable-next-line no-undef
        var buf = new ArrayBuffer(length);

        var bufView = new Uint8Array(buf);

        for (var i = 0; i < length; i++) {
          bufView[i] = decodedKey.charCodeAt(i);
        }

        decodedKey = buf;
      }

      if (add) {
        this.key = decodedKey;
      }

      // TODO: BMR: Comment out for real production...this is just for dev
      //logger.debug("decodeKey( key = {0}, decoded key = {1} )", [key, keyToString()]);

      return decodedKey;
    }
  };

  return DecryptKey;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js":
/*!*****************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/15/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Configuration properties that map the unified player specification document.
 *
 *      Milliseconds are used as the base time unit, but configuration parameters are often specified in seconds.
 *      To keep within the nomenclature of the system, time constants are often defined as n * 1000, denoting
 *      n seconds x 1000 milliseconds making it easy to determine the value n expressed as seconds, while the
 *      final, resulting value is in milliseconds.
 *
 *      The properties are not constants as they can be updated by external clients.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  var HlsConfig = {

    /**
     * Default volume.
     * @type {Number}
     * @const
     */
    VOLUME_DEFAULT: 0.5,

    /**
     * Number of chunks to preload by default.
     * @type {Number}
     * @const
     */
    PRELOAD_DEFAULT_CHUNKS: 2,

    /**
     * Number of chunks to preload that matches the 160 seconds buffer requirement. The assumption is that
     * each chunk is ~10 seconds of audio, so 16 of them is 160 seconds.
     * @type {Number}
     * @const
     */
    NUMBER_BUFFER_CHUNKS: 16,

    /**
     * The max number of chunks to allow the player to load. By default this is infinity, but developers
     * can override this number to something lower to make for shorter track playback during development.
     * @type {Number}
     */
    MAX_NUMBER_CHUNKS_TO_LOAD: Number.POSITIVE_INFINITY,

    /**
     * The min number of chunks to allow the player to load. By default this is 3 to allow for the 2
     * audio first chunks to load and then 1 from the playlist.
     * @type {Number}
     * @const
     */
    MIN_NUMBER_CHUNKS_TO_LOAD: 3,

    /**
     * How many chunks from the end of the playlist before a refresh is requested.
     * @type {Number}
     * @const
     */
    PLAYLIST_REFRESH_AT_CHUNK_INDEX: 3,

    /**
     * The minimum number of bytes in an audio chunk.
     * @type {Number}
     * @const
     */
    // TODO: BMR: 03/29/2016: The min chunks bytes is 9000, but the AudioSink only initially consumes and buffers 2000, so we'll set the value to 1500.
    // TODO: BMR: 03/29/2016: CC is looking into this...
    MIN_CHUNK_BYTES: 500,

    /**
     * The number of milliseconds of audio playback to cache in the buffer.
     * @type {Number}
     * @const
     */
    BUFFER_TIME: 160 * 1000,

    /**
     * The minimum number of milliseconds of audio playback to cache in the buffer.
     * @type {Number}
     * @const
     */
    MIN_BUFFER_TIME: 1 * 500,

    /**
     * Time limit for player empty buffer. If buffer is empty for >= EMPTY_BUFFER_TIME_LIMIT_FOR_ABR, Maximum audio
     * quality has to be down-shifted.
     * @type {Number}
     * @const
     */
    EMPTY_BUFFER_TIME_LIMIT_FOR_ABR: 12 * 1000,

    /**
     * Time frame for checking player empty buffer for a period >= EMPTY_BUFFER_TIME_LIMIT_FOR_ABR.
     * @type {Number}
     * @const
     */
    TIME_FRAME_FOR_CHECKING_EMPTY_BUFFER: 60 * 1000,

    /**
     * Constant that is used to compare the current chunk download rate for shifting up the bit rate.
     * @type {Number}
     * @const
     */
    BIT_RATE_UPGRADE_THRESHOLD: 120,

    /**
     * Constant that is used to compare the player buffer percent for shifting down the bit rate. This
     * value is a percent expressed as a whole number.
     * @type {Number}
     * @const
     */
    BIT_RATE_DOWNGRADE_THRESHOLD: 80,

    /**
     * The higher quality max bit rate allowed in the player.
     *
     * NOTE: Right now we're basically allow anything under 96k.
     * @type {Number}
     * @const
     */
    BIT_RATE_HIGHER_QUALITY: 90000,

    /**
     * The max bit rate allowed in the player.
     *
     * NOTE: Right now we're basically allow anything under 256k.
     * @type {Number}
     * @const
     */
    BIT_RATE_MAX: 200000,

    /**
     * The max bit rate allowed in the player.
     *
     * NOTE: Right now we're basically allow anything above 32k.
     * @type {Number}
     * @const
     */
    BIT_RATE_MIN: 30000,

    /**
     * Flag indicating if the player play less than or equal to 96k audio streams, but not anything above that.
     * If this flag is false then it's only bit rates less than 96k and not including 96k.
     * @type {Boolean}
     * @const
     */
    HIGHER_QUALITY_AUDIO: false,
  
    /**
     * Flag indicating if the player needs to send the cookies along with request url.
     * @type {Boolean}
     * @const
     */
    WITH_CREDENTIALS: true,

    /**
     * Flag indicating if the player can play 256k audio streams. If this flag is true, then HIGHER_QUALITY_AUDIO
     * must also be true.
     * @type {Boolean}
     * @const
     */
    MAXIMUM_QUALITY_AUDIO: false,

    /**
     * Constant indicating the number of milliseconds in between playhead position/time checks;
     * the internal timer uses this value to check the time of the playhead.
     * @type {Number}
     * @const
     */
    PLAYHEAD_INTERVAL: 1 * 1000,

    /**
     * Constant indicating the number of milliseconds in between continuous event dispatching. Currently
     * this is only used for the "playhead" event as that's the only continuous, reoccurring event
     * emitting from the player.
     * @type {Number}
     * @const
     */
    EVENT_DISPATCHING_INTERVAL: 750,

    /**
     * Constant indicating the number of milliseconds a check on the buffer is made to see if more
     * chunks need to be loaded.
     * @type {Number}
     * @const
     */
    FEED_INTERVAL: 250,

    /**
     * Constant indicating the number of milliseconds that an asset load request is allowed to be pending
     * before it is timed out.  Exceeding this time could lead to stuttered audio.
     * @type {Number}
     * @const
     */
    LOAD_COMPLETE_LIMIT: 9 * 1000,

    /**
     * Constant indicating the number of milliseconds that an asset load is allowed before some type of
     * load event occurs otherwise a timeout is triggered and the load is failed.
     * @type {Number}
     * @const
     */
    LOAD_EVENT_LIMIT: 1 * 1000,

    /**
     * Constant indicating the number of times to retry during a STALE Playlist
     * (i.e, we do retries, when the playlist is not updated in back to back requests  
     * @type {Number}
     * @const
     */
    STALENESS_RETRY_LIMIT: 5,
    
    /**
     * Constant indicating the number of milliseconds in between asset load error retries.
     * @type {Number}
     * @const
     */
    FAILOVER_RETRY_DELAY: 1500,

    /**
     * Constant indicating the number of milliseconds in between asset load error retries.
     * @type {Number}
     * @const
     */
    FAILOVER_FAST_RETRY_DELAY: 10,

    /**
     * Constant indicating the number of times to retry before failing over.
     * @type {Number}
     * @const
     */
    FAILOVER_RETRY_LIMIT: 5,
    
    /**
     * Default Constant indicating the number of times to retry before failing over.
     * As FAILOVER_RETRY_LIMIT can be modified
     * @type {Number}
     * @const
     */
    FAILOVER_RETRY_LIMIT_DEFAULT: 5,

    /**
     * Placeholder for query string parameters to append to all player requests.
     * @type {String}
     */
    CONSUMPTION_INFO: "",

    /**
     * Placeholder for the base path for retrieving decryption keys
     * @type {String}
     */
    KEYPATH: "",

    /**
     * Constant indicating the URL used to ensure connectivity.
     * @type {String}
     */
    CONNECTIVITY_URL: "/data/connectivity.json"
  };

  return HlsConfig;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/Manifest.js":
/*!****************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/Manifest.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/15/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Contains static properties that apply to both variant and playlist manifests.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  /**
   * @typedef {Object} Manifest
   * @const {String} SMALL - Small manifest size.
   * @const {String} MEDIUM - Medium manifest size.
   * @const {String} LARGE - Large manifest size.
   */

  /**
   * Manifest constants.
   * @returns {Manifest} The constants for manifests.
   */
  return {

    /**
     * Small manifest size.
     * @type {String}
     * @const
     */
    SMALL: "small",

    /**
     * Medium manifest size.
     * @type {String}
     * @const
     */
    MEDIUM: "medium",

    /**
     * Large manifest size.
     * @type {String}
     * @const
     */
    LARGE: "large"
  };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js":
/*!*******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Created by Chris on 9/12/2015.
 **
 * @MODULE:     web-audio-core
 * @CREATED:    08/31/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Allows for passing around ArrayBuffers containing Media data with a corresponding Uint8Array view of the data
 */
/* beautify preserve:start */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * Object for constructing media buffer factories
   *
   * @param {ArrayBuffer} data contains the actual data for the MediaBuffer object
   * @param {Number} duration of the data in milliseconds
   * @constructor
   */
  function MediaBuffer(data,duration,isAACPlus,isMP4) {
    if (!data) {
      data = null;
    }

    if (!duration) {
      duration = 0;
    }

    // Ensures that the callee has invoked our Class' constructor function with the `new` keyword so that we
    // do not leak into the global namespace
    if (!(this instanceof MediaBuffer)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION,["MediaBuffer"]);
    }

    //-----------------------------------------------------------------------
    // CLASS Properties
    //-----------------------------------------------------------------------

    defineProperties(this,isAACPlus,isMP4);

    this.duration    = duration;
    this.arrayBuffer = data;
  }

  /**
   * Define property getter/setters for a MediaBuffer object
   *
   * This is done in a function like this to avoid capturing the data object passed into the MediaBuffer constructure
   * in any closures that may be involved in setting up these properties.
   *
   * @param self is the this reference for the MediaBuffer object to create properties for
   * @param isAACPlus is true if the media buffer will be holding AACPlus audio
   * @param isMP4 is true if the media buffer will be holding audio data sourced from an MP4 file
   */
  function defineProperties(self,isAACPlus,isMP4)
  {
    // Pass along whether the source is AAC-HE (AAC+) and whether it came from an MP4 or not
    Object.defineProperty(self,"isAACPlus",{
      get : function() {
        return (isAACPlus || false);
      }
    });
    Object.defineProperty(self,"isMP4",{
      get : function() {
        return (isMP4 || false);
      }
    });

    /**
     * bytes property is created using a lambda to define _bytes in a closure that is only available to the
     * property getter function.
     */
    (function bytesLambda() {
      var _bytes = null;

      /**
       * Get the Uint8Array that is the "view" for the MediaBuffer
       *
       * @return {Uint8Array} value of _bytes closure that is a Uint8Array created to "view" data
       */
      Object.defineProperty(self,"bytes",
                            {
                              get : function() {
                                return (_bytes);
                              },
                              set : function(value) {
                                if (value !== null) {
                                  _bytes = new Uint8Array(value);
                                } else {
                                  _bytes = null;
                                }
                              }
                            });
    })();

    /**
     * bytes property is created using a lambda to define _data in a closure that is only available to the
     * property getter function.
     */
    (function dataLambda() {
      var _data;

      /**
       * Get the ArrayBuffer that this MediaBuffer is encapsulating
       *
       * @return {ArrayBuffer} the ArrayBuffer that this MediaBuffer is encapsulating is returned
       */
      Object.defineProperty(self,"arrayBuffer",
                            {
                              get : function() {
                                return (_data);
                              },
                              set : function(value) {
                                _data      = value;
                                this.bytes = value;
                              }
                            });
    })();

    Object.defineProperty(self,"length",
                          {
                            get : function() {
                              return this.bytes ? (this.bytes.length) : 0;
                            }
                          });

  }

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.
   */
  MediaBuffer.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint the base Constructor back at the original
     * constructor Function, otherwise `instanceof` calls will fail.
     */
    constructor: MediaBuffer
  };

  return MediaBuffer;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/PlaybackQueue.js":
/*!*********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/PlaybackQueue.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      The playback queue contains a cache of preloaded playback instances. In the case of MySXM it's possible
 *      to have multiple preloaded Playback instances when an interstitial (commercial) is the "next
 *      "track"; in this case, the next track interstitial and the track after that are preloaded (so
 *      2 tracks are preloaded at the same time) as the interstitial is extremely short (usually
 *      1 chunk) so having that next-next track ready to play is important for speed to audio.
 *
 *      The cache is used like a queue so FIFO for audio playback. Items are added to the end with
 *      Array.push() and then removed from the beginning with Array.shift()..
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

    /**
     * Internal reference to the logger.
     */
    var logger = LoggerFactory.getLogger("PlaybackQueue");

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the PlaybackQueue function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @param {HTML5AudioPlayer} player - The player facade that controls all Playback instances.
     * @constructor
     */
    function PlaybackQueue() {
      // This first guard ensures that the callee has invoked our Class' constructor function
      // with the `new` keyword - failure to do this will result in the `this` keyword referring
      // to the callee's scope (typically the window global) which will result in the following fields
      // (name and _age) leaking into the global namespace and not being set on this object.
      if (!(this instanceof PlaybackQueue)) {
        throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["PlaybackQueue"]);
      }

      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------

      /**
       * Queue of Playback instances using the FIFO rule.
       * @type {Array}
       */
      this._queue = [];

      /**
       * Cache of player configs stored by ID. This is used as a backup to playing the next track
       * in MySXM when the Playback instance is no longer in the queue b/c it was removed or pruned.
       * @type {Array}
       */
      this._configCache = [];

      /**
       * Read-only accessor to the internal queue.
       * @type {Array}
       */
      Object.defineProperty(this, "queue",
        {
          get: function () {
            return this._queue;
          }.bind(this)
        });

      /**
       * Read-only accessor to number of items in the queue.
       * @type {Array}
       */
      Object.defineProperty(this, "length",
        {
          get: function () {
            return this._queue ? this._queue.length : 0;
          }.bind(this)
        });
    };

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Constant indicating the maximum number of items allowed in the player cache.
     * @const {Number}
     */
    PlaybackQueue.PLAYER_CACHE_MAX_ITEMS = 4;

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our PlaybackQueue class, we could write:
     *
     *  `BankManager.prototype = PlaybackQueue.prototype`
     *  `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    PlaybackQueue.prototype = {

      /**
       * Whenever you replace an Object's Prototype, you need to repoint
       * the base Constructor back at the original constructor Function,
       * otherwise `instanceof` calls will fail.
       */
      constructor: PlaybackQueue,

      /**
       * Adds a Playback instance to the queue.
       *
       * @param {Playback} target - The Playback instance to add.
       */
      addPlayback: function (target) {
        if (ObjectUtil.isUndefinedOrNull(target)) {
          logger.error("Could not add undefined playback");
          throw new PlayerError(PlayerError.REQUIRED_PARAM, ["target"]);
        }

        if (ObjectUtil.isUndefinedOrNull(target.id)) {
          logger.error("Could not add playback with undefined id");
          throw new PlayerError(PlayerError.REQUIRED_PARAM, ["target.id"]);
        }

        if (target) {
          var stalePlayback = this.getPlaybackById(target.id);

          if (stalePlayback) {
            stalePlayback.stop();

            logger.debug("replacing stale Playback( {0} {1} )", [target.id, target.uid]);
            this.replacePlaybackById(stalePlayback.id, target);
          }
          else {
            this._queue.push(target);
          }

          logger.debug("addPlayback( {0} )", [target.uid]);

          // Remove any extra ones
          this.prune();

          // Save the player's config.
          this._configCache[target.id] = target.configuration;

          // Log the list if Playback instances -- this is really for development only.
          this.getCachedPlaybackIds("add");
        }
        return target;
      },

      /**
       * Removes a Playback instance from the queue by ID.
       *
       * @param {String} id - ID for a given player.
       * @returns {Playback|null} The Playback instance that matches ID.
       */
      removePlaybackById: function (id) {
        if (ObjectUtil.isUndefinedOrNull(id)) {
          throw new PlayerError(PlayerError.REQUIRED_PARAM, ["id"]);
        }

        var i;
        var len = this.length;

        for (i = len - 1; i >= 0; i--) {
          if (this._queue[i].id === id) {
            var removedItems = this._queue.splice(i, 1);
            var removedItem = (removedItems.length > 0) ? removedItems[0] : null;
            logger.debug("removePlaybackById( {0} )", [removedItem.uid]);
            this.getCachedPlaybackIds("remove");

            return removedItem;
          }
        }

        return null;
      },

      /**
       * Replaces a Playback instance from the queue by ID with provided playback.
       *
       * @param {String} id - ID for a given player.
       * @param {Playback} replacement - a replacement playback.
       * @returns {Playback|null} The Playback instance that matches ID.
       */

      replacePlaybackById: function (id, replacement) {
        if (ObjectUtil.isUndefinedOrNull(id)) {
          throw new PlayerError(PlayerError.REQUIRED_PARAM, ["id"]);
        }

        var i;
        var len = this.length;

        for (i = len - 1; i >= 0; i--) {
          if (this._queue[i].id === id) {
            var removedItems = this._queue.splice(i, 1, replacement);
            var removedItem = (removedItems.length > 0) ? removedItems[0] : null;
            logger.debug("removePlaybackById( {0} )", [removedItem.uid]);
            this.getCachedPlaybackIds("remove");

            return removedItem;
          }
        }

        return null;
      },

      /**
       * Attempts to return a playback from the cache by ID.
       *
       * @param {String} id - ID for a given player.
       * @returns {Playback|null} The Playback instance that matches ID.
       */
      getPlaybackById: function (id) {
        var result = null;

        this._queue.some(function (item) {
          if (item.id === id) {
            logger.debug("getPlaybackById( {0} )", [item.uid]);
            result = item;
            return true;
          }
        });

        return result;
      },

      getPlaybacksBefore: function (target) {
        var indexOfTarget = this.queue.indexOf(target);

        if (indexOfTarget === -1) {
          return [];
        }

        return this.queue.slice(0, indexOfTarget);
      },


      getPlaybacksAfter: function (target) {
        var indexOfTarget = this.queue.indexOf(target);

        if (indexOfTarget === -1) {
          return [];
        }

        return this.queue.slice(indexOfTarget + 1);
      },

      /**
       * Attempts to move a playback after a targeted playback.
       *
       * This was mainly added  as we are stopping all the playbacks( even preloaded) before the current playback during stop,
       * but the preloaded playbacks might still get played after the current playback as client's can set the playbacks in any order.
       *
       * So if a playback(x) is set to play after a playback (y), but if the playback(x) is in queue before playback (y),
       * while skipping from playback(y) to playback(x) might result in stopping and cleaning the playback(x) as this was in queue before playback(y)
       *
       * @param {Playback} targetPlayback.
       * @param {Playback} nextPlayback
       * @returns {Configuration|null} The Configuration instance that matches ID.
       */
      movePlaybackAfter: function ( targetPlayback , nextPlayback){
        var indexOfTargetPlayback = this._queue.indexOf(targetPlayback);
        var indexOfNextPlayback = this._queue.indexOf(nextPlayback);

        if (indexOfTargetPlayback === -1 || indexOfNextPlayback === -1 || indexOfNextPlayback > indexOfTargetPlayback) {
          return; // if the playback order is correct order, no need to switch them
        }
        logger.debug("movePlayback Playback {0} After( {1} )", [nextPlayback.id, targetPlayback.id]);
        this.removePlaybackById(nextPlayback.id);
        this.addPlayback(nextPlayback);
      },
      
      /**
       * Attempts to return a playback config from the cache by ID.
       *
       * @param {String} id - ID for a given player.
       * @returns {Configuration|null} The Configuration instance that matches ID.
       */
      getConfigById: function (id) {
        var result = this._configCache[id] || null;
        logger.debug("getConfigById( {0} {1} )", [(result ? "Found:" : "NOT Found:"), id]);

        return result;
      },

      /**
       * Attempts to find the next Playback instance to play either via the requested ID or
       * simply by taking the first item from the queue.
       *
       * @param {String|undefined} id - ID for a given player.
       * @returns {Playback|null} The next Playback instance to play.
       */
      getNextPlayback: function (id) {
        id = ObjectUtil.isString(id) ? id : null;

        var pb = null;
        var logFn = null;
        var logMsg = "";

        // Grab the requested Playback instance by ID...otherwise just take the first item in the queue.
        if (ObjectUtil.isString(id)) {
          pb = this.getPlaybackById(id);
          logFn = pb ? logger.debug : logger.warn;
          logMsg = pb ? pb.uid : String(id + " Not Found.");
          logFn.apply(logger, ["getNextPlayback( By ID = {0} )", [logMsg]]);
        }
        else {
          pb = this._queue[0] || null;
          logMsg = pb ? pb.uid : "No queued up Playbacks.";
          logger.debug("getNextPlayback( By index: `{0}` )", [logMsg]);
        }

        return pb;
      },

      /**
       * Resets the playback queue by stopping all and then clearing it.
       */
      getCachedPlaybackIds: function (action) {
        var pb;
        var items = [];
        var len = this.length;

        for (var i = 0; i < len; i++) {
          pb = this._queue[i];
          items.push(pb.uid);
        }

        action = action || "";
        logger.debug("getCachedPlaybackIds( Action = {0}, {1} items, IDs = [{2}] )", [
          action, items.length, items.toString().replace(/,/g, ", ")
        ]);
        return items;
      },

      /**
       * The audio player cache should only hold a certain number of players at once to keep down memory, so we check
       * for too many and remove the extra ones. The removed players are also retired.
       */
      prune: function () {
        var len = this.length;
        var playbackItems = [];
        var pb = null;

        // Keep the player cache to max of 4 items...any items beyond that will be removed and a new player
        // will need to be created and cached.
        if (len > PlaybackQueue.PLAYER_CACHE_MAX_ITEMS) {
          // DO NOT remove the item from the cache until it has been stopped -- this was changed from
          // an Array.splice() to an Array.slice() for this reason. We'll simply grab the extra
          // Playback instances in an Array and stop them and then individually remove them once stopped.
          playbackItems = this._queue.slice(0, len - PlaybackQueue.PLAYER_CACHE_MAX_ITEMS);
          for (var i = 0; i < playbackItems.length; i++) {
            pb = playbackItems[i];
            logger.debug("prune( {0} )", [pb.uid]);
            this.removePlaybackById(pb.id);
          }
        }
      },

      /**
       * Resets the playback queue by stopping all and then clearing it.
       */
      reset: function () {
        logger.debug("reset()");
        this._queue = [];
        this._configCache = [];
      }

    };

    return PlaybackQueue;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/PlayerState.js":
/*!*******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/PlayerState.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    02/08/16
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Contains static properties that apply to the player's state.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  /**
   * @name PlayerState
   * @typedef {Object} PlayerState
   * @const {String} INITIAL - Initial state.
   * @const {String} PRELOADING - Preloading state.
   * @const {String} PLAYING - Playing state.
   * @const {String} PAUSED - Paused state.
   * @const {String} SEEKING - Seeking state.
   * @const {String} STOPPING - Stopping state.
   * @const {String} STOPPED - Stopped state.
   * @const {String} FINISHED - Finished state.
   */

  /**
   * PlayerState constants.
   * @returns {PlayerState} The constants for states.
   */
  return {

    /**
     * Initializing state.
     * @type {String}
     * @const
     */
    INITIAL: "initial",

    /**
     * Preloading state.
     * @type {String}
     * @const
     */
    PRELOADING: "preloading",

    /**
     * Playing state.
     * @type {String}
     * @const
     */
    PLAYING: "playing",

    /**
     * Paused state.
     * @type {String}
     * @const
     */
    PAUSED: "paused",

    /**
     * Seeking state.
     * @type {String}
     * @const
     */
    SEEKING: "seeking",

    /**
     * Stopping state -- transitioning from some other state and in the process of stopping but not
     * actually stopped.
     * @type {String}
     * @const
     */
    STOPPING: "stopping",

    /**
     * Stopped state.
     * @type {String}
     * @const
     */
    STOPPED: "stopped",

    /**
     * Finished state.
     * @type {String}
     * @const
     */
    FINISHED: "finished"

  };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/Playlist.js":
/*!****************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/Playlist.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Data model representing a HLS playlist. Contains the following key properties:
 *          * List of chunk URLs
 *          * List of chunk Date objects
 *          * Total playlist duration
 *          * Playlist URL
 *          * Playlist, aka HLS manifest, raw data
 *
 *      The model also contains the current playlist index, which matches the index of the current chunk being
 *      loaded. NOTE, the index is NOT the current chunk being played, but the one being loaded. This index
 *      also matches the index of the chunk's Date objects list.
 *
 *      There are a number of helper methods and accessors that facilitate the location of chunk times and URLs
 *      by both Date and timestamp in milliseconds.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlaylistUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaylistUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaylistUtil.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("Playlist");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the Playlist function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {String} data - The raw manifest data.
   * @param {Array} chunkUrls - The list of URLS for the chunks.
   * @param {Array} timestamps - The list of timestamps for the chunks.
   * @param {Array} chunkDurations - The list of durations for the chunks.
   * @param {Array} chunkDecryptors - The list of decryptor for each chunks if it has any.
   * @param {String} url - The HLS URL for the stream.
   * @param {Boolean} isLive - Flag indicating if the playlist is for "Live" playback.
   * @param {Number} duration - Duration of this playlist in milliseconds. Live is undefined.
   * @param {Number} [offset] The initial offset (chunk sub-seek) in milliseconds. Optional.
   */
  function Playlist(data, chunkUrls, timestamps, chunkDurations, chunkDecryptors, url, isLive, duration, offset) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof Playlist)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["Playlist"]);
    }

    logger.debug("Constructor( {0} )", [url]);

    //-----------------------------------------------------------------------
    // CLASS MEMBERSf
    //-----------------------------------------------------------------------

    /**
     * Raw data for the manifest.
     * @type {String}
     */
    this.data = data || null;

    /**
     * Array of 1...n chunk URLs.
     * NOTE: URLs will be auto-converted to absolute as needed.
     * @type {Array}
     */
    this.chunkUrls = chunkUrls || [];

    /**
     * Array of 1...n `*.ts` UTC Date instances associated with the start of each chunk. It is expected
     * that the chunk and time indices match.
     * @type {Array}
     */
    this.timestamps = timestamps || [];

    /**
     * Array of 1...n chunk durations for the playlist in milliseconds. It is expected that the chunk
     * and time indices match.
     * @type {Array}
     */
    this.chunkDurations = chunkDurations || [];

    /**
     * The List of chunk decryptors for each chunk if any
     * @type {Array}
     */
    this.chunkDecryptors = chunkDecryptors || [];

    /**
     * URL for the Playlist.
     * @type {String}
     */
    this.url = url || "";

    /**
     * Initial offset (msecs) or sub-seek into the first chunk.
     * @type {Number}
     */
    this.offset = offset || 0;

    /**
     * Total duration (msecs) for AOD or MySXM playback. LIVE playback duration is NaN as
     * it's essentially infinite with continuous radio playback.
     *
     * @type {Number}
     */
    this.duration = duration || NaN;

    /**
     * The current chunk index in the playlist. Always default to -1 so we can simply increment to 0 to
     * kickoff the sequence of chunks.
     * @type {Number}
     */
    this.index = Playlist.MIN_INDEX;

    /**
     * Indicates if this is an infinite playlist, aka Live radio.
     * @type {Boolean}
     */
    this.isLive = (isLive === true);

    /**
     * Indicates if the playlist is infinite and revolving as opposed to finite like AOD and My.
     * @type {Boolean}
     */
    this.refreshEnabled = this.isLive;

    /**
     * Indicates the codec.
     * @type {String}
     */
    this.codec = null;

    /**
     * Total number of chunks for this playlist.
     * @type {Number}
     */
    Object.defineProperty(this, "totalChunks",
      {
        get: function () {
          return this.chunkUrls ? this.chunkUrls.length : 0;
        }
      });

    /**
     * The default decryptor for the playlist. Contains the key to decrypt the chunks.
     * @type {DecryptKey}
     */
    var _decryptor = null;
    Object.defineProperty(this, "decryptor",
        {
          get: function () {
            if (!_decryptor && this.chunkDecryptors && this.chunkDecryptors.length > 0) {
              _decryptor = this.chunkDecryptors.find(function (val) {
                return !!val.url && val.type !== 'NONE';
              });
            }
            return _decryptor;
          }
        });

    /**
     * Determines is this playlist is an audio first playlist.
     * @type {Boolean}
     */
    Object.defineProperty(this, "isAudioFirst",
      {
        get: function () {
          return this.data === Playlist.AUDIO_FIRST_PLAYLIST_DATA;
        }
      });

    /**
     * Determines if the last chunk of a playlist have been loaded. This can also be thought of as all chunks
     * loaded for a playlist at any bit rate -- we might not load al chunks for say 32k but with ABR we might
     * jump to 64k and then load the remaining chunks so this can be thought of as all chunks loaded.
     *
     * NOTE: If there are no chunks then, aka total chunks equals zero, then always return false.
     *
     * @type {Boolean}
     */
    Object.defineProperty(this, "areAllChunksLoaded",
      {
        get: function () {
          return (!this.isLive) && (this.totalChunks > 0) && ((this.index + 1) >= this.totalChunks);
        }
      });

    /**
     * The current chunk URL based on current index.
     *
     * @type {String|null}
     */
    Object.defineProperty(this, "currentChunk",
      {
        get: function () {
          return this.isChunkIndexValid(this.index) ? this.chunkUrls[this.index] : null;
        }
      });

    /**
     * The last chunk's URL.
     *
     * @type {String|null}
     */
    Object.defineProperty(this, "lastChunk",
      {
        get: function () {
          var validChunks = this.chunkUrls && (this.totalChunks > 0);
          return validChunks ? this.chunkUrls[this.totalChunks - 1] : null;
        }
      });

    /**
     * The current chunk date object based on current index.
     *
     * @type {Date}
     */
    Object.defineProperty(this, "currentChunkDate",
      {
        get: function () {
          return this.getChunkDateByIndex(this.index);
        }
      });

    /**
     * The current chunk's (based on current index) zulu-based timestamp as a number in milliseconds.
     *
     * @type {Number|NaN}
     */
    Object.defineProperty(this, "currentChunkTime",
      {
        get: function () {
          var date = this.getChunkDateByIndex(this.index);
          return date ? date.getTime() : NaN;
        }
      });

    /**
     * The first chunk's zulu-based timestamp as a number in milliseconds.
     *
     * @type {Number|NaN}
     */
    Object.defineProperty(this, "firstChunkTime",
      {
        get: function () {
          var date = this.getChunkDateByIndex(0);
          return date ? date.getTime() : NaN;
        }
      });

    /**
     * Determines if the playlist has another chunk after the current chunk index.
     *
     * @type {Boolean}
     */
    Object.defineProperty(this, "hasNext",
      {
        get: function () {
          return this.isChunkIndexValid(this.index + 1);
        }
      });

    /**
     * The index of the last chunk.
     *
     * @type {Number}
     */
    Object.defineProperty(this, "lastChunkIndex",
      {
        get: function () {
          return (this.totalChunks > 0) ? this.totalChunks - 1 : 0;
        }
      });

    /**
     * Boolean indicating if the playlist needs to be refreshed. It's possible refresh isn't enabled as
     * it's not required for various playback types. if not enabled, then never allow a refresh.
     *
     * var AAA = Live index file refresh point (3 chunks from end).
     * Index file, aka playlist, is reloaded when all but AAA chunks have been played out.
     *
     * @type {Boolean}
     */
    Object.defineProperty(this, "needsRefresh",
      {
        get: function () {
          return !this.refreshEnabled ? false : this.chunksLeft <= HlsConfig.PLAYLIST_REFRESH_AT_CHUNK_INDEX;
        }
      });

    /**
     * Number of chunks left in the playlist based on the current index.
     *
     * @type {Number}
     */
    Object.defineProperty(this, "chunksLeft",
      {
        get: function () {
          return (this.totalChunks - (this.index + 1));
        }
      });

    /**
     * The percentage of chunks played within the playlist. Remember, chunk indexes are zero-based, so we need
     * to add 1 to the current chunk index when determining what percentage of the chunks have played.
     *
     * @type {Number}
     */
    Object.defineProperty(this, "percentOfChunksLoaded",
      {
        get: function () {
          var result = Number((this.index + 1) / this.totalChunks);
          return result || 0;
        }
      });
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * The index cannot be less than -1.
   * @type {Number}
   * @const
   */
  Playlist.MIN_INDEX = -1;

  /**
   * Mock data used when dynamically creating a playlist for AF chunks that don't initially have a playlist.
   * @type {String}
   * @const
   */
  Playlist.AUDIO_FIRST_PLAYLIST_DATA = "FAKE AUDIO FIRST PLAYLIST DATA";

  /**
   * Mock URL used when dynamically creating a playlist for AF chunks that don't initially have a playlist.
   * @type {String}
   * @const
   */
  Playlist.AUDIO_FIRST_PLAYLIST_URL = "FAKE AUDIO FIRST PLAYLIST URL";

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Playlist class, we could write:
   *
   *  `BankManager.prototype = Playlist.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  Playlist.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: Playlist,

    /**
     * The chunk's date by index. Must be a valid index.
     *
     * @returns {Date|null}
     */
    getChunkDateByIndex: function (index) {
      if (this.isChunkIndexValid(index) && (this.totalChunks > 0)) {
        return this.timestamps[index];
      }
      return null;
    },

    /**
     * The chunk's timestamp in milliseconds by index. Must be a valid index.
     *
     * @returns {Number|NaN}
     */
    getChunkTimeByIndex: function (index) {
      var date = this.getChunkDateByIndex(index);
      return date ? date.getTime() : NaN;
    },

    /**
     * The chunk's decryptor by index. Must be a valid index.
     *
     * @returns {Number|NaN}
     */
    getChunkDecryptorByIndex: function (index) {

      if (this.isChunkIndexValid(index) && (this.totalChunks > 0)) {
        var decrryptor = this.chunkDecryptors[index];
        return decrryptor ? decrryptor : null;
      }
      return null;
    },

    /**
     * The chunk's index by URL.
     *
     * @param {String} url - The requested URL for a chunk.
     * @returns {Number|NaN}
     */
    getChunkIndexByUrl: function (url) {
      return (this.chunkUrls && this.totalChunks > 0) ? this.chunkUrls.indexOf(url) : NaN;
    },

    /**
     * The chunk's duration by index.
     *
     * @returns {Number}
     */
    getChunkDurationByIndex: function (index) {
      if (this.isChunkIndexValid(index) && (this.totalChunks > 0)) {
        var value = this.chunkDurations[index];
        return value ? value : 10;
      }
      return NaN;
    },

    /**
     * Determines if a given index exists within the list of chunks for this playlist.
     *
     * @param index The index in question.
     * @return {Boolean} A Boolean indicating if the index exists within the list of chunks for this playlist.
     */
    isChunkIndexValid: function (index) {
      return ((index >= 0) && (index < this.totalChunks));
    },

    /**
     * Updates the current chunk index to the next available one and returns the new chunk URL.
     *
     * @return {String|null} Next available chunk URL.
     */
    next: function () {
      if (this.hasNext) {
        this.index += 1;
        logger.debug("next( index = {0} )", [this.index]);
        return this.currentChunk;
      }
      return null;
    },

    /**
     * Determines if a value is a zulu-based timestamp.
     *
     * @param {Number} value The value under inspection.
     * @return {Boolean} Boolean indicating if a value is a zulu timestamp.
     */
    isZulu: function (value) {
      var baseline = this.firstChunkTime;
      var timeFromEpoch = PlaylistUtil.TIME_FROM_EPOCH;
      return (!isNaN(value)) && (value > 0) && (baseline > 0) && ((value - timeFromEpoch) >= 0);

      // NOTE: This determines if the zulu based value is in the playlist
      //return(!isNaN(value)) && (value > 0) && (baseline > 0) && ((value - baseline) >= 0);
    },

    /**
     * Acquires the live time by grabbing the 16th chunk's timestamp in milliseconds from the end of
     * the playlist. If the playlist is not for live then grab the first timestamp.
     *
     * @return {Number|0} Returns either the 16th chunk's timestamp in milliseconds from the end of
     * the playlist or zero for non-live playlists.
     */
    getLiveTime: function () {
      // the live point is considered 16 chunks from the end of any playlist size (small, medium or large)
      // if small, then we're grabbing the first chunk, otherwise 16 chunks from the end; however,
      // chunk indexes are zero based so we really need to grab 17 chunks from the end to acquire the
      // correct index
      var liveIndex = this.totalChunks - HlsConfig.NUMBER_BUFFER_CHUNKS;
      return this.isLive && (liveIndex >= 0) ? this.getChunkTimeByIndex(liveIndex) : this.firstChunkTime;
    },

    /**
     * Attempts to convert either a zero-based offset value in milliseconds or zulu-based timestamp in
     * milliseconds to a Date object; mainly used to perform the former.
     *
     * @param {Number} target A millisecond based number.
     * @return {Date} A Date object based on the requested target input.
     */
    convertMillisecondsToDate: function (target) {
      var result = null;
      var offset = Number(target);

      try {
        if (!isNaN(offset) && (offset > 0)) {
          var baseline = this.getChunkDateByIndex(0);
          var isZulu = this.isZulu(offset);
          logger.debug("convertMillisecondsToDate( offset = `{0}`, baseline = {1}, isZulu = {2} )", [
            offset, (baseline ? baseline.getTime() : null), String(isZulu)
          ]);

          if (this.totalChunks >= 1) {
            // target is epoch GMT msecs
            result = isZulu ? new Date(offset) : new Date(baseline.getTime() + offset);
          }
        }
        else {
          logger.warn("convertMillisecondsToDate( Parameter is not a number or <= 0: target = {0} )", [target]);
        }
      }
      catch (e) {
        logger.info("convertMillisecondsToDate( An async operation was killed so expected: {0} )", [e.message]);
        result = null;
      }

      return result;
    },

    /**
     * Confirm target date/time/offset is within range of all available chunk times.
     *
     * @param {Date|Number} target Number === msec offset, Date === absolute zulu-based milliseconds.
     * @return {Boolean} Indicating if the requested time is in the current playlist.
     */
    isInRange: function (target) {
      var isValid = false;
      var numChunks = this.totalChunks;
      var firstTime = this.getChunkDateByIndex(0);
      var lastTime = this.getChunkDateByIndex(numChunks - 1);
      var isTargetValid = !ObjectUtil.isUndefinedOrNullOrEmptyString(target);
      var targetTime = isTargetValid ? (target instanceof Date ? target : this.convertMillisecondsToDate(target)) : null;

      // Check for the case where the requested time is the same as the first chunk's time.
      if (targetTime && firstTime && (targetTime.getTime() === firstTime.getTime())) {
        return true;
      }
      else if (targetTime !== null) {
        var avgTime = numChunks ? Math.floor((lastTime.getTime() - firstTime.getTime()) / (numChunks - 1)) : 0;
        var times = [].concat(this.timestamps);

        // Since the last time duration is not known... we use average of all preceding chunk durations
        if (avgTime > 0) {
          times.push(new Date(lastTime.getTime() + avgTime));
        }

        for (var j = 0; j < (times.length - 1); j++) {
          var it = times[j];
          if ((it !== null) && (targetTime.getTime() >= it.getTime())) {
            var nx = times[j + 1];
            if (targetTime.getTime() < nx.getTime()) {
              isValid = true;
              break;
            }
          }
        }
      }

      logger.debug("isInRange( {0}, targetTime = {1}, firstTime = {2}, lastTime = {3} )", [
        String(isValid), (targetTime ? targetTime.getTime() : null), (firstTime ? firstTime.getTime() : null), (lastTime ? lastTime.getTime() :
          null)
      ]);
      return isValid;
    },

    /**
     * Gets the next date in the playlist based on the date parameter provided. The next date could be the first
     * chunk's timestamp in the playlist or somewhere in the middle.
     *
     * NOTE: This method expects the date parameter to match a date in the playlist exactly -- it cannot
     * be a date + offset and there are other methods that provide tha functionality.
     *
     * @param {Date} date Find the next date in the playlist based on this date parameter.
     * @return {Date} The next date.
     */
    getNextDate: function (date) {
      if (!(date instanceof Date)) {
        throw new TypeError("Only Date input allowed but found", typeof (date));
      }

      var firstChunkTime = this.firstChunkTime;

      // determine if the next chunk to play in the playlist is older than the first chunk in the playlist.
      // If so, return the time for the first chunk in the playlist as that is as far back as we can go
      if (!isNaN(firstChunkTime) && date.getTime() < firstChunkTime) {
        logger.debug("getNextDate( First chunk in playlist being used with date `{0}` )", [nextDateItem]);
        return new Date(firstChunkTime);
      }

      // try looping through all of the chunks to find the chunk that covers the given time.
      // If found use the date after it as the next chunk timestamp to play
      else {
        var timesLen = this.timestamps.length;

        for (var i = 0; i < timesLen; i++) {
          var prevDateItem = (i > 0) ? this.timestamps[i - 1] : this.timestamps[i];
          var dateItem = this.timestamps[i];
          var zuluTime = date.getTime();
          var currentZuluTime = dateItem.getTime();
          var previousZuluTime = (!!prevDateItem) ? prevDateItem.getTime() : currentZuluTime;

          if (zuluTime <= currentZuluTime && zuluTime >= previousZuluTime) {
            if (this.isChunkIndexValid(i + 1)) {
              var nextDateItem = this.timestamps[i + 1];
              logger.debug("getNextDate( {0} )", [nextDateItem]);
              return nextDateItem;
            }
          }
        }
      }

      logger.warn("getNextDate( The date `{0}` is not in the current playlist )", [date]);
      return null;
    },

    /**
     * Gets the chunk index for the specified target time; finds the chunk with the start time
     * in the playlist that matches the provided timestamp (passed in as the target parameter). This can
     * either be for a real zulu based date or an offset. If an offset it's converted to a real date
     * within the current playlist (if possible).
     *
     * @param {Date|Number} target Number === msec offset, Date === absolute zulu-based milliseconds
     * @param {Boolean} [autoDecrement] Optional. There are several cases where we want to get the requested chunk
     * index minus 1 -- this is b/c the normal playback flow always assumes it's loading the next chunk,
     * so for these cases we want to get the requested chunk by timestamp.
     */
    getChunkIndexByTime: function (target, autoDecrement) {
      autoDecrement = autoDecrement || false;

      var foundAt = this.index;
      var numChunks = this.timestamps.length;
      var chunkStart = target ? (target instanceof Date ? target : this.convertMillisecondsToDate(target)) : null;

      for (var j = 0; j < numChunks; j++) {
        var it = this.timestamps[j];

        // if the date we're looking for is null (was not a date or couldn't be converted to a date)
        // then simply default the index to the current index.
        if (!chunkStart) {
          foundAt = this.index;
          break;
        }
        // if the date from the timestamps wasn't null and it's at least greater than the
        // first chunk in the playlist then we can try to locate it...otherwise it's more
        // than likely a timestamp before the 1st chunk date in the playlist so we'll
        // just default the index to the current index
        else if ((it !== null) && (chunkStart.getTime() >= it.getTime())) {
          var nx = this.isChunkIndexValid(j + 1) ? this.timestamps[j + 1] : it;

          // the date we have is less than the next date, then we've found it since we know it's
          // already greater than the current index's time, so it's a time in the current date
          if (chunkStart.getTime() < nx.getTime()) {
            //foundAt = autoDecrement ? j - 1 : j;
            foundAt = j;
            break;
          }
          // the date is the same as the last chunk's date or after the last chunk so we default
          // to the last index available
          // TODO: BMR: Should timestamps past the duration of the last chunk still return the last chunk?
          else {
            if (it === nx) {
              foundAt = j;
              break;
            }
          }
        }
      }

      logger.debug("getChunkIndexByTime( target = {0}, date = {1}, autoDecrement = {2}, index = {3}, url = {4} )", [
        target, ((chunkStart === null) ? null : chunkStart), String(autoDecrement), foundAt, this.chunkUrls[foundAt]
      ]);
      //return foundAt;

      // apply the auto decrement if applicable...
      // if we're starting somewhere in the middle of the playlist due to audio first playback
      // where we play n number of chunks directly (without using the playlist)
      // then the chunk index found actually should be index - 1...this is to accommodate the
      // normal chunk loading process that assumes index + 1 and since audio
      // first has no concept of current index, we need to account for it by setting the "current
      // index" to this found chunk index - 1.
      foundAt = autoDecrement ? foundAt - 1 : foundAt;

      // the index can never be less than -1, the minimum index
      foundAt = (foundAt < Playlist.MIN_INDEX) ? Playlist.MIN_INDEX : foundAt;

      return foundAt;
    },

    /**
     * Sets the playlist's chunk index for the specified target time; finds the chunk with the start time
     * in the playlist that matches the provided timestamp (passed in as the target parameter). This can
     * either be for a real zulu based date or an offset. If an offset it's converted to a real date
     * within the current playlist (if possible).
     *
     * Optionally sets the current offset (aka the sub-seek time into the requested chunk to play), which is
     * determined by subtracting the requested start time from the requested chunk's timestamp.
     *
     * @param {Date|Number} target Number === msec offset, Date === absolute zulu-based milliseconds
     * @param {Boolean} [autoDecrement=false] There are several cases where we want to get the requested chunk
     * index minus 1 -- this is b/c the normal playback flow always assumes it's loading the next chunk,
     * so for these cases we want to get the requested chunk by timestamp.
     * @param {Boolean} [setOffset=false] Flag indicating whether the playlist's offset should be set. Most of
     * the time we don't want to set this property, as it performs a sub-seek into the first chunk
     * requested for playback -- first chunk for playback is not necessarily the first chunk in the
     * playlist but the first chunk to play; we do want to set this in the case of seeking.
     * @return {Playlist} Reference to the playlist with the index and offset values.
     */
    startAt: function (target, autoDecrement, setOffset) {
      autoDecrement = autoDecrement || false;
      setOffset = setOffset || false;

      this.index = this.getChunkIndexByTime(target, autoDecrement);

      if (setOffset) {
        // do not allow the offset to be set to NaN
        var offset = this.getOffsetForTimestamp(target);
        this.offset = isNaN(offset) ? 0 : offset;
      }

      logger.debug("startAt( index = {0}, offset = {1}, autoDecrement = {2}, setOffset = {3} )", [
        this.index, this.offset, String(autoDecrement), String(setOffset)
      ]);

      return this;
    },

    /**
     * Returns the zero-based amount of time in milliseconds that this chunk is from the beginning
     * of the playlist.
     *
     * @param {Number} timestamp - The timestamp in question.
     * @returns {Number} The zero-based amount of time in milliseconds that this chunk is from the beginning
     * of the playlist.
     */
    getTimeIntoPlaylist: function (timestamp) {
      return timestamp - this.firstChunkTime;
    },

    /**
     * Used to grab the chunk timestamp for the given timestamp parameter; this will locate the chunk
     * that contains the timestamp param.
     *
     * @param {Number|Date} timestamp The requested timestamp.
     * @returns {Number|NaN}
     */
    getChunkTimeForTimestamp: function (timestamp) {
      var index = this.getChunkIndexByTime(timestamp, false);
      return this.getChunkTimeByIndex(index);
    },

    /**
     * Used to grab the chunk's offset of sub-seek time in milliseconds for the given timestamp parameter.
     * This will locate the chunk that contains the timestamp param and then determine how much time to
     * sub-seek into that chunk to match the requested timestamp.
     *
     * NOTE: This can easily return NaN if the requested timestamp is outside of the list of timestamps
     * for this playlist so calling objects must be ready to handle the NaN case.
     *
     * @param {Number|Date} timestamp - The requested timestamp.
     * @returns {Number|NaN|0}
     */
    getOffsetForTimestamp: function (timestamp) {
      timestamp = this.convertMillisecondsToDate(timestamp);

      if (timestamp instanceof Date) {
        timestamp = timestamp.getTime();
        var chunkTime = this.getChunkTimeForTimestamp(timestamp);
        var offset = timestamp - chunkTime;
        return Math.max(0, offset);
      }
      return 0;
    },

    /**
     * Sets the playlist's chunk index when starting playback with audio first by trying to locate the
     * chunk with the start time in the playlist that matches the last audio first chunk's timestamp.
     * In the case of MySXM there are no chunk timestamps in the audio first data, so we simply play from
     * the next chunk index -- MySXM always starts from chunk 0, so we can simply start playing from the
     * chunk index after the AF chunks.
     *
     * If there are no audio first chunks then start playback from the current index, usually defaulting
     * to the first chunk in the playlist.
     *
     * @param {AudioFirst} audioFirst The audio first object contains the chunk data with timestamps.
     */
    skipForAudioFirst: function (audioFirst) {
      var previousIndex = this.index;

      // if there are no chunks, then just start playing at the first chunk in the playlist
      if (!audioFirst || !audioFirst.getChunks() || audioFirst.getChunks().length <= 0) {
        this.index = 0;
        logger.info(
          "skipForAudioFirst( No chunks, so skipping from index `{0}` to 0, the first chunk in the playlist )", [
            previousIndex
          ]);
      }
      else {
        var chunks = audioFirst.getChunks();
        var lastChunk = chunks[chunks.length - 1];

        // determine if the chunks have timestamps -- both Live and AOD should have timestamps
        // whereas MySXM does not. if MySXM is sent with a timestamp that's null, then we need to ignore it
        //
        // NOTE: This should be used for Live and AOD, but not for MySXM.
        if (!ObjectUtil.isUndefinedOrNull(lastChunk.timestamp)) {
          // find the timestamp in the playlist immediately after the last chunk's timestamp. this will indicate the
          // chunk index in the playlist to seamlessly start playing audio after the audio first chunks

          var lastChunkDate = PlaylistUtil.convertToDates(lastChunk.timestamp);
          var nextChunkDate = this.getNextDate(lastChunkDate);

          if (nextChunkDate === null) {
            throw new Error("The next chunk timestamp could not be located in the playlist.");
          }

          logger.debug("skipForAudioFirst( Skipping by chunk timestamp: from `{0}` to `{1}` )", [
            lastChunkDate, nextChunkDate
          ]);
          this.startAt(nextChunkDate, true, false);
        }
        // there is no timestamp associated with each chunk, so simply start playing the index in the playlist
        // after the last audio first chunk -- so basically we need to set the current chunk index by using
        // chunks.length - 1. the normal playback process will take care of incrementing this for us and
        // retrieve the correct chunk index out of the playlist (to play next after audio first chunks).
        //
        // NOTE: This should be used for MySXM, but not for Live or AOD.
        else {
          var index = chunks.length - 1;
          if (this.isChunkIndexValid(index)) {
            this.index = index;
          }

          logger.debug("skipForAudioFirst( Skipping to chunk index: from `{0}` to `{1}` )", [
            previousIndex, this.index
          ]);
        }
      }
    }
  };

  return Playlist;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/Stream.js":
/*!**************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/Stream.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Data model representing a stream. Contains the URL to the stream, the bit rate or bandwidth and required codecs.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   * @type {WebAudioPlayerLogger|*}
   */
  var logger = LoggerFactory.getLogger("Stream");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the Stream function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {String} url The HLS URL for the stream.
   * @param {Array} codecs The codecs for the audio stream.
   * @param {Number} bitRate The bit rate for the audio stream.
   */
  function Stream (url, codecs, bitRate) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof Stream)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["Stream"]);
    }

    if (ObjectUtil.isUndefinedOrNull(url)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["url"]);
    }

    logger.debug("Constructor( {0}, {1} )", [bitRate, url]);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * URL for the Stream.
     * @type {String}
     */
    this.url = url;

    /**
     * Codecs for the stream.
     * @type {Array}
     */
    this.codecs = codecs || [];

    /**
     * Bit rate or bandwidth for the stream.
     *
     * The bandwidth metric (aka bit rate) in the m3u8 is in *bits per second*, so
     * 70400 bps = (70400 / 8) Bps = 8800 Bps, where "b" = bits and "B" = Bytes.
     * @type {Number}
     */
    this.bitRate = bitRate || 0;

    /**
     * String name for the stream. This is somewhat a hack as the actual bit rate is a number that's meant to
     * represent 32k, 64k, 96k, or 256k. But they don't compute to those values. Instead we're simply grabbing
     * the name of the stream from the URL. Ths isn't a greta idea, but we don't have any other great options
     * and the `name` prop is currently only used for logging purposes.
     *
     * If the name ends up being an empty string, simply grab the actual bit rate and use that.
     * @type {String}
     */
    Object.defineProperty(this, "bitRateName",
      {
        get: function () {
          var lowerCaseURL = this.url.toLowerCase();

          // TODO: BMR: Come back to this..might work fine the way it is, but not sure
          //
          //var firstIndex;
          //var secondIndex = lowerCaseURL.indexOf("_v3");
          //var counter = secondIndex;
          //
          //while(counter > 0)
          //{
          //	counter--;
          //	if(lowerCaseURL.charAt(counter) === "_")
          //	{
          //		firstIndex = counter + 1;
          //		break;
          //	}
          //}
          //
          //lowerCaseURL = lowerCaseURL.substring(firstIndex, secondIndex);
          //if(ObjectUtil.isUndefinedOrNull(lowerCaseURL) || ObjectUtil.isEmptyString(lowerCaseURL))
          //{
          lowerCaseURL = String((this.bitRate / 1000) + "k");
          //}

          return lowerCaseURL;
        }
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Stream class, we could write:
   *
   *  `BankManager.prototype = Stream.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  Stream.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: Stream
  };

  return Stream;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/model/Variant.js":
/*!***************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/model/Variant.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Data model representing a HLS variant manifest. Variant manages 0...n stream data sources. Each each stream has a
 * specific bit rate/bandwidth, Codec, and PlayList URL. The variant will manage iterate from one stream to another.
 *
 *      NOTE: The bandwidth metric (aka bit rate) in the m3u8 is in *bits per second*,
 *      so 70400 bps = (70400 / 8) Bps = 8800 Bps, where "b" = bits and "B" = Bytes.
 *
 *      70400 (64k and all the other numbers) are actually a fudge, it’s the bit rate of the stream plus an extra 10%.
 *      The HLS spec states that this is an *upper* bound on the bit rate of the stream, and the bit rate does vary
 *      slightly, so the chunker adds 10% and calls it a day, as the variation is not going to come close to exceeding
 *      the 10% fudge factor.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");

  /**
   * Internal reference to the logger.
   * @type {WebAudioPlayerLogger|*}
   */
  var logger = LoggerFactory.getLogger("Variant");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the Stream function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {String} data Raw variant data from the loaded manifest.
   * @param {Array} streams List of bit rate streams.
   * @param {String} url Original URL to the manifest.
   */
  function Variant(data, streams, url) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof Variant)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["Variant"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Raw data for the manifest.
     * @type {String}
     */
    this.data = data || null;

    /**
     * List on 0..n Stream instances
     * @see sxm.html5.model.Stream
     * @type {Array}
     */
    this.streams = this.sortStreams(streams || []);

    /**
     * URL for the variant.
     * @type {String}
     */
    this.url = url || "";

    /**
     * Index of current stream object being played by the player.
     * @type {Number}
     */
    this.currentStreamIndex = 0;

    /**
     * Read-only accessor for the number of streams for this variant.
     * @type {Number}
     */
    Object.defineProperty(this, "streamCount",
      {
        get: function () {
          return this.streams ? this.streams.length : 0;
        }
      });

    /**
     * Read-only accessor for the current stream for this variant.
     * @type {Stream}
     */
    Object.defineProperty(this, "currentStream",
      {
        get: function () {
          return this.streamCount > 0 ? this.streams[this.currentStreamIndex] : null;
        }
      });

    logger.debug("Constructor( {0}, {1} )", [this.toString(), url]);
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Max range of the available steams, is used to validate/calculate the index value of
   * next/previous stream objects.
   *
   * @type {Number}
   * @const
   */
  Variant.MAX_BIT_RATE_INDEX = 0;

  /**
   * Min range of the available steams, is used to validate/calculate the index value of
   * next/previous stream objects.
   *
   * @type {Number}
   * @const
   */
  Variant.MIN_BIT_RATE_INDEX = 0;

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Variant class, we could write:
   *
   *  `BankManager.prototype = Variant.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  Variant.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: Variant,

    /**
     * Validates the given streamIndex against the available streams count and returns the Steam object
     * available at the validated steamIndex.
     *
     * @param {Number} streamIndex The next stream index to set as current.
     * @return {Stream} Stream object available at the given streamIndex
     */
    setCurrentStreamIndex: function (streamIndex) {
      var count = this.streamCount;
      if (streamIndex < 0) {
        this.currentStreamIndex = 0;
      }
      else if (streamIndex >= count) {
        this.currentStreamIndex = count - 1;
      }
      else {
        this.currentStreamIndex = streamIndex;
      }

      var stream = this.streams[this.currentStreamIndex];

      logger.debug("setCurrentStreamIndex( stream index = {0}, name = {1} )", [
        streamIndex, stream.bitRateName
      ]);
      return stream;
    },

    /**
     * Returns the stream at the given streamIndex
     *
     * @param {Number} index number of the stream.
     * @return {Stream} Stream object available at the given index.
     */
    getStreamByIndex: function (index) {
      var stream = this.streams[index] || null;
      return stream;
    },

    /**
     * Sorts the available Steam object numerically in ascending order based on the Steam object bandwidth.
     * Calculates the values of variant MIN_BIT_RATE and MAX_BIT_RATE as well
     *
     * @param {Array} streams List of available streams.
     * @return {Array} Sorted list of streams.
     */
    sortStreams: function (streams) {
      function byAscendingQuality(s1, s2) {
        if (s1.bitRate < s2.bitRate) {
          return -1;
        }
        if (s1.bitRate > s2.bitRate) {
          return 1;
        }

        return 0;
      }

      streams = streams || [];
      streams.sort(byAscendingQuality);

      // set the min bit rate to 0 and the max to the last index for the list of streams
      Variant.MIN_BIT_RATE_INDEX = 0;
      Variant.MAX_BIT_RATE_INDEX = streams.length - 1;

      return streams;
    },

    /**
     * Read-only accessor for the current stream's bit rate.
     */
    getCurrentStreamBitRateName: function () {
      var stream = this.currentStream;
      return stream ? stream.bitRateName : null;
    },

    /**
     * Read-only accessor for the current stream's codec.
     */
    getCurrentStreamCodec: function () {
      var stream = this.currentStream;
      return (stream && stream.codecs && stream.codecs[0]) ? stream.codecs[0] : null;
    },

    /**
     * Read-only accessor for the next available stream.
     *
     * @return {Stream}
     */
    getNextStream: function () {
      var useLast = this.currentStreamIndex + 1 >= this.streams.length;
      var nextStreamIndex = useLast ? this.streams.length - 1 : this.currentStreamIndex + 1;
      return this.streams[nextStreamIndex];
    },

    /**
     * Returns the immediate higher stream index based on either the passed in index value or the current stream
     * index. This allows developers to ask what the next stream is via a specific index or simply by
     * using the default, current stream index and not supplying a specific index.
     *
     * @param {Number} [index=0] Requested index to upgrade from. Defaults to current index.
     * @return {Number} Index of the next available higher Stream object.
     */
    getUpgradeStreamIndex: function (index) {
      if (index !== 0) {
        index = index || -1;
      }

      var newStreamIndex = (index === -1) ? (this.currentStreamIndex + 1) : (index + 1);

      if (newStreamIndex > Variant.MAX_BIT_RATE_INDEX) {
        newStreamIndex = Variant.MAX_BIT_RATE_INDEX;
      }

      return newStreamIndex;
    },

    /**
     * Returns the immediate lower stream index based on either the passed in index value or the current stream
     * index. This allows developers to ask what the next stream is via a specific index or simply by
     * using the default, current stream index and not supplying a specific index.
     *
     * @param {Number} [index=0] Requested index to downgrade from. Defaults to current index.
     * @return {Number} Index of the next available lower Stream object.
     */
    getDowngradeStreamIndex: function (index) {
      if (index !== 0) {
        index = index || -1;
      }

      var newStreamIndex = (index === -1) ? (this.currentStreamIndex - 1) : (index - 1);

      if (newStreamIndex < Variant.MIN_BIT_RATE_INDEX) {
        newStreamIndex = Variant.MIN_BIT_RATE_INDEX;
      }

      return newStreamIndex;
    },

    /**
     * Creates a simple string describing the variant and it's available streams.
     *
     * @return {String}
     */
    toString: function () {
      var result = "Streams: ";

      var buildStreams = function (item) {
        result += ((item.bitRateName) + ", ");
      };

      this.streams.forEach(buildStreams);
      result = result.substring(0, result.length - 2);

      return result;
    }

  };

  return Variant;

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/ABRMonitor.js":
/*!********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/ABRMonitor.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Special class to watch and inject Adaptive Bit Rate (ABR) processes into the Player. Upgrades and downgrades
 * the player's bit rate streams based on following requirements:
 *
 *      * Upgrade up to higher bit rate:
 *          * When download rate over the last 2 chunks > 120% of the next higher bit rate.
 *              * 2 chunks is a configurable param settable by external clients in PlayerConfig and defaulted in HlsConfig.
 *              * Buffer Upgrade Mark (120%) is a configurable param settable by external clients in PlayerConfig and
 *                  defaulted in HlsConfig.
 *
 *      * Downgrade down to lower bit rate
 *          * When the current audio quality is lower than the current stream's bit rate. This means the current
 *              bit rate is not part of the audio quality's current bit rate pool.
 *          * When buffer is < 80% full and download rate of last 2 chunks is below current chunk bit rate.
 *              * 2 chunks is a configurable param settable by external clients in PlayerConfig and defaulted in HlsConfig.
 *              * Buffer High Water Mark (80%) is a configurable param settable by external clients in PlayerConfig and
 *                  defaulted in HlsConfig.
 *
 *      * Auto-Downgrade for Lower Audio Quality
 *          * Force a downgrade if the current stream is above the current audio quality pool's allowable bit rates.
 *
 *      * Auto-Downgrade for Max Audio
 *          * For the following requirements, assume the following values:
 *              * X = 12
 *              * Y = 60
 *          * While in MAX audio quality setting, there will be a “performance monitor” in place to trigger the
 *              auto-downshift to the HIGHER audio quality setting.  The initial algorithm for this monitor will be to
 *              look for >= X seconds of 0% buffer (i.e. audio silence) over a Y second window.  Simon/Ken will get us
 *              these initial {X,Y} values.  This trigger/algorithm is universal, applying to all conditions while in MAX
 *              setting – tuning, navigation (skips, scrubs, startnows, etc.), resume, continuous playback, etc.
 *          * At the point the trigger is reached (guaranteed to be at a point of silence / no audio), the
 *              auto-downshift to HIGHER within the player will take place immediately – the user device setting will also
 *              be automatically modified to the HIGHER audio quality setting (as stored in the GUP as well for this device).
 *              The player shall resume playback from the same exact point in time it left off from the last playback point
 *              while in MAX – this may require a seek within the first chunk downloaded after moving to HIGHER. Just like
 *              any other startup condition for HIGHER, the corresponding HIGHER download/ABR algorithm will be invoked,
 *              which starts at 32kbps bitrate.
 *          * Simultaneous with the auto-downshift execution in the player, a UI pop-up message shall be displayed to
 *              the user advising them of the auto-downshift.  Simon/Ken will provide details of the messaging. I believe
 *              the pop-up will be static until dismissed by the user.  [Note that the auto-downshift execution in the
 *              player occurs immediately and not on the dismissal of this pop-up by the user.]
 *          * Once it auto-downshifts to HIGHER, the user will have to manually change the audio quality setting back
 *              to MAX if desired.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
  var Variant = __webpack_require__(/*! sxm/audioplayer/html5/model/Variant */ "./javascript/src/sxm/audioplayer/html5/model/Variant.js");
  var Timer = __webpack_require__(/*! sxm/audioplayer/html5/util/Timer */ "./javascript/src/sxm/audioplayer/html5/util/Timer.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
  var Q = __webpack_require__(/*! q */ "q");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("ABRMonitor");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the ABRMonitor function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Playback} playback Reference to the playback instance this is monitoring.
   */
  function ABRMonitor(playback) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof ABRMonitor)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["ABRMonitor"]);
    }

    if (ObjectUtil.isUndefinedOrNull(playback)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Reference to the Playback instance being monitored.
     * @type {Playback}
     * @private
     */
    this._playback = playback;

    /**
     * Boolean indicating of the monitor is enabled.
     * @type {Boolean}
     */
    this.enabled = ObjectUtil.isUndefinedOrNull(playback.configuration.abrEnabled) ? true : playback.configuration.abrEnabled;

    /**
     * Chunk counter on a per bit rate stream basis. Is reset to zero when a new stream is acquired.
     * @type {Number}
     */
    this.chunkCount = 0;

    /**
     * Represents the ABR type - upgrade or downgrade. This should only be set internally.
     * @type {String}
     * @private
     */
    this.abrType = null;

    /**
     * The last chunk loaded.
     * @type {Chunk}
     * @private
     */
    this.lastChunk = null;

    /**
     * Indicates if the the playback was put into failover mode and is trying to recover. This occurs
     * when the player is forced to auto-downgrade from Max audio quality due to poor network conditions.
     * @private
     * @type {Boolean}
     */
    this.inFailoverMode = false;

    /**
     * Internal controller or reference to the controller for the feed.
     * @private
     * @type {Number}
     */
    this._bufferMonitor = null;

    /**
     * Timestamp in milliseconds that marks the last empty buffer state. It is used to determine the
     * duration of empty buffer.
     * @private
     * @type {Number}
     */
    this._lastEmptyBufferTime = null;

    /**
     * Timestamp in milliseconds to measure the TIME_FRAME_FOR_CHECKING_EMPTY_BUFFER. As a rule of auto-downgrade, we need to
     * measure the 12 seconds of 0% buffer over 60 seconds of time-frame. This timestamp
     * @private
     * @type {Number}
     */
    this._emptyBufferStartTime = null;

    /**
     * Aggregate of empty buffer duration in milliseconds. Defaulted to negative 1 and set to zero the
     * first time an empty buffer is spotted, then aggregated using the current time minus the last time.
     * @private
     * @type {Number}
     */
    this._emptyBufferDuration = -1;
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * List of upgrade types.
   */
  ABRMonitor.TYPE = {

    /**
     * Constant representing bit rate upgrade flag.
     * @constant {String}
     */
    UPGRADE: "upgradeBitRate",

    /**
     * Constant representing bit rate downgrade flag.
     * @constant {String}
     */
    DOWNGRADE: "downgradeBitRate",

    /**
     * Constant representing a forced or auto downgrade flag.
     * @constant {String}
     */
    AUTO_DOWNGRADE: "autoDowngradeBitRate"
  };

  /**
   * The interval in milliseconds for the monitor to check the buffer.
   * @const {Number}
   */
  ABRMonitor.INTERVAL = 250;

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our ABRMonitor class, we could write:
   *
   *  `BankManager.prototype = ABRMonitor.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  ABRMonitor.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: ABRMonitor,

    /**
     * Add a tail-hook (essentially intercept the promise before giving it back to the original caller) to
     * respond to the chunk load and check rules to determine if:
     *
     *      * More chunks should be pre-loaded
     *      * Streams should be upgraded, downgraded
     *
     * @param {Promise} chunkLoad Promise from chunk loader request.
     * @return {Promise} Passing back original promise from chunk loader request.
     */
    watch: function (chunkLoad) {
      /**
       * Handles the successful chunk load and determines if ABR should change bit rate streams.
       *
       * @param {Chunk} chunk The last chunk downloaded.
       * @return {*}
       */
      var onChunkLoadSuccess = function (chunk) {
        this.chunkCount++;

        if (!this.enabled) {
          logger.info("onChunkLoadSuccess( ABR Disabled )");
        }
        else {
          logger.debug("onChunkLoadSuccess( chunkCount = {0} )", [this.chunkCount]);

          // determine if ABR should upgrade or downgrade
          if (this.shouldChangeStream(chunk, this.lastChunk)) {
            this.loadNextStream(true);
          }
        }

        // save the last chunk for ABR reference
        this.lastChunk = chunk;

        return chunk;
      }.bind(this);

      var onChunkLoadFailed = function (error) {
        logger.warn("onChunkLoadFailed( Chunk failed to load. )");
        throw error;
      }.bind(this);

      if (this._playback && chunkLoad) {
        logger.info("watch()");
        return chunkLoad.then(onChunkLoadSuccess, onChunkLoadFailed);
      }

      return chunkLoad;
    },

    /**
     * Makes the ABR decision based on below UPS logic and determines if the bit rate has to be
     * upgraded, downgraded, or continue with the same bit rate.
     *
     * Do not even check for ABR requirements if the minimum number of chunks hasn't been downloaded yet,
     * and simply stay at the current, lowest bit rate.
     *
     * @param {Chunk} chunk - Current chunk loaded.
     * @param {Chunk} lastChunk - Last chunk loaded.
     * @return {Boolean} Boolean flag indicating if the stream should be upgraded or downgraded.
     */
    shouldChangeStream: function (chunk, lastChunk) {
      logger.info("shouldChangeStream( chunk = {0}, lastChunk = {1} )", [
        (chunk ? chunk.fileName : ""), (lastChunk ? lastChunk.fileName : "")
      ]);

      // Don't even bother checking for normal ABR up/downgrades if in Max Audio and we need to
      // downgrade due to a zero buffer for long enough
      if (this.shouldDownGradeFromMax()) {
        // do not load the next stream since the outter method already handles this
        this.downgradeFromMax(false);
        return true;
      }

      var validVariant = this._playback && this._playback.variant;
      var minChunksDownloaded = (this.chunkCount >= HlsConfig.PRELOAD_DEFAULT_CHUNKS);

      if (lastChunk && chunk && validVariant && minChunksDownloaded) {
        this.activateBufferMonitor(true);

        // NOTE: These are order specific cases:
        // 1) Force a downgrade if the current stream is above the current audio quality pool's allowable bit rates
        // 2) Eagerly try to upgrade
        // 3) If we don't need to force a downgrade and can't upgrade check for bad network and possibly downgrade

        // FORCE DOWNGRADE
        if (this.shouldDowngradeForAudioQuality()) {
          this.abrType = ABRMonitor.TYPE.AUTO_DOWNGRADE;
          logger.debug("shouldChangeStream( {0} )", [this.abrType]);
          return true;
        }
        // UPGRADE
        else if (this.shouldUpgrade(chunk, lastChunk)) {
          this.abrType = ABRMonitor.TYPE.UPGRADE;
          logger.debug("shouldChangeStream( {0} )", [this.abrType]);
          return true;
        }
        // DOWNGRADE
        else if (this.shouldDowngrade(chunk, lastChunk)) {
          this.abrType = ABRMonitor.TYPE.DOWNGRADE;
          logger.debug("shouldChangeStream( {0} )", [this.abrType]);
          return true;
        }
        else {
          logger.debug("shouldChangeStream( Stay at current stream. )");
        }

      }
      else {
        logger.debug("shouldChangeStream( Don't do anything: no variant or not enough chunks downloaded. )");
        return false;
      }
    },

    /**
     * Force a downgrade from the max audio quality stream when it's not playing smoothly.
     *
     * @return {Boolean} Flag indicating if the stream should be downgraded based on the audio quality setting.
     */
    shouldDownGradeFromMax: function () {
      var bool = false;
      var current = null;
      var windowTime = null;

      if (this._playback && this._playback.audioQualityMonitor.isMax() && this._emptyBufferStartTime) {
        current = new Date();
        windowTime = current.getTime() - this._emptyBufferStartTime;
        var withinEmptyBufferWindow = windowTime < HlsConfig.TIME_FRAME_FOR_CHECKING_EMPTY_BUFFER;
        var emptyBufferTimeMaxed = this._emptyBufferDuration >= HlsConfig.EMPTY_BUFFER_TIME_LIMIT_FOR_ABR;

        if (emptyBufferTimeMaxed && withinEmptyBufferWindow) {
          logger.debug("shouldDownGradeFromMax( Yes, emptyBufferDuration = {0}, windowTime = {1} )", [
            this._emptyBufferDuration, windowTime
          ]);
          bool = true;
        }
      }

      return bool;
    },

    /**
     * Force a downgrade when the current stream is not playable with the current audio quality.
     *
     * @return {Boolean} Flag indicating if the stream should be downgraded based on the audio quality setting.
     */
    shouldDowngradeForAudioQuality: function () {
      var bool = false;

      if (this._playback && this._playback.variant && this._playback.audioQualityMonitor && this.enabled) {
        var stream = this._playback.variant.currentStream;
        var isStreamPlayable = this._playback.audioQualityMonitor.isStreamPlayable(stream);
        bool = !isStreamPlayable;
        logger.info("shouldDowngradeForAudioQuality( {0} )", [bool ? "Yes" : "No"]);

        return bool;
      }

      logger.debug("shouldDowngradeForAudioQuality( No playback, variant, no audio quality monitor, or ABR disabled. )");
      return bool;
    },

    /**
     * Upgrade to higher bit rate when download rate over the last 2 chunks > 120% of the next higher bit rate.
     *
     * @param {Chunk} chunk - The last chunk's download statistics.
     * @param {Chunk} lastChunk - The second to last chunk's download statistics.
     * @return {Boolean} Flag indicating if the stream should be upgraded.
     */
    shouldUpgrade: function (chunk, lastChunk) {
      var bool = false;
      var validVariant = this._playback && this._playback.variant;

      if (lastChunk && chunk && validVariant && this.enabled) {
        var nextStream = this._playback.variant.getNextStream();
        var nextStreamBytesPerMillisecond = this.convertBitsToBytes(nextStream.bitRate) / 1000;
        var lastChunkBitRatePercent = this.getBitRatePercentOfNext(chunk.bytesPerMilliseconds, nextStreamBytesPerMillisecond);
        var secondLastChunkBitRateUpPercent = this.getBitRatePercentOfNext(lastChunk.bytesPerMilliseconds,
          nextStreamBytesPerMillisecond);

        bool = (lastChunkBitRatePercent > HlsConfig.BIT_RATE_UPGRADE_THRESHOLD) &&
          (secondLastChunkBitRateUpPercent > HlsConfig.BIT_RATE_UPGRADE_THRESHOLD);

        logger.debug(
          "shouldUpgrade( lastChunkBitRate = {0}kbs, nextStreamBitRate = {1}k, lastChunkBitRate % of nextStreamBitRate = {2}% )", [
            chunk.bytesPerMilliseconds, nextStreamBytesPerMillisecond, lastChunkBitRatePercent
          ]);
        logger.debug(
          "shouldUpgrade( secondLastChunkBitRate = {0}kbs, nextStreamBitRate = {1}k, secondLastChunkBitRate % of nextStreamBitRate = {2}% )", [
            lastChunk.bytesPerMilliseconds, nextStreamBytesPerMillisecond,
            secondLastChunkBitRateUpPercent
          ]);
        logger.info("shouldUpgrade( {0} )", [bool ? "Yes" : "No"]);

        return bool;
      }

      logger.debug("shouldUpgrade( No playback, variant, or ABR disabled. )");
      return bool;
    },

    /**
     * Downgrade to lower bit rate when buffer is < 80% full and download rate of last 2 chunks is below
     * current chunk bit rate.
     *
     * @param {Chunk} chunk - The last chunk's download statistics.
     * @param {Chunk} lastChunk - The second to last chunk's download statistics.
     * @return {Boolean} Flag indicating if the stream should be downgraded.
     */
    shouldDowngrade: function (chunk, lastChunk) {
      var bool = false;
      var validVariant = this._playback && this._playback.variant;

      if (lastChunk && chunk && validVariant && this.enabled) {
        var currentStream = this._playback.variant.currentStream;
        var currentStreamBytesPerMillisecond = this.convertBitsToBytes(currentStream.bitRate) / 1000;
        var isBufferPercentDowngradable = this._playback.bufferPercent < HlsConfig.BIT_RATE_DOWNGRADE_THRESHOLD;
        var isLastChunkDowngradable = chunk.bytesPerMilliseconds < currentStreamBytesPerMillisecond;
        var isSecondLastChunkDowngradable = lastChunk.bytesPerMilliseconds < currentStreamBytesPerMillisecond;

        bool = isBufferPercentDowngradable && isLastChunkDowngradable && isSecondLastChunkDowngradable;

        logger.debug("shouldDowngrade( bufferPercent = {0}, buffer threshold = {1} )", [
          this._playback.bufferPercent, HlsConfig.BIT_RATE_DOWNGRADE_THRESHOLD
        ]);
        logger.debug("shouldDowngrade( lastChunkBitRate = {0}kbs, currentStreamBitRate = {1}k )", [
          chunk.bytesPerMilliseconds, currentStreamBytesPerMillisecond
        ]);
        logger.debug("shouldDowngrade( secondLastChunkBitRate = {0}kbs, currentStreamBitRate = {1}k )", [
          lastChunk.bytesPerMilliseconds, currentStreamBytesPerMillisecond
        ]);
        logger.info("shouldDowngrade( {0} )", [bool ? "Yes" : "No"]);

        // determine if the thresholds are met to downgrade the stream
        return bool;
      }

      logger.debug("shouldDowngrade( No playback, variant, or ABR disabled. )");
      return bool;
    },

    /**
     * Loads the next bit rate stream based on the ABR decision.
     * Resets the chunk counter if bit rate up/downgrade happens.
     *
     * @param {Boolean} [reset] - Flag to determine if the chunk counter has to be reset to 0
     * @return {Promise}
     */
    loadNextStream: function (reset) {
      reset = ObjectUtil.isUndefinedOrNull(reset) ? true : reset;

      // NOTE: MySXM playback `may not` have a variant
      if (this._playback && this._playback.variant && this.enabled) {
        var variant = this._playback.variant;
        var newStreamIndex = this.getNewStreamIndex();

        // don't bother changing streams if the requested stream is the same as the current one
        if (newStreamIndex !== variant.currentStreamIndex) {
          // reset the last chunk and counter info as we're changing streams with different bit rates
          if (reset) {
            this.lastChunk = null;
            this.chunkCount = 0;
          }

          var nextStream = variant.getStreamByIndex(newStreamIndex);

          logger.debug("loadNextStream( bitRate = {0} )", [nextStream.bitRate]);
          return this._playback.loadStreamAt(newStreamIndex);
        }
      }

      return Q.when(this);
    },

    /**
     * Provides the stream index based on the current ABR type.
     * @return {Number} The new stream index based on the ABR action of upgrade, downgrade, or auto-downgrade.
     */
    getNewStreamIndex: function () {
      var streamIndex = -1;

      if (this._playback.variant) {
        var variant = this._playback.variant;
        streamIndex = variant.currentStreamIndex;

        switch (this.abrType) {
          case ABRMonitor.TYPE.UPGRADE:
            streamIndex = variant.getUpgradeStreamIndex();
            break;

          case ABRMonitor.TYPE.DOWNGRADE:
            streamIndex = variant.getDowngradeStreamIndex();
            break;

          case ABRMonitor.TYPE.AUTO_DOWNGRADE:

            // TODO: BMR: Consider broadcasting an event
            // announcing the auto-downgrade to minimum bit rate stream event
            //announceStatus(PlayerEvent.BIT_RATE_AUTO_DOWNGRADE);

            streamIndex = Variant.MIN_BIT_RATE_INDEX;
            break;

          default:
            // Does nothing so the bit rate remains the same
            logger.debug("getNewStreamIndex( No change in bit rate )");
        }
      }

      return streamIndex;
    },

    /**
     * Starts the buffer monitor.
     *
     * @param {Boolean} activate - Flag indicating if the buffer monitor should be created or destroyed.
     */
    activateBufferMonitor: function (activate) {
      activate = ObjectUtil.isUndefinedOrNull(activate) ? false : activate;
      var isMax = this._playback.audioQualityMonitor.isMax();

      if (activate && isMax && ObjectUtil.isNull(this._bufferMonitor)) {
        logger.debug("activateBufferMonitor( Start monitoring the buffer. )");
        this._bufferMonitor = new Timer(ABRMonitor.INTERVAL, this.onCheckBuffer.bind(this));
        this._bufferMonitor.start();
      }
      else if (!activate && this._bufferMonitor) {
        logger.debug("deactivateBufferMonitor( Stop monitoring the buffer. )");

        this._bufferMonitor.stop();
        this._bufferMonitor = null;

        this._emptyBufferDuration = -1;
        this._lastEmptyBufferTime = null;
        this._emptyBufferStartTime = null;
      }
    },

    /**
     * Sets the proper flags to instruct the monitor to force a downgrade from Max.
     *
     * If we need to load the next stream we need to 2 things:
     *
     *  1) Abort all current loads so we don't get ia chunk back when trying to a new one as this
     *  could potentially mix the order of chunks consumed.
     *  2) Set the player into failover mode so it tries to load the failed chunk again -- if we
     *  are telling the player to downgrade from max audio it was because there was zero buffer
     *  for too long and the current chunk didn't load...this meakes sure we do load it when
     *  we perform the downgrade.
     *
     * @param {Boolean} [loadStream] - Indicates if load next stream should also be executed. If
     * this method is called during normal ABR chunk loads then load stream is called already...but
     * if this is called during a buffer outtage, outside the scope of ABR checking, then we need
     * to manually call load next stream.
     */
    downgradeFromMax: function (loadStream) {
      this.activateBufferMonitor(false);
      this.abrType = ABRMonitor.TYPE.AUTO_DOWNGRADE;
      logger.info("downgradeFromMax( {0}, loadStream = {1} )", [this.abrType, loadStream]);

      if (loadStream) {
        // make sure the feed monitor thinks the load we're aborting is "finished", which sets its
        // internal loading flag to false so we can start loaing again
        this._playback.feedMonitor.finishLoad();

        // abort the current chunk load and set the monitor into failover mode so the proper
        // chunk is loaded next in the sequence -- if we're aborting the load of chunk index = 3,
        // then we need to load that failed chunk index 3.
        this._playback.chunkProducer.abort();
        this.inFailoverMode = true;
        this.loadNextStream(true);
      }
    },

    /**
     * Monitors the buffer and aggregates zero buffer durations within a given window. This value is then
     * used later to determine if the buffer has been out (and thus no audio) for X seconds (continuously
     * and non-continuously) under Y seconds window -- if yes, then we force an auto downrgade from
     * max audio.
     */
    onCheckBuffer: function () {
      if (this._playback) {
        var buffer = Math.round(this._playback.bufferTime);
        var currentTime = new Date().getTime();

        var aggregateEmptyBufferDuration = function () {
          this._emptyBufferDuration += (currentTime - this._lastEmptyBufferTime);

        }.bind(this);

        if (buffer <= 0) {
          // add up the amount of time the buffer has been empty in milliseconds
          if (ObjectUtil.isUndefinedOrNull(this._lastEmptyBufferTime)) {
            this._emptyBufferDuration = 0;
            this._emptyBufferStartTime = currentTime;
          }
          else {
            aggregateEmptyBufferDuration();
          }

          // update the last empty buffer timestamp so we can aggregate it next time
          this._lastEmptyBufferTime = currentTime;
        }

        // determine if the player should downgrade from max...if so, force the load of the next stream
        // since this path doesn't do so
        if (this.shouldDownGradeFromMax()) {
          this.downgradeFromMax(true);
        }
      }

      // NOTE: Keep this commented out since it fires all the time
      //logger.debug("onCheckBuffer( Empty buffer for {0} seconds. )", [this._emptyBufferDuration / 1000]);
    },

    /**
     * Converts bits to Bytes.
     *
     * @param {Number} bitRate - bit rate to convert to Bytes.
     * @return {Number} Bytes.
     */
    convertBitsToBytes: function (bitRate) {
      return Math.round(bitRate / 8);
    },

    /**
     * Calculates the percentage of one bit rate to another.
     *
     * @param {Number} bitRate0
     * @param {Number} bitRate1
     * @return {Number}
     */
    getBitRatePercentOfNext: function (bitRate0, bitRate1) {
      return Math.round((bitRate0 / bitRate1) * 100);
    },

    /**
     * Resets the monitor.
     */
    reset: function () {
      logger.debug("reset()");

      this.activateBufferMonitor(false);

      this.lastChunk = null;
      this.chunkCount = 0;
      this.abrType = null;
      this.inFailoverMode = false;
      this._playback = null;
    }
  };

  return ABRMonitor;

}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/AudioQualityMonitor.js":
/*!*****************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/AudioQualityMonitor.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/25/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Special class to watch changes to the player's configuration, specifically for audio quality changes.
 *      Also provides methods to determine if a stream is playable based on teh current audio quality setting.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("AudioQualityMonitor");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the AudioQualityMonitor function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Playback} playback Reference to the playback instance this is monitoring.
   */
  function AudioQualityMonitor(playback) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof AudioQualityMonitor)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["AudioQualityMonitor"]);
    }

    if (ObjectUtil.isUndefinedOrNull(playback)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Reference to the Playback instance being monitored.
     * @private
     * @type {Playback}
     */
    this._playback = playback;

    /**
     * Boolean indicating of the monitor is enabled. Defaults to true.
     * @type {Boolean}
     */
    this.enabled = ObjectUtil.isUndefinedOrNull(playback.configuration.audioQualityEnabled) ? true : playback.configuration.audioQualityEnabled;

    /**
     * Current audio quality based on the player's config object.
     * @type {String}
     */
    this.audioQuality = this.getAudioQuality(this._playback.configuration);

    /**
     * Reference to the watcher function on the Playback's config object. Allows the watch reference
     * to be removed when resetting the monitor.
     * @private
     * @type {Function}
     */
    this._configChangeHandler = ObjectUtil.noop;

    // initialize the monitor
    this.init();
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * List of audio quality types.
   * @type {String}
   */
  AudioQualityMonitor.TYPE = {

    /**
     * Constant representing the `normal` audio quality.
     */
    NORMAL:
      {
        name: "normal",
        value: 0
      },

    /**
     * Constant representing the `high` audio quality.
     */
    HIGH:
      {
        name: "high",
        value: 1
      },

    /**
     * Constant representing the `max` audio quality.
     */
    MAX:
      {
        name: "max",
        value: 2
      }
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our AudioQualityMonitor class, we could write:
   *
   *    `BankManager.prototype = AudioQualityMonitor.prototype`
   *    `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  AudioQualityMonitor.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: AudioQualityMonitor,

    /**
     * Initializes the object
     *
     * Sets up watchers on the configuration.
     */
    init: function () {
      logger.debug("init()");

      /**
       * Handles the change of the player's configuration object and sets the current audio quality.
       *
       * @param {String} prop Property that changed.
       * @param {*} newValue The new value for the changed property.
       * @param {*} oldValue The old value for the changed property.
       */
      var onConfigChange = function (newValue, oldValue, prop) {
        logger.debug("onConfigChange( prop = {0}, newValue = {1}, oldValue = {2} )", [
          prop, String(newValue), String(oldValue)
        ]);

        this.audioQuality = this.getAudioQuality(this._playback.configuration);
      }.bind(this);

      // Save a reference to the watch function so it can be removed later.
      this._configChangeHandler = onConfigChange;

      // The change detection in ClassUtil.observeProperty() cannot handle undefined properties, so default them.
      if (ObjectUtil.isUndefined(this._playback.configuration.higherQualityAudio)) {
        this._playback.configuration.higherQualityAudio = false;
      }
      if (ObjectUtil.isUndefined(this._playback.configuration.maxQualityAudio)) {
        this._playback.configuration.maxQualityAudio = false;
      }

      ClassUtil.observeProperty(this._playback.configuration, "higherQualityAudio", onConfigChange, true);
      ClassUtil.observeProperty(this._playback.configuration, "maxQualityAudio", onConfigChange, true);
    },

    /**
     * Returns a string value for the current audio quality.
     *
     * @param {Configuration} config - The player's configuration object.
     * @return {String} The current audio quality set in the configuration object.
     */
    getAudioQuality: function (config) {
      var quality = AudioQualityMonitor.TYPE.NORMAL;

      if (config) {
        if (config.maxQualityAudio) {
          quality = AudioQualityMonitor.TYPE.MAX;
        }
        else if (config.higherQualityAudio) {
          quality = AudioQualityMonitor.TYPE.HIGH;
        }
        else {
          quality = AudioQualityMonitor.TYPE.NORMAL;
        }

        // Commented out since this is called quite a bit
        //logger.debug("getAudioQuality( {0} )", [quality.name]);
      }

      return quality;
    },

    /**
     * Indicates if the current audio quality is Max.
     * @returns {Boolean}
     */
    isMax: function () {
      var quality = this.getAudioQuality(this._playback.configuration);
      return (quality === AudioQualityMonitor.TYPE.MAX);
    },

    /**
     * Indicates if the current audio quality is High.
     * @returns {Boolean}
     */
    isHigh: function () {
      var quality = this.getAudioQuality(this._playback.configuration);
      return (quality === AudioQualityMonitor.TYPE.HIGH);
    },

    /**
     * Indicates if the current audio quality is Normal.
     * @returns {Boolean}
     */
    isNormal: function () {
      var quality = this.getAudioQuality(this._playback.configuration);
      return (quality === AudioQualityMonitor.TYPE.NORMAL);
    },

    /**
     * Determines if the requested stream is playable by comparing it's bit rate with the acceptable and
     * configured bit rates for this player.
     *
     * Default to a stream being playable.
     *
     * @param {Stream} stream - The requested stream.
     * @return {Boolean} Boolean indicating if this stream is playable.
     */
    isStreamPlayable: function (stream) {
      var bool = true;
      var maxBitRate;
      var quality;

      if (this.enabled) {
        quality = this.getAudioQuality(this._playback.configuration);

        if (this.isMax()) {
          bool = true;
        }
        else if (this.isHigh()) {
          maxBitRate = HlsConfig.BIT_RATE_MAX;
          bool = (stream.bitRate < HlsConfig.BIT_RATE_MAX);
        }
        else {
          maxBitRate = HlsConfig.BIT_RATE_HIGHER_QUALITY;
          bool = (stream.bitRate < HlsConfig.BIT_RATE_HIGHER_QUALITY);
        }

        // NOTE: Simple debug logging.
        if (!bool) {
          logger.info(
            "isStreamPlayable( No, cannot load stream `{0}` with bit rate `{1}` greater than max bit rate of `{2}` " +
            "as the quality is only `{3}` )", [
              stream.bitRateName, stream.bitRate, maxBitRate, quality.name
            ]);
        }
        else {
          logger.debug(
            "isStreamPlayable( Yes, load stream `{0}` with bit rate `{1}` less than max bit rate of `{2}` " +
            "as the quality is only `{3}` )", [
              stream.bitRateName, stream.bitRate, maxBitRate, quality.name
            ]);
        }
      }

      return bool;
    },

    /**
     * Resets the monitor.
     */
    reset: function () {
      logger.debug("reset()");

      ClassUtil.unobserveProperty(this._playback.configuration, "higherQualityAudio", this._configChangeHandler);
      ClassUtil.unobserveProperty(this._playback.configuration, "maxQualityAudio", this._configChangeHandler);
      this._playback = null;
      this.audioQuality = null;
    }
  };

  return AudioQualityMonitor;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/FailoverMonitor.js":
/*!*************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/FailoverMonitor.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Monitors the loading and usage of an asset for failures. If the asset fails in any way, the failover monitor
 *      fails over to the next available server for playback (if there are multiple origin servers) or applies
 *      ABR failover (failover to the next available stream) if there's only 1 origin server.
 *
 *      Failover always attempts to load the failed chunk (for failed chunk assets) or the next chunk after the last
 *      chunk loaded (in the case of a failed manifest load) or when all else fails play from the live point for
 *      Live or chunk 0 for AOD & MySXM.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var Manifest = __webpack_require__(/*! sxm/audioplayer/html5/model/Manifest */ "./javascript/src/sxm/audioplayer/html5/model/Manifest.js");
    var AssetType = __webpack_require__(/*! sxm/audioplayer/html5/model/AssetType */ "./javascript/src/sxm/audioplayer/html5/model/AssetType.js");
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
    var PlayerEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/PlayerEvent */ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js");
    var PlaybackTypeUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaybackTypeUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
    var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");
    var Q = __webpack_require__(/*! q */ "q");

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the FailoverMonitor function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @constructor
     * @param {Playback} playback - Reference to the playback instance this is monitoring.
     * @param {String} type - Reference to the loading being monitored for failures.
     */
    function FailoverMonitor(playback, type) {
      // This first guard ensures that the callee has invoked our Class' constructor function
      // with the `new` keyword - failure to do this will result in the `this` keyword referring
      // to the callee's scope (typically the window global) which will result in the following fields
      // (name and _age) leaking into the global namespace and not being set on this object.
      if (!(this instanceof FailoverMonitor)) {
        throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["FailoverMonitor"]);
      }

      if (ObjectUtil.isUndefinedOrNull(playback)) {
        throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
      }

      if (ObjectUtil.isUndefinedOrNull(type)) {
        throw new PlayerError(PlayerError.REQUIRED_PARAM, ["type"]);
      }

      // NOTE: Unlike loggers in other classes, this one is an class instance member so we can keep
      // track of instances with a type.
      type = ((type !== AssetType.MANIFEST) && (type !== AssetType.CHUNK)) ? "unknown" : type;
      this.logger = LoggerFactory.getLogger(StringUtil.supplant("FailoverMonitor[{0}]", [type]));

      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------

      /**
       * Reference to the Playback instance being monitored.
       * @private
       * @type {Playback}
       */
      this._playback = playback;

      /**
       * The type of asset for this loader, typically "manifest" or "chunk".
       * @type {String}
       * @private
       */
      this._type = type;

      /**
       * Boolean indicating of the monitor is enabled. Defaults to true.
       * @type {Boolean}
       */
      this.enabled = ObjectUtil.isUndefinedOrNull(playback.configuration.failoverEnabled) ? true : playback.configuration.failoverEnabled;

      /**
       * Indicates if the the playback was put into failover mode and is trying to recover.
       * @type {Boolean}
       */
      this.inFailoverMode = false;

      /**
       * Error object for a failed asset.
       * @type {AssetError}
       */
      this.assetError = false;

      /**
       * List of failed stream indexes.
       * @type {Array}
       */
      this.failedStreamIndexes = [];

      /**
       * Flag indicating of this is monitoring chunks.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isManifestType",
        {
          get: function () {
            return (this._type === AssetType.MANIFEST);
          }
        });

      /**
       * Flag indicating of this is monitoring chunks.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isChunkType",
        {
          get: function () {
            return (this._type === AssetType.CHUNK);
          }
        });
    };

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our FailoverMonitor class, we could write:
     *
     *  `BankManager.prototype = FailoverMonitor.prototype`
     *  `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    FailoverMonitor.prototype = {

      /**
       * Whenever you replace an Object's Prototype, you need to repoint
       * the base Constructor back at the original constructor Function,
       * otherwise `instanceof` calls will fail.
       */
      constructor: FailoverMonitor,

      /**
       * Add a tail-hook (essentially intercept the promise before giving it back to the original caller) to
       * to watch the promise returned for loading assets (manifests, both variants and playlists) and
       * chunks and apply failover for rejected promises.
       *
       * @param {Promise} assetPromise - Promise from asset loader request.
       * @return {Promise} Passing back original promise from asset loader request.
       */
      watch: function (assetPromise) {
        if (this.enabled) {
          /**
           * Handles the successful asset load and simply returns the original promise.
           *
           * @param {*} asset - The last asset downloaded.
           * @return {*} The loaded asset.
           */
          var onAssetLoadSuccess = function (asset) {
            this.logger.debug("onAssetLoadSuccess( Asset load and consumption successful so do nothing. )");
            return asset;
          }.bind(this);

          /**
           * Handles the failed asset load and applies failover.
           *
           * @param {AssetError} error - The asset error -- could be a load error or even chunk decode issue..
           * @throw {AssetError}
           */
          var onAssetLoadFailed = function (error) {
            this.logger.warn("onAssetLoadFailed( {0} failed to load. )", [this._type]);

            this.assetError = error;
            return this.failover(error);
          }.bind(this);

          if (this._playback && assetPromise) {
            this.logger.info("watch( Intercepting load promise and determining if success or failure... )");
            return assetPromise.then(onAssetLoadSuccess, onAssetLoadFailed);
          }
          else {
            this.logger.info("watch( Cannot watch as either `playback` or the promise are null. )");
          }
        }

        return assetPromise;
      },

      /**
       * Handles the failover of the current asset by either using ABR to try another stream or looking to the next
       * server origin.
       * @param {AssetError} error - The asset error -- could be a load error or even chunk decode issue..
       */
      failover: function (error) {
        if (this._playback) {
          this.logger.warn("failover()");

          // if there's only 1 origin server, then apply ABR failover logic before ultimately failing over to restart
          if (this.shouldUseABR()) {
            // it's possible that we want to apply ABR failover but the item that failed is the first variant
            // so in that specific case we'll flag that we are restarting
            // TODO: BMR: We actually might want a new event to specifically say "FAILOVER_LOAD_NEXT_TRACK" for MySXM
            if (ObjectUtil.isUndefinedOrNull(this._playback.variant)) {
              this.logger.warn("failover( Restarting player `{0}` as there is no variant and thus no streams. )", [
                this._playback.id
              ]);

              this.restart();
              return Q.reject(error);
            }
            else {
              return this.failoverUsingABR(error);
            }
          }
          // else try starting audio playback from the next available origin server
          else {
            return this.failoverToNextServer(error);
          }
        }
        else {
          this.logger.warn(
            "failover( Not applying failover as playback is null...most likely stopped mid-async process )");
        }
      },

      /**
       * Handles the failover of the current asset by looking to the next server origin. The player will
       * either attempt to continue playback by preloading or playing depending on it's current state
       * using the failed chunk's timestamp or the next chunk or the live time.
       *
       * Dispatches a "FAILOVER" event to alert external clients.
       *
       * If all failover attempts have failed, restart the player.
       *
       * @param {AssetError} error - The asset error -- could be a load error or even chunk decode issue.
       */
      failoverToNextServer: function (error) {
        if (this._playback) {
          // shortcut to the audio data
          var audio = this._playback.configuration.audio;

          // grab the next server origin to `failover` to
          var nextUrl = audio.getNextAudioUrl(this._playback.currentUrl, Manifest.LARGE);

          if (nextUrl) {
            // if a chunk failed to load then we need to grab it's timestamp so we can skip to it when playback
            // resumes after failover -- aka we can look up the next chunk index in the playlist by this timestamp
            var failedChunkTimestamp = this.getFailedChunkTimestamp();

            // we use the time in several places below so we need to account for a null failed chunk timestamp
            // and default to 0 or we'll get NullPointerExceptions
            var time = failedChunkTimestamp ? failedChunkTimestamp.getTime() : 0;

            // set the state to failover mode
            this.announceFailover();

            this.logger.warn("failoverToNextServer( Loading asset from next origin server `{0}` using start time = {1}, {2} )", [
              nextUrl, failedChunkTimestamp, time
            ]);

            // perform failover by playing or preloading the next server's HLS URL with the failed chunk's timestamp
            // NOTE: Due to the way playback flow works we don't even need to pass the timestamp...when the
            // next chunk goes to load it'll look at the current index of the playlist which hasn't changed
            // as we haven't allowed another chunk load since the failed one
            if (this._playback.isPreloading) {
              this._playback.configuration.startTime = String(time);
              return this._playback.preload(nextUrl, this._playback.configuration);
            }
            else {
              return this._playback.play(nextUrl, time);
            }
          }
          else {
            this.restart();
            return Q.reject(error);
          }
        }
      },

      /**
       * Handles the failover of the current asset by loading the next stream starting at the lowest bit rate and
       * continuing to try playback for each stream by upgrading.
       *
       * If ABR was used and upgraded to a stream that has issues -- bad playlist or bad -- then failover to the last
       * successfully played stream and turn off ABR so this doesn't happen again; simply stay at the working
       * stream and allow the rest of ABR failover to work as expected.
       *
       * Dispatches a "FAILOVER" event to alert external clients.
       *
       * If all ABR attempts have failed, restart the player.
       *
       * @param {AssetError} error - The asset error -- could be a load error or even chunk decode issue.
       */
      failoverUsingABR: function (error) {
        this.logger.warn("failoverUsingABR()");

        var variant = this._playback.variant;

        var performFailover = function (streamIndex) {
          if (variant.currentStreamIndex > streamIndex) {
            this._playback.configuration.abrEnabled = false;
            this.logger.warn("performFailover( Using bit rate with index `{0}`. Disabling ABR. )", [streamIndex]);
          }

          // if a chunk failed to load then we need to grab it's timestamp so we can skip to it when playback
          // resumes after failover -- aka we can look up the failed chunk index in the new playlist with this timestamp
          var failedChunkTimestamp = this.getFailedChunkTimestamp();

          // set the state to failover mode
          this.announceFailover();

          // perform failover by loading the next bit rate stream
          return this._playback.loadStreamAt(streamIndex, failedChunkTimestamp);
        }.bind(this);

        var getFailoverStreamIndex = function () {
          var streamIndex = -1;

          while (++streamIndex < variant.streamCount) {
            if (isStreamIndexPlayable(streamIndex)) {
              this.logger.info("getFailoverStreamIndex( Trying failover with stream index = {0}. )", [
                streamIndex
              ]);
              return streamIndex;
            }
          }

          this.logger.info("getFailoverStreamIndex( No playable stream indexes so returning NaN. )");
          return NaN;
        }.bind(this);

        var isStreamIndexValid = function (index) {
          return (index > -1) && (index !== variant.currentStreamIndex);
        }.bind(this);

        var isStreamIndexPlayable = function (index) {
          var stream = variant.getStreamByIndex(index);
          var isStreamPlayable = this._playback.audioQualityMonitor.isStreamPlayable(stream);
          var isPlayable = isStreamIndexValid(index) && isStreamPlayable;
          var isFailedStreamIndex = (this.failedStreamIndexes.indexOf(index) !== -1);
          isPlayable = isPlayable && !isFailedStreamIndex;

          // TODO: BMR: This may not be valid if SXM owns the My chunks...leaving this here for review later
          //if (isPlayable && (index == Variant.MIN_BIT_RATE))
          //{
          //	isPlayable = !variant.isMinBitRateDisabled;
          //}

          this.logger.info("isStreamPlayable( {0}, stream `{1}` is {2} to go. )", [
            (isPlayable ? "Yes" : "No"), stream.bitRateName, (isPlayable ? "good" : "NOT good")
          ]);
          return isPlayable;
        }.bind(this);

        // add the failed stream index to the list so we don't try to failover to it again
        this.failedStreamIndexes.push(variant.currentStreamIndex);

        // determine the stream index to play
        var streamIndex = getFailoverStreamIndex();
        var stream = variant.getStreamByIndex(streamIndex);

        if (isStreamIndexValid(streamIndex)) {
          this.logger.warn("failoverUsingABR( Loading next stream index `{0}`, name = {1} for player `{2}`. )", [
            streamIndex, stream.bitRateName, this._playback.id
          ]);

          return performFailover(streamIndex);
        }
        else {
          this.logger.warn("failoverUsingABR( exhausted `{0}`. )", [
            this._playback.id
          ]);

          if (PlaybackTypeUtil.isPlayerMySXM(this._playback)) {
            this.trackFailed();
          }
          else {
            this.restart();
          }

          return Q.reject(error);
        }
      },

      /**
       * Sets the internal state to indicate the player is in failover mode and announce the state
       * with an event.
       */
      announceFailover: function () {
        this.logger.debug("announceFailover()");

        // save state indicating we're in failover or recovery mode
        this.inFailoverMode = true;

        // this will make sure to reset the PlaylistMonitor state, so that we will monitor the `nextUrl` ( new origin/ ABR url) as new playlist
        this._playback.playlistMonitor.resetLocalState();
        
        // announce the failover
        this._playback.dispatchPlayerEvent(PlayerEvent.FAILOVER);
      },

      /**
       * All failover attempts have failed, so restart the player. The player simply calls stop on itself
       * and alerts external clients that it needs to restart. The actual restart (calling play or preload)
       * is executed by the client using the audio player.
       *
       * Dispatches a "RESTART" event to alert external clients.
       */
      restart: function () {
        this.logger.warn("restart( Restarting player as all failover servers have been exhausted. )");

        // it's possible that the restart event triggers the client to call stop before this is hit
        // which means there is no playback object.
        if (this._playback) {
          this.reset(false);
          this._playback.dispatchPlayerEvent(PlayerEvent.RESTART);

          // NOTE: Unlike the AS3 flash audio player DO NOT call stop on the playback;
          // here we let the HTML5AudioPlayer handle the "restart" event and stop all
          // playback instances to ensure proper cleanup.
        }
      },

      /**
       * All failover attempts have failed for track
       * and alerts external clients that it needs to take action.
       * is executed by the client using the audio player.
       *
       * Dispatches a "TRACK_FAILED" event to alert external clients.
       */
      trackFailed: function () {
        // it's possible that the restart event triggers the client to call stop before this is hit
        // which means there is no playback object.
        if (this._playback) {
          if (this._playback.isPlaying) {
            this.reset(false);
            this._playback.dispatchPlayerEvent(PlayerEvent.TRACK_FAILED);
          }
        }
      },

      /**
       * Determines if ABR failover should be used. If the playback type is MySXM or has less than or equal to
       * 1 origin server, then use ABR failover.
       *
       * Default to false.
       *
       * @return {Boolean}
       */
      shouldUseABR: function () {
        var bool = false;
        var audio = this._playback.configuration.audio;
        if (audio && (audio.numServers <= 1)) {
          bool = true;
        }
        this.logger.info("shouldUseABR( {0}. Number of servers = {1} )", [
          (bool ? "Yes" : "No"), audio.numServers
        ]);

        return bool;
      },

      /**
       * Determine the date for a failed chunk, or last successfully loaded chunk plus its duration if a manifest
       * load failed. This is used for all playback types.
       *
       * @return {Date}
       */
      getFailedChunkTimestamp: function () {
        var failedChunkTimestamp = null;
        var chunkProducer = this._playback.chunkProducer;

        // TODO: BMR: `getNextChunk` could be unnecessary. See notes below. Review later.
        var getDateForChunk = function (chunkURL) {
          var index = this._playback.playlist.getChunkIndexByUrl(chunkURL);
          var date = this._playback.playlist.getChunkDateByIndex(index);

          return date;
        }.bind(this);

        // TODO: BMR: 05/19/2016: This works in the Flash audio player but not here...keeping this here for now until we figure out why
        // if the time to start playback is zero, then return null so the start time in the play is null.
        // this is most likely used for MySXM playback which always starts at zero for the start time and uses a zero
        // based play head
        // if(!PlaybackTypeUtil.isPlayerLive(this._playback) && (isNaN(time) || (time === 0)))
        // {
        // 	this.logger.debug("getFailedChunkTimestamp( Start time is 0, returning null for failed timestamp. This should be MySXM or AOD. )");
        // 	// TODO: BMR: Consider returning
        // }

        // NO PLAYLIST FAULT
        // If there is no playlist, or a manifest load failed and we never successfully loaded a chunk, the best we
        // can do is fallback to the live time. This will likely mean audio first chunk URL will be used, but we
        // will defer to this._playback.getLiveTime() to determine what time to failover to
        if (!this._playback.playlist || (this.isManifestType && chunkProducer && !chunkProducer.lastChunkUrlLoaded)) {
          this.logger.debug("getFailedChunkTimestamp( No playlist or chunk never loaded, so returning live as failed chunk timestamp. )");

          var defaultStartTime = this._playback.getLiveTime(true, true);

          if (isNaN(defaultStartTime) === false) {
            failedChunkTimestamp = new Date(defaultStartTime);
          }
        }

        // CHUNK FAULT
        // Failed asset is a chunk, get the time from the url of the failed chunk (if we have it)
        else if (this.isChunkType && !ObjectUtil.isUndefinedOrNull(this.assetError)) {
          this.logger.debug("getFailedChunkTimestamp( Failed asset is a chunk, so timestamp will come from chunk's URL: {0}. )", [
            this.assetError.url
          ]);
          failedChunkTimestamp = getDateForChunk(this.assetError.url);
        }

        // MANIFEST FAULT
        // Failed asset is a manifest, find the URL of the last successfully loaded chunk, add the duration of the
        // chunk to that, and use that as the failed chunk time.
        else if (this.isManifestType && chunkProducer) {
          this.logger.debug("getFailedChunkTimestamp( Failed asset is a manifest, so timestamp will come from last successful chunk loaded. )");
          failedChunkTimestamp = getDateForChunk(chunkProducer.lastChunkUrlLoaded, true);
        }

        this.logger.debug("getFailedChunkTimestamp ( Failed timestamp = {0} )", [
          (ObjectUtil.isDate(failedChunkTimestamp) ? failedChunkTimestamp.toString() : null)
        ]);

        return failedChunkTimestamp;
      },

      /**
       * Effectively resets the monitor.
       *
       * @param {Boolean} [bool=true] - Flag indicating if the playback instance should be garbage collected.
       */
      reset: function (bool) {
        bool = ObjectUtil.isUndefinedOrNull(bool) ? true : bool;
        this.logger.debug("reset( {0} )", [String(bool)]);

        this.inFailoverMode = false;
        this.assetError = null;
        this.failedStreamIndexes = [];

        if (bool) {
          this._playback = null;
        }

      }

    };

    return FailoverMonitor;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/FeedMonitor.js":
/*!*********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/FeedMonitor.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/25/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Monitors the player's audio data buffer and determines:
 *
 *          * If more audio chunks should be loaded to fulfill buffer requirements.
 *          * If playback is ready based on at least 1 audio chunk loaded and consumed and therefore ready for
 *              audio playback.
 *          * If the player should refresh an infinite playlist -- Live radio audio playback has an infinite playlist
 *              that's continually updated by the server with new chunks, so we'll need to update it (load it again) if
 *              the number of chunks in the current list is getting low.
 *          * If playback is finished, aka all chunks in a playlist have been played.
 */

/**
 * Register the module with RequireJS.
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var PlaybackTypeUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaybackTypeUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js");
    var Timer = __webpack_require__(/*! sxm/audioplayer/html5/util/Timer */ "./javascript/src/sxm/audioplayer/html5/util/Timer.js");
    var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
    var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var Q = __webpack_require__(/*! q */ "q");

    /**
     * Internal reference to the logger.
     */
    var logger = LoggerFactory.getLogger("FeedMonitor");

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the FeedMonitor function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @constructor
     * @param {Playback} playback Reference to the playback instance this is monitoring.
     */
    function FeedMonitor(playback) {
      // This first guard ensures that the callee has invoked our Class' constructor function
      // with the `new` keyword - failure to do this will result in the `this` keyword referring
      // to the callee's scope (typically the window global) which will result in the following fields
      // (name and _age) leaking into the global namespace and not being set on this object.
      if (!(this instanceof FeedMonitor)) {
        throw new TypeError("FeedMonitor constructor cannot be called as a function.");
      }

      // Bind the scope of "this" to all first class functions
      ClassUtil.bindFunctions(this);

      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------

      /**
       * Reference to the Playback instance being monitored.
       * @private
       * @type {Playback}
       */
      this._playback = playback;

      /**
       * Internal controller or reference to the controller for the feed.
       * @private
       * @type {Number}
       */
      this._controller = null;

      /**
       * Internal state manager that indicates if the player is loading. If greater than zero, then
       * the player is in a loading state.
       * @private
       * @type {Number}
       */
      this._loading = 0;

      /**
       * Flag indicating if playback is ready.
       * @private
       * @type {Boolean}
       */
      this.isPlaybackReady = false;

      /**
       * Chunk counter to keep track of all chunks loaded AND consumed (aka ready for playback).
       * @type {Number}
       */
      this.chunkCount = 0;

      /**
       * Flag that allows client objects to stop manifest and chunk loading. This is most commonly used
       * when stopping the load of more chunks due to a developer setting the max chunks to less than infinity.
       * @type {boolean}
       */
      this.canLoadMore = true;

      if (PlaybackTypeUtil.isPlayerMP4(playback)) {
        this.canLoadMore = true;
      }

      /**
       * Internal, read-only accessor to the playlist.
       *
       * @type {Playlist}
       */
      Object.defineProperty(this, "playlist",
        {
          get: function () {
            return (this._playback && this._playback.playlist) ? this._playback.playlist : null;
          }.bind(this)
        });

      /**
       * Flag indicating if the player is in a loading state. The player is expected to load assets
       * in sequential order to ensure smooth playback, so this flag ensures the load of HLS assets
       * to one at a time -- if greater than zero, then the player is in a loading state and the
       * flag returns true.
       *
       * @type {Boolean}
       */
      Object.defineProperty(this, "isLoading",
        {
          /**
           * Flag indicating if the player is loading if greater than zero.
           * @returns {Boolean}
           */
          get: function () {
            return this._loading > 0;
          }.bind(this),

          /**
           * Sets the internal loading flag -- if the param is true then increase the loading state machine
           * counter.
           * @param {Boolean} value
           */
          set: function (value) {
            this._loading += (value ? 1 : -1);
            if (this._loading < 0) {
              this._loading = 0;
            }
          }.bind(this)
        });
    };

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * The interval in milliseconds for the monitor to check for feed request initially before playback is ready.
     *
     * The reason for having an initial interval is that we dispatch the playback ready state or playing state as we check feed
     * every regular 250 ms , which means there is 250ms of difference in emitting the state, and when it's being used for TTM metrics
     * we are 250 ms down from actual playback readiness, so by changing the interval to 10ms, we do check for feed every 10ms and
     * once the playback is ready we will update the interval to regular value ( 250 ms) so here we make sure feedMonitor is aggresive until
     * we are ready to play
     * @const {Number}
     */
    FeedMonitor.INITIAL_INTERVAL = 10;

    /**
     * The interval in milliseconds for the monitor to check for HLS asset feed requests.
     * @const {Number}
     */
    FeedMonitor.INTERVAL = 250;

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our FeedMonitor class, we could write:
     *
     *    `BankManager.prototype = FeedMonitor.prototype`
     *    `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    FeedMonitor.prototype = {

      /**
       * Whenever you replace an Object's Prototype, you need to repoint
       * the base Constructor back at the original constructor Function,
       * otherwise `instanceof` calls will fail.
       */
      constructor: FeedMonitor,

      /**
       * Starts the continuous feed of chunks (producing, loading, followed by consuming).
       */
      startFeed: function () {
        if (ObjectUtil.isNull(this._controller)) {
          logger.debug("startFeed( Start loading and consuming chunks )");
          this._controller = new Timer(FeedMonitor.INITIAL_INTERVAL, this.checkFeed.bind(this));
          this._controller.start(false);
        }
      },

      /**
       * Stops the continuous feed of chunks (producing and consuming).
       */
      stopFeed: function () {
        if (this._controller) {
          logger.debug("stopFeed()");

          this._controller.stop();
          this._controller = null;
        }
      },

      /**
       * Increment `loading` counter so that the next sequential load doesn't start until after
       * the current one is complete. This ensures proper load sequencing.
       *
       * Should take the URL of the HLS asset as a param to start the load so it cna pass it back into the
       * next method load in the promise chain.
       *
       * NOTE: This method must always be the starting point for any chunk loader to ensure the correct
       * loading sequence; e.g., fm.startLoad().then(loadChunk).finally(fm.finishLoad);
       *
       * @param {String} [url] - The HLS URL of the asset to start the load.
       * @return {Promise}
       */
      startLoad: function (url) {
        url = ObjectUtil.isUndefinedOrNull(url) ? "" : url;

        // make this setter is above the logger so the value for the internal loading flag is properly updated
        this.isLoading = true;
        logger.debug("startLoad( {0} )", [this._loading]);
        return Q.when(url);
      },

      /**
       * Decrement `loading` counter.
       *
       * NOTE: This method must always be the end point for any chunk loader to ensure the correct
       * loading sequence; e.g., fm.startLoad().then(loadChunk).finally(fm.finishLoad);
       */
      finishLoad: function () {
        // make this setter is above the logger so the value for the internal loading flag is properly updated
        this.isLoading = false;
        logger.debug("finishLoad( {0} )", [this._loading]);
      },

      /**
       * Determines if playback is ready by asking the playback if it is ready.
       *
       * @param {Playback} pb - The current playback.
       */
      checkPlaybackReady: function (pb) {
        if (!this.isPlaybackReady && pb.isReady()) {
          logger.info("checkPlaybackReady( READY )");
          this.isPlaybackReady = true;
          this._playback.ready();
          // Update the interval to regular periods once we are ready to play
          if (this._controller && this._controller.updateInterval) {
              this._controller.updateInterval(FeedMonitor.INTERVAL);
          }
        }
      },

      /**
       * Simple callback that keeps the player continually loading and consuming chunks for playback.
       */
      checkFeed: function () {
        // NOTE: since JS's internal timers swallow errors we'll make sure to capture it.
        try {
          if (this._playback) {
            var pb = this._playback;
            var buffer = pb.bufferTime;
            var isLive = PlaybackTypeUtil.isPlayerLive(pb);
            var isPlayOrPreload = pb.isPlaying || pb.isPreloading;
            var isValidPlaylist = this.playlist && this.playlist.hasNext;
            var loadMore = this.canLoadMore && isPlayOrPreload && isValidPlaylist;
            //Mp4's doesn't have the playlist, so we depend on the isEnded on the playback
            var hasChunks = PlaybackTypeUtil.isPlayerTrackBased(pb) ? !pb.isEnded : isValidPlaylist;
            var noMoreChunks = !isLive && !hasChunks;
            var isFinished = (this.isPlaybackReady && pb.isPlaying && (buffer <= 0) && (noMoreChunks || !this.canLoadMore));

            // determine if the playback is ready
            this.checkPlaybackReady(pb);

            // determine if more chunks needs to be loaded to fulfill the buffer requirements
            if (loadMore && !this.isLoading) {
              // NOTE: This should never happen for AOD or My (aka finite) playlists...only Live
              if (!pb.playlistMonitor.isPlaylistStalling && this.playlist.needsRefresh) {
                logger.debug(
                  "checkFeed( refreshPlaylist: Only {0} chunks left in playlist with {1} chunks. )", [
                    this.playlist.chunksLeft, this.playlist.totalChunks
                  ]);
                pb.refreshPlaylist(this.playlist.url);
              }
              else if (buffer < HlsConfig.BUFFER_TIME) {
                logger.debug(
                  "checkFeed( Buffer time {0} ms < min buffer time {1} ms...load more audio chunks. )", [
                    buffer, HlsConfig.BUFFER_TIME
                  ]);
                pb.loadAndConsumeChunk();
              }
            }

            // if the player has finished playback for a track let the world know
            else if (isFinished) {
              pb.finished();
            }
          }
        }
        catch (error) {
          throw error;
        }

      },

      /**
       * Resets the monitor.
       */
      reset: function () {
        logger.debug("reset()");

        this._playback = null;
        this._controller = null;
      }
    };

    return FeedMonitor;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));




/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/PlaylistMonitor.js":
/*!*************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/PlaylistMonitor.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    03/04/16
 * @COPYRIGHT:  2016 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Monitors the playlist as it's loaded and determines:
 *
 *          * If it's invalid.
 *          * If it's stale, aka the same playlist as the current one.
 *          * Or good to go.
 *
 *      If the playlist is not good, then the monitor tries to load it again up to 5 additional times
 *      with a delay of half the existing buffer; if the playlist is still no good then the monitor
 *      performs a manifest failover.
 */



/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
  var PlaylistUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaylistUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaylistUtil.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var Timer = __webpack_require__(/*! sxm/audioplayer/html5/util/Timer */ "./javascript/src/sxm/audioplayer/html5/util/Timer.js");
  var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("PlaylistMonitor");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the PlaylistMonitor function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Playback} playback Reference to the playback instance this is monitoring.
   */
  function PlaylistMonitor(playback) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof PlaylistMonitor)) {
      throw new TypeError("PlaylistMonitor constructor cannot be called as a function.");
    }

    // Bind the scope of "this" to all first class functions
    ClassUtil.bindFunctions(this);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Reference to the Playback instance being monitored.
     * @private
     * @type {Playback}
     */
    this._playback = playback;

    /**
     * The counter for number of asset load retries.
     * @type {Number}
     * @private
     */
    this._retries = 0;

    /**
     * The timer used to refresh a playlist later, aka we delay playlist refreshes with it.
     * @type {Timer}
     * @private
     */
    this._refreshLaterTimer = null;

    /**
     * Indicates if the playlist is stale or invalid and therefore stalling.
     * @type {Boolean}
     */
    this.isPlaylistStalling = false;

    /**
     * Internal, read-only accessor to the playlist.
     *
     * @type {Playlist}
     */
    Object.defineProperty(this, "playlist",
      {
        get: function () {
          return (this._playback && this._playback.playlist) ? this._playback.playlist : null;
        }.bind(this)
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our PlaylistMonitor class, we could write:
   *
   *    `BankManager.prototype = PlaylistMonitor.prototype`
   *    `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  PlaylistMonitor.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: PlaylistMonitor,

    /**
     * Determine if the playlist is valid.
     *
     * @param {Playlist} playlist - Playlist to check if valid.
     * @return {Playlist} Passing back original playlist if it's good to go.
     */
    watch: function (playlist) {
      /**
       * Handles the successful playlist load and determines if it's good to go or needs to be requested
       * again.
       *
       * @param {Playlist} playlist - The refreshed playlist.
       * @return {*}
       */
      var refreshPlaylistSuccess = function (playlist) {
        if (!PlaylistUtil.isValid(playlist)) {
          this.isPlaylistStalling = true;
          logger.warn("refreshPlaylistFault( STALLED due to invalid playList )");

          refreshPlaylistFault(playlist);
        }
        else if (PlaylistUtil.arePlaylistsIdentical(this.playlist, playlist)) {
          this.isPlaylistStalling = true;
          logger.warn("refreshPlaylistFault( STALLED due to stale playList: " +
            "current last chunk = {0}, " +
            "new last chunk = {1}. )", [this.playlist.lastChunk, playlist.lastChunk]);

          refreshPlaylistFault(playlist);
        }
        else {
          logger.debug("refreshPlaylistSuccess()");
          this._retries = 0;
          this.isPlaylistStalling = false;
          return playlist;
        }

      }.bind(this);

      /**
       * Handles the failed playlist refresh and determines if a refresh attempt should take place
       * or simply failover.
       *
       * @param {Playlist} playlist - The invalid playlist.
       * @return {*}
       */
      var refreshPlaylistFault = function (playlist) {
        //logger.debug("refreshPlaylistSuccess( playlistCount = {0} )", [this.playlistCount]);

        this._retries++;
        if (this._retries <= HlsConfig.STALENESS_RETRY_LIMIT) {
          // Try again later (if possible)
          this.refreshLater(playlist.url);
        }
        else {
          // TODO: BMR: 03/07/2016: Need to implement failover for invalid or stale playlists
          throw new PlayerError(PlayerError.METOHD_NOT_IMPLEMENTED);
          //failover();
        }

      }.bind(this);

      if (this._playback && playlist) {
        logger.info("watch( Checking for an invalid or stale playlist... )");
        return refreshPlaylistSuccess(playlist);
      }

      return playlist;
    },

    /**
     * Try to refresh the manifest by setting a stall flag on the Playback object. The Playback object will
     * determine when to try refreshing the manifest again based on it's own understanding of what else is
     * currently executing with the player.
     *
     * @param {String} url - The playlist URL.
     */
    refreshLater: function (url) {
      var refreshPlaylist = function () {
        if (this._playback) {
          logger.debug("refreshLater( Retry {0} of {1} with delay for {2} secs )", [
            this._retries, HlsConfig.STALENESS_RETRY_LIMIT, delay
          ]);
          this._playback.refreshPlaylist(url);
        }
        else {
          logger.debug("refreshLater( No playback instance so no refreshing. )");
        }
      }.bind(this);

      if (this._playback) {
        // errors occurred while trying to refresh a manifest, wait 50% of the current buffer
        // to allow server adequate time to update a new manifest.
        var delay = Math.max(Math.floor(this._playback.bufferTime / 2), 1);

        this._refreshLaterTimer = new Timer(delay, refreshPlaylist);
        this._refreshLaterTimer.runOnce();
      }
    },

    /**
     * Stops the playlist refresh dead in it's tracks. It's possible that we're switching channels
     * right in the middle of a playlist refresh, which means that while channel 1 is delaying for
     * a channel refresh it's also told to shutdown. Due to the async nature of timers, this can
     * lead to RTEs as we're trying to load a playlist on a Playback instance that's technically dead.
     * Plus, we really don't want an old, dead Playback instance to do anything.
     */
    abort: function () {
      logger.debug("abort()");

      // It's possible that this player hasn't had a need to call refresh playlist so there's no
      // _refreshLaterTimer even around.
      if (this._refreshLaterTimer) {
        this._refreshLaterTimer.stop();
        this._refreshLaterTimer = null;
      }
    },

    /**
     * Resets the internal state of playlistMonitor.
     * mainly used for failover scenario as we don't want the playback to be null, but all it's internal state has to refreshed.
     */
    resetLocalState: function () {
      logger.debug("reset()");

      // Kill any pending or delayed playlist refreshes.
      this.abort();

      this._refreshLaterTimer = null;
      this.isPlaylistStalling = false;
      this._retries = 0;
    },
    
    /**
     * Resets the monitor.
     */
    reset: function () {
      logger.debug("reset()");

      //It will reset all the internal state
      this.resetLocalState();

      this._playback = null;
    }
  };

  return PlaylistMonitor;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/PreloadMonitor.js":
/*!************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/PreloadMonitor.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    01/28/16
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Monitors the preloading of chunks and is responsible for firing preloading events and the preload complete
 *      event.
 *
 *      Will also execute callbacks on the client Playback object for both the minimum buffer preloaded
 *      (aka 1 chunk) and max buffer preloaded (16 chunks). These can be used to resolve the Playback's
 *      promise for preloading if so desired.
 */



/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var PlayerEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/PlayerEvent */ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("PreloadMonitor");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the PreloadMonitor function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Playback} playback - Reference to the playback instance this is monitoring.
   */
  function PreloadMonitor(playback) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof PreloadMonitor)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["PreloadMonitor"]);
    }

    if (ObjectUtil.isUndefinedOrNull(playback)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Reference to the Playback instance being monitored.
     * @private
     * @type {Playback}
     */
    this._playback = playback;

    /**
     * Boolean indicating of the monitor is enabled.
     * @type {Boolean}
     */
    this.enabled = true;

    /**
     * Reference to the callback method to execute when the minimum buffer to preload is complete.
     * @type {Function}
     */
    this.onMinimumPreloadedCallback = ObjectUtil.noop;

    /**
     * Reference to the callback method to execute when preloading is complete.
     * @type {Function}
     */
    this.onCompleteCallback = ObjectUtil.noop;

    /**
     * Reference to the callback method to execute when preloading has failed.
     * @type {Function}
     */
    this.onFailedCallback = ObjectUtil.noop;
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our PreloadMonitor class, we could write:
   *
   *  `BankManager.prototype = PreloadMonitor.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  PreloadMonitor.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: PreloadMonitor,

    /**
     * Add a tail-hook (essentially intercept the promise before giving it back to the original caller) to
     * to watch the promise returned for preloading chunks.
     *
     * @param {Promise} assetPromise - Promise from asset loader request.
     * @return {Promise} Passing back original promise from asset loader request.
     */
    watch: function (assetPromise) {
      if (this.enabled && this.onCompleteCallback) {
        /**
         * Handles the successful asset load and simply returns the original promise.
         *
         * @param {*} asset - The last asset downloaded.
         * @return {*} The loaded asset.
         */
        var onAssetLoadSuccess = function (asset) {
          // If the player is preloading and doesn't have enough audio buffered then fire off
          // the "preloading" event, otherwise we're finished preloading and we need to fire
          // off the "preloading complete" event and call the preloading success callback in Playback.
          // Finally, if we're not in the preloading state we also need to call the preloading success
          // callback in Playback -- this can happen when the player is in the middle of preloading
          // and is interrupted and told to resume or play.
          if (this._playback.isPreloading) {
            if (this._playback.bufferTime >= HlsConfig.BUFFER_TIME) {
              this.preloadComplete();
            }
            else {
              logger.debug("onAssetLoadSuccess( Preloading Playback[{0}], buffer = {1}. )", [
                this._playback.uid, this._playback.bufferTime
              ]);
              // if(this._playback.inFailoverMode && (this._playback.bufferTime >= HlsConfig.MIN_BUFFER_TIME))
              if (this._playback.bufferTime >= HlsConfig.MIN_BUFFER_TIME) {
                this.minimumPreloaded();
              }
              this.dispatchEvent(PlayerEvent.PRELOADING);
            }
          }
          else {
            this.preloadComplete();
          }

          return asset;
        }.bind(this);

        /**
         * Handles the failed asset load and applies failover.
         *
         * @param {AssetError} error - The asset error -- could be a load error or even chunk decode issue..
         * @throw {AssetError}
         */
        var onAssetLoadFailed = function (error) {
          logger.warn("onAssetLoadFailed( Chunk failed to load or be consumed for Playback[{0}]. )", [this._playback.uid]);

          this.preloadFailed(error);

          throw error;

        }.bind(this);

        if (this._playback && assetPromise) {
          //logger.info("watch( Intercepting load promise and determining if success or failure... )");
          return assetPromise.then(onAssetLoadSuccess, onAssetLoadFailed);
        }
        else {
          logger.info("watch( Cannot watch as either `playback` or the promise are null. )");
        }
      }

      return assetPromise;
    },

    /**
     * Fired when the minimum buffer has been preloaded.
     */
    minimumPreloaded: function () {
      if (this.onMinimumPreloadedCallback) {
        logger.info("minimumPreloaded( Preloading Playback[{0}], buffer = {1}. )", [
          this._playback.uid, this._playback.bufferTime
        ]);
        this.onMinimumPreloadedCallback(false);
        this.onMinimumPreloadedCallback = null;
      }
    },

    /**
     * Completes the preload process.
     */
    preloadComplete: function () {
      if (this.onCompleteCallback) {
        logger.info("preloadComplete( Preloading Playback[{0}], buffer = {1}. )", [
          this._playback.uid, this._playback.bufferTime
        ]);
        this.dispatchEvent(PlayerEvent.PRELOADING_COMPLETE);
        this.onCompleteCallback(true);
        this.onCompleteCallback = null;
      }
    },

    preloadFailed: function (error) {
      if (this.onFailedCallback) {
        logger.error("preloadFailed( {0} Preloading Playback[{1}], buffer = {2}. )", [
          error, this._playback.uid, this._playback.bufferTime
        ]);

        this.onFailedCallback(error);
        this.onFailedCallback = null;
      }
    },

    /**
     *  Dispatches playback events.
     *
     *  TODO: BMR: 03/09/2016: Consider putting in a base Monitor class.
     *
     *  @param {String} type - The event type.
     */
    dispatchEvent: function (type) {
      this._playback.dispatchPlayerEvent(type);
    },

    /**
     * Resets the monitor.
     *
     * TODO: BMR: 03/09/2016: Consider putting in a base Monitor class.
     */
    reset: function () {
      logger.debug("reset()");

      this._playback = null;
      this.onCompleteCallback = null;
      this.onFailedCallback = null;
    }

  };

  return PreloadMonitor;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/QualityOfServiceMonitor.js":
/*!*********************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/QualityOfServiceMonitor.js ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    04/19/16
 * @COPYRIGHT:  2016 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Controls and manages the quality of service for the audio player. The idea is to make sure all older Playback
 * instances are stopped and prepared for garbage collection. There are currently two specific case we check for:
 *
 *          1) Switching playback types, aka when the new playback instance is "Live" and the old, prior
 *          one is "AOD" or "MySXM" then we need to kill all older playback instances; this is applied when
 *          switching between any different Playback instances and not just the example listed above. Old is defined
 *          as anything but the current player.
 *
 *          2) Switching to a new MySXM content ID. This happens when the user requests a new MySXM channel model,
 *          aka changes the listening selections for MySXM and customizes it again. In this use case we don't want
 *          to allow the currently playing MySXM track to finish and we simply want to start playing the new
 *          track from the new customization.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlaybackTypeUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaybackTypeUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
  var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("QualityOfServiceMonitor");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the QualityOfServiceMonitor function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   */
  function QualityOfServiceMonitor() {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof QualityOfServiceMonitor)) {
      throw new TypeError("QualityOfServiceMonitor constructor cannot be called as a function.");
    }

    // Bind the scope of "this" to all first class functions.
    ClassUtil.bindFunctions(this);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Cache of Playback instances.
     * @private
     * @type {Array}
     */
    this._playbackCache = null;

    /**
     * Reference to the current Playback instance that's playing audio.
     * @private
     * @type {Playback}
     */
    this._currentPlayer = null;

    /**
     * Reference to the previous Playback instance.
     * @private
     * @type {Playback}
     */
    this._priorPlayer = null;
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our QualityOfServiceMonitor class, we could write:
   *
   *    `BankManager.prototype = QualityOfServiceMonitor.prototype`
   *    `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  QualityOfServiceMonitor.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: QualityOfServiceMonitor,

    /**
     * Saves a reference to the current and prior players. Stops all older players.
     *
     * @param {Playback} currentPlayer - The current player.
     * @param {Playback} priorPlayer - The prior player.
     * @param {Playback} playbackCache - Current cache of Playback instances.
     */
    activate: function (currentPlayer, priorPlayer, playbackCache) {
      var oldId = priorPlayer ? priorPlayer.uid : "No prior player";
      logger.debug("activate( current = {0}, prior = {1} )", [currentPlayer.uid, oldId]);

      this._playbackCache = playbackCache;
      this._currentPlayer = currentPlayer;
      this._priorPlayer = priorPlayer;

      this.stopPriorPlayer();
    },

    /**
     * Determines if the prior player should be stopped. Currently the only flow where prior shouldn't be
     * stopped is when continuously playing MySXM from the same channel.
     */
    stopPriorPlayer: function () {
      if (this._doPlayersExist()) {
        // If the playback type for the current is different from the prior, aka you're moving from
        // say "Live" to "AOD" or "MySM", then stop the older playback.
        if (this._isDifferentPlaybackType()) {
          logger.debug("stopPriorPlayer( Stop all OLD players as the playback types are different: " +
            "current = {0}, prior = {1} )", [
            this._currentPlayer.configuration.playbackType, this._priorPlayer.configuration.playbackType
          ]);
          this.stopOlderPlayers();
        }

        // Broke out the if logic specifically for MySXM as that's the only playback type that has specific
        // stoppage restrictions...that said, the following if logic could be flattened but isn't so MySXM
        // is a totally separate case and there could be other unique cases for it.
        else if (this._arePlayersMySXM()) {
          // We don't want to stop playback of continuous MySXM playback from the same channel even though
          // each track has a unique player; this is due to crossfade and the fact that each player plays
          // through one track and stops itself.
          //
          // However, if the channel settings for a MySXM channel were changed which means we have a new track
          // and a new player but the same content ID, we do want to stop playback of the old, prior player.
          // the middle tier audio player has no way to know this so we look for a specific property in the
          // player config object indicating such.
          if (this._priorPlayer && this._isDifferentContent() || this._isForceStop()) {
            logger.debug("stopPriorPlayer( Stop prior MySXM player = {0} )", [this._priorPlayer.uid]);
            this._priorPlayer.stop();
            this._priorPlayer = null;
          }
        }

        // Stop all other previous players.
        else if (this._priorPlayer) {
          logger.debug("stopPriorPlayer( Stop prior player = {0} )", [this._priorPlayer.uid]);
          this._priorPlayer.stop();
          this._priorPlayer = null;
        }
      }
    },

    /**
     * Stops all players in the player cache sans the current one.
     */
    stopOlderPlayers: function () {
      var stopPlayback = function (playback) {
        if (playback.id !== this._currentPlayer.id) {
          playback.stop();
        }
      }.bind(this);

      this._playbackCache.forEach(stopPlayback);
    },

    /**
     * Resets the monitor.
     */
    reset: function () {
      logger.debug("reset()");

      this._playbackCache = null;
      this._currentPlayer = null;
      this._priorPlayer = null;
    },

    //-----------------------------------------------------------------------
    // PRIVATE METHODS
    //-----------------------------------------------------------------------

    /**
     * Determines if the prior and current players exist.
     * @return {Boolean}
     */
    _doPlayersExist: function () {
      return !ObjectUtil.isUndefinedOrNull(this._priorPlayer) && !ObjectUtil.isUndefinedOrNull(this._currentPlayer);
    },

    /**
     * Determines if the players are both MySXM.
     * @return {Boolean}
     */
    _arePlayersMySXM: function () {
      return this._doPlayersExist() &&
        (PlaybackTypeUtil.isPlayerMySXM(this._priorPlayer) && PlaybackTypeUtil.isPlayerMySXM(this._currentPlayer));
    },

    /**
     * Determines if the playback type of the prior and current player is different.
     * @return {Boolean}
     */
    _isDifferentPlaybackType: function () {
      return this._doPlayersExist() &&
        (this._priorPlayer.configuration.playbackType !== this._currentPlayer.configuration.playbackType);
    },

    /**
     * Determines if the content of the prior and current player is different.
     * @return {Boolean}
     */
    _isDifferentContent: function () {
      return this._doPlayersExist() &&
        (this._priorPlayer.configuration.contentId !== this._currentPlayer.configuration.contentId);
    },

    /**
     * Determines if the content of the new, current player has a force stop on the old, prior player.
     * @return {Boolean}
     */
    _isForceStop: function () {
      return this._doPlayersExist() &&
        (this._currentPlayer.configuration.hasOwnProperty("forceStop") && this._currentPlayer.configuration.forceStop);
    }
  };

  return QualityOfServiceMonitor;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/AODPlayheadMonitor.js":
/*!*************************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/playhead/AODPlayheadMonitor.js ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * MySXM playhead monitor calculates the playhead value for the player.
 *
 * The core playhead work is performed in the base class, PlayheadMonitor and the playback type based playhead monitors
 * simply take care of the differences between the types.
 */



/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var PlayheadMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/playhead/PlayheadMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/PlayheadMonitor.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the AODPlayheadMonitor function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Playback} playback Reference to the playback instance this is monitoring.
   */
  var AODPlayheadMonitor = function (playback) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof AODPlayheadMonitor)) {
      throw new TypeError("AODPlayheadMonitor constructor cannot be called as a function.");
    }

    if (ObjectUtil.isUndefinedOrNull(playback)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
    }

    // Call the super class's constructor method
    PlayheadMonitor.call(this, playback);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Read-only accessor to the start time. The start time is always the first chunk in the playlist.
     *
     * NOTE: For AOD using Audio First for Pause Points (aka starting in the middle of the episode and not
     * at the beginning) the startTime will momentarily be the audio first chunk 0's timestamp
     * and not the actual AOD playlist's first chunk timestamp (because we don't yet have the episode's real playlist.
     * This means there will be a diff between the start time and ready time, but that's ok since client's just use
     * the ready time, aka playhead zulu.
     *
     * @type {Number}
     */
    Object.defineProperty(this, "startTime",
      {
        get: function () {
          return (this.playlist) ? this.playlist.firstChunkTime : 0;
        }.bind(this)
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our AODPlayheadMonitor class, we could write:
   *
   *  `BankManager.prototype = AODPlayheadMonitor.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   *
   * Inherit from the base PlayheadMonitor class, which means we DO NOT want to create a new `prototype` instance
   * for AODPlayheadMonitor, but DO still need to point our prototype's `constructor` to our subclass `AODPlayheadMonitor`.
   */
  AODPlayheadMonitor.prototype = Object.create(PlayheadMonitor.prototype);
  AODPlayheadMonitor.prototype.constructor = AODPlayheadMonitor;

  /**
   * Implicit getter which will calculate the total playhead position (milliseconds) with a starting value of
   * zero initially; when seeking the "offset" value is used to maintain the current playhead position. This is
   * true of all finite playlists like AOD and MySXM but not for infinite ones like Live.
   *
   * Override the instance method in the base class.
   *
   * @returns {Number}
   */
  AODPlayheadMonitor.prototype.getPlayhead = function () {
    var playhead = PlayheadMonitor.prototype.getPlayhead.call(this);
    return this.getFinitePlaylistPlayhead(playhead);
  };

  /**
   * Explicit setter for the initial timestamp and offset values. Only set if not already set, aka initialized.
   *
   * NOTE: Since there are times when clients send a zero based timestamp and not a zulu based timestamp we
   * normalize the timestamp value so it's always zulu based.
   *
   * @param {Number} timestamp - Time in milliseconds usually correlating to the first chunk's timestamp.
   * @param {Number} [offset=0] - Time in milliseconds usually correlating to the first chunk's offset. Defaults to zero.
   * @param {String} [reason=""] - Reason for setting the initial times -- really just here for logging.
   */
  AODPlayheadMonitor.prototype.setInitialTimestampAndOffset = function (timestamp, offset, reason) {
    if (!this._initialized) {
      var date = (this.playlist) ? this.playlist.convertMillisecondsToDate(timestamp) : null;
      timestamp = (date && (date instanceof Date)) ? date.getTime() : timestamp;
      PlayheadMonitor.prototype.setInitialTimestampAndOffset.call(this, timestamp, offset, reason);
    }
  };

  return AODPlayheadMonitor;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/LivePlayheadMonitor.js":
/*!**************************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/playhead/LivePlayheadMonitor.js ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Live playhead monitor calculates the playhead value for the player.
 *
 * The core playhead work is performed in the base class, PlayheadMonitor and the playback type based playhead monitors
 * simply take care of the differences between the types.
 */



/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var PlayheadMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/playhead/PlayheadMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/PlayheadMonitor.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the LivePlayheadMonitor function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Playback} playback Reference to the playback instance this is monitoring.
   */
  var LivePlayheadMonitor = function (playback) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof LivePlayheadMonitor)) {
      throw new TypeError("LivePlayheadMonitor constructor cannot be called as a function.");
    }

    if (ObjectUtil.isUndefinedOrNull(playback)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
    }

    // Call the super class's constructor method
    PlayheadMonitor.call(this, playback);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Read-only accessor to the start time. The value is always the initially requested chunk timestamp + offset.
     *
     * @type {Number}
     */
    Object.defineProperty(this, "startTime",
      {
        get: function () {
          return this.getInitialChunkOffset() + this.getInitialChunkTimestamp();
        }.bind(this)
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our LivePlayheadMonitor class, we could write:
   *
   *  `BankManager.prototype = LivePlayheadMonitor.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   *
   * Inherit from the base PlayheadMonitor class, which means we DO NOT want to create a new `prototype` instance
   * for LivePlayheadMonitor, but DO still need to point our prototype's `constructor` to our subclass `LivePlayheadMonitor`.
   */
  LivePlayheadMonitor.prototype = Object.create(PlayheadMonitor.prototype);
  LivePlayheadMonitor.prototype.constructor = LivePlayheadMonitor;

  return LivePlayheadMonitor;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/MyPlayheadMonitor.js":
/*!************************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/playhead/MyPlayheadMonitor.js ***!
  \************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * MySXM playhead monitor calculates the playhead value for the player.
 *
 * The core playhead work is performed in the base class, PlayheadMonitor and the playback type based playhead monitors
 * simply take care of the differences between the types.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var PlayheadMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/playhead/PlayheadMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/PlayheadMonitor.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the MyPlayheadMonitor function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {Playback} playback Reference to the playback instance this is monitoring.
   */
  var MyPlayheadMonitor = function (playback) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof MyPlayheadMonitor)) {
      throw new TypeError("MyPlayheadMonitor constructor cannot be called as a function.");
    }

    if (ObjectUtil.isUndefinedOrNull(playback)) {
      throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
    }

    // Call the super class's constructor method
    PlayheadMonitor.call(this, playback);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Read-only accessor to the start time. The value is always 0 for track-based MySXM playback.
     *
     * @type {Number}
     */
    Object.defineProperty(this, "startTime",
      {
        get: function () {
          return 0;
        }.bind(this)
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our MyPlayheadMonitor class, we could write:
   *
   *  `BankManager.prototype = MyPlayheadMonitor.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   *
   * Inherit from the base PlayheadMonitor class, which means we DO NOT want to create a new `prototype` instance
   * for MyPlayheadMonitor, but DO still need to point our prototype's `constructor` to our subclass `MyPlayheadMonitor`.
   */
  MyPlayheadMonitor.prototype = Object.create(PlayheadMonitor.prototype);
  MyPlayheadMonitor.prototype.constructor = MyPlayheadMonitor;

  /**
   * Implicit getter which will calculate the total playhead position (milliseconds) with a starting value of
   * zero initially; when seeking the "offset" value is used to maintain the current playhead position. This is
   * true of all finite playlists like AOD and MySXM but not for infinite ones like Live.
   *
   * Override the instance method in the base class.
   *
   * @returns {Number}
   */
  MyPlayheadMonitor.prototype.getPlayhead = function () {
    var playhead = PlayheadMonitor.prototype.getPlayhead.call(this);
    return this.getFinitePlaylistPlayhead(playhead);
  };

  /**
   * Explicit setter for the initial timestamp and offset values. Only set if not already set, aka initialized.
   *
   * Override the instance method in the base class.
   *
   * @param {Number} timestamp - Time in milliseconds usually correlating to the first chunk's timestamp.
   * Defaults to zero.
   * @param {Number} offset - Time in milliseconds usually correlating to the first chunk's offset.
   * Defaults to zero.
   * @param {String} reason - Reason for setting the initial times -- really just here for logging.
   */
  MyPlayheadMonitor.prototype.setInitialTimestampAndOffset = function (timestamp, offset, reason) {
    timestamp = ObjectUtil.isUndefinedOrNull(timestamp) || isNaN(timestamp) ? 0 : timestamp;
    offset = ObjectUtil.isUndefinedOrNull(offset) ? 0 : offset;

    var startTime = timestamp + offset;
    timestamp = startTime - (this.playlist ? this.playlist.firstChunkTime : 0);
    timestamp = isNaN(timestamp) || (timestamp <= 0) ? 0 : timestamp;
    return PlayheadMonitor.prototype.setInitialTimestampAndOffset.call(this, timestamp, offset, reason);
  };

  return MyPlayheadMonitor;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/PlayheadMonitor.js":
/*!**********************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/playhead/PlayheadMonitor.js ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * This class monitors the state of the audio player and dispatches a player event for the playhead if the
 * player is playing. The event contains the current playhead position, buffer time, duration and other current
 * player snapshots for the given millisecond.
 *
 * Originally a native JS timer was used but unfortunately those don't consistently output events at 1 second.
 * Instead a simple Timer object was created that aims to eradicate the instability issue.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var HlsConfig = __webpack_require__(/*! sxm/audioplayer/html5/model/HlsConfig */ "./javascript/src/sxm/audioplayer/html5/model/HlsConfig.js");
    var Timer = __webpack_require__(/*! sxm/audioplayer/html5/util/Timer */ "./javascript/src/sxm/audioplayer/html5/util/Timer.js");
    var PlayerEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/PlayerEvent */ "./javascript/src/sxm/audioplayer/html5/event/PlayerEvent.js");
    var StateChangeEvent = __webpack_require__(/*! sxm/audioplayer/html5/event/StateChangeEvent */ "./javascript/src/sxm/audioplayer/html5/event/StateChangeEvent.js");
    var PlayerState = __webpack_require__(/*! sxm/audioplayer/html5/model/PlayerState */ "./javascript/src/sxm/audioplayer/html5/model/PlayerState.js");
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
    var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

    /**
     * Internal reference to the logger.
     */
    var logger = LoggerFactory.getLogger("PlayheadMonitor");

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
     * To differentiate constructor functions from regular functions, by convention we start the function
     * name with a capital letter. This informs users that they must invoke the PlayheadMonitor function using
     * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
     *
     * @constructor
     * @param {Playback} playback Reference to the playback instance this is monitoring.
     */
    var PlayheadMonitor = function (playback) {
      // This first guard ensures that the callee has invoked our Class' constructor function
      // with the `new` keyword - failure to do this will result in the `this` keyword referring
      // to the callee's scope (typically the window global) which will result in the following fields
      // (name and _age) leaking into the global namespace and not being set on this object.
      if (!(this instanceof PlayheadMonitor)) {
        throw new TypeError("PlayheadMonitor constructor cannot be called as a function.");
      }

      if (ObjectUtil.isUndefinedOrNull(playback)) {
        throw new PlayerError(PlayerError.REQUIRED_PARAM, ["playback"]);
      }

      // listen for playback state changes
      playback.addEventListener(StateChangeEvent.STATE_CHANGE, this.onPlayerStateChange.bind(this));

      //-----------------------------------------------------------------------
      // CLASS MEMBERS
      //-----------------------------------------------------------------------

      /**
       * Reference to the Playback instance being monitored.
       * @type {Playback}
       */
      this._playback = playback;

      /**
       * Internal timer to create and dispatch the playhead of the audio player.
       */
      this._playheadTicker = new Timer(PlayheadMonitor.PLAYHEAD_EVENT_TICK, this.onPlayheadTick.bind(this));

      /**
       * The initial offset value in milliseconds; aka the sub-seek time into the first audio chunk.
       * @type {Number}
       */
      this._initialChunkOffset = 0;

      /**
       * The initial timestamp value in milliseconds; aka the timestamp of the first audio chunk.
       * @type {Number}
       */
      this._initialChunkTimestamp = 0;

      /**
       * Time span for all play segments.
       * @type {Number}
       */
      this._aggregateSpan = 0;

      /**
       * Timestamp for start of current segment.
       * @type {Number}
       */
      this._spanStart = 0;

      /**
       * Boolean indicating whether the monitor is stopped or not.
       */
      this._isStopped = true;

      /**
       * The delta between the first playhead value and 1000. This becomes the baseline so each playhead
       * value after the first is exactly 1000 milliseconds more than the previous one.
       * @type {Number}
       */
      this._playheadNormalizer = -1;

      /**
       * Flag indicating if the monitor has been initialized.
       * @type {boolean}
       */
      this._initialized = false;

      /**
       * Read-only accessor to the start time. The value is always the initially requested chunk timestamp + offset.
       * @type {Number}
       */
      Object.defineProperty(this, "startTime",
        {
          enumerable: true,
          configurable: true,
          get: function () {
            return 0;
          }.bind(this)
        });

      /**
       * Internal, read-only accessor to the playlist.
       * @type {Playlist}
       */
      Object.defineProperty(this, "playlist",
        {
          get: function () {
            return (this._playback && this._playback.playlist) ? this._playback.playlist : null;
          }.bind(this)
        });

    };

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Constant representing the amount of time in milliseconds between playhead events.
     * @type {Number}
     */
    PlayheadMonitor.PLAYHEAD_EVENT_TICK = 250;

    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    /**
     * The prototype is a special type of Object which is used as a the blueprint for all instances
     * of a given Class; by defining functions and properties on the prototype we reduce memory
     * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
     * example, if we introduced a BankManager class which extended our PlayheadMonitor class, we could write:
     *
     *  `BankManager.prototype = PlayheadMonitor.prototype`
     *  `BankManager.prototype.constructor = BankManager`
     *
     * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
     * over inheritance will make your code easier to read and re-use.
     */
    PlayheadMonitor.prototype = {

      /**
       * Whenever you replace an Object's Prototype, you need to repoint
       * the base Constructor back at the original constructor Function,
       * otherwise `instanceof` calls will fail.
       */
      constructor: PlayheadMonitor,

      /**
       * Starts the internal timer that triggers the playhead event dispatching.
       */
      start: function () {
        if (this._playheadTicker.isStopped) {
          logger.debug("start()");
          this._isStopped = false;
          this._spanStart = this.currentZeroBasedTimeMilli();
          this._playheadTicker.start();
        }
      },

      /**
       * Aggregates the amount of time played thus far so that resuming playback has a starting position.
       * Stops the internal timer that triggers the playhead event dispatching.
       */
      stop: function () {
        if (!this._playheadTicker.isStopped) {
          logger.debug("stop()");
          this._isStopped = true;
          this._aggregateSpan += this.currentZeroBasedTimeMilli() - this._spanStart;
          this._playheadTicker.stop();
        }
      },

      /**
       * Explicit setter for the initial timestamp and offset values. Only set if not already set, aka initialized.
       *
       * @param {Number} timestamp - Time in milliseconds usually correlating to the first chunk's timestamp.
       * @param {Number} offset - Time in milliseconds usually correlating to the first chunk's offset. Defaults to zero.
       * @param {String} reason - Reason for setting the initial times -- really just here for logging.
       */
      setInitialTimestampAndOffset: function (timestamp, offset, reason) {
        if (ObjectUtil.isUndefinedOrNull(timestamp) || (timestamp < 0)) {
          throw new Error("Timestamp must be greater than or equal to zero.");
        }
        offset = offset || 0;
        reason = reason || "";

        if (!this._initialized) {
          this._initialized = true;
          this._initialChunkOffset = offset;
          this._initialChunkTimestamp = timestamp;

          logger.debug("setInitialTimestampAndOffset( timestamp = {0}, offset = {1}, startTime = {2}, reason = {3} )", [
            timestamp, offset, this.startTime, reason
          ]);
        }
      },

      /**
       * Implicit getter which will calculate the total playhead position (milliseconds) with a starting value of
       * zero; this is not zulu based and is the playhead position relative to the start of playback when
       * calling play or seek -- in both cases it starts back at zero.
       */
      getPlayhead: function () {
        /**
         * Allows numbers to be rounded to a given precision. If the roundTo is not provide, the
         * default is -1.
         *
         * @param {Number} value The number to round.
         * @param {Number} [roundTo=0] The precision to round to.
         * @return {Number} The rounded number.
         */
        var round = function (value, roundTo) {
          roundTo = roundTo || -1;
          if (roundTo === -1) {
            roundTo = PlayheadMonitor.PLAYHEAD_EVENT_TICK;
          }

          var round = Math.floor(value / roundTo);
          return round * roundTo;
        }.bind(this);

        /**
         * Ensures that the playhead value is always based off the initial, baseline playhead value. This makes
         * each playhead value exactly PLAYHEAD_EVENT_TICK ms greater than it's predecessor.
         *
         * @param {Number} playheadValue The playhead value to normalize.
         * @return {Number} The normalized playhead value.
         */
        var normalize = function (playheadValue) {
          // Only set the normalized value the first time, but do it after the very first playhead value
          // is greater than PLAYHEAD_EVENT_TICK (aka the number of milliseconds between metronome ticks).
          // After we have the baseline value in hand we normalize the playhead so that each playhead value
          // is static and always increases by Player.PLAYHEAD_EVENT_TICK ms.  In addition, we will only send
          // playhead events to the client evey Player.PLAYHEAD_EVENT_PLAYHEAD_EVENT_FREQUENCY ms
          if ((this._playheadNormalizer === -1) && (playheadValue > HlsConfig.PLAYHEAD_INTERVAL)) {
            this._playheadNormalizer = playheadValue % HlsConfig.PLAYHEAD_INTERVAL;
          }
          else if (this._playheadNormalizer >= 0) {
            playheadValue = round(playheadValue, PlayheadMonitor.PLAYHEAD_EVENT_TICK) + this._playheadNormalizer;
          }

          return playheadValue;
        }.bind(this);

        if (this._isStopped) {
          return this._aggregateSpan;
        }

        var currentSpan = this.currentZeroBasedTimeMilli() - this._spanStart;

        // this was the original but it allows for some variance and not a steady 1 second increase due to
        // async event handling to calculate the playhead and processing speed variances in general...so
        // we added the normalize wrapper method that follows
        var derivedPlayhead = this._aggregateSpan + currentSpan;

        // we added the normalize method to make sure the playhead comes out static, that is it will always
        // come out of the player increasing by 1000; eg: 545, 1545, 2545, 3545, ... Without this method
        // the playhead comes out with slight +/- 40ms due to asynchronous processing of the player.
        derivedPlayhead = normalize(derivedPlayhead);

        // always round down to prevent a runaway playhead that increases too fast and therefore jumps past
        // the live point
        // NOTE: BMR: Do not add the initial offset as we want the playhead value to always be zero based
        derivedPlayhead = Math.floor(derivedPlayhead);

        return derivedPlayhead;
      },

      /**
       * Implicit getter which will calculate the total playhead position (milliseconds) with a starting value of
       * zero initially; when seeking the "offset" value is used to maintain the current playhead position. This is
       * true of all finite playlists like AOD and MySXM but not for infinite ones like Live.
       *
       * Simply put, when playback starts the playhead will be zero. If a requested seek value is say 20000 ms
       * (20 secs into playback) then the "offset" property's value used in this method below will be 20000 ms, so
       * the actual playhead position is maintained. Meanwhile the getter for playhead will be reset to zero so
       * 20000 ms (offset) + 0 ms (playhead) = 20000 ms, the expected playhead time based on the seek request value.
       *
       * @param {Number} playhead - The precision to round to.
       * @return {Number} playhead value for finite playlists.
       */
      getFinitePlaylistPlayhead: function (playhead) {
        // get the infinite playlist's playhead value
        var derivedPlayhead = playhead;

        // this is a difference between the Live playhead and the AOD playhead -- Live always resets the start
        // time to the seek time so it's always a brand new day, but AOD is a finite playlist so it needs to
        // account for the seek time within a playlist which is accomplished by determining the delta of the
        // requested seek time and the playlist's start time, aka chunk zero's timestamp. then we add this "offset"
        // value to the zero-based playhead value.
        var offset = (this._initialChunkTimestamp + this._initialChunkOffset) - this.startTime;

        // always round down to prevent a runaway playhead that increases too fast and therefore jumps past
        // the live point
        derivedPlayhead = Math.floor(derivedPlayhead + offset);

        return derivedPlayhead;
      },

      /**
       * Read-only accessor to the initial offset value.
       */
      getInitialChunkOffset: function () {
        return this._initialChunkOffset;
      },

      /**
       * Gets the current time off of the renderer audio context.
       */
      audioContextCurrentTime: function () {
        return this._playback.audioSink ? this._playback.audioSink.renderer.currentTime : 0;
      },

      /**
       * Gets the current time off of the renderer audio context.
       */
      currentZeroBasedTimeMilli: function () {
        return Math.floor(this.audioContextCurrentTime() * 1000);
      },
      /**
       * Read-only accessor to the initial timestamp value.
       */
      getInitialChunkTimestamp: function () {
        return this._initialChunkTimestamp;
      },

      /**
       * Handles the internal timer's tick-tock callback and dispatches the playhead event.
       */
      onPlayheadTick: function () {
        if (this._playback) {
          this._playback.dispatchPlayerEvent(PlayerEvent.PLAYHEAD);
        }
      },

      /**
       * Listens for state change events from the AudioContext. If the player is not playing then
       * stop the timer.
       */
      onPlayerStateChange: function (event) {
        logger.debug("onPlayerStateChange( {0} )", [event.current]);

        // start or stop the playhead timer
        // wrapping it all in a try/catch due to the async nature of this method when handling state changes
        // it's possible to enter this method and for playback to be set to null
        try {
          if (this._playback) {
            if ((event.previous !== PlayerState.PLAYING) && (event.current === PlayerState.PLAYING)) {
              // Make sure this call's the super classes getPlayer() and not subclass implementations.
              // AOD and MySXM take into account starting offsets (aka pause points) that are
              // more than likely > 0, whereas the the base impl's playhead value  always starts at
              // zero when first starting playback and seeking.
              if (PlayheadMonitor.prototype.getPlayhead.call(this) === 0) {
                this._playback.dispatchPlayerEvent(PlayerEvent.PLAYHEAD_START);
                this._playback.dispatchPlayerEvent(PlayerEvent.PLAYHEAD);
              }

              logger.debug("onPlayerStateChange( Start monitor. )");
              this.start();
            }
            else if (event.current !== PlayerState.PLAYING) {
              logger.debug("onPlayerStateChange( Stop monitor as not playing, state = {0} )", [event.current]);
              this.stop();

              // Only broadcast a playhead event when stopped if we've actually been playing previously
              if (event.previous === PlayerState.PLAYING) {
                this._playback.dispatchPlayerEvent(PlayerEvent.PLAYHEAD);
              }
            }
          }

        }
        catch (error) {
          logger.error("onPlayerStateChange( The player is most likely being shutdown and playback is null. Error: {0} )", [
            error.message
          ]);
        }
      },

      /**
       * Resets the monitor.
       */
      reset: function () {
        logger.debug("reset()");

        this.stop();

        this._playback.removeEventListener(StateChangeEvent.STATE_CHANGE, this.onPlayerStateChange.bind(this));

        this._playheadTicker = null;
        this._playback = null;
      }

    };

    return PlayheadMonitor;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));




/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/PlayheadMonitorFactory.js":
/*!*****************************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/monitor/playhead/PlayheadMonitorFactory.js ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    12/17/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Indicates the playback type for a given player instance.
 */



!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlaybackTypeUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaybackTypeUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js");
  var LivePlayheadMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/playhead/LivePlayheadMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/LivePlayheadMonitor.js");
  var AODPlayheadMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/playhead/AODPlayheadMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/AODPlayheadMonitor.js");
  var MyPlayheadMonitor = __webpack_require__(/*! sxm/audioplayer/html5/monitor/playhead/MyPlayheadMonitor */ "./javascript/src/sxm/audioplayer/html5/monitor/playhead/MyPlayheadMonitor.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("PlayheadMonitorFactory");

  /**
   * Factory creation method to create a specific playhead monitor instance based on the playback type.
   *
   * @param {Playback} player - The playback instance containing the playback type.
   * @return {PlayheadMonitor} Playhead monitor instance based on the playback type.
   */
  var create = function (player) {
    var playheadMonitor;

    if (player && player.configuration) {
      switch (player.configuration.playbackType) {
        case PlaybackTypeUtil.LIVE:
          logger.debug("create( Creating Live Playhead Monitor )");
          playheadMonitor = new LivePlayheadMonitor(player);
          break;

        case PlaybackTypeUtil.AOD:
          logger.debug("create( Creating AOD Playhead Monitor )");
          playheadMonitor = new AODPlayheadMonitor(player);
          break;

        case PlaybackTypeUtil.MY:
          logger.debug("create( Creating My Playhead Monitor )");
          playheadMonitor = new MyPlayheadMonitor(player);
          break;

        case PlaybackTypeUtil.SEEDED:
        case PlaybackTypeUtil.MP4:
        case PlaybackTypeUtil.MP3:
          logger.debug("create( Creating My Playhead Monitor )");
          playheadMonitor = new MyPlayheadMonitor(player);
          break;

        default:
          logger.warn("create( Cannot create playhead monitor for type = {0} )", [
            player.configuration.playbackType
          ]);
      }
    }
    else {
      logger.warn("create( Player or config null: Player = {0}, Config = {1} )", [
        player, player.configuration
      ]);
    }

    return playheadMonitor;
  };

  var PlayheadMonitorFactory = {
    create: create
  };

  return PlayheadMonitorFactory;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js":
/*!**************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/31/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Allows for parsing of ADTS frames.
 */
/* beautify preserve:start */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  //----------------------------------------------------------------------------------------------------------
  // MODULE variables
  //----------------------------------------------------------------------------------------------------------

  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var BitUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/BitUtil */ "./javascript/src/sxm/audioplayer/html5/util/BitUtil.js");
  var AudioUtils = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
  var AacDecoder = __webpack_require__(/*! sxm/audioplayer/html5/audio/decoder/AacDecoder */ "./javascript/src/sxm/audioplayer/html5/audio/decoder/AacDecoder.js");

  var logger = LoggerFactory.getLogger("AdtsFrame");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * Construct an ADTS frame object
   *
   * @constructor
   */
  function AdtsFrame (mediaBuffer, index) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof AdtsFrame)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["AdtsFrame"]);
    }

    ClassUtils.bind(this, AdtsFrame);

    this.sbrResetFrame = false;
    this.mpegVersion = ~~0;
    this.layer = ~~0;
    this.crcPresent = false;
    this.profile = ~~0;
    this.samplingFrequencyIndex = ~~0;
    this.isPrivate = false;
    this.channelConfig = ~~0;
    this.originality = ~~0;
    this.home = ~~0;
    this.copyrightedID = ~~0;
    this.copyrightStart = ~~0;
    this.frameLength = ~~0;
    this.bufferFullness = ~0;
    this.numFrames = ~0;
    this.crc = ~0;
    this.bytes = null;
    this.startIndex = 0;
    this.headerLength = 0;
    this.rawDataStartIndex = 0;
    this.rawDataEndIndex = 0;
    this.rawDataLength = 0;

    // Set the bytes if they are provided.
    if (mediaBuffer) {
      index = (isNaN(index) || (index < 0)) ? 0 : index;
      this.setBytes(mediaBuffer, index);
    }
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Hash of enumerated values describing constants for the AacDecoder class.
   * @type {Object}
   */
  AdtsFrame.CONSTS = {
    ADTS_LAYER: 0,
    ADTS_MPEG4: 1,
    ADTS_MPEG2: 0,
    ADTS_FORBIDDEN_SFI: 15,
    ADTS_MS_PER_FRAME: AacDecoder.CONSTS.AAC_HE_SAMPLES_PER_FRAME * 1000 / AudioUtils.CONSTS.SAMPLERATES.SAMPLERATE_44KHZ,
    ADTS_FRAMES_BETWEEN_SBR: 10, // #ADTS frames before an SBR reset frame
    ADTS_MS_BETWEEN_SBR: 0, // #ADTS frames before an SBR reset frame
    ADTS_HEADER_LENGTH: 7, // Bytes x 8 (bits per byte)
    ADTS_VARIABLE_HEADER_LENGTH: 9, // Bytes x 8 (bits per byte)
    ADTS_MS_PER_ACCESS_UNIT: 0,
    ADTS_FRAMES_PER_ACCESS_UNIT: 210, // #ADTS frames that comprise an atomic access unit
    ID3_VALUE: 0x00494433, // value of the 24 bit ID3 tag in HEX.
    ID3_VERSION_OFFSET: 3, // number of bytes from start of ID3 tag where we find version
    ID3_FLAGS_OFFSET: 5, // number of bytes from start of ID3 tag where we find flags
    ID3_FOOTER_FLAG_MASK: 0x10, // for masking out the footer flag
    ID3_LENGTH_OFFSET: 6, // number of bytes from start of ID3 tag where we find length
    ID3_HEADER_SIZE: 10, // number of bytes in ID3 TAG header
    ID3_FOOTER_SIZE: 10 // number of bytes in ID3 TAG footer
  };

  AdtsFrame.CONSTS.ADTS_MS_BETWEEN_SBR =
    AdtsFrame.CONSTS.ADTS_MS_PER_FRAME * AdtsFrame.CONSTS.ADTS_FRAMES_BETWEEN_SBR;

  AdtsFrame.CONSTS.ADTS_MS_PER_ACCESS_UNIT =
    AdtsFrame.CONSTS.ADTS_MS_PER_FRAME * AdtsFrame.CONSTS.ADTS_FRAMES_PER_ACCESS_UNIT;

  /**
   * Looks for an ID3 tag in bytes starting at index.  It will do this using the ID3 (24 bit) tag value and
   * utilize the fact that the version bytes of the header will never be 0xFF and the length field in the
   * header has the MSB bit always set to zero.  This gives us the best chance (but is not an absolute
   * guarantee) of avoiding ID3 tag emulation in data streams that do not contain ID3 tag information.
   *
   * @param {Uint8Array} bytes to look for ID3 tag
   * @param {Number} index where to look for the ID3 tag in bytes
   *
   * @returns {Number} first byteindex after the ID3 TAG, or index if bytes[index] does not start with an ID3
   *   tag
   */
  AdtsFrame.skipID3TAG = function (bytes, index) {
    if ((BitUtil.grabUint24(bytes, index) === AdtsFrame.CONSTS.ID3_VALUE) &&
      (bytes[index + AdtsFrame.CONSTS.ID3_VERSION_OFFSET] < 0xff) &&
      (bytes[index + AdtsFrame.CONSTS.ID3_VERSION_OFFSET + 1] < 0xff) &&
      (bytes[index + AdtsFrame.CONSTS.ID3_LENGTH_OFFSET] < 0x80) &&
      (bytes[index + AdtsFrame.CONSTS.ID3_LENGTH_OFFSET + 1] < 0x80) &&
      (bytes[index + AdtsFrame.CONSTS.ID3_LENGTH_OFFSET + 2] < 0x80) &&
      (bytes[index + AdtsFrame.CONSTS.ID3_LENGTH_OFFSET + 3] < 0x80)) {
      var footerByte = bytes[index + AdtsFrame.CONSTS.ID3_FLAGS_OFFSET];
      var footerPresent = ((footerByte & AdtsFrame.CONSTS.ID3_FOOTER_FLAG_MASK) !== 0);

      index += BitUtil.grabSyncSafeUint28(bytes, index + AdtsFrame.CONSTS.ID3_LENGTH_OFFSET);
      index += AdtsFrame.CONSTS.ID3_HEADER_SIZE;
      index += (footerPresent === true) ? AdtsFrame.CONSTS.ID3_FOOTER_SIZE : 0;
    }

    return index;
  };

  /**
   * Find the next ADTS sync bytes in a given mediaBuffer from the given index
   *
   * @param {MediaBuffer} mediaBuffer contains Uint8Array to find the ADTS sync bytes
   * @param {Number} index is the index into MediaBuffer where the search for sync bytes should start
   *
   * @returns {Number} byte index with the first ADTS sync byte *after* index in mediaBuffer
   */
  AdtsFrame.findSync = function (mediaBuffer, index) {
    // Default index to zero.
    index = index || 0;

    var found = false;
    var bytes = mediaBuffer.bytes;
    var frameStartIndex;

    /**
     * Find the ADTS sync bytes, and return. The function is static and does not modify the
     * state of the object it is being called on.
     *
     * @param {MediaBuffer} mediaBuffer contains Uint8Array to find the ADTS frame
     * @param {Number} byteIndex is the index into MediaBuffer where the ADTS frame should start
     *
     * @returns number of byte index of the first byte after the ADTS frame that was just parsed
     */
    while ((found === false) && (index < bytes.length)) {
      frameStartIndex = index;
      var syncByte1 = ~~bytes[index++];
      var syncByte2 = ~~(bytes[index] & ~~0xF6);

      if ((syncByte1 === ~~0xFF) && (syncByte2 === ~~0xF0)) {
        found = true;
        break;
      }
    }

    if (!found) {
      logger.error("findSync( No sync, give up. )");
    }

    return (found === true) ? frameStartIndex : -1;
  };

  /**
   * Find the next ADTS frame starting at index. The function will check bytes starting at index to
   * find an ADTS frame, and once it has found a frame (by finding ADTS sync bytes followed by a frame
   * header that has a valid layer, samplingFrequencyIndex and mpgVersion), it will example the frame
   * length from the ADTS header and find the byte index of the *next* frame.
   *
   * This provides a quick way of iterating through ADTS frames to:
   *
   *   1) Count the number of ADTS frames within a given mediaBuffer.
   *   2) Find the start and stop index of an ADTS frame for later retrieval.
   *
   * @param {MediaBuffer} mediaBuffer - Contains Uint8Array to find the ADTS frame
   * @param {Number} index - Is the index into MediaBuffer where the ADTS frame should start
   *
   * @returns {Object|Number} that contains the index that the frames starts at and the length of the frame, or
   * -1 if no
   *          ADTS frame could be found starting at the specified byte index
   */
  AdtsFrame.findNextFrame = function (mediaBuffer, index) {
    var bytes = mediaBuffer.bytes;
    var sync = false;
    var byteIndex = index;
    var frameStartIndex;

    if (byteIndex < bytes.length) {

      frameStartIndex = AdtsFrame.findSync(mediaBuffer, byteIndex);

      if (frameStartIndex >= 0) {
        sync = true;
        byteIndex = frameStartIndex + 1;

        var mpgVersion = ((bytes[byteIndex] & ~~0x08) >> 3);
        var protectionAbsent = (bytes[byteIndex] & ~~0x01);
        var layer = ((bytes[byteIndex] & ~~0x06) >> 1);
        var samplingFrequencyIndex = ((bytes[byteIndex + 1] & ~~0x3C) >> 2);

        if ((layer !== AdtsFrame.CONSTS.ADTS_LAYER) ||
          (samplingFrequencyIndex === AdtsFrame.CONSTS.ADTS_FORBIDDEN_SFI) ||
          ((mpgVersion !== AdtsFrame.CONSTS.ADTS_MPEG2) && (mpgVersion !== AdtsFrame.CONSTS.ADTS_MPEG4))) {
          byteIndex = frameStartIndex + 1;
          logger.error("Invalid ADTS frame detected");
          sync = false;
        }
      }
    }

    if (sync === true) {

      var frameLength = ((bytes[byteIndex + 2] & 0x03) << 11) |
        (bytes[byteIndex + 3] << 3) |
        ((bytes[byteIndex + 4] & 0xe0) >> 5);

      var headerSize = (protectionAbsent) ? AdtsFrame.CONSTS.ADTS_HEADER_LENGTH
        : AdtsFrame.CONSTS.ADTS_VARIABLE_HEADER_LENGTH;

      return {
        index: frameStartIndex,
        payloadIndex: frameStartIndex + headerSize,
        length: frameLength,
        payloadLength: frameLength - headerSize
      };
    }

    return -1;
  };

  //-------------------------------------------------------------------------------------
  // NOT USED
  // While these are not currently used we'll keep them here in case we need them.
  //-------------------------------------------------------------------------------------

  // /**
  //  * Find the next ADTS frame index starting with a specific start index and skipping a certain number
  //  * of milliseconds.
  //  **
  //  * @param {MediaBuffer} mediaBuffer contains Uint8Array to find the ADTS frame
  //  * @param {Number} startByteIndex is the index into MediaBuffer to start looking
  //  * @param {Number} msecsToSkip is the number of milliseconds of ADTS frames to skip. Frames can
  //  *        only be skipped ADTS_FRAMES_BETWEEN_SBR at a time, so if msecsToSkip is not an integer number
  //  *        of ADTS_FRAMES_BETWEEN_SBR, then the index that is returned will be
  //  *        msecsToSkip % ADTS_FRAMES_BETWEEN_SBR milliseconds early
  //  *
  //  * @returns {Number} byte index of the first byte after skipping msecsToSkip ADTS frames in mediaBuffer
  //  *          starting at startByteIndex
  //  */
  // AdtsFrame.findFrameByMsOffset = function(mediaBuffer, startByteIndex, msecsToSkip)
  // {
  //   var frameMsOffset = 0;
  //   var nextFrameByteIndex = startByteIndex;
  //   var frameIndex = 0;
  //
  //   while (msecsToSkip > frameMsOffset && nextFrameByteIndex > 0) {
  //
  //     var nextFrame = AdtsFrame.findNextFrame(mediaBuffer, nextFrameByteIndex);
  //
  //     if (nextFrame !== -1) {
  //       nextFrameByteIndex = nextFrame.index + nextFrame.length;
  //     }
  //     else {
  //       nextFrameByteIndex = -1;
  //     }
  //
  //     frameIndex    += 1;
  //     frameMsOffset += AdtsFrame.CONSTS.ADTS_MS_PER_FRAME;
  //
  //     if ((frameIndex % AdtsFrame.CONSTS.ADTS_FRAMES_BETWEEN_SBR) === 0) {
  //       startByteIndex = nextFrameByteIndex; // skip to the end of this frame
  //     }
  //   }
  //
  //   return (nextFrameByteIndex > 0) ? startByteIndex : -1;
  // };
  //
  // /**
  //  * Find the next ADTS frame index starting with a specific start index and skipping a certain number
  //  * of frames.
  //  **
  //  * @param {MediaBuffer} mediaBuffer contains Uint8Array to find the ADTS frame
  //  * @param {Number} startByteIndex is the index into MediaBuffer to start looking
  //  * @param {Number} offset is the number of ADTS Frames that the returned byte offset should be from
  //  *        startByteOffset
  //  *
  //  * @returns {Number} byte index of the ADTS frame that is offset frames away for the frame at
  //  * startByteIndex
  //  */
  // AdtsFrame.findFrameByFrameOffset = function(mediaBuffer,startByteIndex,offset)
  // {
  //   var endByteIndex = startByteIndex;
  //
  //   for (var i = 0; i < offset; i++) {
  //     var nextFrame = AdtsFrame.findNextFrame(mediaBuffer,endByteIndex);
  //
  //     if (nextFrame < 0) {
  //       endByteIndex = -1;
  //       break;
  //     }
  //     else {
  //       endByteIndex = nextFrame.index + nextFrame.length;
  //     }
  //   }
  //
  //   return endByteIndex;
  // };

  /**
   * Find the index of the last ADTS frame in the mediaBuffer
   **
   * @param {MediaBuffer} mediaBuffer contains Uint8Array to find the ADTS frame
   * @param {Number} startByteIndex is the index into MediaBuffer to start looking
   *
   * @returns {Object} that contains the index that the frames starts at and the length of the frame, or -1 if no
   *          ADTS frame could be found starting at the specified byte index
   */
  AdtsFrame.findLastFrame = function (mediaBuffer, startByteIndex) {
    var endByteIndex = startByteIndex;
    var lastFrame = -1;
    var nextFrame;

    do {

      nextFrame = AdtsFrame.findNextFrame(mediaBuffer, endByteIndex);

      if (nextFrame !== -1) { // ran out of frames
        lastFrame = nextFrame;
        endByteIndex = nextFrame.index + nextFrame.length;
      }
    } while (nextFrame !== -1);

    return lastFrame;
  };

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead. We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a new class which extended our AudioRenderBuffer class, we could write:
   *
   *  `NewClass.prototype = AudioRenderBuffer.prototype`
   *  `NewClass.prototype.constructor = NewClass`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  ClassUtils.baseClass(AdtsFrame).prototype = {

    /**
     * Find the ADTS packet header starting from index in bytes. Values from the header are captured
     * in object properties to be accessed later, and the byte array from mediaBuffer is also captured
     *
     * @param {MediaBuffer} mediaBuffer contains Uint8Array to find the ADTS frame
     * @param {Number} index is the index into MediaBuffer where the ADTS frame should start
     *
     * @returns number of byte index of the first byte after the ADTS frame that was just parsed
     */
    setBytes: function (mediaBuffer, index) {
      var bytes = mediaBuffer.bytes;
      var found = false;

      var byteIndex = index;

      while ((found === false) && (byteIndex < bytes.length)) {
        var frameStartIndex = AdtsFrame.findSync(mediaBuffer, byteIndex);

        if ((byteIndex < 0) || (frameStartIndex === -1)) {
          break;
        }

        byteIndex = frameStartIndex + 1;
        var syncStartIndex = byteIndex;

        // NOTE: Only uncomment this for debugging purposes.
        // logger.debug("setBytes( DEBUGGING ONLY >> syncStartIndex = {0}. )", [syncStartIndex]);

        this.mpgVersion = ((bytes[byteIndex] & ~~0x08) >> 3);
        this.layer = ((bytes[byteIndex] & ~~0x06) >> 1);
        this.crcPresent = ((bytes[byteIndex++] & ~~0x01) !== 1);
        this.profile = ((bytes[byteIndex] & ~~0xC0) >> 6);
        this.samplingFrequencyIndex = ((bytes[byteIndex] & ~~0x3C) >> 2);
        this.isPrivate = ((bytes[byteIndex] & ~~0x02) === ~~0x02);
        this.channelConfig = ((bytes[byteIndex++] & ~~0x01) << 3) | ((bytes[byteIndex] & ~~0xC0) >> 6);
        this.originality = ((bytes[byteIndex] & ~~0x20) >> 1);
        this.home = (bytes[byteIndex] & ~~0x10);
        this.copyrightedID = ((bytes[byteIndex] & 0x08) >> 3);
        this.copyrightStart = ((bytes[byteIndex] & 0x04) >> 2);
        this.frameLength = ((bytes[byteIndex++] & 0x03) << 11) | (bytes[byteIndex++] << 3) | ((bytes[byteIndex] & 0xe0) >> 5);
        this.bufferFullness = ((bytes[byteIndex++] & 0x1f) << 6) | ((bytes[byteIndex] & 0xfc) >> 2);
        this.numFrames = (bytes[byteIndex++] & 0x03);
        this.crc = (this.crcPresent === true) ? (bytes[byteIndex++] << 8) | bytes[byteIndex++] : 0;
        this.headerLength = this.crcPresent ? AdtsFrame.CONSTS.ADTS_VARIABLE_HEADER_LENGTH : AdtsFrame.CONSTS.ADTS_HEADER_LENGTH;
        this.rawDataStartIndex = this.headerLength;
        this.rawDataEndIndex = this.rawDataStartIndex + (this.frameLength - this.headerLength);
        this.rawDataLength = this.frameLength - this.headerLength;

        if ((this.layer !== AdtsFrame.CONSTS.ADTS_LAYER) ||
          (this.samplingFrequencyIndex === AdtsFrame.CONSTS.ADTS_FORBIDDEN_SFI) ||
          ((this.mpgVersion !== AdtsFrame.CONSTS.ADTS_MPEG2) && (this.mpgVersion !== AdtsFrame.CONSTS.ADTS_MPEG4))) {
          byteIndex = syncStartIndex;
          logger.error("setBytes( Invalid ADTS frame detected. )");
          break;
        }

        found = true;
        this.startIndex = frameStartIndex;

        // Set the exact bytes for this frame that includes both the ADTS frame header and the
        // accompanying raw AAC audio data from the incoming media buffer's byte array.
        this.bytes = mediaBuffer.arrayBuffer.slice(index, index + this.rawDataEndIndex);
      }

      if (found === false) {
        return -1;
      }

      return this.startIndex + this.frameLength;
    }
  };

  return AdtsFrame;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsParser.js":
/*!***************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsParser.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************************************************************
 * @MODULE:     AdtsParser
 * @CREATED:    4/16/2019
 * @COPYRIGHT:  2019 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Parser for ADTS chunk data
 **********************************************************************************************************************/
/* beautify preserve:start */



/*******************************************************************************************************************
 * Register the module with RequireJS.
 ******************************************************************************************************************/
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  //----------------------------------------------------------------------------------------------------------
  // CLASS members
  //----------------------------------------------------------------------------------------------------------

  var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var AdtsFrame = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");
  var MediaBuffer = __webpack_require__(/*! sxm/audioplayer/html5/model/MediaBuffer */ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js");
  var AudioUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");

  //----------------------------------------------------------------------------------------------------------
  // CONSTRUCTOR
  //----------------------------------------------------------------------------------------------------------

  /**
   * AdtsParser Constructor
   *
   * @param {MediaBuffer} media buffer that contains ADTS data to parse
   */
  function AdtsParser(mediaBuffer) {

    this._index = 0;

    Object.defineProperty(this, "mediaBuffer",
      {
        get: function () {
          return mediaBuffer;
        }
      });

    ClassUtils.bind(this, AdtsParser);
  };

  //----------------------------------------------------------------------------------------------------------
  // PROTOTYPE Inherit AudioDecodeContext's prototype and restore AacDecoder's constructor
  //----------------------------------------------------------------------------------------------------------

  ClassUtils.baseClass(AdtsParser).prototype = {

    index: ClassUtils.createPropertyDescriptor(
      {
        get: function () {
          return this._index;
        },
        set: function (value) {
          this._index = value;
        }
      }),

    getAACFrames: function (numFrames) {
      var frameArrayBuffers = [];
      var frameDescriptor;

      while ((frameDescriptor = AdtsFrame.findNextFrame(this.mediaBuffer, this.index)) !== -1
      && numFrames-- > 0) {
        this.index = frameDescriptor.index + frameDescriptor.length;
        frameArrayBuffers.push(this.mediaBuffer.arrayBuffer.slice(frameDescriptor.index, this.index));
      }

      if (frameArrayBuffers.length === 0) {
        return undefined;
      }

      return new MediaBuffer(
        AudioUtil.concatArrayBuffers(frameArrayBuffers),
        0,
        this.mediaBuffer.isAACPlus,
        this.mediaBuffer.isMP4
      );
    }
  };

  return AdtsParser;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/protocols/hls/ManifestParser.js":
/*!******************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/protocols/hls/ManifestParser.js ***!
  \******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var loggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var Variant = __webpack_require__(/*! sxm/audioplayer/html5/model/Variant */ "./javascript/src/sxm/audioplayer/html5/model/Variant.js");
  var Stream = __webpack_require__(/*! sxm/audioplayer/html5/model/Stream */ "./javascript/src/sxm/audioplayer/html5/model/Stream.js");
  var Playlist = __webpack_require__(/*! sxm/audioplayer/html5/model/Playlist */ "./javascript/src/sxm/audioplayer/html5/model/Playlist.js");
  var DecryptKey = __webpack_require__(/*! sxm/audioplayer/html5/model/DecryptKey */ "./javascript/src/sxm/audioplayer/html5/model/DecryptKey.js");
  var PlaylistUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/PlaylistUtil */ "./javascript/src/sxm/audioplayer/html5/util/PlaylistUtil.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  var logger = loggerFactory.getLogger("ManifestParser");

  //-----------------------------------------------------------------------
  // PROTECTED VARIABLES
  //-----------------------------------------------------------------------

  // *******************************************************
  // RegExp Patters for Variant files
  // *******************************************************

  var PATTERN_VARIANT_UID = new RegExp("^#EXT-X-STREAM-INF:PROGRAM-ID=.*[\n|\r]+^(.*)$", "gm");
  var PATTERN_STREAM_INFO = new RegExp(
    "^#EXT-X-STREAM-INF:PROGRAM-ID=[0-9]+,BANDWIDTH=([0-9]+),CODECS=\"([a-z0-9.,]+)\".*[\n|\r]+^(.*)$", "m");

  // *******************************************************
  // RegExp Patters for Playlist files
  // *******************************************************

  // NOTE: A live SXM playlist should never have this tag as live is an infinite (never ending) radio stream
  // whereas AOD and MySXM are finite and will have this tag
  var PATTERN_IS_NOT_LIVE = new RegExp("#EXT-X-ENDLIST");
  var PATTERN_PLAYLIST_UID = new RegExp("#EXT-X-MEDIA-SEQUENCE:(.[0-9]*)");

  // *******************************************************
  // RegExp Patters for Decryption key
  // *******************************************************

  // var PATTERN_DECRYPTION_KEY = new RegExp("#EXT-X-KEY:METHOD=(.*),URI=\"(.*)\"");
  // var PATTERN_DECRYPTION_KEY_LIST = new RegExp("#EXT-X-KEY:METHOD=(.*)(,URI=\"(.*)\",(.*))?", "gm");
  var PATTERN_DECRYPTION_KEY_LIST = new RegExp("#EXT-X-KEY:METHOD=(.*)", "gm");
  var PATTERN_EMBEDDED_KEY = new RegExp("data:;base64,(.*)");
  var PATTERN_KEY_START = "#EXT-X-KEY:";

  // *******************************************************
  // RegExp Patters for AOD and MySXM
  // *******************************************************

  var PATTERN_CHUNK_LIST = new RegExp("^#EXTINF:([0-9.]*),(.*)[\n|\r]+^(.*)$", "gm");
  var PATTERN_CHUNK = new RegExp("#EXTINF:([0-9.]*),(.*)[\n|\r]+^(.*)", "m");

  // *******************************************************
  // RegExp Patters for Live
  // *******************************************************

  //var PATTERN_LIVE_CHUNK_NAMES = new RegExp("^\w*(.*\.aac)\w*$", "gm");
  var PATTERN_LIVE_CHUNK_NAMES = new RegExp("^\\w*(.*\\.aac.*)\\w*$", "gm");
  //var PATTERN_LIVE_CHUNK_TIMES = new RegExp("#EXT-X-PROGRAM-DATE-TIME:(.*)\\w*$", "gm");
  var PATTERN_LIVE_CHUNK_TIMES = new RegExp("[0-9]+-[0-9]+-[0-9]+T[-0-9:]+.[-0-9]+[+|-]+[-0-9]+:[-0-9]+", "gm");
  //var PATTERN_LIVE_CHUNK_TIMES = new RegExp("/#EXT-X-PROGRAM-DATE-TIME:(.*)/g");

  //-----------------------------------------------------------------------
  // PROTECTED FUNCTIONS
  //-----------------------------------------------------------------------

  /**
   * Parses a raw manifest file's string data and returns a Variant domain model.
   *
   * @param {String} data The raw data from the manifest file.
   * @param {String} url The URL to the loaded manifest.
   * @return {Variant} A variant data model.
   */
  var parseVariant = function (data, url) {
    var streams = [];
    var streamsFromData = data.match(PATTERN_VARIANT_UID);

    if (!ObjectUtil.isUndefinedOrNull(streamsFromData) && (streamsFromData.length > 0)) {
      logger.debug("parseVariant( url = {0} )", [url]);

      for (var j = 0; j < streamsFromData.length; j++) {
        var blob = String(streamsFromData[j]);
        var info = PATTERN_STREAM_INFO.exec(blob);
        var bitRate = info ? Number(info[1]) : 0;
        var codecs = info ? String(info[2]).split(",") : null;
        var streamUrl = String(info[3]);

        var stream = new Stream(updateURLs(url, streamUrl), codecs, bitRate);
        streams.push(stream);
      }
    }

    return streams && streams.length ? new Variant(data, streams, url) : null;
  };

  /**
   * Parses a raw manifest file's string data and returns a playlist.
   *
   * @param {String} data The raw data from the manifest file.
   * @param {String} url The URL to the loaded manifest.
   * @return {Playlist} A playlist data model.
   */
  var parsePlaylist = function (data, url) {
    logger.debug("parsePlaylist( url = {0} )", [url]);

    var sequence = data.match(PATTERN_PLAYLIST_UID);
    var isPlaylist = sequence && (sequence.length > 0);
    var isLive = (data.match(PATTERN_IS_NOT_LIVE) || []).length <= 0;
    var chunkUrls = [];
    var chunkTimeStamps = [];
    var chunkDurations = [];
    var chunkDecryptors = [];
    var duration = 0;

    /**
     * Parse fixed listing of AOD or MySXM chunks and times.
     */
    var parseFixed = function () {
      var list = data.match(PATTERN_CHUNK_LIST) || [];
      var aodTimes = data.match(PATTERN_LIVE_CHUNK_TIMES) || [];
      var isAOD = (aodTimes.length > 0);
      var row = [];
      var defaultDateTime = new Date(2000, 0, 1).getTime();

      // NOTE: MySXM chunk start times are constructed using chunk duration values converted to
      // epoch dates with a first date of `defaultDateTime`. Without using a real, base date,
      // the default first time is zero and then the playlist can't locate a legit timestamp.

      for (var j = 0; j < list.length; j++) {
        row = PATTERN_CHUNK.exec(list[j]);

        // Insert program-date string or accumulated secs from start...
        chunkTimeStamps.push(isAOD ? aodTimes[j] : new Date(defaultDateTime + (duration * 1000)));

        // Insert chunk url ( usually relative )
        chunkUrls.push(row[3]);

        // save each chunk duration
        chunkDurations.push(Number(row[1]));

        // Prepare next chunk start time as aggregation of
        // all previous chunk durations...
        duration += Number(row[1]);
      }

      // make all of the string timestamps legit Date objects
      chunkTimeStamps = (chunkTimeStamps || []).map(PlaylistUtil.convertToDates);

      if (isAOD) {
        duration = updateAODDuration(chunkTimeStamps, duration) / 1000;
      }

      return chunkUrls && (chunkUrls.length > 0);
    };

    /**
     * Parse Live/AOD listings of chunks and times...
     */
    var parseLive = function () {
      var list = data.match(PATTERN_CHUNK_LIST) || [];
      chunkUrls = data.match(PATTERN_LIVE_CHUNK_NAMES) || [];
      chunkTimeStamps = (data.match(PATTERN_LIVE_CHUNK_TIMES) || []).map(PlaylistUtil.convertToDates);
      var row = [];

      for (var j = 0; j < list.length; j++) {
        row = PATTERN_CHUNK.exec(list[j]);

        // save each chunk duration
        chunkDurations.push(Number(row[1]));
      }

      // NOTE: Live does not support concept of `duration`...

      if (chunkUrls.length > 0) {
        duration = undefined;
      }

      return (chunkUrls.length > 0);
    };

    /**
     * Parse chunk decryption key... the URI indicates either
     *      a) An external, remote key url.
     *      b) An embedded, base64 encoded byteArray.
     *
     * @return {Array}
     */
    var parseDecryptors = function () {
      var list = data.match(PATTERN_DECRYPTION_KEY_LIST) || [];

      for (var j = 0; j < list.length; j++) {

        var row = list[j].slice(PATTERN_KEY_START.length);
        var params = row.split(",");
        var vector = "0x" + String(sequence[1]);
        var type = "";
        var keyUrl = "";
        var initialationVector = "";

        params.forEach(function (param) {
          var keyValuePair = param.split('=');

          if (!keyValuePair) {
            return;
          }

          switch (keyValuePair[0]) {
            case 'METHOD':
              type = keyValuePair[1];
              break;
            case 'URI':
              keyUrl = JSON.parse(keyValuePair[1]);
              break;
            case 'IV':
              initialationVector = keyValuePair[1];
              break;
            default:
              logger.warn("We are ignoring the {0}= {1} in the chunk keys )", [keyValuePair[0], keyValuePair[1]]);
          }
        });

        var embedded = PATTERN_EMBEDDED_KEY.exec(keyUrl);
        if (embedded) {
          logger.debug("parseDecryptor( embedded = {0}, type = {1} )", [String(embedded), type]);
        }

        if (row) {
          var keyUrlUpdated = (keyUrl !== "") ? updateURLs(url, keyUrl) : null;
          var decryptor = new DecryptKey(keyUrlUpdated, type, initialationVector || vector);

          chunkDecryptors.push(decryptor);
          // TODO: BMR
          //if(embedded)
          //{
          //	decryptor.decodeKey(embedded[1], true);
          //}
        }
      }
      return chunkDecryptors;
    };

    /**
     * MySXM chunk durations are Number values parsed from #EXTINF: tags
     * But AOD durations are not accurate and must be derived from chunk start times;
     * which are Date values parsed from #EXT-X-PROGRAM-DATE-TIME: tags
     *
     * @param {Array} allTimes All of the chunk times.
     * @param {number} duration Total duraiton for the playlist.
     * @returns {number}
     */
    var updateAODDuration = function (allTimes, duration) {
      var count = allTimes.length;
      var firstChunkStart = count ? allTimes[0] : null;

      // So if these are AOD times... we need to calculate the duration of the last chunk

      if (firstChunkStart && (count > 1)) {
        var lastChunkStart = allTimes[count - 1];
        var lastChunkDuration = duration / count; // approximate guess

        // Attempt to calculate TOTAL duration has delta between
        // chunk starts for 1st and Last chunks + ~duration of last chunk

        duration = (lastChunkStart.getTime() - firstChunkStart.getTime()) + (lastChunkDuration * 1000);
      }

      return duration;
    };

    if (isPlaylist) {
      // If this is a Live, AOD, or MySXM playlist then create a playlist
      if ((isLive && parseLive()) || parseFixed()) {
        var playlist = new Playlist(data, updateURLs(url, chunkUrls), chunkTimeStamps, chunkDurations, parseDecryptors(),
          url, isLive, duration * 1000);

        if (!playlist.isLive) {
          logger.debug("parsePlaylist( duration = {0} msecs )", [playlist.duration]);
        }

        return playlist;
      }
    }

    return null;
  };

  /**
   * Convert all relative URLs to absolute URLs using the manifest URL as the base context.
   *
   * TODO: BMR: Consider putting this in URLUtils
   *
   * @param {String|Array} baseUrl - Base HLS asset URL.
   * @param {String|Array} urlList - Single string or list of URL strings.
   * @return {String|Array}
   */
  var updateURLs = function (baseUrl, urlList) {
    var index = baseUrl.lastIndexOf("/");
    var path = baseUrl.substring(0, index + 1);

    if (ObjectUtil.isString(urlList)) {
      return path + urlList;
    }
    else if (ObjectUtil.isArray(urlList)) {
      return urlList.map(function (element) {
        return path + element;
      });
    }
  };

  /**
   * Parse the manifest data and build either a Variant instance or a Playlist instance.
   *
   * @param {String} data The raw data from the manifest file.
   * @param {String} url The URL to the loaded manifest.
   * @return {Variant|Playlist} A varient or playlist data model.
   */
  var parse = function (data, url) {
    logger.debug("parse( url = {0} )", [url]);

    return parseVariant(data, url) || parsePlaylist(data, url);
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * Value returned in the constructor
   */
  var instance = {
    parse: parse
  };

  return instance;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP3File.js":
/*!***********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP3File.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    04/19/19
 * @COPYRIGHT:  2019 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *  MP3File class Allows for parsing of MP4 files
 */
/* beautify preserve:start */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
    //----------------------------------------------------------------------------------------------------------
    // MODULE variables
    //----------------------------------------------------------------------------------------------------------

    var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
    var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
    var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
    var BitUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/BitUtil */ "./javascript/src/sxm/audioplayer/html5/util/BitUtil.js");
    var AudioUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
    var MediaBuffer = __webpack_require__(/*! sxm/audioplayer/html5/model/MediaBuffer */ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js");
    var AdtsFrame = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");

    var logger = LoggerFactory.getLogger("MP3File");

    //-----------------------------------------------------------------------
    // CONSTRUCTOR
    //-----------------------------------------------------------------------

    /**
     * Construct an ADTS frame object
     *
     * @constructor
     */
    function MP3File(mediaBuffer) {
        // This first guard ensures that the callee has invoked our Class' constructor function
        // with the `new` keyword - failure to do this will result in the `this` keyword referring
        // to the callee's scope (typically the window global) which will result in the following fields
        // (name and _age) leaking into the global namespace and not being set on this object.
        if (!(this instanceof MP3File)) {
            throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["AdtsFrame"]);
        }

        this.mediaBuffer = mediaBuffer;

        this.id3headerOffset = 0;

        this.contentRange =  null;

        /**
         * Holds the VBR info of a track.
         */
        this.vbr = null;

        // defaulting the sampleDuration to AACPlus as we are not seeing this inforamtion as part of un-fragmented sxm mp4
        // and for fragmented Mp4 if we get the sample duration as part of the Mp4 header box- we will updated accorodingly
        this.sampleDuration = AdtsFrame.CONSTS.ADTS_MS_PER_FRAME;

        defineProperties(this);

        ClassUtils.bind(this, MP3File);
    }

    function defineProperties(self) {
        var mp3Boxes;
        var chunkDescriptors;
        var sampleRate;


        Object.defineProperty(self, 'mp3Boxes',
            {
                get: function () {
                    if (!mp3Boxes) {
                        mp3Boxes = this.getBoxes(0);
                    }
                    return mp3Boxes;
                },
                set: function (value) {
                    mp3Boxes = value;
                }
            });


        Object.defineProperty(self, 'chunkCount',
            {
                get: function () {
                    var stco = this.findBox(this.mp3Boxes, "stco");
                    return !!stco ? BitUtil.grabUint32(this.mediaBuffer.bytes, stco.payloadStart) : 0;
                }
            });

        Object.defineProperty(self, 'chunkDescriptors',
            {
                get: function () {
                    if (!chunkDescriptors || chunkDescriptors.length === 0 ) {
                        chunkDescriptors = this.getChunkOffsets();
                    }

                    return chunkDescriptors;
                },
                set: function (value) {
                    chunkDescriptors = value;
                }
            });

        Object.defineProperty(self, 'sampleRate',
            {
                get: function () {
                    return sampleRate || AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_44KHZ;
                },
                set: function (value) {
                    sampleRate = value;
                }
            });
    }

    //-----------------------------------------------------------------------
    // STATIC MEMBERS
    //-----------------------------------------------------------------------

    /**
     * Hash of enumerated values describing constants for the AacDecoder class.
     * @type {Object}
     */
    MP3File.CONSTS = {
        LENGTH_FIELD_SIZE: 4,
        BOX_TYPE_FIELD_SIZE: 4,
        XING_OFFSETS: {
            1: { 1: 17, 2: 32 },
            2: { 1: 9,  2: 17 }
        },
        /**
         * Samples per frame table:
         * the number of samples per frame is calculated based on the mpeg version and layer
         */
        SAMPLES_PER_FRAME: {
            1: {0: 0, 1: 384, 2: 1152, 3: 1152},
            2: {0: 0, 1: 384, 2: 1152, 3: 576}
        },
        /**
         * Bitrates table:
         * the bitrate value is calculated based on the mpeg version and layer
         */
        BITRATES: {
            1: {
                1: [0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 0],
                2: [0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 0],
                3: [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 0],
                4: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            2: {
                1: [0, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 0],
                2: [0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, 0],
                3: [0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, 0],
                4: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
        },
        /**
         * Sample rate table:
         * the sample rate value is calculated based on the mpeg version
         */
        SAMPLE_RATES: {
            1: [44100, 48000, 32000, 0],
            2: [22050, 24000, 16000, 0]
        }
    };

    ClassUtils.baseClass(MP3File).prototype = {

        /**
         * Get a an array of all the child boxes that the given parent box contains and al the child bnoxes
         * contained within those children.  If this function is run on an entire media buffer it will get all the
         * top level boxes and all the children for those boxes.
         *
         * @param index where to start in the media buffer to look for child boxes
         * @param parentEndIndex where top stop in the media buffer looking for child boxes
         *
         * @returns {Array} of child boxes given the input parameters
         */
        getBoxes: function (index, parentEndIndex) {
            var bytes = this.mediaBuffer.bytes;
            var children = [];

            if (!parentEndIndex || parentEndIndex >= bytes.length) {
                parentEndIndex = bytes.length - 1;
            }

            while (index < parentEndIndex) {
                var child = this.getBoxMap(index);

                if (!!child) {
                    index += child.length;
                    children.push(child);
                } else {
                    break;
                }
            }

            return children;
        },

        /**
         * Get the box map of a single box.  Box map is an object that will contain the generic metadata
         * about the box, and am array of children for the box
         *
         * @param {MediaBuffer} mediaBuffer contains Uint8Array with data to parse for the box
         * @param {Number} index is the index into MediaBuffer where parsing should start
         *
         */
        getBoxMap: function (index) {

            // Use the DataView for parsing the data. Don't use splice or modification on the buffer value
            // as that will cause performance degradation as the data buffer gets larger
            var dataView = new DataView(this.mediaBuffer.arrayBuffer,index);
            var box = this._parse(dataView);

            if (!box) {
                return null;
            }
            box.length= box.frameSize;
            box.type= 'frame';
            box.name= "audio_frame";
            box.payloadStart= index;
            box.startIndex= index;
            box.payloadEnd= index + box.frameSize;
            box.endIndex= index + box.frameSize;
            return box;
        },

        /**
         * Find a box by name in the array of boxes.  Searches children as well
         *
         * @param boxes is an array of boxes
         * @param name of the box to find
         *
         * @returns the box with the given name, or undefined if the box could not be found.
         */
        findBox: function (boxes, name) {
            var foundBox;

            /*
             * This is an unconventional use of the array find function.  To find the box we want, we have to
             * search not only through the boxes array but also through the children of the boxes we find in that
             * array and their children as well so on and so forth.
             *
             * Find is nice because it stops once the box we are looking for is found.  But, since we are calling
             * recursively into other arrays, the top level find can only return a box from the top level array.
             *
             * To address this, the find function returns true if a box or its children has the desired box, but
             * it will also set the foundBox closure variable with the actual box that was found, either in the
             * current array or from one of the recursive calls to findBox.
             */
            boxes.find(function (box) {
                var found = box.name === name;
                foundBox = (!found) ? this.findBox(box.children, name) : box;
                return (!!foundBox);
            }.bind(this));

            return foundBox;
        },

        /**
         * Get the raw chunk offsets in the mdat box from the stco box.  This will allow pulling individual chunks
         * from the mdat box
         *
         * @param mp3Boxes contains the mp4 box information for the mp4 file
         * @param mediaBuffer contains the data for the MP3 file
         *
         * @returns {Array} array of objects containing the start index and frame size of each elementary frame
         *          within the mdat box
         */
        getChunkOffsets: function () {
            var mdatChunks = [];

            if (this.mediaBuffer.length === 0) {
                return [];
            }

            var sampleFrame = this.vbr ? this.mp3Boxes[1] : this.mp3Boxes[0];
            var minFrames = Math.ceil(sampleFrame.samplerate/sampleFrame.num_samples);
            var totalSampleCount = Math.ceil((this.contentRange - this.id3headerOffset)/sampleFrame.frameSize);
            var allChunksPulled = false;
            if(this.contentRange === this.mediaBuffer.length)
            {
                //If we have all the buffer, the take the total count from the mp3boxes length, which will be accurate
                totalSampleCount = this.mp3Boxes.length;
                allChunksPulled = true;
            }

            for (var index = 0; index < (totalSampleCount - 1);) {
                var endIndex = index + minFrames;
                endIndex = (endIndex  > this.mp3Boxes.length -1) && allChunksPulled ? (this.mp3Boxes.length - 1) : endIndex;

                //Fake chunk descriptors
                if(endIndex  > this.mp3Boxes.length - 1)
                {
                    var mdat = mdatChunks[mdatChunks.length - 1];

                    mdatChunks.push({
                        startIndex: mdat.startIndex + mdat.chunkSize,
                        chunkSize: mdat.chunkSize,
                        framesInChunk: [],
                        endIndex: mdat.startIndex + mdat.chunkSize + mdat.chunkSize
                    });

                    // minFrames = this.mp3Boxes.length - index - 1;
                }
                else {

                    mdatChunks.push({
                        startIndex: this.mp3Boxes[index].payloadStart,
                        chunkSize: this.mp3Boxes[endIndex].payloadStart - this.mp3Boxes[index].payloadStart,
                        framesInChunk: this.mp3Boxes.slice(index, endIndex),
                        endIndex: this.mp3Boxes[index].payloadStart + this.mp3Boxes[endIndex].payloadStart - this.mp3Boxes[index].payloadStart
                    });
                }

                index =  endIndex;
            }

            return mdatChunks;
        },

        appendData: function (arrayBuffer, contentRange) {

            this.contentRange = contentRange;

            // Creating this local state to run the below header logic only for the first buffer.
            // or We can directly used arrayBuffer.byteLength === newArrayBuffer.byteLength
            var isFirstArrayBuffer = (this.mediaBuffer.arrayBuffer.byteLength === 0);
            
            var newArrayBuffer = AudioUtil.concatArrayBuffers(
                [
                    this.mediaBuffer.arrayBuffer,
                    arrayBuffer
                ]
            );

            this.mediaBuffer = new MediaBuffer(
                newArrayBuffer,
                0,
                this.mediaBuffer.isAACPlus,
                this.mediaBuffer.isMP3
            );

            if (isFirstArrayBuffer) {
                this.id3headerOffset = this.readId3Header(arrayBuffer);
                var sampleFrame = this.getBoxMap(this.id3headerOffset);
                this.vbr = this.readVbrHeader(arrayBuffer, this.id3headerOffset, sampleFrame.mpeg_version, sampleFrame.channels);

                //If the track is a VBR, then we need to ignore the first frame of the track as it has vbr info
                // we get the second frame in the buffer and use the  sample bitrate of the 2nd frame for duration
                if(this.vbr)
                {
                    sampleFrame = this.getBoxMap(sampleFrame.payloadEnd);
                }
                this.sampleDuration = (sampleFrame.num_samples/sampleFrame.samplerate) * 1000;
                // you have to multiply by *8, as we need total no of bits which equal totalBytes * 8
                // and you have to multiply *1000--> for duration in ms
                this.duration = (((this.contentRange - this.id3headerOffset) * 8)/sampleFrame.bitrate) *1000;
            }

            try {
                var lastMp3Box = this.mp3Boxes.length > 0 ? this.mp3Boxes[this.mp3Boxes.length - 1] : null;
                var offset = lastMp3Box ? lastMp3Box.payloadEnd : this.id3headerOffset;
                var mp3Boxes = this.getBoxes(offset);

                this.mp3Boxes = this.mp3Boxes.concat(mp3Boxes);
                this.chunkDescriptors = this.getChunkOffsets();
            } catch (error) {
                // Usually this means we do not have enough data to get all the boxes yet
                logger.error("Error {0} encountered getting MP3 box information", [error]);
            }
        },

        readId3Header: function (arrayBuffer) {
            //TODO: currenlty only doing for ID3v2 as it's header is at start of the buffer

            // Check if the track is ID3V1 or not by reading the last 128 bytes (ID3v1), C
            // var v1HeaderBuf = arrayBuffer.slice(arrayBuffer.byteLength - 128);
            // var v1Header = new DataView(v1HeaderBuf);
            // if (v1Header.byteLength === 128 && BitUtil.getString(v1Header, 3, undefined, true) === 'TAG') {
            //
            //     return arrayBuffer.slice(0, arrayBuffer.byteLength - 128);
            // }


            //Read 14 bytes (10 for ID3v2 header, 4 for possible extended header size)
            //Assuming the ID3v2 tag is prepended
            var v2PrefixBuf = arrayBuffer.slice(0, 14);
            var v2Prefix = new DataView(v2PrefixBuf);

            //Be sure that the buffer is at least the size of an id3v2 header,
            // Assume incompatibility if a major version of > 4 is used
            if (v2PrefixBuf.byteLength === 14
                && BitUtil.getString(v2Prefix, 3, undefined, true) === 'ID3'
                && v2Prefix.getUint8(3) <= 4) {
                var headerSize = 10;
                var tagSize = 0;
                var tagFlags = v2Prefix.getUint8(5);
                //Do not support unsynchronisation
                if ((tagFlags & 0x80) === 0) {
                    //Increment the header size to offset by if an extended header exists
                    if ((tagFlags & 0x40) !== 0) {
                        headerSize += BitUtil.getUint32Synch(v2Prefix, 11);
                    }
                    //Calculate the tag size to be read
                    tagSize += BitUtil.getUint32Synch(v2Prefix, 6);

                    return headerSize + tagSize;
                }
            }
            return 0;
        },
        /**
         * Parse the VBR tracks headers
         */
        readVbrHeader: function(arrayBuffer, id3headerOffset, mpeg_version, channels){
            //Dataview of the buffer data for quick accessing the buffer
            var arrayBufferDV = new DataView(arrayBuffer);

            // If this header don't contains a Xing/Info tag, nothing to do
            var xing_id_offset  = id3headerOffset + MP3File.CONSTS.XING_OFFSETS[mpeg_version][channels];
            var xing_word = BitUtil.getString(arrayBufferDV, 4, xing_id_offset + 4, true);
            if (xing_word !== "Xing" && xing_word !== "Info") {
                return null;
            }

            var vbr = {};
            vbr.id = xing_word;
            vbr.xing_flags_offset    = xing_id_offset + 4;
            vbr.xing_flags           = arrayBufferDV.getUint8(vbr.xing_flags_offset + 3);
            vbr.xing_has_frames      = vbr.xing_flags & 0x01 == 0x01;
            vbr.xing_has_bytes       = vbr.xing_flags & 0x02 == 0x02;
            vbr.xing_frames_offset   = vbr.xing_flags_offset + 4;
            vbr.xing_bytes_offset    = vbr.xing_flags_offset + (vbr.xing_has_frames ? 4 : 0) + 4;
            vbr.xing_frames          = vbr.xing_has_frames ? arrayBufferDV.getInt32(vbr.xing_frames_offset) : 0;
            vbr.xing_bytes           = vbr.xing_has_bytes ? arrayBufferDV.getInt32(vbr.xing_bytes_offset) : 0;

            return vbr;
        },

        _parse: function (bufferDataView) {

            // Not enough data to read the header
            if (bufferDataView.byteLength < 4) {
                return null;
            }

            // Read the first 4 bytes
            var header = [bufferDataView.getUint8(0), bufferDataView.getUint8(1), bufferDataView.getUint8(2), bufferDataView.getUint8(3)];

            var is_valid = isMpegHeader(header);
            if (!is_valid) {
                return null;
            }

            this.mpeg_version = getMpegVersion(header[1] >> 3);
            this.mpeg_layer = getMpegLayer(header[1] >> 1);

            if (!this.mpeg_version || !this.mpeg_layer) {
                is_valid = false;
                return;
            }

            var frame = {};
            frame.hasPadding = (header[2] & 0x02) >> 1 == 0x01;
            frame.channels = getMpegChannels(header[3] >> 6);
            frame.mpeg_version = this.mpeg_version;
            frame.bitrate = getMpegBitrate(this.mpeg_version, this.mpeg_layer, header[2] >> 4);
            frame.samplerate = getMpegSampleRate(this.mpeg_version, header[2] >> 2);
            frame.num_samples = getMpegNumSamples(this.mpeg_version, this.mpeg_layer);
            frame.frameSize = getMpegFrameLength(
                frame.hasPadding,
                frame.samplerate,
                this.mpeg_layer,
                frame.bitrate,
                frame.num_samples
            );
            frame.frameDuration = (frame.num_samples/frame.samplerate) * 1000;
            return frame;


            function isMpegHeader(header) {
                return (((header[0] & 0xFF) << 8) | ((header[1] & 0xF0))) == 0xFFF0;
            };

            function getMpegVersion(num) {

                /*
                 00 - MPEG Version 2.5 (unofficial)
                 01 - reserved
                 10 - MPEG Version 2 (ISO/IEC 13818-3)
                 11 - MPEG Version 1 (ISO/IEC 11172-3)
                 */

                if ((num & 0x03) == 0x03) {
                    return 1;
                }

                if ((num & 0x02) == 0x02) {
                    return 2;
                }

                return 0;
            };

            function getMpegLayer(num) {

                /**
                 00 - reserved
                 01 - Layer III
                 10 - Layer II
                 11 - Layer I
                 */

                if ((num & 0x03) == 0x03) {
                    return 1;
                }

                if ((num & 0x02) == 0x02) {
                    return 2;
                }

                if ((num & 0x01) == 0x01) {
                    return 3;
                }

                return 0;
            };

            function getMpegChannels(num) {

                /*
                00 - Stereo
                01 - Joint stereo (Stereo)
                10 - Dual channel (2 mono channels)
                11 - Single channel (Mono)
                */

                if ((num & 0x03) == 0x03) {
                    return 1;
                }

                return 2;
            };

            function getMpegBitrate(version, layer, num) {

                return MP3File.CONSTS.BITRATES[version][layer][num & 0x0F] * 1000;
            };

            function getMpegSampleRate(version, num) {

                return MP3File.CONSTS.SAMPLE_RATES[version][num & 0x03];
            };

            function getMpegNumSamples(version, layer) {

                return MP3File.CONSTS.SAMPLES_PER_FRAME[version][layer];
            };

            function getMpegFrameLength(has_padding, sample_rate, layer, bitrate, num_samples) {

                var padding = has_padding ? 1 : 0;
                if (sample_rate == 0) {
                    return 0;
                }

                if (layer == 1) {
                    return Math.floor(12.0 * bitrate / sample_rate + padding) * 4;
                }

                // console.log("Frame size");
                // console.log(((num_samples / 8 * bitrate) / sample_rate) + padding);
                // console.log(Math.floor(num_samples * (bitrate / 8) / sample_rate) + padding);
                return Math.floor(num_samples * (bitrate / 8) / sample_rate) + padding;

            }
        }

    };


    return MP3File;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP4File.js":
/*!***********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP4File.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    04/19/19
 * @COPYRIGHT:  2019 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *  MP4File class Allows for parsing of MP4 files
 *  https://sce.umkc.edu/faculty-sites/lizhu/teaching/2018.fall.video-com/ref/mp4.pdf
 */
/* beautify preserve:start */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  //----------------------------------------------------------------------------------------------------------
  // MODULE variables
  //----------------------------------------------------------------------------------------------------------

  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var PlayerError = __webpack_require__(/*! sxm/audioplayer/html5/error/PlayerError */ "./javascript/src/sxm/audioplayer/html5/error/PlayerError.js");
  var ClassUtils = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var BitUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/BitUtil */ "./javascript/src/sxm/audioplayer/html5/util/BitUtil.js");
  var AudioUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
  var MediaBuffer = __webpack_require__(/*! sxm/audioplayer/html5/model/MediaBuffer */ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js");
  var AdtsFrame   = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");

  var logger = LoggerFactory.getLogger("MP4File");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * Construct an ADTS frame object
   *
   * @constructor
   */
  function MP4File(mediaBuffer) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof MP4File)) {
      throw new PlayerError(PlayerError.CONSTRUCTOR_FUNCTION, ["AdtsFrame"]);
    }

    this.mediaBuffer = mediaBuffer;
  
    // defaulting the sampleDuration to AACPlus as we are not seeing this inforamtion as part of un-fragmented sxm mp4
    // and for fragmented Mp4 if we get the sample duration as part of the Mp4 header box- we will updated accorodingly
    this.sampleDuration = AdtsFrame.CONSTS.ADTS_MS_PER_FRAME;
    
    defineProperties(this);

    ClassUtils.bind(this, MP4File);
  }

  function defineProperties(self)
  {
    var mp4Boxes;
    var chunkDescriptors;
    var sampleRate;

    Object.defineProperty(self, 'mp4Boxes',
                          {
                            get: function () {
                              if (!mp4Boxes) {
                                mp4Boxes = this.getBoxes(0);
                              }
                              return mp4Boxes;
                            },
                            set: function (value) {
                              mp4Boxes = value;
                            }
                          });


    Object.defineProperty(self,'chunkCount',
                          {
                            get : function() {
                              var stco = this.findBox(this.mp4Boxes,"stco");
                              return !!stco ? BitUtil.grabUint32(this.mediaBuffer.bytes,stco.payloadStart) : 0;
                            }
                          });


    Object.defineProperty(self,'isFragmented',
                          {
                            get : function() {
                              return ((this.chunkCount === 0) && !!this.findBox(this.mp4Boxes,"mvex"));
                            }
                          });

    Object.defineProperty(self, 'chunkDescriptors',
                          {
                            get: function () {
                              if (!chunkDescriptors) {
                                chunkDescriptors = this.getChunkOffsets();
                              }

                              return chunkDescriptors;
                            },
                            set: function (value) {
                              chunkDescriptors = value;
                            }
                          });
    
    Object.defineProperty(self, 'sampleRate',
                          {
                            get: function () {
                              return sampleRate || AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_44KHZ;
                            },
                            set: function (value) {
                              sampleRate = value;
                            }
                          });
  }

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * Hash of enumerated values describing constants for the AacDecoder class.
   * @type {Object}
   */
  MP4File.CONSTS = {
    LENGTH_FIELD_SIZE: 4,
    BOX_TYPE_FIELD_SIZE: 4,
    BOXES: [
      {type: 0x66747970, name: "ftyp", headerSize: 8, children: false},
      {type: 0x6D6F6F76, name: "moov", headerSize: 8, children: true},
      {type: 0x6D766578, name: "mvex", headerSize: 8, children: true},
      {type: 0x6D6F6F66, name: "moof", headerSize: 8, children: true},
      {type: 0x74726166, name: "traf", headerSize: 8, children: true},
      {type: 0x7472756e, name: "trun", headerSize: 12, children: false},
      {type: 0x6d766864, name: "mvhd", headerSize: 12, children: false},
      {type: 0x696f6473, name: "iods", headerSize: 12, children: false},
      {type: 0x7472616b, name: "trak", headerSize: 8, children: true},
      {type: 0x746b6864, name: "tkhd", headerSize: 12, children: false},
      {type: 0x6d646961, name: "mdia", headerSize: 8, children: true},
      {type: 0x6d646864, name: "mdhd", headerSize: 12, children: false},
      {type: 0x68646c72, name: "hdlr", headerSize: 12, children: false},
      {type: 0x6d696e66, name: "minf", headerSize: 8, children: true},
      {type: 0x736d6864, name: "smhd", headerSize: 12, children: false},
      {type: 0x64696e66, name: "dinf", headerSize: 8, children: true},
      {type: 0x64726566, name: "dref", headerSize: 16, children: true},
      {type: 0x75726C20, name: "url", headerSize: 12, children: false},
      {type: 0x7374626c, name: "stbl", headerSize: 8, children: true},
      {type: 0x73747473, name: "stts", headerSize: 12, children: false},
      {type: 0x73747364, name: "stsd", headerSize: 16, children: true},
      {type: 0x6d703461, name: "mp4a", headerSize: 40, children: true},
      {type: 0x65736473, name: "esds", headerSize: 12, children: false},
      {type: 0x7374737a, name: "stsz", headerSize: 12, children: false},
      {type: 0x73747363, name: "stsc", headerSize: 12, children: false},
      {type: 0x7374636f, name: "stco", headerSize: 12, children: false},
      {type: 0x6d646174, name: "mdat", headerSize: 8, children: false},
      {type: 0x74666864, name: "tfhd", headerSize: 12, children: false}
    ]
  };

  ClassUtils.baseClass(MP4File).prototype = {

    /**
     * Get a an array of all the child boxes that the given parent box contains and al the child bnoxes
     * contained within those children.  If this function is run on an entire media buffer it will get all the
     * top level boxes and all the children for those boxes.
     *
     * @param index where to start in the media buffer to look for child boxes
     * @param parentEndIndex where top stop in the media buffer looking for child boxes
     *
     * @returns {Array} of child boxes given the input parameters
     */
    getBoxes: function (index, parentEndIndex) {
      var bytes = this.mediaBuffer.bytes;
      var children = [];

      if (!parentEndIndex || parentEndIndex >= bytes.length) {
        parentEndIndex = bytes.length - 1;
      }

      while (index < parentEndIndex) {
        var child = this.getBoxMap(index);

        if (!!child) {
          index += child.length;
          children.push(child);
        }
        else {
          break;
        }
      }

      return children;
    },

    /**
     * Get the box map of a single box.  Box map is an object that will contain the generic metadata
     * about the box, and am array of children for the box
     *
     * @param {MediaBuffer} mediaBuffer contains Uint8Array with data to parse for the box
     * @param {Number} index is the index into MediaBuffer where parsing should start
     *
     */
    getBoxMap: function (index) {
      var bytes = this.mediaBuffer.bytes;

      if ((bytes.length - index) < MP4File.CONSTS.LENGTH_FIELD_SIZE + MP4File.CONSTS.BOX_TYPE_FIELD_SIZE) {
        if (this.isFragmented === false) {
          logger.error("Malformed MP4 file size {0} detected @index {1} ",[bytes.length,index]);
          throw new Error("Malformed MP4 file detected");
        }
        
        return null;
      }

      var boxLength = BitUtil.grabUint32(bytes, index);

      var boxType = BitUtil.grabUint32(bytes, index + MP4File.CONSTS.LENGTH_FIELD_SIZE);
      var boxEnd = index + boxLength;
      
      var boxDescriptor = MP4File.CONSTS.BOXES.find(function (desc) {
        return desc.type === boxType;
      });

      var hasChildren = (boxDescriptor) ? boxDescriptor.children : false;
      var payloadStart = (boxDescriptor) ? index + boxDescriptor.headerSize
        : (index
          + MP4File.CONSTS.LENGTH_FIELD_SIZE
          + MP4File.CONSTS.BOX_TYPE_FIELD_SIZE);
      var box = {
        length: boxLength,
        type: boxType,
        name: (boxDescriptor) ? boxDescriptor.name : "unknown",
        payloadStart: payloadStart,
        payloadEnd: boxEnd,
        headerSize: (boxDescriptor) ? boxDescriptor.headerSize : 0,
        children: (hasChildren) ? this.getBoxes(payloadStart, boxEnd) : []
      };
      box = this.applySpecialPropsToBox(box);
      return box;
    },
    
    /**
     * We need few properties)duration/sampleCount) of boxes(moof/tkhd/trun) to properly parse the moof+mdat boxes
     *
     * @param {box} mediaBuffer contains Uint8Array with data to parse for the box
     *
     */
    applySpecialPropsToBox: function(box){
  
      //Some times we have box header but not the box payload, so we will return the box
      if(box.payloadEnd > this.mediaBuffer.length)
      {
        return box;
      }
      if(box.name === 'mvhd')
      {
          box.timescale = BitUtil.grabUint32(this.mediaBuffer.bytes, box.payloadStart + 8);
          this.timescale = BitUtil.grabUint32(this.mediaBuffer.bytes, box.payloadStart + 8);
      }
      if(box.name === 'tkhd')
      {
        //Need to find out if there is better documentation in finding out the version for the tkhd box
        // currently this is based on the testing frag and un-frag mp4 tracks
        box.version = this.mediaBuffer.bytes[box.payloadStart + 8];
        if(box.version === 0)
        {
          box.duration = BitUtil.grabUint32(this.mediaBuffer.bytes, box.payloadStart + 16);
          
          //store the duration of the entire track(mp4file) in the duration prop, which will be used in playhead event
          // and the total duration will be calculated based on the timeScale
          this.duration = (box.duration/this.timescale) * 1000;
        }
        else if(box.version === 1)
        {
          // box.duration = BitUtil.grabUint64(this.mediaBuffer.bytes, tkhd.payloadStart + 16);
          
          //JS can only accommodate an integer up to 53 bits
          throw new Error("tkhd box has version 1 which means we need grab 64 bit and JS doesn't support it");
  
        }
        
      }
      if(box.name === 'trun')
      {
        //box comprises of header and payload, and box.payloadStart gives only where payload started,
        // to read the box flags you need box header- as trun header is 12bytes
        var boxStartPosition = box.payloadStart - box.headerSize;
        var boxFlags = BitUtil.grabUint32(this.mediaBuffer.bytes, boxStartPosition + 8);
        box.sampleCount = BitUtil.grabUint32(this.mediaBuffer.bytes, box.payloadStart);
        box.samples= [];

        var sizeOffset = box.payloadStart + 8;
        
        for(var i=0; i< box.sampleCount; i++)
        {
          box.samples.push(
              {
                sampleDuration : boxFlags & 256 ? (BitUtil.grabUint32(this.mediaBuffer.bytes, sizeOffset + ( 8 * i))/this.sampleRate)*1000 : this.sampleDuration,
                sampleSize : BitUtil.grabUint32(this.mediaBuffer.bytes, sizeOffset + (  (boxFlags & 256 ? (8 * i +4) : 4 * i)))
              }
          );
        }
      }
      
      if(box.name === 'tfhd')
      {
        var boxStartPosition = box.payloadStart - box.headerSize;
        var boxFlags = BitUtil.grabUint32(this.mediaBuffer.bytes, boxStartPosition + 8);
        //isSampleDurationPresent, boxFlags tells us if the box has the default duration or not
        //if it isn't there, that means sample duration will be part of the trun box where we have the sample duration for ech samples
        if(boxFlags & 8)
        {
          var sampleDurationBytes = BitUtil.grabUint32(this.mediaBuffer.bytes, box.payloadStart+4);
          box.sampleDuration = (sampleDurationBytes/this.sampleRate)*1000; //ms
          this.sampleDuration = box.sampleDuration;
        }
      }
  
      //we use stts box to determine the sampleDuration for the un-fragmented mp4 and as we have stts boc for fragmented mp4 too
      // we only use this box when we have entry_count value > 0
      if(box.name === 'stts')
      {
        //For unfragmented Mp4, we will have the sample_count and sample_Delta(sampleDuration) if the entry_count is not zero
        var entry_count = BitUtil.grabUint32(this.mediaBuffer.bytes, box.payloadStart);
        if(entry_count > 0)
        {
          var sampleDurationBytes = BitUtil.grabUint32(this.mediaBuffer.bytes, box.payloadStart+8);
          box.sampleDuration = (sampleDurationBytes/this.sampleRate)*1000; //ms
          this.sampleDuration = box.sampleDuration;
        }
      }
      
      if(box.name === 'mdhd')
      {
        box.sampleRate = BitUtil.grabUint32(this.mediaBuffer.bytes, box.payloadStart + 8);
        this.sampleRate = box.sampleRate;
      }
  
      return box;
    },
    /**
     * Find a box by name in the array of boxes.  Searches children as well
     *
     * @param boxes is an array of boxes
     * @param name of the box to find
     *
     * @returns the box with the given name, or undefined if the box could not be found.
     */
    findBox: function (boxes, name) {
      var foundBox;

      /*
       * This is an unconventional use of the array find function.  To find the box we want, we have to
       * search not only through the boxes array but also through the children of the boxes we find in that
       * array and their children as well so on and so forth.
       *
       * Find is nice because it stops once the box we are looking for is found.  But, since we are calling
       * recursively into other arrays, the top level find can only return a box from the top level array.
       *
       * To address this, the find function returns true if a box or its children has the desired box, but
       * it will also set the foundBox closure variable with the actual box that was found, either in the
       * current array or from one of the recursive calls to findBox.
       */
      boxes.find(function (box) {
        var found = box.name === name;
        foundBox = (!found) ? this.findBox(box.children, name) : box;
        return (!!foundBox);
      }.bind(this));

      return foundBox;
    },

    /**
     * Get the raw frame offsets in the mdat box from the stsz box.  This will allow pulling the raw
     * elementary stream frames from the mdat box.
     *
     * @returns {Array} array of objects containing the start index and frame size of each elementary frame
     *          within the mdat box
     */
    getFrameOffsets: function () {
      var mdatFrames = [];

      if (this.mediaBuffer.length === 0) {
        return [];
      }

      var stsz = this.findBox(this.mp4Boxes, "stsz");
      var mdat = this.findBox(this.mp4Boxes, "mdat");
      var stszOffset = stsz.payloadStart + 8;
      var mdatOffset = mdat.payloadStart;
      var sampleSize = BitUtil.grabUint32(this.mediaBuffer.bytes, stsz.payloadStart);
      var sampleCount = BitUtil.grabUint32(this.mediaBuffer.bytes, stsz.payloadStart + 4);

      if (sampleSize !== 0) {
        return mdatFrames;
      }

      for (var index = 0; index < sampleCount; index++) {
        var frameSize = BitUtil.grabUint32(this.mediaBuffer.bytes, stszOffset);
        mdatFrames.push({startIndex: mdatOffset, frameSize: frameSize, endIndex: mdatOffset + frameSize});
        mdatOffset += frameSize;
        stszOffset += 4;
      }

      return mdatFrames;
    },

    /**
     * Get the raw chunk offsets in the mdat box from the stco box.  This will allow pulling individual chunks
     * from the mdat box
     *
     * @param mp4Boxes contains the mp4 box information for the mp4 file
     * @param mediaBuffer contains the data for the MP4 file
     *
     * @returns {Array} array of objects containing the start index and frame size of each elementary frame
     *          within the mdat box
     */
    getChunkOffsets: function () {
      var mdatChunks = [];

      if (this.mediaBuffer.length === 0) {
        return [];
      }

      var stco = this.findBox(this.mp4Boxes, "stco");
      var mdat = this.findBox(this.mp4Boxes, "mdat");

      if (!stco || !mdat) {
        logger.warn("Not enough data yet to parse all the MP4 boxes");
        return [];
      }

      var stcoOffset = stco.payloadStart + 4;
      var chunkCount = BitUtil.grabUint32(this.mediaBuffer.bytes, stco.payloadStart);
      var frameOffsets = this.getFrameOffsets();
      
      if(this.isFragmented)
      {
        var fragmentedChunkOffsets = this.getFragmentedChunkOffsets();
        
        return fragmentedChunkOffsets;
      }
      
      for (var index = 0; index < chunkCount; index++) {
        var chunkStartOffset = BitUtil.grabUint32(this.mediaBuffer.bytes, stcoOffset);

        stcoOffset += 4;

        var chunkEndOffset = (index < chunkCount - 1) ? BitUtil.grabUint32(this.mediaBuffer.bytes, stcoOffset)
          : mdat.payloadEnd;

        var framesInChunk = frameOffsets.filter(function (frame) {
          return frame.startIndex >= chunkStartOffset && frame.endIndex <= chunkEndOffset;
        });

        mdatChunks.push({
          startIndex: chunkStartOffset,
          chunkSize: chunkEndOffset - chunkStartOffset,
          framesInChunk: framesInChunk
        });
      }

      return mdatChunks;
    },
  
  
    getFragmentedChunkOffsets: function () {
  
      var mdatChunks = [];

      if (this.mediaBuffer.length === 0) {
        return [];
      }

      var tkhd = this.findBox(this.mp4Boxes, "tkhd"); //moov-->trak-->tkhd
      var moof = this.findBox(this.mp4Boxes, "moof"); //first moof box
      var mdat = this.findBox(this.mp4Boxes, "mdat"); //first mdat box
      var trun = this.findBox(moof.children, "trun"); // trun box in first moof
      var tfhd = this.findBox(moof.children, "tfhd"); //tfhd box in first moof box
  
      var totalDuration = tkhd.duration;
      var eachFragmentDuration = trun.sampleCount * tfhd.sampleDuration;
      var fragmentCount = Math.ceil(totalDuration/eachFragmentDuration) ; //AKA chunkCount

      for (var index = 0; index < fragmentCount; index++) {

        var moof = this.mp4Boxes[2+(2*index)];
  
        var newMdat = this.mp4Boxes[2+(2*index)+1];
        //logger.debug("getFragmentedChunkOffsets {0},{1},{2}", [mdat, trun, index]);
        
        if(moof && moof.name === 'moof' && newMdat && newMdat.name === 'mdat')
        {
          var childTrun = this.findBox(moof.children, "trun");
          var childTfhd = this.findBox(moof.children, "tfhd");

          //include moof headers in the chunks
          var fragStartOffset = moof.payloadStart;
          var fragEndOffset = newMdat.payloadStart + newMdat.length ;
  
          mdatChunks.push({
            startIndex: fragStartOffset,
            chunkSize: fragEndOffset - fragStartOffset,
            endIndex: fragEndOffset,
            framesInChunk: this.getFragmentedFrameOffsets(newMdat,childTrun),
            defaultFrameDuration: childTfhd.sampleDuration // only if all the frames has same sample duration
          });
          
          mdat = newMdat;
        }
        else if (mdat) {//fake chunks
          //for fake chunks, use the previous chunk endIndex
          var fragStartOffset = mdatChunks[mdatChunks.length -1].endIndex;
          var fragEndOffset = fragStartOffset + (mdat.length + 500);

          mdat.payloadEnd = fragEndOffset;

          mdatChunks.push({
                            startIndex: fragStartOffset,
                            chunkSize: fragEndOffset - fragStartOffset,
                            endIndex: fragEndOffset,
                            framesInChunk : [],
                            defaultFrameDuration: tfhd.sampleDuration
                           });
        }
      }
      return mdatChunks;
    },
  
    getFragmentedFrameOffsets: function (mdat,trun) {
      var mdatFrames = [];
    
      if (!trun || !mdat) {
        return [];
      }
      var mdatOffset = mdat.payloadStart;
    
      for (var index = 0; index < trun.sampleCount; index++) {
        var frame = trun.samples[index];
        if((mdatOffset + frame.sampleSize) > this.mediaBuffer.length)
        {
          return mdatFrames;
        }
        else {
          mdatFrames.push({startIndex: mdatOffset, frameSize: frame.sampleSize, frameDuration: frame.sampleDuration, endIndex: mdatOffset + frame.sampleSize});
        }
        
        mdatOffset = mdatOffset+ frame.sampleSize;
      }
    
      return mdatFrames;
    },
    
    appendData: function (arrayBuffer) {

      var oldBoxes = this.mp4Boxes;

      var newArrayBuffer = AudioUtil.concatArrayBuffers(
        [
          this.mediaBuffer.arrayBuffer,
          arrayBuffer
        ]
      );

      this.mediaBuffer = new MediaBuffer(
        newArrayBuffer,
        0,
        this.mediaBuffer.isAACPlus,
        this.mediaBuffer.isMP4
      );

      if (!this.findBox(oldBoxes, 'stco')
          || !this.findBox(oldBoxes, 'stsz')
          || !this.findBox(oldBoxes, 'mdat')
          || this.isFragmented === true) {
        try {
          this.mp4Boxes = this.getBoxes(0);
          this.chunkDescriptors = this.getChunkOffsets();
        }
        catch (error) {
          // Usually this means we do not have enough data to get all the boxes yet
          logger.error("Error {0} encountered getting MP4 box information", [error]);
        }
      }
    },

    /**
     * Returns the number of chunks in the file.
     * Returns 0 if the header doesn't exist.
     */
    numberOfChunksInFile: function() {
      return this.chunkDescriptors.length;
    }
  };

  return MP4File;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* beautify preserve:end */


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP4Parser.js":
/*!*************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/protocols/mp4/MP4Parser.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************************************************************
 * @MODULE:     MP4Parser
 * @CREATED:    4/19/2019
 * @COPYRIGHT:  2019 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Parser for MP4 chunk data
 **********************************************************************************************************************/
/* beautify preserve:start */



/*******************************************************************************************************************
 * Register the module with RequireJS.
 ******************************************************************************************************************/
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  //----------------------------------------------------------------------------------------------------------
  // CLASS members
  //----------------------------------------------------------------------------------------------------------
  var ClassUtils  = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var MediaBuffer = __webpack_require__(/*! sxm/audioplayer/html5/model/MediaBuffer */ "./javascript/src/sxm/audioplayer/html5/model/MediaBuffer.js");
  var BitUtil     = __webpack_require__(/*! sxm/audioplayer/html5/util/BitUtil */ "./javascript/src/sxm/audioplayer/html5/util/BitUtil.js");
  var AudioUtil   = __webpack_require__(/*! sxm/audioplayer/html5/util/AudioUtil */ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js");
  var AdtsFrame   = __webpack_require__(/*! sxm/audioplayer/html5/protocols/adts/AdtsFrame */ "./javascript/src/sxm/audioplayer/html5/protocols/adts/AdtsFrame.js");
  var ObjectUtil  = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  var saveToDisk = false; // for debugging
  //----------------------------------------------------------------------------------------------------------
  // CONSTRUCTOR
  //----------------------------------------------------------------------------------------------------------

  /**
   * MP4Parser Constructor
   *
   * @param {MP4File} mp4File file to look at
   */
  function MP4Parser(mp4File) {
    ClassUtils.bind(this,MP4Parser);

    defineProperties(this,mp4File);
  }

  /**
   * Define properties that will be available on the MP4 Parser object.
   *
   * This is done here to avoid closures keeping things alive for longer than necessary
   *
   * @param self is the object to create property descriptors for
   * @param mediaBuffer is the media buffer to use in property getter/setters
   * @param chunkDescriptors is the chunk descriprot array to use in property getter/setters
   */
  function defineProperties(self,mp4File)
  {
    Object.defineProperty(self,"mediaBuffer",
                          {
                            get : function() {
                              return mp4File.mediaBuffer;
                            }
                          });

    Object.defineProperty(self,"chunkDescriptors",
                          {
                            get : function() {
                              return mp4File.chunkDescriptors;
                            }
                          });

    Object.defineProperty(self,"frameDuration",
                          {
                            get : function() {
                              return mp4File.sampleDuration;
                            }
                          });
    
    Object.defineProperty(self,"sampleRate",
                          {
                            get : function() {
                              return mp4File.sampleRate;
                            }
                          });


    var chunkIndex = 0;

    Object.defineProperty(self,"chunkIndex",
                          {
                            get : function() {
                              return chunkIndex;
                            },
                            set : function(value) {
                              chunkIndex = value;
                            }
                          });
  }

  //----------------------------------------------------------------------------------------------------------
  // PROTOTYPE Inherit AudioDecodeContext's prototype and restore AacDecoder's constructor
  //----------------------------------------------------------------------------------------------------------

  ClassUtils.baseClass(MP4Parser).prototype = {

    index: ClassUtils.createPropertyDescriptor(
      {
        get: function () {
          return this._index;
        },
        set: function (value) {
          this._index = value;
        }
      }),

    /**
     * Get frames number of aac frames (with ADTS headers on each frame) from the parser.  If the frames
     * parameter is supplied, then this function will return *at* least that many AAC frames, but may
     * return more in order to maintain chunk boundaries within the MP4 data
     *
     * If the frames parameter is not supplied, then one chunk worth of ADTS frames will be returned.
     *
     * @param frames is the number of AAC frames to get, if undefined then one chunk of frames will be
     *        returned
     *
     * @returns {MediaBuffer} new media buffer with the requested amount of ADTS audio frames
     */
    getAACFrames: function (frames, enableHeaders) {
      var frameBuffers = [];

      // if frames is not supplied, then we will get 1 frame or one chunks worth of frames, whichever
      // is greater
      frames = frames >= 0 ? frames : 1;

      while (frames > 0) {

        var chunkIndex = this.chunkIndex;
        var chunkDescriptors = this.chunkDescriptors;

        if (chunkIndex >= chunkDescriptors.length) {
          break;
        } // no more chunks, break out and return

        var frameDescriptors = chunkDescriptors[chunkIndex].framesInChunk;
        var numFrames = (!!frameDescriptors) ? frameDescriptors.length : 0;
        var frameIndex = 0;

        while (numFrames-- > 0) {
          var frameDescriptor = frameDescriptors[frameIndex++];
          var frameStartIndex = frameDescriptor.startIndex;
          var frameEndIndex = frameDescriptor.endIndex;
          var rawFrame = this.mediaBuffer.arrayBuffer.slice(frameStartIndex, frameEndIndex);

          if(enableHeaders !== false)
          {
            var adtsHeader = this.getAdtsHeader(frameDescriptor);
            frameBuffers.push(adtsHeader);
          }
          frameBuffers.push(rawFrame);
          frames--;
        }

        this.chunkIndex += 1;
      }

      if (frameBuffers.length === 0) {
        return undefined;
      }

      var buffer = AudioUtil.concatArrayBuffers(frameBuffers);

      // only enable the following for debugging.  Will write raw aac, works on Chrome but not necessarily
      // elsewhere
      if (saveToDisk) {
        BitUtil.saveByteArrayToFile([buffer], "rawadts.aac");
        BitUtil.saveByteArrayToFile([buffer], "rawadts.aac"); // doubled up because of an issue with Chrome
        saveToDisk; // save once only
      }

      return new MediaBuffer(buffer, 0, this.mediaBuffer.isAACPlus, this.mediaBuffer.isMP4);
    },

    getAACFramesByIndex: function (startIndex, endIndex) {
      var frameBuffers = [];
      var i = startIndex;
      var frameDescriptors = this.frameDescriptors;
  
      while (i < endIndex && i < frameDescriptors.length) {
        var frameDescriptor = frameDescriptors[i++];
        var frameStartIndex = frameDescriptor.startIndex;
        var frameEndIndex = frameDescriptor.startIndex + frameDescriptor.frameSize;
        var rawFrame = this.mediaBuffer.arrayBuffer.slice(frameStartIndex, frameEndIndex);
        var adtsHeader = this.getAdtsHeader(frameDescriptor);
        frameBuffers.push(adtsHeader);
        frameBuffers.push(rawFrame);
      }

      if (frameBuffers.length === 0) {
        return undefined;
      }

      var buffer = AudioUtil.concatArrayBuffers(frameBuffers);

      // only enable the following for debugging.  Will write raw aac, works on Chrome but not necessarily
      // elsewhere
      if (saveToDisk) {
        BitUtil.saveByteArrayToFile([buffer], "rawadts.aac");
        BitUtil.saveByteArrayToFile([buffer], "rawadts.aac"); // doubled up because of an issue with Chrome
        saveToDisk; // save once only
      }

      return new MediaBuffer(buffer, 0, this.mediaBuffer.isAACPlus, this.mediaBuffer.isMP4);
    },
  
  
    getChunkIndexAndOffsetByTime: function (startAt) {
      var offset = startAt;
      var chunkIndex;
      
      //For fragmented Mp4, we don't know how many samples/frames each chunks has-
      // so we will have mockSampleCount based on first chunk
      var mockSampleCount= null;
      
      if(startAt >=0 && this.chunkDescriptors.length > 0)
      {
        var eachFrameDuration = this.frameDuration;

        var chunkOffSetStartTime = 0;
        
        for(var j =0; j < this.chunkDescriptors.length; j++ )
        {
          var samplesCount = this.chunkDescriptors[j].framesInChunk.length;
          
          if(samplesCount > 0 && !mockSampleCount)
          {
            mockSampleCount = this.chunkDescriptors[j].framesInChunk.length;
          }
          
          //for fakeChunks, we will replace noOfFrames with mockSampleCount
          var noOfFrames = this.chunkDescriptors[j].framesInChunk.length >0
            ? this.chunkDescriptors[j].framesInChunk.length : mockSampleCount;
  
          var chunkTotalDuration = noOfFrames * eachFrameDuration;
          if(startAt < (chunkTotalDuration + chunkOffSetStartTime)){
            chunkIndex = j;
            break;
          }
          offset = offset - chunkTotalDuration;
          chunkOffSetStartTime = chunkTotalDuration + chunkOffSetStartTime;
        }
        // If we are looking for position out of the chunk total duration, then we will give back the duration of the last chunk minus 1 second.  
        if(ObjectUtil.isUndefinedOrNull(chunkIndex) && startAt >= chunkOffSetStartTime)
        {
          var chunkduration = (this.chunkDescriptors[0].framesInChunk.length * eachFrameDuration);
          chunkIndex = (this.chunkDescriptors.length - 1);
          offset = (chunkduration > 1000) ? (chunkduration - 1000) : 0;
        }
        return { index : chunkIndex || 0, offset : offset };
      }
      return null;
    },

    getChunkDuration: function(chunk) {
      if(chunk.defaultFrameDuration)
      {
        return chunk.framesInChunk.length * chunk.defaultFrameDuration;
      }
      else {
        return chunk.framesInChunk.reduce(function (a,b) {
          return a + b.frameDuration;
        }, 0);
      }
    },

    getChunksByIndex: function (startIndex, endIndex, enableHeaders) {
      var frameBuffers = [];
      var duration = 0;

      var chunkIndex = startIndex;
      endIndex = Math.min(endIndex, this.chunkDescriptors.length);
  
  
      while (chunkIndex < endIndex) {
        var frameDescriptors = this.chunkDescriptors[chunkIndex].framesInChunk;
        var numFrames = (!!frameDescriptors) ? frameDescriptors.length : 0;
        var frameIndex = 0;

        while (numFrames-- > 0) {
          var frameDescriptor = frameDescriptors[frameIndex++];
          var frameStartIndex = frameDescriptor.startIndex;
          var frameEndIndex = frameDescriptor.endIndex;
          var rawFrame = this.mediaBuffer.arrayBuffer.slice(frameStartIndex, frameEndIndex);

          if(enableHeaders !== false)
          {
            var adtsHeader = this.getAdtsHeader(frameDescriptor);
            frameBuffers.push(adtsHeader);
          }
          frameBuffers.push(rawFrame);
        }


        duration += this.getChunkDuration(this.chunkDescriptors[chunkIndex]);
        chunkIndex += 1;
      }

      var buffer = AudioUtil.concatArrayBuffers(frameBuffers);

      // only enable the following for debugging.  Will write raw aac, works on Chrome but not necessarily
      // elsewhere
      if (saveToDisk) {
        BitUtil.saveByteArrayToFile([buffer], "rawadts.aac");
        BitUtil.saveByteArrayToFile([buffer], "rawadts.aac"); // doubled up because of an issue with Chrome
        saveToDisk; // save once only
      }

      

      return new MediaBuffer(buffer, duration, this.isAACPlus, this.mediaBuffer.isMP4);
    },
    
    getAdtsHeader : function (frameDescriptor) {
  
      this.isAACPlus = (this.frameDuration >= AdtsFrame.CONSTS.ADTS_MS_PER_FRAME) ? true : false;
  
      var adtsHeader = new Uint8Array(7);
      var adtsFrameSize = frameDescriptor.frameSize + AdtsFrame.CONSTS.ADTS_HEADER_LENGTH;
  
      adtsHeader[0] = 0xff; // 1st byte of ADTS 0xFFF syncword
      adtsHeader[1] = 0xf1; // 2nd byte of ADTS 0cFFF syncword and protection absent bit set
  
      switch (this.sampleRate)
      {
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_96KHZ:
          adtsHeader[2] = (this.isAACPlus)
            ? 0x4c  // Audio Type 2 (minus 1) Sampling Frequency index 3 (48 Khz), stereo
            : 0x40; // Audio Type 2 (minus 1) Sampling Frequency index 0 (96 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_88KHZ:
          adtsHeader[2] = (this.isAACPlus)
            ? 0x50  // Audio Type 2 (minus 1) Sampling Frequency index 4 (44.1 Khz), stereo
            : 0x44; // Audio Type 2 (minus 1) Sampling Frequency index 1 (88.2 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_64KHZ:
          adtsHeader[2] = (this.isAACPlus)
            ? 0x54  // Audio Type 2 (minus 1) Sampling Frequency index 5 (32 Khz), stereo
            : 0x48; // Audio Type 2 (minus 1) Sampling Frequency index 2 (64 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_48KHZ:
          adtsHeader[2] = (this.isAACPlus)
            ? 0x58  // Audio Type 2 (minus 1) Sampling Frequency index 6 (24 Khz), stereo
            : 0x4c; // Audio Type 2 (minus 1) Sampling Frequency index 3 (48 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_44KHZ:
          adtsHeader[2] = (this.isAACPlus)
            ? 0x5c  // Audio Type 2 (minus 1) Sampling Frequency index 7 (22.05 Khz), stereo
            : 0x50; // Audio Type 2 (minus 1) Sampling Frequency index 4 (44.1 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_32KHZ:
          adtsHeader[2] = (this.isAACPlus)
            ? 0x60  // Audio Type 2 (minus 1) Sampling Frequency index 8 (16 Khz), stereo
            : 0x54; // Audio Type 2 (minus 1) Sampling Frequency index 5 (32 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_24Khz:
          adtsHeader[2] = (this.isAACPlus)
            ? 0x64  // Audio Type 2 (minus 1) Sampling Frequency index 9 (12 Khz), stereo
            : 0x58; // Audio Type 2 (minus 1) Sampling Frequency index 6 (24 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_22Khz:
          adtsHeader[2] = (this.isAACPlus)
            ? 0x68  // Audio Type 2 (minus 1) Sampling Frequency index 10 (11 Khz), stereo
            : 0x5c; // Audio Type 2 (minus 1) Sampling Frequency index 7 (22 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_16Khz:
          adtsHeader[2] = (this.isAACPlus)
            ? 0x6c  // Audio Type 2 (minus 1) Sampling Frequency index 11 (8 Khz), stereo
            : 0x60; // Audio Type 2 (minus 1) Sampling Frequency index 8 (16 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_12Khz:
          if (this.isAACPlus) { throw new Error("Invalid sample rate for AAC-HE"); }
          adtsHeader[2] = 0x64;  // Audio Type 2 (minus 1) Sampling Frequency index 9 (12 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_11Khz:
          if (this.isAACPlus) { throw new Error("Invalid sample rate for AAC-HE"); }
          adtsHeader[2] = 0x68;  // Audio Type 2 (minus 1) Sampling Frequency index 10 (11 Khz), stereo
          break;
    
        case AudioUtil.CONSTS.SAMPLERATES.SAMPLERATE_8Khz:
          if (this.isAACPlus) { throw new Error("Invalid sample rate for AAC-HE"); }
          adtsHeader[2] = 0x6c;  // Audio Type 2 (minus 1) Sampling Frequency index 11 (8 Khz), stereo
          break;
      }
  
      adtsHeader[3] = 0x80 | (adtsFrameSize >> 11) & 0x03; // continuation of stereo + 2 MSBs size
      adtsHeader[4] = (adtsFrameSize >> 3) & 0xff; // 8 middle bits frame size
      adtsHeader[5] = ((adtsFrameSize << 5) & 0xe0) | 0x1f; // 3 LSBs frame size, buffer fullness
      adtsHeader[6] = 0xfc; // continuation of buffer fullness, num AAC frames (1) minus 1
  
      return adtsHeader;
    }
  };

  return MP4Parser;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/Mp4BoxTreeTemplate.js":
/*!**********************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/protocols/mp4/Mp4BoxTreeTemplate.js ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/07/16
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *    Contains the box tree model template for MP4s. This template should be populated with audio
 *    data before being passed into the Mp4Builder.build(tree) method.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  return {
    BoxHead: 0,
    BoxSize: 0,
    BoxType: "root",
    BoxPath: "",
    root:
      {
        ftyp:
          {
            BoxHead: 0,
            BoxSize: 0,
            BoxType: "ftyp",
            BoxPath: "root/ftyp",
            major_brand: "mp42",
            minor_version: 0,
            compatible_brands: []
          },
        mdat:
          {
            BoxHead: 0,
            BoxSize: 0,
            BoxType: "mdat",
            BoxPath: "root/mdat",
            data:
              {}
          },
        moov:
          {
            BoxHead: 0,
            BoxSize: 0,
            BoxType: "moov",
            BoxPath: "root/moov",
            mvhd:
              {
                BoxHead: 0,
                BoxSize: 0,
                BoxType: "mvhd",
                BoxPath: "root/moov/mvhd",
                version: 0,
                flags: 0,
                creation_time: 3554301323,
                modification_time: 3554301324,
                timescale: 1000,
                duration: 875291,
                rate: 65536,
                volume: 256,
                matrix: [
                  65536,
                  0,
                  0,
                  0,
                  65536,
                  0,
                  0,
                  0,
                  1073741824
                ],
                next_track_ID: 2
              },
            iods:
              {
                BoxHead: 0,
                BoxSize: 0,
                BoxType: "iods",
                BoxPath: "root/moov/iods",
                version: 0,
                flags: 0
              },
            trak: [
              {
                BoxHead: 0,
                BoxSize: 0,
                BoxType: "trak",
                BoxPath: "root/moov/trak",
                tkhd:
                  {
                    BoxHead: 0,
                    BoxSize: 0,
                    BoxType: "tkhd",
                    BoxPath: "root/moov/trak:0/tkhd",
                    version: 0,
                    flags: 1,
                    creation_time: 3554301323,
                    modification_time: 3554301324,
                    track_ID: 1,
                    duration: 875291,
                    layer: 0,
                    alternate_group: 0,
                    volume: 256,
                    matrix: [
                      65536,
                      0,
                      0,
                      0,
                      65536,
                      0,
                      0,
                      0,
                      1073741824
                    ],
                    width: 0,
                    height: 0
                  },
                mdia:
                  {
                    BoxHead: 0,
                    BoxSize: 0,
                    BoxType: "mdia",
                    BoxPath: "root/moov/trak:0/mdia",
                    mdhd:
                      {
                        BoxHead: 0,
                        BoxSize: 0,
                        BoxType: "mdhd",
                        BoxPath: "root/moov/trak:0/mdia/mdhd",
                        version: 0,
                        flags: 0,
                        creation_time: 3554301323,
                        modification_time: 3554301324,
                        timescale: 44100,
                        duration: 429056,
                        language: "```"
                      },
                    hdlr:
                      {
                        BoxHead: 0,
                        BoxSize: 0,
                        BoxType: "hdlr",
                        BoxPath: "root/moov/trak:0/mdia/hdlr",
                        version: 0,
                        flags: 0,
                        handler_type: 1936684398,
                        handler_type2: 0,
                        name: ""
                      },
                    minf:
                      {
                        BoxHead: 0,
                        BoxSize: 0,
                        BoxType: "minf",
                        BoxPath: "root/moov/trak:0/mdia/minf",
                        smhd:
                          {
                            BoxHead: 0,
                            BoxSize: 0,
                            BoxType: "smhd",
                            version: 0,
                            flags: 0,
                            balance: 0
                          },
                        dinf:
                          {
                            BoxHead: 0,
                            BoxSize: 0,
                            BoxType: "dinf",
                            BoxPath: "root/moov/trak:0/mdia/minf/dinf",
                            dref:
                              {
                                BoxHead: 0,
                                BoxSize: 0,
                                BoxType: "dref",
                                BoxPath: "root/moov/trak:0/mdia/minf/dinf/dref",
                                version: 0,
                                flags: 0,
                                entry_count: 1,
                                url: [
                                  {
                                    BoxHead: 0,
                                    BoxSize: 0,
                                    BoxType: "url ",
                                    BoxPath: "root/moov/trak:0/mdia/minf/dinf/dref/url ",
                                    version: 0,
                                    flags: 1,
                                    url: ""
                                  }]
                              }
                          },
                        stbl:
                          {
                            BoxHead: 0,
                            BoxSize: 0,
                            BoxType: "stbl",
                            BoxPath: "root/moov/trak:0/mdia/minf/stbl",
                            stsd:
                              {
                                BoxHead: 0,
                                BoxSize: 0,
                                BoxType: "stsd",
                                BoxPath: "root/moov/trak:0/mdia/minf/stbl/stsd",
                                version: 0,
                                flags: 0,
                                entry_count: 1,
                                mp4a:
                                  {
                                    BoxHead: 0,
                                    BoxSize: 0,
                                    BoxType: "mp4a",
                                    BoxPath: "root/moov/trak:0/mdia/minf/stbl/stsd/mp4a",
                                    version: 0,
                                    flags: 0,
                                    channelcount: 2,
                                    samplesize: 16,
                                    samplerate: 44100,
                                    data_reference_index: 1,
                                    esds:
                                      {
                                        BoxHead: 0,
                                        BoxSize: 0,
                                        BoxType: "esds",
                                        BoxPath: "root/moov/trak:0/mdia/minf/stbl/stsd/mp4a/esds"
                                      }
                                  }
                              },
                            stts:
                              {
                                BoxHead: 0,
                                BoxSize: 0,
                                BoxType: "stts",
                                BoxPath: "root/moov/trak:0/mdia/minf/stbl/stts",
                                version: 0,
                                flags: 0,
                                entry_count: 1,
                                samples: [
                                  {
                                    sample_count: 0,
                                    sample_delta: 0
                                  }]
                              },
                            ctts:
                              {
                                BoxHead: 0,
                                BoxSize: 0,
                                BoxType: "ctts",
                                BoxPath: "root/moov/trak:0/mdia/minf/stbl/ctts",
                                version: 0,
                                flags: 0,
                                entry_count: 1,
                                samples: [
                                  {
                                    sample_count: 0,
                                    sample_delta: 0
                                  }]
                              },
                            stsz:
                              {
                                BoxHead: 0,
                                BoxSize: 0,
                                BoxType: "stsz",
                                BoxPath: "root/moov/trak:0/mdia/minf/stbl/stsz",
                                version: 0,
                                flags: 0,
                                sample_size: 0,
                                sample_count: 420,
                                samples: [
                                  {
                                    entry_size: 0
                                  }]
                              },
                            stsc:
                              {
                                BoxHead: 0,
                                BoxSize: 0,
                                BoxType: "stsc",
                                BoxPath: "root/moov/trak:0/mdia/minf/stbl/stsc",
                                version: 0,
                                flags: 0,
                                entry_count: 1,
                                samples: [
                                  {
                                    first_chunk: 1,
                                    samples_per_chunk: 1,
                                    sample_description_index: 1
                                  }]
                              },
                            stco:
                              {
                                BoxHead: 0,
                                BoxSize: 0,
                                BoxType: "stco",
                                BoxPath: "root/moov/trak:0/mdia/minf/stbl/stco",
                                version: 0,
                                flags: 0,
                                entry_count: 1,
                                samples: [
                                  {
                                    chunk_offset: 0
                                  }]
                              }
                          }
                      }
                  }
              }],
            udta:
              {
                BoxHead: 0,
                BoxSize: 0,
                BoxType: "udta",
                BoxPath: "root/moov/udta",
                meta:
                  {
                    BoxHead: 0,
                    BoxSize: 0,
                    BoxType: "meta",
                    BoxPath: "root/moov/udta/meta",
                    version: 0,
                    flags: 0,
                    hdlr:
                      {
                        BoxHead: 0,
                        BoxSize: 0,
                        BoxType: "hdlr",
                        BoxPath: "root/moov/udta/meta/hdlr",
                        version: 0,
                        flags: 0,
                        handler_type: 1835297138,
                        handler_type2: 1634758764,
                        name: ""
                      }
                  }
              }
          }
      }
  };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/Mp4Builder.js":
/*!**************************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/protocols/mp4/Mp4Builder.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/31/16
 * @COPYRIGHT:  2016 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *    Builds MP4 containers.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var Mp4BoxTreeTemplate = __webpack_require__(/*! sxm/audioplayer/html5/protocols/mp4/Mp4BoxTreeTemplate */ "./javascript/src/sxm/audioplayer/html5/protocols/mp4/Mp4BoxTreeTemplate.js");
  var AacDecoder = __webpack_require__(/*! sxm/audioplayer/html5/audio/decoder/AacDecoder */ "./javascript/src/sxm/audioplayer/html5/audio/decoder/AacDecoder.js");
  var AudioContext = __webpack_require__(/*! sxm/audioplayer/html5/audio/AudioContext */ "./javascript/src/sxm/audioplayer/html5/audio/AudioContext.js");

  /**
   * Internal reference to the logger.
   * @type {WebAudioPlayerLogger|*}
   */
  var logger = LoggerFactory.getLogger("Mp4Builder", "CORE");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * The constructor function is simply defined as a reference to create "static" methods.
   *
   * @constructor
   */
  function Mp4Builder() {}

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /**
   * The average number of milliseconds in an audio chunk.
   *
   * TODO: BMR: This is a magic number -- can we derive it?
   *
   * Possible formula:
   *    * Number of Frames * Samples Per Frame / Sampling Rate
   *    * 420 * 1024 / 44100
   *
   * @type {Number}
   */
  Mp4Builder.DURATION = 9753;

  /**
   * AAC-LC number of samples or bytes per frame.
   *
   * @type {Number}
   */
  Mp4Builder.AAC_LC_SAMPLES_PER_FRAME = AacDecoder.CONSTS.AAC_LC_SAMPLES_PER_FRAME;

  /**
   * AAC-HE number of samples or bytes per frame.
   *
   * @type {Number}
   */
  Mp4Builder.AAC_HE_SAMPLES_PER_FRAME = AacDecoder.CONSTS.AAC_HE_SAMPLES_PER_FRAME;

  /**
   * The byte index of the last byte in the `mdat` box's type field. The idea is that the next byte is
   * where the audio starts.
   *
   * TODO: BMR: This is a magic number -- can we derive it?
   *
   * @type {Number}
   */
  Mp4Builder.MDAT_BYTE_INDEX = 36;

  /**
   * The number of frames in AAC Plus or AAC-HE (bit rates lower than 128k, so 32k, 64k, and 96k) audio data.
   *
   * TODO: BMR: This is a magic number -- can we derive it?
   *
   * @type {Number}
   */
  Mp4Builder.AAC_PLUS_FRAMES_LENGTH = 210;

  /**
   * The number of frames in AAC-LC (bit rates greater than 128k, so 256k) audio data.
   *
   * TODO: BMR: This is a magic number -- can we derive it?
   *
   * @type {Number}
   */
  Mp4Builder.AAC_FRAMES_LENGTH = 420;

  // TODO
  Mp4Builder.AAC_SAMPLE_RATE = AudioContext.CONSTS.SAMPLE_RATE_44KHZ;

  /**
   * Builds an MP4 object based on the box tree passed in. The key component is the `source` property
   * that contains the actual byte data for the MP4 file.
   */
  Mp4Builder.build = function (tree, aacPlus) {
    logger.debug("build()");

    var view = null;
    var root = {
      BoxPath: "",
      BoxType: "root",
      BoxSize: 0,
      cursor: 0,
      source: []
    };

    try {
      var ftyp = _ftyp(tree, "ftyp");
      var mdat = _mdat(tree, "mdat");
      var moov = _moov("moov");
      var mvhd = _mvhd(tree, "moov/mvhd");
      var iods = _iods(tree, "moov/iods");
      var trak = _trak("moov/trak");
      var tkhd = _tkhd(tree, "moov/trak:0/tkhd");
      var mdia = _mdia("moov/trak:0/mdia");
      var mdhd = _mdhd(tree, "moov/trak:0/mdia/mdhd");
      var hdlr = _hdlr(tree, "moov/trak:0/mdia/hdlr");
      var minf = _minf("moov/trak:0/mdia/minf");
      var smhd = _smhd(tree, "moov/trak:0/mdia/minf/smhd");
      var dinf = _dinf("moov/trak:0/mdia/minf/dinf");
      var dref = _dref("moov/trak:0/mdia/minf/dinf/dref");
      var stbl = _stbl("moov/trak:0/mdia/minf/stbl");
      var stsd = _stsd(tree, "moov/trak:0/mdia/minf/stbl/stsd");
      var mp4a = _mp4a(tree, "moov/trak:0/mdia/minf/stbl/stsd/mp4a");
      var esds = _esds("moov/trak:0/mdia/minf/stbl/stsd/mp4a/esds", aacPlus);
      var stts = _stts(tree, "moov/trak:0/mdia/minf/stbl/stts");
      var stsz = _stsz(tree, "moov/trak:0/mdia/minf/stbl/stsz");
      var stsc = _stsc(tree, "moov/trak:0/mdia/minf/stbl/stsc");
      var stco = _stco(tree, "moov/trak:0/mdia/minf/stbl/stco");
      var udta = _udta(tree, "moov/udta");

      view =
        _mx(root,
          ftyp,
          mdat,
          _mx(moov,
            mvhd,
            iods,
            _mx(trak, tkhd,
              _mx(mdia, mdhd, hdlr,
                _mx(minf, smhd,
                  _mx(dinf, dref),
                  _mx(stbl,
                    _mx(stsd,
                      _mx(mp4a, esds)
                    ),
                    stts,
                    stsz,
                    stsc,
                    stco
                  )
                )
              )
            ),
            _mx(udta)
          )
        );
    }
    catch (error) {
      logger.error("build( tree = {0} )", [error.message]);
    }

    return view;
  };

  /**
   * Creates a MP4 box tree template using the audio data, the size of that data, and number of frames.
   *
   * @param {ArrayBuffer} audioData - The raw audio data, currently expected to be AAC.
   * @param {Number} framesLen - The number of AAC frames is used to set the number of samples in the MP4 world.
   * @param {Array} bytesPerFrameList - Lists the number of bytes per audio frame. This is used to create
   * some of the sample boxes in the MP4 world, especially the sample sizes and offset boxes.
   * @param {Boolean} aacPlus is true of this is AAC+ data, false otherwise
   * @returns {*} A MP4 template populated with the audio data passed in and some details as they relate
   * to the audio data in the MP4 box model.
   */
  Mp4Builder.createBoxTreeTemplate = function (audioData, framesLen, bytesPerFrameList, aacPlus) {
    logger.debug("createBoxTreeTemplate( Adding AAC audio data to the MP4 box tree template. )");

    var box;
    var tree = Mp4BoxTreeTemplate;

    var populateMdatBox = function (boxType) {
      box = _findBoxByPath(tree, boxType);
      if (box) {
        box.data = audioData;
      }
    };

    var populateStscBox = function (boxType) {
      box = _findBoxByPath(tree, boxType);
      if (box) {
        box.samples[0].first_chunk = 1;
        box.samples[0].samples_per_chunk = 1;
        box.samples[0].sample_description_index = 1;
        box.framesLen = 1;
      }
    };

    var populateSttsBox = function (boxType) {
      box = _findBoxByPath(tree, boxType);
      if (box) {
        box.entry_count = 1;
        box.samples[0].sample_count = framesLen;
        box.samples[0].sample_delta = aacPlus ? Mp4Builder.AAC_HE_SAMPLES_PER_FRAME : Mp4Builder.AAC_LC_SAMPLES_PER_FRAME;
      }
    };

    var populateStszBox = function (boxType) {
      box = _findBoxByPath(tree, boxType);
      if (box) {
        box.sample_count = framesLen;
        box.samples = [];
        // for(var i = 0; i < bytesPerFrameList.length; i++)
        for (var i = 0; i < framesLen; i++) {
          box.samples.push(
            {
              entry_size: bytesPerFrameList[i]
            });
        }
      }
    };

    var populateStcoBox = function (boxType) {
      box = _findBoxByPath(tree, boxType);
      if (box) {
        var len = framesLen;
        var offset = 0;

        box.samples = [];
        box.entry_count = len;
        for (var j = 0; j < len; j++) {
          // TODO: BMR: We should calculate the magic number 32 as it comes from the last byte of the `mdat` type byte.
          // The offset from the previous one plus the byte size of the previous sample.
          offset = (j > 0) ? (bytesPerFrameList[j - 1] + box.samples[j - 1].chunk_offset) : Mp4Builder.MDAT_BYTE_INDEX;
          box.samples.push(
            {
              chunk_offset: offset
            });
        }
      }
    };

    // TODO: BMR: Move these box type strings directly into the functions.
    populateMdatBox("mdat");
    populateStscBox("moov/trak:0/mdia/minf/stbl/stsc");
    populateSttsBox("moov/trak:0/mdia/minf/stbl/stts");
    populateStszBox("moov/trak:0/mdia/minf/stbl/stsz");
    populateStcoBox("moov/trak:0/mdia/minf/stbl/stco");
    // populateCttsBox("moov/trak:0/mdia/minf/stbl/ctts");

    return tree;
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Mp4Builder class, we could write:
   *
   *  `BankManager.prototype = Mp4Builder.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  Mp4Builder.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: Mp4Builder
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * Create box class view, without version and flags.
   *
   * @param boxType
   * @param boxPath
   * @returns {{BoxSize: number, BoxType: *, BoxPath: *, cursor: number, source: [number,number,number,number,*,*,*,*]}}
   * @private
   */
  var _createBoxClassView = function (boxType, boxPath) {
    // ISO/IEC 14496-12 ISO base media file format - 4.2 Object Structure
    //
    //      aligned(8) class Box(unsigned int(32) boxtype,
    //                           optional unsigned int(8)[16] extended_type) {
    //          unsigned int(32) size;
    //          unsigned int(32) type = boxtype;
    //          if (size == 1) {
    //              unsigned int(64) largesize;
    //          } else if (size == 0) {
    //              // box extends to end of file
    //          }
    //          if (boxtype == "uuid") {
    //              unsigned int(8)[16] usertype = extended_type;
    //          }
    //      }
    //
    // > size is an integer that specifies the number of bytes in this box,
    // > including all its fields and contained boxes;
    // > if size is 1 then the actual size is in the field largesize;
    // > if size is 0, then this box is the last one in the file,
    // > and its contents extend to the end of the file (normally only used for a Media Data Box)

    return {
      BoxSize: 8,
      BoxType: boxType,
      BoxPath: boxPath,
      cursor: 8,
      source: [
        0x00, // BoxSize(4) reserved
        0x00, // BoxSize(4) reserved
        0x00, // BoxSize(4) reserved
        0x08, // BoxSize(4) reserved
        boxType.charCodeAt(0),
        boxType.charCodeAt(1),
        boxType.charCodeAt(2),
        boxType.charCodeAt(3)
      ]
    };
  };

  function _createFullBoxClassView(boxType, // @arg MP4BoxTypeString - eg: "ftyp"
                                   boxPath, // @arg MP4BoxPathString - "root/ftyp"
                                   version, // @arg UINT8 = 0
                                   flags) { // @arg UINT24 = 0
    // @ret MP4BoxClassFullViewObject - { source, cursor }
    // @desc create box class view, with version and flags.
    //
    // ISO/IEC 14496-12 ISO base media file format - 4.2 Object Structure
    //
    //      aligned(8) class FullBox(unsigned int(32) boxtype,
    //                               unsigned int(8) v,
    //                               bit(24) f) extends Box(boxtype) {
    //          unsigned int(8) version = v;
    //          bit(24) flags = f;
    //      }
    //

    version = version || 0;
    flags = flags || 0;

    return {
      BoxSize: 12,
      BoxType: boxType,
      BoxPath: boxPath,
      cursor: 12,
      source: [
        0x00, // BoxSize(4) reserved
        0x00, // BoxSize(4) reserved
        0x00, // BoxSize(4) reserved
        0x0C, // BoxSize(4) reserved
        boxType.charCodeAt(0),
        boxType.charCodeAt(1),
        boxType.charCodeAt(2),
        boxType.charCodeAt(3), (version >>> 0) & 0xff, (flags >>> 16) & 0xff, (flags >>> 8) & 0xff, (flags >>> 0) & 0xff
      ]
    };
  }

  function _findBoxByPath(tree, // @arg MP4BoxTreeObject - { root: { ftyp, moov: {...}, free, mdat } }
                          boxPath) { // @arg MP4BoxPathString - eg: "moov/trak:0/mdia/minf"
    // @ret MP4BoxObject|null - { property... }
    // eslint-disable-next-line dot-notation
    var boxObject = tree["root"];
    var pathArray = boxPath.split("/"); // "moov/trak:0/mdia/minf" -> ["moov", "trak:0", "mdia", "minf"]

    for (var i = 0, iz = pathArray.length; boxObject && i < iz; ++i) {
      var boxType = pathArray[i]; // "moov" / "trak:0" / "mdia" / "minf"

      if (_hasTrackNumber(boxType)) {
        var tokenArray = boxType.split(":"); // "trak:0" -> ["trak", 0]

        boxObject = boxObject[tokenArray[0]][tokenArray[1]] || null; // get track
      }
      else {
        boxObject = boxObject[boxType] || null; // get object
      }
    }
    return boxObject;

    function _hasTrackNumber(boxType) { // @arg MP4BoxTypeString
      // @ret Boolean
      return boxType.indexOf(":") >= 0; // "trak:0" -> true
    }
  }

  function _getLastBoxType(boxPath) { // @arg MP4BoxPathString - "moov/mvhd"
    // @ret MP4BoxTypeString - "mvhd"
    // @desc get last BoxType in path.
    if (boxPath.indexOf("/") < 0) {
      return boxPath;
    }
    var tokenArray = boxPath.split("/");

    return tokenArray[tokenArray.length - 1];
  }

  function _writeT(view, // @arg Object - { source, cursor }
                   text, // @arg String
                   size) { // @arg UINT8
    // @ret Object - { source, cursor }
    // @desc write text
    for (var i = 0, iz = size; i < iz; ++i) {
      view.source[view.cursor++] = text.charCodeAt(i);
    }
    return view;
  }

  function _write1(view, // @arg Object - { source, cursor }
                   value) { // @arg UINT8
    // @ret Object - { source, cursor }
    view.source[view.cursor++] = (value >>> 0) & 0xff;
    return view;
  }

  function _write2(view, // @arg Object - { source, cursor }
                   value) { // @arg UINT16
    // @ret Object - { source, cursor }
    view.source[view.cursor++] = (value >>> 8) & 0xff;
    view.source[view.cursor++] = (value >>> 0) & 0xff;
    return view;
  }

  /**
   * Writes 4 bytes to the ArrayBuffer.
   * @param view
   * @param value
   * @returns {*}
   * @private
   */
  function _write4(view, // @arg Object - { source, cursor }
                   value) { // @arg UINT32
    // @ret Object - { source, cursor }
    view.source[view.cursor++] = (value >>> 24) & 0xff;
    view.source[view.cursor++] = (value >>> 16) & 0xff;
    view.source[view.cursor++] = (value >>> 8) & 0xff;
    view.source[view.cursor++] = (value >>> 0) & 0xff;
    return view;
  }

  function _writeBoxSize(view, // @arg MP4BoxClassViewObject|MP4BoxClassFullViewObject
                         boxSize) { // @arg UINT32
    // @ret Uint8Array|Array
    view.BoxSize = boxSize;
    view.source[0] = (boxSize >>> 24) & 0xff;
    view.source[1] = (boxSize >>> 16) & 0xff;
    view.source[2] = (boxSize >>> 8) & 0xff;
    view.source[3] = (boxSize >>> 0) & 0xff;
    return view;
  }

  var _ftyp = function (tree, boxPath) { // @arg MP4BoxPathString
    // @ret Object - { BoxType:String, source:Uint8Array, cursor:UINT32 }
    var box = _findBoxByPath(tree, boxPath);
    var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);

    // Add metadata specific to the FTYP box type.
    // box.major_brand = box.major_brand || "mp42";
    box.major_brand = "isom";
    // box.major_brand = "M4A";
    // box.minor_version = box.minor_version || 0;
    box.minor_version = 512;
    // if(!box.compatible_brands)
    // {
    // box.compatible_brands = [];
    // box.compatible_brands[0] = "mp42";
    // box.compatible_brands[1] = "isom";

    box.compatible_brands = [];
    box.compatible_brands[0] = "isom";
    box.compatible_brands[1] = "iso2";
    box.compatible_brands[2] = "mp41";
    // }

    // ORIG
    // _writeT(view, box["major_brand"], 4); // "isom"
    // _write4(view, box["minor_version"]); // 512
    // _writeT(view, box["compatible_brands"][0], 4); // "isom"
    // _writeT(view, box["compatible_brands"][1], 4); // "iso2"
    // _writeT(view, box["compatible_brands"][2], 4); // "avc1"
    // _writeT(view, box["compatible_brands"][3], 4); // "mp41"

    _writeT(view, box.major_brand, 4); // "isom"
    _write4(view, box.minor_version); // 512

    for (var i = 0; i < box.compatible_brands.length; i++) {
      _writeT(view, box.compatible_brands[i], 4);
    }

    // _writeT(view, box.compatible_brands[0], 4); // "isom"
    // _writeT(view, box.compatible_brands[1], 4); // "iso2"
    // _writeT(view, box.compatible_brands[2], 4); // "avc1"
    // _writeT(view, box.compatible_brands[3], 4); // "mp41"

    _writeBoxSize(view, view.source.length);
    return view;
  };

  function _mdat(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString

    // @ret Object - { BoxType:String, source:Uint8Array, cursor:UINT32 }
    var box = _findBoxByPath(tree, boxPath);
    // eslint-disable-next-line no-undef
    if ((box.data instanceof ArrayBuffer)) {
      box.data = new Uint8Array(box.data);
    }
    var boxSize = 4 + 4 + box.data.length; // | BoxSize(4) | BoxType(4) | BoxData(n) |
    var boxType = _getLastBoxType(boxPath);
    var view = {
      BoxSize: boxSize,
      BoxType: boxType,
      BoxPath: boxPath,
      source: new Uint8Array(boxSize),
      cursor: 0
    };

    view.source[0] = (boxSize >>> 24) & 0xff;
    view.source[1] = (boxSize >>> 16) & 0xff;
    view.source[2] = (boxSize >>> 8) & 0xff;
    view.source[3] = (boxSize >>> 0) & 0xff;
    view.source[4] = boxType.charCodeAt(0);
    view.source[5] = boxType.charCodeAt(1);
    view.source[6] = boxType.charCodeAt(2);
    view.source[7] = boxType.charCodeAt(3);
    view.source.set(box.data, 8);
    return view;
  }

  function _mx(parentBoxView // @arg MP4BoxClassViewObject|MP4BoxClassFullViewObject
               /*, childrenBoxView... */
  ) { // @var_args MP4BoxClassViewObject|MP4BoxClassFullViewObject
    // @ret MP4BoxView - { BOxSize, BoxType, BoxPath, source, cursor }
    // @desc mixin
    var args = arguments;
    // --- get BoxSize ---
    var boxSize = parentBoxView.source.length;
    var boxType = parentBoxView.BoxType;
    var boxPath = parentBoxView.BoxPath;
    var viewObject = null;
    var children = {};

    // --- Write BoxSize include children BoxSize ---
    for (var i = 1, iz = args.length; i < iz; ++i) {
      viewObject = args[i];
      if (viewObject) {
        children[viewObject.BoxPath] = {
          "BoxPath": viewObject.BoxPath,
          "BoxSize": viewObject.BoxSize,
          "BoxType": viewObject.BoxType
        };
        boxSize += viewObject.source.length;
      }
    }
    // --- copy BoxData to new buffer ---
    var buffer = new Uint8Array(boxSize);
    var cursor = 0;
    for (i = 0; i < iz; ++i) {
      viewObject = args[i];
      if (viewObject) {
        buffer.set(viewObject.source, cursor); // BoxData copy to buffer
        cursor += viewObject.source.length; // move cursor
      }
    }
    if (boxType === "root") {
      return {
        BoxSize: buffer.length,
        BoxType: boxType,
        BoxPath: boxPath,
        cursor: 0,
        source: buffer
      };
    }
    buffer[0] = (boxSize >>> 24) & 0xff;
    buffer[1] = (boxSize >>> 16) & 0xff;
    buffer[2] = (boxSize >>> 8) & 0xff;
    buffer[3] = (boxSize >>> 0) & 0xff;

    return {
      BoxSize: boxSize,
      BoxType: boxType, // parent BoxType
      BoxPath: boxPath, // parent BoxPath
      cursor: cursor,
      source: buffer
    };
  }

  function _moov(boxPath) { // @arg MP4BoxPathString
    // @ret Object - { BoxType:String, source:Uint8Array, cursor:UINT32 }
    var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);
    return view;
  }

  function _mvhd(tree, boxPath) { // @arg MP4BoxPathString
    // @ret Object - { BoxType:String, source:Uint8Array, cursor:UINT32 }

    var box = _findBoxByPath(tree, boxPath);
    // box.version = box.version || 1;
    // box.flags = box.flags || 0;

    /*
     creation_time: 0,
     modification_time: 0,
     timescale: 90000,
     duration: 9725,
     // rate: 1.0,
     rate: 65536,
     volume: 256,
     matrix: [
     65536,
     0,
     0,
     0,
     65536,
     0,
     0,
     0,
     1073741824
     ],
     next_track_ID: 2
     */

    box.creation_time = box.creation_time || new Date().getTime();
    box.modification_time = box.modification_time || new Date().getTime();
    box.timescale = box.timescale || 1000;
    // box.duration = box.duration || Mp4Builder.DURATION;
    box.duration = Mp4Builder.DURATION;
    // box.rate = box.rate || 65536;
    // box.rate = 0x0001;
    box.rate = 0x00010000;
    // box.rate = 0x00010000;
    box.volume = box.volume || 256;
    // box.volume = 0x0100;
    box.next_track_ID = box.next_track_ID || 2;

    if (!box.matrix) {
      box.matrix = [0x00010000, 0, 0, 0, 0x00010000, 0, 0, 0, 0x40000000];
      // for(var i = 0; i < 9; i++)
      // {
      // 	box.matrix[i] = 0;
      // }
    }

    // float2fix(a) ((int)((a)*256.0))         //Convert float to fix. a is a float

    var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath, box.version, box.flags);
    _write4(view, box.creation_time);
    _write4(view, box.modification_time);
    _write4(view, box.timescale);
    _write4(view, box.duration);
    _write4(view, box.rate);
    // _writeFixedPont88(view, box.rate);
    _write2(view, box.volume);
    // _writeFixedPont88(view, box.volume);
    _write2(view, 0); // reserved = 0
    _write4(view, 0); // reserved = 0
    _write4(view, 0); // reserved = 0

    // TODO: BMR: What should this be?
    _write4(view, box.matrix[0]);
    _write4(view, box.matrix[1]);
    _write4(view, box.matrix[2]);
    _write4(view, box.matrix[3]);
    _write4(view, box.matrix[4]);
    _write4(view, box.matrix[5]);
    _write4(view, box.matrix[6]);
    _write4(view, box.matrix[7]);
    _write4(view, box.matrix[8]);

    _write4(view, 0); // pre_defined[0]
    _write4(view, 0); // pre_defined[1]
    _write4(view, 0); // pre_defined[2]
    _write4(view, 0); // pre_defined[3]
    _write4(view, 0); // pre_defined[4]
    _write4(view, 0); // pre_defined[5]
    _write4(view, box.next_track_ID);
    _writeBoxSize(view, view.source.length);
    return view;
  }

  function _iods(tree, boxPath) {
    var box = _findBoxByPath(tree, boxPath);
    var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath, box.version, box.flags);

    view.cursor = 0;
    view.source = [];

    // 00 00 00 18
    _write4(view, 0x00000018);

    // 69 6F 64 73
    _write4(view, 0x696F6473);

    // 00 00 00 00
    _write4(view, 0x00000000);

    // 10 80 80 80
    _write4(view, 0x10808080);

    // 07 00 4F FF
    _write4(view, 0x07004FFF);

    // FF 0F FF FF
    _write4(view, 0xFF0FFFFF);

    return view;
  }

  function _trak(boxPath) { // @arg MP4BoxPathString
    // @ret Object - { BoxType:String, source:Uint8Array, cursor:UINT32 }
    var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);
    return view;
  }

  function _tkhd(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString
    var box = _findBoxByPath(tree, boxPath);
    var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath, box.version, box.flags); // 0, 3

    box.creation_time = box.creation_time || new Date().getTime();
    box.modification_time = box.modification_time || new Date().getTime();

    // box.duration = box.duration || Mp4Builder.DURATION;
    box.duration = Mp4Builder.DURATION;
    box.layer = box.layer || 0;
    box.alternate_group = box.alternate_group || 0;
    box.volume = box.volume || 1.0;
    box.volume = 0x0100;
    box.width = box.width || 0;
    box.height = box.height || 0;

    if (!box.matrix) {
      box.matrix = [0x00010000, 0, 0, 0, 0x00010000, 0, 0, 0, 0x40000000];
      // for(var i = 0; i < 9; i++)
      // {
      // 	box.matrix[i] = 0;
      // }
    }

    _write4(view, box.creation_time);
    _write4(view, box.modification_time);
    _write4(view, box.track_ID);
    _write4(view, 0); // reserved = 0;
    _write4(view, box.duration);
    _write4(view, 0); // reserved = 0;
    _write4(view, 0); // reserved = 0;
    _write2(view, box.layer);
    _write2(view, box.alternate_group);
    _write2(view, box.volume);
    // _writeFixedPont88(view, box.volume);
    _write2(view, 0); // reserved = 0;
    _write4(view, box.matrix[0]);
    _write4(view, box.matrix[1]);
    _write4(view, box.matrix[2]);
    _write4(view, box.matrix[3]);
    _write4(view, box.matrix[4]);
    _write4(view, box.matrix[5]);
    _write4(view, box.matrix[6]);
    _write4(view, box.matrix[7]);
    _write4(view, box.matrix[8]);
    _write4(view, box.width);
    _write4(view, box.height);
    _writeBoxSize(view, view.source.length);
    return view;
  }

  function _mdia(boxPath) { // @arg MP4BoxPathString
    var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);
    return view;
  }

  function _mdhd(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString
    var box = _findBoxByPath(tree, boxPath);
    var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath, box.version, box.flags);

    box.creation_time = box.creation_time || new Date().getTime();
    // box.creation_time = Date.UTC(0. 1, 1904,) / 1000;
    // Jan. 1, 1904
    box.modification_time = box.modification_time || new Date().getTime();
    box.timescale = box.timescale || Mp4Builder.AAC_SAMPLE_RATE;
    // box.duration = box.duration || 429056;
    box.duration = box.duration || 429056;
    box.language = box.language || "";

    _write4(view, box.creation_time);
    _write4(view, box.modification_time);
    _write4(view, box.timescale);
    _write4(view, box.duration);
    _write2(view, (box.language.charCodeAt(0) - 0x60) << 10 |
      (box.language.charCodeAt(1) - 0x60) << 5 |
      (box.language.charCodeAt(2) - 0x60));
    _write2(view, 0); // pre_defined
    _writeBoxSize(view, view.source.length);
    return view;
  }

  function _hdlr(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString - "moov/trak:0/mdia/hdlr" or "moov/udta/meta/hdlr"

    var box = _findBoxByPath(tree, boxPath);
    var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath, box.version, box.flags);

    box.handler_type = box.handler_type || "soun";
    box.handler_type2 = box.handler_type2 || 0;
    // box.name = box.name || "SoundHandler";
    box.name = box.name || "";

    _write4(view, 0); // pre_defined = 0
    _writeT(view, "soun", 4); // "isom"

    // meta/hdlr.handler_type = 1835297138 = 0x6d646972 = "mdir"
    // _write4(view, box.handler_type2); // mdia/hdlr.handler_type2 = 0
    // meta/hdlr.handler_type2 = 1634758764 = 0x6d646972 = "appl"
    _write4(view, 0); // reserved = 0
    _write4(view, 0); // reserved = 0
    _write4(view, 0); // reserved = 0
    _write1(view, 0x00); // add null-terminate
    _writeBoxSize(view, view.source.length);

    return view;
  }

  function _minf(boxPath) { // @arg MP4BoxPathString
    var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);
    return view;
  }

  /**
   *
   *
   * @param tree
   * @param boxPath
   * @returns {*}
   * @private
   */
  function _smhd(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString
    var box = _findBoxByPath(tree, boxPath);
    if (box) {
      // aligned(8) class SoundMediaHeaderBox extends FullBox(‘smhd’, version = 0, 0) {
      // 		template int(16) balance = 0;
      // 		const unsigned int(16)  reserved = 0;
      // }

      var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath, box.version, box.flags); // 0, 1 (flags always 1)
      _write2(view, box.balance); // template int(16) balance = 0;
      _write2(view, 0x00); // const unsigned int(16)  reserved = 0;
      _writeBoxSize(view, view.source.length);
      return view;
    }
    return null;
  }

  function _dinf(boxPath) { // @arg MP4BoxPathString
    var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);
    return view;
  }

  function _dref(boxPath) { // @arg MP4BoxPathString
    var view = {
      BoxSize: 28,
      BoxType: "dref",
      BoxPath: boxPath,
      cursor: 28,
      source: [
        0x00, 0x00, 0x00, 0x1C, // BoxSize 28
        0x64, 0x72, 0x65, 0x66, // BoxType "dref"
        0x00, // unsigned int(8)  version
        0x00, 0x00, 0x00, // unsigned int(24) flags
        0x00, 0x00, 0x00, 0x01, // unsigned int(32) entry_count
        0x00, 0x00, 0x00, 0x0C, // BoxSize 12
        0x75, 0x72, 0x6C, 0x20, // BoxType "url "
        0x00, // unsigned int(8)  version
        0x00, 0x00, 0x01 // unsigned int(24) flags = 0x000000 or 0x000001
      ]
    };
    return view;
  }

  function _stbl(boxPath) { // @arg MP4BoxPathString
    var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);
    return view;
  }

  function _stsd(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString
    var box = _findBoxByPath(tree, boxPath);
    var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath,
      box.version, box.flags); // 0, 0
    _write4(view, box.entry_count);
    return view;
  }

  function _stts(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString
    var box = _findBoxByPath(tree, boxPath);
    var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath,
      box.version, box.flags); // 0, 0
    _write4(view, box.entry_count);

    for (var i = 0, iz = box.entry_count; i < iz; ++i) {
      _write4(view, box.samples[i].sample_count);
      _write4(view, box.samples[i].sample_delta);
    }
    _writeBoxSize(view, view.source.length);
    return view;
  }

  function _stsc(tree, boxPath) {
    var box = _findBoxByPath(tree, boxPath);
    var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath, box.version, box.flags); // 0, 0

    _write4(view, box.entry_count);

    for (var i = 0, iz = box.entry_count; i < iz; ++i) {
      _write4(view, box.samples[i].first_chunk);
      _write4(view, box.samples[i].samples_per_chunk);
      _write4(view, box.samples[i].sample_description_index);
    }
    _writeBoxSize(view, view.source.length);
    return view;
  }

  function _stsz(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString
    var box = _findBoxByPath(tree, boxPath);
    if (box) {
      var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath, box.version, box.flags); // 0, 0
      _write4(view, box.sample_size);
      _write4(view, box.sample_count);

      if (box.sample_size === 0) {
        for (var i = 0, iz = box.sample_count; i < iz; ++i) {
          _write4(view, box.samples[i].entry_size);
        }
      }
      _writeBoxSize(view, view.source.length);
      return view;
    }
    return null;
  }

  function _stco(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString
    var box = _findBoxByPath(tree, boxPath);
    var view = _createFullBoxClassView(_getLastBoxType(boxPath), boxPath,
      box.version, box.flags); // 0, 0
    var entry_count = box.entry_count;

    _write4(view, entry_count);

    for (var i = 0, iz = entry_count; i < iz; ++i) {
      _write4(view, box.samples[i].chunk_offset);
    }
    _writeBoxSize(view, view.source.length);
    return view;
  }

  function _udta(tree, // @arg MP4BoxTreeObject
                 boxPath) { // @arg MP4BoxPathString
    // "moov.udta" or "trak.udta"
    var box = _findBoxByPath(tree, boxPath);
    if (box) {
      var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);

      // 75 64 74 61
      // _write4(view, 0x75647461);
      // 00 00 00 6F
      _write4(view, 0x0000006F);
      // 6D 65 74 61
      _write4(view, 0x6D657461);
      // 00 00 00 00
      _write4(view, 0x00000000);
      // 00 00 00 21
      _write4(view, 0x00000021);
      // 68 64 6C 72
      _write4(view, 0x68646C72);
      // 00 00 00 00
      _write4(view, 0x00000000);
      // 00 00 00 00
      _write4(view, 0x00000000);
      // 6D 64 69 72
      _write4(view, 0x6D646972);
      // 61 70 70 6C
      _write4(view, 0x6170706C);
      // 00 00 00 00
      _write4(view, 0x00000000);
      // 00 00 00 00
      _write4(view, 0x00000000);
      // 00 00 00 00
      _write4(view, 0x00000000);
      // 42 69 6C 73
      _write4(view, 0x42696C73);
      // 74 00 00 00
      _write4(view, 0x74000000);
      // 3A A9 74 6F
      _write4(view, 0x3AA9746F);
      // 6F 00 00 00
      _write4(view, 0x36F000000);
      // 32 64 61 74
      _write4(view, 0x32646174);
      // 61 00 00 00
      _write4(view, 0x61000000);
      // 01 00 00 00
      _write4(view, 0x01000000);
      // 00 46 41 41
      _write4(view, 0x00464141);
      // 43 20 31 2E
      _write4(view, 0x4320312E);
      // 32 36 2E 31
      _write4(view, 0x32362E31);
      // 20 28 41 70
      _write4(view, 0x20284170);
      // 72 20 32 39
      _write4(view, 0x72203239);
      // 20 32 30 30
      _write4(view, 0x20323030);
      // 38 29 20 55
      _write4(view, 0x38292055);
      // 4E 53 54 41
      _write4(view, 0x4E535441);
      // 42 4C
      _write2(view, 0x424C);
      // 45
      _write1(view, 0x45);

      return view;
    }
    return null;
  }

  /*
   class AudioSampleEntry(codingname) extends SampleEntry (codingname){
   const unsigned int(8)[6] reserved = 0;
   unsigned int(16) data_reference_index;

       const unsigned int(32)[2] reserved = 0;
       template unsigned int(16) channelcount = 2;
       template unsigned int(16) samplesize = 16;
       unsigned int(16) pre_defined = 0;
       const unsigned int(16) reserved = 0 ;
       template unsigned int(32) samplerate = {timescale of media}<<16;
   }

   class VisualSampleEntry(codingname) extends SampleEntry (codingname){
       unsigned int(16) pre_defined = 0;
       const unsigned int(16) reserved = 0;
       unsigned int(32)[3] pre_defined = 0;
       unsigned int(16) width;
       unsigned int(16) height;
       template unsigned int(32) horizresolution = 0x00480000; // 72 dpi
       template unsigned int(32) vertresolution = 0x00480000; // 72 dpi
       const unsigned int(32) reserved = 0;
       template unsigned int(16) frame_count = 1;
       string[32] compressorname;
       template unsigned int(16) depth = 0x0018;
       int(16) pre_defined = -1;
   }
   */

  function _mp4a(tree, boxPath) {
    var box = _findBoxByPath(tree, boxPath);
    var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);

    // SampleEntry
    _write4(view, 0); // reserved = 0 // const unsigned int(8)[6] reserved = 0;
    _write2(view, 0); // reserved = 0 // const unsigned int(8)[6] reserved = 0;
    _write2(view, box.data_reference_index); // unsigned int(16) data_reference_index;

    // AudioSampleEntry
    _write4(view, 0); // reserved[0] = 0 // const unsigned int(32)[2] reserved = 0;
    _write4(view, 0); // reserved[1] = 0 // const unsigned int(32)[2] reserved = 0;
    _write2(view, box.channelcount); // template unsigned int(16) channelcount = 2;
    _write2(view, box.samplesize); // template unsigned int(16) samplesize = 16;
    _write2(view, 0); // pre_defined = 0 // unsigned int(16) pre_defined = 0;
    _write2(view, 0); // reserved = 0 // const unsigned int(16) reserved = 0 ;
    // _write4(view, box.samplerate); // template unsigned int(32) samplerate = {timescale of media}<<16;
    _write4(view, (box.samplerate << 16)); // template unsigned int(32) samplerate = {timescale of media}<<16;

    return view;
  }

  function _esds(boxPath, aacPlus) {
    var view = _createBoxClassView(_getLastBoxType(boxPath), boxPath);

    return aacPlus ? _esdsAccHe(view) : _esdsAacLc(view);
  }

  function _esdsAccHe(view) {
    // The initial box is created in the _esds() method. This sets the box size
    // and type...we're going to overwrite the size here now since it was defaulted.
    // Set the size of the box.
    view.source[3] = 0x35; // works chrome
    // view.source[3] = 0x33; // DOES NOT work

    // Padding after box size and type.
    _write4(view, 0x00000000);

    ////////////////////////////////////////////////
    // ES_Descriptor
    // 03 (tag) 19 (tag size) 00 02 (track_id) 00 (flag)
    ////////////////////////////////////////////////

    // dataView.setUint32(4, 0x03808080); // ES_DescrTag, type = 3
    _write4(view, 0x03808080);

    // length(8) = 34, ES_ID(16) = 2, stream priority + flags byte = 0
    // dataView.setUint32(8, 0x22000200);
    //22 00 01 00
    _write4(view, 0x24000100); // works chrome
    // _write4(view, 0x22000100); // DOES NOT work

    ////////////////////////////////////////////////
    // DecoderConfigDescriptor
    ////////////////////////////////////////////////

    // 04 80 80 80

    // dataView.setUint32(12, 0x04808080); // ES_DescrTag, type = 4
    _write4(view, 0x04808080);

    // 16 40 15 00

    // length(8) = 20, objectTypeIndication(8) = MPEG4 Audio ISO/IEC 14496-3
    // streamType = 5 (Audio), upStream = 0, reserved = 0, bufferSize = 0
    _write4(view, 0x16401500); // works chrome
    // _write4(view, 0x14401500); // DOES NOT work

    // 00 00

    // 2 more bytes of bufferSize = 0
    _write2(view, 0x0000);

    // dataView.setUint32(22, track.maxBitrate);
    _write4(view, 0x00007DBB);

    // dataView.setUint32(26, track.avgBitrate);
    _write4(view, 0x00007DBB);

    ////////////////////////////////////////////////
    // DecoderSpecificInfo
    ////////////////////////////////////////////////

    // dataView.setUint32(30, 0x05808080); // DecSpecificInfoTag
    _write4(view, 0x05808080);

    // dataView.setUint8(34, 2); // length
    _write1(view, 0x04); // Works Chrome
    // _write1(view, 0x02);

    ////////////////////////////////////////////////
    // AudioSpecificInfo
    ////////////////////////////////////////////////

    /*
     Audio Specific Config:
     5 bits: object type
     4 bits: frequency index
     4 bits: channel configuration
     1 bit: frame length flag
     1 bit: dependsOnCoreCoder
     1 bit: extensionFlag
     */

    /*
     * Object Type Values
     * The first 5 (0-4) bits tell us about the coder used for aacaot/aottype
     * http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio
     0 - NULL
     1 - AAC Main (a deprecated AAC profile from MPEG-2)
     2 - AAC LC or backwards compatible HE-AAC
     3 - AAC Scalable Sample Rate
     4 - AAC LTP (a replacement for AAC Main, rarely used)
     5 - HE-AAC explicitly signaled (Non-backward compatible)
     23 - Low Delay AAC
     29 - HE-AACv2 explicitly signaled
     32 - MP3on4 Layer 1
     33 - MP3on4 Layer 2
     34 - MP3on4 Layer 3
     */

    // 00101 = 5 = HE-AAC, 5 bits: object type
    // 0100 = 4 = 44100 Hz, 4 bits: frequency index
    // 0010 = 2 = 2 channels, stereo Hz, 4 bits: channel configuration
    // 0 = 0 = 0: Each packet contains 1024 samples, 1 bit: frame length flag
    // 0 = 0 = 0, 1 bit: dependsOnCoreCoder
    // 0 = 0 = 0, 1 bit: extensionFlag

    // Possible Values:
    // 0001001000010000 = AAC-LC - object descriptor = 00010 = 2
    // 0001101000010000 = AAC-SSR (Scalable Sample Rate) - object descriptor = 00011 = 3
    // 0010101000010000 = HE-AAC - object descriptor = 00101 = 5
    // 1110101000010000 = HE-AACv2 - object descriptor = 11101 = 29

    // dataView.setUint16(35, (objectType << 11) | (freqIndex << 7) | (channelConf << 3));
    // _write4(view, 0xEB8A0800); // works chrome - copied directly from FFMPEG - HE-AACv2
    _write4(view, 0x2B920800); // works chrome - copied directly from FFMPEG - HE-AAC
    // _write2(view, 0x1210); // DOES NOT work - AAC-LC = 2
    // _write2(view, 0x1A10); // DOES NOT work - AAC-SSR = 3
    // _write2(view, 0xEB8A); // DOES NOT work - ??? looks like FFMPEG - HE-AACv2
    // _write2(view, 0x2A10); // DOES NOT work - HE-AAC = 5
    // _write4(view, 0x2A100800); // DOES NOT work - HE-AAC = 5 - Padding
    // _write2(view, 0xEA10); // DOES NOT work - HE-AACv2 = 29

    ////////////////////////////////////////////////
    // SLConfigDescriptor
    ////////////////////////////////////////////////

    // SLConfigDescriptorTag
    _write4(view, 0x06808080);

    // 01 02

    // dataView.setUint32(37, 0x06808080); //SLConfigDescrTag
    _write2(view, 0x0102);

    ////////////////////////////////////////////////
    // END
    ////////////////////////////////////////////////

    return view;
  }

  function _esdsAacLc(view) {
    view.source[3] = 0x33;

    // Padding after box type
    _write4(view, 0x00000000);

    ////////////////////////////////////////////////
    // ES_Descriptor
    // 03 (tag) 19 (tag size) 00 02 (track_id) 00 (flag)
    ////////////////////////////////////////////////

    // dataView.setUint32(4, 0x03808080); // ES_DescrTag, type = 3
    _write4(view, 0x03808080);

    // length(8) = 34, ES_ID(16) = 2, stream priority + flags byte = 0
    // dataView.setUint32(8, 0x22000200);
    // _write4(view, 0x22000000);
    _write4(view, 0x22000100);

    ////////////////////////////////////////////////
    // DecoderConfigDescriptor
    ////////////////////////////////////////////////

    // dataView.setUint32(12, 0x04808080); // ES_DescrTag, type = 4
    _write4(view, 0x04808080);

    // length(8) = 20, objectTypeIndication(8) = MPEG4 Audio ISO/IEC 14496-3
    // streamType = 5 (Audio), upStream = 0, reserved = 0, bufferSize = 0
    // dataView.setUint32(16, 0x14401500);
    _write4(view, 0x14401500);

    // 02 09, 00 02 5F E8, 00 02 3B AE

    // 2 more bytes of bufferSize = 0
    // _write2(view, 0x0209);
    _write2(view, 0x0000);

    // dataView.setUint32(22, track.maxBitrate);
    // dataView.setUint32(22, 256000);
    _write4(view, 0x0001F400);

    // dataView.setUint32(26, track.avgBitrate);
    // dataView.setUint32(26, 32000);
    _write4(view, 0x0001F3E9);

    ////////////////////////////////////////////////
    // DecoderSpecificInfo
    ////////////////////////////////////////////////

    // dataView.setUint32(30, 0x05808080); // DecSpecificInfoTag
    _write4(view, 0x05808080);

    // 02, 12 10

    // dataView.setUint8(34, 2); // length
    _write1(view, 0x02);

    ////////////////////////////////////////////////
    // AudioSpecificInfo
    ////////////////////////////////////////////////

    /*
     Audio Specific Config:
     5 bits: object type
     4 bits: frequency index
     4 bits: channel configuration
     1 bit: frame length flag
     1 bit: dependsOnCoreCoder
     1 bit: extensionFlag
     */

    /*
     * Object Type Values
     * The first 5 (0-4) bits tell us about the coder used for aacaot/aottype
     * http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio
     0 - NULL
     1 - AAC Main (a deprecated AAC profile from MPEG-2)
     2 - AAC LC or backwards compatible HE-AAC
     3 - AAC Scalable Sample Rate
     4 - AAC LTP (a replacement for AAC Main, rarely used)
     5 - HE-AAC explicitly signaled (Non-backward compatible)
     23 - Low Delay AAC
     29 - HE-AACv2 explicitly signaled
     32 - MP3on4 Layer 1
     33 - MP3on4 Layer 2
     34 - MP3on4 Layer 3
     */

    // 0010101000010000
    // 00101 = 5 = HE-AAC, 5 bits: object type
    // 0100 = 4 = 44100 Hz, 4 bits: frequency index
    // 0010 = 2 = 2 channels, stereo Hz, 4 bits: channel configuration
    // 0 = 0 = 0: Each packet contains 1024 samples, 1 bit: frame length flag
    // 0 = 0 = 0, 1 bit: dependsOnCoreCoder
    // 0 = 0 = 0, 1 bit: extensionFlag

    // 1110101000010000 // 11101 = 29 = HE-AAC, 5 bits: object type

    // dataView.setUint16(35, (objectType << 11) | (freqIndex << 7) | (channelConf << 3));
    _write2(view, 0x1210);

    ////////////////////////////////////////////////
    // SLConfigDescriptor
    ////////////////////////////////////////////////

    // SLConfigDescriptorTag
    _write4(view, 0x06808080);

    // 01 02

    // dataView.setUint32(37, 0x06808080); //SLConfigDescrTag
    _write2(view, 0x0102);

    ////////////////////////////////////////////////
    // END
    ////////////////////////////////////////////////

    return view;
  }

  return Mp4Builder;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js":
/*!****************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/util/AudioUtil.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     AudioUtil
 * @CREATED:    12/30/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *   Audio utility functions
 */

/* beautify preserve:start */



/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {

  var AudioUtil = {};

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  AudioUtil.CONSTS = {
    NO_TRIM: -1,
    TRIM_FROM_START: 0,
    TRIM_FROM_END: 1,
    TRIM_CORE: 2,
    TRIM_FROM_START_AND_END: 3,
    MONO_NUMCHANNELS: 1,
    STEREO_NUMCHANNELS: 2,
    STEREO_LEFT_CHANNEL: 0,
    STEREO_RIGHT_CHANNEL: 1,
    SAMPLE_8BIT_NUMBYTES: 1,
    SAMPLE_16BIT_NUMBYTES: 2,
    SAMPLE_24BIT_NUMBYTES: 3,

    SAMPLERATES: {
      SAMPLERATE_8Khz : 8000,
      SAMPLERATE_11Khz: 11025,
      SAMPLERATE_12Khz: 12000,
      SAMPLERATE_16Khz: 16000,
      SAMPLERATE_22Khz: 22050,
      SAMPLERATE_24Khz: 24000,
      SAMPLERATE_32KHZ: 32000,
      SAMPLERATE_44KHZ: 44100,
      SAMPLERATE_48KHZ: 48000,
      SAMPLERATE_64KHZ: 64000,
      SAMPLERATE_88KHZ: 88200,
      SAMPLERATE_96KHZ: 96000
    }
  };

  /**
   * Concatenates a list of ArrayBuffers.
   *
   * @param {Array} buffers - Is an array of ArrayBuffers to concatenate.
   * @param {Number} padding - Bytes that will be added to the end of the new buffer.
   * @returns {ArrayBuffer} New ArrayBuffer with first's data followed by second's data.
   */
  AudioUtil.concatArrayBuffers = function (buffers, padding) {
    var length = padding | 0;

    buffers.forEach(function (buffer) {
      if (buffer) {
        length += buffer.byteLength;
      }
    });

    var aBuf = new Uint8Array(length);

    var offset = 0;

    buffers.forEach(function (buffer) {
      if (buffer) {
        aBuf.set(new Uint8Array(buffer), offset);
        offset += buffer.byteLength;
      }
    });

    return aBuf.buffer;
  };

  /**
   * Concatenating Typed Arrays(any type).
   *
   * @param {resultConstructor} buffers - result type array to return.
   * @param {...arrays} buffers - Is an array of ArrayBuffers to concatenate.
   * @returns {resultConstructor} New resultConstructor with first's data followed by second's data.
   */

  AudioUtil.concatenate= function(ResultConstructor) {
    //IE11 doesn't support the ... spread operator or the object.values
    // so had to create buffers Array from the arguments old fashion way
    var argumentsKeys = Object.keys(arguments);
    var bufferArray =[];
    for(var i= 1; i< argumentsKeys.length;i++)
    {
      bufferArray.push(arguments[i]);
    }

    var totalLength = 0;
    for (var i = 0; i < bufferArray.length; i++) {
      totalLength += bufferArray[i].length;
    }
    var result = new ResultConstructor(totalLength);
    var offset = 0;
    for (var i = 0; i < bufferArray.length; i++) {
      result.set(bufferArray[i], offset);
      offset += bufferArray[i].length;
    }
    return result;
  };
  
  /**
   * XOR the given two buffer
   *
   * @param {buffer1 ArrayBuffer} buffer to xor'ed
   * @param {buffer2 ArrayBuffer} buffer to xor'ed
   * @param {arrayType} typeArray constructed to be buffered
   * @returns XOR'ed ArrayBuffer
   */
  AudioUtil.xorArrayBuffer = function (buffer1, buffer2, ResultConstructor) {
  
    ResultConstructor = ResultConstructor ? ResultConstructor : Uint8Array;
    buffer1 = new ResultConstructor(buffer1);
    buffer2 = new ResultConstructor(buffer2);

    var result = new ResultConstructor(buffer2.length);
    
    for (var i = 0; i < result.length; i++) {
      result[i] = buffer1[i] ^ buffer2[i];
    }
    
    return result;
  };
  /**
   * Trim audio from either the start or the end of an AudioBuffer
   *
   * @param {ArrayBuffer} buffer to trim
   * @param {Number} numSamples is number of samples to trim from buffer
   * @param {Number} type is TRIM_FROM_START if bytes should be trimmed at start of buffer or
   *           TRIM_FROM_END if bytes are to be trimmed from end of buffer
   * @returns Array of Float32Arrays with trimmed channel data (one element per channel)
   */
  AudioUtil.trimAudioBuffer = function (buffer, numSamples, type) {
    var numChannels = buffer.numberOfChannels;
    var trimmedAudio = [];
    var channelIndex;
    var channelData;
    var firstSample;
    var lastSample;

    switch (type) {

      case AudioUtil.CONSTS.NO_TRIM:
        firstSample = 0;
        lastSample = buffer.length;
        break;

      case AudioUtil.CONSTS.TRIM_FROM_START:
        firstSample = numSamples;
        lastSample = buffer.length;
        break;

      case AudioUtil.CONSTS.TRIM_CORE:
        firstSample = (buffer.length - numSamples) / 2;
        lastSample = (buffer.length + numSamples) / 2;
        break;

      case AudioUtil.CONSTS.TRIM_FROM_END:
        firstSample = 0;
        lastSample = buffer.length - numSamples;
        break;

      case AudioUtil.CONSTS.TRIM_FROM_START_AND_END:
        var secondChunkSize = buffer.length - (numSamples * 2);
        firstSample = numSamples;
        lastSample = buffer.length - (secondChunkSize / 2);
        break;

      default:
        throw new Error("AudioUtil.trimAudioBuffer bad trim type (" + type + ")");
    }

    if (lastSample <= 0) {
      throw new Error("AudioUtil.trimAudioBuffer bad index (" + numSamples + ")");
    }

    for (channelIndex = 0; channelIndex < numChannels; channelIndex++) {
      var channelAudio = buffer.getChannelData(channelIndex);
      channelData = channelAudio.subarray(firstSample, lastSample);
      trimmedAudio.push(channelData);
    }

    return {
      audio            : trimmedAudio,
      trimmedFromStart : firstSample,
      trimmedFromEnd   : buffer.length - lastSample
    };
  };

  /**
   * Calculate the duration of audio based on the number of samples and the sample rate
   *
   * @param {Number} numSamples is the number of audio pcm samples for the calculation
   * @param {Number} sampleRate is the sample rate of the audio for the calculation
   * @returns {Number} playback duration of the number of samples in milliseconds
   */
  AudioUtil.calculateDurationInMs = function (numSamples, sampleRate) {
    return (numSamples * 1000) / sampleRate;
  };

  /**
   * Calculate the sample offset given a millisecond offset and the sample rate involved.
   *
   * @param {Number} msOffset is the offset of the desired sample in milliseconds
   * @param {Number} sampleRate is the sample rate of the audio for the calculation
   * @returns {Number} sample offset rounded to the nearest integer
   */
  AudioUtil.calculateSampleOffset = function (msOffset, sampleRate) {
    return Math.round((msOffset * sampleRate) / 1000);
  };

  /**
   * Calculate the duration of audio based on the number of samples and the sample rate
   *
   * @param {Number} timestamp is the unix epoch based timestamp to adjust
   * @param {Number} duration is used to determine the maximum precision for timestamp
   * @returns {Number} a new timestamp that has been adjusted to the prevision level
   */
  AudioUtil.adjustTimestampPrecision = function (timestamp, duration) {
    var precision = 0;

    do {
      if ((duration % 10) !== 0) {
        precision++;
      }
    } while ((duration /= 10) >= 1);

    precision *= 10;

    return (Math.floor(timestamp * precision) / precision);
  };

  /**
   * Calculate a new timestamp based on timestamp and duration.  This function takes care to perform
   * the calculation so that the double precision math does not introduce any unwanted digits to the
   * right of the decimal place.
   *
   * @param {Number} timestamp is the unix epoch based timestamp to adjust
   * @param {Number} offset is the affset in milliseconds to add to timestamp
   * @returns {Number} a new timestamp that has been calculated with the correct amount of precision
   */
  AudioUtil.calculateNewTimestamp = function (timestamp, offset) {
    var precision = 0;
    var originalOffset = offset;

    do {
      if ((offset % 10) !== 0) {
        precision++;
      }
    } while ((offset /= 10) >= 1);

    precision = (precision === 0) ? 1 : precision * 10;

    return Math.floor((timestamp + originalOffset) * precision) / precision;
  };

  return AudioUtil;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/util/BitUtil.js":
/*!**************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/util/BitUtil.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/31/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Static utility functions for dealing with bits and bytes.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {

  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("BitUtil");

  /**
   * The consrtuctor function is simply defined as a reference to create "static" methods.
   *
   * @constructor
   */
  var BitUtil = function () {
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------

  /* beautify preserve:start */
  /**
   * Bit shift number by a specified amount of bits
   * @param {Number} number to shift bits, will be converted to an unsigned integer if it not already one
   * @param {Number} shiftBy is the number of bits to shift by, negative is right shift, positive is left shift
   * @returns number that has been shifted by specified amount
   */
  BitUtil.shift = function (number, shiftBy) {
    shiftBy = ~~shiftBy;
    number = ~~number;

    if (shiftBy === 0) {
      return number;
    }

    return (shiftBy < 0) ? (number) >> Math.abs(shiftBy) : (number) << Math.abs(shiftBy);
  };

  /**
   * grab a 16 bit unsigned number from an array at a specified index, optionally mask and shift
   * @param {Uint8Array} bytes to grab the 16 bit number from
   * @param {Number} i byte index to start grabbing from
   * @param {Number} shiftBy (optional) bit shift to be applied, negative is right shift, positive is left shift
   * @param {Number} mask (optional) 16 bit mask to mask the 16 bit number by when it has been retrieved
   *
   * @returns {Number} after array retrieval and (optional) shifting and masking
   */
  BitUtil.grabUint16 = function (bytes, i, shiftBy, mask) {
    mask = mask | 0xffffff;
    shiftBy = shiftBy | 0;

    var result = (((bytes[i++] & ~~0x7F) << 16) | ((bytes[i++] & ~~0xFF) << 8) | bytes[i]);

    return BitUtil.shift(result, shiftBy) & mask;
  };

  /**
   * grab a 24 bit unsigned number from an array at a specified index, optionally mask and shift
   * @param {Uint8Array} bytes to grab the 24 bit number from
   * @param {Number} i byte index to start grabbing from
   * @param {Number} shiftBy (optional) bit shift to be applied, negative is right shift, positive is left shift
   * @param {Number} mask (optional) 24 bit mask to mask the 24 bit number by when it has been retrieved
   *
   * @returns {Number} after array retrieval and (optional) shifting and masking
   */
  BitUtil.grabUint24 = function (bytes, i, shiftBy, mask) {
    mask = mask | 0xffffff;
    shiftBy = shiftBy | 0;

    var result = (((bytes[i++] & ~~0x7F) << 16) | ((bytes[i++] & ~~0xFF) << 8) | bytes[i]);

    return BitUtil.shift(result, shiftBy) & mask;
  };

  /**
   * grab a 32 bit unsigned number from an array at a specified index, optionally mask and shift
   * @param {Uint8Array} bytes to grab the 32 bit number from
   * @param {Number} i byte index to start grabbing from
   * @param {Number} shiftBy (optional) bit shift to be applied, negative is right shift, positive is left shift
   * @param {Number} mask (optional) 32 bit mask to mask the 32 bit number by when it has been retrieved
   *
   * @returns {Number}  after array retrieval and (optional) shifting and masking
   */
  BitUtil.grabUint32 = function (bytes, i, shiftBy, mask) {
    mask = mask | 0xffffffff;
    shiftBy = shiftBy | 0;

    var result = ((bytes[i++] << 24) | (bytes[i++] << 16) | (bytes[i++] << 8) | bytes[i]);

    return BitUtil.shift(result, shiftBy) & mask;
  };

  /**
   * grab a 28 bit syncsafe unsigned number from an array at a specified index, optionally mask and shift
   * @param {Uint8Array} bytes to grab the 32 bit number from
   * @param {Number} i byte index to start grabbing from
   * @param {Number} shiftBy (optional) bit shift to be applied, negative is right shift, positive is left shift
   * @param {Number} mask (optional) 32 bit mask to mask the 32 bit number by when it has been retrieved
   *
   * @returns {Number}  after array retrieval and (optional) shifting and masking
   */
  BitUtil.grabSyncSafeUint28 = function (bytes, i, shiftBy, mask) {
    mask = (typeof (mask) !== 'undefined') ? mask : 0xffffffff;
    shiftBy = shiftBy | 0;

    var result = ((bytes[i++] & 0x7F) << 21) | ((bytes[i++] & 0x7F) << 14) | ((bytes[i++] & 0x7F) << 7) | (bytes[i] &
      0x7F);

    return BitUtil.shift(result, shiftBy) & mask;
  };

  /**
   * Takes a ArrayBuffer or byte array and saves it to a file through the browser. This method
   * is currently used in development only to inspect MP4 files.
   *
   * NOTE: This really only works in Chrome at the moment.
   *
   * @param {ArrayBuffer} data - The raw data.
   * @param {String} name - The name of the file to create.
   */
  BitUtil.saveByteArrayToFile = (function () {

    var a = document.createElement("a");
    document.body.appendChild(a);

    // This blows up in Safari so we'll simply catch it as this method is a debugging tool.
    try {
      a.style = "display: none";
    }
    catch (error) {
      logger.warn("The current browser doesn't support file downloading.");
    }

    return function (data, name) {
      try {
        var blob = new Blob(data, {type: "octet/stream"}),
          url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = name;
        a.click();
        setTimeout(function () {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
      }
      catch (error) {
        logger.error("Exception saving byte array to file {0}", [error.toString()]);

      }
    };
  }());

  BitUtil.byteToHexString = function (uint8arr, grouping) {
    if (!uint8arr) {
      return "";
    }

    grouping = grouping || -1;
    var hexStr = "";
    for (var i = 0; i < uint8arr.length; i++) {
      var hex = (uint8arr[i] & 0xff).toString(16);
      hex = (hex.length === 1) ? '0' + hex : hex;
      hexStr += ((grouping > -1) && (hexStr.length > 0) && (hexStr.length % grouping === 0)) ? " " + hex : hex;
      // hexStr += hex;
    }

    return hexStr.toUpperCase();
  };

  BitUtil.hexStringToByte = function (str) {
    if (!str) {
      return new Uint8Array();
    }

    var a = [];
    for (var i = 0, len = str.length; i < len; i += 2) {
      a.push(parseInt(str.substr(i, 2), 16));
    }

    return new Uint8Array(a);
  };

  BitUtil.convertBase = (function () {

    function convertBase(baseFrom, baseTo) {
      return function (num) {
        return parseInt(num, baseFrom).toString(baseTo);

      };
    }

    // binary to decimal
    convertBase.bin2dec = convertBase(2, 10);

    // binary to hexadecimal
    convertBase.bin2hex = convertBase(2, 16);

    // decimal to binary
    convertBase.dec2bin = convertBase(10, 2);

    // decimal to hexadecimal
    convertBase.dec2hex = convertBase(10, 16);

    // hexadecimal to binary
    convertBase.hex2bin = convertBase(16, 2);

    // hexadecimal to decimal
    convertBase.hex2dec = convertBase(16, 10);

    return convertBase;
  }());
  
  /**
   * Grabs a hex number and send back the hexa string
   * @param {hex} number
   *
   * @returns {String}  hexa string
   */
  BitUtil.hex2String = function(hex)
  {
    var str = '';
    hex = hex.toString();
    for (var i = 0; i < hex.length; i += 2)
    {
      str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    }
    return str;
  };

  BitUtil.getUint32Synch = function (view, offset) {
    offset = offset || 0;
    return BitUtil.getSynch(view.getUint32(offset));
  };

  /**
   * Gets the "synch" representation of a number
   * @param {number} num Number to convert
   * @return {number}
   */
  BitUtil.getSynch = function(num) {
    var out = 0;
    var mask = 0x7f000000;
    while (mask) {
      out >>= 1;
      out |= num & mask;
      mask >>= 8;
    }
    return out;
  };

  BitUtil.getString = function(view, length, offset, raw) {
    offset = offset || 0;
    var len = length || view.byteLength - offset;
    if (len < 0) {
      len += view.byteLength;
    }
    var data = [];
    var limit = offset + len;
    for (var i = offset; i < limit; i++) {
      var current = view.getUint8(i);
      if (current === 0) {
        break;
      }
      data.push(current);
    }
    var str = data.map(function (chr) {
      return String.fromCharCode(chr);
    }).join('');
    if (raw) {
      return str;
    }
    return decodeURIComponent(escape(str));
  };
  return BitUtil;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/util/BrowserUtil.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/util/BrowserUtil.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    12/17/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Provides helper methods to determine browser types and versions.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  var CHROME = "chrome";
  var FIREFOX = "firefox";
  //var SAFARI = "safari";
  var EDGE = "edge";

  ////////////////////////////////////////////////////////////////////////////////////////
  // TODO: BMR: Consider changing the conditional checks to the following:
  // FROM: http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
  ////////////////////////////////////////////////////////////////////////////////////////

  // // Opera 8.0+
  // var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  //
  // // Firefox 1.0+
  // var isFirefox = typeof InstallTrigger !== 'undefined';
  //
  // // Safari 3.0+ "[object HTMLElementConstructor]"
  // var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || (function (p)
  // {
  // 	return p.toString() === "[object SafariRemoteNotification]";
  // })(!window['safari'] || safari.pushNotification);
  //
  // // Internet Explorer 6-11
  // var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  //
  // // Edge 20+
  // var isEdge = !isIE && !!window.StyleMedia;
  //
  // // Chrome 1+
  // var isChrome = !!window.chrome && !!window.chrome.webstore;
  //
  // // Blink engine detection
  // var isBlink = (isChrome || isOpera) && !!window.CSS;

  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function(predicate) {
        // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return kValue.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return undefined.
        return undefined;
      }
    });
  }

  // IE11 doesn't support the Array.findIndex
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex#Polyfill
  if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
      value: function(predicate) {
        // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return k.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return k;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return -1.
        return -1;
      },
      configurable: true,
      writable: true
    });
  }

  // IE11 doesn't support the Object.assign
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      // eslint-disable-next-line no-unused-vars
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // IE11 doesn't support the TypedArray slice
  //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/TypedArray/slice#Polyfill
  if (!Uint8Array.prototype.slice) {
    Object.defineProperty(Uint8Array.prototype, 'slice', {
      value: function (begin, end)
      {
        return new Uint8Array(Array.prototype.slice.call(this, begin, end));
      }
    });
  }
  ////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Determines if the current browser is Chrome.
   * @returns {Boolean}
   */
  var isChrome = function () {
    return isBrowser(CHROME) && !isBrowser(EDGE);
  };

  /**
   * Determines if the current browser is Safari.
   * @returns {Boolean}
   */
  var isSafari = function () {
    // NOTE: Too rudimentary as Chrome also has the word "safari" in it.
    // return isBrowser(SAFARI);

    // Taken from: http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
    // eslint-disable-next-line dot-notation
    var hasRemoteNotificationParams = !window['safari'] || window['safari'].pushNotification;
    var hasRemoteNotification = function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    };
    var hasConstructor = function () {
      return Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
    };

    return hasConstructor() || hasRemoteNotification(hasRemoteNotificationParams);
  };

  /**
   * Determines if the current browser is Firefox.
   * @returns {Boolean}
   */
  var isFirefox = function () {
    return isBrowser(FIREFOX);
  };

  /**
   * Determines if the current browser is Edge, and (optionally) is greater than the specified version number.
   *
   * @param {Number} [version] is the minimum Edge version number to check for
   *
   * @returns {Boolean}
   */
  var isEdge = function (version) {
    var isEdge = isBrowser(EDGE);
    var EDGE_APPVERSION = "Edge/";

    if (isEdge &&
      version &&
      navigator.appVersion &&
      navigator.appVersion.indexOf(EDGE_APPVERSION) >= 0) {
      var edgeRev = parseFloat(navigator.appVersion.substring(navigator.appVersion.indexOf(EDGE_APPVERSION) +
        EDGE_APPVERSION.length), 10);

      isEdge = (edgeRev >= version);
    }

    return isEdge;
  };

  /**
   * Determines if the current browser is the one passed in by the `name` param.
   * @returns {Boolean}
   */
  var isBrowser = function (name) {
    return getBrowser().toLowerCase().indexOf(name) > -1;
  };

  /**
   * Returns the string name of the browser using the `navigator.userAgent` global property.
   * @returns {String}
   */
  var getBrowser = function () {
    return navigator.userAgent.toLowerCase();
  };

  var BrowserUtil = {
    getBrowser: getBrowser,
    isChrome: isChrome,
    isFirefox: isFirefox,
    isSafari: isSafari,
    isEdge: isEdge
  };

  return BrowserUtil;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js":
/*!***********************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/util/PlaybackTypeUtil.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    12/17/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Indicates the playback type for a given player instance.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    /**
     * String indicating a playback type of Live. This matches the string used in the web client.
     */
    var LIVE = "playbackType.liveChannel";

    /**
     * String indicating a playback type of AOD. This matches the string used in the web client.
     */
    var AOD = "playbackType.aodEpisode";

    /**
     * String indicating a playback type of MySXM. This matches the string used in the web client.
     */
    var MY = "playbackType.myChannel";

    /**
     * String indicating a playback type of Seeded. This matches the string used in the web client.
     */
    var SEEDED = "playbackType.seededAudio";

    /**
     * String indicating a playback type of Seeded. This matches the string used in the web client.
     */
    var MP4 = "playbackType.MP4";

    /**
     * String indicating a playback type of Seeded. This matches the string used in the web client.
     */
    var MP3 = "playbackType.MP3";

    /**
     * Simple method that indicates if a player is using the `Live` playback type.
     *
     * @param {Playback} player Playback instance.
     * @return {boolean} Flag indicating if playing Live.
     */
    var isPlayerLive = function (player) {
      return !!player && player.configuration.playbackType === LIVE;
    };

    /**
     * Simple method that indicates if a player is using the `AOD` playback type.
     *
     * @param {Playback} player Playback instance.
     * @return {boolean} Flag indicating if playing AOD.
     */
    var isPlayerAOD = function (player) {
      return !!player && player.configuration.playbackType === AOD;
    };

    /**
     * Simple method that indicates if a player is using the `MySXM` playback type.
     *
     * @param {Playback} player Playback instance.
     * @return {boolean} Flag indicating if playing MySXM.
     */
    var isPlayerMySXM = function (player) {
      return !!player && player.configuration.playbackType === MY;
    };

    /**
     * Simple method that indicates if a player is using the `MP4 or Seeded Audio` playback type.
     *
     * @param {Playback} player Playback instance.
     * @return {boolean} Flag indicating if playing Seeded
     */
    var isPlayerMP4 = function (player) {
      return !!player && (player.configuration.playbackType === SEEDED
                        || player.configuration.playbackType === MP4);
    };

    /**
     * Simple method that indicates if a player is using the `MP3` playback type.
     *
     * @param {Playback} player Playback instance.
     * @return {boolean} Flag indicating if playing Seeded
     */
    var isPlayerMP3 = function (player) {
        return (!!player && player.configuration.playbackType === MP3);
    };

    /**
     * Simple method that indicates if a player is using a track (file based) media playback type.  This will either
     * be MP3, MP3 or "seeded" playback
     *
     * @param {Playback} player Playback instance.

     * @return {boolean} Flag indicating if playing track based content
     */
    var isPlayerTrackBased = function(player) {
        return isPlayerMP4(player) || isPlayerMP3(player);
    };

    var PlaybackTypeUtil = {
      LIVE: LIVE,
      AOD: AOD,
      MY: MY,
      SEEDED: SEEDED,
      MP4 : MP4,
      MP3 : MP3,
      isPlayerLive: isPlayerLive,
      isPlayerAOD: isPlayerAOD,
      isPlayerMySXM: isPlayerMySXM,
      isPlayerMP4: isPlayerMP4,
      isPlayerMP3: isPlayerMP3,
      isPlayerTrackBased : isPlayerTrackBased
    };

    return PlaybackTypeUtil;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));




/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/util/PlaylistUtil.js":
/*!*******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/util/PlaylistUtil.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/03/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * ßCollection of Playlist utils.
 */



!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");

  /**
   * Number of milliseconds in a 1 day.
   */
  var DAY = 1000 * 60 * 60 * 24;

  /**ß
   * Number of milliseconds between now and the time from epoch.
   */
  var TIME_FROM_EPOCH = new Date("1970-01-01T00:00:00Z").getTime();

  /**
   * The regex pattern for finding date timestamps for Live & AOD programs in the playlist.
   * LIVE & AOD Programs >>
   *
   *      #EXT-X-PROGRAM-DATE-TIME:2014-03-24T12:28:57.082+00:00
   *      #EXT-X-PROGRAM-DATE-TIME:2015-08-26T15:53:11.523+00:00
   */
  var PATTERN_PROGRAM_TIME = new RegExp(
    // ORIG -- the escaping threw off JSHint so we removed them
    //"#EXT-X-PROGRAM-DATE-TIME:([0-9]+)-([0-9]+)-([0-9]+)+T([\-0-9:]+)+\.([\-0-9]+)+[\+|\-]+([\-0-9]+)+:([\-0-9]+)+"

    // NEW with removed escaping \
    "#EXT-X-PROGRAM-DATE-TIME:([0-9]+)-([0-9]+)-([0-9]+)+T([-0-9:]+)+.([-0-9]+)+[+|-]+([-0-9]+)+:([-0-9]+)+"
  );

  /**
   * The regex pattern for finding date timestamps for Live & AOD chunks in the playlist.
   * Chunk timestamps for Live & AOD >>
   *
   *      2014-03-24T12:28:57.082+00:00
   */
  var PATTERN_CHUNK_TIME = new RegExp(
    // ORIG -- the escaping threw off JSHint so we removed them
    //"([0-9]+)-([0-9]+)-([0-9]+)+T([\-0-9:]+)+\.([\-0-9]+)+[\+|\-]+([\-0-9]+)+:([\-0-9]+)+"

    // NEW with removed escaping \
    "([0-9]+)-([0-9]+)-([0-9]+)+T([-0-9:]+)+.([-0-9]+)+[+|-]+([-0-9]+)+:([-0-9]+)+"
  );

  /**
   * The regex pattern for finding date timestamps for Live & AOD audio first in the playlist.
   * Audio First chunk timestamps for Live & AOD; notice the removal of the : in the last part >>
   *
   *      2014-03-24T12:28:57.082+0000
   */
  var PATTERN_CHUNK_TIME2 = new RegExp(
    // ORIG -- the escaping threw off JSHint so we removed them
    //"([0-9]+)-([0-9]+)-([0-9]+)+T([\-0-9:]+)+\.([\-0-9]+)+[\+|\-]+([\-0-9]+)+"

    // NEW with removed escaping \
    "([0-9]+)-([0-9]+)-([0-9]+)+T([-0-9:]+)+.([-0-9]+)+[+|-]+([-0-9]+)+"
  );

  ///**
  // * Transforms the incoming `startTime` to a time from epoch value in milliseconds.
  // *
  // * @param startTime The time for the seek to start audio playback. Can be specified as time from epoch in
  // * milliseconds, Date object, or even a Date timestamp string like `Wed Apr 12 15:30:17 GMT-0700 2006`.
  // */
  //var toStartAt = function (startTime: * ): *
  //{
  //	if(!startTime || (startTime === ""))
  //	{
  //		startTime = 0;
  //	}
  //
  //	var result: * = Number(startTime);
  //
  //	if(!isNaN(result))
  //	{
  //		if(result < 0)
  //		{
  //			result = NaN;
  //		} // Positive offsets from baseline required for AOD/MySXM
  //		else if(result === 0)
  //		{
  //			result = NaN;
  //		} // start playback without seek overrides
  //		else if(result > DAY)
  //		{
  //			// Date instance with absolute zulu msecs; for LIVE
  //
  //			result = new Date();
  //			result.time = Number(startTime);
  //		}
  //	}
  //	else if(startTime is String)
  //	{
  //		try
  //		{
  //			// Since not a number, we must assume string value is formatted for GMT epoch time.
  //			// e.g. Wed Apr 12 15:30:17 GMT-0700 2006
  //			result = new Date(startTime);
  //		}
  //		catch(e: Error)
  //		{
  //			result = null;
  //		}
  //	}
  //	else if(startTime is Date)
  //	{
  //		result = startTime;
  //	}
  //
  //	// If not start time... then always specify 1 msec value
  //	// which will find drive logic to find the first chunk (AOD/MySXM)...
  //
  //	return isNaN(result) ? null : result;
  //}

  /**
   * Convert SXM formatted-UTC dates to Flash formatted date strings/date instances; e.g.:
   *
   *     SXM - 2013-10-29T01:21:23.136+00:00
   *     JS - 2013/10/29 01:21:23 GMT-0000
   *
   * @param {String} item - The value to attempt to convert to a Date object.
   * @return {Date|String} Either a Date object created by the input string or the originla string.
   */
  var convertToDates = function (item) {
    var time = 0;
    var date = new Date();
    var it = StringUtil.trim(String(item));
    var parts = PATTERN_PROGRAM_TIME.exec(it) || PATTERN_CHUNK_TIME.exec(it) || PATTERN_CHUNK_TIME2.exec(it);

    if (parts !== null) {
      parts[1] = parts[1].replace("-", "/");

      it = StringUtil.supplant("{1}/{2}/{3} {4} UTC-{6}{7}", parts);

      // in the case of audio first timestamps there is only 7 parts so it's possible the last one = "undefined"
      it = it.replace("undefined", "");

      time = Date.parse(it) + Number(parts[5]);
      date = new Date(time);
    }

    if (!date) {
      //date = DateUtil.parseW3CDTF(it);
      throw new Error("Can't parse {0}", [item]);
    }

    return parts ? date : item;
  };

  /**
   * Determines if 2 playlists are the same or different. This is especially useful when trying to determine
   * if a playlist s stale -- is the new one retrieved from the server different from the current one the client
   * has cached?
   *
   * @param {Playlist} playlist1 - Playlist one.
   * @param {Playlist} playlist2 - Playlist two.
   * @return {Boolean} Indicates if the two playlists are different.
   */
  var arePlaylistsIdentical = function (playlist1, playlist2) {
    return playlist1.lastChunk === playlist2.lastChunk;
  };

  /**
   * Determines if a playlist is valid. In simplest sense, this checks to make sure chunk URLs are in the playlist.
   *
   * @param {Playlist} playlist - Playlist to check for validity.
   * @return {Boolean} Indicates if a playlist is valid.
   */
  var isValid = function (playlist) {
    return playlist.totalChunks > 0;
  };

  var PlaylistUtil = {
    isValid: isValid,
    arePlaylistsIdentical: arePlaylistsIdentical,
    convertToDates: convertToDates,
    DAY: DAY,
    TIME_FROM_EPOCH: TIME_FROM_EPOCH
  };

  return PlaylistUtil;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/util/Timer.js":
/*!************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/util/Timer.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Accurate Javascript setInterval replacement.
 *
 *      This code snippet can be used when a very accurate setInterval is needed. It will always be
 *      accurate ( 1+-ms in variance, but the mean will be the exact interval). Of course the function provided
 *      must run faster than the interval parameter. If for some reason the function takes more time than the
 *      interval in some occasions, the timer will still converge to the exact intervals very fast.
 *
 *      NOTE: Taken from gist: https://gist.github.com/manast/1185904
 *
 *      Example of use:
 *
 *      @example
 *      var timer = new interval(50, function(){
 *          console.log(new Date().getTime());
 *      })
 *
 *      timer.start();
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var ClassUtil = __webpack_require__(/*! sxm/util/ClassUtil */ "./javascript/src/sxm/util/ClassUtil.js");
  var TimerWorker = __webpack_require__(/*! sxm/audioplayer/html5/util/TimerWorker */ "./javascript/src/sxm/audioplayer/html5/util/TimerWorker.js");
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the Timer function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   */
  var Timer = function (interval, callback) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof Timer)) {
      throw new TypeError("Timer constructor cannot be called as a function.");
    }

    // Bind the scope of "this" to all first class functions
    ClassUtil.bindFunctions(this);

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    /**
     * The internal timer.
     * @private
     * @type {Object}
     */
    this._internalTimer = null;

    /**
     * The interval for the timer in milliseconds.
     * @type {number}
     */
    this.interval = interval;

    /**
     * The callback function when the timer goes off at each interval.
     * @type {number}
     */
    this.callback = callback;

    /**
     * The baseline number of milliseconds.
     * @type {number}
     */
    this.baseline = undefined;

    /**
     * Read-only accessor indicating if the Timer is stopped.
     * @type {Boolean}
     */
    Object.defineProperty(this, "isStopped",
      {
        get: function () {
          return (this._internalTimer === null);
        }
      });
  };

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our Timer class, we could write:
   *
   *  `BankManager.prototype = Timer.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  Timer.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: Timer,

    /**
     * Starts the timer and continues to call the `callback()` method until it's `stop()` is called.
     *
     * @param {Boolean} [invokeCallback=true] - Optional, flag indicating if the callback should be executed.
     * The default is true as this methods previously executed the callback immediately no matter what. However,
     * we want to provide objects the ability to not execute the callback until the first tick fires and then
     * thereafter.
     */
    start: function (invokeCallback) {
      invokeCallback = ObjectUtil.isBoolean(invokeCallback) ? invokeCallback : true;

      if (this.baseline === undefined) {
        this.baseline = Date.now();
      }

      try {
        if (invokeCallback) {
          this.callback();
        }
      }
      catch (error) {
        throw error;
      }

      var end = Date.now();
      this.baseline += this.interval;

      var nextTick = this.interval - (end - this.baseline);
      if (nextTick < 0) {
        nextTick = 0;
      }
      (function (i) {
        // The use of Function.call() is required for native JS timer methods, as they
        // are required by browsers to run from the global window's context. If we don't
        // do this then some browsers like Chrome will throw an error.
        i._internalTimer = TimerWorker.setTimeout.call(window, function () {
          //logger.debug("start()");
          i.start(true);
        }, nextTick);
      }(this));
    },

    /**
     * Stops the timer.
     */
    stop: function () {
      if (this._internalTimer) {
        //logger.debug("stop()");
        // The use of Function.call() is required for native JS timer methods, as they
        // are required by browsers to run from the global window's context. If we don't
        // do this then some browsers like Chrome will throw an error.
        TimerWorker.clearTimeout.call(window, this._internalTimer);
        this._internalTimer = null;
      }
    },

    /**
     * This provides a way to update the interval value for the next tick
     * 
     * In cases where we want the interval to be small ( ex: say 10 ms initially and later we want the interval to be 100ms)
     * @type {number} The interval for the timer in milliseconds
     */
    updateInterval: function (interval){
      this.interval = interval;
    },

    /**
     * Starts the timer and executes the `callback()` method once.
     */
    runOnce: function () {
      var _callback = function () {
        try {
          this.callback();
        }
        catch (error) {
          throw error;
        }
        this.stop();
      }.bind(this);
      // The use of Function.call() is required for native JS timer methods, as they
      // are required by browsers to run from the global window's context. If we don't
      // do this then some browsers like Chrome will throw an error.
      this._internalTimer = TimerWorker.setTimeout.call(window, _callback, this.interval);
    }
  };

  return Timer;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/audioplayer/html5/util/TimerWorker.js":
/*!******************************************************************!*\
  !*** ./javascript/src/sxm/audioplayer/html5/util/TimerWorker.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/* jshint ignore:start */
/**
 * @MODULE:     web-audio-core
 * @CREATED:    12/14/16
 * @COPYRIGHT:  2016 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Worker that creates global, window vars that mimic the default timer methods in JS, but
 *      with the power of a web worker. This eliminates any timer throttling the browser might
 *      apply when it's a background task and/or decouples it from the main JS thread.
 */


/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var LoggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var BrowserUtil = __webpack_require__(/*! sxm/audioplayer/html5/util/BrowserUtil */ "./javascript/src/sxm/audioplayer/html5/util/BrowserUtil.js");

  /**
   * Internal reference to the logger.
   */
  var logger = LoggerFactory.getLogger("TimerWorker");

  /**
   * Creates a global window reference to the timer using the native JS
   * timer functions. These should be used when Workers aren't supported
   * or we've decided not to apply the Worker timers (due to say browser
   * whitelisting or some other criteria). It allows for the timers to
   * always default to the native functions.
   */
  var setTimerDefaults = function () {
    logger.warn("setTimerDefaults( Using default JS timer functions. )");
    window.sxmTimer = window.sxmTimer || {};
    window.sxmTimer.setInterval = window.setInterval;
    window.sxmTimer.clearInterval = window.clearInterval;
    window.sxmTimer.setTimeout = window.setTimeout;
    window.sxmTimer.clearTimeout = window.clearTimeout;
  };

  // Set the timer defaults to the native JS timer functions.
  setTimerDefaults();

  // For the time being we'll only apply timer workers to Safari.
  if (BrowserUtil.isSafari()) {
    logger.warn("setTimerDefaults( Polyfilling timer worker for Safari )");
    (function (workerScript) {
      // We'll leave this check in even though we're only supporting Safari at the moment.
      // Might be useful in the future.
      if (!/MSIE 10/i.test(navigator.userAgent)) {
        try {
          var blob = new Blob([
            "\
    var fakeIdToId = {};\
    onmessage = function (event) {\
      var data = event.data,\
        name = data.name,\
        fakeId = data.fakeId,\
        time;\
      if(data.hasOwnProperty('time')) {\
        time = data.time;\
      }\
      switch (name) {\
        case 'setInterval':\
          fakeIdToId[fakeId] = setInterval(function () {\
            postMessage({fakeId: fakeId});\
          }, time);\
          break;\
        case 'clearInterval':\
          if (fakeIdToId.hasOwnProperty (fakeId)) {\
            clearInterval(fakeIdToId[fakeId]);\
            delete fakeIdToId[fakeId];\
          }\
          break;\
        case 'setTimeout':\
          fakeIdToId[fakeId] = setTimeout(function () {\
            postMessage({fakeId: fakeId});\
            if (fakeIdToId.hasOwnProperty (fakeId)) {\
              delete fakeIdToId[fakeId];\
            }\
          }, time);\
          break;\
        case 'clearTimeout':\
          if (fakeIdToId.hasOwnProperty (fakeId)) {\
            clearTimeout(fakeIdToId[fakeId]);\
            delete fakeIdToId[fakeId];\
          }\
          break;\
      }\
    }\
    "
          ]);
          // Obtain a blob URL reference to our worker "file".
          workerScript = window.URL.createObjectURL(blob);
        }
        catch (error) {
          logger.error("Blob is not supported, use external script instead. Error = .", [error.message]);
          setTimerDefaults();
          return;
        }
      }
      var worker,
        fakeIdToCallback = {},
        lastFakeId = 0,
        maxFakeId = 0x7FFFFFFF; // 2 ^ 31 - 1, 31 bit, positive values of signed 32 bit integer
      if (typeof (Worker) !== "undefined") {
        var getFakeId = function () {
          do {
            if (lastFakeId === maxFakeId) {
              lastFakeId = 0;
            }
            else {
              lastFakeId++;
            }
          } while (fakeIdToCallback.hasOwnProperty(lastFakeId));
          return lastFakeId;
        };

        try {
          worker = new Worker(workerScript);
          window.sxmTimer.setInterval = function (callback, time /* , parameters */) {
            var fakeId = getFakeId();
            fakeIdToCallback[fakeId] = {
              callback: callback,
              parameters: Array.prototype.slice.call(arguments, 2)
            };
            worker.postMessage(
              {
                name: "setInterval",
                fakeId: fakeId,
                time: time
              });
            return fakeId;
          };
          window.sxmTimer.clearInterval = function (fakeId) {
            if (fakeIdToCallback.hasOwnProperty(fakeId)) {
              delete fakeIdToCallback[fakeId];
              worker.postMessage(
                {
                  name: "clearInterval",
                  fakeId: fakeId
                });
            }
          };
          window.sxmTimer.setTimeout = function (callback, time /* , parameters */) {
            var fakeId = getFakeId();
            fakeIdToCallback[fakeId] = {
              callback: callback,
              parameters: Array.prototype.slice.call(arguments, 2),
              isTimeout: true
            };
            worker.postMessage(
              {
                name: "setTimeout",
                fakeId: fakeId,
                time: time
              });
            return fakeId;
          };
          window.sxmTimer.clearTimeout = function (fakeId) {
            if (fakeIdToCallback.hasOwnProperty(fakeId)) {
              delete fakeIdToCallback[fakeId];
              worker.postMessage(
                {
                  name: "clearTimeout",
                  fakeId: fakeId
                });
            }
          };
          worker.onmessage = function (event) {
            var data = event.data,
              fakeId = data.fakeId,
              request,
              parameters,
              callback;
            if (fakeIdToCallback.hasOwnProperty(fakeId)) {
              request = fakeIdToCallback[fakeId];
              callback = request.callback;
              parameters = request.parameters;
              if (request.hasOwnProperty("isTimeout") && request.isTimeout) {
                delete fakeIdToCallback[fakeId];
              }
            }
            if (typeof (callback) === "string") {
              try {
                callback = new Function(callback);
              }
              catch (error) {
                logger.warn("Error parsing callback code string: ", error);
              }
            }
            if (typeof (callback) === "function") {
              callback.apply(window, parameters);
            }
          };
          worker.onerror = function (event) {
            logger.warn(event);
          };
          logger.debug("Initialization succeeded");
        }
        catch (error) {
          logger.warn("Initialization failed. Error = .", [error.message]);
          setTimerDefaults();
        }
      }
      else {
        logger.warn("Initialization failed - HTML5 Web Worker is not supported");
        setTimerDefaults();
      }

      // TODO: BMR: We need to figure out how to handle the external Worker scripts scenario.
    })("HackTimerWorker.js");
  }

  return window.sxmTimer;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* jshint ignore:end */


/***/ }),

/***/ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js":
/*!***********************************************************!*\
  !*** ./javascript/src/sxm/logger/WebAudioPlayerLogger.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/21/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      The JavaScript logger for the web audio player. Outputs log statements to the JS console like:
 *
 *          [ParentContext] 13:36:22:069 [DEBUG] MyClass - methodName( some message. )
 *
 *      When called like:
 *
 *          logger.debug("setName( first = {0}, last = {1} )", [person.firstName, person.lastName]);
 *
 *      Performing token substitution with values from the second, array param. It can also be enabled
 *      at both a global and individual logger instance level.
 ]);
 */

/**
 * Register the module with RequireJS.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var StringUtil = __webpack_require__(/*! sxm/util/StringUtil */ "./javascript/src/sxm/util/StringUtil.js");

  /**
   * @private Internal method that determines if the console logging method is available -- if so, print to the console.
   *
   * @param {String} method - The request console logging method.
   * @param {String} msg - The message to log to the console.
   */
  var logToConsole = function (method, msg) {
    try {
      if (WebAudioPlayerLogger.logger[method]) {
        // eslint-disable-next-line no-console
        WebAudioPlayerLogger.logger[method](msg);
      }
    }
    catch (e) {
      // eslint-disable-next-line no-console
      console.error("Logging exception " + e.toString);
    }
  };
  //-----------------------------------------------------------------------
  // CONSTRUCTOR
  //-----------------------------------------------------------------------

  /**
   * This is our classes constructor; unlike AS3 this is where we define our member properties (fields).
   * To differentiate constructor functions from regular functions, by convention we start the function
   * name with a capital letter. This informs users that they must invoke the Stream function using
   * the `new` keyword and treat it as a constructor (ie: it returns a new instance of the Class).
   *
   * @constructor
   * @param {String} context - TODO
   * @param {String} parentContext - TODO
   */
  var WebAudioPlayerLogger = function (context, parentContext) {
    // This first guard ensures that the callee has invoked our Class' constructor function
    // with the `new` keyword - failure to do this will result in the `this` keyword referring
    // to the callee's scope (typically the window global) which will result in the following fields
    // (name and _age) leaking into the global namespace and not being set on this object.
    if (!(this instanceof WebAudioPlayerLogger)) {
      throw new TypeError("WebAudioPlayerLogger constructor cannot be called as a function.");
    }

    //-----------------------------------------------------------------------
    // CLASS MEMBERS
    //-----------------------------------------------------------------------

    var parentContext = ':[' + WebAudioPlayerLogger.DEFAULT_PARENT_CONTEXT + (parentContext ?  '-' + parentContext  : '') + ']: ';
    this.logContext = parentContext + context + '  ';

    this.isEnabled = true;
  };

  //-----------------------------------------------------------------------
  // STATIC MEMBERS
  //-----------------------------------------------------------------------


  /**
   * The default parent context in the logging statement.
   * @type {String}
   * @const
   */
  WebAudioPlayerLogger.DEFAULT_PARENT_CONTEXT = "AP";

  /**
   * Creates a logger that outputs the following format:
   *
   * 16:11:45:956 DEBUG [CafeTownsend.controller.AuthenticationController] - login: username = a, password = a
   *
   * @param {String} context - The string name used for the logger. This is often the class name of the object the
   * logger is used in.
   * @param {String} [parentContext="AP"] - The parentContext is typically JavaScript and looks like [JS] for
   * this logger instance; however, it can be specified to whatever a particular logger instance requires.
   * This can be handy when developers want to filter different parts of the application in the console
   * logger (in like Chrome Dev Tools).
   * @returns {WebAudioPlayerLogger} An instance of the WebAudioPlayerLogger logger.
   */
  WebAudioPlayerLogger.getLogger = function (context, parentContext) {
    return new WebAudioPlayerLogger(context, parentContext);
  };

  /**
   * Global flag for all logger instances indicating if logging is enabled.
   * @type {Boolean}
   * @const
   */
  Object.defineProperty(WebAudioPlayerLogger, "isEnabled", (function () {
    var _isEnabled = true;

    return {
      get: function () {
        return _isEnabled;
      },
      set: function (value) {
        _isEnabled = value;
      }
    };
  }()));

  Object.defineProperty(WebAudioPlayerLogger, "logger", (function () {
    var _logger = true;

    return {
      get: function () {
        return _logger || console;
      },
      set: function (value) {
        _logger = value;
      }
    };
  }()));

  //-----------------------------------------------------------------------
  // EXPOSED API
  //-----------------------------------------------------------------------

  /**
   * The prototype is a special type of Object which is used as a the blueprint for all instances
   * of a given Class; by defining functions and properties on the prototype we reduce memory
   * overhead.  We can also achieve inheritance by pointing one classes' prototype at another, for
   * example, if we introduced a BankManager class which extended our WebAudioPlayerLogger class, we could write:
   *
   *  `BankManager.prototype = WebAudioPlayerLogger.prototype`
   *  `BankManager.prototype.constructor = BankManager`
   *
   * However, due to the dynamic nature of JavaScript I am of the opinion that favouring composition
   * over inheritance will make your code easier to read and re-use.
   */
  WebAudioPlayerLogger.prototype = {

    /**
     * Whenever you replace an Object's Prototype, you need to repoint
     * the base Constructor back at the original constructor Function,
     * otherwise `instanceof` calls will fail.
     */
    constructor: WebAudioPlayerLogger,

    /**
     * Prints debug messages to the JS console.
     */
    debug: function () {
      this.internalLog('debug', arguments);
    },

    /**
     * Prints info messages to the JS console.
     */
    info: function () {
      this.internalLog('info', arguments);
    },

    /**
     * Prints warning messages to the JS console.
     */
    warn: function () {
      this.internalLog('warn', arguments);
    },

    /**
     * Prints error messages to the JS console.
     */
    error: function () {
      this.internalLog('error', arguments);
    },

    /**
     * Prints fatal messages to the JS console.
     */
    fatal: function () {
      this.internalLog('fatal', arguments);
    },

    /**
     * Determines the log level and logs to the console accordingly. Can take tokenized log messages and substitute
     * values passed into the logging method.
     * @private
     *
     * @param {string} method - The logging level.
     * @param {IArguments} args - An array of logging arguments. The first argument is typically the message and the following
     * can be used in log message token substitution.
     */
    internalLog: function (method, args){
      // do not log anything if logging is not enabled -- checks both the global "enabled" param as
      // well as the per instance "enabled" param for varying levels of granularity.
      if (!WebAudioPlayerLogger.isEnabled || !this.isEnabled) {
        return;
      }

      // get the console print friendly message
      var msg = args[0];

      // determine if the message has parametrized tokens...if so, replace them with values
      if (args && (args.length >= 2)) {
        var tokenValues = args[1];
        msg = StringUtil.supplant(args[0], tokenValues);
      }

      msg = (this.logContext || '') + msg;

      logToConsole(method, msg);
    }
  };

  return WebAudioPlayerLogger;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/swfloader/SWFLoader.js":
/*!***************************************************!*\
  !*** ./javascript/src/sxm/swfloader/SWFLoader.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @docType     module
 * @ngDoc       app
 * @name        sxm.swfloader:SWFLoader
 * @author      Brian Riley
 * @date        November 6, 2013
 * @copyright   2013 Sirius XM Radio Inc.
 * @description
 *
 *      SWFLoader will dynamically inject a Embed tag to load the specified SWF and then initialize a `bridge` to the
 *      SWF interfaces.
 *
 *      The following libraries must be preloaded:
 *
 *          - swfObject.js and
 *          - SWFService.js
 *
 */

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var loggerFactory = __webpack_require__(/*! sxm/logger/WebAudioPlayerLogger */ "./javascript/src/sxm/logger/WebAudioPlayerLogger.js");
  var URLUtils = __webpack_require__(/*! sxm/util/URLUtils */ "./javascript/src/sxm/util/URLUtils.js");
  var version = __webpack_require__(/*! sxm/util/version */ "./javascript/src/sxm/util/version.js");
  var swfobject = __webpack_require__(/*! swfobject */ "./javascript/vendor/swfobject/swfobject/swfobject.js");
  var SWFService = __webpack_require__(/*! SWFService */ "./javascript/vendor/SWFService/dist/client/SWFService.js");
  var Q = __webpack_require__(/*! q */ "q");
  
  /**
   * Reference to the logger.
   * @type {Logger|*}
   */
  var logger = loggerFactory.getLogger("SWFLoader");
  
  /**
   * Exports the SWFLoader to the global namespace -- may not need to do this any longer.
   * @type {exports|*}
   */
  var target = ( true && exports !== null) ? exports : window;
  
  /**
   * The service name for the chunk player.
   * @type {string}
   */
  var chunkPlayerServiceName = "SiriusXM.ChunkPlayerService";
  
  /**
   * Unique string name of the method to call when the swf is ready.
   * @type {string}
   */
  var swfReadyCallback = "onSwfReady_" + (new Date()).getTime();
  
  /**
   * Unique string name of the method to call when the swf is ready.
   * @type {string}
   */
  var flashContainerID = "flashContainer";
  
  /**
   * flag that gets set to indicate the flash player has started running
   * @type {boolean}
   */
  var flashIsRunning = false;
  
  /**
   * Creates the Embed tag to load and initialize the `headless audio player` SWF.
   *
   * @param swfId = SiriusXMHeadlessAudioPlayer  (prefix name of *.swf)
   * @param targetDiv =  #flash_div
   * @param path = path to the player (path + swfId + .swf is name of player binary)
   * @param loadCallback = callback function that emdedSWF will call when SWF has been injected into DOM
   */
  var createHeadlessPlayer = function (swfId, targetDiv, path, domLoadedCallback) {
    logger.debug("createHeadlessPlayer( {0}, {1}, {2} )", [swfId, targetDiv, path]);
    logger.debug("Core Player JS version is {0}.{1}", [version.getBranch(), version.getHash()]);
    
    var flashContainer = document.getElementById(targetDiv);
    if (!flashContainer) {
      //Changed to prepend to avoid scrolling in login page. WC-964
      var bodyElement = document.getElementsByTagName('body')[0];
      var targetElement = document.createElement('div');
      targetElement.setAttribute('id', targetDiv);
      bodyElement.insertBefore(targetElement, bodyElement.firstChild);
    }
    
    // there is a URL paramater that can be used to test the reload logic below.  This defaults to 0% percent chance
    // of failure, but can be overriden with a URL parameter "simulaterunfailure=[01].XX, where the run failure
    // percentage is between 0.0 and 1.0 and indicates the chance that the flash player will fail to run.  The
    // flash player will ONLY simluate failure if debugging (debug=true URL param) is ALSO turned on.  Note, the
    // flash player performs this last check internally, as well as the check being performed here.
    var randomPlayerFailurePercent = 0.0;
    
    var swfFile = swfId;
    
    //Only use the debug version of the flash file when default file was used
    if (swfId === 'web-audio-player' && (window.debugMode || URLUtils.getURLParam("debug"))) {
      var debug = URLUtils.getURLParam("debug");
      
      swfFile += '-debug';
      
      logger.info("Using debug version of core player " + swfFile + ".swf");
      
      if (window.debugMode || debug === "true") {
        if (URLUtils.getURLParam("simulaterunfailure")) {
          randomPlayerFailurePercent = URLUtils.getURLParam("simulaterunfailure");
        }
      }
    }
    else {
      logger.info("Using production version of core player " + swfFile + ".swf");
    }
    
    var flashvars = {
      audioPlayerServiceName: chunkPlayerServiceName,
      headlessPlayerReadyCallback: swfReadyCallback,
      randomPlayerFailure: randomPlayerFailurePercent
    };
    
    var params = {
      bgcolor: "#ffffff",
      wmode: "opaque",
      quality: "high",
      allowFullScreen: "false", // headless player does not need full screen access (since no GUI is provided)
      allowScriptAccess: "always", // allow ExternalInterface.call() access to scripts
      allowNetworking: "all" // allow JavaScript injection and browser DOM access
    };
    
    var attributes = {
      id: swfId,
      name: swfId,
      styleclass: "web-player"
    };
  
    var cacheBuster = "";
    //If the file given to us is not the default web-audio-player.swf, then we don't apply cacheBuster
    if(swfId === 'web-audio-player')
    {
      cacheBuster = "?v=";
      
      if (window.appVersion) {
        cacheBuster = window.appVersion;
      }
      else {
        cacheBuster += (new Date()).getTime();
      }
    }
    
    logger.debug("createHeadlessPlayer embed");
    
    swfobject.embedSWF(
      path + swfFile + ".swf" + cacheBuster,
      targetDiv,
      "1px", "1px",
      "11.1.0",
      path + "playerProductInstall.swf",
      flashvars, params, attributes, domLoadedCallback
    );
    swfobject.createCSS(targetDiv, "display:block;text-align:left;");
  };
  
  /**
   * Public API to load a specified SWF into a specific DOM element
   * @return Promise to be resolved when the SWF has loaded, initialized and is `ready`
   */
  function load(swfId, targetDiv, path) {
    var loadRetries = 0;
    var loadFailed = false;
    var MAX_LOAD_TRIES = 3;
  
    var dfd = Q.defer();
  
  
    logger.debug("load( {0}, {1}, {2} )", [swfId, targetDiv, path]);
  
    // Create temporary global callback; so swf can announce `ready`
    if (!window[swfReadyCallback]) {
      window[swfReadyCallback] = function () {
      
        logger.debug("SWFOnReadyCallback");
      
        if (loadFailed === false) {
          flashIsRunning = true;
        
          logger.debug("Getting flash object " + swfId + " " + chunkPlayerServiceName);
        
          if (!SWFService) {
            logger.error("No swf service detected");
          }
        
          try{
            var flashObject = SWFService.get(swfId, chunkPlayerServiceName);
          }
          catch (e) {
            logger.debug("Getting flash object Error", e);
          }
        
          logger.debug("Got flash object");
        
          // Gets the registered SWF services from the headless player SWF.
          dfd.resolve(flashObject);
        }
        else {
          dfd.resolve(null);
        }
      
        // Be sure to clean up...
        window[swfReadyCallback] = null;
        
      };
    }
  
    // Callback to check flash as it is loading and see if it eventually runs
    var callback = function (e) {
      if (!e.success || !e.ref) {
        logger.debug("createHeadlessPlayer embed FAILED)");
        return false;
      }
    
      logger.debug("createHeadlessPlayer load STARTED");
    
      var checkInterval = setInterval(function () {
        clearInterval(checkInterval);
      
        if (flashIsRunning === true) {
          logger.debug("headlessPlayer is LOADED and RUNNING");
        }
        else {
          if (loadRetries++ < MAX_LOAD_TRIES) {
            logger.error("headlessPlayer FAILED loading or running SWF, reload# " + loadRetries);
            swfobject.removeSWF(targetDiv);
            load(swfId, targetDiv, path);
          }
          else {
            loadFailed = true;
            logger.error("headlessPlayer FAILED loading or running SWF");
            window[swfReadyCallback]();
          }
        }
      }, 10000);
    };
  
    createHeadlessPlayer( swfId, targetDiv || flashContainerID, path, callback);
  
    return dfd.promise;
  }
  
  // Publish global SWFLoader construct with simple API
  target.SWFLoader = {
    load: load
  };
  
  return target.SWFLoader;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/util/ClassUtil.js":
/*!**********************************************!*\
  !*** ./javascript/src/sxm/util/ClassUtil.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/***********************************************************************************************************************
 * @MODULE:     ClassUtils
 * @CREATED:    12/22/2015
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Utility object with functions for O-O in Javscript
 **********************************************************************************************************************/
/* beautify preserve:start */


/*******************************************************************************************************************
 * Register the module with RequireJS.
 ******************************************************************************************************************/
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");
  var Q = __webpack_require__(/*! q */ "q");

  //----------------------------------------------------------------------------------------------------------
  // Private functions
  //----------------------------------------------------------------------------------------------------------

  /***********************************************************************************************************
   * This function will create a proxy prototype object for obj.  The proxy object will have a property
   * called "prototype" that will take all the (non inherited) properties from the prototype object that
   * is provided in the call to set and add those properties to the prototype for obj
   *
   * This function is intended for internal use in this codefile and should not be exported to outside
   * clients
   *
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
   *
   * @param {Object} obj is the object to create the proxy prototype for
   *********************************************************************************************************/
  function createProxyPrototype(obj) {
    var proxyPrototype = {};

    Object.defineProperty(proxyPrototype, "prototype",
      {
        set: function (childPrototype) {
          if (childPrototype && childPrototype !== null) {
            for (var property in childPrototype) {
              if (childPrototype.hasOwnProperty(property)) {
                if (childPrototype[property].propertyDescriptor &&
                  childPrototype[property].propertyDescriptor !== null) {
                  Object.defineProperty(obj.prototype,
                    property,
                    childPrototype[property].propertyDescriptor);
                }
                else {
                  obj.prototype[property] = childPrototype[property];
                }
              }
            }
          }
        }
      });

    return proxyPrototype;
  }

  //----------------------------------------------------------------------------------------------------------
  // Public functions
  //----------------------------------------------------------------------------------------------------------

  /***********************************************************************************************************
   * Bind all the necessary functions to the object prototype (with current this) and give the object a
   * super member for accessing methods (again with correct this) for the immediate parent class.
   *
   * @param {Object} self is the object instance being bound
   * @param {Object} type is the object type that is being bound
   **********************************************************************************************************/
  function bind(self, type) {
    if (!(self instanceof type)) // make sure constructor is called through new and not directly
    {
      throw new TypeError("Attempting to call a constructor as a function");
    }

    bindFunctions(self);
  }

  /***********************************************************************************************************
   * Bind all functions in object prototype to the self reference that is passed into the function
   *
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
   *
   * @param self object to bind functions for
   **********************************************************************************************************/
  function bindFunctions(self) {
    for (var property in self) {
      if (ObjectUtil.isFunction(self[property])) {
        self[property] = self[property].bind(self);
      }
    }
  }

  /*
   * Bind a property descriptor left on the object prototype to a getter/setter pair with a private
   * backing store set to the default value for the property.
   *
   * @param {Object} self object to create the property on
   * @param {String} is the property name
   * @param {Object} propertyTemplate is the template for the property that is being bound
   *   @param {true} propertyTemplate.propertyDescriptor is set to true indicating this is an instance property
   *   @param {Object} propertyTemplate.initialValue is the the initial value for the instance property
   *   @param {Boolean} propertyTemplate.readOnly is true if property can only be read, read/write otherwise
   *   @param {Object} propertyTemplate.observeDescriptor (optional) is used to give the property and observer
   *     @param {function} propertyTemplate.observeDescriptor.callbackFunc (see createInstancePropertyDescriptor)
   *     @param {Boolean} propertyTemplate.observeDescriptor.onChangeOnly (see createInstancePropertyDescriptor)
   */
  function bindInstanceProperty(self, propertyName, propertyTemplate) {
    Object.defineProperty(self, propertyName, (function () {
      var backingStore = propertyTemplate.initialValue;

      var descriptor = {
        enumerable: true,
        configurable: true,
        get: function () {
          return backingStore;
        }
      };

      if (propertyTemplate.readOnly === false) {
        descriptor.set = function (newValue) {
          backingStore = newValue;
        };
      }
      else if (propertyTemplate.readOnly !== true) {
        throw new Error("Bad propertyTemplate :" + propertyTemplate);
      }

      return descriptor;
    })());

    if (propertyTemplate.observeDescriptor) {
      if (propertyTemplate.observeDescriptor.callbackFunc && ObjectUtil.isFunction(
        propertyTemplate.observeDescriptor.callbackFunc)) {

        observeProperty(self,
          propertyName,
          propertyTemplate.observeDescriptor.callbackFunc,
          propertyTemplate.observeDescriptor.onChangeOnly);
      }
      else {
        throw new Error("Bad observeProperty member :" + propertyTemplate.observeDescriptor);
      }
    }
  }

  /***********************************************************************************************************
   * This function will cause child to become a "base class" with no parent class (child will still be an
   * "object" of course).
   *
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
   *
   * @param {Function} obj is the (constructor) object for the class
   *********************************************************************************************************/
  function baseClass(obj) {
    obj.parent = null;

    var proxyPrototype = createProxyPrototype(obj);

    obj.prototype.constructor = obj; // set the proper constructor

    return proxyPrototype;
  }

  /***********************************************************************************************************
   * This function will cause child to become a "subclass" of parent by setting the child's prototype to a new
   * object created from the parents prototype and then setting the child's constructor back to the child
   *
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
   *
   * @param {Function} child is the child object
   * @param {Function} parent is the parent object that the child will subclass
   *********************************************************************************************************/
  function subClass(child, parent) {
    child.parent = parent;

    if (parent && parent !== null) {
      child.prototype = Object.create(parent.prototype);
    }

    var proxyPrototype = createProxyPrototype(child);

    child.prototype.constructor = child; // restore the child's constructor

    return proxyPrototype;
  }

  /***********************************************************************************************************
   * This function merely returns a new object with a propertyDescriptor member that is set to the passed
   * in value
   *
   * This function can be used in class prototype initialization objects to create a property within
   * a given classes's prototype.  The bind function (above) will find these initialization objects and
   * create the actual properties based on the data found in descriptor
   *
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
   *
   * @param {Object} descriptor will be set to the returned objects propertyDescriptor data member
   * @returns {Object} new object with one data mamber called propertyDescriptor set to be descriptor
   *********************************************************************************************************/
  function createPropertyDescriptor(descriptor) {
    return {propertyDescriptor: descriptor};
  }

  /***********************************************************************************************************
   * This function will create a property on obj with the given name.  This property will return a
   * promise in its getter function, and will resolve that promise with the value set in its setter
   * function.  The promise itself is captured in a closure. If autoReset is specified and true, then
   * a new promise will be created to replace the old promise every time set is called and the old promise
   * is resolved, otherwise the promise remains the same when it is resolved.
   *
   * @param {Object} obj that will have a property created for it (using Object.defineProperty)
   * @param {String} name of the property that should be created for obj
   * @param {Boolean} autoReset, if present and true whenever the promise for the property gets resolved,
   *        a new promise will be created to take its place.
   *********************************************************************************************************/
  function createPromiseProperty(obj, name, autoReset) {
    var deferred = Q.defer();

    var get = function () {
      return deferred.promise;
    };
    var set = function (value) {
      deferred.resolve(value);
      if (autoReset && autoReset === true) {
        deferred = Q.defer();
      }
    };

    Object.defineProperty(obj, name, {get: get, set: set});
  }

  /*
   * This function merely returns a new object with a propertyDescriptor member that is set to the passed
   * in value
   *
   * This function can be used in class prototype initialization objects to create a property within
   * a given classes's prototype.  The bind function (above) will find these initialization objects and
   * create the actual properties based on the data found in descriptor
   *
   * @param {Object} initialValue is an optional object that will be used to set the initial value of the property
   * @param {Object} readOnly is true if the property is readOnly, ignored if needsBacking is *not* true
   * @param {Object} observeDescriptor (optional, default is none) describes an observer for the property
   *   @param {Function} observeDescriptor.callbackFunc is the callback function to call to observe the property
   *   @param {Boolean} observeDescriptor.onChangeOnly (optional, default is false) call callback only when
   *          property value is different from what it was before (change detection)
   *
   * @returns {Object} object that defines the property.  Used in ClassUtils.bind to create the property for
   *          each instance created through the constructor.
   */
  function createInstancePropertyDescriptor(initialValue, readOnly, observeDescriptor) {
    return {
      propertyDescriptor: true,
      needsBacking: true,
      readOnly: readOnly,
      initialValue: initialValue,
      observeDescriptor: observeDescriptor
    };
  }

  /*
   * When a property changes, call the specified notification function
   *
   * @param {Object} source object is the object to observe
   * @param {string} property is the property to observe on source
   * @param {function} callbackFunc is a function to be called when the property changes
   * @param {Boolean} onChangeOnly (default false) is true if the callback is to be called only when the
   *        property changes value, or false if callback is always to be called when the property is set
   */
  function observeProperty(source, property, callbackFunc, onChangeOnly) {

    if (!ObjectUtil.isFunction(callbackFunc)) {
      throw new Error("callbackFunc must be a function");
    }

    var descriptor = Object.getOwnPropertyDescriptor(source, property);

    if (ObjectUtil.isObject(descriptor)) {
      // for dealing with accessor descriptors, if we are dealing with the original setter, save it away for
      // usage and create a new setter that will call the original  and then call change callbacks as
      // necessary.  callbackFunc is pushed onto the array of callbacks to be made when the setter is called
      if (ObjectUtil.isFunction(descriptor.set)) {
        if (!descriptor.set.originalSetter) {
          var changeCallbacks = [];
          var originalSetter = descriptor.set;
          descriptor.set = function (value) {
            var oldVal = descriptor.get();
            var changed = (value !== oldVal);

            originalSetter(value);
            changeCallbacks.forEach(function (callback) {
              if (callback.onChangeOnly === false || changed === true) {
                callback(value, oldVal, property);
              }
            });
          };

          descriptor.set.originalSetter = originalSetter;
          descriptor.set.changeCallbacks = changeCallbacks;
          Object.defineProperty(source, property, descriptor);
        }

        callbackFunc.onChangeOnly = (onChangeOnly === true);
        descriptor.set.changeCallbacks.push(callbackFunc);
      }
      // for dealing with data descriptors, we must first upgrade to an accessor descriptor, then the
      // observer can be hooked in
      else if (descriptor.value !== undefined) {
        var observeDescriptor = {
          callbackFunc: callbackFunc,
          onChangeOnly: onChangeOnly
        };

        var propertyTemplate = createInstancePropertyDescriptor(descriptor.value,
          !descriptor.writable,
          observeDescriptor);
        bindInstanceProperty(source, property, propertyTemplate);
      }
      else {
        throw new Error("Cannot register property notification change.");
      }
    }
    else {
      throw new Error("Cannot register property notification change on `" + property + "` as it does not exist.");
    }
  }

  /*
   * Cancel notification to a particular notification function when a property changes
   *
   * @param self object to create the property on
   * @param property is the name of the property to remove the notification for
   * @param callbackFunc is the notification function to remove from property change notification
   */
  function unobserveProperty(source, property, callbackFunc) {
    var descriptor = Object.getOwnPropertyDescriptor(source, property);
    var found = false;

    if (ObjectUtil.isObject(descriptor) &&
      ObjectUtil.isFunction(callbackFunc) &&
      ObjectUtil.isFunction(descriptor.set) &&
      ObjectUtil.isFunction(descriptor.set.originalSetter) &&
      ObjectUtil.isArray(descriptor.set.changeCallbacks)) {

      for (var index = 0; index < descriptor.set.changeCallbacks.length; index++) {
        if (descriptor.set.changeCallbacks[index] === callbackFunc) {
          found = true;
          break;
        }
      }

      if (found === true) {
        descriptor.set.changeCallbacks.splice(index, 1);
      }

      if (descriptor.set.changeCallbacks.length === 0) {
        descriptor.set = descriptor.set.originalSetter;
      }
    }
    else {
      throw new Error("Cannot de-register property notification change");
    }
  }

  return {
    bind: bind,
    bindFunctions: bindFunctions,
    subClass: subClass,
    baseClass: baseClass,
    createPropertyDescriptor: createPropertyDescriptor,
    createPromiseProperty: createPromiseProperty,
    createInstancePropertyDescriptor: createInstancePropertyDescriptor,
    observeProperty: observeProperty,
    unobserveProperty: unobserveProperty
  };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/util/ObjectUtil.js":
/*!***********************************************!*\
  !*** ./javascript/src/sxm/util/ObjectUtil.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/13/14
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Utility methods for all objects that include type checking and object conversion.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {

  /**
   * Checks if `value` is `undefined`.
   *
   * @static
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `undefined`, else `false`.
   * @example
   *
   * ObjectUtil.isUndefined(void 0);
   * // => true
   */
  var isUndefined = function (value) {
    return (typeof value === "undefined");
  };

  /**
   * Checks if `value` is defined or not `undefined`.
   *
   * @static
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is defined or not `undefined`, else `false`.
   * @example
   *
   * ObjectUtil.isDefined(void 0);
   * // => false
   */
  var isDefined = function (value) {
    return !isUndefined(value);
  };

  /**
   * Checks if `value` is `null`.
   *
   * @static
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `null`, else `false`.
   * @example
   *
   * ObjectUtil.isNull(null);
   * // => true
   *
   * ObjectUtil.isNull(undefined);
   * // => false
   */
  var isNull = function (value) {
    return (value === null);
  };

  /**
   * Checks if `value` is `undefined` or is `null`.
   *
   * @static
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` is `undefined` or 'null', else `false`.
   * @example
   *
   * ObjectUtil.isUndefinedOrNull(void 0);
   * // => true
   *
   * ObjectUtil.isUndefinedOrNull(null);
   * // => true
   *
   * ObjectUtil.isUndefinedOrNull(undefined);
   * // => true
   *
   * ObjectUtil.isUndefinedOrNull(5);
   * // => false
   */
  var isUndefinedOrNull = function (value) {
    return isUndefined(value) || isNull(value);
  };

  /**
   * @ngdoc method
   * @name sxm.utils:ObjectUtils#isObject
   * @methodOf sxm.utils:ObjectUtils
   * @description
   * Checks to see if source is an object
   * @param {Object} source object to be checked
   * @returns {boolean} returns object or not
   */
  var isObject = function (source) {
    return (source instanceof Object);
  };

  /**
   * Checks to see if 'value' is a function.
   * @param value
   */
  var isFunction = function (value) {
    return (typeof value === "function");
  };

  /**
   * Checks to see if 'value' is an array
   * @param value
   */
  var isArray = function (value) {
    return Array.isArray(value);
  };

  /**
   * Checks if `value` is `null` or is `undefined` or is an array with no items.
   *
   * @static
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if the `value` has a length property less than or equal to zero, else `false`.
   * @example
   *
   * ObjectUtil.isArrayEmpty(null);
   * // => true
   *
   * ObjectUtil.isArrayEmpty([]);
   * // => true
   *
   * ObjectUtil.isArrayEmpty([1, 2, 3]);
   * // => false
   */
  var isArrayEmpty = function (value) {
    if (!value) {
      return true;
    }
    else {
      return isDefined(value.length) && (value.length <= 0);
    }
  };

  var isNumber = function (value) {
    return (typeof value === "number");
  };

  var isBoolean = function (val) {
    return isDefined(val) && (val === true || val === false);
  };

  var isString = function (val) {
    return (typeof val === "string");
  };

  var isEmptyString = function (val) {
    // trims down the spaces so the value doesn't have to be "" and could be "    ".
    if (isString(val)) {
      return (val.replace(/\ /g, "") === "");
    }
    return false;
    //return val === "";
  };

  var isUndefinedOrNullOrEmptyString = function (val) {
    return isEmptyString(val) || isUndefinedOrNull(val);
  };

  /**
   * Checks if `value` is a Date object instance.
   *
   * @static
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the `value` is a Date instance, else `false`.
   * @example
   *
   * ObjectUtil.isDate(new Date());
   * // => true
   *
   * ObjectUtil.isDate("foo");
   * // => false
   */
  var isDate = function (value) {
    //return value instanceof Date;
    return Object.prototype.toString.call(value) === "[object Date]";
  };

  var convertArrayToObject = function (array) {
    var result = {};
    for (var i = 0; i < array.length; ++i) {
      result[i] = array[i];
    }
    return result;
  };

  /**
   * Performs a shallow clone of simple objects.
   * @param object
   * @returns {*}
   */
  var shallowClone = function (object) {
    var copy = [];
    for (var property in object) {
      if (object.hasOwnProperty(property)) {
        copy[property] = object[property];
      }
    }
    return copy;
  };

  /**
   * Creates a simple no operation function. Most typically used as a placeholder for function variables
   * to prohibit null pointers on undefined or null methods.
   */
  var noop = function () {
  };

  var IObjectUtil = {
    isUndefined: isUndefined,
    isDefined: isDefined,
    isNull: isNull,
    isUndefinedOrNull: isUndefinedOrNull,
    isObject: isObject,
    isFunction: isFunction,
    isArray: isArray,
    isArrayEmpty: isArrayEmpty,
    isDate: isDate,
    isBoolean: isBoolean,
    isNumber: isNumber,
    isString: isString,
    isEmptyString: isEmptyString,
    isUndefinedOrNullOrEmptyString: isUndefinedOrNullOrEmptyString,
    convertArrayToObject: convertArrayToObject,
    shallowClone: shallowClone,
    noop: noop
  };

  return IObjectUtil;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));



/***/ }),

/***/ "./javascript/src/sxm/util/PromiseUtil.js":
/*!************************************************!*\
  !*** ./javascript/src/sxm/util/PromiseUtil.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    09/03/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Collection of Q Promise utils.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var Q = __webpack_require__(/*! q */ "q");

  /**
   * Allows for the sequentially calling of promise based functions by iterating over a list of
   * items and then calling the next promise based function when the previous one has resolved.
   *
   * @param {Array} arr List of values or objects used to pass into the promise-based `iterator`
   * parameter function.
   * @param {Function} iterator The promise-based function to call with an item from the `arr` parameter.
   * @returns {Promise}
   */
  var promiseLoopSequence = function (arr, iterator) {
    // create a empty promise to start our series (so we can use `then`)
    // we save Q to qPromise so JSLint doesn't complain about no "new" keyword
    var qPromise = Q;
    var currentPromise = qPromise();
    var promises = arr.map(function (el) {
      return currentPromise = currentPromise.then(function () {
        // execute the next function after the previous has resolved successfully
        return iterator(el);
      });
    });
    // group the results and return the group promise
    return Q.all(promises);
  };

  /**
   * This is an attempt to scope and context support to promise's then method callbacks.
   *
   * NOTE: Not currently used.
   */
  var addScopeSupport = function () {
    Q.makePromise.prototype.bind = function (context) {
      this.context = context;
      return this;
    };

    Q.makePromise.prototype.then = (function () {
      var old_then = Q.makePromise.prototype.then;
      return function (fulfill, reject) {
        if (this.context) {
          return old_then.call(this,
            fulfill && fulfill.bind && fulfill.bind(this.context),
            reject && reject.bind && reject.bind(this.context)
          );
        }
        else {
          return old_then.call(this,
            fulfill,
            reject
          );
        }
      };
    }());
  };

  var PromiseUtil = {
    promiseLoopSequence: promiseLoopSequence,
    addScopeSupport: addScopeSupport
  };

  return PromiseUtil;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/util/StringUtil.js":
/*!***********************************************!*\
  !*** ./javascript/src/sxm/util/StringUtil.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/31/15
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 * Collection of string utils.
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  //-----------------------------------------------------------------------
  // CONSTANTS
  //-----------------------------------------------------------------------

  var INVALID_DATA = "Undefined template provided";

  /**
   * supplant() method from Crockfords `Remedial Javascript`
   *
   * @param template
   * @param values
   * @param pattern
   * @returns {*}
   */
  var supplant = function (template, values, pattern) {
    if (!template || !template.toString) {
      throw(new Error(INVALID_DATA));
    }

    pattern = pattern || /\{([^\{\}]*)\}/g;

    return template.toString().replace(pattern, function (a, b) {
      var p = b.split("."),
        r = values;

      try {
        // In IE8 for(var s in p) iterative twice even p.length is 1 which leads messup with data, so that I
        // have followed with general for loop which supports all browsers.
        //for(var s in p)
        for (var s = 0; s < p.length; s++) {
          r = String(r[p[s]]);
        }
      }
      catch (e) {
        r = a;
      }

      if (typeof r === "undefined") {
        r = "undefined";
      }
      else if (r === null) {
        r = "null";
      }

      return String((typeof r === "string" || typeof r === "number") ? r : typeof r);
    });
  };

  /**
   * Removes whitespace from the front and the end of the specified string.
   *
   * @param {String} str - The String whose beginning and ending whitespace will will be removed.
   * @returns {String} A String with whitespace removed from the beginning and end.
   */
  var trim = function trimStr(str) {
    return str.replace(/^\s+|\s+$/g, "");
  };

  /**
   * Gets the file name from a URL. Removes the query string.
   * @param {String} str - The URL.
   * @returns {String} The file name from the URL sans the query string.
   */
  var getFileName = function (str) {
    var index = str.indexOf("?");
    if (index > -1) {
      str = str.substring(0, index);
    }
    return str.replace(/^.*[\\\/]/, "");
  };

  var StringUtil = {
    trim: trim,
    supplant: supplant,
    getFileName: getFileName
  };

  return StringUtil;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/util/URLUtils.js":
/*!*********************************************!*\
  !*** ./javascript/src/sxm/util/URLUtils.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @MODULE:     web-audio-core
 * @CREATED:    08/13/14
 * @COPYRIGHT:  2015 Sirius XM Radio Inc.
 *
 * @DESCRIPTION:
 *
 *      Utility methods for working with URLs, specifically query string parameters.
 *
 */


!(__WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
  var ObjectUtil = __webpack_require__(/*! sxm/util/ObjectUtil */ "./javascript/src/sxm/util/ObjectUtil.js");

  /**
   * Get value of URL query string parameter.
   * http://url?param1=true&param2=true
   *
   * @param {String} key - The query string parameter name.
   * @param {String} type - The expected type of the string parameter's value.
   */
  var getURLParam = function (key, type) {
    var params = getParams();
    if (params) {
      var value = getParamValue(params, key);
      var convert = !ObjectUtil.isUndefinedOrNullOrEmptyString(value) && !ObjectUtil.isUndefinedOrNullOrEmptyString(type);
      if (convert) {
        switch (type.toLowerCase()) {
          case "boolean":
            value = (value === "true");
            break;

          case "number":
            value = parseInt(value, 10);
            break;
        }
      }

      return value;
    }

    return null;
  };

  /**
   * Set value of URL query string parameter.
   * http://url?param1=true&param2=true
   *
   * @param {String} key - The name of the parameter.
   * @param {*} value - The value of the parameter.
   */
  var setURLParam = function (key, value) {
    var params = getParams();
    var found = false;
    var paramString = "";

    var setParams = function (params) {
      var state = {};
      var url = window.location.pathname + "?" + params;
      history.pushState(state, "", url);
    };

    // try to locate an existing param and set the new value on it
    if (params && key && value) {
      var paramArray = params.split("&");
      for (var i = 0; i < paramArray.length; i++) {
        var param = paramArray[i].split("=");
        if (param[0] === key) {
          found = true;
          paramArray[i] = key + "=" + value;
          break;
        }
      }

      // convert the array of params to a string
      for (var j = 0; j < paramArray.length; j++) {
        if (paramArray[j] !== "") {
          paramString += paramArray[j] + "&";
        }
      }

      setParams(paramString);
    }

    // no existing param found so add a new query string param and value
    if (!found) {
      params = params + "&" + key + "=" + value;
      setParams(params);
    }

    return null;
  };

  /**
   * Check for params and return set of params for an url
   */
  var getParams = function () {
    var url = window.location.href;

    // check whether url contains params
    var params = url.split("?");

    // since the first item is the URL itself we try to grab the list of params
    if (params.length > 1) {
      return params[1];
    }

    return null;
  };

  /**
   * Utility function to get a particular parameter from list of params
   * @param {Object} params
   * @param {Object} key
   */
  var getParamValue = function (params, key) {
    if (params && key) {
      var paramArray = params.split("&");
      for (var i = 0; i < paramArray.length; i++) {
        var param = paramArray[i].split("=");
        if (param[0] === key) {
          var value = param[1];

          // Inspect the value for a route -- this can happen when using routing frameworks like
          // AngularJS's ui-router that uses query string params in between the document and
          // the route; e.g., debug.html?debug=true&audioPlayerType=javascript#/player/live
          // We DO NOT want the value of `audioPlayerType` to be `javascript#/player/live` -- we simply
          // want `javascript` so we grab the value before the route.
          var routeIndex = value.indexOf("#/");
          if (routeIndex !== -1) {
            value = value.substring(0, routeIndex);
          }
          return value;
        }
      }
    }
    return null;
  };

  var IURLUtils = {
    getURLParam: getURLParam,
    setURLParam: setURLParam
  };

  return IURLUtils;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./javascript/src/sxm/util/version.js":
/*!********************************************!*\
  !*** ./javascript/src/sxm/util/version.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// NOTE: This file is automatically generated by the version task
(function () {"use strict";
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
var getBranch = function () { return "task"; };
var getHash = function() { return "2160c9d92c6e720a7ea51a8c61e1de2b2251378f"; };
var IVersion = { getBranch : getBranch,
                 getHash   : getHash };
return IVersion;
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}());

/***/ }),

/***/ "./javascript/vendor/SWFService/dist/client/SWFService.js":
/*!****************************************************************!*\
  !*** ./javascript/vendor/SWFService/dist/client/SWFService.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, setImmediate) {/*** IMPORTS FROM imports-loader ***/
(function() {
var exports = null;

/*!
 * [SWFService](http://github.com/CodeCatalyst/SWFService) v2.0.4
 * Copyright (c) 2008-2013 [CodeCatalyst, LLC](http://codecatalyst.com)
 * Open source under the [MIT License](http://en.wikipedia.org/wiki/MIT_License).
 */

/*
 * [promise.coffee](http://github.com/CodeCatalyst/promise.coffee) v1.0.6
 * Copyright (c) 2012-2013 [CodeCatalyst, LLC](http://www.codecatalyst.com/).
 * Open source under the [MIT License](http://en.wikipedia.org/wiki/MIT_License).
 */
// Generated by CoffeeScript 1.6.3
(function() {
  var CallbackQueue, Consequence, Deferred, Promise, Resolver, callbackQueue, enqueue, isFunction, isObject, nextTick, target;

  nextTick = (typeof process !== "undefined" && process !== null ? process.nextTick : void 0) != null ? process.nextTick : typeof setImmediate !== "undefined" && setImmediate !== null ? setImmediate : function(task) {
    return setTimeout(task, 0);
  };

  CallbackQueue = (function() {
    function CallbackQueue() {
      var execute, queuedCallbackCount, queuedCallbacks;
      queuedCallbacks = new Array(1e4);
      queuedCallbackCount = 0;
      execute = function() {
        var index;
        index = 0;
        while (index < queuedCallbackCount) {
          queuedCallbacks[index]();
          queuedCallbacks[index] = null;
          index++;
        }
        queuedCallbackCount = 0;
      };
      this.schedule = function(callback) {
        queuedCallbacks[queuedCallbackCount++] = callback;
        if (queuedCallbackCount === 1) {
          nextTick(execute);
        }
      };
    }

    return CallbackQueue;

  })();

  callbackQueue = new CallbackQueue();

  enqueue = function(task) {
    return callbackQueue.schedule(task);
  };

  isFunction = function(value) {
    return value && typeof value === 'function';
  };

  isObject = function(value) {
    return value && typeof value === 'object';
  };

  Consequence = (function() {
    function Consequence(onFulfilled, onRejected) {
      this.onFulfilled = onFulfilled;
      this.onRejected = onRejected;
      this.resolver = new Resolver();
      this.promise = this.resolver.promise;
    }

    Consequence.prototype.trigger = function(action, value) {
      switch (action) {
        case 'fulfill':
          this.propagate(value, this.onFulfilled, this.resolver, this.resolver.resolve);
          break;
        case 'reject':
          this.propagate(value, this.onRejected, this.resolver, this.resolver.reject);
      }
    };

    Consequence.prototype.propagate = function(value, callback, resolver, resolverMethod) {
      if (isFunction(callback)) {
        enqueue(function() {
          var error;
          try {
            resolver.resolve(callback(value));
          } catch (_error) {
            error = _error;
            resolver.reject(error);
          }
        });
      } else {
        resolverMethod.call(resolver, value);
      }
    };

    return Consequence;

  })();

  Resolver = (function() {
    function Resolver() {
      this.promise = new Promise(this);
      this.consequences = [];
      this.completed = false;
      this.completionAction = null;
      this.completionValue = null;
    }

    Resolver.prototype.then = function(onFulfilled, onRejected) {
      var consequence;
      consequence = new Consequence(onFulfilled, onRejected);
      if (this.completed) {
        consequence.trigger(this.completionAction, this.completionValue);
      } else {
        this.consequences.push(consequence);
      }
      return consequence.promise;
    };

    Resolver.prototype.resolve = function(value) {
      var error, isHandled, self, thenFn;
      if (this.completed) {
        return;
      }
      try {
        if (value === this.promise) {
          throw new TypeError('A Promise cannot be resolved with itself.');
        }
        if ((isObject(value) || isFunction(value)) && isFunction(thenFn = value.then)) {
          isHandled = false;
          try {
            self = this;
            thenFn.call(value, function(value) {
              if (!isHandled) {
                isHandled = true;
                self.resolve(value);
              }
            }, function(error) {
              if (!isHandled) {
                isHandled = true;
                self.reject(error);
              }
            });
          } catch (_error) {
            error = _error;
            if (!isHandled) {
              this.reject(error);
            }
          }
        } else {
          this.complete('fulfill', value);
        }
      } catch (_error) {
        error = _error;
        this.reject(error);
      }
    };

    Resolver.prototype.reject = function(reason) {
      if (this.completed) {
        return;
      }
      this.complete('reject', reason);
    };

    Resolver.prototype.complete = function(action, value) {
      var consequence, _i, _len, _ref;
      this.completionAction = action;
      this.completionValue = value;
      this.completed = true;
      _ref = this.consequences;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        consequence = _ref[_i];
        consequence.trigger(this.completionAction, this.completionValue);
      }
      this.consequences = null;
    };

    return Resolver;

  })();

  Promise = (function() {
    function Promise(resolver) {
      this.then = function(onFulfilled, onRejected) {
        return resolver.then(onFulfilled, onRejected);
      };
    }

    return Promise;

  })();

  Deferred = (function() {
    function Deferred() {
      var resolver;
      resolver = new Resolver();
      this.promise = resolver.promise;
      this.resolve = function(value) {
        return resolver.resolve(value);
      };
      this.reject = function(reason) {
        return resolver.reject(reason);
      };
    }

    Deferred.resolve = function(value) {
      var deferred;
      deferred = new Deferred();
      deferred.resolve(value);
      return deferred.promise;
    };

    Deferred.reject = function(reason) {
      var deferred;
      deferred = new Deferred();
      deferred.reject(reason);
      return deferred.promise;
    };

    return Deferred;

  })();

  target = typeof exports !== "undefined" && exports !== null ? exports : window;

  target.Deferred = Deferred;

  target.defer = function() {
    return new Deferred();
  };

}).call(this);
// Generated by CoffeeScript 1.6.3
(function() {
  var DeferredEntityRegistry, EntitySet, SWFService, SWFServiceContext, SWFServiceContextManager, SWFServiceEventListenerProxy, SWFServiceOperationProxy, SWFServiceProxy, Timer, target;

  Timer = (function() {
    function Timer(duration) {
      var now, start;
      now = function() {
        return new Date().getTime();
      };
      start = now();
      this.elapsed = function() {
        return now() - start;
      };
      this.remaining = function() {
        return Math.max(duration - this.elapsed(), 0);
      };
      this.expired = function() {
        return this.elapsed() > duration;
      };
    }

    return Timer;

  })();

  EntitySet = (function() {
    function EntitySet(entityClass, entityName, entityKeyProperty) {
      this.entityClass = entityClass;
      this.entityName = entityName != null ? entityName : 'entity';
      this.entityKeyProperty = entityKeyProperty != null ? entityKeyProperty : 'id';
      this.entitiesByKey = {};
    }

    EntitySet.prototype.add = function(entity) {
      var entityKey;
      if (!(entity instanceof this.entityClass)) {
        throw new Error("Entity must be of type: " + this.entityName + " to be added to this EntitySet.");
      }
      entityKey = entity[this.entityKeyProperty];
      if (this.exists(entityKey)) {
        throw new Error("An Entity with key: " + entityKey + " already exists in this EntitySet.");
      }
      this.entitiesByKey[entityKey] = entity;
      return entity;
    };

    EntitySet.prototype.remove = function(entity) {
      if (this.contains(entity)) {
        delete this.entitiesByKey[entity[this.entityKeyProperty]];
        return entity;
      }
      return null;
    };

    EntitySet.prototype.removeAll = function() {
      this.entitiesByKey = {};
    };

    EntitySet.prototype.get = function(key) {
      return this.entitiesByKey[key];
    };

    EntitySet.prototype.find = function(attributes) {
      var matches;
      matches = function(entity) {
        var attribute, attributeValue;
        for (attribute in attributes) {
          attributeValue = attributes[attribute];
          if (entity[attribute] !== attributeValue) {
            return false;
          }
        }
        return true;
      };
      return this.match(matches);
    };

    EntitySet.prototype.match = function(matcherFunction) {
      var entity, entityId, matchingEntities, _ref;
      matchingEntities = [];
      _ref = this.entitiesByKey;
      for (entityId in _ref) {
        entity = _ref[entityId];
        if (matcherFunction(entity)) {
          matchingEntities.push(entity);
        }
      }
      return matchingEntities;
    };

    EntitySet.prototype.contains = function(entity) {
      var entityKey;
      entityKey = entity[this.entityKeyProperty];
      return this.exists(entityKey) && entity === this.get(entityKey);
    };

    EntitySet.prototype.exists = function(key) {
      return this.entitiesByKey[key] != null;
    };

    EntitySet.prototype.toArray = function() {
      var entities, entity, entityId, _ref;
      entities = [];
      _ref = this.entitiesByKey;
      for (entityId in _ref) {
        entity = _ref[entityId];
        entities.push(entity);
      }
      return entities;
    };

    return EntitySet;

  })();

  DeferredEntityRegistry = (function() {
    function DeferredEntityRegistry(entityClass, entityName, entityKeyProperty) {
      this.entityClass = entityClass;
      this.entityName = entityName != null ? entityName : 'entity';
      this.entityKeyProperty = entityKeyProperty != null ? entityKeyProperty : 'id';
      this.entities = new EntitySet(this.entityClass, this.entityName, this.entityKeyProperty);
      this.pendingEntityRequestsByEntityId = {};
    }

    DeferredEntityRegistry.prototype.get = function(entityId, timeout) {
      var deferred, entity, _base,
        _this = this;
      entity = this.entities.get(entityId);
      if (entity != null) {
        deferred = new Deferred();
        deferred.resolve(entity);
        return deferred.promise;
      } else {
        deferred = new Deferred();
        if (timeout != null) {
          setTimeout(function() {
            deferred.reject(new Error("Request for " + _this.entityName + " with " + _this.entityKeyProperty + ": \"" + entityId + "\" timed out."));
          }, timeout);
        }
        if ((_base = this.pendingEntityRequestsByEntityId)[entityId] == null) {
          _base[entityId] = [];
        }
        this.pendingEntityRequestsByEntityId[entityId].push(deferred);
        return deferred.promise;
      }
    };

    DeferredEntityRegistry.prototype.register = function(entity) {
      var entityId, pendingEntityRequest, pendingEntityRequests, _i, _len;
      this.entities.add(entity);
      entityId = entity[this.entityKeyProperty];
      pendingEntityRequests = this.pendingEntityRequestsByEntityId[entityId];
      if (pendingEntityRequests != null) {
        for (_i = 0, _len = pendingEntityRequests.length; _i < _len; _i++) {
          pendingEntityRequest = pendingEntityRequests[_i];
          pendingEntityRequest.resolve(entity);
        }
      }
      delete this.pendingEntityRequestsByEntityId[entityId];
      return entity;
    };

    DeferredEntityRegistry.prototype.unregister = function(entity) {
      this.entities.remove(entity);
      return entity;
    };

    return DeferredEntityRegistry;

  })();

  SWFServiceProxy = (function() {
    function SWFServiceProxy(serviceContext, id, descriptor) {
      var accessor, createGetter, createMethod, createSetter, error, method, variable, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2;
      this.id = id;
      createGetter = function(propertyName) {
        return function() {
          return serviceContext.getServiceProperty(id, propertyName);
        };
      };
      createSetter = function(propertyName) {
        return function(value) {
          serviceContext.setServiceProperty(id, propertyName, value);
        };
      };
      createMethod = function(methodName) {
        return function() {
          var args;
          args = Array.prototype.slice.call(arguments);
          return serviceContext.executeServiceMethod(id, methodName, args);
        };
      };
      try {
        _ref = descriptor.accessors;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          accessor = _ref[_i];
          Object.defineProperty(this, accessor.name, {
            writeable: accessor.access !== 'readonly',
            get: createGetter(accessor.name),
            set: createSetter(accessor.name)
          });
        }
        _ref1 = descriptor.variables;
        for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
          variable = _ref1[_j];
          Object.defineProperty(this, variable.name, {
            get: createGetter(variable.name),
            set: createSetter(variable.name)
          });
        }
      } catch (_error) {
        error = _error;
        if (typeof console !== "undefined" && console !== null) {
          if (typeof console.log === "function") {
            console.log('Warning: SWFService properties and getters/setters are only available for browsers that support ECMAScript 5 properties.');
          }
        }
      }
      _ref2 = descriptor.methods;
      for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
        method = _ref2[_k];
        this[method.name] = createMethod(method.name);
      }
      if (descriptor.isEventDispatcher) {
        this.addEventListener = function(eventType, listenerFunction, useCapture, priority, weakReference) {
          if (useCapture == null) {
            useCapture = false;
          }
          if (priority == null) {
            priority = 0;
          }
          if (weakReference == null) {
            weakReference = false;
          }
          serviceContext.addServiceEventListener(id, eventType, listenerFunction, useCapture, priority, weakReference);
        };
        this.removeEventListener = function(eventType, listenerFunction, useCapture) {
          if (useCapture == null) {
            useCapture = false;
          }
          serviceContext.removeServiceEventListener(id, eventType, listenerFunction, useCapture);
        };
      }
    }

    return SWFServiceProxy;

  })();

  SWFServiceOperationProxy = (function() {
    function SWFServiceOperationProxy(id, serviceId, methodName, args) {
      var deferred;
      this.id = id;
      this.serviceId = serviceId;
      this.methodName = methodName;
      this.args = args;
      deferred = new Deferred();
      this.promise = deferred.promise, this.resolve = deferred.resolve, this.reject = deferred.reject;
    }

    return SWFServiceOperationProxy;

  })();

  SWFServiceEventListenerProxy = (function() {
    function SWFServiceEventListenerProxy(id, serviceId, eventType, listenerFunction, useCapture, priority, useWeakReference) {
      this.id = id;
      this.serviceId = serviceId;
      this.eventType = eventType;
      this.listenerFunction = listenerFunction;
      this.useCapture = useCapture != null ? useCapture : false;
      this.priority = priority != null ? priority : 0;
      this.useWeakReference = useWeakReference != null ? useWeakReference : false;
    }

    SWFServiceEventListenerProxy.prototype.redispatch = function(event) {
      return this.listenerFunction(event);
    };

    return SWFServiceEventListenerProxy;

  })();

  SWFServiceContext = (function() {
    function SWFServiceContext(id) {
      this.id = id;
      this.serviceProxyRegistry = new DeferredEntityRegistry(SWFServiceProxy, 'SWF service proxy');
      this.serviceOperationProxies = new EntitySet(SWFServiceOperationProxy);
      this.serviceEventListenerProxies = new EntitySet(SWFServiceEventListenerProxy);
      return;
    }

    SWFServiceContext.prototype.get = function(serviceId, timeout) {
      return this.serviceProxyRegistry.get(serviceId, timeout);
    };

    SWFServiceContext.prototype.getServiceDescriptor = function(serviceId) {
      return this.swf.SWFServiceContext_getServiceDescriptor(serviceId);
    };

    SWFServiceContext.prototype.getServiceProperty = function(serviceId, propertyName) {
      return this.swf.SWFServiceContext_getServiceProperty(serviceId, propertyName);
    };

    SWFServiceContext.prototype.setServiceProperty = function(serviceId, propertyName, value) {
      this.swf.SWFServiceContext_setServiceProperty(serviceId, propertyName, value);
    };

    SWFServiceContext.prototype.executeServiceMethod = function(serviceId, methodName, args) {
      var cleanUp, returnValue, serviceOperationProxy,
        _this = this;
      returnValue = this.swf.SWFServiceContext_executeServiceMethod(serviceId, methodName, args);
      if (returnValue.pending) {
        serviceOperationProxy = new SWFServiceOperationProxy(returnValue.operationId, serviceId, methodName, args);
        this.serviceOperationProxies.add(serviceOperationProxy);
        cleanUp = function() {
          return _this.serviceOperationProxies.remove(serviceOperationProxy);
        };
        serviceOperationProxy.promise.then(cleanUp, cleanUp);
        return serviceOperationProxy.promise;
      }
      return returnValue.value;
    };

    SWFServiceContext.prototype.addServiceEventListener = function(serviceId, eventType, listenerFunction, useCapture, priority, weakReference) {
      var serviceEventListenerProxyId;
      serviceEventListenerProxyId = this.swf.SWFServiceContext_addServiceEventListener(serviceId, eventType, useCapture, priority, weakReference);
      this.serviceEventListenerProxies.add(new SWFServiceEventListenerProxy(serviceEventListenerProxyId, serviceId, eventType, listenerFunction, useCapture, priority, weakReference));
    };

    SWFServiceContext.prototype.removeServiceEventListener = function(serviceId, eventType, listenerFunction, useCapture) {
      var serviceEventListenerProxy;
      serviceEventListenerProxy = this.serviceEventListenerProxies.find({
        serviceId: serviceId,
        eventType: eventType,
        listenerFunction: listenerFunction,
        useCapture: useCapture
      })[0];
      if (serviceEventListenerProxy != null) {
        this.swf.SWFServiceContext_removeServiceEventListener(serviceId, serviceEventListenerProxy.id);
        this.serviceEventListenerProxies.remove(serviceEventListenerProxy);
      }
    };

    SWFServiceContext.prototype.onServiceRegister = function(serviceId, serviceDescriptor) {
      this.serviceProxyRegistry.register(new SWFServiceProxy(this, serviceId, serviceDescriptor));
    };

    SWFServiceContext.prototype.onServiceExecuteComplete = function(serviceId, serviceOperationProxyId, action, value) {
      var serviceOperationProxy;
      serviceOperationProxy = this.serviceOperationProxies.get(serviceOperationProxyId);
      if (serviceOperationProxy != null) {
        serviceOperationProxy[action](value);
      }
    };

    SWFServiceContext.prototype.onServiceEvent = function(serviceId, serviceEventListenerProxyId, event) {
      return this.serviceEventListenerProxies.get(serviceEventListenerProxyId).redispatch(event);
    };

    return SWFServiceContext;

  })();

  SWFServiceContextManager = (function() {
    function SWFServiceContextManager() {
      this.serviceContexts = new EntitySet(SWFServiceContext);
    }

    SWFServiceContextManager.prototype.add = function(serviceContext) {
      return this.serviceContexts.add(serviceContext);
    };

    SWFServiceContextManager.prototype.getById = function(serviceContextId) {
      return this.serviceContexts.get(serviceContextId);
    };

    SWFServiceContextManager.prototype.getBySWFId = function(swfId, timeout) {
      var deferred, intervalId, timer,
        _this = this;
      deferred = new Deferred();
      timer = new Timer(timeout);
      intervalId = setInterval(function() {
        var error, serviceContext, serviceContextId, swf;
        try {
          swf = document.getElementById(swfId);
          serviceContextId = swf.SWFServiceContext_getId();
          serviceContext = _this.serviceContexts.get(serviceContextId);
        } catch (_error) {
          error = _error;
        }
        if ((serviceContextId != null) && (serviceContext != null)) {
          clearInterval(intervalId);
          if (serviceContext.swf == null) {
            serviceContext.swf = swf;
          }
          deferred.resolve(serviceContext);
        } else {
          if (timer.expired()) {
            clearInterval(intervalId);
            deferred.reject(new Error('SWFService timed out attempting to access the requested SWF.'));
          }
        }
      }, 100);
      return deferred.promise;
    };

    return SWFServiceContextManager;

  })();

  SWFService = (function() {
    function SWFService() {
      this.serviceContextManager = new SWFServiceContextManager();
    }

    SWFService.prototype.get = function(swfId, serviceId, timeout) {
      var timer;
      if (timeout == null) {
        timeout = 30000;
      }
      timer = new Timer(timeout);
      return this.serviceContextManager.getBySWFId(swfId, timer.remaining()).then(function(serviceContext) {
        return serviceContext.get(serviceId, timer.remaining());
      });
    };

    SWFService.prototype.onInit = function(serviceContextId) {
      this.serviceContextManager.add(new SWFServiceContext(serviceContextId));
    };

    SWFService.prototype.onServiceRegister = function(serviceContextId, serviceId, serviceDescriptor) {
      this.serviceContextManager.getById(serviceContextId).onServiceRegister(serviceId, serviceDescriptor);
    };

    SWFService.prototype.onServiceExecuteComplete = function(serviceContextId, serviceId, operationId, action, value) {
      this.serviceContextManager.getById(serviceContextId).onServiceExecuteComplete(serviceId, operationId, action, value);
    };

    SWFService.prototype.onServiceEvent = function(serviceContextId, serviceId, listenerId, event) {
      return this.serviceContextManager.getById(serviceContextId).onServiceEvent(serviceId, listenerId, event);
    };

    return SWFService;

  })();

  target = typeof exports !== "undefined" && exports !== null ? exports : window;

  target.SWFService = new SWFService();

}).call(this);


/*** EXPORTS FROM exports-loader ***/
module.exports = SWFService;
}.call(window));
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../../node_modules/process/browser.js */ "./node_modules/process/browser.js"), __webpack_require__(/*! ./../../../../../node_modules/timers-browserify/main.js */ "./node_modules/timers-browserify/main.js").setImmediate))

/***/ }),

/***/ "./javascript/vendor/swfobject/swfobject/swfobject.js":
/*!************************************************************!*\
  !*** ./javascript/vendor/swfobject/swfobject/swfobject.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*!    SWFObject v2.3.20130521 <http://github.com/swfobject/swfobject>
    is released under the MIT License <http://www.opensource.org/licenses/mit-license.php>
*/
var swfobject=function(){var D="undefined",r="object",T="Shockwave Flash",Z="ShockwaveFlash.ShockwaveFlash",q="application/x-shockwave-flash",S="SWFObjectExprInst",x="onreadystatechange",Q=window,h=document,t=navigator,V=false,X=[],o=[],P=[],K=[],I,p,E,B,L=false,a=false,m,G,j=true,l=false,O=function(){var ad=typeof h.getElementById!=D&&typeof h.getElementsByTagName!=D&&typeof h.createElement!=D,ak=t.userAgent.toLowerCase(),ab=t.platform.toLowerCase(),ah=ab?/win/.test(ab):/win/.test(ak),af=ab?/mac/.test(ab):/mac/.test(ak),ai=/webkit/.test(ak)?parseFloat(ak.replace(/^.*webkit\/(\d+(\.\d+)?).*$/,"$1")):false,aa=t.appName==="Microsoft Internet Explorer",aj=[0,0,0],ae=null;if(typeof t.plugins!=D&&typeof t.plugins[T]==r){ae=t.plugins[T].description;if(ae&&(typeof t.mimeTypes!=D&&t.mimeTypes[q]&&t.mimeTypes[q].enabledPlugin)){V=true;aa=false;ae=ae.replace(/^.*\s+(\S+\s+\S+$)/,"$1");aj[0]=n(ae.replace(/^(.*)\..*$/,"$1"));aj[1]=n(ae.replace(/^.*\.(.*)\s.*$/,"$1"));aj[2]=/[a-zA-Z]/.test(ae)?n(ae.replace(/^.*[a-zA-Z]+(.*)$/,"$1")):0}}else{if(typeof Q.ActiveXObject!=D){try{var ag=new ActiveXObject(Z);if(ag){ae=ag.GetVariable("$version");if(ae){aa=true;ae=ae.split(" ")[1].split(",");aj=[n(ae[0]),n(ae[1]),n(ae[2])]}}}catch(ac){}}}return{w3:ad,pv:aj,wk:ai,ie:aa,win:ah,mac:af}}(),i=function(){if(!O.w3){return}if((typeof h.readyState!=D&&(h.readyState==="complete"||h.readyState==="interactive"))||(typeof h.readyState==D&&(h.getElementsByTagName("body")[0]||h.body))){f()}if(!L){if(typeof h.addEventListener!=D){h.addEventListener("DOMContentLoaded",f,false)}if(O.ie){h.attachEvent(x,function aa(){if(h.readyState=="complete"){h.detachEvent(x,aa);f()}});if(Q==top){(function ac(){if(L){return}try{h.documentElement.doScroll("left")}catch(ad){setTimeout(ac,0);return}f()}())}}if(O.wk){(function ab(){if(L){return}if(!/loaded|complete/.test(h.readyState)){setTimeout(ab,0);return}f()}())}}}();function f(){if(L||!document.getElementsByTagName("body")[0]){return}try{var ac,ad=C("span");ad.style.display="none";ac=h.getElementsByTagName("body")[0].appendChild(ad);ac.parentNode.removeChild(ac);ac=null;ad=null}catch(ae){return}L=true;var aa=X.length;for(var ab=0;ab<aa;ab++){X[ab]()}}function M(aa){if(L){aa()}else{X[X.length]=aa}}function s(ab){if(typeof Q.addEventListener!=D){Q.addEventListener("load",ab,false)}else{if(typeof h.addEventListener!=D){h.addEventListener("load",ab,false)}else{if(typeof Q.attachEvent!=D){g(Q,"onload",ab)}else{if(typeof Q.onload=="function"){var aa=Q.onload;Q.onload=function(){aa();ab()}}else{Q.onload=ab}}}}}function Y(){var aa=h.getElementsByTagName("body")[0];var ae=C(r);ae.setAttribute("style","visibility: hidden;");ae.setAttribute("type",q);var ad=aa.appendChild(ae);if(ad){var ac=0;(function ab(){if(typeof ad.GetVariable!=D){try{var ag=ad.GetVariable("$version");if(ag){ag=ag.split(" ")[1].split(",");O.pv=[n(ag[0]),n(ag[1]),n(ag[2])]}}catch(af){O.pv=[8,0,0]}}else{if(ac<10){ac++;setTimeout(ab,10);return}}aa.removeChild(ae);ad=null;H()}())}else{H()}}function H(){var aj=o.length;if(aj>0){for(var ai=0;ai<aj;ai++){var ab=o[ai].id;var ae=o[ai].callbackFn;var ad={success:false,id:ab};if(O.pv[0]>0){var ah=c(ab);if(ah){if(F(o[ai].swfVersion)&&!(O.wk&&O.wk<312)){w(ab,true);if(ae){ad.success=true;ad.ref=z(ab);ad.id=ab;ae(ad)}}else{if(o[ai].expressInstall&&A()){var al={};al.data=o[ai].expressInstall;al.width=ah.getAttribute("width")||"0";al.height=ah.getAttribute("height")||"0";if(ah.getAttribute("class")){al.styleclass=ah.getAttribute("class")}if(ah.getAttribute("align")){al.align=ah.getAttribute("align")}var ak={};var aa=ah.getElementsByTagName("param");var af=aa.length;for(var ag=0;ag<af;ag++){if(aa[ag].getAttribute("name").toLowerCase()!="movie"){ak[aa[ag].getAttribute("name")]=aa[ag].getAttribute("value")}}R(al,ak,ab,ae)}else{b(ah);if(ae){ae(ad)}}}}}else{w(ab,true);if(ae){var ac=z(ab);if(ac&&typeof ac.SetVariable!=D){ad.success=true;ad.ref=ac;ad.id=ac.id}ae(ad)}}}}}X[0]=function(){if(V){Y()}else{H()}};function z(ac){var aa=null,ab=c(ac);if(ab&&ab.nodeName.toUpperCase()==="OBJECT"){if(typeof ab.SetVariable!==D){aa=ab}else{aa=ab.getElementsByTagName(r)[0]||ab}}return aa}function A(){return !a&&F("6.0.65")&&(O.win||O.mac)&&!(O.wk&&O.wk<312)}function R(ad,ae,aa,ac){var ah=c(aa);aa=W(aa);a=true;E=ac||null;B={success:false,id:aa};if(ah){if(ah.nodeName.toUpperCase()=="OBJECT"){I=J(ah);p=null}else{I=ah;p=aa}ad.id=S;if(typeof ad.width==D||(!/%$/.test(ad.width)&&n(ad.width)<310)){ad.width="310"}if(typeof ad.height==D||(!/%$/.test(ad.height)&&n(ad.height)<137)){ad.height="137"}var ag=O.ie?"ActiveX":"PlugIn",af="MMredirectURL="+encodeURIComponent(Q.location.toString().replace(/&/g,"%26"))+"&MMplayerType="+ag+"&MMdoctitle="+encodeURIComponent(h.title.slice(0,47)+" - Flash Player Installation");if(typeof ae.flashvars!=D){ae.flashvars+="&"+af}else{ae.flashvars=af}if(O.ie&&ah.readyState!=4){var ab=C("div");
aa+="SWFObjectNew";ab.setAttribute("id",aa);ah.parentNode.insertBefore(ab,ah);ah.style.display="none";y(ah)}u(ad,ae,aa)}}function b(ab){if(O.ie&&ab.readyState!=4){ab.style.display="none";var aa=C("div");ab.parentNode.insertBefore(aa,ab);aa.parentNode.replaceChild(J(ab),aa);y(ab)}else{ab.parentNode.replaceChild(J(ab),ab)}}function J(af){var ae=C("div");if(O.win&&O.ie){ae.innerHTML=af.innerHTML}else{var ab=af.getElementsByTagName(r)[0];if(ab){var ag=ab.childNodes;if(ag){var aa=ag.length;for(var ad=0;ad<aa;ad++){if(!(ag[ad].nodeType==1&&ag[ad].nodeName=="PARAM")&&!(ag[ad].nodeType==8)){ae.appendChild(ag[ad].cloneNode(true))}}}}}return ae}function k(aa,ab){var ac=C("div");ac.innerHTML="<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000'><param name='movie' value='"+aa+"'>"+ab+"</object>";return ac.firstChild}function u(ai,ag,ab){var aa,ad=c(ab);ab=W(ab);if(O.wk&&O.wk<312){return aa}if(ad){var ac=(O.ie)?C("div"):C(r),af,ah,ae;if(typeof ai.id==D){ai.id=ab}for(ae in ag){if(ag.hasOwnProperty(ae)&&ae.toLowerCase()!=="movie"){e(ac,ae,ag[ae])}}if(O.ie){ac=k(ai.data,ac.innerHTML)}for(af in ai){if(ai.hasOwnProperty(af)){ah=af.toLowerCase();if(ah==="styleclass"){ac.setAttribute("class",ai[af])}else{if(ah!=="classid"&&ah!=="data"){ac.setAttribute(af,ai[af])}}}}if(O.ie){P[P.length]=ai.id}else{ac.setAttribute("type",q);ac.setAttribute("data",ai.data)}ad.parentNode.replaceChild(ac,ad);aa=ac}return aa}function e(ac,aa,ab){var ad=C("param");ad.setAttribute("name",aa);ad.setAttribute("value",ab);ac.appendChild(ad)}function y(ac){var ab=c(ac);if(ab&&ab.nodeName.toUpperCase()=="OBJECT"){if(O.ie){ab.style.display="none";(function aa(){if(ab.readyState==4){for(var ad in ab){if(typeof ab[ad]=="function"){ab[ad]=null}}ab.parentNode.removeChild(ab)}else{setTimeout(aa,10)}}())}else{ab.parentNode.removeChild(ab)}}}function U(aa){return(aa&&aa.nodeType&&aa.nodeType===1)}function W(aa){return(U(aa))?aa.id:aa}function c(ac){if(U(ac)){return ac}var aa=null;try{aa=h.getElementById(ac)}catch(ab){}return aa}function C(aa){return h.createElement(aa)}function n(aa){return parseInt(aa,10)}function g(ac,aa,ab){ac.attachEvent(aa,ab);K[K.length]=[ac,aa,ab]}function F(ac){ac+="";var ab=O.pv,aa=ac.split(".");aa[0]=n(aa[0]);aa[1]=n(aa[1])||0;aa[2]=n(aa[2])||0;return(ab[0]>aa[0]||(ab[0]==aa[0]&&ab[1]>aa[1])||(ab[0]==aa[0]&&ab[1]==aa[1]&&ab[2]>=aa[2]))?true:false}function v(af,ab,ag,ae){var ad=h.getElementsByTagName("head")[0];if(!ad){return}var aa=(typeof ag=="string")?ag:"screen";if(ae){m=null;G=null}if(!m||G!=aa){var ac=C("style");ac.setAttribute("type","text/css");ac.setAttribute("media",aa);m=ad.appendChild(ac);if(O.ie&&typeof h.styleSheets!=D&&h.styleSheets.length>0){m=h.styleSheets[h.styleSheets.length-1]}G=aa}if(m){if(typeof m.addRule!=D){m.addRule(af,ab)}else{if(typeof h.createTextNode!=D){m.appendChild(h.createTextNode(af+" {"+ab+"}"))}}}}function w(ad,aa){if(!j){return}var ab=aa?"visible":"hidden",ac=c(ad);if(L&&ac){ac.style.visibility=ab}else{if(typeof ad==="string"){v("#"+ad,"visibility:"+ab)}}}function N(ab){var ac=/[\\\"<>\.;]/;var aa=ac.exec(ab)!=null;return aa&&typeof encodeURIComponent!=D?encodeURIComponent(ab):ab}var d=function(){if(O.ie){window.attachEvent("onunload",function(){var af=K.length;for(var ae=0;ae<af;ae++){K[ae][0].detachEvent(K[ae][1],K[ae][2])}var ac=P.length;for(var ad=0;ad<ac;ad++){y(P[ad])}for(var ab in O){O[ab]=null}O=null;for(var aa in swfobject){swfobject[aa]=null}swfobject=null})}}();return{registerObject:function(ae,aa,ad,ac){if(O.w3&&ae&&aa){var ab={};ab.id=ae;ab.swfVersion=aa;ab.expressInstall=ad;ab.callbackFn=ac;o[o.length]=ab;w(ae,false)}else{if(ac){ac({success:false,id:ae})}}},getObjectById:function(aa){if(O.w3){return z(aa)}},embedSWF:function(af,al,ai,ak,ab,ae,ad,ah,aj,ag){var ac=W(al),aa={success:false,id:ac};if(O.w3&&!(O.wk&&O.wk<312)&&af&&al&&ai&&ak&&ab){w(ac,false);M(function(){ai+="";ak+="";var an={};if(aj&&typeof aj===r){for(var aq in aj){an[aq]=aj[aq]}}an.data=af;an.width=ai;an.height=ak;var ar={};if(ah&&typeof ah===r){for(var ao in ah){ar[ao]=ah[ao]}}if(ad&&typeof ad===r){for(var am in ad){if(ad.hasOwnProperty(am)){var ap=(l)?encodeURIComponent(am):am,at=(l)?encodeURIComponent(ad[am]):ad[am];if(typeof ar.flashvars!=D){ar.flashvars+="&"+ap+"="+at}else{ar.flashvars=ap+"="+at}}}}if(F(ab)){var au=u(an,ar,al);if(an.id==ac){w(ac,true)}aa.success=true;aa.ref=au;aa.id=au.id}else{if(ae&&A()){an.data=ae;R(an,ar,al,ag);return}else{w(ac,true)}}if(ag){ag(aa)}})}else{if(ag){ag(aa)}}},switchOffAutoHideShow:function(){j=false},enableUriEncoding:function(aa){l=(typeof aa===D)?true:aa},ua:O,getFlashPlayerVersion:function(){return{major:O.pv[0],minor:O.pv[1],release:O.pv[2]}},hasFlashPlayerVersion:F,createSWF:function(ac,ab,aa){if(O.w3){return u(ac,ab,aa)}else{return undefined}},showExpressInstall:function(ac,ad,aa,ab){if(O.w3&&A()){R(ac,ad,aa,ab)}},removeSWF:function(aa){if(O.w3){y(aa)}},createCSS:function(ad,ac,ab,aa){if(O.w3){v(ad,ac,ab,aa)}},addDomLoadEvent:M,addLoadEvent:s,getQueryParamValue:function(ad){var ac=h.location.search||h.location.hash;
if(ac){if(/\?/.test(ac)){ac=ac.split("?")[1]}if(ad==null){return N(ac)}var ab=ac.split("&");for(var aa=0;aa<ab.length;aa++){if(ab[aa].substring(0,ab[aa].indexOf("="))==ad){return N(ab[aa].substring((ab[aa].indexOf("=")+1)))}}}return""},expressInstallCallback:function(){if(a){var aa=c(S);if(aa&&I){aa.parentNode.replaceChild(I,aa);if(p){w(p,true);if(O.ie){I.style.display="block"}}if(E){E(B)}}a=false}},version:"2.3"}}();


/*** EXPORTS FROM exports-loader ***/
module.exports = swfobject;

/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/setimmediate/setImmediate.js":
/*!***************************************************!*\
  !*** ./node_modules/setimmediate/setImmediate.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/timers-browserify/main.js":
/*!************************************************!*\
  !*** ./node_modules/timers-browserify/main.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(/*! setimmediate */ "./node_modules/setimmediate/setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "q":
/*!********************!*\
  !*** external "q" ***!
  \********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_q__;

/***/ })

/******/ });
});
//# sourceMappingURL=web-audio-player.js.map